/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(app, $, riot) {'use strict';
	
	__webpack_require__(514);
	
	__webpack_require__(845);
	
	__webpack_require__(332);
	
	__webpack_require__(844);
	
	__webpack_require__(849);
	
	__webpack_require__(847);
	
	__webpack_require__(848);
	
	__webpack_require__(347);
	
	__webpack_require__(349);
	
	__webpack_require__(153);
	
	__webpack_require__(152);
	
	__webpack_require__(519);
	
	__webpack_require__(341);
	
	__webpack_require__(511);
	
	__webpack_require__(512);
	
	__webpack_require__(513);
	
	if (!app.checkUnsupported()) {
	    $(document).ready(function () {
	        riot.mount('app');
	        // ckeditor self link fix
	        $(document).on('click', 'ckeditor a', function (e) {
	            if (!e.ctrlKey) e.preventDefault();
	        });
	    });
	
	    var popups = document.createElement('popups');
	    document.body.appendChild(popups);
	    window.popups = riot.mount('popups', {
	        position: 'top-right',
	        timeout: '6000',
	        animation: 'slide',
	        margin: '15px 10px'
	    })[0];
	
	    var modals = document.createElement('modals');
	    document.body.appendChild(modals);
	    window.modals = riot.mount('modals')[0];
	
	    if (false) {
	        window.$ = $;
	        window.jQuery = jQuery;
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(16), __webpack_require__(1)))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/* Riot v3.0.0-alpha.2, @license MIT, (c) 2015 Muut Inc. + contributors */
	
	;(function(window, undefined) {
	  'use strict';
	var riot = { version: 'v3.0.0-alpha.2', settings: {} },
	  // be aware, internal usage
	  // ATTENTION: prefix the global dynamic variables with `__`
	
	  // counter to give a unique id to all the Tag instances
	  __uid = 0,
	  // tags instances cache
	  __virtualDom = [],
	  // tags implementation cache
	  __tagImpl = {},
	
	  /**
	   * Const
	   */
	  GLOBAL_MIXIN = '__global_mixin',
	
	  // riot specific prefixes
	  RIOT_PREFIX = 'riot-',
	  RIOT_TAG = RIOT_PREFIX + 'tag',
	
	  // for typeof == '' comparisons
	  T_STRING = 'string',
	  T_OBJECT = 'object',
	  T_UNDEF  = 'undefined',
	  T_FUNCTION = 'function',
	  // special native tags that cannot be treated like the others
	  SPECIAL_TAGS_REGEX = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?|opt(?:ion|group))$/,
	  RESERVED_WORDS_BLACKLIST = ['_item', '_id', '_parent', 'update', 'root', 'mount', 'unmount', 'mixin', 'isMounted', 'isLoop', 'tags', 'parent', 'opts', 'trigger', 'on', 'off', 'one'],
	
	  // version# for IE 8-11, 0 for others
	  IE_VERSION = (window && window.document || {}).documentMode | 0
	/* istanbul ignore next */
	riot.observable = function(el) {
	
	  /**
	   * Extend the original object or create a new empty one
	   * @type { Object }
	   */
	
	  el = el || {}
	
	  /**
	   * Private variables and methods
	   */
	  var callbacks = {},
	    slice = Array.prototype.slice,
	    onEachEvent = function(e, fn) { e.replace(/\S+/g, fn) },
	    defineProperty = function (key, value) {
	      Object.defineProperty(el, key, {
	        value: value,
	        enumerable: false,
	        writable: false,
	        configurable: false
	      })
	    }
	
	  /**
	   * Listen to the given space separated list of `events` and execute the `callback` each time an event is triggered.
	   * @param  { String } events - events ids
	   * @param  { Function } fn - callback function
	   * @returns { Object } el
	   */
	  defineProperty('on', function(events, fn) {
	    if (typeof fn != 'function')  return el
	
	    onEachEvent(events, function(name, pos) {
	      (callbacks[name] = callbacks[name] || []).push(fn)
	      fn.typed = pos > 0
	    })
	
	    return el
	  })
	
	  /**
	   * Removes the given space separated list of `events` listeners
	   * @param   { String } events - events ids
	   * @param   { Function } fn - callback function
	   * @returns { Object } el
	   */
	  defineProperty('off', function(events, fn) {
	    if (events == '*' && !fn) callbacks = {}
	    else {
	      onEachEvent(events, function(name) {
	        if (fn) {
	          var arr = callbacks[name]
	          for (var i = 0, cb; cb = arr && arr[i]; ++i) {
	            if (cb == fn) arr.splice(i--, 1)
	          }
	        } else delete callbacks[name]
	      })
	    }
	    return el
	  })
	
	  /**
	   * Listen to the given space separated list of `events` and execute the `callback` at most once
	   * @param   { String } events - events ids
	   * @param   { Function } fn - callback function
	   * @returns { Object } el
	   */
	  defineProperty('one', function(events, fn) {
	    function on() {
	      el.off(events, on)
	      fn.apply(el, arguments)
	    }
	    return el.on(events, on)
	  })
	
	  /**
	   * Execute all callback functions that listen to the given space separated list of `events`
	   * @param   { String } events - events ids
	   * @returns { Object } el
	   */
	  defineProperty('trigger', function(events) {
	
	    // getting the arguments
	    // skipping the first one
	    var args = slice.call(arguments, 1),
	      fns
	
	    onEachEvent(events, function(name) {
	
	      fns = slice.call(callbacks[name] || [], 0)
	
	      for (var i = 0, fn; fn = fns[i]; ++i) {
	        if (fn.busy) return
	        fn.busy = 1
	        fn.apply(el, fn.typed ? [name].concat(args) : args)
	        if (fns[i] !== fn) { i-- }
	        fn.busy = 0
	      }
	
	      if (callbacks['*'] && name != '*')
	        el.trigger.apply(el, ['*', name].concat(args))
	
	    })
	
	    return el
	  })
	
	  return el
	
	}
	/* istanbul ignore next */
	;(function(riot) {
	
	/**
	 * Simple client-side router
	 * @module riot-route
	 */
	
	
	var RE_ORIGIN = /^.+?\/+[^\/]+/,
	  EVENT_LISTENER = 'EventListener',
	  REMOVE_EVENT_LISTENER = 'remove' + EVENT_LISTENER,
	  ADD_EVENT_LISTENER = 'add' + EVENT_LISTENER,
	  HAS_ATTRIBUTE = 'hasAttribute',
	  REPLACE = 'replace',
	  POPSTATE = 'popstate',
	  HASHCHANGE = 'hashchange',
	  TRIGGER = 'trigger',
	  MAX_EMIT_STACK_LEVEL = 3,
	  win = typeof window != 'undefined' && window,
	  doc = typeof document != 'undefined' && document,
	  hist = win && history,
	  loc = win && (hist.location || win.location), // see html5-history-api
	  prot = Router.prototype, // to minify more
	  clickEvent = doc && doc.ontouchstart ? 'touchstart' : 'click',
	  started = false,
	  central = riot.observable(),
	  routeFound = false,
	  debouncedEmit,
	  base, current, parser, secondParser, emitStack = [], emitStackLevel = 0
	
	/**
	 * Default parser. You can replace it via router.parser method.
	 * @param {string} path - current path (normalized)
	 * @returns {array} array
	 */
	function DEFAULT_PARSER(path) {
	  return path.split(/[/?#]/)
	}
	
	/**
	 * Default parser (second). You can replace it via router.parser method.
	 * @param {string} path - current path (normalized)
	 * @param {string} filter - filter string (normalized)
	 * @returns {array} array
	 */
	function DEFAULT_SECOND_PARSER(path, filter) {
	  var re = new RegExp('^' + filter[REPLACE](/\*/g, '([^/?#]+?)')[REPLACE](/\.\./, '.*') + '$'),
	    args = path.match(re)
	
	  if (args) return args.slice(1)
	}
	
	/**
	 * Simple/cheap debounce implementation
	 * @param   {function} fn - callback
	 * @param   {number} delay - delay in seconds
	 * @returns {function} debounced function
	 */
	function debounce(fn, delay) {
	  var t
	  return function () {
	    clearTimeout(t)
	    t = setTimeout(fn, delay)
	  }
	}
	
	/**
	 * Set the window listeners to trigger the routes
	 * @param {boolean} autoExec - see route.start
	 */
	function start(autoExec) {
	  debouncedEmit = debounce(emit, 1)
	  win[ADD_EVENT_LISTENER](POPSTATE, debouncedEmit)
	  win[ADD_EVENT_LISTENER](HASHCHANGE, debouncedEmit)
	  doc[ADD_EVENT_LISTENER](clickEvent, click)
	  if (autoExec) emit(true)
	}
	
	/**
	 * Router class
	 */
	function Router() {
	  this.$ = []
	  riot.observable(this) // make it observable
	  central.on('stop', this.s.bind(this))
	  central.on('emit', this.e.bind(this))
	}
	
	function normalize(path) {
	  return path[REPLACE](/^\/|\/$/, '')
	}
	
	function isString(str) {
	  return typeof str == 'string'
	}
	
	/**
	 * Get the part after domain name
	 * @param {string} href - fullpath
	 * @returns {string} path from root
	 */
	function getPathFromRoot(href) {
	  return (href || loc.href || '')[REPLACE](RE_ORIGIN, '')
	}
	
	/**
	 * Get the part after base
	 * @param {string} href - fullpath
	 * @returns {string} path from base
	 */
	function getPathFromBase(href) {
	  return base[0] == '#'
	    ? (href || loc.href || '').split(base)[1] || ''
	    : getPathFromRoot(href)[REPLACE](base, '')
	}
	
	function emit(force) {
	  // the stack is needed for redirections
	  var isRoot = emitStackLevel == 0
	  if (MAX_EMIT_STACK_LEVEL <= emitStackLevel) return
	
	  emitStackLevel++
	  emitStack.push(function() {
	    var path = getPathFromBase()
	    if (force || path != current) {
	      central[TRIGGER]('emit', path)
	      current = path
	    }
	  })
	  if (isRoot) {
	    while (emitStack.length) {
	      emitStack[0]()
	      emitStack.shift()
	    }
	    emitStackLevel = 0
	  }
	}
	
	function click(e) {
	  if (
	    e.which != 1 // not left click
	    || e.metaKey || e.ctrlKey || e.shiftKey // or meta keys
	    || e.defaultPrevented // or default prevented
	  ) return
	
	  var el = e.target
	  while (el && el.nodeName != 'A') el = el.parentNode
	  if (
	    !el || el.nodeName != 'A' // not A tag
	    || el[HAS_ATTRIBUTE]('download') // has download attr
	    || !el[HAS_ATTRIBUTE]('href') // has no href attr
	    || el.target && el.target != '_self' // another window or frame
	    || el.href.indexOf(loc.href.match(RE_ORIGIN)[0]) == -1 // cross origin
	  ) return
	
	  if (el.href != loc.href) {
	    if (
	      el.href.split('#')[0] == loc.href.split('#')[0] // internal jump
	      || base != '#' && getPathFromRoot(el.href).indexOf(base) !== 0 // outside of base
	      || !go(getPathFromBase(el.href), el.title || doc.title) // route not found
	    ) return
	  }
	
	  e.preventDefault()
	}
	
	/**
	 * Go to the path
	 * @param {string} path - destination path
	 * @param {string} title - page title
	 * @param {boolean} shouldReplace - use replaceState or pushState
	 * @returns {boolean} - route not found flag
	 */
	function go(path, title, shouldReplace) {
	  if (hist) { // if a browser
	    path = base + normalize(path)
	    title = title || doc.title
	    // browsers ignores the second parameter `title`
	    shouldReplace
	      ? hist.replaceState(null, title, path)
	      : hist.pushState(null, title, path)
	    // so we need to set it manually
	    doc.title = title
	    routeFound = false
	    emit()
	    return routeFound
	  }
	
	  // Server-side usage: directly execute handlers for the path
	  return central[TRIGGER]('emit', getPathFromBase(path))
	}
	
	/**
	 * Go to path or set action
	 * a single string:                go there
	 * two strings:                    go there with setting a title
	 * two strings and boolean:        replace history with setting a title
	 * a single function:              set an action on the default route
	 * a string/RegExp and a function: set an action on the route
	 * @param {(string|function)} first - path / action / filter
	 * @param {(string|RegExp|function)} second - title / action
	 * @param {boolean} third - replace flag
	 */
	prot.m = function(first, second, third) {
	  if (isString(first) && (!second || isString(second))) go(first, second, third || false)
	  else if (second) this.r(first, second)
	  else this.r('@', first)
	}
	
	/**
	 * Stop routing
	 */
	prot.s = function() {
	  this.off('*')
	  this.$ = []
	}
	
	/**
	 * Emit
	 * @param {string} path - path
	 */
	prot.e = function(path) {
	  this.$.concat('@').some(function(filter) {
	    var args = (filter == '@' ? parser : secondParser)(normalize(path), normalize(filter))
	    if (typeof args != 'undefined') {
	      this[TRIGGER].apply(null, [filter].concat(args))
	      return routeFound = true // exit from loop
	    }
	  }, this)
	}
	
	/**
	 * Register route
	 * @param {string} filter - filter for matching to url
	 * @param {function} action - action to register
	 */
	prot.r = function(filter, action) {
	  if (filter != '@') {
	    filter = '/' + normalize(filter)
	    this.$.push(filter)
	  }
	  this.on(filter, action)
	}
	
	var mainRouter = new Router()
	var route = mainRouter.m.bind(mainRouter)
	
	/**
	 * Create a sub router
	 * @returns {function} the method of a new Router object
	 */
	route.create = function() {
	  var newSubRouter = new Router()
	  // stop only this sub-router
	  newSubRouter.m.stop = newSubRouter.s.bind(newSubRouter)
	  // return sub-router's main method
	  return newSubRouter.m.bind(newSubRouter)
	}
	
	/**
	 * Set the base of url
	 * @param {(str|RegExp)} arg - a new base or '#' or '#!'
	 */
	route.base = function(arg) {
	  base = arg || '#'
	  current = getPathFromBase() // recalculate current path
	}
	
	/** Exec routing right now **/
	route.exec = function() {
	  emit(true)
	}
	
	/**
	 * Replace the default router to yours
	 * @param {function} fn - your parser function
	 * @param {function} fn2 - your secondParser function
	 */
	route.parser = function(fn, fn2) {
	  if (!fn && !fn2) {
	    // reset parser for testing...
	    parser = DEFAULT_PARSER
	    secondParser = DEFAULT_SECOND_PARSER
	  }
	  if (fn) parser = fn
	  if (fn2) secondParser = fn2
	}
	
	/**
	 * Helper function to get url query as an object
	 * @returns {object} parsed query
	 */
	route.query = function() {
	  var q = {}
	  var href = loc.href || current
	  href[REPLACE](/[?&](.+?)=([^&]*)/g, function(_, k, v) { q[k] = v })
	  return q
	}
	
	/** Stop routing **/
	route.stop = function () {
	  if (started) {
	    if (win) {
	      win[REMOVE_EVENT_LISTENER](POPSTATE, debouncedEmit)
	      win[REMOVE_EVENT_LISTENER](HASHCHANGE, debouncedEmit)
	      doc[REMOVE_EVENT_LISTENER](clickEvent, click)
	    }
	    central[TRIGGER]('stop')
	    started = false
	  }
	}
	
	/**
	 * Start routing
	 * @param {boolean} autoExec - automatically exec after starting if true
	 */
	route.start = function (autoExec) {
	  if (!started) {
	    if (win) {
	      if (document.readyState == 'complete') start(autoExec)
	      // the timeout is needed to solve
	      // a weird safari bug https://github.com/riot/route/issues/33
	      else win[ADD_EVENT_LISTENER]('load', function() {
	        setTimeout(function() { start(autoExec) }, 1)
	      })
	    }
	    started = true
	  }
	}
	
	/** Prepare the router **/
	route.base()
	route.parser()
	
	riot.route = route
	})(riot)
	/* istanbul ignore next */
	
	/**
	 * The riot template engine
	 * @version v2.3.21
	 */
	
	/**
	 * riot.util.brackets
	 *
	 * - `brackets    ` - Returns a string or regex based on its parameter
	 * - `brackets.set` - Change the current riot brackets
	 *
	 * @module
	 */
	
	var brackets = (function (UNDEF) {
	
	  var
	    REGLOB = 'g',
	
	    R_MLCOMMS = /\/\*[^*]*\*+(?:[^*\/][^*]*\*+)*\//g,
	
	    R_STRINGS = /"[^"\\]*(?:\\[\S\s][^"\\]*)*"|'[^'\\]*(?:\\[\S\s][^'\\]*)*'/g,
	
	    S_QBLOCKS = R_STRINGS.source + '|' +
	      /(?:\breturn\s+|(?:[$\w\)\]]|\+\+|--)\s*(\/)(?![*\/]))/.source + '|' +
	      /\/(?=[^*\/])[^[\/\\]*(?:(?:\[(?:\\.|[^\]\\]*)*\]|\\.)[^[\/\\]*)*?(\/)[gim]*/.source,
	
	    FINDBRACES = {
	      '(': RegExp('([()])|'   + S_QBLOCKS, REGLOB),
	      '[': RegExp('([[\\]])|' + S_QBLOCKS, REGLOB),
	      '{': RegExp('([{}])|'   + S_QBLOCKS, REGLOB)
	    },
	
	    DEFAULT = '{ }'
	
	  var _pairs = [
	    '{', '}',
	    '{', '}',
	    /{[^}]*}/,
	    /\\([{}])/g,
	    /\\({)|{/g,
	    RegExp('\\\\(})|([[({])|(})|' + S_QBLOCKS, REGLOB),
	    DEFAULT,
	    /^\s*{\^?\s*([$\w]+)(?:\s*,\s*(\S+))?\s+in\s+(\S.*)\s*}/,
	    /(^|[^\\]){=[\S\s]*?}/
	  ]
	
	  var
	    cachedBrackets = UNDEF,
	    _regex,
	    _cache = [],
	    _settings
	
	  function _loopback (re) { return re }
	
	  function _rewrite (re, bp) {
	    if (!bp) bp = _cache
	    return new RegExp(
	      re.source.replace(/{/g, bp[2]).replace(/}/g, bp[3]), re.global ? REGLOB : ''
	    )
	  }
	
	  function _create (pair) {
	    if (pair === DEFAULT) return _pairs
	
	    var arr = pair.split(' ')
	
	    if (arr.length !== 2 || /[\x00-\x1F<>a-zA-Z0-9'",;\\]/.test(pair)) {
	      throw new Error('Unsupported brackets "' + pair + '"')
	    }
	    arr = arr.concat(pair.replace(/(?=[[\]()*+?.^$|])/g, '\\').split(' '))
	
	    arr[4] = _rewrite(arr[1].length > 1 ? /{[\S\s]*?}/ : _pairs[4], arr)
	    arr[5] = _rewrite(pair.length > 3 ? /\\({|})/g : _pairs[5], arr)
	    arr[6] = _rewrite(_pairs[6], arr)
	    arr[7] = RegExp('\\\\(' + arr[3] + ')|([[({])|(' + arr[3] + ')|' + S_QBLOCKS, REGLOB)
	    arr[8] = pair
	    return arr
	  }
	
	  function _brackets (reOrIdx) {
	    return reOrIdx instanceof RegExp ? _regex(reOrIdx) : _cache[reOrIdx]
	  }
	
	  _brackets.split = function split (str, tmpl, _bp) {
	    // istanbul ignore next: _bp is for the compiler
	    if (!_bp) _bp = _cache
	
	    var
	      parts = [],
	      match,
	      isexpr,
	      start,
	      pos,
	      re = _bp[6]
	
	    isexpr = start = re.lastIndex = 0
	
	    while (match = re.exec(str)) {
	
	      pos = match.index
	
	      if (isexpr) {
	
	        if (match[2]) {
	          re.lastIndex = skipBraces(str, match[2], re.lastIndex)
	          continue
	        }
	        if (!match[3])
	          continue
	      }
	
	      if (!match[1]) {
	        unescapeStr(str.slice(start, pos))
	        start = re.lastIndex
	        re = _bp[6 + (isexpr ^= 1)]
	        re.lastIndex = start
	      }
	    }
	
	    if (str && start < str.length) {
	      unescapeStr(str.slice(start))
	    }
	
	    return parts
	
	    function unescapeStr (s) {
	      if (tmpl || isexpr)
	        parts.push(s && s.replace(_bp[5], '$1'))
	      else
	        parts.push(s)
	    }
	
	    function skipBraces (s, ch, ix) {
	      var
	        match,
	        recch = FINDBRACES[ch]
	
	      recch.lastIndex = ix
	      ix = 1
	      while (match = recch.exec(s)) {
	        if (match[1] &&
	          !(match[1] === ch ? ++ix : --ix)) break
	      }
	      return ix ? s.length : recch.lastIndex
	    }
	  }
	
	  _brackets.hasExpr = function hasExpr (str) {
	    return _cache[4].test(str)
	  }
	
	  _brackets.loopKeys = function loopKeys (expr) {
	    var m = expr.match(_cache[9])
	    return m
	      ? { key: m[1], pos: m[2], val: _cache[0] + m[3].trim() + _cache[1] }
	      : { val: expr.trim() }
	  }
	
	  _brackets.hasRaw = function (src) {
	    return _cache[10].test(src)
	  }
	
	  _brackets.array = function array (pair) {
	    return pair ? _create(pair) : _cache
	  }
	
	  function _reset (pair) {
	    if ((pair || (pair = DEFAULT)) !== _cache[8]) {
	      _cache = _create(pair)
	      _regex = pair === DEFAULT ? _loopback : _rewrite
	      _cache[9] = _regex(_pairs[9])
	      _cache[10] = _regex(_pairs[10])
	    }
	    cachedBrackets = pair
	  }
	
	  function _setSettings (o) {
	    var b
	    o = o || {}
	    b = o.brackets
	    Object.defineProperty(o, 'brackets', {
	      set: _reset,
	      get: function () { return cachedBrackets },
	      enumerable: true
	    })
	    _settings = o
	    _reset(b)
	  }
	
	  Object.defineProperty(_brackets, 'settings', {
	    set: _setSettings,
	    get: function () { return _settings }
	  })
	
	  /* istanbul ignore next: in the browser riot is always in the scope */
	  _brackets.settings = typeof riot !== 'undefined' && riot.settings || {}
	  _brackets.set = _reset
	
	  _brackets.R_STRINGS = R_STRINGS
	  _brackets.R_MLCOMMS = R_MLCOMMS
	  _brackets.S_QBLOCKS = S_QBLOCKS
	
	  return _brackets
	
	})()
	
	/**
	 * @module tmpl
	 *
	 * tmpl          - Root function, returns the template value, render with data
	 * tmpl.hasExpr  - Test the existence of a expression inside a string
	 * tmpl.loopKeys - Get the keys for an 'each' loop (used by `_each`)
	 */
	
	var tmpl = (function () {
	
	  var _cache = {}
	
	  function _tmpl (str, data) {
	    if (!str) return str
	
	    return (_cache[str] || (_cache[str] = _create(str))).call(data, _logErr)
	  }
	
	  _tmpl.haveRaw = brackets.hasRaw
	
	  _tmpl.hasExpr = brackets.hasExpr
	
	  _tmpl.loopKeys = brackets.loopKeys
	
	  _tmpl.errorHandler = null
	
	  function _logErr (err, ctx) {
	
	    if (_tmpl.errorHandler) {
	
	      err.riotData = {
	        tagName: ctx && ctx.root && ctx.root.tagName,
	        _riot_id: ctx && ctx._riot_id  //eslint-disable-line camelcase
	      }
	      _tmpl.errorHandler(err)
	    }
	  }
	
	  function _create (str) {
	
	    var expr = _getTmpl(str)
	    if (expr.slice(0, 11) !== 'try{return ') expr = 'return ' + expr
	
	    return new Function('E', expr + ';')
	  }
	
	  var
	    RE_QBLOCK = RegExp(brackets.S_QBLOCKS, 'g'),
	    RE_QBMARK = /\x01(\d+)~/g
	
	  function _getTmpl (str) {
	    var
	      qstr = [],
	      expr,
	      parts = brackets.split(str.replace(/\u2057/g, '"'), 1)
	
	    if (parts.length > 2 || parts[0]) {
	      var i, j, list = []
	
	      for (i = j = 0; i < parts.length; ++i) {
	
	        expr = parts[i]
	
	        if (expr && (expr = i & 1 ?
	
	              _parseExpr(expr, 1, qstr) :
	
	              '"' + expr
	                .replace(/\\/g, '\\\\')
	                .replace(/\r\n?|\n/g, '\\n')
	                .replace(/"/g, '\\"') +
	              '"'
	
	          )) list[j++] = expr
	
	      }
	
	      expr = j < 2 ? list[0] :
	             '[' + list.join(',') + '].join("")'
	
	    } else {
	
	      expr = _parseExpr(parts[1], 0, qstr)
	    }
	
	    if (qstr[0])
	      expr = expr.replace(RE_QBMARK, function (_, pos) {
	        return qstr[pos]
	          .replace(/\r/g, '\\r')
	          .replace(/\n/g, '\\n')
	      })
	
	    return expr
	  }
	
	  var
	    RE_BREND = {
	      '(': /[()]/g,
	      '[': /[[\]]/g,
	      '{': /[{}]/g
	    },
	    CS_IDENT = /^(?:(-?[_A-Za-z\xA0-\xFF][-\w\xA0-\xFF]*)|\x01(\d+)~):/
	
	  function _parseExpr (expr, asText, qstr) {
	
	    if (expr[0] === '=') expr = expr.slice(1)
	
	    expr = expr
	          .replace(RE_QBLOCK, function (s, div) {
	            return s.length > 2 && !div ? '\x01' + (qstr.push(s) - 1) + '~' : s
	          })
	          .replace(/\s+/g, ' ').trim()
	          .replace(/\ ?([[\({},?\.:])\ ?/g, '$1')
	
	    if (expr) {
	      var
	        list = [],
	        cnt = 0,
	        match
	
	      while (expr &&
	            (match = expr.match(CS_IDENT)) &&
	            !match.index
	        ) {
	        var
	          key,
	          jsb,
	          re = /,|([[{(])|$/g
	
	        expr = RegExp.rightContext
	        key  = match[2] ? qstr[match[2]].slice(1, -1).trim().replace(/\s+/g, ' ') : match[1]
	
	        while (jsb = (match = re.exec(expr))[1]) skipBraces(jsb, re)
	
	        jsb  = expr.slice(0, match.index)
	        expr = RegExp.rightContext
	
	        list[cnt++] = _wrapExpr(jsb, 1, key)
	      }
	
	      expr = !cnt ? _wrapExpr(expr, asText) :
	          cnt > 1 ? '[' + list.join(',') + '].join(" ").trim()' : list[0]
	    }
	    return expr
	
	    function skipBraces (ch, re) {
	      var
	        mm,
	        lv = 1,
	        ir = RE_BREND[ch]
	
	      ir.lastIndex = re.lastIndex
	      while (mm = ir.exec(expr)) {
	        if (mm[0] === ch) ++lv
	        else if (!--lv) break
	      }
	      re.lastIndex = lv ? expr.length : ir.lastIndex
	    }
	  }
	
	  // istanbul ignore next: not both
	  var
	    JS_CONTEXT = '"in this?this:' + (typeof window !== 'object' ? 'global' : 'window') + ').',
	    JS_VARNAME = /[,{][$\w]+:|(^ *|[^$\w\.])(?!(?:typeof|true|false|null|undefined|in|instanceof|is(?:Finite|NaN)|void|NaN|new|Date|RegExp|Math)(?![$\w]))([$_A-Za-z][$\w]*)/g,
	    JS_NOPROPS = /^(?=(\.[$\w]+))\1(?:[^.[(]|$)/
	
	  function _wrapExpr (expr, asText, key) {
	    var tb
	
	    expr = expr.replace(JS_VARNAME, function (match, p, mvar, pos, s) {
	      if (mvar) {
	        pos = tb ? 0 : pos + match.length
	
	        if (mvar !== 'this' && mvar !== 'global' && mvar !== 'window') {
	          match = p + '("' + mvar + JS_CONTEXT + mvar
	          if (pos) tb = (s = s[pos]) === '.' || s === '(' || s === '['
	        } else if (pos) {
	          tb = !JS_NOPROPS.test(s.slice(pos))
	        }
	      }
	      return match
	    })
	
	    if (tb) {
	      expr = 'try{return ' + expr + '}catch(e){E(e,this)}'
	    }
	
	    if (key) {
	
	      expr = (tb ?
	          'function(){' + expr + '}.call(this)' : '(' + expr + ')'
	        ) + '?"' + key + '":""'
	
	    } else if (asText) {
	
	      expr = 'function(v){' + (tb ?
	          expr.replace('return ', 'v=') : 'v=(' + expr + ')'
	        ) + ';return v||v===0?v:""}.call(this)'
	    }
	
	    return expr
	  }
	
	  // istanbul ignore next: compatibility fix for beta versions
	  _tmpl.parse = function (s) { return s }
	
	  _tmpl.version = brackets.version = 'v2.3.21'
	
	  return _tmpl
	
	})()
	
	/*
	  lib/browser/tag/mkdom.js
	
	  Includes hacks needed for the Internet Explorer version 9 and below
	  See: http://kangax.github.io/compat-table/es5/#ie8
	       http://codeplanet.io/dropping-ie8/
	*/
	var mkdom = (function (checkIE) {
	
	  var
	    reHasYield  = /<yield\b/i,
	    reYieldAll  = /<yield\s*(?:\/>|>([\S\s]*?)<\/yield\s*>)/ig,
	    reYieldCls  = /<yield\s+to=[^>]+>[\S\s]*?<\/yield\s*>\s*/ig,
	    reYieldDest = /<yield\s+from=['"]?([-\w]+)['"]?\s*(?:\/>|>([\S\s]*?)<\/yield\s*>)/ig,
	    rsYieldSrc  = '<yield\\s+to=[\'"]@[\'"]\\s*>([\\S\\s]*?)</yield\\s*>',
	    rootEls = { tr: 'tbody', th: 'tr', td: 'tr', col: 'colgroup' },
	    GENERIC = 'div'
	
	
	  checkIE = checkIE && checkIE < 10
	  var tblTags = checkIE
	    ? SPECIAL_TAGS_REGEX : /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?)$/
	
	  /**
	   * Creates a DOM element to wrap the given content. Normally an `DIV`, but can be
	   * also a `TABLE`, `SELECT`, `TBODY`, `TR`, or `COLGROUP` element.
	   *
	   * @param   {string} impl   - Tag implementation with the template and root attributes
	   * @param   {string} [html] - HTML content that comes from the DOM element where you
	   *           will mount the tag, mostly the original tag in the page
	   * @param   {object} [attr] - Plain object where to store the root attributes
	   * @returns {HTMLElement} DOM element with _templ_ merged through `YIELD` with the _html_.
	   */
	  function _mkdom(impl, html, attr) {
	
	    var templ = impl.tmpl,
	      match   = templ && templ.match(/^\s*<([-\w]+)/),
	      tagName = match && match[1].toLowerCase(),
	
	      el = mkEl(GENERIC)
	
	    if (!html) html = ''
	
	    if (impl.attrs) attr.attrs = replaceYield(impl.attrs, html)
	
	    // replace all the yield tags with the tag inner html
	    templ = replaceYield(templ, html)
	
	    /* istanbul ignore next */
	    if (tblTags.test(tagName))
	      el = specialTags(el, templ, tagName)
	    else
	      el.innerHTML = templ
	
	    el.stub = true
	
	    return el
	  }
	
	
	  /*
	    Creates the root element for table or select child elements:
	    tr/th/td/thead/tfoot/tbody/caption/col/colgroup/option/optgroup
	  */
	  function specialTags(el, templ, tagName) {
	    var
	      select = tagName[0] === 'o',
	      parent = select ? 'select>' : 'table>'
	
	    // trim() is important here, this ensures we don't have artifacts,
	    // so we can check if we have only one element inside the parent
	    el.innerHTML = '<' + parent + templ.trim() + '</' + parent
	    parent = el.firstChild
	
	    // returns the immediate parent if tr/th/td/col is the only element, if not
	    // returns the whole tree, as this can include additional elements
	    if (select) {
	      parent.selectedIndex = -1  // for IE9, compatible w/current riot behavior
	    } else {
	      var tname = rootEls[tagName]
	      if (tname && parent.children.length === 1) parent = $(tname, parent)
	    }
	    return parent
	  }
	
	  /*
	    Replace the yield tag from any tag template with the innerHTML of the
	    original tag in the page
	  */
	  function replaceYield(templ, html) {
	    // do nothing if no yield
	    if (!reHasYield.test(templ)) return templ
	
	    // be careful with #1343 - string on the source having `$1`
	    var n = 1
	    templ = templ.replace(reYieldDest, function (_, ref, def) {
	      var m = html.match(RegExp(rsYieldSrc.replace('@', ref), 'i'))
	      n = 0
	      return (m ? m[1] : def) || ''
	    })
	
	    // yield without any "from", replace yield in templ with the innerHTML
	    if (n || reHasYield.test(templ)) {
	      if (html) html = html.replace(reYieldCls, '').trim()
	      templ = templ.replace(reYieldAll, function (_, def) {
	        return html || def || ''
	      })
	    }
	
	    return templ
	  }
	
	  return _mkdom
	
	})(IE_VERSION)
	
	/**
	 * Convert the item looped into an object used to extend the child tag properties
	 * @param   { Object } expr - object containing the keys used to extend the children tags
	 * @param   { * } key - value to assign to the new object returned
	 * @param   { * } val - value containing the position of the item in the array
	 * @returns { Object } - new object containing the values of the original item
	 *
	 * The variables 'key' and 'val' are arbitrary.
	 * They depend on the collection type looped (Array, Object)
	 * and on the expression used on the each tag
	 *
	 */
	function mkitem(expr, key, val) {
	  var item = {}
	  item[expr.key] = key
	  if (expr.pos) item[expr.pos] = val
	  return item
	}
	
	/**
	 * Unmount the redundant tags
	 * @param   { Array } items - array containing the current items to loop
	 * @param   { Array } tags - array containing all the children tags
	 */
	function unmountRedundant(items, tags) {
	
	  var i = tags.length,
	    j = items.length,
	    t
	
	  while (i > j) {
	    t = tags[--i]
	    tags.splice(i, 1)
	    t.unmount()
	  }
	}
	
	/**
	 * Move the nested custom tags in non custom loop tags
	 * @param   { Object } child - non custom loop tag
	 * @param   { Number } i - current position of the loop tag
	 */
	function moveNestedTags(child, i) {
	  Object.keys(child.tags).forEach(function(tagName) {
	    var tag = child.tags[tagName]
	    if (isArray(tag))
	      each(tag, function (t) {
	        moveChildTag(t, tagName, i)
	      })
	    else
	      moveChildTag(tag, tagName, i)
	  })
	}
	
	/**
	 * Manage tags having the 'each'
	 * @param   { Object } dom - DOM node we need to loop
	 * @param   { Tag } parent - parent tag instance where the dom node is contained
	 * @param   { String } expr - string contained in the 'each' attribute
	 * @returns { Object } expression object for this each loop
	 */
	function _each(dom, parent, expr) {
	
	  // remove the each property from the original tag
	  remAttr(dom, 'each')
	
	  var mustReorder = typeof getAttr(dom, 'no-reorder') !== T_STRING || remAttr(dom, 'no-reorder'),
	    tagName = getTagName(dom),
	    impl = __tagImpl[tagName] || { tmpl: dom.outerHTML },
	    useRoot = SPECIAL_TAGS_REGEX.test(tagName),
	    root = dom.parentNode,
	    ref = document.createTextNode(''),
	    child = getTag(dom),
	    isOption = /^option$/i.test(tagName), // the option tags must be treated differently
	    tags = [],
	    oldItems = [],
	    hasKeys,
	    isVirtual = dom.tagName == 'VIRTUAL'
	
	  // parse the each expression
	  expr = tmpl.loopKeys(expr)
	  expr.isLoop = true
	
	  // insert a marked where the loop tags will be injected
	  root.insertBefore(ref, dom)
	
	  // clean template code
	  parent.one('before-mount', function () {
	
	    // remove the original DOM node
	    dom.parentNode.removeChild(dom)
	    if (root.stub) root = parent.root
	  })
	
	  expr.update = function () {
	    // get the new items collection
	    var items = tmpl(expr.val, parent),
	      // create a fragment to hold the new DOM nodes to inject in the parent tag
	      frag = document.createDocumentFragment()
	
	
	
	    // object loop. any changes cause full redraw
	    if (!isArray(items)) {
	      hasKeys = items || false
	      items = hasKeys ?
	        Object.keys(items).map(function (key) {
	          return mkitem(expr, key, items[key])
	        }) : []
	    }
	
	    // loop all the new items
	    items.forEach(function(item, i) {
	      // reorder only if the items are objects
	      var _mustReorder = mustReorder && item instanceof Object,
	        oldPos = oldItems.indexOf(item),
	        pos = ~oldPos && _mustReorder ? oldPos : i,
	        // does a tag exist in this position?
	        tag = tags[pos], domToInsert
	
	      item = !hasKeys && expr.key ? mkitem(expr, item, i) : item
	
	      // new tag
	      if (
	        !_mustReorder && !tag // with no-reorder we just update the old tags
	        ||
	        _mustReorder && !~oldPos || !tag // by default we always try to reorder the DOM elements
	      ) {
	
	        tag = new Tag(impl, {
	          parent: parent,
	          isLoop: true,
	          hasImpl: !!__tagImpl[tagName],
	          root: useRoot ? root : dom.cloneNode(),
	          item: item
	        }, dom.innerHTML)
	
	        tag.mount()
	        domToInsert = tag.stub || tag.root
	        // this tag must be appended
	        if (i == tags.length) {
	          if (isVirtual)
	            makeVirtual(tag, frag)
	          else frag.appendChild(domToInsert)
	        }
	        // this tag must be insert
	        else {
	          if (isVirtual)
	            makeVirtual(tag, root, tags[i])
	          else root.insertBefore(domToInsert, tags[i].root)
	          oldItems.splice(i, 0, item)
	        }
	
	        tags.splice(i, 0, tag)
	        pos = i // handled here so no move
	      } else tag.update(item)
	
	      // reorder the tag if it's not located in its previous position
	      if (pos !== i && _mustReorder) {
	        // update the DOM
	        if (isVirtual)
	          moveVirtual(tag, root, tags[i])
	        else root.insertBefore(tag.root, tags[i].root)
	        // update the position attribute if it exists
	        if (expr.pos)
	          tag[expr.pos] = i
	        // move the old tag instance
	        tags.splice(i, 0, tags.splice(pos, 1)[0])
	        // move the old item
	        oldItems.splice(i, 0, oldItems.splice(pos, 1)[0])
	        // if the loop tags are not custom
	        // we need to move all their custom tags into the right position
	        if (!child && tag.tags) moveNestedTags(tag, i)
	      }
	
	      // cache the original item to use it in the events bound to this node
	      // and its children
	      tag._item = item
	      // cache the real parent tag internally
	      defineProperty(tag, '_parent', parent)
	
	    })
	
	    // remove the redundant tags
	    unmountRedundant(items, tags)
	
	    // insert the new nodes
	    if (isOption) root.appendChild(frag)
	    else root.insertBefore(frag, ref)
	
	    // set the 'tags' property of the parent tag
	    // if child is 'undefined' it means that we don't need to set this property
	    // for example:
	    // we don't need store the `myTag.tags['div']` property if we are looping a div tag
	    // but we need to track the `myTag.tags['child']` property looping a custom child node named `child`
	    if (child) parent.tags[tagName] = tags
	
	    // clone the items array
	    oldItems = items.slice()
	  }
	
	  return expr
	}
	/**
	 * Object that will be used to inject and manage the css of every tag instance
	 */
	var styleManager = (function(_riot) {
	
	  if (!window) return { // skip injection on the server
	    add: function () {},
	    inject: function () {}
	  }
	
	  var styleNode = (function () {
	    // create a new style element with the correct type
	    var newNode = mkEl('style')
	    setAttr(newNode, 'type', 'text/css')
	
	    // replace any user node or insert the new one into the head
	    var userNode = $('style[type=riot]')
	    if (userNode) {
	      if (userNode.id) newNode.id = userNode.id
	      userNode.parentNode.replaceChild(newNode, userNode)
	    }
	    else document.getElementsByTagName('head')[0].appendChild(newNode)
	
	    return newNode
	  })()
	
	  // Create cache and shortcut to the correct property
	  var cssTextProp = styleNode.styleSheet,
	    stylesToInject = ''
	
	  // Expose the style node in a non-modificable property
	  Object.defineProperty(_riot, 'styleNode', {
	    value: styleNode,
	    writable: true
	  })
	
	  /**
	   * Public api
	   */
	  return {
	    /**
	     * Save a tag style to be later injected into DOM
	     * @param   { String } css [description]
	     */
	    add: function(css) {
	      stylesToInject += css
	    },
	    /**
	     * Inject all previously saved tag styles into DOM
	     * innerHTML seems slow: http://jsperf.com/riot-insert-style
	     */
	    inject: function() {
	      if (stylesToInject) {
	        if (cssTextProp) cssTextProp.cssText += stylesToInject
	        else styleNode.innerHTML += stylesToInject
	        stylesToInject = ''
	      }
	    }
	  }
	
	})(riot)
	function parseExpressions(root, tag, expressions) {
	  var base = {parent: {children: expressions}}
	
	  walk(root, function(dom, ctx) {
	    var type = dom.nodeType, parent = ctx.parent, attr, expr
	
	    // text node
	    if (type == 3 && dom.parentNode.tagName != 'STYLE' && tmpl.hasExpr(dom.nodeValue))
	      parent.children.push({dom: dom, expr: dom.nodeValue})
	
	    if (type != 1) return ctx // not an element
	
	    // loop. each does it's own thing (for now)
	    if (attr = getAttr(dom, 'each')) {
	      parent.children.push(_each(dom, tag, attr))
	      return false
	    }
	
	    // if-attrs become the new parent. Any following expressions (either on the current
	    // element, or below it) become children of this expression.
	    if (expr = getAttr(dom, 'if')) {
	      remAttr(dom, 'if')
	      attr = {isIf: true, expr: expr, dom: dom, children: []}
	      parent.children.push(attr)
	      parent = attr
	    }
	
	    if (expr = getNamedKey(dom)) {
	      parent.children.push({isNamed: true, dom: dom, expr: expr})
	    }
	
	    // attribute expressions
	    var allAttrs = [], nameHasExpression = false
	    each(dom.attributes, function(attr) {
	      var name = attr.name, bool = name.split('__')[1]
	      var hasExp = tmpl.hasExpr(attr.value)
	      if (name === 'if') return // already handled
	
	      // dirty dirty hack until we can clean up named tags
	      if (name === 'name' && hasExp) nameHasExpression = true
	
	      expr = {dom: dom, expr: attr.value, attr: bool || attr.name, bool: bool}
	      allAttrs.push(expr) // stores all attributes, even without expressions
	
	      if (!hasExp) return // no expressions here
	      parent.children.push(expr)
	      if (bool) { remAttr(dom, name); return false }
	    })
	
	    // if this is a tag, stop traversing here.
	    // we ignore the root, since parseExpressions is called while we're mounting that root
	    var tagImpl = getTag(dom)
	    if (tagImpl && dom !== root) {
	      attr = {dom: dom, impl: tagImpl, isTag: true,
	        ownAttrs: allAttrs, nameHasExpression: nameHasExpression}
	      if (dom.tagName == 'VIRTUAL') attr.isVirtual = true
	
	      parent.children.push(attr)
	      return false
	    }
	
	    // whatever the parent is, all child elements get the same parent.
	    // If this element had an if-attr, that's the parent for all child elements
	    return {parent: parent}
	  }, base)
	}
	function Tag(impl, conf, innerHTML) {
	
	  var self = riot.observable(this),
	    opts = inherit(conf.opts) || {},
	    parent = conf.parent,
	    isLoop = conf.isLoop,
	    hasImpl = conf.hasImpl,
	    ownAttrs = conf.ownAttrs, // attributes on this tag (evaluated in parent context)
	    item = cleanUpData(conf.item),
	    expressions = [],
	    root = conf.root,
	    fn = impl.fn,
	    tagName = root.tagName.toLowerCase(),
	    attr = {},
	    implAttr = {},
	    propsInSyncWithParent = [],
	    dom
	
	  if (fn && root._tag) root._tag.unmount(true)
	
	  // not yet mounted
	  this.isMounted = false
	  root.isLoop = isLoop
	
	  // keep a reference to the tag just created
	  // so we will be able to mount this tag multiple times
	  root._tag = this
	
	  // create a unique id to this tag
	  // it could be handy to use it also to improve the virtual dom rendering speed
	  defineProperty(this, '_riot_id', ++__uid) // base 1 allows test !t._riot_id
	
	  extend(this, { parent: parent, root: root, opts: opts, tags: {} }, item)
	
	  // grab attributes
	  each(root.attributes, function(el) {
	    var val = el.value
	    // remember attributes with expressions only
	    if (tmpl.hasExpr(val)) attr[el.name] = val
	  })
	
	  dom = mkdom(impl, innerHTML, implAttr)
	  implAttr = implAttr.attrs || ''
	
	
	  // options
	  function updateOpts() {
	    var ctx = hasImpl && isLoop ? self : parent || self
	
	    // If we're nested beneath another tag, then our attributes are evaluated
	    // in that parent context. Here, we copy them onto opts.
	    if (ownAttrs) {
	      each(ownAttrs || [], function(expr) {
	        // if the attribute doesn't actually have an expression, there
	        // won't be a value. Just use the string itself in this case.
	        var v = expr.hasOwnProperty('value') ? expr.value : expr.expr
	        opts[toCamel(expr.attr)] = v
	      })
	
	    } else {
	      each(root.attributes, function(el) {
	        var val = el.value, hasTmpl = tmpl.hasExpr(val)
	        if (hasTmpl && ownAttrs) return // already handled above
	        opts[toCamel(el.name)] = hasTmpl ? tmpl(val, ctx) : val
	      })
	    }
	  }
	
	  function normalizeData(data) {
	    for (var key in item) {
	      if (typeof self[key] !== T_UNDEF && isWritable(self, key))
	        self[key] = data[key]
	    }
	  }
	
	  function inheritFromParent () {
	    if (!self.parent || !isLoop) return
	    each(Object.keys(self.parent), function(k) {
	      // some properties must be always in sync with the parent tag
	      var mustSync = !contains(RESERVED_WORDS_BLACKLIST, k) && contains(propsInSyncWithParent, k)
	      if (typeof self[k] === T_UNDEF || mustSync) {
	        // track the property to keep in sync
	        // so we can keep it updated
	        if (!mustSync) propsInSyncWithParent.push(k)
	        self[k] = self.parent[k]
	      }
	    })
	  }
	
	  defineProperty(this, 'update', function(data) {
	
	    // make sure the data passed will not override
	    // the component core methods
	    data = cleanUpData(data)
	    // inherit properties from the parent
	    inheritFromParent()
	    // normalize the tag properties in case an item object was initially passed
	    if (data && typeof item === T_OBJECT) {
	      normalizeData(data)
	      item = data
	    }
	    extend(self, data)
	    updateOpts()
	    self.trigger('update', data)
	    update(expressions, self)
	    // the updated event will be triggered
	    // once the DOM will be ready and all the reflows are completed
	    // this is useful if you want to get the "real" root properties
	    // 4 ex: root.offsetWidth ...
	    rAF(function() { self.trigger('updated') })
	    return this
	  })
	
	  defineProperty(this, 'mixin', function() {
	    each(arguments, function(mix) {
	      var instance
	
	      mix = typeof mix === T_STRING ? riot.mixin(mix) : mix
	
	      // check if the mixin is a function
	      if (isFunction(mix)) {
	        // create the new mixin instance
	        instance = new mix()
	        // save the prototype to loop it afterwards
	        mix = mix.prototype
	      } else instance = mix
	
	      // loop the keys in the function prototype or the all object keys
	      each(Object.getOwnPropertyNames(mix), function(key) {
	        // bind methods to self
	        if (key != 'init')
	          self[key] = isFunction(instance[key]) ?
	                        instance[key].bind(self) :
	                        instance[key]
	      })
	
	      // init method will be called automatically
	      if (instance.init) instance.init.bind(self)()
	    })
	    return this
	  })
	
	  defineProperty(this, 'mount', function() {
	
	    updateOpts()
	
	    // add global mixin
	    var globalMixin = riot.mixin(GLOBAL_MIXIN)
	    if (globalMixin) self.mixin(globalMixin)
	
	    // initialiation
	    if (fn) fn.call(self, opts)
	
	    // update the root adding custom attributes coming from the compiler
	    // it fixes also #1087
	    if (implAttr || hasImpl) {
	      walkAttributes(implAttr, function (k, v) { setAttr(root, k, v) })
	      parseExpressions(self.root, self, expressions)
	    }
	
	    // parse layout after init. fn may calculate args for nested custom tags
	    parseExpressions(dom, self, expressions)
	
	    // unmount automatically when our parent does
	    if (parent) parent.on('unmount', self.unmount)
	
	    if (!self.parent || isLoop) self.update(item)
	
	    // internal use only, fixes #403
	    self.trigger('before-mount')
	
	    if (isLoop && !hasImpl) {
	      // update the root attribute for the looped elements
	      self.root = root = dom.firstChild
	
	    } else {
	      while (dom.firstChild) root.appendChild(dom.firstChild)
	      if (root.stub) self.root = root = parent.root
	    }
	
	    // if it's not a child tag we can trigger its mount event
	    if (!self.parent || self.parent.isMounted) {
	      self.isMounted = true
	      self.trigger('mount')
	    }
	    // otherwise we need to wait that the parent event gets triggered
	    else self.parent.one('mount', function() {
	      // avoid to trigger the `mount` event for the tags
	      // not visible included in an if statement
	      if (!isInStub(self.root)) {
	        self.parent.isMounted = self.isMounted = true
	        self.trigger('mount')
	      }
	    })
	  })
	
	
	  defineProperty(this, 'unmount', function(keepRootTag) {
	    var el = root,
	      p = el.parentNode,
	      ptag,
	      tagIndex = __virtualDom.indexOf(self)
	
	    self.trigger('before-unmount')
	
	    // remove this tag instance from the global virtualDom variable
	    if (~tagIndex)
	      __virtualDom.splice(tagIndex, 1)
	
	    if (this._virts) {
	      each(this._virts, function(v) {
	        if (v.parentNode) v.parentNode.removeChild(v)
	      })
	    }
	
	    if (p) {
	
	      if (parent) {
	        ptag = getImmediateCustomParentTag(parent)
	        // remove this tag from the parent tags object
	        // if there are multiple nested tags with same name..
	        // remove this element form the array
	        if (isArray(ptag.tags[tagName]))
	          each(ptag.tags[tagName], function(tag, i) {
	            if (tag._riot_id == self._riot_id)
	              ptag.tags[tagName].splice(i, 1)
	          })
	        else
	          // otherwise just delete the tag instance
	          ptag.tags[tagName] = undefined
	      }
	
	      else
	        while (el.firstChild) el.removeChild(el.firstChild)
	
	      if (!keepRootTag)
	        p.removeChild(el)
	      else
	        // the riot-tag attribute isn't needed anymore, remove it
	        remAttr(p, 'riot-tag')
	    }
	
	
	    self.trigger('unmount')
	    if (parent) parent.off('unmount', self.unmount)
	    self.off('*')
	    self.isMounted = false
	    delete root._tag
	
	  })
	}
	/**
	 * Attach an event to a DOM node
	 * @param { String } name - event name
	 * @param { Function } handler - event callback
	 * @param { Object } dom - dom node
	 * @param { Tag } tag - tag instance
	 */
	function setEventHandler(name, handler, dom, tag) {
	
	  dom[name] = function(e) {
	
	    var ptag = tag._parent,
	      item = tag._item,
	      el
	
	    if (!item)
	      while (ptag && !item) {
	        item = ptag._item
	        ptag = ptag._parent
	      }
	
	    // cross browser event fix
	    e = e || window.event
	
	    // override the event properties
	    if (isWritable(e, 'currentTarget')) e.currentTarget = dom
	    if (isWritable(e, 'target')) e.target = e.srcElement
	    if (isWritable(e, 'which')) e.which = e.charCode || e.keyCode
	
	    e.item = item
	
	    // prevent default behaviour (by default)
	    if (handler.call(tag, e) !== true && !/radio|check/.test(dom.type)) {
	      if (e.preventDefault) e.preventDefault()
	      e.returnValue = false
	    }
	
	    if (!e.preventUpdate) {
	      el = item ? getImmediateCustomParentTag(ptag) : tag
	      el.update()
	    }
	
	  }
	
	}
	
	
	/**
	 * Insert a DOM node replacing another one (used by if- attribute)
	 * @param   { Object } root - parent node
	 * @param   { Object } node - node replaced
	 * @param   { Object } before - node added
	 */
	function insertTo(root, node, before) {
	  if (!root) return
	  root.insertBefore(before, node)
	  root.removeChild(node)
	}
	
	/**
	 * Update the expressions in a Tag instance
	 * @param   { Array } expressions - expression that must be re evaluated
	 * @param   { Tag } tag - tag instance
	 */
	function update(expressions, tag) {
	
	  each(expressions, function(expr, i) {
	
	    var dom = expr.dom,
	      attrName = expr.attr,
	      value = tmpl(expr.expr, tag),
	      parent = dom && dom.parentNode
	
	    if (expr.bool)
	      value = value ? attrName : false
	    else if (value == null)
	      value = ''
	
	    // leave out riot- prefixes from strings inside textarea
	    // fix #815: any value -> string
	    if (parent && parent.tagName == 'TEXTAREA') {
	      value = ('' + value).replace(/riot-/g, '')
	      // change textarea's value
	      parent.value = value
	    }
	
	    var old = expr.value
	    expr.value = value
	
	    if (expr.isIf) return updateIf(expr, old, value, tag)
	    if (expr.isTag) return updateTagRef(expr, tag)
	    if (expr.isLoop) return expr.update()
	    if (expr.isNamed) return updateNamed(expr, old, value, tag)
	
	    // no change, so nothing more to do
	    if (old === value) return
	
	    // text node
	    if (!attrName) {
	      dom.nodeValue = '' + value    // #815 related
	      return
	    }
	
	    // remove original attribute
	    remAttr(dom, attrName)
	    // event handler
	    if (isFunction(value)) {
	      setEventHandler(attrName, value, dom, tag)
	
	    // show / hide
	    } else if (/^(show|hide)$/.test(attrName)) {
	      if (attrName == 'hide') value = !value
	      dom.style.display = value ? '' : 'none'
	
	    // field value
	    } else if (attrName == 'value') {
	      dom.value = value
	
	    // <img src="{ expr }">
	    } else if (startsWith(attrName, RIOT_PREFIX) && attrName != RIOT_TAG) {
	      if (value)
	        setAttr(dom, attrName.slice(RIOT_PREFIX.length), value)
	
	    } else {
	      // <select> <option selected={true}> </select>
	      if (attrName == 'selected' && parent && /^(SELECT|OPTGROUP)$/.test(parent.nodeName) && value)
	        parent.value = dom.value
	
	      if (expr.bool) {
	        dom[attrName] = value
	        if (!value) return
	      }
	
	      if (value === 0 || value && typeof value !== T_OBJECT)
	        setAttr(dom, attrName, value)
	
	    }
	
	  })
	
	}
	
	// Named expressions set a property on the parent, so that
	// <input name='foo' /> is available as this.foo
	function updateNamed(expr, old, value, tag) {
	  if (expr.done) return // only set named once
	  // names only get set on custom tags (not loop items, for example)
	  var parent = getImmediateCustomParentTag(tag)
	  setNamed(expr.dom, parent, value)
	  expr.done = true
	}
	
	// TagRef points to a child tag that may or may not exist yet.
	// This way, we don't mount a tag until it's actually going to be inserted into DOM
	function updateTagRef(expr, parent) {
	  if (expr.tag) {
	    expr.tag.update()
	    return
	  }
	
	  var conf = {root: expr.dom, parent: parent, hasImpl: true, ownAttrs: expr.ownAttrs}
	  expr.tag = initChildTag(expr.impl, conf, expr.dom.innerHTML, parent, expr.nameHasExpression)
	  expr.tag.mount()
	
	  if (expr.isVirtual) {
	    var frag = document.createDocumentFragment()
	    makeVirtual(expr.tag, frag)
	    expr.tag.root.parentElement.replaceChild(frag, expr.tag.root)
	  }
	  expr.tag.update()
	}
	
	// If expressions add or remove DOM, as well as control the flow of updates.
	// An if-expression that remains false won't update any dependants.
	// When the truthyness changes, we insert the DOM, or a stub to hold position.
	function updateIf(expr, old, value, tag) {
	  // if the truthyness remains unchange
	  if (expr.started && !value == !old) {
	    if (value)
	      update(expr.children, tag)
	    return
	  }
	
	  var stub, dom = expr.dom
	  stub = expr.stub = expr.stub || document.createTextNode('')
	
	  // add to DOM
	  if (value) {
	    update(expr.children, tag)
	    insertTo(stub.parentNode, stub, dom)
	  } else {
	    if (dom.parentNode) insertTo(dom.parentNode, dom, stub)
	    // pretty sure this only happens with <foo each={items} if={show} />
	    else tag.stub = stub
	  }
	  expr.started = true
	}
	/**
	 * Specialized function for looping an array-like collection with `each={}`
	 * @param   { Array } els - collection of items
	 * @param   {Function} fn - callback function
	 * @returns { Array } the array looped
	 */
	function each(els, fn) {
	  var len = els ? els.length : 0
	
	  for (var i = 0, el; i < len; i++) {
	    el = els[i]
	    // return false -> current item was removed by fn during the loop
	    if (el != null && fn(el, i) === false) i--
	  }
	  return els
	}
	
	/**
	 * Detect if the argument passed is a function
	 * @param   { * } v - whatever you want to pass to this function
	 * @returns { Boolean } -
	 */
	function isFunction(v) {
	  return typeof v === T_FUNCTION || false   // avoid IE problems
	}
	
	/**
	 * Detect if the argument passed is an object
	 * @param   { * } v - whatever you want to pass to this function
	 * @returns { Boolean } -
	 */
	function isObject(v) {
	  return typeof v === T_OBJECT || false   // avoid IE problems
	}
	
	/**
	 * Remove any DOM attribute from a node
	 * @param   { Object } dom - DOM node we want to update
	 * @param   { String } name - name of the property we want to remove
	 */
	function remAttr(dom, name) {
	  dom.removeAttribute(name)
	}
	
	/**
	 * Convert a string containing dashes to camel case
	 * @param   { String } string - input string
	 * @returns { String } my-string -> myString
	 */
	function toCamel(string) {
	  return string.replace(/-(\w)/g, function(_, c) {
	    return c.toUpperCase()
	  })
	}
	
	/**
	 * Get the value of any DOM attribute on a node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { String } name - name of the attribute we want to get
	 * @returns { String | undefined } name of the node attribute whether it exists
	 */
	function getAttr(dom, name) {
	  return dom.getAttribute(name)
	}
	
	/**
	 * Set any DOM attribute
	 * @param { Object } dom - DOM node we want to update
	 * @param { String } name - name of the property we want to set
	 * @param { String } val - value of the property we want to set
	 */
	function setAttr(dom, name, val) {
	  dom.setAttribute(name, val)
	}
	
	/**
	 * Detect the tag implementation by a DOM node
	 * @param   { Object } dom - DOM node we need to parse to get its tag implementation
	 * @returns { Object } it returns an object containing the implementation of a custom tag (template and boot function)
	 */
	function getTag(dom) {
	  return dom.tagName && __tagImpl[getAttr(dom, RIOT_TAG) || dom.tagName.toLowerCase()]
	}
	/**
	 * Add a child tag to its parent into the `tags` object
	 * @param   { Object } tag - child tag instance
	 * @param   { String } tagName - key where the new tag will be stored
	 * @param   { Object } parent - tag instance where the new child tag will be included
	 */
	function addChildTag(tag, tagName, parent) {
	  var cachedTag = parent.tags[tagName]
	
	  // if there are multiple children tags having the same name
	  if (cachedTag) {
	    // if the parent tags property is not yet an array
	    // create it adding the first cached tag
	    if (!isArray(cachedTag))
	      // don't add the same tag twice
	      if (cachedTag !== tag)
	        parent.tags[tagName] = [cachedTag]
	    // add the new nested tag to the array
	    if (!contains(parent.tags[tagName], tag))
	      parent.tags[tagName].push(tag)
	  } else {
	    parent.tags[tagName] = tag
	  }
	}
	
	/**
	 * Move the position of a custom tag in its parent tag
	 * @param   { Object } tag - child tag instance
	 * @param   { String } tagName - key where the tag was stored
	 * @param   { Number } newPos - index where the new tag will be stored
	 */
	function moveChildTag(tag, tagName, newPos) {
	  var parent = tag.parent,
	    tags
	  // no parent no move
	  if (!parent) return
	
	  tags = parent.tags[tagName]
	
	  if (isArray(tags))
	    tags.splice(newPos, 0, tags.splice(tags.indexOf(tag), 1)[0])
	  else addChildTag(tag, tagName, parent)
	}
	
	/**
	 * Create a new child tag including it correctly into its parent
	 * @param   { Object } child - child tag implementation
	 * @param   { Object } opts - tag options containing the DOM node where the tag will be mounted
	 * @param   { String } innerHTML - inner html of the child node
	 * @param   { Object } parent - instance of the parent tag including the child custom tag
	 * @param   { Boolean } skipName - hack to ignore the name attribute when attaching to parent
	 * @returns { Object } instance of the new child tag just created
	 */
	function initChildTag(child, opts, innerHTML, parent, skipName) {
	  var tag = new Tag(child, opts, innerHTML),
	    tagName = getTagName(opts.root, skipName),
	    ptag = getImmediateCustomParentTag(parent)
	  // fix for the parent attribute in the looped elements
	  tag.parent = ptag
	  // store the real parent tag
	  // in some cases this could be different from the custom parent tag
	  // for example in nested loops
	  tag._parent = parent
	
	  // add this tag to the custom parent tag
	  addChildTag(tag, tagName, ptag)
	  // and also to the real parent tag
	  if (ptag !== parent)
	    addChildTag(tag, tagName, parent)
	  // empty the child node once we got its template
	  // to avoid that its children get compiled multiple times
	  opts.root.innerHTML = ''
	
	  return tag
	}
	
	/**
	 * Loop backward all the parents tree to detect the first custom parent tag
	 * @param   { Object } tag - a Tag instance
	 * @returns { Object } the instance of the first custom parent tag found
	 */
	function getImmediateCustomParentTag(tag) {
	  var ptag = tag
	  while (!getTag(ptag.root)) {
	    if (!ptag.parent) break
	    ptag = ptag.parent
	  }
	  return ptag
	}
	
	/**
	 * Helper function to set an immutable property
	 * @param   { Object } el - object where the new property will be set
	 * @param   { String } key - object key where the new property will be stored
	 * @param   { * } value - value of the new property
	* @param   { Object } options - set the propery overriding the default options
	 * @returns { Object } - the initial object
	 */
	function defineProperty(el, key, value, options) {
	  Object.defineProperty(el, key, extend({
	    value: value,
	    enumerable: false,
	    writable: false,
	    configurable: false
	  }, options))
	  return el
	}
	
	/**
	 * Get the tag name of any DOM node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { Boolean } skipName - hack to ignore the name attribute when attaching to parent
	 * @returns { String } name to identify this dom node in riot
	 */
	function getTagName(dom, skipName) {
	  var child = getTag(dom),
	    namedTag = !skipName && getAttr(dom, 'name'),
	    tagName = namedTag && !tmpl.hasExpr(namedTag) ?
	                namedTag :
	              child ? child.name : dom.tagName.toLowerCase()
	
	  return tagName
	}
	
	/**
	 * Extend any object with other properties
	 * @param   { Object } src - source object
	 * @returns { Object } the resulting extended object
	 *
	 * var obj = { foo: 'baz' }
	 * extend(obj, {bar: 'bar', foo: 'bar'})
	 * console.log(obj) => {bar: 'bar', foo: 'bar'}
	 *
	 */
	function extend(src) {
	  var obj, args = arguments
	  for (var i = 1; i < args.length; ++i) {
	    if (obj = args[i]) {
	      for (var key in obj) {
	        // check if this property of the source object could be overridden
	        if (isWritable(src, key))
	          src[key] = obj[key]
	      }
	    }
	  }
	  return src
	}
	
	/**
	 * Check whether an array contains an item
	 * @param   { Array } arr - target array
	 * @param   { * } item - item to test
	 * @returns { Boolean } Does 'arr' contain 'item'?
	 */
	function contains(arr, item) {
	  return ~arr.indexOf(item)
	}
	
	/**
	 * Check whether an object is a kind of array
	 * @param   { * } a - anything
	 * @returns {Boolean} is 'a' an array?
	 */
	function isArray(a) { return Array.isArray(a) || a instanceof Array }
	
	/**
	 * Detect whether a property of an object could be overridden
	 * @param   { Object }  obj - source object
	 * @param   { String }  key - object property
	 * @returns { Boolean } is this property writable?
	 */
	function isWritable(obj, key) {
	  var props = Object.getOwnPropertyDescriptor(obj, key)
	  return typeof obj[key] === T_UNDEF || props && props.writable
	}
	
	
	/**
	 * With this function we avoid that the internal Tag methods get overridden
	 * @param   { Object } data - options we want to use to extend the tag instance
	 * @returns { Object } clean object without containing the riot internal reserved words
	 */
	function cleanUpData(data) {
	  if (!(data instanceof Tag) && !(data && typeof data.trigger == T_FUNCTION))
	    return data
	
	  var o = {}
	  for (var key in data) {
	    if (!contains(RESERVED_WORDS_BLACKLIST, key))
	      o[key] = data[key]
	  }
	  return o
	}
	
	/**
	 * Walk down recursively all the children tags starting dom node
	 * @param   { Object }   dom - starting node where we will start the recursion
	 * @param   { Function } fn - callback to transform the child node just found
	 * @param   { Object }   context - fn can optionally return an object, which is passed to children
	 */
	function walk(dom, fn, context) {
	  if (dom) {
	    var res = fn(dom, context)
	    // stop the recursion
	    if (res === false) return
	    else {
	      dom = dom.firstChild
	
	      while (dom) {
	        walk(dom, fn, res)
	        dom = dom.nextSibling
	      }
	    }
	  }
	}
	
	/**
	 * Minimize risk: only zero or one _space_ between attr & value
	 * @param   { String }   html - html string we want to parse
	 * @param   { Function } fn - callback function to apply on any attribute found
	 */
	function walkAttributes(html, fn) {
	  var m,
	    re = /([-\w]+) ?= ?(?:"([^"]*)|'([^']*)|({[^}]*}))/g
	
	  while (m = re.exec(html)) {
	    fn(m[1].toLowerCase(), m[2] || m[3] || m[4])
	  }
	}
	
	/**
	 * Check whether a DOM node is in stub mode, useful for the riot 'if' directive
	 * @param   { Object }  dom - DOM node we want to parse
	 * @returns { Boolean } -
	 */
	function isInStub(dom) {
	  while (dom) {
	    if (dom.inStub) return true
	    dom = dom.parentNode
	  }
	  return false
	}
	
	/**
	 * Create a generic DOM node
	 * @param   { String } name - name of the DOM node we want to create
	 * @returns { Object } DOM node just created
	 */
	function mkEl(name) {
	  return document.createElement(name)
	}
	
	/**
	 * Shorter and fast way to select multiple nodes in the DOM
	 * @param   { String } selector - DOM selector
	 * @param   { Object } ctx - DOM node where the targets of our search will is located
	 * @returns { Object } dom nodes found
	 */
	function $$(selector, ctx) {
	  return (ctx || document).querySelectorAll(selector)
	}
	
	/**
	 * Shorter and fast way to select a single node in the DOM
	 * @param   { String } selector - unique dom selector
	 * @param   { Object } ctx - DOM node where the target of our search will is located
	 * @returns { Object } dom node found
	 */
	function $(selector, ctx) {
	  return (ctx || document).querySelector(selector)
	}
	
	/**
	 * Simple object prototypal inheritance
	 * @param   { Object } parent - parent object
	 * @returns { Object } child instance
	 */
	function inherit(parent) {
	  function Child() {}
	  Child.prototype = parent
	  return new Child()
	}
	
	/**
	 * Get the name property needed to identify a DOM node in riot
	 * @param   { Object } dom - DOM node we need to parse
	 * @returns { String | undefined } give us back a string to identify this dom node
	 */
	function getNamedKey(dom) {
	  return getAttr(dom, 'id') || getAttr(dom, 'name')
	}
	
	/**
	 * Set the named properties of a tag element
	 * @param { Object } dom - DOM node we need to parse
	 * @param { Object } parent - tag instance where the named dom element will be eventually added
	 * @param { Array } key - the key on which to set on parent
	 */
	function setNamed(dom, parent, key) {
	  // get the key value we want to add to the tag instance
	  key = key || getNamedKey(dom)
	  if (!key) return
	
	  var dest = parent[key]
	  var isArr = isArray(dest)
	
	  // if the key was never set, set it once on the tag instance
	  if (!dest) parent[key] = dom
	  // if it was an array and not yet set
	  else if (!isArr || isArr && !contains(dest, dom)) {
	    // add the dom node into the array
	    if (isArr)
	      dest.push(dom)
	    else
	      parent[key] = [dest, dom]
	  }
	}
	
	/**
	 * Faster String startsWith alternative
	 * @param   { String } src - source string
	 * @param   { String } str - test string
	 * @returns { Boolean } -
	 */
	function startsWith(src, str) {
	  return src.slice(0, str.length) === str
	}
	
	/**
	 * requestAnimationFrame function
	 * Adapted from https://gist.github.com/paulirish/1579671, license MIT
	 */
	var rAF = (function (w) {
	  var raf = w.requestAnimationFrame    ||
	            w.mozRequestAnimationFrame || w.webkitRequestAnimationFrame
	
	  if (!raf || /iP(ad|hone|od).*OS 6/.test(w.navigator.userAgent)) {  // buggy iOS6
	    var lastTime = 0
	
	    raf = function (cb) {
	      var nowtime = Date.now(), timeout = Math.max(16 - (nowtime - lastTime), 0)
	      setTimeout(function () { cb(lastTime = nowtime + timeout) }, timeout)
	    }
	  }
	  return raf
	
	})(window || {})
	
	/**
	 * Mount a tag creating new Tag instance
	 * @param   { Object } root - dom node where the tag will be mounted
	 * @param   { String } tagName - name of the riot tag we want to mount
	 * @param   { Object } opts - options to pass to the Tag instance
	 * @returns { Tag } a new Tag instance
	 */
	function mountTo(root, tagName, opts) {
	  var tag = __tagImpl[tagName],
	    // cache the inner HTML to fix #855
	    innerHTML = root._innerHTML = root._innerHTML || root.innerHTML
	
	  // clear the inner html
	  root.innerHTML = ''
	
	  if (tag && root) tag = new Tag(tag, { root: root, opts: opts }, innerHTML)
	
	  if (tag && tag.mount) {
	    tag.mount()
	    // add this tag to the virtualDom variable
	    if (!contains(__virtualDom, tag)) __virtualDom.push(tag)
	  }
	
	  return tag
	}
	
	
	/**
	 * Adds the elements for a virtual tag
	 * @param { Tag } tag - the tag whose root's children will be inserted or appended
	 * @param { Node } src - the node that will do the inserting or appending
	 * @param { Tag } target - only if inserting, insert before this tag's first child
	 */
	function makeVirtual(tag, src, target) {
	  var head = document.createTextNode(''), tail = document.createTextNode(''), sib, el
	  tag._head = tag.root.insertBefore(head, tag.root.firstChild)
	  tag._tail = tag.root.appendChild(tail)
	  el = tag._head
	  tag._virts = []
	  while (el) {
	    sib = el.nextSibling
	    if (target)
	      src.insertBefore(el, target._head)
	    else
	      src.appendChild(el)
	
	    tag._virts.push(el) // hold for unmounting
	    el = sib
	  }
	}
	
	/**
	 * Move virtual tag and all child nodes
	 * @param { Tag } tag - first child reference used to start move
	 * @param { Node } src  - the node that will do the inserting
	 * @param { Tag } target - insert before this tag's first child
	 */
	function moveVirtual(tag, src, target) {
	  var el = tag._head, sib
	  while (el) {
	    sib = el.nextSibling
	    src.insertBefore(el, target._head)
	    el = sib
	    if (el == tag._tail) {
	      src.insertBefore(el, target._head)
	      break
	    }
	  }
	}
	/**
	 * Riot public api
	 */
	
	// share methods for other riot parts, e.g. compiler
	riot.util = { brackets: brackets, tmpl: tmpl }
	
	/**
	 * Create a mixin that could be globally shared across all the tags
	 */
	riot.mixin = (function() {
	  var mixins = {}
	
	  /**
	   * Create/Return a mixin by its name
	   * @param   { String } name - mixin name (global mixin if missing)
	   * @param   { Object } mixin - mixin logic
	   * @returns { Object } the mixin logic
	   */
	  return function(name, mixin) {
	    if (isObject(name)) {
	      mixin = name
	      mixins[GLOBAL_MIXIN] = extend(mixins[GLOBAL_MIXIN] || {}, mixin)
	      return
	    }
	
	    if (!mixin) return mixins[name]
	    mixins[name] = mixin
	  }
	
	})()
	
	/**
	 * Create a new riot tag implementation
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   html - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	riot.tag = function(name, html, css, attrs, fn) {
	  if (isFunction(attrs)) {
	    fn = attrs
	    if (/^[\w\-]+\s?=/.test(css)) {
	      attrs = css
	      css = ''
	    } else attrs = ''
	  }
	  if (css) {
	    if (isFunction(css)) fn = css
	    else styleManager.add(css)
	  }
	  __tagImpl[name] = { name: name, tmpl: html, attrs: attrs, fn: fn }
	  return name
	}
	
	/**
	 * Create a new riot tag implementation (for use by the compiler)
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   html - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @param   { string }  [bpair] - brackets used in the compilation
	 * @returns { String } name/id of the tag just created
	 */
	riot.tag2 = function(name, html, css, attrs, fn, bpair) {
	  if (css) styleManager.add(css)
	  //if (bpair) riot.settings.brackets = bpair
	  __tagImpl[name] = { name: name, tmpl: html, attrs: attrs, fn: fn }
	  return name
	}
	
	/**
	 * Mount a tag using a specific tag implementation
	 * @param   { String } selector - tag DOM selector
	 * @param   { String } tagName - tag implementation name
	 * @param   { Object } opts - tag logic
	 * @returns { Array } new tags instances
	 */
	riot.mount = function(selector, tagName, opts) {
	
	  var els,
	    allTags,
	    tags = []
	
	  // helper functions
	
	  function addRiotTags(arr) {
	    var list = ''
	    each(arr, function (e) {
	      if (!/[^-\w]/.test(e))
	        list += ',*[' + RIOT_TAG + '=' + e.trim() + ']'
	    })
	    return list
	  }
	
	  function selectAllTags() {
	    var keys = Object.keys(__tagImpl)
	    return keys + addRiotTags(keys)
	  }
	
	  function pushTags(root) {
	    if (root.tagName) {
	      var riotTag = getAttr(root, RIOT_TAG)
	
	      // have tagName? force riot-tag to be the same
	      if (tagName && riotTag !== tagName) {
	        riotTag = tagName
	        setAttr(root, RIOT_TAG, tagName)
	      }
	      var tag = mountTo(root, riotTag || root.tagName.toLowerCase(), opts)
	
	      if (tag) tags.push(tag)
	    } else if (root.length) {
	      each(root, pushTags)   // assume nodeList
	    }
	  }
	
	  // ----- mount code -----
	
	  // inject styles into DOM
	  styleManager.inject()
	
	  if (typeof tagName === T_OBJECT) {
	    opts = tagName
	    tagName = 0
	  }
	
	  // crawl the DOM to find the tag
	  if (typeof selector === T_STRING) {
	    if (selector === '*')
	      // select all the tags registered
	      // and also the tags found with the riot-tag attribute set
	      selector = allTags = selectAllTags()
	    else
	      // or just the ones named like the selector
	      selector += addRiotTags(selector.split(/, ?/))
	
	    // make sure to pass always a selector
	    // to the querySelectorAll function
	    els = selector ? $$(selector) : []
	  }
	  else
	    // probably you have passed already a tag or a NodeList
	    els = selector
	
	  // select all the registered and mount them inside their root elements
	  if (tagName === '*') {
	    // get all custom tags
	    tagName = allTags || selectAllTags()
	    // if the root els it's just a single tag
	    if (els.tagName)
	      els = $$(tagName, els)
	    else {
	      // select all the children for all the different root elements
	      var nodeList = []
	      each(els, function (_el) {
	        nodeList.push($$(tagName, _el))
	      })
	      els = nodeList
	    }
	    // get rid of the tagName
	    tagName = 0
	  }
	
	  pushTags(els)
	
	  return tags
	}
	
	/**
	 * Update all the tags instances created
	 * @returns { Array } all the tags instances
	 */
	riot.update = function() {
	  return each(__virtualDom, function(tag) {
	    tag.update()
	  })
	}
	
	/**
	 * Export the Tag constructor
	 */
	riot.Tag = Tag
	  // support CommonJS, AMD & browser
	  /* istanbul ignore next */
	  if (typeof exports === T_OBJECT)
	    module.exports = riot
	  else if ("function" === T_FUNCTION && typeof __webpack_require__(858) !== T_UNDEF)
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return riot }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else
	    window.riot = riot
	
	})(typeof window != 'undefined' ? window : void 0);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(840)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(8)
	  , core      = __webpack_require__(39)
	  , hide      = __webpack_require__(22)
	  , redefine  = __webpack_require__(23)
	  , ctx       = __webpack_require__(40)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(observable, $) {'use strict';
	
	var _stringify = __webpack_require__(29);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var API = {
	  url: '/api/',
	  version: function version() {
	    var url = new URL(window.location);
	    var searchParams = new URLSearchParams(url.search.substring(1));
	    // сейчас в любом случае Shop
	    return 'Shop';
	  },
	  complete: function complete(params) {
	    if (!('notFoundRedirect' in params)) params.notFoundRedirect = true;
	    if (!('unauthorizedReload' in params)) params.unauthorizedReload = true;
	
	    return function (xhr) {
	      var response = void 0;
	      try {
	        response = JSON.parse(xhr.responseText);
	      } catch (e) {
	        response = xhr.responseText;
	      }
	
	      var errorPopup = function errorPopup() {
	        var msg = typeof response === 'string' ? response : response ? (0, _stringify2.default)(response) : '';
	
	        popups.create({
	          style: 'popup-danger',
	          title: 'Ошибка',
	          text: !msg || msg.trim() === '' ? 'Ошибка соединения с сервером' : msg,
	          timeout: 2000
	        });
	      };
	
	      var status = xhr.status;
	
	      // ВАЖНО: 200 обрабатываем в settings.success (иначе можно случайно задвоить)
	      switch (status) {
	        case 401:
	          if (params.unauthorizedReload) {
	            localStorage.removeItem('shop24');
	            localStorage.removeItem('shop24_permissions');
	            localStorage.removeItem('shop24_cookie');
	            localStorage.removeItem('shop24_user');
	            localStorage.removeItem('shop24_main_user');
	            window.location.reload(true);
	          }
	          break;
	
	        case 404:
	          if (params.notFoundRedirect) observable.trigger('not-found');
	          break;
	
	        case 500:
	          errorPopup();
	          if (params.error) params.error(response, xhr);
	          break;
	
	        default:
	          // для всех не-200
	          if (status !== 200) {
	            errorPopup();
	            if (params.error) params.error(response, xhr);
	          }
	          break;
	      }
	
	      if (params.complete) params.complete(response, xhr);
	    };
	  },
	  request: function request(params) {
	    var settings = {};
	
	    if (!params.object) throw new Error('"Object" parameter is required');
	    if (!params.method) throw new Error('"Method" parameter is required');
	
	    settings.crossDomain = true;
	    settings.xhrFields = { withCredentials: true };
	
	    settings.url = '' + this.url + this.version() + '/' + params.object + '/' + params.method + '/';
	    settings.method = 'POST';
	
	    settings.beforeSend = params.beforeSend || function (request) {
	      request.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
	    };
	
	    // ✅ JSON как JSON
	    if (params.data !== undefined) {
	      settings.data = (0, _stringify2.default)(params.data);
	      settings.contentType = 'application/json; charset=UTF-8';
	      settings.processData = false;
	    }
	
	    settings.dataType = 'json';
	
	    // ✅ успех обрабатываем тут
	    settings.success = function (response, textStatus, xhr) {
	      if (response && response.noticeCount) {
	        response.noticeCount.forEach(function (item) {
	          if (item.object) {
	            $('.notice-count-' + item.object).text(item.count);
	          }
	        });
	      }
	      if (params.success) params.success(response, xhr);
	    };
	
	    settings.complete = this.complete(params);
	
	    return $.ajax(settings);
	  },
	  requestCMS: function requestCMS(params) {
	    var settings = {};
	
	    if (!params.object) throw new Error('"Object" parameter is required');
	    if (!params.method) throw new Error('"Method" parameter is required');
	
	    settings.crossDomain = true;
	    settings.xhrFields = { withCredentials: true };
	
	    settings.url = this.url + '2_dev/CMS/' + params.object + '/';
	    settings.method = params.method;
	
	    settings.beforeSend = params.beforeSend || function (request) {
	      request.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
	    };
	
	    // ✅ JSON как JSON
	    if (params.data !== undefined) {
	      settings.data = (0, _stringify2.default)(params.data);
	      settings.contentType = 'application/json; charset=UTF-8';
	      settings.processData = false;
	    }
	
	    settings.dataType = 'json';
	    settings.complete = this.complete(params);
	
	    // если нужен success коллбек
	    if (params.success) {
	      settings.success = function (response, textStatus, xhr) {
	        params.success(response, xhr);
	      };
	    }
	
	    return $.ajax(settings);
	  },
	  upload: function upload(params) {
	    var settings = {};
	
	    if (!params.data) throw new Error('"Data" parameter is required');
	
	    if (!params.object) settings.url = '' + this.url + this.version() + '/Image/?section=' + params.section;else settings.url = '' + this.url + this.version() + '/' + params.object;
	
	    settings.method = 'POST';
	    settings.data = params.data;
	    settings.cache = false;
	    settings.processData = false;
	    settings.contentType = false;
	    settings.dataType = 'json';
	
	    settings.crossDomain = true;
	    settings.xhrFields = { withCredentials: true };
	
	    settings.beforeSend = function (request) {
	      request.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
	    };
	
	    if (params.progress) {
	      settings.xhr = function () {
	        var xhr = $.ajaxSettings.xhr();
	        xhr.upload.addEventListener('progress', function (e) {
	          if (e.lengthComputable) params.progress(e);
	        }, false);
	        return xhr;
	      };
	    }
	
	    if (params.success) {
	      settings.success = function (response, textStatus, xhr) {
	        params.success(response, xhr);
	      };
	    }
	
	    settings.complete = this.complete(params);
	    return $.ajax(settings);
	  },
	  download: function download(params) {
	    if (!params.object) throw new Error('"Object" parameter is required');
	    if (!params.method) throw new Error('"Method" parameter is required');
	
	    var xhr = new XMLHttpRequest();
	
	    // ✅ добавил method в URL (как в request)
	    xhr.open('POST', '' + this.url + this.version() + '/' + params.object + '/' + params.method + '/', true);
	    xhr.withCredentials = true;
	    xhr.responseType = 'arraybuffer';
	
	    xhr.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
	
	    xhr.onload = function () {
	      if (this.status === 200) {
	        var filename = '';
	
	        var disposition = xhr.getResponseHeader('Content-Disposition');
	        if (disposition && disposition.indexOf('attachment') !== -1) {
	          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
	          var matches = filenameRegex.exec(disposition);
	          if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
	        }
	
	        var type = xhr.getResponseHeader('Content-Type');
	        var blob = new Blob([this.response], { type: type });
	
	        if (typeof window.navigator.msSaveBlob !== 'undefined') {
	          window.navigator.msSaveBlob(blob, filename);
	        } else {
	          var URL_ = window.URL || window.webkitURL;
	          var downloadUrl = URL_.createObjectURL(blob);
	
	          if (filename) {
	            var a = document.createElement('a');
	            if (typeof a.download === 'undefined') {
	              window.location = downloadUrl;
	            } else {
	              a.href = downloadUrl;
	              a.download = filename;
	              document.body.appendChild(a);
	              a.click();
	            }
	          } else {
	            window.location = downloadUrl;
	          }
	
	          setTimeout(function () {
	            URL_.revokeObjectURL(downloadUrl);
	          }, 100);
	        }
	      }
	    };
	
	    // ✅ JSON как JSON
	    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
	    xhr.send((0, _stringify2.default)(params.data || {}));
	  },
	  authCheck: function authCheck(params) {
	    if (localStorage.getItem('shop24_cookie') == null) return;
	
	    var settings = {};
	    var _this = this;
	
	    $.ajax({
	      url: './config.json',
	      dataType: 'json',
	      success: function success(response) {
	        settings.url = response.data.hostApi + '/api/Auth/';
	        _this.url = response.data.hostApi + '/api/';
	
	        settings.method = 'GET';
	        settings.crossDomain = true;
	        settings.xhrFields = { withCredentials: true };
	
	        settings.beforeSend = function (xhr) {
	          xhr.setRequestHeader("Secookie", params.cookie || localStorage.getItem('shop24_cookie'));
	        };
	
	        settings.complete = function (xhr) {
	          var resp = void 0;
	          try {
	            resp = JSON.parse(xhr.responseText);
	          } catch (e) {
	            resp = xhr.responseText;
	          }
	
	          var status = xhr.status;
	          switch (status) {
	            case 200:
	              if (params && typeof params.success === 'function') params.success(resp, xhr);
	              break;
	            case 401:
	              if (params && typeof params.error === 'function') params.error(resp, xhr);
	              break;
	          }
	        };
	
	        return $.ajax(settings);
	      }
	    });
	  }
	};
	
	if (false) window.API = API;
	
	module.exports = API;
	
	if (false) module.hot.accept();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(16)))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var observable = riot.observable();
	
	if (false) window.observable = observable;
	
	module.exports = observable;
	
	if (false) module.hot.accept();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(83);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API, $) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(61);
	
	__webpack_require__(157);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('catalog', '  <div class="row">\n    <div class="col-md-12">\n      <form name="filters" onchange="{find}">\n        <yield from="filters"></yield>\n      </form>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">\n      <div class="form-inline m-b-2">\n        <button class="btn {allMode ? &quot;btn-primary&quot; : &quot;btn-default&quot;}" if="{opts.allselect &amp;&amp; (totalCount &gt; 0)}" type="button" onclick="{selectedAll}" title="{allMode ? &quot;Снять выделение&quot; : &quot;Выделить всё&quot;}"><i class="fa {allMode ? &quot;fa-toggle-on&quot; : &quot;fa-toggle-off&quot;}"></i></button>\n        <button class="btn btn-primary" if="{opts.add}" onclick="{opts.add}" type="button" title="Добавить"><i class="fa fa-plus"></i><span class="hidden-sm hidden-xs">&nbsp;Добавить</span></button>\n        <button class="btn btn-success" if="{opts.reload}" onclick="{reload}" title="Обновить (Ctrl+R)" type="button"><i class="fa fa-refresh"></i></button>\n        <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n        <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n        <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n        <yield from="head"></yield>\n      </div>\n    </div>\n    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">\n      <yield from="head-right"></yield>\n      <form class="form-inline text-right m-b-2">\n        <div class="form-group" if="{opts.search}">\n          <div class="input-group">\n            <input class="searchCatalog form-control" name="search" type="text" title="Поиск (Ctrl+F)" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n              <div class="btn-group" if="{showSearchFields}">\n                <datatable-search-select class="dropdown" if="{tags.datatable}" table="{tags.datatable}" fields="{searchFields}" store="{storeSettings}" align="right"></datatable-search-select>\n              </div>\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <div class="table-responsive">\n        <datatable cols="{opts.cols}" rows="{items}" handlers="{opts.handlers}" dblclick="{opts.dblclick}" __sortable="{opts.sortable}" contextmenu="{opts.contextMenu}" reorder="{opts.reorder}" loader="{loader}">\n          <yield from="body"></yield>\n          <yield></yield>\n        </datatable>\n      </div>\n    </div>\n  </div>\n  <div class="row" show="{!opts.disablepagination} &amp;&amp; {!opts.offtotal}">\n    <div class="col-md-12">\n      <bs-pagination show="{!opts.disablepagination}" name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination><span class="form-inline hidden-xs" show="{!opts.disablepagination}">\n        <select class="form-control" style="max-width: 50px;" value="{pages.limit}" onchange="{limitChange}">\n          <option>15</option>\n          <option>30</option>\n          <option>50</option>\n          <option>100</option>\n          <option>1000</option>\n        </select></span>\n      <div class="pull-right" show="{!opts.offtotal}" style="margin: 20px 0; height: 34px; line-height: 34px;">\n        <yield from="aggregation"></yield><strong>Всего: {totalCount}</strong>\n      </div>\n    </div>\n  </div>\n', 'catalog,[riot-tag="catalog"],[data-is="catalog"]{ position: relative; display: block; }', '', function (opts) {
	    'use strict';
	
	    var _typeof2 = __webpack_require__(74);
	
	    var _typeof3 = _interopRequireDefault(_typeof2);
	
	    var _keys = __webpack_require__(108);
	
	    var _keys2 = _interopRequireDefault(_keys);
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    var _this2 = this;
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.totalCount = 0;
	    self.allMode = false;
	    self.allIds = [];
	    self.lastParams = {};
	    self.isFirstRefresh = true;
	    self.searchFields = [];
	    self.showSearchFields = false;
	
	    /** 2018.04.10 закоментированно, тк не определено назначение метода ("выделить все" работает без него),
	     *  метод вызывал ошибку при запуске всплывающего окна с каталогом (паралельный запуск 2 каталогов),
	     *  при сворачивании всплывающего окна и клике на главный каталог - появлялась ошибка и не срабатывал первый клик
	     */
	    // observable.off('catalog-recount').on('catalog-recount', (allMode) => {
	    //     allMode = (typeof allMode !== 'undefined') ?  allMode : false;
	    //
	    //     console.log(self.tags.datatable)
	    //
	    //     var sr = self.tags.datatable.getSelectedRows().length;
	    //     var tc = self.totalCount;
	    //
	    //
	    //     //console.log('self.allMode == ' + self.allMode);
	    //     if(self.tags.datatable !== undefined){
	    //
	    //         console.log(sr + ' из ' + self.totalCount);
	    //
	    //         if(self.totalCount == sr && self.totalCount > 1){
	    //             self.allMode = true;
	    //         } else if(self.totalCount > sr){
	    //             self.allMode = false;
	    //         }
	    //     }
	    //
	    //     if(allMode) {
	    //         if(sr > 0){
	    //             self.allMode = true;
	    //         }
	    //     }
	    // });
	
	    self.selectedAll = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "selectedAll" }));
	
	        self.allMode = self.tags.datatable.selectAllRows(self.allMode);
	        if (self.allMode) {
	            self.selectedCount = self.totalCount;
	        }
	
	        observable.trigger('catalog-recount', true);
	    };
	
	    self.getSelectedMode = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getSelectedMode" }));
	
	        if (self.allMode) return { allMode: self.allMode, allModeLastParams: self.lastParams };else {
	            var rows = self.tags.datatable.getSelectedRows();
	            var ids = rows.map(function (item) {
	                return item.id;
	            });
	            return { ids: ids, allMode: false };
	        }
	    };
	
	    self.afterRemove = function (e) {
	        self.reload(e);
	    };
	
	    self.reorderNext = function () {
	        self.tags.datatable.reorderNext();
	    };
	
	    self.reorderPrev = function () {
	        self.tags.datatable.reorderPrev();
	    };
	
	    self.pages = {
	        count: 0,
	        current: 1,
	        limit: 15,
	        change: function change(e) {
	            self.pages.current = e.currentTarget.page;
	            self.reload();
	        }
	    };
	
	    self.reload = function (tempparam, e, relAPI) {
	
	        /** перезагрузить
	         *
	         *  @@@@@@ @@@@@@ @@     @@@@@@    @@    @@@@@@   |
	         *  @@  @@ @@     @@     @@  @@   @@@@   @@   @@  |
	         *  @@@@@@ @@@@@@ @@     @@  @@  @@  @@  @@   @@  |
	         *  @@ @@  @@     @@     @@  @@ @@@@@@@@ @@   @@  |
	         *  @@  @@ @@@@@@ @@@@@@ @@@@@@ @@    @@ @@@@@@   |
	         *
	         * @param {obj} tempparam  произвольные параметры из методов
	         * @param {boll} tempparam['dcreset']  принудит. запускает обнов. из API (сбрас. данные из памяти catalog)
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload",
	            groupLog: "reload", dComment: "opts", dArray: opts }));
	
	        self.trigger('reload');
	        self.allMode = false;
	        self.loader = true;
	
	        if (opts.disablepagination) {
	            delete self.pages.limit; // удалить лимит по кол-ву строк из параметров (в API)
	        }
	
	        if (tempparam && tempparam['dcreset']) self.datacatalog = undefined;
	
	        if (opts.limit) {
	            self.pages.limit = opts.limit;
	        }
	
	        self.update();
	
	        var sort;
	        if (self.tags.datatable) sort = self.tags.datatable.getSortedColumn();
	
	        var params = {};
	        params.offset = (self.pages.current - 1) * self.pages.limit;
	
	        if (params.offset < 0) {
	            params.offset = 0;
	        }
	
	        params.limit = self.pages.limit;
	
	        if (sort) {
	            params.sortBy = sort.name; // name столбца сортировки
	            params.sortOrder = sort.dir.toLowerCase();
	        }
	
	        if (opts.search && self.search) {
	            params.searchText = self.search.value;
	        }
	
	        if (opts.id) {
	            params.id = opts.id;
	        }
	
	        if (opts.curr) {
	            params.curr = opts.curr;
	        }
	
	        if (opts.filters && opts.filters instanceof Array) params.filters = opts.filters;else params.filters = serializeFilters();
	
	        if (opts.combineFilters && opts.filters && opts.filters instanceof Array) {
	            params.filters = [].concat(serializeFilters(), opts.filters);
	        }
	
	        if (opts.systemfilters && self.isFirstRefresh) params.filters = opts.systemfilters;
	
	        if (self.handlers) {
	            self.handlers['params'] = params;
	        }
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload",
	            groupLog: "reload", dComment: "params", dArray: params }));
	
	        /** ПОЛУЧЕНИЕ ДАННЫХ ИЗ БД И ТРАНС-ТАБЛИЧНЫХ ДАННЫХ
	         *  @param {object} params           именнованны массив
	         *  @param {str}    opts.method      произвольный метод или поумолчанию 'Fetch'
	         *  @param {int}    params.id        фильтрация результатов по id (пример: получение групп в которых состоит контакт)
	         *  @param {str}    params.curr      вернуть значения в валюте отличной от базовой
	         *  @param {array}  opts.items       указатель на раздел, где храниться список значений (по умолчанию items)
	         *  @param {object} opts.response    передает результаты СОВЕРШЕННОГО запроса (exm: response = '{ item }', )
	         *  @param {array}  opts.count       указатель на раздел, где храниться длина списка (по умолчанию count)
	         *
	         *  DataCatalog
	         *  @param {bool}   opts.writeDC     записать значения из списка в транс-табличные данные (с привязкой по opts.object)
	         *  @param {str}    opts.getDC       добавить в список значения из транс-табличных данных (указать opts.object таблицы-родителя, откуда данные)
	         *
	         *  @param {bool}   opts.offtotal    true - отключить отображение "Всего" в итогах таблицы
	         *  @param {bool}   opts.disablePagination
	         *                                   true - удаляет лимит из свойств в запросе,
	         *                                   блок. панели перекл. страниц и выставления лимита
	         *                                   (в общем отключение пролистывания)
	         */
	
	        if (opts.response) {
	            self.reloadProcessingResult(opts, params, opts.response); // если данные уже есть - запрос не нужен
	            self.update({
	                selectedCount: 0,
	                loader: false,
	                isFind: false
	            });
	        } else {
	            API.request({
	                object: opts.object,
	                method: opts.method || 'Fetch',
	                cookie: opts.cookie || undefined,
	                data: params,
	                notFoundRedirect: false,
	                success: function success(response, xhr) {
	                    self.reloadProcessingResult(opts, params, response, xhr);
	                },
	                error: function error(response, xhr) {
	                    self.pages.count = 0;
	                    self.pages.current = 0;
	                    self.items = [];
	                    self.tags.paginator.update({ pages: self.pages.count, page: self.pages.current });
	                },
	                complete: function complete(response, xhr) {
	
	                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload",
	                        groupLog: "reload", dComment: "complete", dArray: response }));
	
	                    self.update({
	                        selectedCount: 0,
	                        loader: false,
	                        isFind: false
	                    });
	                }
	            });
	        }
	    }; // перезагрузить
	
	    self.reloadProcessingResult = function (opts, params, response, xhr) {
	
	        /** обработчик результатов запроса/входныхДанных
	         *
	         *  @@@@@@ @@@@@@ @@     @@@@@@    @@    @@@@@@     @@@@@@ @@@@@@  |
	         *  @@  @@ @@     @@     @@  @@   @@@@   @@   @@    @@  @@ @@  @@  |
	         *  @@@@@@ @@@@@@ @@     @@  @@  @@  @@  @@   @@    @@@@@@ @@@@@@  |
	         *  @@ @@  @@     @@     @@  @@ @@@@@@@@ @@   @@    @@     @@ @@   |
	         *  @@  @@ @@@@@@ @@@@@@ @@@@@@ @@    @@ @@@@@@     @@     @@  @@  |
	         *
	         * @param {obj} params    параметры запроса
	         * @param {obj} response  ответ на запрос
	         * @param {obj} xhr
	         * @return {array} tempdatacatalog запись значений таблицы в транс-табличные данные
	         *
	         * 1 при наличии параметра в опциях - заменяем
	         * 2 добавить из транс-табличных данных данные по ключу ...
	         * 3 запись всех значений в транс-табличные данные
	         *
	         * fixme в последствии при необходимости прописать передачу xhr
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadProcessingResult" }));
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadProcessingResult",
	            groupLog: "reload", dComment: "response", dArray: response }));
	
	        if (opts.items) response.items = response[opts.items]; // 1
	        if (opts.count) response.count = response[opts.count];
	
	        if (opts.getdc && // 2
	        self.datacatalog && self.pages.current == 1) {
	            self.readTranceData(response, params);
	        } else if (opts.getdc || opts.getdc) {
	            self.readTranceDataFirst(response, params);
	        }
	
	        self.lastParams = params;
	        if (opts.exception) {
	            self.tags.datatable.exceptionFilter(response.items, opts.exception);
	        }
	        if ('beforeSuccess' in opts && typeof opts.beforeSuccess === 'function') opts.beforeSuccess.call(_this2, response, xhr);
	
	        self.pageCurr = response.pageCurr;
	        self.totalCount = response.count;
	        self.allIds = response.items.map(function (item) {
	            return item.id;
	        });
	        self.pages.count = Math.ceil(response.count / self.pages.limit);
	        if (self.pages.current > self.pages.count) {
	            self.pages.current = self.pages.count;
	        }
	        self.items = response.items ? response.items : [];
	
	        if (opts.writedc) {
	            self.writeTranceData();
	        } // 3
	
	        self.searchFields = response.searchFields ? response.searchFields : [];
	        self.showSearchFields = self.searchFields.length > 0;
	        self.tags.paginator.update({ pages: self.pages.count, page: self.pages.current });
	        self.isFirstRefresh = false;
	        self.update();
	    }; // обработчик результатов запроса/входныхДанных
	
	    self.readTranceData = function (response, params) {
	
	        /** читать из транс-табличных данных по ключу
	         *  (новосозданные строки определяются по отсутствию ключа!)
	         *  @param {object} response данные по странице
	         *  @param {object} params ид, сортировка...
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "readTranceData" }));
	
	        self.datacatalog[opts.getdc].forEach(function (item) {
	            response.items.push(item);
	        }); // добавляем к значениям из БД
	        response.items = self.datacatalog[opts.getdc];
	
	        var uniq = {};
	        var withoutId = []; // только созданные значения
	        response.items.forEach(function (item) {
	            if (item.id) uniq[item.id] = item;else withoutId.push(item);
	        }); // фильтруем уникальные значения по id
	        response.items = []; // очистка исходного массива
	        for (var item in uniq) {
	            response.items.push(uniq[item]);
	        } // возвращаем уникальные значения
	        response.items = response.items.concat(withoutId); // возвращаем значения без id (только созданные)
	        if (opts.disablepagination) {
	            response.count = response.items.length;
	            response.groupsCount = response.count;
	        } // определяем длину списка НА СТРАНИЦЕ
	
	        self.datacatalog[opts.getdc] = response.items;
	        observable.trigger('datacatalog', self.datacatalog); // запис. в транс-табл. данные объединенны данные
	        self.sorting(response.items, params.sortBy, params.sortOrder);
	    };
	
	    self.readTranceDataFirst = function (response, params) {
	
	        /** читать из транс-табличных данных по ключу (первый запуск)
	         *  @param {object} response данные по странице
	         *  @param {object} params ид, сортировка...
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "readTranceDataFirst" }));
	
	        self.datacatalog = {};
	        self.datacatalog[opts.getdc] = [];
	        self.datacatalog[opts.getdc] = response.items;
	        observable.trigger('datacatalog', self.datacatalog); // запис. в транс-табл. данные объединенны данные
	        self.sorting(response.items, params.sortBy, params.sortOrder);
	    };
	
	    self.writeTranceData = function () {
	
	        /** запись в транс-табличные данные по ключу
	         *  @param {array} self.items массив значений на запись
	         *  @return {object} observable.trigger 'tempdatacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "writeTranceData" }));
	
	        if (self.datacatalog == undefined) {
	            self.datacatalog = {};
	        }
	        self.datacatalog[opts.object] = self.items;
	        observable.trigger('tempdatacatalog', self.datacatalog); // записываем в транс-табличные временные данные
	    };
	
	    self.sorting = function (items, sort, desc) {
	
	        /** сортировка объектов в массиве по свойству
	         *  @param {array} items значения для обработки
	         *  @param {str} sort имя столбца сортировки
	         *  @param {str} desc порядок сортировки (по возростанию / по убыванию)
	         *  @return {array} items
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "sorting" }));
	
	        var result = items.sort(function (a, b) {
	            if (a[sort] < b[sort]) return -1;else if (a[sort] > b[sort]) return 1;else return 0;
	        });
	        if (desc == "desc") result.reverse();
	    };
	
	    self.remove = function (e) {
	
	        /** удалить */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "remove" }));
	
	        var _this = _this2,
	            itemsToRemove = [];
	
	        if (self.allMode !== true) {
	            _this.items.forEach(function (item, i, arr) {
	                if (item.__selected__ == true && item.id) {
	                    delete _this.items[i];
	                    itemsToRemove.push(item.id);
	                } else if (item.__selected__ == true) {
	                    delete _this.items[i];
	                }
	            });
	        } else {
	            itemsToRemove = {};
	            itemsToRemove.allMode = true;
	            itemsToRemove.allModeLastParams = self.lastParams;
	        }
	
	        // упорядочивание номеров в массиве
	        var tempItems = [];
	        _this.items.forEach(function (item) {
	            tempItems.push(item);
	        });
	        _this.items = tempItems;
	        tempItems = null;
	
	        if (opts.remove) opts.remove.bind(_this2, e, itemsToRemove, self)();
	        self.reload();
	    };
	
	    self.find = (0, _debounce2.default)(function (e) {
	        if (e.key !== 'Control' && (e.key !== 'f' || self.lastEvent !== 1)) {
	            self.pages.current = 1;
	            self.reload();
	            self.lastEvent = 0;
	        }
	    }, 400);
	
	    self.storeSettings = function () {
	
	        /** Настройки магазина */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "storeSettings" }));
	
	        var params = {
	            searchFields: self.searchFields
	        };
	        /*
	        self.debuger({ ...self.debugParam, method:"storeSettings",
	            groupLog: "storeSettings", dComment:"params", dArray: response })
	        */
	        API.request({
	            object: opts.object,
	            method: 'Store',
	            data: params,
	            success: function success(response, xhr) {}
	        });
	    };
	
	    self.limitChange = function (e) {
	
	        /** изменить ограничение */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "limitChange" }));
	
	        if (opts.store && opts.store.trim() !== '') {
	            var store = JSON.parse(localStorage.getItem('shop24_' + opts.store) || '{}');
	            store.offset = 0;
	            store.limit = e.target.value;
	            localStorage['shop24_' + opts.store] = (0, _stringify2.default)(store);
	        }
	        self.pages.current = 1;
	        self.pages.offset = 0;
	        self.pages.limit = e.target.value;
	        self.reload();
	    };
	
	    var serializeFilters = function serializeFilters() {
	
	        /** Сериализовать фильтры
	         * Сериализация — это процесс преобразования объекта в поток байтов для сохранения или передачи в память,
	         * в базу данных или в файл. Эта операция предназначена для того,
	         * чтобы сохранить состояния объекта для последующего воссоздания при необходимости
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "serializeFilters" }));
	
	        if (!self.filters) return;
	
	        var result = [];
	        var items = self.filters.querySelectorAll('[data-name]');
	        var fielditems = {};
	        console.log(items);
	        for (var i = 0; i < items.length; i++) {
	            var item = {};
	            var required = items[i].getAttribute('data-required');
	            var type = items[i].type ? items[i].type.toLowerCase() : '';
	
	            var bool = items[i].getAttribute('data-bool');
	
	            if (bool && bool.split(',').length === 2) bool = bool.split(',');else bool = false;
	
	            if (type === 'checkbox') {
	                var value = items[i].checked;
	
	                if (bool) {
	                    var _i = value ? 0 : 1;
	                    item.value = bool[_i];
	                } else {
	                    item.value = items[i].checked;
	                }
	            }
	
	            if (type != 'checkbox') {
	                item.value = items[i].value;
	            }
	
	            if (item) {
	                item.field = items[i].getAttribute('data-name');
	                if (items[i].getAttribute('data-sign')) item.sign = items[i].getAttribute('data-sign').toUpperCase();else item.sign = '=';
	                if (items[i].getAttribute('data-type')) item.type = items[i].getAttribute('data-type');
	            }
	            if (type === 'checkbox' && item.sign == 'IN') {
	                //item.value = items[i].value
	                if (!fielditems[item.field]) {
	                    fielditems[item.field] = [];
	                }
	                if (items[i].checked) {
	                    fielditems[item.field].push(items[i].value);
	                }
	            } else if (type === 'checkbox' && bool instanceof Array) {
	                if (required || item.value != bool[1]) {
	                    console.log(item.value);
	                    result.push(item);
	                }
	            } else {
	                if (required || item.value) result.push(item);
	            }
	        }
	        if ((0, _keys2.default)(fielditems).length) {
	            (0, _keys2.default)(fielditems).forEach(function (key) {
	                result.push({ field: key, value: fielditems[key], sign: 'IN' });
	            });
	        }
	
	        if (result.length) return result;else return [];
	    };
	
	    var parseFilters = function parseFilters(filters) {
	
	        /** анализировать фильтры */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "parseFilters" }));
	
	        if (!filters && !(filters instanceof Array)) return;
	
	        var result = filters.map(function (item) {
	            var field = item.field,
	                sign = item.sign,
	                value = item.value,
	                type = item.type;
	
	            if (type == 'bool') value = value === '1';else if (typeof value !== 'boolean') value = '\'' + value + '\'';
	
	            return '[' + field + ']' + sign + value;
	        });
	
	        return result.join(' AND ');
	    };
	
	    self.on('mount', function () {
	        if (opts.store && opts.store.trim() !== '') {
	            var columns;
	            var column;
	
	            (function () {
	                var store = JSON.parse(localStorage.getItem('shop24_' + opts.store));
	                if (store) {
	                    if (store.limit) self.pages.limit = store.limit;
	
	                    if (opts.cols && store.cols && (0, _typeof3.default)(store.cols) === 'object') {
	                        columns = (0, _keys2.default)(store.cols);
	
	                        opts.cols.forEach(function (item) {
	                            if (columns.indexOf(item.name) !== -1) item.hidden = true;
	                        });
	                    }
	
	                    if (store.sort && (0, _typeof3.default)(store.sort) === 'object') {
	                        column = (0, _keys2.default)(store.sort);
	
	                        if (column.length > 0) opts.cols.forEach(function (item) {
	                            if (item.name === column[0]) item.dir = store.sort[column[0]];
	                        });
	                    }
	                }
	            })();
	        }
	        self.reload();
	    });
	
	    self.on('update', function () {
	        if (opts.handlers) self.handlers = opts.handlers;
	    });
	
	    observable.on('datacatalog', function (e) {
	
	        /** получение транс-табличных данных
	         *  @param {object} e таблицы-строки
	         *  @return {object} self.datacatalog
	         */
	
	        self.datacatalog = e;
	    });
	
	    self.one('updated', function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "updated" }));
	
	        self.tags.datatable.on('row-selected', function (count) {
	            self.selectedCount = count;
	            if (self.selectedCount === self.totalCount) {
	                self.allMode = true;
	            }
	            self.update();
	        });
	        self.tags.datatable.on('sort', function () {
	            var store = JSON.parse(localStorage.getItem('shop24_' + opts.store) || '{}');
	
	            store.sort = {};
	
	            var sort = self.tags.datatable.getSortedColumn();
	
	            store.sort[sort.name] = sort.dir;
	            localStorage['shop24_' + opts.store] = (0, _stringify2.default)(store);
	            self.reload();
	        });
	        self.tags.datatable.on('column-toggle', function (name, hidden) {
	            var store = JSON.parse(localStorage.getItem('shop24_' + opts.store) || '{}');
	            if (!('cols' in store)) store.cols = {};
	
	            if (!hidden) {
	                store.cols[name] = hidden;
	            } else {
	                delete store.cols[name];
	            }
	
	            localStorage['shop24_' + opts.store] = (0, _stringify2.default)(store);
	        });
	    });
	
	    self.lastEvent = 0;
	
	    self.allParams = function (params) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "allParams" }));
	
	        console.log('allMode', self.allMode);
	        console.log(self.allIds, '<', self.selectedCount);
	
	        var mode = self.allIds < self.selectedCount || self.allMode;
	        if ((params.ids || params.id) && mode) {
	            var newParams = {};
	            delete params.ids;
	            delete params.id;
	            newParams.allModeLastParams = self.lastParams;
	            newParams.allModeParams = params;
	            newParams.allMode = true;
	        }
	        if (newParams !== undefined) {
	            return newParams;
	        }
	        return params;
	    };
	
	    // Горячие клавиши
	    document.onkeydown = function (e) {
	        if (e.ctrlKey) {
	            if (e.key == 'a') {
	                self.selectedAll();
	                return false;
	            }
	            if (e.key == 'f') {
	                self.lastEvent = 1;
	                $('.searchCatalog').focus();
	                return false;
	            }
	            if (e.key == 'r') {
	                self.reload();
	                return false;
	            }
	        }
	    };
	
	    self.toggleSearchField = function (e) {
	        console.log("ok");
	        console.log(e);
	    };
	
	    self.debugParam = {
	        module: "catalog.tag",
	        dClass: "catalog",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true,
	            reload: false,
	            storeSettings: false
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4), __webpack_require__(16)))

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, $, API, observable) {'use strict';
	
	var _stringify = __webpack_require__(29);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _md5Min = __webpack_require__(62);
	
	var _md5Min2 = _interopRequireDefault(_md5Min);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var app = {
	  auth: false,
	  accounts: [],
	  permissions: {},
	  config: {},
	  mainCookie: ''
	};
	
	riot.observable(app);
	
	app.checkUnsupported = function () {
	  if (window.FormData === undefined) return true;
	  if (window.FileReader === undefined) return true;
	  if (typeof document.createElement("canvas").getContext !== 'function') return true;
	  return false;
	};
	
	app.login = function (params) {
	  $.ajax({
	    url: './config.json',
	    dataType: 'json',
	    success: function success(response) {
	      if (response.status === 'ok') {
	        var secookie = (0, _md5Min2.default)(String(Date.now()));
	        API.url = response.data.hostApi + '/api/';
	
	        var project = params.project || response.data.project;
	
	        API.request({
	          object: 'Auth',
	          method: 'Info',
	          data: {
	            login: String(params.serial || '').trim(),
	            hash: String(params.password || '').trim()
	          },
	          beforeSend: function beforeSend(request) {
	            request.setRequestHeader('Project', project);
	            request.setRequestHeader('Secookie', secookie);
	          },
	          success: function success(resp) {
	            if (typeof params.success === 'function') params.success.call(this, resp, secookie);
	          },
	          error: function error(resp) {
	            if (typeof params.error === 'function') params.error.call(this, resp);
	          }
	        });
	        return;
	      }
	
	      if (response.status === 'error') {
	        if (typeof params.error === 'function') params.error.call(this, response);
	      }
	    },
	    error: function error(response) {
	      if (typeof params.error === 'function') params.error.call(this, response);
	    }
	  });
	};
	
	var accountFetchRetryDelays = [250, 700, 1500];
	
	function fetchAccounts(params) {
	  params = params || {};
	
	  var attempt = params.attempt || 0;
	  var cookie = params.cookie;
	  var done = params.done || function () {};
	
	  API.request({
	    object: 'Account',
	    method: 'Fetch',
	    cookie: cookie,
	    unauthorizedReload: false,
	    success: function success(resp) {
	      app.mainCookie = cookie || localStorage.getItem('shop24_cookie');
	      if (resp && Array.isArray(resp.items)) app.accounts = resp.items;
	    },
	    complete: function complete(response, xhr) {
	      if (xhr && xhr.status === 401 && attempt < accountFetchRetryDelays.length) {
	        setTimeout(function () {
	          fetchAccounts({
	            cookie: cookie,
	            done: done,
	            attempt: attempt + 1
	          });
	        }, accountFetchRetryDelays[attempt]);
	        return;
	      }
	
	      done(response, xhr);
	    }
	  });
	}
	
	app.init = function () {
	  var res = localStorage.getItem('shop24');
	  if (!res || res === 'undefined') res = '{}';
	
	  var storage = void 0;
	  try {
	    storage = JSON.parse(res);
	  } catch (e) {
	    storage = {};
	  }
	
	  if (storage && storage.domain) {
	    app.config.project = storage.project;
	    app.config.version = storage.version;
	    app.config.lang = 'rus';
	    app.config.projectURL = storage.domain + '/';
	    app.config.isAdmin = storage.isAdmin || false;
	    app.config.idUser = storage.idUser || 0;
	    app.auth = true;
	  } else {
	    app.auth = false;
	  }
	
	  if (!app.auth) {
	    observable.trigger('auth', app.auth);
	    return;
	  }
	
	  // ✅ сброс
	  app.permissions = {};
	
	  var permissionsRaw = localStorage.getItem('shop24_permissions') || '[]';
	  var permissions = void 0;
	  try {
	    permissions = JSON.parse(permissionsRaw);
	  } catch (e) {
	    permissions = [];
	  }
	
	  if (Array.isArray(permissions)) {
	    permissions.forEach(function (item) {
	      if (item && item.code != null) app.permissions[item.code] = item.mask;
	    });
	  }
	
	  var mainUser = void 0;
	  var config = void 0;
	
	  try {
	    mainUser = JSON.parse(localStorage.getItem('shop24_main_user') || '{}');
	  } catch (e) {
	    mainUser = {};
	  }
	  try {
	    config = JSON.parse(localStorage.getItem('shop24') || '{}');
	  } catch (e) {
	    config = {};
	  }
	
	  if (config && mainUser && 'login' in config && 'login' in mainUser && config.login !== mainUser.login) {
	
	    app.login({
	      project: mainUser.project,
	      serial: mainUser.login,
	      password: mainUser.hash,
	      success: function success(response, secookie) {
	        fetchAccounts({
	          cookie: secookie,
	          done: function done() {
	            observable.trigger('auth', app.auth);
	          }
	        });
	      },
	      error: function error() {
	        observable.trigger('auth', app.auth);
	      }
	    });
	  } else {
	    fetchAccounts({
	      done: function done() {
	        observable.trigger('auth', app.auth);
	      }
	    });
	  }
	};
	
	app.restoreSession = function (user) {
	  var params = JSON.parse(user);
	  var secookie = (0, _md5Min2.default)(String(Date.now()));
	  API.url = params.uri + '/api/';
	
	  API.request({
	    object: 'Auth',
	    method: 'Info',
	    unauthorizedReload: false,
	    data: params,
	    beforeSend: function beforeSend(request) {
	      request.setRequestHeader('Secookie', secookie);
	      request.setRequestHeader('Project', params.project);
	    },
	    success: function success(response) {
	      if (response.permissions) {
	        var permStr = typeof response.permissions === 'string' ? response.permissions : (0, _stringify2.default)(response.permissions);
	
	        localStorage.setItem('shop24_permissions', permStr);
	
	        // ✅ сразу строим мапу
	        app.permissions = {};
	        var arr = void 0;
	        try {
	          arr = JSON.parse(permStr);
	        } catch (e) {
	          arr = [];
	        }
	        if (Array.isArray(arr)) {
	          arr.forEach(function (item) {
	            if (item && item.code != null) app.permissions[item.code] = item.mask;
	          });
	        }
	      }
	
	      localStorage.setItem('shop24_cookie', secookie);
	      localStorage.setItem('shop24', (0, _stringify2.default)(response.config));
	
	      app.init();
	      riot.route.start(true);
	    },
	    error: function error() {
	      localStorage.removeItem('shop24');
	      localStorage.removeItem('shop24_permissions');
	      localStorage.removeItem('shop24_cookie');
	      localStorage.removeItem('shop24_user');
	      localStorage.removeItem('shop24_main_user');
	
	      app.auth = false;
	      observable.trigger('auth', false);
	    }
	  });
	};
	
	app.getImageUrl = function (name, section) {
	  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rus';
	
	  return app.config.projectURL + 'images/' + lang + '/' + section + '/' + name;
	};
	
	app.getImagePreviewURL = function (name, section) {
	  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 64;
	  var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'rus';
	
	  return app.config.projectURL + 'lib/image.php?size=' + size + '&img=images/' + lang + '/' + section + '/' + name;
	};
	
	app.insertText = function () {
	  this.target = null;
	
	  this.focus = function (e) {
	    this.target = e.target;
	  };
	
	  this.insert = function (e) {
	    if (this.target) {
	      var value = this.target.value;
	      var start = this.target.selectionStart;
	      var end = this.target.selectionEnd;
	      var newstr = value.substr(0, start) + e.target.innerHTML + value.substr(end);
	      this.target.value = newstr;
	      this.target.selectionEnd = this.target.selectionStart = start + e.target.innerHTML.length;
	      this.target.focus();
	      var event = document.createEvent('Event');
	      event.initEvent('change', true, true);
	      this.target.dispatchEvent(event);
	    }
	  };
	
	  return this;
	};
	
	if (false) window.app = app;
	
	module.exports = app;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(16), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(98)('wks')
	  , uid        = __webpack_require__(58)
	  , Symbol     = __webpack_require__(8).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(9)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(7)
	  , IE8_DOM_DEFINE = __webpack_require__(195)
	  , toPrimitive    = __webpack_require__(36)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.1.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-04-28T16:01Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//
	
	var arr = [];
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		version = "2.1.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
		},
	
		isPlainObject: function( obj ) {
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			if ( obj.constructor &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
	
			// If the function hasn't returned already, we're confident that
			// |obj| is a plain object, created by {} or constructed with new Object
			return true;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf("use strict") === 1 ) {
					script = document.createElement("script");
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.0-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-16
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
		nodeType = context.nodeType;
	
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		if ( !seed && documentIsHTML ) {
	
			// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType !== 1 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
		parent = doc.defaultView;
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Support tests
		---------------------------------------------------------------------- */
		documentIsHTML = !isXML( doc );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\f]' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				truncate = until !== undefined;
	
			while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
				if ( elem.nodeType === 1 ) {
					if ( truncate && jQuery( elem ).is( until ) ) {
						break;
					}
					matched.push( elem );
				}
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var matched = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					matched.push( n );
				}
			}
	
			return matched;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter(function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.unique( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// Flag to know if list is currently firing
			firing,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// We once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[0], key ) : emptyGet;
	};
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( owner ) {
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	function Data() {
		// Support: Android<4,
		// Old WebKit does not have Object.preventExtensions/freeze method,
		// return new empty object instead with no [[set]] accessor
		Object.defineProperty( this.cache = {}, 0, {
			get: function() {
				return {};
			}
		});
	
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	Data.accepts = jQuery.acceptData;
	
	Data.prototype = {
		key: function( owner ) {
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return the key for a frozen object.
			if ( !Data.accepts( owner ) ) {
				return 0;
			}
	
			var descriptor = {},
				// Check if the owner object already has a cache key
				unlock = owner[ this.expando ];
	
			// If not, create one
			if ( !unlock ) {
				unlock = Data.uid++;
	
				// Secure it in a non-enumerable, non-writable property
				try {
					descriptor[ this.expando ] = { value: unlock };
					Object.defineProperties( owner, descriptor );
	
				// Support: Android<4
				// Fallback to a less secure definition
				} catch ( e ) {
					descriptor[ this.expando ] = unlock;
					jQuery.extend( owner, descriptor );
				}
			}
	
			// Ensure the cache object
			if ( !this.cache[ unlock ] ) {
				this.cache[ unlock ] = {};
			}
	
			return unlock;
		},
		set: function( owner, data, value ) {
			var prop,
				// There may be an unlock assigned to this node,
				// if there is no entry for this "owner", create one inline
				// and set the unlock as though an owner entry had always existed
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
				// Fresh assignments by object are shallow copied
				if ( jQuery.isEmptyObject( cache ) ) {
					jQuery.extend( this.cache[ unlock ], data );
				// Otherwise, copy the properties one-by-one to the cache object
				} else {
					for ( prop in data ) {
						cache[ prop ] = data[ prop ];
					}
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			// Either a valid cache is found, or will be created.
			// New caches will be created and the unlock returned,
			// allowing direct access to the newly created
			// empty data object. A valid owner object must be provided.
			var cache = this.cache[ this.key( owner ) ];
	
			return key === undefined ?
				cache : cache[ key ];
		},
		access: function( owner, key, value ) {
			var stored;
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					((key && typeof key === "string") && value === undefined) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase(key) );
			}
	
			// [*]When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			if ( key === undefined ) {
				this.cache[ unlock ] = {};
	
			} else {
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
		},
		hasData: function( owner ) {
			return !jQuery.isEmptyObject(
				this.cache[ owner[ this.expando ] ] || {}
			);
		},
		discard: function( owner ) {
			if ( owner[ this.expando ] ) {
				delete this.cache[ owner[ this.expando ] ];
			}
		}
	};
	var data_priv = new Data();
	
	var data_user = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				data_user.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend({
		hasData: function( elem ) {
			return data_user.hasData( elem ) || data_priv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return data_user.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			data_user.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to data_priv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return data_priv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			data_priv.remove( elem, name );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = data_user.get( elem );
	
					if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						data_priv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					data_user.set( this, key );
				});
			}
	
			return access( this, function( value ) {
				var data,
					camelKey = jQuery.camelCase( key );
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
					// Attempt to get data from the cache
					// with the key as-is
					data = data_user.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to get data from the cache
					// with the key camelized
					data = data_user.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each(function() {
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = data_user.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					data_user.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf("-") !== -1 && data !== undefined ) {
						data_user.set( this, key, value );
					}
				});
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each(function() {
				data_user.remove( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = data_priv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = data_priv.access( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return data_priv.get( elem, key ) || data_priv.access( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					data_priv.remove( elem, [ type + "queue", key ] );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = data_priv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	})();
	var strundefined = typeof undefined;
	
	
	
	support.focusinBubbles = "onfocusin" in window;
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.hasData( elem ) && data_priv.get( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
				data_priv.remove( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.disabled !== true || event.type !== "click" ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && e.preventDefault ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && e.stopPropagation ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// Support: Firefox, Chrome, Safari
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						data_priv.remove( doc, fix );
	
					} else {
						data_priv.access( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
	
			// Support: IE9
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
			thead: [ 1, "<table>", "</table>" ],
			col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			_default: [ 0, "", "" ]
		};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute("type");
		}
	
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			data_priv.set(
				elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( data_priv.hasData( src ) ) {
			pdataOld = data_priv.access( src );
			pdataCur = data_priv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( data_user.hasData( src ) ) {
			udataOld = data_user.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			data_user.set( dest, udataCur );
		}
	}
	
	function getAll( context, tag ) {
		var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
				context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var elem, tmp, tag, wrap, contains, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
						tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];
	
						// Descend through wrappers to the right content
						j = wrap[ 0 ];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, tmp.childNodes );
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( fragment.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			return fragment;
		},
	
		cleanData: function( elems ) {
			var data, elem, type, key,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
				if ( jQuery.acceptData( elem ) ) {
					key = elem[ data_priv.expando ];
	
					if ( key && (data = data_priv.cache[ key ]) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
						if ( data_priv.cache[ key ] ) {
							// Discard any remaining `private` data
							delete data_priv.cache[ key ];
						}
					}
				}
				// Discard any remaining `user` data
				delete data_user.cache[ elem[ data_user.expando ] ];
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each(function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					});
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[ 0 ],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[ 0 ] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								// Support: QtWebKit
								// jQuery.merge because push.apply(_, arraylike) throws
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[ i ], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
								}
							}
						}
					}
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optimization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			if ( elem.ownerDocument.defaultView.opener ) {
				return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
			}
	
			return window.getComputedStyle( elem, null );
		};
	
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
		}
	
		if ( computed ) {
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// Support: iOS < 6
			// A tribute to the "awesome hack by Dean Edwards"
			// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
			// Support: IE
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		var pixelPositionVal, boxSizingReliableVal,
			docElem = document.documentElement,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
			"position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computePixelPositionAndBoxSizingReliable() {
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
			div.innerHTML = "";
			docElem.appendChild( container );
	
			var divStyle = window.getComputedStyle( div, null );
			pixelPositionVal = divStyle.top !== "1%";
			boxSizingReliableVal = divStyle.width === "4px";
	
			docElem.removeChild( container );
		}
	
		// Support: node.js jsdom
		// Don't assume that getComputedStyle is a property of the global object
		if ( window.getComputedStyle ) {
			jQuery.extend( support, {
				pixelPosition: function() {
	
					// This test is executed only once but we still do memoizing
					// since we can use the boxSizingReliable pre-computing.
					// No need to check if the test was already performed, though.
					computePixelPositionAndBoxSizingReliable();
					return pixelPositionVal;
				},
				boxSizingReliable: function() {
					if ( boxSizingReliableVal == null ) {
						computePixelPositionAndBoxSizingReliable();
					}
					return boxSizingReliableVal;
				},
				reliableMarginRight: function() {
	
					// Support: Android 2.3
					// Check if div with explicit width and no margin-right incorrectly
					// gets computed margin-right based on width of container. (#3333)
					// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
					// This support function is only executed once so no memoizing is needed.
					var ret,
						marginDiv = div.appendChild( document.createElement( "div" ) );
	
					// Reset CSS: box-sizing; display; margin; border; padding
					marginDiv.style.cssText = div.style.cssText =
						// Support: Firefox<29, Android 2.3
						// Vendor-prefix box-sizing
						"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
						"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
					marginDiv.style.marginRight = marginDiv.style.width = "0";
					div.style.width = "1px";
					docElem.appendChild( container );
	
					ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );
	
					docElem.removeChild( container );
					div.removeChild( marginDiv );
	
					return ret;
				}
			});
		}
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
		// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = data_priv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend({
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
					style[ name ] = value;
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*.
						// Use string for doubling so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur(),
					// break the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = data_priv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// Ensure the complete handler is called before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = data_priv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
	
				data_priv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || data_priv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = data_priv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = data_priv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	});
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each(function() {
				delete this[ jQuery.propFix[ name ] || name ];
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
						elem.tabIndex :
						-1;
				}
			}
		}
	});
	
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = arguments.length === 0 || typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// Toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						data_priv.set( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// Handle most common string cases
						ret.replace(rreturn, "") :
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE6-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = window.location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType[0] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
				// URL without anti-cache param
				cacheURL,
				// Response headers
				responseHeadersString,
				responseHeaders,
				// timeout handle
				timeoutTimer,
				// Cross-domain detection vars
				parts,
				// To know if global events are to be dispatched
				fireGlobals,
				// Loop variable
				i,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	};
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new XMLHttpRequest();
		} catch( e ) {}
	};
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSuccessStatus = {
			// file protocol always yields status code 0, assume 200
			0: 200,
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE9
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]();
			}
		});
	}
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport(function( options ) {
		var callback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;
	
					xhr.open( options.type, options.url, options.async, options.username, options.password );
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								delete xhrCallbacks[ id ];
								callback = xhr.onload = xhr.onerror = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
									complete(
										// file: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
										// Support: IE9
										// Accessing binary-data responseText throws an exception
										// (#11426)
										typeof xhr.responseText === "string" ? {
											text: xhr.responseText
										} : undefined,
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					xhr.onerror = callback("error");
	
					// Create the abort callback
					callback = xhrCallbacks[ id ] = callback("abort");
	
					try {
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery("<script>").prop({
						async: true,
						charset: s.scriptCharset,
						src: s.url
					}).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf("auto") > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// Support: BlackBerry 5, iOS 3 (original iPhone)
			// If we don't have gBCR, just use 0,0 rather than error
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : window.pageXOffset,
						top ? val : window.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Support: Safari<7+, Chrome<37+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(46)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(31);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(101),
	    now = __webpack_require__(834),
	    toNumber = __webpack_require__(224);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 20 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(15)
	  , createDesc = __webpack_require__(45);
	module.exports = __webpack_require__(14) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(8)
	  , hide      = __webpack_require__(22)
	  , has       = __webpack_require__(20)
	  , SRC       = __webpack_require__(58)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(39).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(9)
	  , defined = __webpack_require__(31)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(76)
	  , defined = __webpack_require__(31);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parallelLimit;
	
	var _eachOf = __webpack_require__(333);
	
	var _eachOf2 = _interopRequireDefault(_eachOf);
	
	var _parallel = __webpack_require__(339);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Run the `tasks` collection of functions in parallel, without waiting until
	 * the previous function has completed. If any of the functions pass an error to
	 * its callback, the main `callback` is immediately called with the value of the
	 * error. Once the `tasks` have completed, the results are passed to the final
	 * `callback` as an array.
	 *
	 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
	 * parallel execution of code.  If your tasks do not use any timers or perform
	 * any I/O, they will actually be executed in series.  Any synchronous setup
	 * sections for each task will happen one after the other.  JavaScript remains
	 * single-threaded.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 * results from {@link async.parallel}.
	 *
	 * @name parallel
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing functions to run.
	 * Each function is passed a `callback(err, result)` which it must call on
	 * completion with an error `err` (which can be `null`) and an optional `result`
	 * value.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 * @example
	 * async.parallel([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // the results array will equal ['one','two'] even though
	 *     // the second function had a shorter timeout.
	 * });
	 *
	 * // an example using an object instead of an array
	 * async.parallel({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equals to: {one: 1, two: 2}
	 * });
	 */
	function parallelLimit(tasks, callback) {
	  (0, _parallel2.default)(_eachOf2.default, tasks, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(77)
	  , createDesc     = __webpack_require__(45)
	  , toIObject      = __webpack_require__(25)
	  , toPrimitive    = __webpack_require__(36)
	  , has            = __webpack_require__(20)
	  , IE8_DOM_DEFINE = __webpack_require__(195)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(20)
	  , toObject    = __webpack_require__(18)
	  , IE_PROTO    = __webpack_require__(137)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(571), __esModule: true };

/***/ },
/* 30 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(9);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('loader', '  <div class="dimmer {inverted: opts.inverted}">\n    <div class="loader {opts.size} {text: opts.text} {indeterminate: opts.indeterminate}">{opts.text}</div>\n  </div>\n', 'loader,[riot-tag="loader"],[data-is="loader"]{ background-color: rgba(255, 255, 255, 1); position: absolute; top: 0; left: 0; width: 100%; min-height: 100px; height: 100%; z-index: 40; } loader .loader,[riot-tag="loader"] .loader,[data-is="loader"] .loader{ display: none; position: absolute; top: 50%; left: 50%; margin: 0; text-align: center; z-index: 1000; -webkit-transform: translateX(-50%) translateY(-50%); -ms-transform: translateX(-50%) translateY(-50%); transform: translateX(-50%) translateY(-50%) } loader .loader:before,[riot-tag="loader"] .loader:before,[data-is="loader"] .loader:before{ position: absolute; content: \'\'; top: 0; left: 50%; border-radius: 500rem; border: .2em solid rgba(0, 0, 0, .1) } loader .loader:after,[riot-tag="loader"] .loader:after,[data-is="loader"] .loader:after{ position: absolute; content: \'\'; top: 0; left: 50%; -webkit-animation: loader .6s linear; animation: loader .6s linear; -webkit-animation-iteration-count: infinite; animation-iteration-count: infinite; border-radius: 500rem; border-color: #767676 transparent transparent; border-style: solid; border-width: .2em; box-shadow: 0 0 0 1px transparent; } @-webkit-keyframes loader { from { -webkit-transform: rotate(0); transform: rotate(0); } to { -webkit-transform: rotate(360deg); transform: rotate(360deg); } } @keyframes loader { from { -webkit-transform: rotate(0); transform: rotate(0); } to { -webkit-transform: rotate(360deg); transform: rotate(360deg); } } loader .loader:after,[riot-tag="loader"] .loader:after,[data-is="loader"] .loader:after,loader .loader:before,[riot-tag="loader"] .loader:before,[data-is="loader"] .loader:before{ width: 2.2585em; height: 2.2585em; margin: 0 0 0 -1.12925em; } loader .mini.loader:after,[riot-tag="loader"] .mini.loader:after,[data-is="loader"] .mini.loader:after,loader .mini.loader:before,[riot-tag="loader"] .mini.loader:before,[data-is="loader"] .mini.loader:before{ width: 1.2857em; height: 1.2857em; margin: 0 0 0 -.64285em; } loader .small.loader:after,[riot-tag="loader"] .small.loader:after,[data-is="loader"] .small.loader:after,loader .small.loader:before,[riot-tag="loader"] .small.loader:before,[data-is="loader"] .small.loader:before{ width: 1.7142em; height: 1.7142em; margin: 0 0 0 -.8571em; } loader .large.loader:after,[riot-tag="loader"] .large.loader:after,[data-is="loader"] .large.loader:after,loader .large.loader:before,[riot-tag="loader"] .large.loader:before,[data-is="loader"] .large.loader:before{ width: 4.5714em; height: 4.5714em; margin: 0 0 0 -2.2857em; } loader .dimmer .loader,[riot-tag="loader"] .dimmer .loader,[data-is="loader"] .dimmer .loader{ display: block } loader .dimmer .loader,[riot-tag="loader"] .dimmer .loader,[data-is="loader"] .dimmer .loader{ color: rgba(0, 0, 0, .87); } loader .dimmer .loader:before,[riot-tag="loader"] .dimmer .loader:before,[data-is="loader"] .dimmer .loader:before{ border-color: rgba(0, 0, 0, .1); } loader .dimmer .loader:after,[riot-tag="loader"] .dimmer .loader:after,[data-is="loader"] .dimmer .loader:after{ border-color: #767676 transparent transparent; } loader .inverted.dimmer .loader,[riot-tag="loader"] .inverted.dimmer .loader,[data-is="loader"] .inverted.dimmer .loader{ color: rgba(255, 255, 255, .9); } loader .inverted.dimmer .loader:before,[riot-tag="loader"] .inverted.dimmer .loader:before,[data-is="loader"] .inverted.dimmer .loader:before{ border-color: rgba(255, 255, 255, .15) } loader .inverted.dimmer .loader:after,[riot-tag="loader"] .inverted.dimmer .loader:after,[data-is="loader"] .inverted.dimmer .loader:after{ border-color: #fff transparent transparent; } loader .text.loader,[riot-tag="loader"] .text.loader,[data-is="loader"] .text.loader{ width: auto !important; height: auto !important; text-align: center; font-style: normal } loader .indeterminate.loader:after,[riot-tag="loader"] .indeterminate.loader:after,[data-is="loader"] .indeterminate.loader:after{ -webkit-animation-direction: reverse; animation-direction: reverse; -webkit-animation-duration: 1.2s; animation-duration: 1.2s } loader .loader.active,[riot-tag="loader"] .loader.active,[data-is="loader"] .loader.active,loader .loader.visible,[riot-tag="loader"] .loader.visible,[data-is="loader"] .loader.visible{ display: block } loader .loader.disabled,[riot-tag="loader"] .loader.disabled,[data-is="loader"] .loader.disabled,loader .loader.hidden,[riot-tag="loader"] .loader.hidden,[data-is="loader"] .loader.hidden{ display: none } loader .inverted.dimmer .mini.loader,[riot-tag="loader"] .inverted.dimmer .mini.loader,[data-is="loader"] .inverted.dimmer .mini.loader,loader .mini.loader,[riot-tag="loader"] .mini.loader,[data-is="loader"] .mini.loader{ width: 1.2857em; height: 1.2857em; font-size: .71428571em } loader .inverted.dimmer .small.loader,[riot-tag="loader"] .inverted.dimmer .small.loader,[data-is="loader"] .inverted.dimmer .small.loader,loader .small.loader,[riot-tag="loader"] .small.loader,[data-is="loader"] .small.loader{ width: 1.7142em; height: 1.7142em; font-size: .92857143em } loader .inverted.dimmer .loader,[riot-tag="loader"] .inverted.dimmer .loader,[data-is="loader"] .inverted.dimmer .loader,loader .loader,[riot-tag="loader"] .loader,[data-is="loader"] .loader{ width: 2.2585em; height: 2.2585em; font-size: 1em } loader .inverted.dimmer .loader.large,[riot-tag="loader"] .inverted.dimmer .loader.large,[data-is="loader"] .inverted.dimmer .loader.large,loader .loader.large,[riot-tag="loader"] .loader.large,[data-is="loader"] .loader.large{ width: 4.5714em; height: 4.5714em; font-size: 1.14285714em } loader .mini.text.loader,[riot-tag="loader"] .mini.text.loader,[data-is="loader"] .mini.text.loader{ min-width: 1.2857em; padding-top: 1.99998571em } loader .small.text.loader,[riot-tag="loader"] .small.text.loader,[data-is="loader"] .small.text.loader{ min-width: 1.7142em; padding-top: 2.42848571em } loader .text.loader,[riot-tag="loader"] .text.loader,[data-is="loader"] .text.loader{ min-width: 2.2585em; padding-top: 2.97278571em } loader .large.text.loader,[riot-tag="loader"] .large.text.loader,[data-is="loader"] .large.text.loader{ min-width: 4.5714em; padding-top: 5.28568571em } loader .inverted.loader,[riot-tag="loader"] .inverted.loader,[data-is="loader"] .inverted.loader{ color: rgba(255, 255, 255, .9) } loader .inverted.loader:before,[riot-tag="loader"] .inverted.loader:before,[data-is="loader"] .inverted.loader:before{ border-color: rgba(255, 255, 255, .15) } loader .inverted.loader:after,[riot-tag="loader"] .inverted.loader:after,[data-is="loader"] .inverted.loader:after{ border-top-color: #fff } loader .inline.loader,[riot-tag="loader"] .inline.loader,[data-is="loader"] .inline.loader{ position: relative; vertical-align: middle; margin: 0; left: 0; top: 0; -webkit-transform: none; -ms-transform: none; transform: none } loader .inline.loader.active,[riot-tag="loader"] .inline.loader.active,[data-is="loader"] .inline.loader.active,loader .inline.loader.visible,[riot-tag="loader"] .inline.loader.visible,[data-is="loader"] .inline.loader.visible{ display: inline-block } loader .centered.inline.loader.active,[riot-tag="loader"] .centered.inline.loader.active,[data-is="loader"] .centered.inline.loader.active,loader .centered.inline.loader.visible,[riot-tag="loader"] .centered.inline.loader.visible,[data-is="loader"] .centered.inline.loader.visible{ display: block; margin-left: auto; margin-right: auto } loader .dimmer,[riot-tag="loader"] .dimmer,[data-is="loader"] .dimmer{ display: block; position: absolute; top: 0 !important; left: 0 !important; width: 100%; height: 100%; text-align: center; vertical-align: middle; background-color: rgba(255, 255, 255, .85); opacity: 1; line-height: 1; -webkit-animation-fill-mode: both; animation-fill-mode: both; -webkit-animation-duration: .5s; animation-duration: .5s; -webkit-transition: background-color .5s linear; transition: background-color .5s linear; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; will-change: opacity; z-index: 1000; } loader .inverted.dimmer,[riot-tag="loader"] .inverted.dimmer,[data-is="loader"] .inverted.dimmer{ background-color: rgba(0, 0, 0, .85); }', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(40)
	  , IObject  = __webpack_require__(76)
	  , toObject = __webpack_require__(18)
	  , toLength = __webpack_require__(17)
	  , asc      = __webpack_require__(609);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3)
	  , core    = __webpack_require__(39)
	  , fails   = __webpack_require__(9);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(11);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, $) {'use strict';
	
	riot.tag2('ckeditor', '  <textarea name="{opts.name}" id="ck_{_riot_id}" value="{value}"></textarea>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.value = '';
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	        }
	    });
	
	    self.one('updated', function () {
	        var instance = CKEDITOR.replace('ck_' + self._riot_id, {
	            extraPlugins: 'divarea,youtube'
	        });
	
	        instance.on('change', function () {
	            var event = document.createEvent('Event');
	            event.initEvent('change', true, true);
	            self.root.dispatchEvent(event);
	            $('#ck_' + self._riot_id).val(self.value);
	        });
	
	        localStorage.setItem('SE_section', opts.section);
	
	        instance.on('instanceReady', function (event) {
	            /* Активируем кнопку исходного кода */
	            var element = $('.cke_button__source');
	            element.on('click', function () {
	                var elem = $('#cke_ck_' + self._riot_id + ' .cke_source');
	                elem.on('input', function () {
	                    var event = document.createEvent('Event');
	                    event.initEvent('change', true, true);
	                    self.root.dispatchEvent(event);
	                    $('#ck_' + self._riot_id).val(elem[0].value);
	                });
	            });
	
	            instance.setData(self.value);
	            instance.resetUndo();
	            Object.defineProperty(self, 'value', {
	                get: function get() {
	                    return instance.getData();
	                },
	                set: function set(value) {
	                    if (value == null || value == undefined) value = '';
	                    if (instance.getData() !== value) {
	                        instance.setData(value);
	                        instance.resetUndo();
	                    }
	                }
	            });
	        });
	
	        self.on('unmount', function () {
	            instance.destroy();
	        });
	    });
	
	    self.on('mount', function () {
	        self.value = opts.value || '';
	        self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(16)))

/***/ },
/* 38 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 39 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(21);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(211)
	  , $export = __webpack_require__(3)
	  , shared  = __webpack_require__(98)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(214)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(14)){
	  var LIBRARY             = __webpack_require__(51)
	    , global              = __webpack_require__(8)
	    , fails               = __webpack_require__(9)
	    , $export             = __webpack_require__(3)
	    , $typed              = __webpack_require__(99)
	    , $buffer             = __webpack_require__(144)
	    , ctx                 = __webpack_require__(40)
	    , anInstance          = __webpack_require__(50)
	    , propertyDesc        = __webpack_require__(45)
	    , hide                = __webpack_require__(22)
	    , redefineAll         = __webpack_require__(55)
	    , toInteger           = __webpack_require__(46)
	    , toLength            = __webpack_require__(17)
	    , toIndex             = __webpack_require__(57)
	    , toPrimitive         = __webpack_require__(36)
	    , has                 = __webpack_require__(20)
	    , same                = __webpack_require__(208)
	    , classof             = __webpack_require__(75)
	    , isObject            = __webpack_require__(11)
	    , toObject            = __webpack_require__(18)
	    , isArrayIter         = __webpack_require__(129)
	    , create              = __webpack_require__(52)
	    , getPrototypeOf      = __webpack_require__(28)
	    , gOPN                = __webpack_require__(53).f
	    , getIterFn           = __webpack_require__(146)
	    , uid                 = __webpack_require__(58)
	    , wks                 = __webpack_require__(13)
	    , createArrayMethod   = __webpack_require__(34)
	    , createArrayIncludes = __webpack_require__(89)
	    , speciesConstructor  = __webpack_require__(138)
	    , ArrayIterators      = __webpack_require__(147)
	    , Iterators           = __webpack_require__(71)
	    , $iterDetect         = __webpack_require__(95)
	    , setSpecies          = __webpack_require__(56)
	    , arrayFill           = __webpack_require__(122)
	    , arrayCopyWithin     = __webpack_require__(188)
	    , $DP                 = __webpack_require__(15)
	    , $GOPD               = __webpack_require__(27)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 43 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(58)('meta')
	  , isObject = __webpack_require__(11)
	  , has      = __webpack_require__(20)
	  , setDesc  = __webpack_require__(15).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(9)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(64)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 48 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(180)
	  , defined = __webpack_require__(109);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(7)
	  , dPs         = __webpack_require__(201)
	  , enumBugKeys = __webpack_require__(125)
	  , IE_PROTO    = __webpack_require__(137)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(124)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(127).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(203)
	  , hiddenKeys = __webpack_require__(125).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(203)
	  , enumBugKeys = __webpack_require__(125);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(23);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(8)
	  , dP          = __webpack_require__(15)
	  , DESCRIPTORS = __webpack_require__(14)
	  , SPECIES     = __webpack_require__(13)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(46)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 58 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, $) {'use strict';
	
	var _defineProperties = __webpack_require__(516);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	__webpack_require__(33);
	
	var _sortablejs = __webpack_require__(843);
	
	var _sortablejs2 = _interopRequireDefault(_sortablejs);
	
	__webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('datatable', '  <div class="thead">\n    <datatable-row>\n      <datatable-head-cell class="{col.classes}" each="{col, i in cols}" name="{col.name}" title="{col.title}" onclick="{parent.headCellClick}" riot-style="{col.width ? &quot;width: &quot; + col.width : &quot;&quot;};" no-reorder>{col.value}</datatable-head-cell>\n    </datatable-row>\n  </div>\n  <div class="tbody" if="{!opts.loader}" ontouchmove="{tableScroll}">\n    <datatable-row class="{&quot;bg-info&quot;: row.__selected__}" each="{row, i in rows}" onclick="{rowClick}" ontouchstart="{rowTouchStart}" ontouchend="{rowTouchEnd}" oncontextmenu="{rowContext}">\n      <yield></yield>\n    </datatable-row>\n  </div>\n  <loader if="{opts.loader}"></loader>\n', 'datatable,[riot-tag="datatable"],[data-is="datatable"]{ display: table; border-spacing: 2px; box-sizing: border-box; text-indent: 0; border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 100%; margin-bottom: 20px; } datatable .thead,[riot-tag="datatable"] .thead,[data-is="datatable"] .thead{ display: table-header-group; vertical-align: middle; } datatable .tbody,[riot-tag="datatable"] .tbody,[data-is="datatable"] .tbody{ display: table-row-group; vertical-align: middle; position: relative; } .table-responsive > datatable,.table-responsive > [riot-tag="datatable"],.table-responsive > [data-is="datatable"]{ margin-bottom: 0; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.rows;
	        },
	        set: function set(value) {
	            self.rows = value;
	        }
	    });
	
	    function changeEvent() {
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    }
	
	    // Заголовок
	    self.headCellClick = function (e) {
	        if (!opts.sortable) return;
	        if (this.col.name === '') return;
	        this.col.dir = !this.col.dir ? 'ASC' : this.col.dir === 'ASC' ? 'DESC' : 'ASC';
	
	        var name = this.col.name;
	        for (var i = 0; i < this.cols.length; i++) {
	            if (this.cols[i].name !== name) {
	                delete this.cols[i].dir;
	            }
	        }self.trigger('sort');
	    };
	
	    // Колонки
	    self.getSortedColumn = function () {
	        return self.cols.filter(function (item) {
	            return item.dir && item.dir !== '';
	        })[0];
	    };
	
	    self.getVisibleColumns = function () {
	        return self.cols.filter(function (item) {
	            return !item.hidden;
	        });
	    };
	
	    self.getHiddenColumns = function () {
	        return self.cols.filter(function (item) {
	            return item.hidden;
	        });
	    };
	
	    self.toggleColumn = function (name) {
	        for (var i = 0; i < self.cols.length; i++) {
	            if (self.cols[i].name == name) {
	                var hidden = self.cols[i].hidden ? true : false;
	                break;
	            }
	        }hidden ? self.showColumn(name) : self.hideColumn(name);
	        self.trigger('column-toggle', name, hidden);
	    };
	
	    self.hideColumn = function (name) {
	        var nodeList = self.root.querySelectorAll('[name="' + name + '"]');
	
	        for (var i = 0; i < nodeList.length; i++) {
	            nodeList[i].style.display = 'none';
	        }for (var k = 0; k < self.cols.length; k++) {
	            if (self.cols[k].name == name) {
	                self.cols[k].hidden = true;
	                break;
	            }
	        }
	    };
	
	    self.showColumn = function (name) {
	        var nodeList = self.root.querySelectorAll('[name="' + name + '"]');
	
	        for (var i = 0; i < nodeList.length; i++) {
	            nodeList[i].style.display = '';
	        }for (var k = 0; k < self.cols.length; k++) {
	            if (self.cols[k].name == name) {
	                delete self.cols[k].hidden;
	                break;
	            }
	        }
	    };
	
	    // Строки
	    var doubleClick = opts.dblclick || function (e) {};
	
	    /** Исключить из списка
	     * @param array nodes  нумерованный массив с информацией об элементах
	     * @param str exception id редактируемой группы для исключения из списка
	     */
	    self.exceptionFilter = function (nodes, exception) {
	        exceptionFilter(nodes, exception);
	    };
	    /** Исключения из списка
	     * @param array nodes  нумерованный массив с информацией об элементах
	     * @param str exception id редактируемой группы для исключения из списка
	     * @return bool true - исключение найденно
	     */
	    function exceptionFilter(nodes, exception) {
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item, index, object) {
	                if (item["id"] == exception) {
	                    object.splice(index, 1);
	                    return true;
	                }
	            });
	        }
	    }
	
	    function setRowSelected(row) {
	        Object.defineProperty(row, '__selected__', {
	            configurable: true,
	            enumerable: false,
	            value: true
	        });
	        observable.trigger('catalog-recount');
	    }
	
	    function setRowUnselected(row) {
	        delete row.__selected__;
	    }
	
	    function selectOneRow(e) {
	        self.rows.forEach(function (item) {
	            setRowUnselected(item);
	        });
	        setRowSelected(e.item.row);
	    }
	
	    function selectRows(e) {
	        if (e.item.row.__selected__) setRowUnselected(e.item.row);else setRowSelected(e.item.row);
	        observable.trigger('catalog-recount');
	    }
	
	    function getSelectY() {
	        var el = self.root.querySelector('.bg-info');
	        var _y = 0;
	        var scrollY = 0;
	        var height = document.documentElement.clientHeight;
	        while (el && !isNaN(el.offsetTop)) {
	            _y += el.offsetTop - el.scrollTop;
	            el = el.offsetParent;
	        }
	        if (_y > height / 2 + window.scrollY) {
	            scrollY = _y - height / 2;
	            window.scrollTo(0, scrollY);
	        }
	        if (_y < height / 2 + window.scrollY) {
	            scrollY = _y - height / 2;
	            if (scrollY < 0) scrollY = 0;
	            window.scrollTo(0, scrollY);
	        }
	
	        console.log(_y, window.scrollY, height, scrollY);
	
	        return window.scrollY;
	    }
	
	    self.selectRangeRows = function (start, end) {
	        for (var i = 0; i < self.rows.length; i++) {
	            if (i >= start && i <= end) setRowSelected(self.rows[i]);else setRowUnselected(self.rows[i]);
	        }
	        self.update();
	    };
	
	    var lastSelectedRowIndex = 0;
	
	    self.rowContext = function (e) {
	        if (typeof self.handlers.contextMenu === "function") {
	            if (self.getSelectedRows() > 0) {
	                selectOneRow(e);
	            }
	            return self.handlers.contextMenu(e, e.item.row);
	        }
	        return true;
	    };
	
	    self.rowClick = function (e) {
	
	        var currentSelectedRowIndex = self.rows.indexOf(e.item.row);
	
	        var currentClick = Date.now();
	        var clickLength = currentClick - this.__lastClick__;
	
	        if (clickLength < 300 && clickLength > 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
	            currentClick = 0;
	            doubleClick(e);
	        }
	
	        if (!e.shiftKey) {
	            if (!e.ctrlKey && !e.metaKey && !e.target.classList.contains("select-row")) selectOneRow(e);else selectRows(e);
	        } else {
	            if (currentSelectedRowIndex >= lastSelectedRowIndex) self.selectRangeRows(lastSelectedRowIndex, currentSelectedRowIndex);else self.selectRangeRows(currentSelectedRowIndex, lastSelectedRowIndex);
	        }
	
	        self.trigger('row-selected', self.getSelectedRowsCount(), e.item.row);
	
	        if (!e.shiftKey) lastSelectedRowIndex = currentSelectedRowIndex;
	        this.__lastClick__ = currentClick;
	        if (e.target.className == 'open-page-item') return true;
	    };
	
	    var tbodyScroll = false;
	    self.tableScroll = function (e) {
	        tbodyScroll = true;
	        return true;
	    };
	
	    self.rowTouchStart = function (e) {
	        var _this = this;
	        _this.__tapLong__ = false;
	        tbodyScroll = false;
	        _this.__lastTapStart__ = Date.now();
	
	        _this.__tapStartTimer__ = setTimeout(function () {
	            if (!tbodyScroll) {
	                selectRows(e);
	                self.trigger('row-selected', self.getSelectedRowsCount(), e.item.row);
	                _this.__tapLong__ = true;
	                self.update();
	            }
	        }, 400);
	
	        return true;
	    };
	
	    self.rowTouchEnd = function (e) {
	        var currentTap = Date.now();
	        var tapLength = currentTap - this.__lastTapEnd__;
	
	        if (this.__tapStartTimer__) clearTimeout(this.__tapStartTimer__);
	
	        if (!tbodyScroll && !this.__tapLong__) {
	            selectOneRow(e);
	            self.trigger('row-selected', self.getSelectedRowsCount(), e.item.row);
	        }
	
	        if (tapLength < 500 && tapLength > 0) {
	            currentTap = 0;
	            doubleClick(e);
	        }
	
	        this.__lastTapEnd__ = currentTap;
	        return true;
	    };
	
	    self.getSelectedRows = function () {
	        if (self.rows) {
	            return self.rows.filter(function (item) {
	                return item.__selected__ == true;
	            });
	        }
	        return [];
	    };
	
	    self.selectAllRows = function (all) {
	        all = all || true;
	
	        var select = self.getSelectedRowsCount() == self.rows.length;
	
	        if (select && all) select = true;
	
	        for (var i = 0; i < self.rows.length; i++) {
	            select ? setRowUnselected(self.rows[i]) : setRowSelected(self.rows[i]);
	        }
	
	        self.trigger('row-selected', self.getSelectedRowsCount(), self.rows[i]);
	        self.update();
	        self.reload();
	        return !select;
	    };
	
	    self.getUnselectedRows = function () {
	        return self.rows.filter(function (item) {
	            return !item.__selected__;
	        });
	    };
	
	    self.getSelectedRowsCount = function () {
	        return self.getSelectedRows().length;
	    };
	
	    // Прочее
	    self.stopPropagation = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	    };
	
	    self.reload = function () {
	        self.cols = opts.cols || [];
	        self.rows = opts.rows || [];
	        self.handlers = opts.handlers || {};
	    };
	
	    self.reorderNext = function () {
	        if (!opts.reorder) return;
	        var srows = self.getSelectedRows();
	        //console.log(srows)
	        var newIndex = 0,
	            oldIndex = 0;
	        if (srows.length > 0) {
	            for (var i = 0; i < self.rows.length; i++) {
	                if (srows[0].id == self.rows[i].id) {
	                    oldIndex = i;
	                    break;
	                }
	            }
	            if (oldIndex + 1 > self.rows.length) return;
	            newIndex = oldIndex + 1;
	            self.rows.splice(newIndex, 0, self.rows.splice(oldIndex, 1)[0]);
	            var temp = self.rows;
	            self.rows = [];
	            changeEvent();
	            self.rows = temp;
	            changeEvent();
	            self.trigger('reorder-end', newIndex, oldIndex);
	        }
	    };
	
	    self.reorderPrev = function () {
	        if (!opts.reorder) return;
	        var srows = self.getSelectedRows();
	        var newIndex = 0,
	            oldIndex = 0;
	        if (srows.length > 0) {
	            for (var i = 0; i < self.rows.length; i++) {
	                if (srows[0].id == self.rows[i].id) {
	                    oldIndex = i;
	                    break;
	                }
	            }
	            if (oldIndex - 1 < 0) return;
	            newIndex = oldIndex - 1;
	            self.rows.splice(newIndex, 0, self.rows.splice(oldIndex, 1)[0]);
	            var temp = self.rows;
	            self.rows = [];
	            changeEvent();
	            self.rows = temp;
	            changeEvent();
	            self.trigger('reorder-end', newIndex, oldIndex);
	        }
	    };
	
	    self.reorderKey = function () {
	        // Горячие клавиши
	        document.onkeydown = function (e) {
	            if (e.ctrlKey) {
	                if (e.keyCode == 38) {
	                    //UP
	                    self.reorderPrev();
	                    console.log(getSelectY());
	                    return false;
	                }
	                if (e.keyCode == 40) {
	                    //DOWN
	                    self.reorderNext();
	                    console.log(getSelectY());
	                    return false;
	                }
	            }
	        };
	    };
	
	    self.on('updated', function () {
	        var colsHidden = self.getHiddenColumns();
	        colsHidden.forEach(function (item) {
	            self.hideColumn(item.name);
	        });
	    });
	
	    self.on('update', function () {
	        self.reload();
	        self.reorderKey();
	    });
	
	    var sortableOption = {
	        delay: 200,
	        animation: 100,
	        scroll: true,
	        sort: true,
	        chosenClass: "sortable-chosen",
	        onEnd: function onEnd(evt) {
	            self.rows.splice(evt.newIndex, 0, self.rows.splice(evt.oldIndex, 1)[0]);
	            var temp = self.rows;
	            self.rows = [];
	            changeEvent();
	            self.rows = temp;
	            changeEvent();
	            self.trigger('reorder-end', evt.newIndex, evt.oldIndex);
	        }
	    };
	
	    self.on('mount', function () {
	        self.root.name = opts.name;
	
	        if (opts.reorder) {
	            var el = self.root.querySelector('.tbody');
	            _sortablejs2.default.create(el, sortableOption);
	        }
	
	        $(self.root).colResizable({
	            resizeMode: 'flex',
	            liveDrag: true
	        });
	
	        self.reload();
	    });
	});
	riot.tag2('datatable-head-cell', '  <yield></yield><i class="{&quot;fa fa-chevron-up&quot;: col.dir == &quot;DESC&quot;, &quot;fa fa-chevron-down&quot;: col.dir == &quot;ASC&quot;}"></i>\n  <grip></grip>\n', 'datatable-head-cell,[riot-tag="datatable-head-cell"],[data-is="datatable-head-cell"]{ display: table-cell; vertical-align: inherit; font-weight: bold; padding: 1px; position: relative; user-select: none; -khtml-user-select: none; -o-user-select: none; -ms-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; cursor: pointer; background-color: #eceeef; } .thead datatable-head-cell,.thead [riot-tag="datatable-head-cell"],.thead [data-is="datatable-head-cell"]{ padding: 5px; border-bottom: 2px solid #ddd; } .table-responsive > datatable > .thead > datatable-row > datatable-head-cell,.table-responsive > datatable > .thead > datatable-row > [riot-tag="datatable-head-cell"],.table-responsive > datatable > .thead > datatable-row > [data-is="datatable-head-cell"]{ white-space: nowrap; }', '', function (opts) {
	    var self = this;
	
	    self.col = self.parent.col;
	
	    self.on('update', function () {
	        self.handlers = self.parent.handlers;
	    });
	});
	riot.tag2('datatable-row', '  <yield></yield>\n', 'datatable-row,[riot-tag="datatable-row"],[data-is="datatable-row"]{ display: table-row; vertical-align: inherit; user-select: none; -khtml-user-select: none; -o-user-select: none; -ms-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; cursor: default; }', '', function (opts) {
	    var self = this;
	
	    (0, _defineProperties2.default)(self, {
	        '__lastClick__': {
	            writable: true,
	            configurable: true,
	            enumerable: false,
	            value: 0
	        },
	        '__lastTapStart__': {
	            writable: true,
	            configurable: true,
	            enumerable: false,
	            value: 0
	        },
	        '__lastTapEnd__': {
	            writable: true,
	            configurable: true,
	            enumerable: false,
	            value: 0
	        },
	        '__tapStartTimer__': {
	            writable: true,
	            configurable: true,
	            enumerable: false,
	            value: false
	        },
	        '__tapLong__': {
	            writable: true,
	            configurable: true,
	            enumerable: false,
	            value: false
	        }
	    });
	
	    self.on('update', function () {
	        self.cols = self.parent.cols;
	        self.handlers = self.parent.handlers;
	        self.headCellClick = self.parent.headCellClick;
	    });
	});
	riot.tag2('datatable-cell', '  <yield></yield>\n', 'datatable-cell,[riot-tag="datatable-cell"],[data-is="datatable-cell"]{ display: table-cell; vertical-align: inherit; text-align: inherit; } .tbody datatable-cell,.tbody [riot-tag="datatable-cell"],.tbody [data-is="datatable-cell"]{ padding: 5px; border-top: 1px solid #ddd; } .table-responsive > datatable > .tbody > datatable-row > datatable-cell,.table-responsive > datatable > .tbody > datatable-row > [riot-tag="datatable-cell"],.table-responsive > datatable > .tbody > datatable-row > [data-is="datatable-cell"]{ white-space: nowrap; } datatable-cell input,[riot-tag="datatable-cell"] input,[data-is="datatable-cell"] input{ width: 100%; } datatable-cell[contenteditable]:focus,[riot-tag="datatable-cell"][contenteditable]:focus,[data-is="datatable-cell"][contenteditable]:focus{ background-color: #fff; outline: 1px solid #ccc; }', '', function (opts) {
	    var self = this;
	
	    self.on('update', function () {
	        if (self._parent && self._parent.row) self.row = self._parent.row;else if (self.parent && self.parent.row) self.row = self.parent.row;
	
	        if (self._parent && self._parent.handlers) self.handlers = self._parent.handlers;else if (self.parent && self.parent.handlers) self.handlers = self.parent.handlers;
	    });
	
	    if (self._parent && self._parent.row) self.stopPropagation = self._parent.stopPropagation;
	});
	riot.tag2('datatable-search-select', '  <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><span class="caret"></span></button>\n  <ul class="dropdown-menu {&quot;dropdown-menu-right&quot;: opts.align == &quot;right&quot;}">\n    <virtual each="{col in opts.fields}">\n      <li onclick="{toggleField}"><a><i class="fa fa-check" riot-style="{col.active ? &quot;visibility: visible;&quot; : &quot;visibility: hidden;&quot;};"></i> {col.title}</a></li>\n    </virtual>\n  </ul>\n', 'datatable-search-select,[riot-tag="datatable-search-select"],[data-is="datatable-search-select"]{ position: relative; } datatable-search-select .dropdown-menu > li,[riot-tag="datatable-search-select"] .dropdown-menu > li,[data-is="datatable-search-select"] .dropdown-menu > li{ user-select: none; -khtml-user-select: none; -o-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; cursor: pointer; }', '', function (opts) {
	    var self = this;
	
	    self.toggleField = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        var item = e.item.col;
	        item.active = !item.active;
	        self.update();
	        opts.store();
	    };
	});
	riot.tag2('datatable-columns-select', '  <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><i class="fa fa-list">&nbsp;</i><span class="caret"></span></button>\n  <ul class="dropdown-menu {&quot;dropdown-menu-right&quot;: opts.align == &quot;right&quot;}">\n    <virtual each="{col in opts.table.cols}">\n      <li class="{(!col.hidden &amp;&amp; parent.opts.table.getVisibleColumns().length === 1) ? &quot;disabled&quot; : &quot;&quot;}" onclick="{(!col.hidden &amp;&amp; parent.opts.table.getVisibleColumns().length === 1) ? stopPropagation : toggleColumn}"><a><i class="fa fa-check" riot-style="{!col.hidden ? &quot;visibility: visible;&quot; : &quot;visibility: hidden;&quot;};"></i> {col.value}</a></li>\n    </virtual>\n  </ul>\n', 'datatable-columns-select,[riot-tag="datatable-columns-select"],[data-is="datatable-columns-select"]{ position: relative; } datatable-columns-select .dropdown-menu > li,[riot-tag="datatable-columns-select"] .dropdown-menu > li,[data-is="datatable-columns-select"] .dropdown-menu > li{ user-select: none; -khtml-user-select: none; -o-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; cursor: pointer; }', '', function (opts) {
	    var self = this;
	
	    self.stopPropagation = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	    };
	
	    self.toggleColumn = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        opts.table.toggleColumn(e.item.col.name);
	    };
	});
	riot.tag2('grip', '', 'grip,[riot-tag="grip"],[data-is="grip"]{ width: 3px; height: 31px; top: 0; position: absolute; right: 0; cursor: w-resize; background-color: #DFE8EC; } grip:hover,[riot-tag="grip"]:hover,[data-is="grip"]:hover{ background-color: #697276; }', 'onclick="{cellClick}"', function (opts) {
	    var self = this;
	
	    self.cellClick = function (e) {
	        e.preventDefault();
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(16)))

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!function(n){"use strict";function t(n,t){var r=(65535&n)+(65535&t),e=(n>>16)+(t>>16)+(r>>16);return e<<16|65535&r}function r(n,t){return n<<t|n>>>32-t}function e(n,e,o,u,c,f){return t(r(t(t(e,n),t(u,f)),c),o)}function o(n,t,r,o,u,c,f){return e(t&r|~t&o,n,t,u,c,f)}function u(n,t,r,o,u,c,f){return e(t&o|r&~o,n,t,u,c,f)}function c(n,t,r,o,u,c,f){return e(t^r^o,n,t,u,c,f)}function f(n,t,r,o,u,c,f){return e(r^(t|~o),n,t,u,c,f)}function i(n,r){n[r>>5]|=128<<r%32,n[(r+64>>>9<<4)+14]=r;var e,i,a,h,d,l=1732584193,g=-271733879,v=-1732584194,m=271733878;for(e=0;e<n.length;e+=16)i=l,a=g,h=v,d=m,l=o(l,g,v,m,n[e],7,-680876936),m=o(m,l,g,v,n[e+1],12,-389564586),v=o(v,m,l,g,n[e+2],17,606105819),g=o(g,v,m,l,n[e+3],22,-1044525330),l=o(l,g,v,m,n[e+4],7,-176418897),m=o(m,l,g,v,n[e+5],12,1200080426),v=o(v,m,l,g,n[e+6],17,-1473231341),g=o(g,v,m,l,n[e+7],22,-45705983),l=o(l,g,v,m,n[e+8],7,1770035416),m=o(m,l,g,v,n[e+9],12,-1958414417),v=o(v,m,l,g,n[e+10],17,-42063),g=o(g,v,m,l,n[e+11],22,-1990404162),l=o(l,g,v,m,n[e+12],7,1804603682),m=o(m,l,g,v,n[e+13],12,-40341101),v=o(v,m,l,g,n[e+14],17,-1502002290),g=o(g,v,m,l,n[e+15],22,1236535329),l=u(l,g,v,m,n[e+1],5,-165796510),m=u(m,l,g,v,n[e+6],9,-1069501632),v=u(v,m,l,g,n[e+11],14,643717713),g=u(g,v,m,l,n[e],20,-373897302),l=u(l,g,v,m,n[e+5],5,-701558691),m=u(m,l,g,v,n[e+10],9,38016083),v=u(v,m,l,g,n[e+15],14,-660478335),g=u(g,v,m,l,n[e+4],20,-405537848),l=u(l,g,v,m,n[e+9],5,568446438),m=u(m,l,g,v,n[e+14],9,-1019803690),v=u(v,m,l,g,n[e+3],14,-187363961),g=u(g,v,m,l,n[e+8],20,1163531501),l=u(l,g,v,m,n[e+13],5,-1444681467),m=u(m,l,g,v,n[e+2],9,-51403784),v=u(v,m,l,g,n[e+7],14,1735328473),g=u(g,v,m,l,n[e+12],20,-1926607734),l=c(l,g,v,m,n[e+5],4,-378558),m=c(m,l,g,v,n[e+8],11,-2022574463),v=c(v,m,l,g,n[e+11],16,1839030562),g=c(g,v,m,l,n[e+14],23,-35309556),l=c(l,g,v,m,n[e+1],4,-1530992060),m=c(m,l,g,v,n[e+4],11,1272893353),v=c(v,m,l,g,n[e+7],16,-155497632),g=c(g,v,m,l,n[e+10],23,-1094730640),l=c(l,g,v,m,n[e+13],4,681279174),m=c(m,l,g,v,n[e],11,-358537222),v=c(v,m,l,g,n[e+3],16,-722521979),g=c(g,v,m,l,n[e+6],23,76029189),l=c(l,g,v,m,n[e+9],4,-640364487),m=c(m,l,g,v,n[e+12],11,-421815835),v=c(v,m,l,g,n[e+15],16,530742520),g=c(g,v,m,l,n[e+2],23,-995338651),l=f(l,g,v,m,n[e],6,-198630844),m=f(m,l,g,v,n[e+7],10,1126891415),v=f(v,m,l,g,n[e+14],15,-1416354905),g=f(g,v,m,l,n[e+5],21,-57434055),l=f(l,g,v,m,n[e+12],6,1700485571),m=f(m,l,g,v,n[e+3],10,-1894986606),v=f(v,m,l,g,n[e+10],15,-1051523),g=f(g,v,m,l,n[e+1],21,-2054922799),l=f(l,g,v,m,n[e+8],6,1873313359),m=f(m,l,g,v,n[e+15],10,-30611744),v=f(v,m,l,g,n[e+6],15,-1560198380),g=f(g,v,m,l,n[e+13],21,1309151649),l=f(l,g,v,m,n[e+4],6,-145523070),m=f(m,l,g,v,n[e+11],10,-1120210379),v=f(v,m,l,g,n[e+2],15,718787259),g=f(g,v,m,l,n[e+9],21,-343485551),l=t(l,i),g=t(g,a),v=t(v,h),m=t(m,d);return[l,g,v,m]}function a(n){var t,r="",e=32*n.length;for(t=0;t<e;t+=8)r+=String.fromCharCode(n[t>>5]>>>t%32&255);return r}function h(n){var t,r=[];for(r[(n.length>>2)-1]=void 0,t=0;t<r.length;t+=1)r[t]=0;var e=8*n.length;for(t=0;t<e;t+=8)r[t>>5]|=(255&n.charCodeAt(t/8))<<t%32;return r}function d(n){return a(i(h(n),8*n.length))}function l(n,t){var r,e,o=h(n),u=[],c=[];for(u[15]=c[15]=void 0,o.length>16&&(o=i(o,8*n.length)),r=0;r<16;r+=1)u[r]=909522486^o[r],c[r]=1549556828^o[r];return e=i(u.concat(h(t)),512+8*t.length),a(i(c.concat(e),640))}function g(n){var t,r,e="0123456789abcdef",o="";for(r=0;r<n.length;r+=1)t=n.charCodeAt(r),o+=e.charAt(t>>>4&15)+e.charAt(15&t);return o}function v(n){return unescape(encodeURIComponent(n))}function m(n){return d(v(n))}function p(n){return g(m(n))}function s(n,t){return l(v(n),v(t))}function C(n,t){return g(s(n,t))}function A(n,t,r){return t?r?s(t,n):C(t,n):r?m(n):p(n)} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return A}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=A:n.md5=A}(this);
	//# sourceMappingURL=md5.min.js.map

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(43)
	  , core      = __webpack_require__(38)
	  , ctx       = __webpack_require__(581)
	  , hide      = __webpack_require__(65)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(66)
	  , createDesc = __webpack_require__(87);
	module.exports = __webpack_require__(47) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(84)
	  , IE8_DOM_DEFINE = __webpack_require__(179)
	  , toPrimitive    = __webpack_require__(119)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(185)
	  , enumBugKeys = __webpack_require__(110);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(116)('wks')
	  , uid        = __webpack_require__(88)
	  , Symbol     = __webpack_require__(43).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(13)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(22)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(40)
	  , call        = __webpack_require__(197)
	  , isArrayIter = __webpack_require__(129)
	  , anObject    = __webpack_require__(7)
	  , toLength    = __webpack_require__(17)
	  , getIterFn   = __webpack_require__(146)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(15).f
	  , has = __webpack_require__(20)
	  , TAG = __webpack_require__(13)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , defined = __webpack_require__(31)
	  , fails   = __webpack_require__(9)
	  , spaces  = __webpack_require__(142)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(518);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(517);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(30)
	  , TAG = __webpack_require__(13)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(30);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 77 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148),
	    getRawTag = __webpack_require__(815),
	    objectToString = __webpack_require__(819);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _once = __webpack_require__(835);
	
	var _once2 = _interopRequireDefault(_once);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('autocomplete', '  <div class="input-group">\n    <input class="{&quot;open&quot;: isOpen &amp;&amp; !opts.disabled}" type="text" onfocus="{focus}" oninput="{filterOptions}" onchange="{stop}" value="{filterValue}">\n    <div class="results" show="{isOpen &amp;&amp; !opts.disabled}" onchange="return false;">\n      <div class="text" if="{parseInt(opts.minSymbols) ? filterValue.length &lt; parseInt(opts.minSymbols) : false}">Введите не менее {parseInt(opts.minSymbols)} символ{parseInt(opts.minSymbols) == 1 ? \'а\' : \'ов\'}</div>\n      <ul if="{parseInt(opts.minSymbols) ? filterValue.length &gt; (parseInt(opts.minSymbols) - 1) : true}">\n        <li each="{item, i in filter()}" onclick="{itemClick}" no-reorder>\n          <yield></yield>\n        </li>\n      </ul>\n    </div>\n    <div class="input-group-btn" if="{opts.add}">\n      <button class="btn btn-secondary" onclick="{opts.add}"><i class="fa fa-plus" title="Добавить"></i></button>\n    </div>\n  </div>\n', 'autocomplete,[riot-tag="autocomplete"],[data-is="autocomplete"]{ display: block; width: 100%; vertical-align: middle; height: 34px; position: relative; } autocomplete > input,[riot-tag="autocomplete"] > input,[data-is="autocomplete"] > input{ padding: 6px 12px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; background-color: #fff; } autocomplete .text,[riot-tag="autocomplete"] .text,[data-is="autocomplete"] .text{ margin: 6px 12px; font-size: 14px; background-color: #fff; } autocomplete > input.open,[riot-tag="autocomplete"] > input.open,[data-is="autocomplete"] > input.open{ border: 1px solid #66afe9; border-radius: 4px 4px 0 0; outline: 0; -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); } autocomplete .results,[riot-tag="autocomplete"] .results,[data-is="autocomplete"] .results{ outline: 0; -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); border-radius: 0 0 4px 4px; z-index: 10; position: absolute; background-color: #fff; background-image: none; border-left: 1px solid #66afe9; border-right: 1px solid #66afe9; border-bottom: 1px solid #66afe9; left: 0; right: 0; width: calc(100% - 40px); } autocomplete .results > .text,[riot-tag="autocomplete"] .results > .text,[data-is="autocomplete"] .results > .text{ display: block; position: relative; padding: 4px; } autocomplete .results > .text input,[riot-tag="autocomplete"] .results > .text input,[data-is="autocomplete"] .results > .text input{ border: 1px solid #ccc; width: 100%; padding: 4px; height: 28px; } autocomplete ul,[riot-tag="autocomplete"] ul,[data-is="autocomplete"] ul{ list-style: none; margin: 0; padding: 6px 0px; font-size: 14px; overflow-x: hidden; overflow-y: auto; max-height: 200px; } autocomplete ul li,[riot-tag="autocomplete"] ul li,[data-is="autocomplete"] ul li{ padding: 4px 12px; cursor: pointer; } autocomplete ul li:hover,[riot-tag="autocomplete"] ul li:hover,[data-is="autocomplete"] ul li:hover{ color: #fff; background-color: #66afe9; } .form-inline autocomplete,.form-inline [riot-tag="autocomplete"],.form-inline [data-is="autocomplete"]{ display: inline-block; width: auto; vertical-align: middle; }', '', function (opts) {
	    'use strict';
	
	    var _this = this;
	
	    var self = this;
	    self.filterValue = '';
	
	    self.value = opts.value;
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	            self.update();
	        }
	    });
	
	    var handleClickOutside = function handleClickOutside(e) {
	        if (!self.root.contains(e.target)) self.close();
	        self.update();
	    };
	
	    self.stop = function (e) {
	        e.stopPropagation();
	    };
	
	    self.open = function () {
	        self.isOpen = true;
	        self.trigger('open');
	    };
	
	    self.close = function () {
	        self.isOpen = false;
	        self.trigger('close');
	    };
	
	    self.focus = function (e) {
	        self.open();
	    };
	
	    self.filterOptions = function (e) {
	        e.stopPropagation();
	        if (e.target.value == '') {
	            self.value = undefined;
	            var event = document.createEvent('Event');
	            event.initEvent('change', true, true);
	            self.root.dispatchEvent(event);
	        }
	        self.filterValue = e.target.value;
	    };
	
	    self.filter = function () {
	        var value = self.filterValue;
	
	        if (parseInt(opts.minSymbols)) if (value.length < parseInt(opts.minSymbols)) return [];else if (value == '') return self.data;
	
	        return self.data.filter(function (item) {
	            return item[self.valueField].toLowerCase().indexOf(value.toLowerCase()) !== -1;
	        });
	    };
	
	    self.itemClick = function (e) {
	        self.value = e.item.item[self.idField];
	        self.filterValue = e.item.item[self.valueField];
	        self.close();
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.one('mount', function () {
	        self.root.name = opts.name;
	        self.close();
	        document.addEventListener('mousedown', handleClickOutside);
	    });
	
	    self.one('update', function () {
	        if (opts.loadData) self.firstLoadData = (0, _once2.default)(opts.loadData.bind(_this));
	    });
	
	    this.on('unmount', function () {
	        document.removeEventListener('mousedown', handleClickOutside);
	    });
	
	    self.on('update', function () {
	        if (!opts.disabled) {
	            if (opts.loadData) self.loadData = opts.loadData.bind(_this);
	
	            if (opts.data && !opts.loadData) self.data = opts.data || [];
	
	            self.idField = opts.idField || 'id';
	            self.valueField = opts.valueField || 'value';
	
	            if (opts.loadData) self.firstLoadData();
	        }
	    });
	
	    self.on('open', function () {
	        if (self.loadData && !opts.disabled) self.loadData();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, $) {'use strict';
	
	__webpack_require__(795);
	
	__webpack_require__(846);
	
	riot.tag2('datetime-picker', '  <input value="{value}" onchange="{change}" onfocus="{show}">\n', ':scope { position: inherit; } input { font-family: inherit; padding: 0; margin: 0; border: none; width: inherit; height: auto; color: inherit; background-color: inherit; } span { cursor: pointer; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.value = '';
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	            if (opts.value) opts.value = value;
	            self.update();
	        }
	    });
	
	    self.on('mount', function () {
	
	        var input = self.root.children[0];
	        if (opts.value) self.value = opts.value;else if (opts.defvalue) self.value = opts.defvalue;
	
	        $(self.root).datetimepicker({
	            locale: opts.locale || 'ru',
	            useCurrent: true,
	            showTodayButton: true,
	            showClear: true,
	            format: opts.format || false,
	            widgetParent: $(self.root)
	        });
	
	        $(self.root).on('dp.change', function (e) {
	            self.one('update', function () {
	                if (opts.value) opts.value = input.value;
	                self.value = input.value;
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	            });
	            self.update();
	        });
	
	        self.show = function (e) {
	            $(self.root).data("DateTimePicker").show();
	        };
	
	        self.hide = function (e) {
	            $(self.root).data("DateTimePicker").hide();
	        };
	    });
	
	    self.on('mount', function () {
	        self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(16)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('add-fields-edit-block', '  <div class="row">\n    <div class="col-md-12">\n      <ul class="nav nav-tabs m-b-2" if="{value.length &gt; 0}">\n        <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.name}</span></a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <add-fields-edit-block-group if="{value.length &gt; 0}" value="{value[activeTab].items || []}"></add-fields-edit-block-group>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.value = [];
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value || [];
	        }
	    });
	
	    self.activeTab = 0;
	
	    self.changeTab = function (e) {
	        self.activeTab = e.item.i;
	    };
	
	    self.on('update', function () {
	        if (opts.value) self.value = opts.value;
	
	        if (opts.name) self.root.name = opts.name;
	    });
	});
	riot.tag2('add-fields-edit-block-group', '  <div class="row">\n    <form>\n      <div class="col-md-4" each="{field, i in value}" onchange="{change}">\n        <div class="form-group">\n          <label class="control-label">{field.name}</label>\n\n          <input class="form-control" if="{field.type == &quot;string&quot;}" __required="{field.required}" value="{field.value}">\n\n          <textarea class="form-control" if="{field.type == &quot;text&quot;}" __required="{field.required}" rows="5" style="min-width: 100%; max-width: 100%;" value="{field.value}"></textarea>\n\n          <input class="form-control" if="{field.type == &quot;number&quot;}" __required="{field.required}" value="{field.value}" type="{\'number\'}">\n\n          <select class="form-control" if="{field.type == &quot;select&quot;}" __required="{field.required}" value="{field.value}">\n            <option value="">-</option>\n            <option each="{option, k in field.values.split(&quot;,&quot;)}" __selected="{option == field.value}">{option}</option>\n          </select>\n\n          <div class="checkbox" if="{field.type == &quot;checkbox&quot;}" __required="{field.required}" each="{option, k in field.values.split(&quot;,&quot;)}">\n            <label>\n              <input type="checkbox" data-value="{option}" __checked="{field.value.split(&quot;,&quot;).indexOf(option) !== - 1}">{option}\n            </label>\n          </div>\n\n          <div class="radio" if="{field.type == &quot;radio&quot;}" each="{option, k in field.values.split(&quot;,&quot;)}">\n            <label>\n              <input name="{field.name}" type="radio" __checked="{field.value.split(&quot;,&quot;).indexOf(option) !== - 1}" value="{option}">{option}\n            </label>\n          </div>\n\n          <datetime-picker class="form-control" if="{field.type == &quot;date&quot;}" __required="{field.required}" format="YYYY-MM-DD" value="{field.value}"></datetime-picker>\n          <div class="help-block">{field.description}</div>\n        </div>\n      </div>\n    </form>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.change = function (e) {
	        e.stopPropagation();
	        var type = e.item.field.type;
	
	        if (type !== 'checkbox') {
	            e.item.field.value = e.target.value;
	        } else {
	            var checkedValues = (e.item.field.value || '').split(',');
	            var checkedValue = e.target.getAttribute('data-value');
	            var idx = checkedValues.indexOf(checkedValue);
	
	            if (idx !== -1) checkedValues.splice(idx, 1);else checkedValues.push(checkedValue);
	
	            e.item.field.value = checkedValues.filter(function (i) {
	                return i;
	            }).join(',');
	        }
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.parent.root.dispatchEvent(event);
	    };
	
	    self.on('update', function () {
	        if (opts.value) self.value = opts.value;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(573), __esModule: true };

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(85);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 86 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(25)
	  , toLength  = __webpack_require__(17)
	  , toIndex   = __webpack_require__(57);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(8)
	  , $export           = __webpack_require__(3)
	  , redefine          = __webpack_require__(23)
	  , redefineAll       = __webpack_require__(55)
	  , meta              = __webpack_require__(44)
	  , forOf             = __webpack_require__(70)
	  , anInstance        = __webpack_require__(50)
	  , isObject          = __webpack_require__(11)
	  , fails             = __webpack_require__(9)
	  , $iterDetect       = __webpack_require__(95)
	  , setToStringTag    = __webpack_require__(72)
	  , inheritIfRequired = __webpack_require__(128);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(22)
	  , redefine = __webpack_require__(23)
	  , fails    = __webpack_require__(9)
	  , defined  = __webpack_require__(31)
	  , wks      = __webpack_require__(13);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(7);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 93 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(11)
	  , cof      = __webpack_require__(30)
	  , MATCH    = __webpack_require__(13)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(13)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(51)|| !__webpack_require__(9)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(8)[K];
	});

/***/ },
/* 97 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8)
	  , hide   = __webpack_require__(22)
	  , uid    = __webpack_require__(58)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(830),
	    isLength = __webpack_require__(221);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(61);
	
	__webpack_require__(157);
	
	riot.tag2('catalog-static', '  <div class="row" if="{!opts.removeToolbar}">\n    <div class="col-md-12">\n      <div class="form-inline m-b-3">\n        <div class="form-group" if="{opts.add}">\n          <button class="btn btn-primary" onclick="{add}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n        </div>\n        <yield from="toolbar"></yield>\n        <div class="form-group">\n          <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n          <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n          <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <div class="{opts.responsive == &quot;false&quot; ? &quot;&quot; : &quot;table-responsive&quot;}">\n        <datatable cols="{opts.cols}" rows="{items}" handlers="{opts.handlers}" dblclick="{opts.dblclick}" reorder="{opts.reorder}">\n          <yield from="body"></yield>\n        </datatable>\n      </div>\n    </div>\n  </div>\n  <div class="row" if="{value.length &gt; pages.limit}">\n    <div class="col-md-12">\n      <bs-pagination onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.value = [];
	    self.items = [];
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value || [];
	        },
	        set: function set(value) {
	            self.value = value || [];
	            self.update();
	        }
	    });
	
	    self.pages = {
	        count: 0,
	        current: 1,
	        limit: 15,
	        change: function change(e) {
	            self.pages.current = e.currentTarget.page;
	        }
	    };
	
	    if (opts.limit) self.pages.limit = opts.limit;
	
	    self.getPageItems = function () {
	        var count = self.value.length;
	
	        self.pages.count = Math.ceil(count / self.pages.limit);
	
	        if (self.pages.current > self.pages.count) self.pages.current = self.pages.count;
	
	        self.pages.current = self.pages.current == 0 ? 1 : self.pages.current;
	
	        var offset = (self.pages.current - 1) * self.pages.limit;
	        var end = offset + self.pages.limit;
	
	        var items = self.value.filter(function (item, i) {
	            return i > offset - 1 && i < end;
	        });
	
	        return items;
	    };
	
	    self.add = function () {
	        if (typeof opts.add === 'function') {
	            opts.add.bind(self)();
	        }
	    };
	
	    self.remove = function (e) {
	        self.selectedCount = 0;
	        if (typeof opts.remove === 'function') {
	            var _this = _this2,
	                itemsToRemove = [];
	
	            _this.items.forEach(function (item, i, arr) {
	                if (item.__selected__ == true) itemsToRemove.push(item);
	            });
	            opts.remove.bind(_this2, e, itemsToRemove)();
	        } else {
	            (function () {
	                var items = self.tags.datatable.getSelectedRows();
	
	                self.value = self.value.filter(function (item) {
	                    return items.indexOf(item) === -1;
	                });
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                if (typeof opts.afterRemove === 'function') {
	                    opts.afterRemove.bind(self)();
	                }
	            })();
	        }
	    };
	    /*
	    self.remove = () => {
	        self.selectedCount = 0
	    
	        let items = self.tags.datatable.getSelectedRows()
	    
	        self.value = self.value.filter(item => {
	            return items.indexOf(item) === -1
	        })
	    
	        let event = document.createEvent('Event')
	        event.initEvent('change', true, true)
	        self.root.dispatchEvent(event)
	    
	        if (typeof(opts.afterRemove) === 'function') {
	            opts.afterRemove.bind(self)()
	        }
	    }
	    */
	
	    self.reorderNext = function () {
	        self.tags.datatable.reorderNext();
	    };
	
	    self.reorderPrev = function () {
	        self.tags.datatable.reorderPrev();
	    };
	
	    self.on('update', function () {
	        if ('rows' in opts) {
	            if (self.value !== opts.rows) self.selectedCount = 0;
	
	            self.value = opts.rows || [];
	            self.items = self.getPageItems(self.value) || [];
	        }
	    });
	
	    self.one('updated', function () {
	        self.tags.datatable.on('row-selected', function (count) {
	            self.selectedCount = count;
	            self.update();
	        });
	        self.tags.datatable.on('reorder-end', function () {
	            self.value.forEach(function (item, index) {
	                item.sort = index;
	            });
	        });
	    });
	
	    self.on('mount', function () {
	        if (opts.name) self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('images-gallery-modal', '  <bs-modal name="modal">\n    <yield to="title">\n      <div class="h4 modal-title">Библиотека изображений</div>\n    </yield>\n    <yield to="body">\n      <image-gallery name="gallery" hide-unised="true" dblclick="{parent.opts.submit.bind(this)}"></image-gallery>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        self.tags.modal.tags.gallery.update({ params: { section: opts.section, limit: 10, offset: 0 } });
	        self.tags.modal.tags.gallery.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(166);
	
	riot.tag2('persons-category-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Группы контактов</div>\n    </yield>\n    <yield to="body">\n      <catalog object="ContactCategory" cols="{parent.cols}" add="{parent.add}" remove="{parent.remove}" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="true" writedc="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.collection = "ContactCategory";
	    self.remove = function (e, items) {
	        var self = _this2,
	            params = { ids: items };
	
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: items.length > 1 ? 'Вы точно хотите удалить эти записи?' : 'Вы точно хотите удалить эту запись?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    API.request({
	                        object: self.collection,
	                        method: 'Delete',
	                        data: params,
	                        success: function success(response) {
	                            popups.create({ title: 'Успешно удалено!', style: 'popup-success' });
	                            self.tags['bs-modal'].tags.catalog.reload();
	                        }
	                    });
	                }
	                this.modalHide();
	            }
	        });
	    };
	
	    self.add = function () {
	        modals.create('person-category-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var params = { name: _this.name.value };
	                API.request({
	                    object: 'ContactCategory',
	                    method: 'Save',
	                    data: params,
	                    success: function success(response, xhr) {
	                        popups.create({ title: 'Успех!', text: 'Группа добавлена!', style: 'popup-success' });
	                        _this.modalHide();
	                        self.tags['bs-modal'].tags.catalog.reload();
	                    }
	                });
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('persons-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Контакты</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Contact" cols="{parent.cols}" search="true" reload="false" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="1" exception="{parent.opts.id}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="date">{row.regDate}</datatable-cell>\n          <datatable-cell name="email">{row.email}</datatable-cell>\n          <datatable-cell name="discount">{row.discount}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this = this;
	
	    var self = this;
	
	    self.item = {};
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'email', value: 'Email' }, { name: 'discount', value: 'Скидка' }];
	
	    self.submit = function () {
	        var items = _this.tags.datatable.getSelectedRows();
	        if (!items.length) return;
	        self.item.idAuthor = items[0].id;
	        self.item.customer = items[0].displayName;
	        self.item.idCompany = null;
	        opts.submit.bind(_this)();
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('products-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Товары</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Product" cols="{parent.cols}" search="true" reload="true" sortable="true" store="products-list-select-modal" dblclick="{parent.opts.submit.bind(this)}" systemfilters="{parent.opts.systemFilters}" disable-limit="1" disable-col-select="1">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="article">{row.article}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="price">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}<span> {(row.price / 1).toFixed(2)}</span> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</datatable-cell>\n          <datatable-cell name="stock">{row.stock}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'price', value: 'Цена' }, { name: 'stock', value: 'Остаток' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(575), __esModule: true };

/***/ },
/* 109 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 110 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 113 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(66).f
	  , has = __webpack_require__(48)
	  , TAG = __webpack_require__(68)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(116)('keys')
	  , uid    = __webpack_require__(88);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(43)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 117 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(109);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(85);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(43)
	  , core           = __webpack_require__(38)
	  , LIBRARY        = __webpack_require__(112)
	  , wksExt         = __webpack_require__(121)
	  , defineProperty = __webpack_require__(66).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(68);

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18)
	  , toIndex  = __webpack_require__(57)
	  , toLength = __webpack_require__(17);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(15)
	  , createDesc      = __webpack_require__(45);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11)
	  , document = __webpack_require__(8).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 125 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(13)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(8).document && document.documentElement;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(11)
	  , setPrototypeOf = __webpack_require__(136).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(71)
	  , ITERATOR   = __webpack_require__(13)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(30);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(52)
	  , descriptor     = __webpack_require__(45)
	  , setToStringTag = __webpack_require__(72)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(22)(IteratorPrototype, __webpack_require__(13)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(51)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(23)
	  , hide           = __webpack_require__(22)
	  , has            = __webpack_require__(20)
	  , Iterators      = __webpack_require__(71)
	  , $iterCreate    = __webpack_require__(131)
	  , setToStringTag = __webpack_require__(72)
	  , getPrototypeOf = __webpack_require__(28)
	  , ITERATOR       = __webpack_require__(13)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 133 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 134 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(8)
	  , macrotask = __webpack_require__(143).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(30)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(11)
	  , anObject = __webpack_require__(7);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(40)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(98)('keys')
	  , uid    = __webpack_require__(58);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(7)
	  , aFunction = __webpack_require__(21)
	  , SPECIES   = __webpack_require__(13)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(46)
	  , defined   = __webpack_require__(31);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(94)
	  , defined  = __webpack_require__(31);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(46)
	  , defined   = __webpack_require__(31);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(40)
	  , invoke             = __webpack_require__(93)
	  , html               = __webpack_require__(127)
	  , cel                = __webpack_require__(124)
	  , global             = __webpack_require__(8)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(30)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(8)
	  , DESCRIPTORS    = __webpack_require__(14)
	  , LIBRARY        = __webpack_require__(51)
	  , $typed         = __webpack_require__(99)
	  , hide           = __webpack_require__(22)
	  , redefineAll    = __webpack_require__(55)
	  , fails          = __webpack_require__(9)
	  , anInstance     = __webpack_require__(50)
	  , toInteger      = __webpack_require__(46)
	  , toLength       = __webpack_require__(17)
	  , gOPN           = __webpack_require__(53).f
	  , dP             = __webpack_require__(15).f
	  , arrayFill      = __webpack_require__(122)
	  , setToStringTag = __webpack_require__(72)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(8)
	  , core           = __webpack_require__(39)
	  , LIBRARY        = __webpack_require__(51)
	  , wksExt         = __webpack_require__(210)
	  , defineProperty = __webpack_require__(15).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(75)
	  , ITERATOR  = __webpack_require__(13)('iterator')
	  , Iterators = __webpack_require__(71);
	module.exports = __webpack_require__(39).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(69)
	  , step             = __webpack_require__(198)
	  , Iterators        = __webpack_require__(71)
	  , toIObject        = __webpack_require__(25);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(132)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(150);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 149 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(218);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// A temporary value used to identify if the loop should be broken.
	// See #1064, #1293
	exports.default = {};
	module.exports = exports["default"];

/***/ },
/* 155 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = once;
	function once(fn) {
	    return function () {
	        if (fn === null) return;
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 156 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = onlyOnce;
	function onlyOnce(fn) {
	    return function () {
	        if (fn === null) throw new Error("Callback was already called.");
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, $) {'use strict';
	
	riot.tag2('bs-pagination', '  <div class="form-inline pagination">\n    <div class="btn-group" onclick="{prev}">\n      <button class="btn btn-default {disabled: page &lt;= 1}" type="button"><a class="fa fa-angle-left"></a></button>\n    </div><span> стр.</span>\n    <div class="btn-group">\n      <input class="form-control" type="text" style="width: 64px; text-align: right;" value="{parseInt(page)}" onkeyup="{submit}" onchange="{stopPropagation}" onselect="{stopPropagation}">\n    </div><span> из</span><strong> {parseInt(pages)}</strong>\n    <div class="btn-group" onclick="{next}">\n      <button class="btn btn-default {disabled: page &gt;= pages}" type="button"><a class="fa fa-angle-right"></a></button>\n    </div>\n  </div>\n', 'bs-pagination,[riot-tag="bs-pagination"],[data-is="bs-pagination"]{ display: inline-block; position: relative; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.page_array = function () {
	        var arr = [];
	        var current = self.page,
	            count = self.pages;
	
	        if (count > 10) {
	            var start = current - 5,
	                stop = current + 5;
	
	            var dstart = 1 - (current - 5);
	            var dstop = count - (current + 5);
	
	            var astop = dstart > 0 ? Math.abs(dstart) : 0;
	            var astart = dstop < 0 ? Math.abs(dstop) : 0;
	
	            start = start - astart > 0 ? start - astart : start > 0 ? start : 1;
	            stop = stop + astop <= count ? stop + astop : stop <= count ? stop : count;
	
	            for (var i = start; i <= stop; i++) {
	                arr.push(i);
	            }
	        } else {
	            for (var i = 0; i < count; i++) {
	                arr.push(i + 1);
	            }
	        }
	
	        return arr;
	    };
	
	    self.first = function (e) {
	        if (self.page > 1) {
	            self.root.page = self.page = 1;
	            $(self.root).trigger('select');
	        }
	    };
	
	    self.prev = function (e) {
	        if (self.page > 1) {
	            self.root.page = --self.page;
	            $(self.root).trigger('select');
	        }
	    };
	
	    self.next = function (e) {
	        if (self.page < self.pages) {
	            self.root.page = ++self.page;
	            $(self.root).trigger('select');
	        }
	    };
	
	    self.last = function (e) {
	        if (self.page < self.pages) {
	            self.root.page = self.page = self.pages;
	            $(self.root).trigger('select');
	        }
	    };
	
	    self.select = function (e) {
	        self.root.page = self.page = e.item.item;
	        $(self.root).trigger('select');
	    };
	
	    self.submit = function (e) {
	        if (e.keyCode === 13) {
	            var page = parseInt(e.target.value);
	            if (typeof page === 'number') {
	                if (page > self.pages) page = self.pages;
	
	                if (page < 1) page = 1;
	
	                self.root.page = self.page = page;
	                $(self.root).trigger('select');
	            }
	        }
	    };
	
	    self.stopPropagation = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	    };
	
	    self.on('update', function () {
	        self.pages = parseInt(opts.pages) || 0;
	        self.root.page = self.page = parseInt(opts.page) || 1;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(16)))

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('tags', '  <div class="tags-item" each="{item, i in items}" if="{item !== null}">\n    <div class="tags-item-body"><span class="title" title="{item.name}">{item.name}</span><span class="close" onclick="{remove}">&times;</span></div>\n  </div>\n', 'tags,[riot-tag="tags"],[data-is="tags"]{ height: auto !important; padding-bottom: 0 !important; padding-left: 6px !important; min-height: 40px; } tags .tags-item,[riot-tag="tags"] .tags-item,[data-is="tags"] .tags-item{ display: inline-block; max-width: 250px; color: #333; background-color: #fff; border-radius: 4px; padding: 2px 4px; margin-right: 4px; margin-bottom: 6px; border: 1px solid #ccc; } tags .tags-item:hover,[riot-tag="tags"] .tags-item:hover,[data-is="tags"] .tags-item:hover{ border: 1px solid #aaa; } tags .tags-item-body,[riot-tag="tags"] .tags-item-body,[data-is="tags"] .tags-item-body{ display: block; position: relative; } tags .tags-item-body .title,[riot-tag="tags"] .tags-item-body .title,[data-is="tags"] .tags-item-body .title{ display: inline-block; overflow: hidden; text-overflow: ellipsis; vertical-align: top; max-width: 225px; white-space: nowrap; cursor: default; } tags .tags-item-body .close,[riot-tag="tags"] .tags-item-body .close,[data-is="tags"] .tags-item-body .close{ line-height: 0.85; }', '', function (opts) {
	    var self = this;
	
	    self.items = [];
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.items;
	        },
	        set: function set(value) {
	            self.items = value;
	        }
	    });
	
	    self.remove = function () {
	        self.items.splice(this.i, 1);
	    };
	
	    self.add = function (item) {
	        for (var i = 0; i < self.items.length; i++) {
	            if (self.items[i].id) if (self.items[i].id == item.id) return;
	        }if (self.items instanceof Array) {
	            self.items.push(item);
	        } else {
	            self.items = [];
	            self.items.push(item);
	        }
	    };
	
	    var sortableOption = {
	        onEnd: function onEnd(evt) {
	            self.items.splice(evt.newIndex, 0, self.items.splice(evt.oldIndex, 1)[0]);
	            var temp = self.items;
	            self.items = [];
	            self.update();
	            self.items = temp;
	            self.update();
	        }
	    };
	
	    self.on('mount', function () {
	        //Sortable.create(self.root, sortableOption)
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('week-days-checkbox', '  <div class="btn-group"><span class="btn btn-sm btn-default {btn-primary: parseInt(value[i])}" each="{day, i in days}" onclick="{click}">{day}</span></div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.days = ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'];
	    self.value = '0000000'.split('');
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value.join('');
	        },
	        set: function set(value) {
	            if (!value) {
	                self.value = '0000000'.split('');
	            } else {
	                self.value = value.toString().split('');
	            }
	        }
	    });
	
	    self.click = function (e) {
	        self.value[e.item.i] = self.value[e.item.i] === '0' ? '1' : '0';
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.on('mount', function () {
	        self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('comment-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#reviews/comments"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;comments&quot;, &quot;0100&quot;) : checkPermission(&quot;comments&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">Комментарий к товару:<b>{item.nameProduct}</b></div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Дата</label>\n            <datetime-picker class="form-control" name="date" format="YYYY-MM-DD" value="{item.date}"></datetime-picker>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.idPrice}">\n            <label class="control-label">Товар</label>\n            <div class="input-group">\n              <div class="input-group-btn"><a class="btn btn-default" if="{item.idPrice}" href="#products/{item.idPrice}" target="_blank"><i class="fa fa-eye"></i></a></div>\n              <input class="form-control" name="nameProduct" type="text" value="{item.nameProduct}" readonly>\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{changeProduct}"><i class="fa fa-list text-primary"></i></div>\n              </div>\n            </div>\n            <div class="help-block">{error.idPrice}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-8">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Автор комментария</label>\n            <input class="form-control" name="name" type="text" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.email}">\n            <label class="control-label">Email</label>\n            <input class="form-control" name="email" type="text" value="{item.email}">\n            <div class="help-block">{error.email}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Комментарий</label>\n            <textarea class="form-control" rows="5" name="commentary" style="min-width: 100%; max-width: 100%;" value="{item.commentary}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label"><b>Ответ администратора</b></label>\n            <textarea class="form-control" rows="5" name="response" style="min-width: 100%; max-width: 100%;" value="{item.response}"></textarea>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.item = {};
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.rules = {
	        idPrice: 'empty',
	        name: 'empty',
	        email: 'email'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	
	        self.error = self.validation.validate(self.item, self.rules);
	        if (!self.error) {
	            API.request({
	                object: 'Comment',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	                    self.item = response;
	                    if (self.isNew) riot.route('/reviews/comments/' + self.item.id);
	                    self.update();
	                    observable.trigger('comments-reload');
	                }
	            });
	        }
	    };
	
	    self.changePerson = function () {
	        modals.create('persons-list-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0) {
	                    self.item.idUser = items[0].id;
	                    self.item.nameUser = items[0].displayName;
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    self.changeProduct = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0) {
	                    self.item.idPrice = items[0].id;
	                    self.item.nameProduct = items[0].name;
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    observable.on('comment-edit', function (id) {
	        var params = { id: id };
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'Comment',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	            },
	            error: function error(response) {
	                self.item = {};
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('comment-new', function () {
	        self.isNew = true;
	        self.item = {};
	        self.update();
	    });
	
	    self.reload = function () {
	        observable.trigger('comment-edit', self.item.id);
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(10);
	
	riot.tag2('comments-list', '  <catalog search="true" sortable="true" object="Comment" cols="{cols}" reload="true" add="{permission(add, &quot;comments&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;comments&quot;, &quot;0001&quot;)}" dblclick="{permission(commentOpen, &quot;comments&quot;, &quot;1000&quot;)}" store="comments-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="date">{row.date}</datatable-cell>\n      <datatable-cell name="nameProduct">{row.nameProduct}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="email">{row.email}</datatable-cell>\n      <datatable-cell name="commentary">{row.commentary}</datatable-cell>\n      <datatable-cell name="response">{row.response}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.collection = 'Comment';
	
	    self.mixin('permissions');
	    self.mixin('remove');
	
	    self.add = function () {
	        riot.route('/reviews/comments/new');
	    };
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'nameProduct', value: 'Наименование товара' }, { name: 'name', value: 'Пользователь' }, { name: 'email', value: 'E-mail' }, { name: 'commentary', value: 'Комментарий' }, { name: 'response', value: 'Ответ' }];
	
	    self.commentOpen = function (e) {
	        riot.route('/reviews/comments/' + e.item.row.id);
	    };
	
	    observable.on('comments-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('delivery-regions', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Выберите город</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{parent.change.bind(this.parent)}">\n        <div class="form-group">\n          <label class="control-label">Страна</label>\n          <autocomplete name="idCountryTo" value-field="name" data="{parent.countries}" onchange="{parent.changeCountry.bind(this)}" min-symbols="2" value="{parent.item.idCountryTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Регион</label>\n          <autocomplete name="idRegionTo" value-field="name" data="{parent.getRegions(tags.idCountryTo.value)}" __disabled="{tags.region.data.length == 0 &amp;&amp; tags.country.value == undefined}" onchange="{parent.changeRegion.bind(this)}" min-symbols="2" value="{parent.item.idRegionTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Город</label>\n          <autocomplete name="idCityTo" value-field="name" data="{parent.cities}" __disabled="{tags.country.value == undefined}" min-symbols="2" value="{parent.item.idCityTo}">{item.name}</autocomplete>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('change');
	    self.cities = [];
	
	    self.getRegions = function (id) {
	        if (self.regions instanceof Array && id !== undefined) return self.regions.filter(function (item) {
	            return item.idCountry == id;
	        });else return [];
	    };
	
	    self.changeCountry = function (e) {
	        self.getCities(this.idCountryTo.value, this.idRegionTo.value);
	    };
	
	    self.changeRegion = function (e) {
	        self.getCities(this.idCountryTo.value, this.idRegionTo.value);
	    };
	
	    self.getCities = function (country, region) {
	        return API.request({
	            object: 'GeoCity',
	            method: 'Fetch',
	            data: { idCountry: country, idRegion: region },
	            success: function success(response) {
	                self.cities = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.cannotBeClosed = true;
	        modal.eChange = false;
	        modal.close = function () {
	            modal.modalHide();
	        };
	
	        self.item = {};
	
	        if (opts.item) self.item = opts.item;
	
	        (0, _parallel2.default)([function (callback) {
	            API.request({
	                object: 'GeoCountry',
	                method: 'Fetch',
	                success: function success(response) {
	                    self.countries = response.items;
	                    callback(null, 'Countries');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'GeoRegion',
	                method: 'Fetch',
	                success: function success(response) {
	                    self.regions = response.items;
	                    callback(null, 'Regions');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function (err, res) {
	
	            if (self.item.idCityTo != null && self.item.idCityTo > 0) {
	                var ids = [self.item.idCityTo];
	
	                API.request({
	                    object: 'GeoCity',
	                    method: 'Fetch',
	                    data: { ids: ids },
	                    success: function success(response) {
	                        self.item.idCountryTo = response.items[0].idCountry;
	                        self.item.idRegionTo = response.items[0].idRegion;
	
	                        self.countries.forEach(function (item) {
	                            if (item.id == self.item.idCountryTo) self.tags['bs-modal'].tags.idCountryTo.filterValue = item.name;
	                        });
	
	                        self.regions.forEach(function (item) {
	                            if (item.id == self.item.idRegionTo) self.tags['bs-modal'].tags.idRegionTo.filterValue = item.name;
	                        });
	
	                        self.tags['bs-modal'].tags.idCityTo.filterValue = response.items[0].name;
	
	                        self.loader = false;
	                        self.update();
	                    }
	                });
	            } else {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, observable, API, $) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('image-gallery', '  <div class="col-sm-6">\n    <div class="form-inline">\n      <div class="input-group btn btn-primary btn-file" if="{checkPermission(&quot;images&quot;, &quot;0100&quot;)}">\n        <input id="importFile" name="files" onchange="{upload}" type="file" multiple="multiple" accept="image/*"><i class="fa fa-plus"></i> Добавить\n      </div>\n      <button class="btn btn-danger" if="{selectedCount &amp;&amp; checkPermission(&quot;images&quot;, &quot;0001&quot;)}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash"></i></button>\n      <button class="btn btn-danger" if="{!opts.hideUnised checkPermission(&quot;images&quot;, &quot;0001&quot;)}" onclick="{removeUnused}" type="button"><i class="fa fa-trash"></i> Удалить неиспользуемые</button>\n    </div>\n  </div>\n  <div class="col-sm-6">\n    <form class="form-inline text-right m-b-2">\n      <div class="form-group">\n        <div class="input-group">\n          <input class="searchCatalog form-control" name="search" type="text" title="Поиск (Ctrl+F)" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n            <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n        </div>\n      </div>\n    </form>\n  </div>\n  <div class="table-responsive col-sm-12">\n    <datatable cols="{cols}" rows="{items}" handlers="{handlers}" dblclick="{opts.dblclick}">\n      <datatable-cell name="">\n        <div class="image-prev"><img riot-src="{row.imageUrlPreview}" width="64"></div>\n      </datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="sizeDisplay">{row.sizeDisplay}</datatable-cell>\n      <datatable-cell name="weight">{row.weight}</datatable-cell>\n    </datatable>\n  </div>\n  <bs-pagination name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n', '.image-prev { border-width: 1px; border-color: #F2F2F2; border-style: solid; display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-align-items: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-flex: auto; -ms-flex: auto; -webkit-box-flex: 1; flex: auto; width: 64px; height: 64px; overflow: hidden; -moz-border-radius: 4px; -webkit-border-radius: 4px; border-radius: 4px; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	
	    self.cols = [{ name: '', value: 'Картинка' }, { name: 'name', value: 'Наименование' }, { name: 'sizeDisplay', value: 'Размер (px)' }, { name: 'weight', value: 'Вес (байт)' }];
	
	    self.handlers = {
	        getImageUrl: function getImageUrl(name) {
	            if (name.indexOf('http://') == -1 && name.indexOf('https://') == -1) {
	                return app.getImagePreviewURL(name, self.params.section);
	                //return app.config.imagePreviewURL + self.params.section + '/' + name
	            } else {
	                return name;
	            }
	        }
	    };
	
	    self.find = (0, _debounce2.default)(function (e) {
	        if (e.key !== 'Control' && (e.key !== 'f' || self.lastEvent !== 1)) {
	            if (self.pages.current > self.pages.count) self.pages.current = 1;
	            self.reload();
	            self.lastEvent = 0;
	        }
	    }, 400);
	
	    self.items = [];
	    self.params = {};
	
	    self.pages = {
	        count: 0,
	        current: 1,
	        limit: 11,
	        change: function change(e) {
	            self.pages.current = e.currentTarget.page;
	            self.params.limit = self.pages.limit;
	            self.params.offset = (self.pages.current - 1) * self.pages.limit;
	            if (self.params.offset < 0) self.params.offset = 0;
	            observable.trigger('images-page-change', self.params);
	            self.reload();
	        }
	    };
	
	    self.reload = function () {
	        if (self.params.limit && self.params.offset) self.pages.current = self.params.offset / self.params.limit + 1;
	        if (self.search) {
	            self.params.searchText = self.search.value;
	        }
	
	        API.request({
	            object: 'Image',
	            method: 'Fetch',
	            data: self.params,
	            success: function success(response) {
	                self.pages.count = Math.ceil(response.count / self.pages.limit);
	                if (self.pages.current > self.pages.count) {
	                    self.pages.current = self.pages.count;
	                }
	                self.items = response.items;
	                self.tags.paginator.update({ pages: self.pages.count, page: self.pages.current });
	                self.update();
	            },
	            error: function error(response) {
	                self.pages.count = 1;
	                self.pages.current = 1;
	                self.items = [];
	                self.tags.paginator.update({ pages: self.pages.count, page: self.pages.current });
	                self.update();
	            }
	        });
	    };
	
	    self.removeUnused = function (e) {
	
	        API.request({
	            object: 'Image',
	            method: 'Delete',
	            data: { isUnused: true, section: self.params.section },
	            success: function success(response) {
	                popups.create({ title: 'Успех!', text: 'Неиспользованные картинки удалены', style: 'popup-success' });
	                self.reload();
	            }
	        });
	    };
	
	    self.remove = function (e) {
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: 'Вы точно хотите удалить выделенные картинки?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    var files = self.tags.datatable.getSelectedRows().map(function (item) {
	                        return item.name;
	                    });
	
	                    var params = {
	                        section: self.params.section,
	                        files: files
	                    };
	
	                    API.request({
	                        object: 'Image',
	                        method: 'Delete',
	                        data: params,
	                        success: function success(response) {
	                            self.selectedCount = 0;
	                            self.reload();
	                            popups.create({ style: 'popup-success', title: 'Успех!', text: 'Удалено' });
	                        }
	                    });
	                }
	                this.modalHide();
	            }
	        });
	    };
	
	    self.upload = function (e) {
	        var formData = new FormData();
	
	        for (var i = 0; i < e.target.files.length; i++) {
	            formData.append('file' + i, e.target.files[i], e.target.files[i].name);
	        }
	        API.upload({
	            section: self.params.section,
	            count: e.target.files.length,
	            data: formData,
	            success: function success(response) {
	                if (Array.isArray(response.items) && response.items.length) {
	                    self.items = response.items.concat(self.items);
	                }
	
	                self.update();
	
	                if (typeof opts.autoselect === 'function' && response.items && response.items[0]) {
	                    opts.autoselect.bind(self)(response.items[0]);
	                }
	            }
	        });
	        $("#importFile").val(undefined);
	    };
	
	    self.one('updated', function () {
	        self.tags.datatable.on('row-selected', function (count) {
	            self.selectedCount = count;
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(5), __webpack_require__(4), __webpack_require__(16)))

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API) {'use strict';
	
	__webpack_require__(104);
	
	riot.tag2('image-select', '  <div class="image" riot-style="background-image: url({item.imageUrlPreview.replaceAll(&quot; &quot;,&quot;%20&quot;)});">\n    <div class="image-select text-center" if="{uploadStatus === 0}">\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0100&quot;)}">\n        <div class="input-group btn btn-sm btn-primary btn-file" style="margin: 0 auto;">\n          <input onchange="{upload}" type="file" accept="image/*"><i class="fa fa-fw fa-upload"></i> Загрузить\n        </div>\n      </div>\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0010&quot;)}">\n        <button class="btn btn-sm btn-success" onclick="{select}" type="button"><i class="fa fa-fw fa-picture-o"></i> Выбрать</button>\n      </div>\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0010&quot;)}">\n        <button class="btn btn-sm btn-danger" onclick="{remove}" type="button"><i class="fa fa-fw fa-trash"></i> Очистить</button>\n      </div>\n    </div>\n    <div class="image-upload text-center" if="{uploadStatus &gt; 0}">\n      <h3 class="image-upload-percent">{uploadStatus}%</h3>\n    </div>\n  </div>\n', 'image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ display: table; position: relative; background-position: center; background-repeat: no-repeat; background-size: cover; width: 100%; height: 170px; } @media (max-width: 991px) { image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ margin: 0 auto; height: 450px !important; width: 450px !important; } } @media (max-width: 767px) { image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ margin: 0 auto; height: 300px !important; width: 300px !important; } } @media (max-width: 480px) { image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ margin: 0 auto; height: 240px !important; width: 240px !important; } } image-select .image .image-select,[riot-tag="image-select"] .image .image-select,[data-is="image-select"] .image .image-select{ display: none; } image-select .image:hover .image-select,[riot-tag="image-select"] .image:hover .image-select,[data-is="image-select"] .image:hover .image-select,image-select .image:focus .image-select,[riot-tag="image-select"] .image:focus .image-select,[data-is="image-select"] .image:focus .image-select{ display: table-cell; vertical-align: middle; background-color: rgba(0, 0, 0, 0.5); } image-select .image-upload,[riot-tag="image-select"] .image-upload,[data-is="image-select"] .image-upload{ display: table-cell; vertical-align: middle; } image-select .image-upload-percent,[riot-tag="image-select"] .image-upload-percent,[data-is="image-select"] .image-upload-percent{ color: #FFF; text-shadow: 0 0 1px black, 1px 1px 2px black; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.uploadStatus = 0;
	    self.item = {};
	
	    function changeEvent() {
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    }
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.item.image;
	        },
	        set: function set(value) {
	            console.log(value);
	
	            self.item.image = value;
	            self.item.imageFile = 'images/' + opts.section + '/' + value;
	            self.item.imageUrlPreview = app.getImagePreviewURL(value, opts.section, opts.size);
	        }
	    });
	
	    self.upload = function (e) {
	        var formData = new FormData();
	
	        for (var i = 0; i < e.target.files.length; i++) {
	            formData.append('file' + i, e.target.files[i], e.target.files[i].name);
	        }
	
	        API.upload({
	            section: opts.section,
	            count: 1,
	            data: formData,
	            progress: function progress(e) {
	                var percentComplete = Math.ceil(e.loaded / e.total * 100);
	                self.uploadStatus = percentComplete;
	                self.update();
	            },
	            success: function success(response) {
	                self.item.image = response.items[0].name;
	                changeEvent();
	                self.update();
	            },
	            complete: function complete() {
	                self.uploadStatus = 0;
	                self.update();
	            }
	        });
	    };
	
	    self.select = function () {
	        modals.create('images-gallery-modal', {
	            type: 'modal-primary',
	            section: opts.section,
	            submit: function submit() {
	                var items = this.tags.gallery.tags.datatable.getSelectedRows();
	
	                if (items.length) {
	                    self.item.image = items[0].name;
	                    changeEvent();
	                    self.update();
	                }
	
	                this.modalHide();
	            }
	        });
	    };
	
	    self.remove = function () {
	        self.item.image = '';
	        self.item.imageFile = '';
	        self.item.imageUrlPreview = '';
	        changeEvent();
	    };
	
	    self.on('mount', function () {
	        self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4)))

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('news-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории новостей</div>\n    </yield>\n    <yield to="body">\n      <catalog object="News" cols="{parent.cols}" dblclick="{parent.opts.submit.bind(this)}" reload="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n          <datatable-cell name="publicationDateDisplay">{row.publicationDateDisplay}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }, { name: 'publicationDateDisplay', value: 'Дата публикации' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(105);
	
	riot.tag2('person-category-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категория</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.parentName}">\n          <label class="control-label">Родительская группа</label>\n          <div class="input-group">\n            <select class="form-control" name="idParent">\n              <option each="{groupsPerson}" value="{id}" __selected="{id == item.idParent}" no-reorder>{title}</option>\n            </select>\n            <div class="input-group-btn">\n              <div class="btn btn-default" onclick="{removeGroup}"><i class="fa fa-times text-danger"></i></div>\n            </div>\n          </div>\n        </div>\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Код категории рассылки</label>\n          <div class="input-group">\n            <input class="form-control" name="emailSettings" type="text" value="{item.emailSettings}">\n            <div class="input-group-btn">\n              <div class="btn btn-default" onclick="{getEmailGroup}" title="Связать с группой рассылки"><i class="fa fa-cogs"></i></div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    function loadGroupPerson(modal) {
	        var params = {};
	        params.ignoreId = modal.item.id || 0;
	        params.parentId = 0;
	
	        modal.groupsPerson = [];
	        API.request({
	            object: 'ContactCategory',
	            method: 'Fetch',
	            data: params,
	            success: function success(response, xhr) {
	                modal.groupsPerson.push({ id: 0, title: "Без родителя" });
	                modal.groupsPerson = modal.groupsPerson.concat(response.items);
	                modal.update();
	            }
	        });
	    }
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.groupsPerson = [];
	        modal.item = opts.item || {};
	
	        loadGroupPerson(modal);
	
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.getEmailGroup = function (e) {
	            var params = {
	                id: modal.item.id,
	                name: modal.item.name,
	                addBook: true
	            };
	            API.request({
	                object: 'ContactCategory',
	                data: params,
	                method: 'Save',
	                success: function success(response) {
	                    modal.item.emailSettings = response.emailSettings;
	                    popups.create({ title: 'Успех!', text: 'Контакты синхронизированы с группой рассылки!', style: 'popup-success' });
	                    modal.update();
	                }
	            });
	        };
	        modal.removeGroup = function (e) {
	            modal.item.idParent = null;
	            modal.item.nameParent = '';
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('person-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новый контакт</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Имя</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">E-mail</label>\n          <input class="form-control" name="email" type="text">\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('group-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории</div>\n    </yield>\n    <yield to="body">\n      <catalog-tree object="Category" add="{add}" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" handlers="{handlers}" reload="true" search="true" dblclick="{parent.opts.submit.bind(this)}" exception="{parent.opts.id}">\n        <yield to="after"><span>{this[parent.childrenField].length ? ⁗[⁗ + this[parent.childrenField].length + ⁗]⁗ : ⁗⁗}</span></yield>\n      </catalog-tree>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', 'group-select-modal .tree,[riot-tag="group-select-modal"] .tree,[data-is="group-select-modal"] .tree{ display : inline-block; border-left : 1px solid grey; border-bottom : 1px solid grey; width : 10px; height : 10px; margin-bottom : 5px; margin-right : 5px; }', '', function (opts) {
	  "use strict";
	
	  var self = this;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(419);
	
	__webpack_require__(343);
	
	riot.tag2('groups-list', '  <catalog-tree object="Category" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" dblclick="{handlers.open}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" handlers="{handlers}" allselect="true" reload="true" search="true" reorder="true" observable-trigger="categories-reload">\n    <yield to="head">\n      <button class="btn btn-primary" if="{selectedCount &gt; 1}" type="button" title="Мультиредактирование категорий" onclick="{handlers.multiEdit}"><i class="fa fa-pencil"></i></button>\n    </yield>\n    <yield to="after"><span>{this[parent.childrenField].length ? ⁗[⁗ + this[parent.childrenField].length + ⁗]⁗ : ⁗⁗}</span><span class="col-code">{parent.childrenField.codeGr}</span>\n      <form class="form-inline pull-right">\n\n        <i class="fa fa-plus text-success" title="Добавить категорию" if="{handlers.checkPermission(&quot;products&quot;, &quot;0100&quot;)}" onclick="{handlers.add}" style="margin-right: 10px;"></i>\n      </form>\n    </yield>\n  </catalog-tree>\n', 'groups-list,[riot-tag="groups-list"],[data-is="groups-list"]{ position: relative; display: block; } groups-list treenodes .treenode,[riot-tag="groups-list"] treenodes .treenode,[data-is="groups-list"] treenodes .treenode{ width: 100%; display: inline-block; line-height: 2.2; }', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Category';
	
	    self.add = function (e) {
	        e.stopPropagation();
	
	        var id, item;
	        if (e.item && e.item.id) {
	            id = e.item.id;
	            item = e.item;
	        }
	
	        modals.create('group-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (_this.name.value.toString().trim() != '' && !_this.error) {
	
	                    var params, sortIndex, childs;
	
	                    if (item) {
	                        sortIndex = item['childs'].length;
	                        item['childs'] = item['childs'] || [];
	                        childs = item['childs'];
	                    } else {
	                        sortIndex = self.tags['catalog-tree'].nodes.length;
	                        self.tags['catalog-tree'].nodes = self.tags['catalog-tree'].nodes || [];
	                        childs = self.tags['catalog-tree'].nodes;
	                    }
	
	                    if (id) params = { name: _this.name.value, upid: id, sortIndex: sortIndex };else params = { name: _this.name.value, sortIndex: sortIndex };
	
	                    API.request({
	                        object: 'Category',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            if (e.item && e.item.id) {
	                                Object.defineProperty(response, '__parent__', {
	                                    writable: true,
	                                    configurable: true,
	                                    enumerable: false,
	                                    value: e.item
	                                });
	                                childs.push(response);
	                                self.tags['catalog-tree'].update();
	                            } else {
	                                observable.trigger('categories-reload');
	                            }
	                            _this.modalHide();
	                            popups.create({
	                                title: 'Успех!',
	                                text: 'Категория добавлена',
	                                style: 'popup-success'
	                            });
	                            //self.tags['catalog-tree'].update()
	                            //observable.trigger('categories-reload')
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.removeNode = function (e) {
	        e.stopPropagation();
	        var self = _this2,
	            params = { ids: [e.item.id] };
	
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: 'Вы точно хотите удалить эту запись?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    API.request({
	                        object: 'Category',
	                        method: 'Delete',
	                        data: params,
	                        success: function success(response) {
	                            if (e.item.__parent__ instanceof Array) {
	                                e.item.__parent__.splice(e.item.__parent__.indexOf(e.item), 1);
	                            } else if (e.item.__parent__ instanceof Object) {
	                                e.item.__parent__['childs'].splice(e.item.__parent__['childs'].indexOf(e.item), 1);
	                            }
	
	                            popups.create({ title: 'Успешно удалено!', style: 'popup-success' });
	                            self.tags['catalog-tree'].update();
	                        }
	                    });
	                }
	                this.modalHide();
	            }
	        });
	    };
	
	    function open(e) {
	        e.stopPropagation();
	        riot.route('/products/categories/' + e.item.id);
	    }
	
	    function multiEdit(e) {
	        var ids = this.tags.treeview.getSelectedNodes().map(function (item) {
	            return item.id;
	        }).join(',');
	        riot.route('/products/categories/multi?ids=' + ids);
	    }
	
	    function afterChangeParent(idParent, id, position) {
	        var params = {};
	        params.id = id;
	        params.upid = idParent;
	        params.position = position;
	
	        API.request({
	            object: 'Category',
	            method: 'Save',
	            data: params,
	            success: function success() {
	                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	            }
	        });
	    }
	
	    function afterChangePosition(indexes) {
	        var params = { indexes: indexes };
	        API.request({
	            object: 'Category',
	            method: 'Sort',
	            data: params,
	            success: function success() {
	                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	            }
	        });
	    }
	
	    self.handlers = {
	        checkMask: self.checkMask,
	        checkPermission: self.checkPermission,
	        permission: self.permission,
	        add: self.add,
	        open: open,
	        remove: self.removeNode,
	        multiEdit: multiEdit,
	        afterChangeParent: afterChangeParent,
	        afterChangePosition: afterChangePosition
	    };
	
	    observable.on('categories-reload', function (item) {
	        if (item == undefined) {
	            self.tags['catalog-tree'].reload();
	        } else {
	            var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	            items[0].name = item.name;
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(173);
	
	riot.tag2('modification-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/modifications"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;products&quot;, &quot;0100&quot;) : checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Добавление модификации\' : item.name || \'Редактирование модификации\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Наименование</label>\n            <input class="form-control" name="name" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.type}">\n            <label class="control-label">Тип цены</label>\n            <select class="form-control" name="vtype" value="{item.vtype}">\n              <option value="0">Добавляет к цене</option>\n              <option value="1">Умножает на цену</option>\n              <option value="2">Замещает цену</option>\n            </select>\n            <div class="help-block">{error.vtype}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <catalog-static name="values" add="{addColumns}" cols="{columnsCols}" rows="{item.values}" remove="true">\n            <yield to="body">\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n          <div class="alert alert-danger" if="{error.values}">{error.values}</div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.item = {};
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty',
	        values: {
	            required: true,
	            rules: [{
	                vtype: 'minLength[1]',
	                prompt: 'В списке должно быть не менее одного элемента'
	            }]
	        }
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    // o_O
	    self.columnsCols = [{ name: 'name', value: 'Наименование' }];
	
	    self.addColumns = function () {
	        var _this = this;
	        modals.create('parameters-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            filters: { field: 'type', sign: 'IN', value: 'list, colorlist' },
	            submit: function submit() {
	                _this.value = _this.value || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                var ids = _this.value.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) _this.value.push(item);
	                });
	
	                self.update();
	                this.modalHide();
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.tags.values.root.dispatchEvent(event);
	            }
	        });
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        self.error = self.validation.validate(self.item, self.rules);
	        if (!self.error) {
	            API.request({
	                object: 'Modification',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    self.update();
	                    popups.create({ title: 'Успех!', text: 'Модификация сохранена!', style: 'popup-success' });
	                    if (self.isNew) riot.route('products/modifications/' + response.id);
	                    observable.trigger('modifications-reload');
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        observable.trigger('modifications-edit', self.item.id);
	    };
	
	    observable.on('modifications-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = { values: [] };
	        self.update();
	    });
	
	    observable.on('modifications-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.loader = true;
	        self.isNew = false;
	        self.item = {};
	
	        API.request({
	            object: 'Modification',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.update({
	                    loader: false
	                });
	            }
	        });
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('modifications-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Модификации товара</div>\n    </yield>\n    <yield to="body">\n      <catalog-static cols="{parent.cols}" rows="{parent.rows}" remove="true" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="stock">{row.stock}</datatable-cell>\n          <datatable-cell name="price">{row.price}</datatable-cell>\n        </yield>\n      </catalog-static>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	    self.rows = [];
	
	    self.cols = [{ name: 'name', value: 'Наименование' }, { name: 'stock', value: 'Остаток' }, { name: 'price', value: 'Цена' }];
	
	    self.on('update', function () {});
	
	    self.on('mount', function () {
	        self.loader = true;
	        API.request({
	            object: 'Product',
	            method: 'Info',
	            data: { id: [opts.id] },
	            notFoundRedirect: false,
	            success: function success(response) {
	                var name = response.name;
	                var modifications = response.modifications;
	
	                self.rows = [];
	
	                if (modifications.length > 0) {
	                    modifications.forEach(function (item) {
	                        var _item = item;
	                        var count = item.columns.length;
	                        var names = item.columns.map(function (i) {
	                            return i.name;
	                        });
	
	                        if ('items' in item && item.items instanceof Array && item.items.length > 0) {
	
	                            item.items.forEach(function (item) {
	                                item.price = item.priceRetail;
	                                if (item.count == -1) item.count = null;
	                                var namesValues = item.values.map(function (i) {
	                                    return i.value;
	                                });
	                                var row = names.map(function (item, i) {
	                                    return item + ': ' + namesValues[i];
	                                });
	                                var value = name + ' (' + row.join(', ') + ')';
	                                self.rows.push((0, _extends3.default)({}, item, { name: value }));
	                            });
	                        }
	                    });
	                }
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('feature-new-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Элемент списка параметра</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-4" if="{parent.opts.typeparam==&quot;list&quot; || parent.opts.typeparam==&quot;colorlist&quot;}">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" section="shopfeature" alt="0" size="256" value="{item.image}"></image-select>\n              </div>\n            </div>\n          </div>\n          <div class="{(parent.opts.typeparam==\'colorlist\' || parent.opts.typeparam==\'list\' ) ? \'col-md-8\' : \'col-md-12\'}">\n            <div class="form-group {has-error: error.value}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="value" type="text" value="{item.value}">\n              <div class="help-block">{error.value}</div>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Код (URL)</label>\n              <input class="form-control" name="code" type="text" value="{item.code}">\n            </div>\n            <div class="form-group {has-error: error.color}" if="{parent.opts.typeparam==&quot;colorlist&quot;}">\n              <label class="control-label">Цвет</label>\n              <input class="form-control" name="color" value="{item.color}" type="{\'color\'}">\n              <div class="help-block">{error.color}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        //modal.cannotBeClosed = true
	
	        modal.item = opts.item || {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            value: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('parameters-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Параметры</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-4 left-block">\n          <catalog-tree object="FeatureGroup" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" descendants="true"></catalog-tree>\n        </div>\n        <div class="col-md-8 cont-block">\n          <catalog object="Feature" cols="{parent.cols}" search="true" store="parameters-list-select-modal" add="{parent.add}" remove="true" handlers="{parent.handlers}" reload="true" filters="{categoryFilters}" disable-limit="true" disable-col-select="true" dblclick="{parent.opts.submit.bind(this)}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="type">{handlers.featureName(row.type)}</datatable-cell>\n            </yield>\n          </catalog>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '.left-block { margin-top: 45px; overflow: auto; max-height: 600px; } .cont-block { margin-top: 5px; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    var getFeaturesTypes = function getFeaturesTypes() {
	        API.request({
	            object: 'FeatureType',
	            method: 'Fetch',
	            data: {},
	            success: function success(response) {
	                self.featuresTypes = response.items;
	                self.update();
	            }
	        });
	    };
	
	    var featureName = function featureName(type) {
	        for (var i = 0; i < self.featuresTypes.length; i++) {
	            if (self.featuresTypes[i].code === type) return self.featuresTypes[i].name;
	        }
	    };
	
	    self.add = function () {
	        modals.create('parameter-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var params = { name: _this.name.value };
	
	                API.request({
	                    object: 'Feature',
	                    method: 'Save',
	                    data: params,
	                    success: function success(response) {
	                        _this.modalHide();
	                        if (response.id) riot.route('products/parameters/' + response.id);
	                    }
	                });
	            }
	        });
	    };
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип' }];
	
	    self.handlers = {
	        featureName: featureName
	    };
	    getFeaturesTypes();
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.categoryFilters = false;
	        modal.one('updated', function () {
	            modal.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
	                modal.selectedCategory = node.__selected__ ? node.id : undefined;
	                var items = modal.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                if (items.length > 0) {
	                    var value = items.map(function (i) {
	                        return i.id;
	                    }).join(',');
	                    modal.categoryFilters = [{ field: 'idFeatureGroup', sign: 'IN', value: value }];
	                } else {
	                    modal.categoryFilters = false;
	                }
	                modal.update();
	                modal.tags.catalog.reload();
	            });
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(103);
	
	__webpack_require__(158);
	
	__webpack_require__(168);
	
	riot.tag2('product-edit-additional-categories', '  <div class="input-group">\n    <tags class="form-control" name="{opts.name}" value="{value}"></tags><span class="input-group-addon" onclick="{add}"><i class="fa fa-plus"></i></span>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	            self.update();
	        }
	    });
	
	    self.add = function () {
	        modals.create('group-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.value = self.value || [];
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                var ids = self.value.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) self.value.push(item);
	                });
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.on('update', function () {
	        if ('name' in opts && opts.name !== '') self.root.name = opts.name;
	
	        if ('value' in opts) self.value = opts.value || [];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(415);
	
	riot.tag2('product-edit-discounts', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" add="{add}" cols="{cols}" rows="{value}" handlers="{handlers}" remove="true">\n        <yield to="toolbar">\n          <yield from="toolbar"></yield>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n          <datatable-cell name="dateFrom">{row.dateFrom}</datatable-cell>\n          <datatable-cell name="dateTo">{row.dateTo}</datatable-cell>\n          <datatable-cell name="stepTime">{row.stepTime}ч.</datatable-cell>\n          <datatable-cell name="stepDiscount">{row.stepDiscount}</datatable-cell>\n          <datatable-cell name="summFrom"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summFrom.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="summTo"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summTo.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="countFrom">{row.countFrom}</datatable-cell>\n          <datatable-cell name="countTo">{row.countTo}</datatable-cell>\n          <datatable-cell name="week">{handlers.getListOfDays(row.week)}</datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value || [];
	        },
	        set: function set(value) {
	            self.value = value || [];
	            self.update();
	        }
	    });
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }, { name: 'dateFrom', value: 'Старт' }, { name: 'dateTo', value: 'Завершение' }, { name: 'stepTime', value: 'Шаг времени' }, { name: 'stepDiscount', value: 'Шаг скидки' }, { name: 'summFrom', value: 'От суммы' }, { name: 'summTo', value: 'До суммы' }, { name: 'countFrom', value: 'От кол-ва' }, { name: 'countTo', value: 'До кол-ва' }, { name: 'week', value: 'Дни недели' }];
	
	    self.add = function () {
	        modals.create('discounts-list-modal-select', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.value = self.value || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.value.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) self.value.push(item);
	                });
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.handlers = {
	        daysOfWeek: ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'],
	        getListOfDays: function getListOfDays(days) {
	            var _this = this;
	
	            var items = days.split('');
	
	            var result = items.map(function (item, i) {
	                return item == 1 ? _this.daysOfWeek[i] : undefined;
	            }).filter(function (item) {
	                return item;
	            }).join(',');
	
	            return result;
	        }
	    };
	
	    self.on('update', function () {
	        if ('name' in opts && opts.name !== '') self.root.name = opts.name;
	
	        if ('value' in opts) self.value = opts.value || [];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(540)();
	
	__webpack_require__(538)(Chart);
	__webpack_require__(554)(Chart);
	__webpack_require__(534)(Chart);
	__webpack_require__(543)(Chart);
	__webpack_require__(537)(Chart);
	__webpack_require__(533)(Chart);
	__webpack_require__(535)(Chart);
	__webpack_require__(536)(Chart);
	__webpack_require__(541)(Chart);
	__webpack_require__(545)(Chart);
	__webpack_require__(546)(Chart);
	__webpack_require__(544)(Chart);
	__webpack_require__(547)(Chart);
	__webpack_require__(542)(Chart);
	__webpack_require__(539)(Chart);
	__webpack_require__(548)(Chart);
	
	__webpack_require__(549)(Chart);
	__webpack_require__(550)(Chart);
	__webpack_require__(551)(Chart);
	__webpack_require__(552)(Chart);
	
	__webpack_require__(557)(Chart);
	__webpack_require__(555)(Chart);
	__webpack_require__(556)(Chart);
	__webpack_require__(558)(Chart);
	__webpack_require__(559)(Chart);
	__webpack_require__(560)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(527)(Chart);
	__webpack_require__(528)(Chart);
	__webpack_require__(529)(Chart);
	__webpack_require__(530)(Chart);
	__webpack_require__(531)(Chart);
	__webpack_require__(532)(Chart);
	
	__webpack_require__(520)(Chart);
	__webpack_require__(521)(Chart);
	__webpack_require__(522)(Chart);
	__webpack_require__(523)(Chart);
	__webpack_require__(524)(Chart);
	__webpack_require__(525)(Chart);
	__webpack_require__(526)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ },
/* 177 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(85)
	  , document = __webpack_require__(43).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(47) && !__webpack_require__(64)(function(){
	  return Object.defineProperty(__webpack_require__(178)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(177);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(112)
	  , $export        = __webpack_require__(63)
	  , redefine       = __webpack_require__(186)
	  , hide           = __webpack_require__(65)
	  , has            = __webpack_require__(48)
	  , Iterators      = __webpack_require__(111)
	  , $iterCreate    = __webpack_require__(585)
	  , setToStringTag = __webpack_require__(114)
	  , getPrototypeOf = __webpack_require__(592)
	  , ITERATOR       = __webpack_require__(68)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(84)
	  , dPs         = __webpack_require__(183)
	  , enumBugKeys = __webpack_require__(110)
	  , IE_PROTO    = __webpack_require__(115)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(178)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(583).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(66)
	  , anObject = __webpack_require__(84)
	  , getKeys  = __webpack_require__(67);
	
	module.exports = __webpack_require__(47) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(185)
	  , hiddenKeys = __webpack_require__(110).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(48)
	  , toIObject    = __webpack_require__(49)
	  , arrayIndexOf = __webpack_require__(580)(false)
	  , IE_PROTO     = __webpack_require__(115)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(65);

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(30);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18)
	  , toIndex  = __webpack_require__(57)
	  , toLength = __webpack_require__(17);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(70);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(18)
	  , IObject   = __webpack_require__(76)
	  , toLength  = __webpack_require__(17);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(21)
	  , isObject   = __webpack_require__(11)
	  , invoke     = __webpack_require__(93)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(15).f
	  , create      = __webpack_require__(52)
	  , redefineAll = __webpack_require__(55)
	  , ctx         = __webpack_require__(40)
	  , anInstance  = __webpack_require__(50)
	  , defined     = __webpack_require__(31)
	  , forOf       = __webpack_require__(70)
	  , $iterDefine = __webpack_require__(132)
	  , step        = __webpack_require__(198)
	  , setSpecies  = __webpack_require__(56)
	  , DESCRIPTORS = __webpack_require__(14)
	  , fastKey     = __webpack_require__(44).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75)
	  , from    = __webpack_require__(189);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(55)
	  , getWeak           = __webpack_require__(44).getWeak
	  , anObject          = __webpack_require__(7)
	  , isObject          = __webpack_require__(11)
	  , anInstance        = __webpack_require__(50)
	  , forOf             = __webpack_require__(70)
	  , createArrayMethod = __webpack_require__(34)
	  , $has              = __webpack_require__(20)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(14) && !__webpack_require__(9)(function(){
	  return Object.defineProperty(__webpack_require__(124)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(11)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(7);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 199 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(54)
	  , gOPS     = __webpack_require__(97)
	  , pIE      = __webpack_require__(77)
	  , toObject = __webpack_require__(18)
	  , IObject  = __webpack_require__(76)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(9)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(15)
	  , anObject = __webpack_require__(7)
	  , getKeys  = __webpack_require__(54);
	
	module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(25)
	  , gOPN      = __webpack_require__(53).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(20)
	  , toIObject    = __webpack_require__(25)
	  , arrayIndexOf = __webpack_require__(89)(false)
	  , IE_PROTO     = __webpack_require__(137)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(54)
	  , toIObject = __webpack_require__(25)
	  , isEnum    = __webpack_require__(77).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(53)
	  , gOPS     = __webpack_require__(97)
	  , anObject = __webpack_require__(7)
	  , Reflect  = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(8).parseFloat
	  , $trim       = __webpack_require__(73).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(142) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(8).parseInt
	  , $trim     = __webpack_require__(73).trim
	  , ws        = __webpack_require__(142)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 208 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(17)
	  , repeat   = __webpack_require__(141)
	  , defined  = __webpack_require__(31);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(13);

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(192);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(90)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(14) && /./g.flags != 'g')__webpack_require__(15).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(92)
	});

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(192);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(90)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(34)(0)
	  , redefine     = __webpack_require__(23)
	  , meta         = __webpack_require__(44)
	  , assign       = __webpack_require__(200)
	  , weak         = __webpack_require__(194)
	  , isObject     = __webpack_require__(11)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(90)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/f4769f9bdb7466be65088239c12046d1.eot";

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148),
	    arrayMap = __webpack_require__(804),
	    isArray = __webpack_require__(220),
	    isSymbol = __webpack_require__(222);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 218 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(218);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 221 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(78),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(837);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(101),
	    isSymbol = __webpack_require__(222);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	var bgX = moment.defineLocale('bg-x', {
	    parentLocale: 'bg'
	});
	
	return bgX;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(791);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./font-awesome.min.css", function() {
				var newContent = require("!!../../css-loader/index.js!./font-awesome.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (coll, iteratee, callback) {
	    var eachOfImplementation = (0, _isArrayLike2.default)(coll) ? eachOfArrayLike : eachOfGeneric;
	    eachOfImplementation(coll, iteratee, callback);
	};
	
	var _isArrayLike = __webpack_require__(100);
	
	var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
	
	var _breakLoop = __webpack_require__(154);
	
	var _breakLoop2 = _interopRequireDefault(_breakLoop);
	
	var _eachOfLimit = __webpack_require__(334);
	
	var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);
	
	var _doLimit = __webpack_require__(335);
	
	var _doLimit2 = _interopRequireDefault(_doLimit);
	
	var _noop = __webpack_require__(151);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _once = __webpack_require__(155);
	
	var _once2 = _interopRequireDefault(_once);
	
	var _onlyOnce = __webpack_require__(156);
	
	var _onlyOnce2 = _interopRequireDefault(_onlyOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eachOf implementation optimized for array-likes
	function eachOfArrayLike(coll, iteratee, callback) {
	    callback = (0, _once2.default)(callback || _noop2.default);
	    var index = 0,
	        completed = 0,
	        length = coll.length;
	    if (length === 0) {
	        callback(null);
	    }
	
	    function iteratorCallback(err, value) {
	        if (err) {
	            callback(err);
	        } else if (++completed === length || value === _breakLoop2.default) {
	            callback(null);
	        }
	    }
	
	    for (; index < length; index++) {
	        iteratee(coll[index], index, (0, _onlyOnce2.default)(iteratorCallback));
	    }
	}
	
	// a generic version of eachOf which can handle array, object, and iterator cases.
	var eachOfGeneric = (0, _doLimit2.default)(_eachOfLimit2.default, Infinity);
	
	/**
	 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
	 * to the iteratee.
	 *
	 * @name eachOf
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEachOf
	 * @category Collection
	 * @see [async.each]{@link module:Collections.each}
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each
	 * item in `coll`. The `key` is the item's key, or index in the case of an
	 * array. The iteratee is passed a `callback(err)` which must be called once it
	 * has completed. If no error has occurred, the callback should be run without
	 * arguments or with an explicit `null` argument. Invoked with
	 * (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
	 * var configs = {};
	 *
	 * async.forEachOf(obj, function (value, key, callback) {
	 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
	 *         if (err) return callback(err);
	 *         try {
	 *             configs[key] = JSON.parse(data);
	 *         } catch (e) {
	 *             return callback(e);
	 *         }
	 *         callback();
	 *     });
	 * }, function (err) {
	 *     if (err) console.error(err.message);
	 *     // configs is now a map of JSON data
	 *     doSomethingWith(configs);
	 * });
	 */
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachOfLimit;
	
	var _eachOfLimit2 = __webpack_require__(336);
	
	var _eachOfLimit3 = _interopRequireDefault(_eachOfLimit2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name eachOfLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A function to apply to each
	 * item in `coll`. The `key` is the item's key, or index in the case of an
	 * array. The iteratee is passed a `callback(err)` which must be called once it
	 * has completed. If no error has occurred, the callback should be run without
	 * arguments or with an explicit `null` argument. Invoked with
	 * (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachOfLimit(coll, limit, iteratee, callback) {
	  (0, _eachOfLimit3.default)(limit)(coll, iteratee, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = doLimit;
	function doLimit(fn, limit) {
	    return function (iterable, iteratee, callback) {
	        return fn(iterable, limit, iteratee, callback);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = _eachOfLimit;
	
	var _noop = __webpack_require__(151);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _once = __webpack_require__(155);
	
	var _once2 = _interopRequireDefault(_once);
	
	var _iterator = __webpack_require__(338);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _onlyOnce = __webpack_require__(156);
	
	var _onlyOnce2 = _interopRequireDefault(_onlyOnce);
	
	var _breakLoop = __webpack_require__(154);
	
	var _breakLoop2 = _interopRequireDefault(_breakLoop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _eachOfLimit(limit) {
	    return function (obj, iteratee, callback) {
	        callback = (0, _once2.default)(callback || _noop2.default);
	        if (limit <= 0 || !obj) {
	            return callback(null);
	        }
	        var nextElem = (0, _iterator2.default)(obj);
	        var done = false;
	        var running = 0;
	
	        function iterateeCallback(err, value) {
	            running -= 1;
	            if (err) {
	                done = true;
	                callback(err);
	            } else if (value === _breakLoop2.default || done && running <= 0) {
	                done = true;
	                return callback(null);
	            } else {
	                replenish();
	            }
	        }
	
	        function replenish() {
	            while (running < limit && !done) {
	                var elem = nextElem();
	                if (elem === null) {
	                    done = true;
	                    if (running <= 0) {
	                        callback(null);
	                    }
	                    return;
	                }
	                running += 1;
	                iteratee(elem.value, elem.key, (0, _onlyOnce2.default)(iterateeCallback));
	            }
	        }
	
	        replenish();
	    };
	}
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (coll) {
	    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
	};
	
	var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
	
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = iterator;
	
	var _isArrayLike = __webpack_require__(100);
	
	var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
	
	var _getIterator = __webpack_require__(337);
	
	var _getIterator2 = _interopRequireDefault(_getIterator);
	
	var _keys = __webpack_require__(833);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createArrayIterator(coll) {
	    var i = -1;
	    var len = coll.length;
	    return function next() {
	        return ++i < len ? { value: coll[i], key: i } : null;
	    };
	}
	
	function createES2015Iterator(iterator) {
	    var i = -1;
	    return function next() {
	        var item = iterator.next();
	        if (item.done) return null;
	        i++;
	        return { value: item.value, key: i };
	    };
	}
	
	function createObjectIterator(obj) {
	    var okeys = (0, _keys2.default)(obj);
	    var i = -1;
	    var len = okeys.length;
	    return function next() {
	        var key = okeys[++i];
	        return i < len ? { value: obj[key], key: key } : null;
	    };
	}
	
	function iterator(coll) {
	    if ((0, _isArrayLike2.default)(coll)) {
	        return createArrayIterator(coll);
	    }
	
	    var iterator = (0, _getIterator2.default)(coll);
	    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
	}
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = _parallel;
	
	var _noop = __webpack_require__(151);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _isArrayLike = __webpack_require__(100);
	
	var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
	
	var _rest = __webpack_require__(340);
	
	var _rest2 = _interopRequireDefault(_rest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _parallel(eachfn, tasks, callback) {
	    callback = callback || _noop2.default;
	    var results = (0, _isArrayLike2.default)(tasks) ? [] : {};
	
	    eachfn(tasks, function (task, key, callback) {
	        task((0, _rest2.default)(function (err, args) {
	            if (args.length <= 1) {
	                args = args[0];
	            }
	            results[key] = args;
	            callback(err);
	        }));
	    }, function (err) {
	        callback(err, results);
	    });
	}
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = rest;
	
	var _overRest2 = __webpack_require__(821);
	
	var _overRest3 = _interopRequireDefault(_overRest2);
	
	var _identity = __webpack_require__(827);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Lodash rest function without function.toString()
	// remappings
	function rest(func, start) {
	    return (0, _overRest3.default)(func, start, _identity2.default);
	}
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, observable, $, API) {'use strict';
	
	var _md5Min = __webpack_require__(62);
	
	var _md5Min2 = _interopRequireDefault2(_md5Min);
	
	__webpack_require__(361);
	
	__webpack_require__(386);
	
	__webpack_require__(441);
	
	__webpack_require__(463);
	
	__webpack_require__(407);
	
	__webpack_require__(362);
	
	__webpack_require__(376);
	
	__webpack_require__(509);
	
	__webpack_require__(369);
	
	__webpack_require__(370);
	
	__webpack_require__(502);
	
	__webpack_require__(396);
	
	__webpack_require__(360);
	
	__webpack_require__(377);
	
	__webpack_require__(82);
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault2(_parallel);
	
	__webpack_require__(457);
	
	__webpack_require__(348);
	
	__webpack_require__(346);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('app', '  <div if="{unsupported}">\n    <div class="old-browser">\n      <div class="old-browser__content">\n        <p>Для работы с сайтом необходим современный браузер.</p>\n        <p>Загрузите и установите один из этих браузеров:</p>\n      </div>\n      <div class="old-browser__browsers"><a class="old-browser__browser-link firefox" href="http://www.mozilla-europe.org/" target="_blank">Firefox</a><a class="old-browser__browser-link chrome" href="http://www.google.com/chrome/" target="_blank">Chrome</a><a class="old-browser__browser-link opera" href="http://www.opera.com/" target="_blank">Opera</a></div>\n    </div>\n  </div>\n  <loader if="{loader}" size="large" text="Загрузка"></loader>\n  <auth if="{!app.auth &amp;&amp; !loader}"></auth>\n  <images-manager if="{imageLoad &amp;&amp; !loader}"></images-manager>\n  <div class="app-layout" if="{sidebarShow}" onclick="{toggleSidebar}"></div>\n  <div class="wrapper" if="{!unsupported &amp;&amp; app.auth &amp;&amp; !loader &amp;&amp; !imageLoad}">\n    <div class="sidebar-left {active: sidebarShow}">\n      <div class="logo"></div>\n      <div class="menu">\n        <div class="menu__up" onclick="{scrollMenuTop}" style="display: none;"></div>\n        <div class="menu__down" onclick="{scrollMenuBottom}"></div>\n        <ul onscroll="{onResize}">\n          <li class="menu-item {active: name == tab}" each="{sidebar}" if="{checkPermission(permission, 1000)}"><a href="#{link}"><i class="fa {icon}"></i><span>{title}</span><span class="notice-count notice-count-{name}" if="{notice}">0</span></a></li>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n          <li class="hidden-md hidden-sm hidden-lg"><a href="{app.config.projectURL}" target="_blank" title="Перейти на сайт"><i class="fa fa-share"></i><span>Перейти на сайт</span></a></li>\n          <li class="hidden-md hidden-sm hidden-lg"><a onclick="{logout}" href="#"><i class="fa fa-sign-out"></i><span>Выход</span></a></li>\n        </ul>\n      </div>\n    </div>\n    <div class="main-container">\n      <div class="navbar navbar-default navbar-fixed-top m-b-2">\n        <div class="container-fluid">\n          <div class="navbar-header">\n            <button class="navbar-toggle pull-left m-x-2" onclick="{toggleSidebar}" type="button"><span class="sr-only"></span><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span></button><a class="navbar-brand">{headTitle || \'Shop 24\'}</a>\n          </div>\n          <div class="navbar-collapse collapse">\n            <current-time></current-time>\n            <ul class="nav navbar-nav navbar-right">\n              <li if="{app.config.projectURL}"><a href="{app.config.projectURL}" target="_blank" title="Перейти на сайт"><i class="fa fa-share"></i></a></li>\n              <li><a onclick="{logout}" href="#"><i class="fa fa-fw fa-sign-out"></i>Выход</a></li>\n            </ul>\n            <order-person-search></order-person-search>\n          </div>\n        </div>\n      </div>\n      <div class="main col-md-12" style="width: 100%;">\n        <desktop if="{tab == &quot;desktop&quot;}">\n          <h4>Рабочий стол - в разработке</h4>\n        </desktop>\n        <orders if="{tab == &quot;orders&quot;}"></orders>\n        <purchases if="{tab == &quot;purchases&quot;}"></purchases>\n        <products if="{tab == &quot;products&quot;}"></products>\n        <payments if="{tab == &quot;payments&quot;}"></payments>\n        <persons if="{tab == &quot;persons&quot;}"></persons>\n        <news if="{tab == &quot;news&quot;}"></news>\n        <user-reviews if="{tab == &quot;reviews&quot;}"></user-reviews>\n        <images if="{tab == &quot;images&quot;}"></images>\n        <sections if="{tab == &quot;sections&quot;}"></sections>\n        <analytics if="{tab == &quot;analytics&quot;}"></analytics>\n        <settings if="{tab == &quot;settings&quot;}"></settings>\n        <not-found if="{tab == &quot;not-found&quot;}"></not-found>\n      </div>\n    </div>\n  </div>\n', 'app .app-layout,[riot-tag="app"] .app-layout,[data-is="app"] .app-layout{ position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: #000; opacity: 0.7; z-index: 1100; } app .menu-item,[riot-tag="app"] .menu-item,[data-is="app"] .menu-item{ position: relative; } app .notice-count,[riot-tag="app"] .notice-count,[data-is="app"] .notice-count{ background: #d9534f; position: absolute; right: 0; top: 0; min-width: 16px; height: 16px; font-size: 11px; padding: 2px; white-space: nowrap; text-align: center; color: #fff; }', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.app = app;
	    self.mixin('permissions');
	    self.auth = false;
	    self.sidebarShow = false;
	    self.loader = true;
	    self.auth = app.auth;
	    self.imageLoad = false;
	
	    var route = riot.route.create();
	
	    route(function (tab) {
	        if (tab == '') {
	            if (self.checkPermission(self.sidebar[1].permission, "1000")) {
	                riot.route(self.sidebar[1].link);
	            } else {
	                var links = self.sidebar.filter(function (i) {
	                    return self.checkPermission(i.permission, "1000");
	                });
	                if (links.length) {
	                    riot.route(links[0].link);
	                } else {
	                    riot.route('');
	                    observable.trigger('not-found');
	                }
	            }
	        } else {
	            if (tab == 'imageLoad') {
	                self.imageLoad = true;
	                self.update();
	                return;
	            }
	            var idx = self.sidebar.map(function (item) {
	                return item.name;
	            }).indexOf(tab);
	            if (idx !== -1 && self.checkPermission(self.sidebar[idx].permission, 1000)) {
	                var item = self.sidebar.filter(function (item) {
	                    return item.name === tab;
	                });
	                self.headTitle = item[0].title;
	                self.tab = tab;
	            } else {
	                observable.trigger('not-found');
	            }
	        }
	        self.sidebarShow = false;
	        document.body.classList.remove('modal-open');
	        window.scrollTo(0, 0);
	        self.update();
	    });
	
	    self.unsupported = app.checkUnsupported();
	
	    self.sidebar = [{ title: 'Аналитика', name: 'analytics', link: 'analytics', permission: '', icon: 'fa-area-chart ' }, { title: 'Заказы', name: 'orders', link: 'orders', permission: 'orders', icon: 'fa-shopping-cart', notice: true }, { title: 'Закупки', name: 'purchases', link: 'purchases', permission: 'purchases', icon: 'fa-shopping-basket' }, { title: 'Товары', name: 'products', link: 'products', permission: 'products', icon: 'fa-shopping-bag' }, { title: 'Платежи', name: 'payments', link: 'payments', permission: 'payments', icon: 'fa-money' }, { title: 'Контакты', name: 'persons', link: 'persons', permission: 'contacts', icon: 'fa-users' }, { title: 'Публикации', name: 'news', link: 'news', permission: 'news', icon: 'fa-newspaper-o' }, { title: 'Отзывы', name: 'reviews', link: 'reviews', permission: 'reviews', icon: 'fa-comment-o' }, { title: 'Разделы', name: 'sections', link: 'sections', permission: 'sections', icon: 'fa-file-text' }, { title: 'Картинки', name: 'images', link: 'images/products', permission: 'images', icon: 'fa-picture-o' }, { title: 'Настройки', name: 'settings', link: 'settings', permission: 'settings', icon: 'fa-cogs' }];
	
	    self.toggleSidebar = function () {
	        self.sidebarShow = !self.sidebarShow;
	        if (self.sidebarShow) document.body.classList.add('modal-open');else document.body.classList.remove('modal-open');
	    };
	
	    self.logout = function () {
	        localStorage.removeItem('shop24');
	        localStorage.removeItem('shop24_permissions');
	        localStorage.removeItem('shop24_cookie');
	        localStorage.removeItem('shop24_user');
	        localStorage.removeItem('shop24_main_user');
	        window.location.reload();
	    };
	
	    self.getActiveAccount = function () {
	        var shop = JSON.parse(localStorage.getItem('shop24') || '{}');
	        if ('login' in shop) {
	            (function () {
	                var login = shop.login;
	
	                var item = app.accounts.filter(function (item) {
	                    return item.login === login;
	                })[0] || {};
	                if ('login' in item) self.activeLogin = item.login;
	            })();
	        }
	    };
	
	    observable.on('auth', function (auth) {
	        if (auth) self.getActiveAccount();
	        self.loader = false;
	        self.update();
	    });
	
	    observable.on('not-found', function () {
	        self.headTitle = '404';
	        self.tab = 'not-found';
	        self.update();
	    });
	
	    self.onResize = function (e) {
	        var menuWrapper = self.root.querySelector('.menu');
	        var menuUp = menuWrapper.querySelector('.menu__up');
	        var menuDown = menuWrapper.querySelector('.menu__down');
	        var menu = menuWrapper.querySelector('ul');
	
	        if (menu.scrollTopMax === 0) {
	            menuUp.style.display = 'none';
	            menuDown.style.display = 'none';
	        } else {
	            if (menu.scrollTop === 0) {
	                menuUp.style.display = 'none';
	                menuDown.style.display = 'block';
	            }
	
	            if (menu.scrollTop === menu.scrollTopMax) {
	                menuUp.style.display = 'block';
	                menuDown.style.display = 'none';
	            }
	
	            if (menu.scrollTop !== 0 && menu.scrollTop !== menu.scrollTopMax) {
	                menuUp.style.display = 'block';
	                menuDown.style.display = 'block';
	            }
	        }
	    };
	
	    self.scrollMenuTop = function (e) {
	        $(self.root).find('.menu ul').animate({ scrollTop: 0 }, '300');
	    };
	
	    self.scrollMenuBottom = function (e) {
	        var menu = $(self.root).find('.menu ul')[0];
	        var scroll = menu.scrollTopMax;
	        $(menu).animate({ scrollTop: scroll }, '300');
	    };
	
	    self.parseGetParams = function () {
	        var $_GET = {};
	        var __GET = window.location.search.substring(1).split("&");
	        for (var i = 0; i < __GET.length; i++) {
	            var getVar = __GET[i].split("=");
	            $_GET[getVar[0]] = typeof getVar[1] == "undefined" ? "" : getVar[1];
	        }
	        return $_GET;
	    };
	
	    self.on('mount', function () {
	        var params = self.parseGetParams();
	        if (params.project && params.login && params.password) {
	            localStorage.removeItem('shop24_cookie');
	            app.login({
	                project: params.project.trim(),
	                serial: params.login.trim(),
	                password: (0, _md5Min2.default)(params.password.trim()),
	                success: function success(response, secookie) {
	                    var mainUser = {
	                        project: params.project.trim(),
	                        login: params.login.trim(),
	                        hash: (0, _md5Min2.default)(params.password.trim())
	                    };
	
	                    localStorage.setItem('shop24_main_user', (0, _stringify2.default)(mainUser));
	                    localStorage.setItem('shop24_cookie', secookie);
	                    localStorage.setItem('shop24', (0, _stringify2.default)(response.config));
	                    if (response.permissions) localStorage.setItem('shop24_permissions', (0, _stringify2.default)(response.permissions));
	                    location.search = '';
	                    window.location.hash = '#orders/new';
	                }
	            });
	            return;
	        }
	
	        if (localStorage.getItem('shop24_cookie') !== null) {
	            API.authCheck({
	                success: function success(response) {
	                    if (response.permissions) localStorage.setItem('shop24_permissions', (0, _stringify2.default)(response.permissions));
	
	                    app.init();
	                    riot.route.start(true);
	                },
	                error: function error(response, xhr) {
	                    // ✅ если реально 401 — принудительно показываем логин
	                    if (xhr && xhr.status === 401) {
	                        localStorage.removeItem('shop24');
	                        localStorage.removeItem('shop24_permissions');
	                        localStorage.removeItem('shop24_cookie');
	                        localStorage.removeItem('shop24_user');
	                        localStorage.removeItem('shop24_main_user');
	
	                        app.auth = false;
	                        observable.trigger('auth', false);
	                        riot.route.start(true);
	                        return;
	                    }
	
	                    // иначе оставляем старую логику (восстановление/инициализация)
	                    var user = localStorage.getItem('shop24_user');
	                    if (user) {
	                        app.restoreSession(user);
	                    } else {
	                        app.init();
	                        riot.route.start(true);
	                    }
	                }
	            });
	        } else {
	            app.init();
	            riot.route.start(true);
	        }
	
	        window.addEventListener('resize', self.onResize);
	
	        self.on('unmount', function () {
	            window.removeEventListener('resize', self.onResize);
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(5), __webpack_require__(16), __webpack_require__(4)))

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('catalog-tree-check', '  <div class="row panel-option" if="{!hidePanel}">\n    <div class="col-md-8 col-sm-6 col-xs-12">\n      <div class="form-inline m-b-2">\n        <button class="btn btn-primary" if="{opts.add}" onclick="{opts.add}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n        <button class="btn btn-success" if="{opts.reload}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n        <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n        <yield from="head"></yield>\n      </div>\n    </div>\n    <div class="col-md-4 col-sm-6 col-xs-12">\n      <form class="form-inline text-right m-b-2">\n        <div class="form-group">\n          <div class="input-group" if="{opts.search}">\n            <input class="form-control" name="search" type="text" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <treeview-check nodes="{nodes}" handlers="{opts.handlers}" label-field="{opts.labelField}" children-field="{opts.childrenField}" loader="{loader}" descendants="{opts.descendants}" dblclick="{opts.dblclick}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treeview-check>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.nodes = [];
	    self.selectedCount = 0;
	    self.handlers = opts.handlers;
	
	    self.reload = function () {
	        self.trigger('reload');
	        self.loader = true;
	        self.update();
	
	        var params = {};
	        params.isTree = true;
	
	        if (opts.search && self.search) {
	            params.searchText = self.search.value;
	        }
	
	        API.request({
	            object: opts.object,
	            method: 'Fetch',
	            data: params,
	            success: function success(response) {
	                self.nodes = response.items;
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	    self.getSelectedNodes = function (e) {
	        return self.tags['treeview-check'].getSelectedNodes();
	    };
	    self.remove = function (e) {
	        var _this = _this2;
	
	        var items = self.tags['treeview-check'].getSelectedNodes();
	        var itemsToRemove = items.map(function (i) {
	            return i.id;
	        });
	
	        if (opts.remove) opts.remove.bind(_this2, e, itemsToRemove, self)();
	    };
	
	    self.afterRemove = function () {
	        self.tags.treeview.removeNodes();
	        self.update();
	    };
	
	    self.find = (0, _debounce2.default)(function (e) {
	        self.reload();
	    }, 400);
	
	    self.on('mount', function () {
	        self.reload();
	    });
	
	    self.on('update', function () {
	        if (opts.hidePanel) {
	            self.hidePanel = opts.hidePanel;
	        } else {
	            self.hidePanel = true;
	        }
	        self.handlers = opts.handlers;
	    });
	
	    self.one('updated', function () {
	        self.tags['treeview-check'].on('nodeselect', function (item, count) {
	            self.selectedCount = count;
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(352);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('catalog-tree', '  <div class="row" if="{opts.add || opts.reload || opts.remove || opts.search}">\n    <div class="col-md-8 col-sm-6 col-xs-12">\n      <div class="form-inline m-b-2">\n        <button class="btn {allMode ? &quot;btn-primary&quot; : &quot;btn-default&quot;}" if="{opts.allselect &amp;&amp; (totalCount &gt; 0)}" type="button" onclick="{selectedAll}" title="{allMode ? &quot;Снять выделение&quot; : &quot;Выделить всё&quot;}"><i class="fa {allMode ? &quot;fa-toggle-on&quot; : &quot;fa-toggle-off&quot;}"></i></button>\n        <button class="btn btn-primary" if="{opts.add}" onclick="{opts.add}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n        <button class="btn btn-success" if="{opts.reload}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n        <button class="btn btn-primary" if="{opts.deselall}" onclick="{deselAll}" title="Показать все" type="button"><i class="fa fa-share"></i></button>\n        <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n        <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n        <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n        <yield from="head"></yield>\n      </div>\n    </div>\n    <div class="col-md-4 col-sm-6 col-xs-12">\n      <form class="form-inline text-right m-b-2">\n        <div class="form-group">\n          <div class="input-group" if="{opts.search}">\n            <input class="form-control" name="search" type="text" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <treeview nodes="{nodes}" handlers="{opts.handlers}" label-field="{opts.labelField}" children-field="{opts.childrenField}" loader="{loader}" descendants="{opts.descendants}" dblclick="{opts.dblclick}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treeview>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.allMode = false;
	    self.nodes = [];
	    self.selectedCount = 0;
	    self.handlers = opts.handlers;
	
	    // перезагрузить
	    self.reload = function () {
	        self.trigger('reload');
	        self.allMode = false;
	        self.loader = true;
	        self.update();
	        self.deselAll();
	
	        /** перезугрузка другого списка (удаляем группу - перезагружаем и список групп в товарах) */
	        if (opts.observableTrigger) observable.trigger(opts.observableTrigger);
	
	        var params = {};
	        params.isTree = true;
	
	        if (opts.search && self.search) {
	            params.searchText = self.search.value;
	        }
	
	        /** API.request
	         *
	         * @param str opts.object  exp:Category
	         * @param bool isTree  true-древовидный список
	         * @param str searchText  искомый текст
	         * @return array response.items  массив групп
	         */
	        API.request({
	            object: opts.object,
	            method: 'Fetch',
	            data: params,
	            success: function success(response) {
	                self.nodes = response.items;
	                if (opts.exception) {
	                    self.tags.treeview.exceptionFilter(self.nodes, opts.exception);
	                }
	                self.totalCount = response.items.length;
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    // выделить все
	    self.selectedAll = function () {
	        //self.allMode = self.tags.treeview.selectAllRows(self.allMode);
	        if (self.allMode == false) {
	            self.allMode = true;
	            self.selectedCount = self.totalCount;
	            self.tags.treeview.selectAllRows();
	        } else {
	            self.deselAll();
	        }
	
	        observable.trigger('catalog-recount', true);
	    };
	
	    // сброс выбора в списке
	    self.deselAll = function (e) {
	        self.allMode = false;
	        self.selectedCount = 0;
	        self.tags.treeview.deselectAll();
	        if (self.opts.object == 'Category') observable.trigger('products-reload', []); // перезагрузка листа товаров
	        if (self.opts.object == 'WarehouseBrand') observable.trigger('warehouse-reload', []); // перезагрузка листа товаров
	    };
	
	    self.remove = function (e) {
	        /** удалить
	         * 1 обнулить выделение элементов
	         */
	
	        var _this = _this2;
	
	        var items = self.tags.treeview.getSelectedNodes();
	        var itemsToRemove = items.map(function (i) {
	            return i.id;
	        });
	
	        if (opts.remove) opts.remove.bind(_this2, e, itemsToRemove, self)();
	
	        //self.deselAll(); //1
	    };
	
	    self.afterRemove = function () {
	        self.tags.treeview.removeNodes();
	        self.update();
	    };
	
	    self.find = (0, _debounce2.default)(function (e) {
	        self.reload();
	    }, 400);
	
	    self.on('mount', function () {
	        self.reload();
	    });
	
	    self.on('update', function () {
	        self.handlers = opts.handlers;
	        if (self.selectedCount != self.totalCount) {
	            self.allMode = false;
	        }
	    });
	
	    self.one('updated', function () {
	        self.tags.treeview.on('nodeselect', function (item, count) {
	            self.selectedCount = count;
	            if (self.selectedCount === self.totalCount) {
	                self.allMode = true;
	            }
	            self.update();
	        });
	    });
	
	    self.reorderNext = function () {
	        console.log("next");
	    };
	
	    self.reorderPrev = function () {
	        console.log("prev");
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _chart = __webpack_require__(176);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	__webpack_require__(563);
	
	__webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('chart', '  <canvas></canvas>\n', 'chart,[riot-tag="chart"],[data-is="chart"]{ display: inline-block; width: 100%; }', '', function (opts) {
	    'use strict';
	
	    var _this = this;
	
	    var self = this;
	    self.chart = null;
	
	    _chart2.default.defaults.global.responsive = true;
	
	    self.one('updated', function () {
	        drawChart();
	
	        self.on('updated', function () {
	            destroyChart();
	            drawChart();
	        });
	    });
	
	    self.on('loaded', function (c) {
	        _this.on('unmount', function () {
	            c.destroy();
	        });
	    });
	
	    var chartTypes = ['bar', 'line', 'radar', 'polar', 'pie', 'doughnut', 'funnel'];
	
	    var drawChart = function drawChart() {
	        if (!opts.data) opts.data = { labels: [], datasets: [] };
	        if (!opts.options) opts.options = {};
	
	        opts.options.animation = { duration: 0 };
	
	        var ctx = self.root.querySelector('canvas').getContext('2d');
	        self.chart = new _chart2.default(ctx, {
	            type: chartTypes.indexOf(opts.type) !== -1 ? opts.type : 'bar',
	            data: opts.data,
	            options: opts.options
	        });
	
	        self.trigger('loaded', self.chart);
	    };
	
	    var destroyChart = function destroyChart() {
	        self.chart.destroy();
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('checkbox-list-inline', '  <label class="form-check-inline" each="{items}">\n    <input class="form-check-input" data-id="{id}" type="checkbox" __checked="{isChecked}" onclick="{click}">&nbsp {name} &nbsp&nbsp\n  </label>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.click = function (e) {
	        var id = e.target.dataset.id;
	        var isChecked = e.target.checked;
	        self.items.forEach(function (item) {
	            if (item.id == id) item.isChecked = isChecked;
	        });
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.on('update', function () {
	        self.items = opts.items;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('current-time', '  <p class="navbar-text">{timer}</p>\n', '', '', function (opts) {
	    "use strict";
	
	    var self = this;
	
	    self.timer = '';
	
	    self.time = function () {
	        var options = {
	            timeZone: "Europe/Moscow",
	            year: "numeric",
	            month: "numeric",
	            day: "numeric",
	            hour: "numeric",
	            minute: "numeric",
	            second: "numeric"
	        },
	            formatter = new Intl.DateTimeFormat([], options);
	        var date_ = new Date(Date.now());
	
	        self.timer = formatter.format(date_);
	
	        self.update();
	    };
	
	    setInterval(self.time, 1000);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('modals', '\n  <div class="modal-backdrop fade {&quot;in&quot;: backdrop, &quot;hidden&quot;: !backdrop}"></div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        modals = [],
	        count = 0;
	
	    self.backdrop = false;
	    //self.backdropHidden = true
	
	    self.create = function (name, opts) {
	        var elem = document.createElement('div');
	        self.root.appendChild(elem);
	
	        var modal = riot.mount(elem, name, opts)[0];
	
	        if (modal) {
	            if (modals.length > 0) {
	                modals[modals.length - 1].modalHide();
	            } else {
	                self.backdrop = true;
	                self.update();
	            }
	
	            modal.modalUID = ++count;
	            modals.push(modal);
	
	            modal.on('shown', function () {
	                document.body.classList.add('modal-open');
	            });
	
	            modal.on('hidden', function () {
	                if (this.modalUID == count && modals.length > 0) {
	                    var m = modals.pop();
	                    m.unmount();
	                    --count;
	                    if (modals.length > 0) {
	                        modals[modals.length - 1].modalShow();
	                    } else {
	                        document.body.classList.remove('modal-open');
	                        self.backdrop = false;
	                        self.update();
	                    }
	                }
	            });
	
	            modal.modalShow();
	            return modal;
	        }
	    };
	});
	riot.tag2('bs-modal', '  <div class="modal" onclick="{!cannotBeClosed ? close : &quot;close&quot;}" tabindex="-1" riot-style="{&quot;display: block;&quot;: animationEnd, &quot;display: none;&quot;: !animationEnd};">\n    <div class="modal-dialog {modalVisible ? animation.show : animation.hide} {parent.opts.size}">\n      <div class="modal-content">\n        <div class="modal-header {parent.opts.type}">\n          <button class="close" onclick="{!cannotBeClosed ? modalHide : &quot;modalHide&quot;}" type="button"><span>&times;</span></button>\n          <yield from="title"></yield>\n        </div>\n        <div class="modal-body">\n          <yield from="body"></yield>\n        </div>\n        <div class="modal-footer">\n          <yield from="footer"></yield>\n        </div>\n      </div>\n    </div>\n  </div>\n', 'bs-modal .modal-dialog,[riot-tag="bs-modal"] .modal-dialog,[data-is="bs-modal"] .modal-dialog{ -webkit-animation-duration: .4s; animation-duration: .4s; } bs-modal .modal-default,[riot-tag="bs-modal"] .modal-default,[data-is="bs-modal"] .modal-default,bs-modal .modal-primary,[riot-tag="bs-modal"] .modal-primary,[data-is="bs-modal"] .modal-primary,bs-modal .modal-success,[riot-tag="bs-modal"] .modal-success,[data-is="bs-modal"] .modal-success,bs-modal .modal-info,[riot-tag="bs-modal"] .modal-info,[data-is="bs-modal"] .modal-info,bs-modal .modal-warning,[riot-tag="bs-modal"] .modal-warning,[data-is="bs-modal"] .modal-warning,bs-modal .modal-danger,[riot-tag="bs-modal"] .modal-danger,[data-is="bs-modal"] .modal-danger{ border-radius: 4px 4px 0 0; } bs-modal .modal-default,[riot-tag="bs-modal"] .modal-default,[data-is="bs-modal"] .modal-default{ background-color: #FFFFFF; color: #333; } bs-modal .modal-primary,[riot-tag="bs-modal"] .modal-primary,[data-is="bs-modal"] .modal-primary{ background-color: #337AB5; color: #fff; } bs-modal .modal-success,[riot-tag="bs-modal"] .modal-success,[data-is="bs-modal"] .modal-success{ background-color: #5CB85C; color: #fff; } bs-modal .modal-info,[riot-tag="bs-modal"] .modal-info,[data-is="bs-modal"] .modal-info{ background-color: #5BC0DE; color: #fff; } bs-modal .modal-warning,[riot-tag="bs-modal"] .modal-warning,[data-is="bs-modal"] .modal-warning{ background-color: #F0AD4E; color: #fff; } bs-modal .modal-danger,[riot-tag="bs-modal"] .modal-danger,[data-is="bs-modal"] .modal-danger{ background-color: #D9534F; color: #fff; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.cannotBeClosed = false;
	    self.modalVisible = false;
	    self.animationEnd = false;
	    self.items = [];
	
	    self.animation = {
	        show: 'animated fadeInDown',
	        hide: 'animated fadeOutUp'
	    };
	
	    if (self.parent.opts.animation) {
	        self.animation = {
	            show: self.parent.opts.animation.show || 'animated fadeInDown',
	            hide: self.parent.opts.animation.hide || 'animated fadeOutUp'
	        };
	    }
	
	    //self.stopPropagation = function (e) {
	    //    e.stopPropagation()
	    //}
	
	    self.close = function (e) {
	        if (e.target == self.root.children[0]) self.modalHide();
	        return true;
	    };
	
	    self.modalHide = function () {
	        self.modalVisible = false;
	        self.parent.trigger('hide');
	        var end = function end() {
	            self.animationEnd = false;
	            self.parent.trigger('hidden');
	            this.removeEventListener('animationend', end);
	            this.removeEventListener('webkitAnimationEnd', end);
	            this.removeEventListener('oAnimationEnd', end);
	        };
	        self.root.addEventListener('animationend', end);
	        self.root.addEventListener('webkitAnimationEnd', end);
	        self.root.addEventListener('oAnimationEnd', end);
	        //self.root.addEventListener('transitionend', end)
	        self.update();
	    };
	
	    self.modalShow = function () {
	        self.parent.trigger('show');
	        self.modalVisible = true;
	        self.animationEnd = true;
	        var end = function end() {
	            self.parent.trigger('shown');
	            this.removeEventListener('animationend', end);
	            this.removeEventListener('webkitAnimationEnd', end);
	            this.removeEventListener('oAnimationEnd', end);
	        };
	        self.root.addEventListener('animationend', end);
	        self.root.addEventListener('webkitAnimationEnd', end);
	        self.root.addEventListener('oAnimationEnd', end);
	        //self.root.addEventListener('transitionend', end)
	        self.update();
	    };
	
	    if (self.parent) {
	        self.parent.modalVisible = self.modalVisible;
	        self.parent.modalHide = self.modalHide;
	        self.parent.modalShow = self.modalShow;
	    }
	});
	riot.tag2('bs-alert', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title text-center">{parent.opts.title}</div>\n    </yield>\n    <yield to="body">\n      <div class="text-center">{parent.opts.text}</div>\n    </yield>\n    <yield to="footer">\n      <div class="text-center">\n        <button class="btn {style}" each="{parent.opts.buttons}" onclick="{parent.parent.click}" type="button">{title}</button>\n      </div>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    if (!opts.animation) {
	        opts.animation = {
	            show: 'animated zoomIn',
	            hide: 'animated zoomOut'
	        };
	    }
	
	    self.callback = opts.callback || function (action) {
	        self.modalHide();
	    };
	
	    self.click = function (e) {
	        self.callback(e.item.action);
	    };
	});
	riot.tag2('bs-prompt', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title}</div>\n    </yield>\n    <yield to="body">\n      <div class="form-group">\n        <label class="control-label">{parent.opts.label}</label>\n        <input class="form-control" type="{parent.opts.inputType || &quot;text&quot;}" name="{parent.opts.inputName || &quot;name&quot;}" min="{parent.opts.min}" max="{parent.opts.max}" step="{parent.opts.step}">\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('order-person-search', '  <form class="navbar-form navbar-right" action="" onchange="{change}" onkeyup="{change}" method="POST">\n    <div class="input-group" if="{checkPermission(&quot;orders&quot;, &quot;1000&quot;)}">\n      <input class="form-control" name="orderId" min="0" placeholder="№ заказа" onkeyup="{keyUp}" value="{item.orderId &gt; 0 ? item.orderId : &quot;&quot;}" type="{\'number\'}">\n      <div class="input-group-btn">\n        <button class="btn btn-primary" type="button" onclick="{orderOpen}" __disabled="{!(item.orderId &gt; 0) || item.load}"><i class="fa fa-chevron-right"></i></button>\n      </div>\n    </div><i class="fa fa-fw"></i>\n    <div class="input-group" if="{checkPermission(&quot;contacts&quot;, &quot;1000&quot;)}">\n      <input class="form-control" name="email" placeholder="Email клиента" onkeyup="{keyUp}" value="{item.email}" type="{\'email\'}">\n      <div class="input-group-btn">\n        <button class="btn btn-primary" type="button" onclick="{personOpen}" __disabled="{!item.email || item.load}"><i class="fa fa-chevron-right" if="{!item.load}"></i><i class="fa fa-spinner fa-spin" if="{item.load}"></i></button>\n      </div>\n    </div><i class="fa fa-fw"></i>\n    <button class="btn btn-primary" if="{checkPermission(&quot;contacts&quot;, &quot;1000&quot;)}" type="button" onclick="{personSearch}"><i class="fa fa-fw fa-search"></i>Поиск</button>\n  </form>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.orderOpen = function () {
	        riot.route('/orders/' + self.item.orderId);
	    };
	
	    self.keyUp = function (e) {
	        if (e.key == 'Enter') {
	            if (e.target.name == 'orderId') self.orderOpen();
	            if (e.target.name == 'email') self.personOpen();
	        }
	    };
	
	    self.personOpen = function () {
	        self.item.load = true;
	        API.request({
	            object: 'Contact',
	            method: 'Fetch',
	            data: { "offset": 0, "limit": 1, "searchText": self.item.email, "filters": [] },
	            success: function success(response) {
	                self.item.load = '';
	                if (response.items.length) riot.route('/persons/' + response.items[0].id);
	                self.update();
	            }
	        });
	    };
	
	    self.personSearch = function () {
	        modals.create('persons-search-list-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit(e) {
	                this.modalHide();
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                if (items.length > 0) {
	                    riot.route('/persons/' + items[0].id);
	                }
	            }
	        });
	    };
	});
	riot.tag2('persons-search-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{!parent.item.orders ? ⁗Поиск контактов⁗ : ⁗Заказы пользователя ⁗ + parent.item.id}</div>\n    </yield>\n    <yield to="body">\n      <div id="person-orders" if="{parent.checkPermission(&quot;orders&quot;, &quot;1000&quot;) &amp;&amp; parent.item.orders}">\n        <div class="row">\n          <div class="col-md-12 m-b-2">\n            <button class="btn btn-default" onclick="{() =&gt; (parent.item={})}"><i class="fa fa-chevron-left"></i> Назад</button>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <datatable cols="{parent.orderCols}" rows="{parent.item.orders}" dblclick="{parent.handlers.dblclickOrder}">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell class="{handlers.orderText.colors[row.status]}" name="status">{row.status}</datatable-cell>\n              <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n              <datatable-cell name="amount"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.curr !== null && row.curr !== ⁗⁗ ? row.curr : row.titleCurr}</span></datatable-cell>\n              <datatable-cell name="note">{row.note}</datatable-cell>\n            </datatable>\n            <div class="pull-right"><strong> Суммма:</strong><strong> {currTotal.nameFront !== null && currTotal.nameFront !== ⁗⁗ ? currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.item.amountOrders || 0)}</strong><strong> {currTotal.nameFront !== null && currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : currTotal.nameFlang !== null && currTotal.nameFlang !== ⁗⁗ ? currTotal.nameFlang : currTotal.titleCurr}</strong></div>\n          </div>\n        </div>\n      </div>\n      <catalog if="{parent.checkPermission(&quot;contacts&quot;, &quot;1000&quot;) &amp;&amp; !parent.item.orders}" object="ContactSearch" cols="{parent.cols}" search="true" reload="true" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="1" handlers="{parent.handlers}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="date">{row.regDate}</datatable-cell>\n          <datatable-cell name="email">{row.email}</datatable-cell>\n          <datatable-cell name="countOrders">{row.countOrders}<i class="fa fa-fw"></i><a class="test {text-muted: row.countOrders &lt;= 0}" href="#" onclick="{handlers.showOrders}"><i class="fa fa-list"></i><i class="caret"></i></a></datatable-cell>\n          <datatable-cell name="amountOrders"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {(row.amountOrders / 1).toFixed(2)}/{(row.paidOrders / 1).toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="discount">{row.discount + 0}%</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	
	    self.mixin('permissions');
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'regDate', value: 'Регистрация' }, { name: 'email', value: 'Email' }, { name: 'countOrders', value: 'Заказов' }, { name: 'amountOrders', value: 'Сумма/оплачено' }, { name: 'discount', value: 'Скидка' }];
	
	    self.orderCols = [{ name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус заказа' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'amount', value: 'Сумма' }, { name: 'note', value: 'Примечание' }];
	
	    self.handlers = {
	        showOrders: function showOrders(e) {
	            self.item = e.item.row;
	            self.update();
	        },
	        dblclickOrder: function dblclickOrder(e) {
	            riot.route('/orders/' + e.item.row.id);
	            self.tags['bs-modal'].modalHide();
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('popups', '  <div class="popups popups-top-left" name="tl" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n  <div class="popups popups-top-right" name="tr" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n  <div class="popups popups-bottom-right" name="br" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n  <div class="popups popups-bottom-left" name="bl" riot-style="margin: {opts.margin != &quot;&quot; ? opts.margin : &quot;0&quot;};"></div>\n', 'popups .popups,[riot-tag="popups"] .popups,[data-is="popups"] .popups{ position: fixed; width: 250px; z-index: 9999; -webkit-hyphens: auto; -moz-hyphens: auto; -ms-hyphens: auto; hyphens: auto; word-wrap: break-word; } popups .popups-top-left,[riot-tag="popups"] .popups-top-left,[data-is="popups"] .popups-top-left{ top: 0; left: 0; } popups .popups-top-right,[riot-tag="popups"] .popups-top-right,[data-is="popups"] .popups-top-right{ top: 0; right: 0; } popups .popups-bottom-left,[riot-tag="popups"] .popups-bottom-left,[data-is="popups"] .popups-bottom-left{ bottom: 0; left: 0; } popups .popups-bottom-right,[riot-tag="popups"] .popups-bottom-right,[data-is="popups"] .popups-bottom-right{ bottom: 0; right: 0; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.create = function (params) {
	        if (!params) return;
	
	        var popup = document.createElement('bs-popup');
	        var position = params.position || opts.position || undefined,
	            animation = params.animation || opts.animation || undefined,
	            timeout = 5000;
	
	        if (opts.timeout !== undefined && typeof parseInt(opts.timeout) === 'number') {
	            timeout = parseInt(opts.timeout);
	        }
	        if (params.timeout !== undefined && typeof parseInt(params.timeout) === 'number') {
	            timeout = parseInt(params.timeout);
	        }
	
	        if (position && typeof position === 'string') {
	            if (position === 'top-left') self.tl.insertBefore(popup, null);
	            if (position === 'top-right') self.tr.insertBefore(popup, null);
	            if (position === 'bottom-right') self.br.insertBefore(popup, self.br.children[0]);
	            if (position === 'bottom-left') {
	                self.bl.insertBefore(popup, self.bl.children[0]);
	            }
	        } else {
	            self.tr.insertBefore(popup, null);
	        }
	
	        popup = riot.mount(popup, 'bs-popup', {
	            title: params.title,
	            text: params.text,
	            style: params.style || 'popup-primary',
	            animation: animation,
	            position: position || 'top-right'
	        })[0];
	
	        if (timeout != 0) {
	            popup.timer = setTimeout(function () {
	                popup.close();
	            }, timeout + 300);
	        }
	    };
	});
	riot.tag2('bs-popup', '  <div class="popup {opts.style} {css}" onclick="{close}">\n    <div class="h4" if="{opts.title}">{opts.title}</div>\n    <p if="{opts.text}">{opts.text}</p>\n  </div>\n', 'bs-popup .popup,[riot-tag="bs-popup"] .popup,[data-is="bs-popup"] .popup{ background-color: rgba(60, 60, 60, 0.95); padding: 6px; color: #fff; margin: 5px; z-index: 9999; border-radius: 5px; -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5); box-shadow: 0 3px 9px rgba(0, 0, 0, .5); -webkit-animation-duration: 0.3s; animation-duration: 0.3s; } bs-popup .popup-default,[riot-tag="bs-popup"] .popup-default,[data-is="bs-popup"] .popup-default{ background-color: rgba(255, 255, 255, 0.95); color: #333; border-color: #ccc; } bs-popup .popup-primary,[riot-tag="bs-popup"] .popup-primary,[data-is="bs-popup"] .popup-primary{ background-color: rgba(51, 122, 183, 0.95); color: #fff; border-color: #2e6da4; } bs-popup .popup-success,[riot-tag="bs-popup"] .popup-success,[data-is="bs-popup"] .popup-success{ background-color: rgba(92, 184, 92, 0.95); color: #fff; border-color: #4cae4c; } bs-popup .popup-info,[riot-tag="bs-popup"] .popup-info,[data-is="bs-popup"] .popup-info{ background-color: rgba(91, 192, 222, 0.95); color: #fff; border-color: #46b8da; } bs-popup .popup-warning,[riot-tag="bs-popup"] .popup-warning,[data-is="bs-popup"] .popup-warning{ background-color: rgba(240, 173, 78, 0.95); color: #fff; border-color: #eea236; } bs-popup .popup-danger,[riot-tag="bs-popup"] .popup-danger,[data-is="bs-popup"] .popup-danger{ background-color: rgba(217, 83, 79, 0.95); color: #fff; border-color: #d43f3a; } bs-popup .popup p,[riot-tag="bs-popup"] .popup p,[data-is="bs-popup"] .popup p{ margin: 0px; } bs-popup .popup .h4,[riot-tag="bs-popup"] .popup .h4,[data-is="bs-popup"] .popup .h4,bs-popup .popup .h5,[riot-tag="bs-popup"] .popup .h5,[data-is="bs-popup"] .popup .h5,bs-popup .popup .h6,[riot-tag="bs-popup"] .popup .h6,[data-is="bs-popup"] .popup .h6,bs-popup .popup h4,[riot-tag="bs-popup"] .popup h4,[data-is="bs-popup"] .popup h4,bs-popup .popup h5,[riot-tag="bs-popup"] .popup h5,[data-is="bs-popup"] .popup h5,bs-popup .popup h6,[riot-tag="bs-popup"] .popup h6,[data-is="bs-popup"] .popup h6{ margin-top: 0; }', '', function (opts) {
	    var self = this,
	        animations = ['bounce', 'slide', 'fade', 'zoom'],
	        isAnimation = animations.indexOf(opts.animation) > -1,
	        direction = opts.position.indexOf('right') > -1 ? 'Right' : 'Left',
	        css = {
	        show: isAnimation ? opts.animation + 'In' + direction + ' animated' : '',
	        hide: isAnimation ? opts.animation + 'Out' + direction + ' animated' : ''
	    };
	
	    self.css = css.show;
	
	    self.close = function () {
	        if (self.timer) clearTimeout(self.timer);
	
	        if (isAnimation) {
	            self.css = css.hide;
	            self.update();
	            setTimeout(function () {
	                self.unmount();
	            }, 300);
	        } else {
	            self.unmount();
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(332);
	
	riot.tag2('star-rating', '  <div class="star fa {size ? sizes[size] : &quot;fa-lg&quot;}{item.selected ? &quot; fa-star&quot; : &quot; fa-star-o&quot;}" each="{item, i in items}" onclick="{select}" no-reorder></div>\n', 'star-rating,[riot-tag="star-rating"],[data-is="star-rating"]{ position: relative; display: block; } star-rating.inline,[riot-tag="star-rating"].inline,[data-is="star-rating"].inline{ display: inline-block; } star-rating .star,[riot-tag="star-rating"] .star,[data-is="star-rating"] .star{ display: inline-block; white-space: nowrap; cursor: pointer; color: #ffaa00; } star-rating .star:hover,[riot-tag="star-rating"] .star:hover,[data-is="star-rating"] .star:hover{ text-shadow: 0 0 3px #885500; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.value = 0;
	
	    self.sizes = {
	        small: '',
	        normal: 'fa-lg',
	        middle: 'fa-2x',
	        large: 'fa-3x',
	        big: 'fa-4x'
	    };
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	            self.update();
	        }
	    });
	
	    self.items = [];
	
	    self.select = function (e) {
	        self.value = e.item.i + 1;
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	
	        self.trigger('selected', e.item.i);
	    };
	
	    self.on('update', function () {
	        if (opts.value) self.value = parseInt(opts.value);
	
	        if (opts.name) self.root.name = opts.name;
	
	        if (opts.size) self.size = opts.size;
	
	        self.items = [];
	
	        for (var i = 0; i < opts.count; i++) {
	            var selected = i < self.value;
	            self.items.push({ selected: selected });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('treeview-check', '  <loader if="{opts.loader}"></loader>\n  <treenodes-check if="{!opts.loader}" nodes="{nodes}" handlers="{opts.handlers}" treeview="{this}" label-field="{labelField}" children-field="{childrenField}" dblclick="{opts.dblclick}">\n    <yield to="before">\n      <yield from="before"></yield>\n    </yield>\n    <yield to="after">\n      <yield from="after"></yield>\n    </yield>\n  </treenodes-check>\n', '', '', function (opts) {
	    'use strict';
	
	    var _typeof2 = __webpack_require__(74);
	
	    var _typeof3 = _interopRequireDefault(_typeof2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.nodes = [];
	    self.labelField = opts.labelField || 'label';
	    self.childrenField = opts.childrenField || 'children';
	    self.descendants = opts.descendants || undefined;
	
	    self.toggleChildren = function (node, value) {
	        if (node[self.childrenField] && node[self.childrenField] instanceof Array) {
	            node[self.childrenField].forEach(function (item) {
	                item.__selected__ = value;
	                self.toggleChildren(item, value);
	            });
	        }
	    };
	
	    self.toggleParent = function (item) {
	        if (item.__parent__) {
	            var parent = item.__parent__;
	            if (parent instanceof Object && !(parent instanceof Array)) {
	                var selected = parent[self.childrenField].map(function (i) {
	                    return i.__selected__;
	                }).indexOf(false) <= -1;
	                parent.__selected__ = selected;
	                self.toggleParent(parent);
	            }
	        }
	    };
	
	    self.deselectAll = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                item.__selected__ = false;
	                if (item[self.childrenField]) self.deselectAll(item[self.childrenField]);
	            });
	        }
	    };
	
	    self.getSelectedNodes = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        var result = [];
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                if (item.__selected__) result.push(item);
	                if (item[self.childrenField]) {
	                    var childResult = self.getSelectedNodes(item[self.childrenField]);
	                    result = [].concat(result, childResult);
	                }
	            });
	            return result;
	        }
	        return [];
	    };
	
	    self.removeNodes = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        var result = [];
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                if (item.__selected__) {
	                    nodes.splice(nodes.indexOf(item), 1);
	                    self.removeNodes(nodes);
	                    return;
	                }
	                if (item[self.childrenField]) {
	                    self.removeNodes(item[self.childrenField]);
	                }
	            });
	        }
	    };
	
	    self.setNodes = function (nodesList) {
	        var childsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (self.nodes.length == 0) {
	            self.update();
	        }
	        if (childsList == false) {
	            self.nodes.forEach(function (node) {
	                if (nodesList.indexOf(node.id) > -1) {
	                    node.__selected__ = true;
	                    if (node.childs.length > 0) {
	                        node.childs = self.setNodes(nodesList, node.childs);
	                    }
	                }
	                if (node.childs.length > 0) {
	                    node.childs = self.setNodes(nodesList, node.childs);
	                }
	            });
	        } else {
	            childsList.forEach(function (node) {
	                if (nodesList.indexOf(node.id) > -1) {
	                    node.__selected__ = true;
	                }
	                if (node.childs.length > 0) {
	                    node.childs = self.setNodes(nodesList, node.childs);
	                }
	            });
	            return childsList;
	        }
	    };
	
	    function setParentLinks(nodes) {
	        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.nodes;
	
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                Object.defineProperty(item, '__parent__', {
	                    writable: true,
	                    configurable: true,
	                    enumerable: false,
	                    value: parent
	                });
	                if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && item[self.childrenField]) setParentLinks(item[self.childrenField], item);
	            });
	        }
	    }
	
	    self.on('update', function () {
	        self.labelField = opts.labelField || 'label';
	        self.childrenField = opts.childrenField || 'children';
	        self.descendants = opts.descendants || undefined;
	
	        if (self.nodes !== opts.nodes) {
	            self.nodes = opts.nodes || [];
	            setParentLinks(self.nodes);
	        }
	    });
	});
	riot.tag2('treenodes-check', '  <ul each="{nodes}">\n    <li>\n      <div class="treenode" title="{title}" ondblclick="{dblclick}"><span class="icon {this[parent.childrenField].length ? expanded ? css.open  : css.closed : css.leaf}" onclick="{toggleExpand}"></span>\n        <yield from="before"></yield>\n        <input type="checkbox" onclick="{select}" __checked="{__selected__ ? true : false}">&nbsp;<span class="{this[parent.childrenField].length ? &quot;&quot; : &quot;leaf&quot;}">{this[parent.labelField]}</span>\n        <yield from="after"></yield>\n      </div>\n      <treenodes-check nodes="{this[parent.childrenField]}" dblclick="{dblclick}" handler="{parent.handler}" css="{parent.css}" if="{expanded}" handlers="{handlers}" treeview="{treeview}" label-field="{labelField}" children-field="{childrenField}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treenodes-check>\n    </li>\n  </ul>\n', 'treenodes-check ul,[riot-tag="treenodes-check"] ul,[data-is="treenodes-check"] ul{ list-style: none; padding-left: 2em; margin: 0.25em 0; } treenodes-check li,[riot-tag="treenodes-check"] li,[data-is="treenodes-check"] li{ cursor: pointer; margin-top:0.3em; } treenodes-check .icon,[riot-tag="treenodes-check"] .icon,[data-is="treenodes-check"] .icon{ width: 1.1em; } treenodes-check .treenode.selected,[riot-tag="treenodes-check"] .treenode.selected,[data-is="treenodes-check"] .treenode.selected{ background-color: #d9edf7; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.treeview = opts.treeview;
	    self.labelField = opts.labelField || 'label';
	    self.childrenField = opts.childrenField || 'children';
	
	    self.nodes = opts.nodes || [];
	    //self.nodes.map(n => {
	    //    n.children = n.children || []
	    //    //n.__selected__ = false
	    //})
	
	    var doubleClick = opts.dblclick || function (e) {};
	
	    self.on('update', function () {
	        self.title = opts.title;
	        self.css = opts.css || { open: 'fa fa-fw fa-caret-down', closed: 'fa fa-fw fa-caret-right', leaf: 'fa fa-fw' };
	        self.nodes = opts.nodes || [];
	        self.handlers = opts.handlers || {};
	        self.labelField = opts.labelField || 'label';
	        self.childrenField = opts.childrenField || 'children';
	    });
	
	    self.dblclick = function (e) {
	        doubleClick(e);
	    };
	
	    self.toggleExpand = function (e) {
	        e.stopPropagation();
	        e.item.expanded = !e.item.expanded;
	    };
	
	    self.select = function (e) {
	        e.item.__selected__ = !e.item.__selected__;
	        if (!e.ctrlKey) {
	            self.treeview.toggleChildren(e.item, e.item.__selected__);
	            if (self.treeview.descendants) {
	                self.treeview.toggleParent(e.item);
	                self.treeview.update();
	            }
	        } else {
	            //self.treeview.deselectAll()
	            if (self.treeview.descendants) {
	                self.treeview.toggleChildren(e.item, e.item.__selected__);
	            }
	            self.treeview.update();
	        }
	
	        var count = self.treeview.getSelectedNodes().length;
	        self.treeview.trigger('nodeselect', e.item, count);
	    };
	
	    self.stopPropagation = function (e) {
	        e.stopPropagation();
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('treeview', '  <loader if="{opts.loader}"></loader>\n  <treenodes if="{!opts.loader}" nodes="{nodes}" handlers="{opts.handlers}" treeview="{this}" label-field="{labelField}" children-field="{childrenField}" dblclick="{opts.dblclick}">\n    <yield to="before">\n      <yield from="before"></yield>\n    </yield>\n    <yield to="after">\n      <yield from="after"></yield>\n    </yield>\n  </treenodes>\n', '', '', function (opts) {
	    'use strict';
	
	    var _typeof2 = __webpack_require__(74);
	
	    var _typeof3 = _interopRequireDefault(_typeof2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.nodes = [];
	    self.labelField = opts.labelField || 'label';
	    self.childrenField = opts.childrenField || 'children';
	    self.descendants = opts.descendants || undefined;
	
	    self.toggleChildren = function (node, value) {
	        if (node[self.childrenField] && node[self.childrenField] instanceof Array) {
	            node[self.childrenField].forEach(function (item) {
	                item.__selected__ = value;
	                self.toggleChildren(item, value);
	            });
	        }
	    };
	
	    self.toggleParent = function (item) {
	        if (item.__parent__) {
	            var parent = item.__parent__;
	            if (parent instanceof Object && !(parent instanceof Array)) {
	                var selected = parent[self.childrenField].map(function (i) {
	                    return i.__selected__;
	                }).indexOf(false) <= -1;
	                parent.__selected__ = selected;
	                self.toggleParent(parent);
	            }
	        }
	    };
	
	    self.deselectAll = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                item.__selected__ = false;
	                if (item[self.childrenField]) self.deselectAll(item[self.childrenField]);
	            });
	        }
	    };
	
	    /** Выделить все
	     * Запускает рекурсивную функцию для выделения элементов всех уровней
	     *
	     * @param array nodes  нумерованный массив с информацией об элементах
	     */
	    self.selectAllRows = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        selectAllRowsChildren(nodes);
	    };
	
	    /** Исключить из списка
	     *
	     * @param array nodes  нумерованный массив с информацией об элементах
	     * @param str exception id редактируемой группы для исключения из списка
	     */
	    self.exceptionFilter = function (nodes, exception) {
	        exceptionFilter(nodes, exception);
	    };
	
	    self.getSelectedNodes = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        var result = [];
	
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                if (item.__selected__) result.push(item);
	                if (item[self.childrenField]) {
	                    var childResult = self.getSelectedNodes(item[self.childrenField]);
	                    result = [].concat(result, childResult);
	                }
	            });
	            return result;
	        }
	        return [];
	    };
	
	    self.removeNodes = function () {
	        var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;
	
	        var result = [];
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                if (item.__selected__) {
	                    nodes.splice(nodes.indexOf(item), 1);
	                    self.removeNodes(nodes);
	                    return;
	                }
	                if (item[self.childrenField]) {
	                    self.removeNodes(item[self.childrenField]);
	                }
	            });
	        }
	    };
	
	    /** Рекурсивная функция выделения всех строк в древовидном списке (включая детей)
	     *
	     * @param array nodes  нумерованный массив с информацией об элементах
	     * @var array item["childs"] нумерованный массив с информацией о Дочерних элементах
	     */
	    function selectAllRowsChildren(nodes) {
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                if (item["childs"] && item["childs"].length > 0) {
	                    selectAllRowsChildren(item["childs"]);
	                }
	                item.__selected__ = true;
	            });
	        }
	    }
	
	    /** Рекурсия исключения из древовидного списка
	     * 1 запускаем цикл прохода по уровню
	     * 2 если id совпадает с исключением - удаляем из массива, заканчиваем поиск
	     * 3 если исключение не сработало и есть элементы-дети - запускаем проверку уровня ниже
	     * 4 если исключение встретилось в нижних уровнях и вернулось true - заканчиваем поиск
	     *
	     * @param array nodes  нумерованный массив с информацией об элементах
	     * @param str exception id редактируемой группы для исключения из списка
	     * @return bool true - исключение найденно
	     */
	    function exceptionFilter(nodes, exception) {
	        if (nodes instanceof Array) {
	            // 1
	            nodes.forEach(function (item, index, object) {
	                if (item["id"] == exception) {
	                    // 2
	                    object.splice(index, 1);
	                    return true;
	                }
	                if (item["childs"].length > 0) {
	                    // 3
	                    var stop = exceptionFilter(item["childs"], exception);
	                    if (stop == true) return true; // 4
	                }
	            });
	        }
	    }
	
	    function setParentLinks(nodes) {
	        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.nodes;
	
	        if (nodes instanceof Array) {
	            nodes.forEach(function (item) {
	                Object.defineProperty(item, '__parent__', {
	                    writable: true,
	                    configurable: true,
	                    enumerable: false,
	                    value: parent
	                });
	                if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && item[self.childrenField]) setParentLinks(item[self.childrenField], item);
	            });
	        }
	    }
	
	    self.on('update', function () {
	        self.labelField = opts.labelField || 'label';
	        self.childrenField = opts.childrenField || 'children';
	        self.descendants = opts.descendants || undefined;
	
	        if (self.nodes !== opts.nodes) {
	            self.nodes = opts.nodes || [];
	            setParentLinks(self.nodes);
	        }
	    });
	});
	riot.tag2('treenodes', '  <ul each="{nodes}">\n    <li>\n      <div class="treenode{__selected__ ? &quot; selected&quot; : &quot;&quot;}" title="{title}" onclick="{select}" ondblclick="{dblclick}"><span class="icon {this[parent.childrenField].length ? expanded ? css.open  : css.closed : css.leaf}" onclick="{toggleExpand}"></span>\n        <yield from="before"></yield><span class="{this[parent.childrenField].length ? &quot;&quot; : &quot;leaf&quot;}" draggable="true" ondragstart="{handleDragStart}" ondragenter="{handleDragEnter}" ondragover="{handleDragOver}" ondragleave="{handleDragLeave}" ondrop="{handleDrop}" ondragend="{handleDragEnd}">{this[parent.labelField]}</span>\n        <yield from="after"></yield>\n      </div>\n      <hr class="drop" ondragenter="{handleDragEnterHr}" ondragleave="{handleDragLeaveHr}" ondragover="{handleDragOverHr}" ondrop="{handleDropHr}">\n      <treenodes nodes="{this[parent.childrenField]}" dblclick="{dblclick}" handler="{parent.handler}" css="{parent.css}" if="{expanded}" handlers="{handlers}" treeview="{treeview}" label-field="{labelField}" children-field="{childrenField}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treenodes>\n    </li>\n  </ul>\n', 'treenodes ul,[riot-tag="treenodes"] ul,[data-is="treenodes"] ul{ list-style: none; padding-left: 2em; margin: 0.25em 0; } treenodes li,[riot-tag="treenodes"] li,[data-is="treenodes"] li{ cursor: pointer; } treenodes .icon,[riot-tag="treenodes"] .icon,[data-is="treenodes"] .icon{ width: 1.1em; } treenodes .treenode.selected,[riot-tag="treenodes"] .treenode.selected,[data-is="treenodes"] .treenode.selected{ background-color: #d9edf7; } treenodes .treenode span.highlight,[riot-tag="treenodes"] .treenode span.highlight,[data-is="treenodes"] .treenode span.highlight{ border: 2px dashed #000; } treenodes hr.drop,[riot-tag="treenodes"] hr.drop,[data-is="treenodes"] hr.drop{ margin: 0; padding-top: 3px; padding-bottom: 3px; border: 0; border-top: 1px solid #fff; } treenodes hr.drop.highlight,[riot-tag="treenodes"] hr.drop.highlight,[data-is="treenodes"] hr.drop.highlight{ padding-top: 8px; padding-bottom: 8px; border-top: 2px solid #000; }', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    var _this = this;
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.treeview = opts.treeview;
	    self.labelField = opts.labelField || 'label';
	    self.childrenField = opts.childrenField || 'children';
	
	    self.nodes = opts.nodes || [];
	
	    var doubleClick = opts.dblclick || function (e) {};
	
	    self.on('update', function () {
	        self.title = opts.title;
	        self.css = opts.css || { open: 'fa fa-fw fa-caret-down', closed: 'fa fa-fw fa-caret-right', leaf: 'fa fa-fw' };
	        self.nodes = opts.nodes || [];
	        self.handlers = opts.handlers || {};
	        self.labelField = opts.labelField || 'label';
	        self.childrenField = opts.childrenField || 'children';
	    });
	
	    self.dblclick = function (e) {
	        doubleClick(e);
	    };
	
	    self.handleDragStart = function (e) {
	        e.target.style.opacity = 0.5;
	        e.dataTransfer.effectAllowed = 'move';
	        e.dataTransfer.setData('json', (0, _stringify2.default)(e.item));
	        return true;
	    };
	
	    self.handleDragOver = function (e) {
	        //console.log("DragOver")
	    };
	
	    self.handleDragEnterHr = function (e) {
	        e.target.classList.add('highlight');
	    };
	
	    self.handleDragLeaveHr = function (e) {
	        e.target.classList.remove('highlight');
	    };
	
	    self.handleDragOverHr = function (e) {};
	
	    self.handleDragEnter = function (e) {
	        if (e.fromElement) e.target.classList.add('highlight');
	    };
	
	    self.handleDragLeave = function (e) {
	        e.target.classList.remove('highlight');
	    };
	
	    self.handleDrop = function (e) {
	        e.target.classList.remove('highlight');
	        var dataTransfer = JSON.parse(e.dataTransfer.getData("json"));
	        if (dataTransfer.id == e.item.id) {
	            e.stopPropagation();
	            return false;
	        }
	
	        self.changeParent(self.treeview.nodes, e.item, dataTransfer.id);
	
	        e.stopPropagation();
	        return false;
	    };
	
	    self.handleDropHr = function (e) {
	        e.target.classList.remove('highlight');
	        var dataTransfer = JSON.parse(e.dataTransfer.getData("json"));
	        if (dataTransfer.id == e.item.id) {
	            e.stopPropagation();
	            return false;
	        }
	
	        if (e.item.upid != dataTransfer.upid) {
	            var itemParent = e.item.upid ? self.getItemById(self.treeview.nodes, e.item.upid) : null;
	            self.changeParent(self.treeview.nodes, itemParent, dataTransfer.id);
	        }
	
	        self.changePositionItem(e.item, dataTransfer.id);
	
	        e.stopPropagation();
	        return false;
	    };
	
	    self.handleDragEnd = function (e) {
	        e.target.style.opacity = 1;
	        self.update();
	    };
	
	    self.toggleExpand = function (e) {
	        e.stopPropagation();
	        e.item.expanded = !e.item.expanded;
	    };
	
	    self.getItemById = function (nodes, id) {
	
	        for (var i = 0; i < nodes.length; i++) {
	            if (nodes[i].id == id) return nodes[i];
	
	            if (nodes[i][self.childrenField]) {
	                var result = self.getItemById(nodes[i][self.childrenField], id);
	                if (result) return result;
	            }
	        }
	
	        return null;
	    };
	
	    self.changeParent = function (nodes, itemParent, id) {
	        var indexDel = -1;
	
	        nodes.forEach(function (item, i) {
	            if (item.id == id) {
	                indexDel = i;
	                return;
	            }
	        });
	        if (indexDel > -1) {
	            var item = nodes[indexDel];
	            nodes.splice(indexDel, 1);
	            var idParent = null;
	            var position = self.treeview.nodes.length;
	            if (itemParent) {
	                if (itemParent[self.childrenField].length > 0) position = itemParent[self.childrenField][itemParent[self.childrenField].length - 1].position + 1;
	                itemParent[self.childrenField].push(item);
	                idParent = itemParent.id;
	            } else self.treeview.nodes.push(item);
	
	            if ('afterChangeParent' in self.handlers && typeof self.handlers.afterChangeParent === 'function') self.handlers.afterChangeParent.call(_this, idParent, id, position);
	        } else {
	            nodes.forEach(function (item, i) {
	                if (item[self.childrenField]) self.changeParent(item[self.childrenField], itemParent, id);
	            });
	        }
	    };
	
	    self.changePositionItem = function (item, id) {
	        var nodes = self.getNodesWithId(self.treeview.nodes, id);
	        var indexDel = -1;
	
	        nodes.forEach(function (item, i) {
	            if (item.id == id) {
	                indexDel = i;
	                return;
	            }
	        });
	        if (indexDel > -1) {
	            var itemMove = nodes[indexDel];
	            nodes.splice(indexDel, 1);
	            nodes = self.getNodesWithId(self.treeview.nodes, item.id);
	            if (nodes) {
	                var indexInsert = nodes.indexOf(item);
	                if (indexInsert > -1) {
	                    (function () {
	                        nodes.splice(indexInsert + 1, 0, itemMove);
	                        var indexes = [];
	                        nodes.forEach(function (item, sort) {
	                            item.sort = sort;
	                            indexes.push({ id: item.id, sort: sort });
	                        });
	                        if ('afterChangePosition' in self.handlers && typeof self.handlers.afterChangePosition === 'function') self.handlers.afterChangePosition.call(_this, indexes);
	                    })();
	                }
	            }
	        }
	    };
	
	    self.getNodesWithId = function (nodes, id) {
	
	        for (var i = 0; i < nodes.length; i++) {
	            if (nodes[i].id == id) return nodes;
	
	            if (nodes[i][self.childrenField]) {
	                var result = self.getNodesWithId(nodes[i][self.childrenField], id);
	                if (result) return result;
	            }
	        }
	
	        return null;
	    };
	
	    self.select = function (e) {
	        if (e.ctrlKey) {
	            e.item.__selected__ = !e.item.__selected__;
	            if (self.treeview.descendants) {
	                self.treeview.toggleChildren(e.item, e.item.__selected__);
	                self.treeview.toggleParent(e.item);
	                self.treeview.update();
	            }
	        } else {
	            self.treeview.deselectAll();
	            e.item.__selected__ = true;
	            if (self.treeview.descendants) {
	                self.treeview.toggleChildren(e.item, e.item.__selected__);
	            }
	            self.treeview.update();
	        }
	
	        var count = self.treeview.getSelectedNodes().length;
	        self.treeview.trigger('nodeselect', e.item, count);
	    };
	
	    self.stopPropagation = function (e) {
	        e.stopPropagation();
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('add-link-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{title}</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Адрес ссылки</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.title = opts.title || 'Добавить';
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('export-persons-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Экспорт</div>\n    </yield>\n    <yield to="body">\n      <loader text="Экспорт" indeterminate="true" if="{loader}"></loader>\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">От даты</label>\n              <datetime-picker class="form-control date-picker" name="dateFrom" data-sign="&gt;=" format="YYYY-MM-DD" value="{item.dateFrom}"></datetime-picker>\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">До даты</label>\n              <datetime-picker class="form-control date-picker" name="dateTo" data-sign="&gt;=" format="YYYY-MM-DD" value="{item.dateTo}"></datetime-picker>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" id="startImp" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}">Экспорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.loader = true;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.error = false;
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.item = {
	            dateFrom: '',
	            dateTo: ''
	        };
	
	        modal.loader = false;
	
	        modal.clear = function () {
	            modal.item.dateFrom = '';
	            modal.item.dateTo = '';
	        };
	    });
	
	    self.submit = function () {
	        var modal = self.tags['bs-modal'];
	        modal.loader = true;
	
	        API.request({
	            object: 'Contact',
	            method: 'Export',
	            data: modal.item,
	            success: function success(response) {
	                var a = document.createElement('a');
	                a.href = response.url;
	                a.download = response.name;
	                document.body.appendChild(a);
	                a.click();
	                a.remove();
	                modal.modalHide();
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('export-products-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Экспорт</div>\n    </yield>\n    <yield to="body">\n      <div id="myProgress" style="width: 100%; background-color: #ccc;" if="{loader}">\n        <div id="myBar" style="width: 0%; height: 30px; background-color: #0782C1; text-align: center; line-height: 30px; color: white;">0%</div>\n      </div>\n      <form onchange="{change}" onkeyup="{change}" if="{!loader}">\n\n        <div class="container-fluid">\n          <table class="table table table">\n            <thead>\n              <tr>\n                <th>#</th>\n                <th>Тип</th>\n                <th>Вставка в импорт</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr each="{i, v in units}">\n                <td>{i}</td>\n                <td style="width: 80%;">\n                  <div style="width: 180px; overflow: hidden;">{v.column || \'Пустая строка\'}</div>\n                </td>\n                <td style="width: 20%;">\n\n\n\n\n\n\n                  <input onclick="{switch}" __checked="{(v.checkbox == &quot;Y&quot;)}" type="checkbox" value="{i}">\n                </td>\n              </tr>\n            </tbody>\n          </table>\n\n\n\n\n\n\n          <div class="checkbox-inline">\n            <label>\n              <input onclick="{switchMod}" __checked="{(expModif == &quot;Y&quot;)}" type="checkbox">Экспортировать параметры\n            </label>\n          </div>\n          <div class="checkbox-inline" if="{parent.opts.idGroup}">\n            <label>\n              <input onclick="{switchGroup}" __checked="{(expGroup == &quot;Y&quot;)}" type="checkbox">Экспортировать выбранную группу\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}" if="{!loader}">Экспорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    /*
	    * ПРОГРУЗКА СТРАНИЦЫ
	    * statusPreview - параметр-светофор, при значении true, файл excel не создается
	    */
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        var data = {
	            'statusPreview': true
	        };
	        opts.idGroup = opts.idGroup || false;
	        // получение колонок из браузера и БД
	        API.request({
	            object: 'Product',
	            method: 'Export',
	            data: data,
	            success: function success(response) {
	                modal.units = {};
	                modal.columns = response['headerCSV'];
	                modal.expModif = localStorage.getItem('shop24_export_modif') || 'N';
	                modal.expGroup = localStorage.getItem('shop24_export_group') || 'N';
	                var jsonUnits = JSON.parse(localStorage.getItem('shop24_export_products') || '{}');
	                localStorage.removeItem('shop24_import_products');
	
	                // слияние данных (данные браузера в приоритете)
	                for (var i = 0; i < modal.columns.length; i++) {
	                    if (jsonUnits[i] && jsonUnits[i].column && jsonUnits[i].column == modal.columns[i]) modal.units[i] = jsonUnits[i];else modal.units[i] = {
	                        'column': modal.columns[i],
	                        'checkbox': 'Y'
	                    };
	                }
	                modal.update();
	            }
	        });
	
	        // переключатель чекбокса
	        modal.switch = function (e) {
	            var i = e.target.value;
	            if (modal.units[i].checkbox == 'Y') {
	                delete modal.units[i].checkbox;
	                modal.units[i].checkbox = 'N';
	            } else {
	                delete modal.units[i].checkbox;
	                modal.units[i].checkbox = 'Y';
	            }
	            modal.update();
	        };
	
	        // переключатель чекбокса Модификаций
	        modal.switchMod = function (e) {
	            if (modal.expModif == 'Y') modal.expModif = 'N';else modal.expModif = 'Y';
	            modal.update();
	        };
	
	        modal.switchGroup = function (e) {
	            if (modal.expGroup == 'Y') modal.expGroup = 'N';else modal.expGroup = 'Y';
	            modal.update();
	        };
	    });
	
	    // отправка
	    self.submit = function () {
	        var modal = self.tags['bs-modal'];
	        modal.loader = true;
	
	        // сохранение профиля экспорта (растановка чекбоксов)
	        var profile = (0, _stringify2.default)(modal.units);
	        localStorage.setItem('shop24_export_products', profile);
	        localStorage.setItem('shop24_export_modif', modal.expModif);
	        localStorage.setItem('shop24_export_group', modal.expGroup);
	
	        /**
	        * прикрепляем к профилю соотношения полей
	        * объявляем переменные
	        * запускаем цикл запросов к API
	        *   отправляем в API соотношения полей и страницу
	        *     в циклах формируются временные файлы на сервере
	        *     возвращается колво страниц
	        *   если страница == общему колву страниц
	        *     загружаем файл
	        *     закрываем всплывающее окно, обновляем страницу
	        *     выходим из цикла
	        */
	
	        var cycleNum = 0;
	        var pages = null;
	        var units = modal.units;
	        var expModif = modal.expModif;
	
	        var idGroup = 0;
	        var params = [];
	        if (opts.idGroup && modal.expGroup == 'Y') {
	            idGroup = opts.idGroup;
	        }
	        params = opts.params;
	
	        //console.log(opts.idGroup, modal.expGroup, idGroup);
	        function repReq(pages, cycleNum, units, expModif, idGroup, params) {
	
	            var data = {
	                'cycleNum': cycleNum,
	                'columns': units,
	                'expModif': expModif,
	                'idGroup': idGroup,
	                'params': params
	            };
	            API.request({
	                object: 'Product',
	                method: 'Export',
	                data: data,
	                success: function success(response) {
	                    pages = response.pages;
	
	                    // прогресс-бар
	                    var elem = document.getElementById("myBar");
	                    var width = (cycleNum + 1) / pages * 100;
	                    elem.style.width = width + '%';
	                    elem.innerHTML = Math.round(width) * 1 + '%';
	
	                    if (cycleNum != pages - 1) {
	                        // переход в следующий цикл
	                        cycleNum = cycleNum + 1; // подгружаем следующую страницу
	                        return repReq(pages, cycleNum, units, expModif, idGroup, params);
	                    } else {
	                        // закрытие / обновление / выход из цикла
	                        var a = document.createElement('a');
	                        a.href = response.url;
	                        a.download = response.name;
	                        document.body.appendChild(a);
	                        a.click();
	                        a.remove();
	                        modal.modalHide();
	                        //observable.trigger('products-reload')
	                        //observable.trigger('categories-reload')
	                        //observable.trigger('special-reload')
	                        observable.trigger('products-exports-end');
	                    }
	                }
	            });
	        }
	        repReq(pages, cycleNum, units, expModif, idGroup, params);
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable, $) {'use strict';
	
	riot.tag2('import-persons-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Импорт</div>\n    </yield>\n    <yield to="body">\n      <loader text="Импорт" indeterminate="true" if="{loader}"></loader>\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.filename}">\n          <div class="input-group">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onchange="{changeFile}">\n                <input name="file" type="file" accept=".xlsx, .csv"><i class="fa fa-fw fa-folder-open text-primary"></i>\n              </div>\n            </div>\n            <input class="form-control" name="filename" value="{item.filename}" placeholder="Выберите файл или введите ссылку" __disabled="{file.files.length}">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onclick="{clear}" title="Сброс"><i class="fa fa-fw fa-close text-danger"></i></div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">Пропустить строк</label>\n              <input class="form-control" name="skip" min="0" step="1" value="{item.skip}" type="{\'number\'}">\n            </div>\n            <div class="form-group">\n              <label class="control-label">Ограничитель поля</label>\n              <input class="form-control" id="limFId" name="limiterField" value="{item.limiterField}">\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">Разделитель столбцов</label>\n              <select class="form-control" id="delimId" name="delimiter" value="{item.delimiter}">\n                <option each="{i in delimiters}" value="{i.name}" __selected="{i.name == parent.item.delimiter}" no-reorder>{i.title}</option>\n              </select>\n            </div>\n          </div>\n          <div class="help-block">{error.filename}</div>\n        </div>\n\n\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" id="startImp" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}">Импорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	    self.loader = true;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        /** ... разделителителя столбцов **/
	        modal.delimiters = [{ name: 'auto', title: 'Автоопределение' }, { name: ';', title: 'Точка с запятой' }, { name: ',', title: 'Запятая' }, { name: '\t', title: 'Табуляция' }];
	
	        /** ... ключевое поле */
	        modal.keyFields = [{ name: 'article', title: 'Артикул' }, { name: 'id', title: 'Идентификатор' }, { name: 'code', title: 'Код (URL)' }, { name: 'name', title: 'Наименование' }];
	
	        /** значния по умолчанию */
	        modal.error = false;
	        modal.mixin('validation');
	        modal.mixin('change');
	        var limiterFieldValue = '"';
	        var skipValue = 1;
	
	        modal.item = {
	            filename: '',
	            type: '0',
	            reset: false,
	            limiterField: limiterFieldValue,
	            skip: skipValue,
	            delimiter: modal.delimiters[0]['name']
	        };
	
	        modal.rules = {
	            filename: {
	                required: true,
	                rules: [{
	                    type: 'url',
	                    prompt: 'Выберите файл или введите правильную ссылку'
	                }]
	            }
	        };
	        self.blockImportButtonReload(modal.item.filename);
	
	        modal.loader = false;
	        modal.changeFile = function (e) {
	            modal.item.filename = e.target.files[0].name;
	            modal.update();
	
	            /** блокировка полей для не CSV */
	            if (modal.item.filename.indexOf(".csv") + 1 != 0) {
	                document.getElementById("delimId").disabled = false;
	                document.getElementById("limFId").disabled = false;
	            } else {
	                document.getElementById("delimId").disabled = true;
	                document.getElementById("limFId").disabled = true;
	            }
	
	            self.blockImportButtonReload(modal.item.filename);
	        };
	
	        modal.clear = function () {
	            modal.item.filename = '';
	            modal.item.file = '';
	            modal.file.value = '';
	            self.blockImportButtonReload(modal.item.filename);
	        };
	
	        /** после изменения */
	        modal.afterChange = function (e) {
	            if (modal.file.files && !modal.file.files.length) {
	                var name = e.target.name;
	                delete modal.error[name];
	                modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	            }
	
	            if (modal.file.files && modal.file.files.length) modal.error = false;
	
	            if (modal.item && modal.item.type == 0) modal.item.reset = false;
	
	            delete modal.item.file;
	        };
	    });
	
	    self.blockImportButtonReload = function (filename) {
	        /**
	         * блокировка/разб.. кнопки импорта
	         * @param {string} filename  имя выбранного файла
	         * @param {bool}   startImp  id кнопки импорта
	         */
	        if (filename == '' || filename == undefined) document.getElementById("startImp").disabled = true;else document.getElementById("startImp").disabled = false;
	    }; // блокировка/разб.. импорта
	
	    self.submit = function () {
	        var modal = self.tags['bs-modal'];
	        var target = modal.file;
	        modal.loader = true;
	
	        /**
	         * ЗАГРУЗИТЬ
	         * данные уходят в Product.php post
	         * по файлу - $items, по настройкам - $_POST
	         */
	
	        /** прикрепляем к отправке параметры */
	        var formData = new FormData();
	        for (var i = 0; i < target.files.length; i++) {
	            formData.append('file' + i, target.files[i], target.files[i].name);
	        }
	        formData.append('delimiter', modal.item.delimiter);
	        formData.append('limiterField', modal.item.limiterField);
	        formData.append('skip', parseInt(modal.item.skip));
	        API.upload({
	            object: 'Contact',
	            data: formData,
	            success: function success(response) {
	                self.update();
	                observable.trigger('persons-reload');
	                modal.modalHide();
	            }
	        });
	        $("#importFile").val(undefined);
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(16)))

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('import-products-modal-continue', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Импорт (Шаг 2 из 2)</div>\n    </yield>\n    <yield to="body">\n\n      <div id="myProgress" style="width: 100%; background-color: #ccc;" if="{loader}">\n        <div id="myBar" style="width: 0%; height: 30px; background-color: #0782C1; text-align: center; line-height: 30px; color: white;">0%</div>\n      </div>\n      <div id="terminalImp" style="width: 100%; margin-top: 20px; color: orange;" if="{loader}"></div>\n      <form onchange="{change}" onkeyup="{change}" if="{!loader}">\n\n        <div class="container-fluid">\n          <table class="table table table">\n            <thead>\n              <tr>\n                <th>#</th>\n                <th>Пример</th>\n                <th>Мод.</th>\n                <th>Тип</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr id="tbody" each="{category, i in item[0]}">\n                <td>{i}</td>\n                <td style="width: 55%;">\n                  <div style="width: 180px; overflow: hidden;">{item[1][i] || \'Пустая строка\'}</div>\n                </td>\n                <td>\n                  <div id="mod{i}" style="width: 100%;"></div>\n                </td>\n                <td style="width: 35%;">\n                  <select class="form-control" id="tbody{i}" onchange="{changeitem}" name="{category}">\n                    <option value="{i}:undefined:undefined"></option>\n                    <option each="{russian, english in item[2]}" __selected="{item[0][i] == russian}" value="{i}:{russian}:{english}" no-reorder>{russian}</option>\n                  </select>\n\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Тип импорта</label><br>\n          <label class="radio-inline">\n            <input type="radio" name="type" value="0" __checked="{item.type == 0}">Обновление\n          </label>\n          <label class="radio-inline">\n            <input type="radio" name="type" value="1" __checked="{item.type == 1}">Вставка\n          </label>\n        </div>\n        <div class="form-group" if="{item.type == 1}">\n          <div class="checkbox-inline">\n            <label>\n              <input name="reset" type="checkbox" __checked="{item.reset}" onchange="{resetCheckbox}">Очистить базу данных перед импортом\n            </label>\n          </div>\n        </div>\n      </form>\n      <div id="errorLabel" style="width: 100%; margin-top: 0px; color: #a94442;" if="{!loader}"></div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" id="startImp" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}" if="{!loader}">Импорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	    var items = JSON.parse(localStorage.getItem('shop24_import_products') || '{}');
	    localStorage.removeItem('shop24_import_products');
	
	    self.item = items.prepare;
	    self.coincidence = false;
	
	    /** проверка наличия соотношений в профиле и замена (при положительном результате) */
	    var profiles = JSON.parse(localStorage.getItem("profiles"));
	
	    if (profiles[profiles['groupNow']]['margins'] != undefined) {
	        var tmpprofile = profiles[profiles['groupNow']]['margins'];
	        if (tmpprofile.length == self.item[0].length) {
	            self.item[0] = tmpprofile;
	        }
	    }
	
	    self.on('mount', function () {
	
	        /**
	         * прогрузка страницы
	         * @metod {bool} comparisonValues - сверяет значения в таблице, при совпадении подсвечивает и блокирует кнопку импорта
	         */
	
	        var modal = self.tags['bs-modal'];
	        self.item.type = 0;
	        self.errorLabel = {};
	
	        modal.error = false;
	        modal.mixin('validation');
	        modal.mixin('change');
	        modal.item = self.item;
	
	        /** сохранение и передача пользовательских правок */
	        self.newItem = {
	            'newTitele': {},
	            'newDB': {}
	        };
	
	        self.monitoring();
	
	        modal.changeitem = function (e) {
	            /**
	             * пользовательские замены
	             * @param {array}  num_walue_db - значения строки из динамического списка
	             * @param {int}    num          - номер строки в динамическом списке
	             * @param {string} walue        - имя столбца на русском (если пустое "undefined")
	             * @param {string} db           - имя столбца на латыни (если пустое "undefined")
	             */
	
	            var num_walue_db = e.target.value.split(':');
	            var num = Number(num_walue_db[0]);
	            var walue = num_walue_db[1];
	            var db = num_walue_db[2];
	
	            self.newItem.newTitele[num] = walue;
	            self.newItem.newDB[e.target.name] = db;
	
	            self.comparisonValues();
	        }; // пользовательские замены
	
	        modal.resetCheckbox = function (e) {
	            if (self.item.reset != true) {
	                self.errorLabel.delete = 'ВНИМАНИЕ: будут удалены все данные по товарам и заказам!';
	                self.printErrorLabel();
	            } else {
	                delete self.errorLabel.delete;
	                self.printErrorLabel();
	            }
	        }; // Очистить базу данных
	    }); // прогрузка страницы
	
	    self.monitoring = function () {
	        if (document.getElementById('tbody')) {
	            self.comparisonValues();
	        } else {
	            setTimeout(function () {
	                self.monitoring();
	            }, 100);
	        }
	    }; // ожидание, прослушивание элемента
	
	    self.comparisonValues = function () {
	
	        /**
	         * сверка значений - проверка отсутствия совпадений и наличия ключевого поля
	         * @param {array}  currentItem  - массив значений в интерфейсе
	         * @param {str}    errorLabel   - строка ошибок для вывода на панель
	         * @param {bool}   coincidence  - true найдено совпадение
	         * @param {bool}   keyField     - false не найдено ключевое поле
	         */
	
	        var currentItem = {};
	        for (var i = 0; i < self.item[0].length; i++) {
	            if (i in self.newItem.newTitele) currentItem[i] = self.newItem.newTitele[i];else currentItem[i] = self.item[0][i];
	        }
	
	        /** проверка совпадений - обнаруженные подсветить, не обнаруженные погасить */
	        self.coincidence = false;
	        self.keyField = false;
	        for (var k1 in currentItem) {
	            /** проверка совпадений */
	            var coinUnit = false;
	            for (var k2 in currentItem) {
	                if (currentItem[k1] == currentItem[k2] && k1 != k2 && currentItem[k1] != 'undefined') {
	                    document.getElementById("tbody" + k1).style.borderColor = "#a94442";
	                    coinUnit = true;
	                    self.coincidence = true;
	                    break;
	                }
	            }
	            if (coinUnit == false) document.getElementById("tbody" + k1).style.borderColor = "#ccc";
	
	            /** проверка наличия ключ-поля */
	            if (currentItem[k1] == 'Код (URL)' || currentItem[k1] == 'Наименование') self.keyField = true;
	
	            /** подсветка полей модификаций */
	            if (currentItem[k1].indexOf("#") + 1 != 0) document.getElementById("mod" + k1).innerHTML = "мод.";else document.getElementById("mod" + k1).innerHTML = "";
	        }
	
	        if (self.coincidence == true) self.errorLabel.comparison = 'ОШИБКА: совпадающие названия столбцов';else if (self.errorLabel.comparison) delete self.errorLabel.comparison;
	        if (self.keyField == false) self.errorLabel.key = 'ОШИБКА: не выбранно ключевое поле "Ид."';else if (self.errorLabel.key) delete self.errorLabel.key;
	
	        if (self.errorLabel.comparison || self.errorLabel.key) document.getElementById("startImp").disabled = true;else document.getElementById("startImp").disabled = false;
	        self.printErrorLabel();
	
	        return true;
	    }; // сверка значений
	
	    self.printErrorLabel = function () {
	        var errors = '';
	        for (var kError in self.errorLabel) {
	            errors += self.errorLabel[kError] + '<br/>';
	        }document.getElementById("errorLabel").innerHTML = errors;
	    }; // вывод сообщений в консоль паканели импорта
	
	    self.submit = function () {
	
	        /**
	         * отправка
	         *
	         * @param {bool} last - true: последний цикл
	         */
	
	        var modal = self.tags['bs-modal'];
	        modal.loader = true;
	        /** замена на пользовательские значения */
	        for (var index in self.newItem.newTitele) {
	            self.item[0][index] = self.newItem.newTitele[index];
	        }for (var index in self.newItem.newDB) {
	            self.item[2][index] = self.newItem.newDB[index];
	        }items.prepare = self.item;
	
	        if (self.item.type) items.type = self.item.type;
	        if (self.item.reset) items.reset = self.item.reset;
	
	        items.last = false;
	
	        if (self.item.type > -1 && self.item.type < 2) {
	            var profiles;
	            var serialProfiles;
	            var cycleNum;
	            var countPages;
	            var pages;
	            var errors;
	
	            (function () {
	                var repReq = function repReq(pages, cycleNum) {
	                    var data = {
	                        'cycleNum': cycleNum,
	                        'prepare': items.prepare,
	                        'type': items.type,
	                        'reset': items.reset,
	                        'filename': items.filename,
	                        'uploadProfile': items.uploadProfile,
	                        'last': items.last
	                    };
	                    API.request({
	                        object: 'Product',
	                        method: 'Import',
	                        data: data,
	                        success: function success(response) {
	                            pages = response.pages;
	                            cycleNum = response.cycleNum;
	                            countPages = response.countPages;
	
	                            /** прогресс-бар */
	                            var elem = document.getElementById("myBar");
	                            var progress = (cycleNum + countPages) / 2;
	                            var width = progress / pages * 100;
	                            if (width <= 100) {
	                                elem.style.width = width + '%';
	                                elem.innerHTML = Math.round(width) * 1 + '%';
	                                //elem.innerHTML = cycleNum+'/'+pages
	                            }
	
	                            /** терминал */
	                            if (response.errors && progress >= pages) errors = response.errors + '<br/>КОНЕЦ: Импорт завершен';else if (response.errors) errors = response.errors;else if (progress > pages) errors = 'КОНЕЦ: Импорт завершен';
	                            var elemT = document.getElementById("terminalImp");
	                            elemT.innerHTML = errors;
	
	                            if (progress <= pages) {
	                                /** переход в следующий цикл */
	                                //cycleNum   = cycleNum + 1                    /** подгружаем следующую страницу */
	                                //if(cycleNum == 0) cycleNum = cycleNum + 2
	                                if (progress == pages) items.last = true;
	                                return repReq(pages, cycleNum);
	                            } else {
	                                /** закрытие / обновление / выход из цикла */
	                                //modal.modalHide() /** закрытие второго шага импорта */
	                                observable.trigger('products-reload');
	                                observable.trigger('categories-reload');
	                                observable.trigger('special-reload');
	                                // observable.trigger('products-imports-end')
	                            }
	                        }
	                    });
	                };
	
	                /** прикрепляем к профилю соотношения полей */
	                profiles = JSON.parse(localStorage.getItem("profiles"));
	
	                profiles[profiles['groupNow']]['margins'] = items.prepare[0];
	                serialProfiles = (0, _stringify2.default)(profiles);
	
	                localStorage.setItem('profiles', serialProfiles);
	
	                cycleNum = 0;
	                countPages = 0;
	                pages = null;
	                errors = '';
	
	                repReq(pages, cycleNum);
	            })();
	        }
	    }; // отправка
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('import-products-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Импорт (Шаг 1 из 2)</div>\n    </yield>\n    <yield to="body">\n      <loader text="Импорт" indeterminate="true" if="{loader}"></loader>\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.filename}">\n          <div class="input-group">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onchange="{changeFile}">\n                <input name="file" type="file" accept=".xlsx, .csv"><i class="fa fa-fw fa-folder-open text-primary"></i>\n              </div>\n            </div>\n            <input class="form-control" name="filename" value="{item.filename}" placeholder="Выберите файл или введите ссылку" __disabled="{file.files.length}">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onclick="{clear}" title="Сброс"><i class="fa fa-fw fa-close text-danger"></i></div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">Профиль загрузки</label>\n              <div class="input-group">\n                <select class="form-control" name="uploadProfile" value="{item.uploadProfile}" onchange="{uploadProfileChange}">\n                  <option each="{i in uploadProfiles}" value="{i.name}" __selected="{i.name == parent.item.uploadProfile}" no-reorder>{i.title}</option>\n                </select>\n                <div class="input-group-btn">\n                  <div class="btn-file btn btn-default" onclick="{deleteProfile}" title="Удалить выбранный профиль" placeholder="Выберите файл или введите ссылку"><i class="fa fa-fw fa-close text-danger"></i></div>\n                </div>\n              </div>\n            </div>\n\n\n\n\n\n\n\n            <div class="form-group">\n              <label class="control-label">Разделитель столбцов</label>\n              <select class="form-control" id="delimId" name="delimiter" value="{item.delimiter}">\n                <option each="{i in delimiters}" value="{i.name}" __selected="{i.name == parent.item.delimiter}" no-reorder>{i.title}</option>\n              </select>\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12">\n\n\n\n\n\n\n\n            <div class="form-group">\n              <label class="control-label">Пропустить строк</label>\n              <input class="form-control" name="skip" min="0" step="1" value="{item.skip}" type="{\'number\'}">\n            </div>\n            <div class="form-group">\n              <label class="control-label">Ограничитель поля</label>\n              <input class="form-control" id="limFId" name="limiterField" value="{item.limiterField}">\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12" if="{parent.opts.idGroup}">\n            <div class="form-group">\n              <label></label>\n              <input type="checkbox" id="inGroup" name="inGroup" __checked="{item.inGroup}">Разместить в выбранную группу\n            </div>\n          </div>\n          <div class="help-block">{error.filename}</div>\n        </div>\n\n\n      </form>\n      <div id="terminalImport" style="width: 100%; margin-top: 20px; color: #a94442;"></div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}">Продолжить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    var _keys = __webpack_require__(108);
	
	    var _keys2 = _interopRequireDefault(_keys);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	    self.loader = true;
	
	    // ВКЛ
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        // нужно получать профили из браузера
	        var profiles = JSON.parse(localStorage.getItem("profiles")); // отсутствуют - null
	
	        // поля селектора профиля загрузки,
	        // значение при отсутствии записей в браузере
	        modal.uploadProfiles = [{ name: 'profile1', title: 'Профиль 1' }];
	
	        // загружаем профили из браузера
	        if (profiles == null) {
	            var profiles = {};
	        } else {
	            modal.uploadProfiles = [];
	            for (var key in profiles) {
	                if (key != 'groupNow') {
	                    var profileUnit = { name: key, title: profiles[key]['title'] };
	                    modal.uploadProfiles.push(profileUnit);
	                }
	            }
	        }
	
	        /*// ... кодировки
	        modal.encodings = [
	            {name: 'utf-8',         title: 'UTF-8'},
	            {name: 'windows-1251',  title: 'Windows-1251'}
	        ]*/
	
	        // ... разделителителя столбцов
	        modal.delimiters = [{ name: 'auto', title: 'Автоопределение' }, { name: ';', title: 'Точка с запятой' }, { name: ',', title: 'Запятая' }, { name: '\t', title: 'Табуляция' }];
	
	        // ... ключевое поле
	        modal.keyFields = [{ name: 'article', title: 'Артикул' }, { name: 'id', title: 'Идентификатор' }, { name: 'code', title: 'Код (URL)' }, { name: 'name', title: 'Наименование' }];
	
	        // значния по умолчанию
	        modal.error = false;
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        // получаем настройки последнего профиля или по умолчанию
	        if ((0, _keys2.default)(profiles).length != 0) {
	
	            var uploadProfileValue = profiles['groupNow'];
	            if (profiles != undefined && uploadProfileValue != undefined) {
	
	                if (profiles[uploadProfileValue]['title'] != undefined) {
	                    var titleValue = profiles[uploadProfileValue]['title'];
	                } else {
	                    var titleValue = undefined;
	                }
	
	                if (profiles[uploadProfileValue]['delimiter'] != undefined) {
	                    var delimiterValue = profiles[uploadProfileValue]['delimiter'];
	                } else {
	                    var delimiterValue = modal.delimiters[0]['name'];
	                }
	
	                if (profiles[uploadProfileValue]['keyField'] != undefined) {
	                    var keyFieldValue = profiles[uploadProfileValue]['keyField'];
	                } else {
	                    var keyFieldValue = modal.keyFields[0]['name'];
	                }
	
	                if (profiles[uploadProfileValue]['limiterField'] != undefined) {
	                    var limiterFieldValue = profiles[uploadProfileValue]['limiterField'];
	                } else {
	                    var limiterFieldValue = '"';
	                }
	
	                if (profiles[uploadProfileValue]['skip'] != undefined) {
	                    var skipValue = profiles[uploadProfileValue]['skip'];
	                } else {
	                    var skipValue = 1;
	                }
	
	                if (profiles[uploadProfileValue]['margins'] != undefined) {
	                    var marginsValue = profiles[uploadProfileValue]['margins'];
	                } else {
	                    var marginsValue = undefined;
	                }
	            } else {
	                var uploadProfileValue = modal.uploadProfiles[0]['name'];
	                var titleValue = modal.uploadProfiles[0]['title'];
	                var delimiterValue = modal.delimiters[0]['name'];
	                var keyFieldValue = modal.keyFields[0]['name'];
	                var limiterFieldValue = '"';
	                var skipValue = 1;
	                var marginsValue = undefined;
	            }
	        } else {
	            var uploadProfileValue = modal.uploadProfiles[0]['name'];
	            var titleValue = modal.uploadProfiles[0]['title'];
	            var delimiterValue = modal.delimiters[0]['name'];
	            var keyFieldValue = modal.keyFields[0]['name'];
	            var limiterFieldValue = '"';
	            var skipValue = 1;
	            var marginsValue = undefined;
	        }
	
	        modal.item = {
	            filename: '',
	            type: '0',
	            reset: false,
	
	            uploadProfile: uploadProfileValue,
	            title: titleValue,
	            /*encoding      : modal.encodings[0]['name'],*/
	            delimiter: delimiterValue,
	            keyField: keyFieldValue,
	            limiterField: limiterFieldValue,
	            skip: skipValue,
	
	            margins: marginsValue
	        };
	
	        modal.rules = {
	            filename: {
	                required: true,
	                rules: [{
	                    type: 'url',
	                    prompt: 'Выберите файл или введите правильную ссылку'
	                }]
	            }
	        };
	
	        modal.loader = false;
	        modal.changeFile = function (e) {
	            modal.item.filename = e.target.files[0].name;
	            modal.update();
	
	            /** блокировка полей для не CSV */
	            if (modal.item.filename.indexOf(".csv") + 1 != 0) {
	                document.getElementById("delimId").disabled = false;
	                document.getElementById("limFId").disabled = false;
	            } else {
	                document.getElementById("delimId").disabled = true;
	                document.getElementById("limFId").disabled = true;
	            }
	        };
	
	        modal.clear = function () {
	            modal.item.filename = '';
	            modal.item.file = '';
	            modal.file.value = '';
	        };
	
	        // после изменения
	        modal.afterChange = function (e) {
	            if (modal.file.files && !modal.file.files.length) {
	                var name = e.target.name;
	                delete modal.error[name];
	                modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	            }
	
	            if (modal.file.files && modal.file.files.length) modal.error = false;
	
	            if (modal.item && modal.item.type == 0) modal.item.reset = false;
	
	            delete modal.item.file;
	        };
	
	        // загрузка измененного профиля
	        modal.uploadProfileChange = function (e) {
	            var prof = JSON.parse(localStorage.getItem("profiles"));
	            if (prof != null) profiles = prof;
	
	            // parseInt()
	            modal.item.uploadProfile = e.target.value;
	            modal.item.title = profiles[modal.item.uploadProfile]['title'];
	            modal.item.delimiter = profiles[modal.item.uploadProfile]['delimiter'];
	            modal.item.keyField = profiles[modal.item.uploadProfile]['keyField'];
	            modal.item.limiterField = profiles[modal.item.uploadProfile]['limiterField'];
	            modal.item.skip = parseInt(profiles[modal.item.uploadProfile]['skip']);
	            modal.item.margins = profiles[modal.item.uploadProfile]['margins'];
	            modal.update();
	        };
	
	        // удаление профиля
	        modal.deleteProfile = function (e) {
	            // получаем данные из брауз
	            var prof = JSON.parse(localStorage.getItem("profiles"));
	            if (prof != null) profiles = prof;
	
	            // удаление проф
	            if ((0, _keys2.default)(profiles).length != 0) {
	                delete profiles[modal.item.uploadProfile];
	                profiles['groupNow'] = 'profile1';
	
	                // запись
	                var serialProfiles = (0, _stringify2.default)(profiles);
	                localStorage.setItem('profiles', serialProfiles);
	
	                modal.uploadProfiles = [];
	                for (var key in profiles) {
	                    if (key != 'groupNow') {
	                        var _profileUnit = { name: key, title: profiles[key]['title'] };
	                        modal.uploadProfiles.push(_profileUnit);
	                    }
	                }
	                delete modal.item.margins;
	                modal.update();
	            }
	        };
	    });
	
	    // ОТПРАВИТЬ
	    self.submit = function () {
	        var modal = self.tags['bs-modal'];
	        var formData = new FormData();
	        var target = modal.file;
	        modal.loader = true;
	
	        //formData.append('type', modal.item.type)
	        //formData.append('reset', modal.item.reset)
	        formData.append('prepare', true);
	
	        if (target.files.length) {
	            for (var i = 0; i < target.files.length; i++) {
	                formData.append('file' + i, target.files[i], target.files[i].name);
	            }
	        } else {
	            formData.append('url', modal.item.filename);
	            modal.error = modal.validation.validate(modal.item, modal.rules);
	            if (modal.error) return;
	        }
	        // прикрепляем к отправке параметры
	        var idGroup = 0;
	        if (modal.item.inGroup) {
	            idGroup = opts.idGroup;
	        }
	        formData.append('uploadProfile', modal.item.uploadProfile);
	        /*formData.append('encoding', modal.item.encoding)*/
	        formData.append('delimiter', modal.item.delimiter);
	        formData.append('keyField', modal.item.keyField);
	        formData.append('limiterField', modal.item.limiterField);
	        formData.append('skip', parseInt(modal.item.skip));
	        formData.append('idGroup', idGroup);
	
	        // получаем настройки по профилям из браузера
	        var profiles = JSON.parse(localStorage.getItem("profiles")); // отсутствуют - null
	
	        // если настройки не совподают или их нет - добаить новый профиль
	        // (если нет параметра - перезаписывается в профиль)
	        var create = true;
	        if (profiles == null) {
	            var profiles = {};
	        } else if ((0, _keys2.default)(profiles).length == 1) {
	            var create = false;
	        } else {
	            for (var key in profiles) {
	                if (modal.item.delimiter == profiles[key]['delimiter'] && modal.item.keyField == profiles[key]['keyField'] && modal.item.limiterField == profiles[key]['limiterField']
	                //- modal.item.skip         == profiles[key]['skip']  // отступ менятеся внутри профиля
	                ) {
	                        var create = false;
	                        break;
	                    }
	            }
	        }
	
	        if (create == true) {
	            // генерируем новый профиль
	
	            // получаем список имен профилей - генерируем новое название
	            var numProfiles = 1;
	            var stop = false;
	            while (stop == false) {
	                var array_in_presence = false;
	
	                // проверяем наличие имени в списке
	                for (var key in profiles) {
	                    if ('profile' + numProfiles == key) {
	                        array_in_presence = true;
	                        break;
	                    }
	                }
	
	                // нет - присваивае к newNameProfile, останавливаем перебор
	                // есть - поднимаем номер, продолжаем перебор
	                if (array_in_presence == false) {
	                    var newNameProfile = 'profile' + numProfiles;
	                    var newTitleProfile = '\u041F\u0440\u043E\u0444\u0438\u043B\u044C ' + numProfiles;
	                    stop = true;
	                } else numProfiles += 1;
	            }
	        } else {
	            // редактируем старый профиль
	            var newNameProfile = modal.item.uploadProfile;
	            var newTitleProfile = modal.item.title;
	        }
	
	        // собираем данные
	        var newProfileSettings = {
	            'title': newTitleProfile,
	            'delimiter': modal.item.delimiter,
	            'keyField': modal.item.keyField,
	            'limiterField': modal.item.limiterField,
	            'skip': parseInt(modal.item.skip),
	
	            'margins': modal.item.margins
	        };
	
	        // добавляем в массив и возвращаем браузеру
	        profiles[newNameProfile] = newProfileSettings;
	        profiles['groupNow'] = newNameProfile;
	
	        var serialProfiles = (0, _stringify2.default)(profiles);
	        localStorage.setItem('profiles', serialProfiles);
	
	        modal.uploadProfiles = [];
	        for (var key in profiles) {
	            if (key != 'groupNow') {
	                var profileUnit = { name: key, title: profiles[key]['title'] };
	                modal.uploadProfiles.push(profileUnit);
	            }
	        }
	        modal.update();
	
	        //- } else {
	        //-     // добавляем в массив выбранный профиль
	        //-     profiles['groupNow'] = modal.item.uploadProfile
	        //-
	        //-     var serialProfiles = JSON.stringify(profiles)
	        //-     localStorage.setItem('profiles', serialProfiles)
	        //- }
	        //-
	        //- modal.loader = true
	        //- modal.cannotBeClosed = true
	        //- modal.update()
	
	        // ЗАГРУЗИТЬ
	        // данные уходят в Product.php post
	        // по файлу - $items, по настройкам - $_POST
	
	        API.upload({
	            object: 'Product',
	            data: formData,
	            success: function success(response) {
	                console.log(response);
	                if (response.errors == '') {
	                    var dataI = response;
	                    dataI.filename = modal.item.filename;
	                    dataI.uploadProfile = modal.item.uploadProfile;
	                    localStorage.setItem('shop24_import_products', (0, _stringify2.default)(dataI));
	                    var items = JSON.parse(localStorage.getItem('shop24_import_products') || '{}');
	                    modal.modalHide();
	                    observable.trigger('products-imports');
	                }
	
	                var elemT = document.getElementById("terminalImport");
	                elemT.innerHTML = response.errors;
	            },
	            complete: function complete() {
	                modal.loader = false;
	                modal.cannotBeClosed = false;
	                modal.update();
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, $) {'use strict';
	
	riot.tag2('analytics-statictics', '  <div class="row m-b-3">\n    <div class="col-md-12">\n      <div class="checkbox-inline">\n        <label>\n          <input type="checkbox" __checked="{editMode}" onclick="{toggleEditMode}">Режим прогнозирования\n        </label>\n      </div>\n    </div>\n  </div>\n  <form onchange="{change}" onsubmit="{submit}" method="POST">\n    <div class="row">\n      <div class="col-md-4">\n        <div class="analytic-calc">\n          <div class="analytic-calc__title">Сайт</div>\n          <div class="analytic-calc__body" style="border-left: 2px solid #E54A4F;">\n            <div class="row">\n              <div class="col-xs-4">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Посетители&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Количество уникальных посетителей сайта"></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.countVisitors}</p>\n                  <input class="form-control" name="countVisitors" if="{editMode}" value="{item.countVisitors}">\n                </div>\n              </div>\n              <div class="col-xs-4">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Конверсия&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Сколько процентов от всех посетителей за период сделали заказы"></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.siteConversion}%</p>\n                  <div class="input-group" if="{editMode}">\n                    <input class="form-control" name="siteConversion" value="{item.siteConversion}">\n                    <div class="input-group-addon">%</div>\n                  </div>\n                </div>\n              </div>\n              <div class="col-xs-4">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Заказы&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Количество клиентов, которые сделали заказ"></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.countAllCustomers}</p>\n                  <input class="form-control" name="countAllCustomers" if="{editMode}" value="{item.countAllCustomers}">\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-xs-12">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Рекламный бюджет&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Сумма потраченного рекламного бюджета для расчета ROI"></i></label>\n                  <input class="form-control" name="advertisingBudget" value="{item.advertisingBudget}">\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="col-md-4">\n        <div class="analytic-calc">\n          <div class="analytic-calc__title">Отдел продаж</div>\n          <div class="analytic-calc__body" style="border-left: 2px solid #A086D3;">\n            <div class="row">\n              <div class="col-xs-4">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Конверс.&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Сколько процентов от всех заказов за период станут в итоге вашими клиентами"></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.ordersConversion}%</p>\n                  <div class="input-group" if="{editMode}">\n                    <input class="form-control" name="ordersConversion" value="{item.ordersConversion}">\n                    <div class="input-group-addon">%</div>\n                  </div>\n                </div>\n              </div>\n              <div class="col-xs-4">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Клиенты</label>\n                  <p class="form-control-static" if="{!editMode}">{item.countPaidCustomers}</p>\n                  <input class="form-control" name="countPaidCustomers" if="{editMode}" value="{item.countPaidCustomers}">\n                </div>\n              </div>\n              <div class="col-xs-4">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Ср.чек&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Как посчитать средний чек, если у вас несколько товаров по разным ценам? Возьмите всю выручку за день/неделю/месяц и поделите на количество клиентов за этот же период."></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.averageCheck}</p>\n                  <input class="form-control" name="averageCheck" if="{editMode}" value="{item.averageCheck}">\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-xs-12">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Цена клиента&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Сколько вам стоит получить одного клиента"></i></label>\n                  <p class="form-control-static" if="{item.clientPrice != Infinity}">{item.clientPrice}<i class="fa fa-rub"></i></p>\n                  <p class="form-control-static" if="{item.clientPrice == Infinity}">∞</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="col-md-4">\n        <div class="analytic-calc">\n          <div class="analytic-calc__title">Доход</div>\n          <div class="analytic-calc__body" style="border-left: 2px solid #A4C639;">\n            <div class="row">\n              <div class="col-xs-6">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Рентабельность<br>(без рекламы)&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Рентабельность считается по формуле R=(операц.прибыль / выручку)*100%. Как посчитать здесь операционную пибыль? Вычтите из выручки все расходы, кроме расходов на рекламу (они учитываются позже в формуле)"></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.rentability}%</p>\n                  <div class="input-group" if="{editMode}">\n                    <input class="form-control" name="rentability" value="{item.rentability}">\n                    <div class="input-group-addon">%</div>\n                  </div>\n                </div>\n              </div>\n              <div class="col-xs-6">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">Чистая прибыль&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="Ожидаемая чистая прибыль за период. Здесь уже учтены все расходы, включая расходы на рекламу"></i></label>\n                  <p class="form-control-static" if="{!editMode}">{item.profit}</p>\n                  <input class="form-control" name="profit" if="{editMode}" value="{item.profit}">\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-xs-12">\n                <div class="analytic-calc__form-group">\n                  <label class="analytic-calc__label">ROI&nbsp;<i class="icon-append fa fa-question-circle text-muted" data-toggle="tooltip" data-placement="auto" title="" data-original-title="ROI - коэффициент, показывающий окупаемость инвестиций. ROI = (Средний чек * К-во клиентов * Рентабельность(без рекламы)/Расходы на рекламу)*100% "></i></label>\n                  <p class="form-control-static" if="{item.ROI != Infinity}">{item.ROI}%</p>\n                  <p class="form-control-static" if="{item.ROI == Infinity}">∞</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </form>\n', 'analytics-statictics .analytic-calc,[riot-tag="analytics-statictics"] .analytic-calc,[data-is="analytics-statictics"] .analytic-calc{ position: relative; margin-bottom: 15px; } analytics-statictics .analytic-calc__body,[riot-tag="analytics-statictics"] .analytic-calc__body,[data-is="analytics-statictics"] .analytic-calc__body{ padding: 0 0 0 20px; } analytics-statictics .analytic-calc__title,[riot-tag="analytics-statictics"] .analytic-calc__title,[data-is="analytics-statictics"] .analytic-calc__title{ font-size: 18px; text-align: center; padding-bottom: 10px; } analytics-statictics .analytic-calc__label,[riot-tag="analytics-statictics"] .analytic-calc__label,[data-is="analytics-statictics"] .analytic-calc__label{ font-size: 11px; line-height: 1; width: 100%; height: 14px; display: inline-block; text-align: center; } analytics-statictics .analytic-calc__form-group,[riot-tag="analytics-statictics"] .analytic-calc__form-group,[data-is="analytics-statictics"] .analytic-calc__form-group{ margin-bottom: 0; vertical-align: middle; text-align: center; padding-bottom: 10px; } analytics-statictics .analytic-calc__body > .row:not(:last-child),[riot-tag="analytics-statictics"] .analytic-calc__body > .row:not(:last-child),[data-is="analytics-statictics"] .analytic-calc__body > .row:not(:last-child){ border-bottom: 1px solid #ccc; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    var _typeof2 = __webpack_require__(74);
	
	    var _typeof3 = _interopRequireDefault(_typeof2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.editMode = false;
	    self.mixin('change');
	    self.item = {
	        averageCheck: 0,
	        siteConversion: 0,
	        ordersConversion: 0,
	        rentability: 0,
	        clientPrice: 0,
	        profit: 0,
	        ROI: 0
	    };
	    var advertisingBudget = 10000;
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.item;
	        },
	        set: function set(value) {
	            if (!self.editMode && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
	                self.item = (0, _extends3.default)({}, value);
	                self.item.advertisingBudget = advertisingBudget;
	            }if (self.editMode) {
	                self.newValue = value;
	                self.newValue.advertisingBudget = advertisingBudget;
	            }
	        }
	    });
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	
	        switch (name) {
	            case 'advertisingBudget':
	                advertisingBudget = e.target.value;
	                self.calc();
	                break;
	            case 'countVisitors':
	            case 'siteConversion':
	                self.item.countAllCustomers = (self.item.countVisitors * self.item.siteConversion / 100).toFixed(0);
	                self.item.countPaidCustomers = (self.item.countAllCustomers * self.item.ordersConversion / 100).toFixed(0);
	                self.calc();
	                break;
	            case 'countAllCustomers':
	                self.item.countVisitors = (self.item.countAllCustomers / self.item.siteConversion * 100).toFixed(0);
	                self.item.countPaidCustomers = (self.item.countAllCustomers * self.item.ordersConversion / 100).toFixed(0);
	                self.calc();
	                break;
	            case 'ordersConversion':
	                self.item.countPaidCustomers = (self.item.countAllCustomers * self.item.ordersConversion / 100).toFixed(0);
	                self.calc();
	                break;
	            case 'countPaidCustomers':
	                self.item.countAllCustomers = (self.item.countPaidCustomers / self.item.ordersConversion * 100).toFixed(0);
	                self.item.countVisitors = (self.item.countAllCustomers / self.item.siteConversion * 100).toFixed(0);
	                self.calc();
	                break;
	            case 'averageCheck':
	            case 'rentability':
	                self.calc();
	                break;
	            case 'profit':
	                self.item.sumPaidOrders = (+self.item.profit + +self.item.advertisingBudget) / (self.item.rentability / 100);
	                self.item.countPaidCustomers = (self.item.sumPaidOrders / self.item.averageCheck).toFixed(0);
	                self.item.countAllCustomers = (self.item.countPaidCustomers / self.item.ordersConversion * 100).toFixed(0);
	                self.item.countVisitors = (self.item.countAllCustomers / self.item.siteConversion * 100).toFixed(0);
	                self.calc();
	                break;
	        }
	    };
	
	    self.calc = function () {
	        var sumPaidOrders = self.item.averageCheck * self.item.countPaidCustomers || 0;
	        var clientPrice = self.item.advertisingBudget / self.item.countPaidCustomers || 0;
	        var profit = sumPaidOrders * self.item.rentability / 100 - self.item.advertisingBudget || 0;
	        var ROI = self.item.averageCheck * self.item.countPaidCustomers * self.item.rentability / 100 / self.item.advertisingBudget * 100 || 0;
	
	        self.item.sumPaidOrders = sumPaidOrders;
	        self.item.clientPrice = clientPrice.toFixed(0);
	        self.item.profit = profit.toFixed(0);
	        self.item.ROI = ROI.toFixed(2);
	    };
	
	    self.toggleEditMode = function (e) {
	        self.editMode = !self.editMode;
	        if (self.editMode) self.newValue = (0, _extends3.default)({}, self.item);else self.item = self.newValue;
	    };
	
	    self.on('update', function () {
	        if (!self.editMode) {
	            var averageCheck = self.item.sumPaidOrders / self.item.countPaidCustomers || 0;
	            var siteConversion = self.item.countAllCustomers / self.item.countVisitors * 100 || 0;
	            var ordersConversion = self.item.countPaidCustomers / self.item.countAllCustomers * 100 || 0;
	            var rentability = (self.item.sumPaidOrders - self.item.sumPurchase) / self.item.sumPaidOrders * 100 || 0;
	            var clientPrice = self.item.advertisingBudget / self.item.countPaidCustomers || 0;
	            var profit = self.item.sumPaidOrders * rentability / 100 - self.item.advertisingBudget || 0;
	            var ROI = averageCheck * self.item.countPaidCustomers * rentability / 100 / self.item.advertisingBudget * 100 || 0;
	
	            self.item.averageCheck = averageCheck.toFixed(2);
	            self.item.siteConversion = siteConversion.toFixed(4);
	            self.item.ordersConversion = ordersConversion.toFixed(2);
	            self.item.rentability = rentability.toFixed(2);
	            self.item.clientPrice = clientPrice.toFixed(0);
	            self.item.profit = profit.toFixed(0);
	            self.item.ROI = ROI.toFixed(2);
	        }
	    });
	
	    self.submit = function () {};
	
	    self.on('mount', function () {
	        $(self.root).find('[data-toggle="tooltip"]').tooltip();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(16)))

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, $) {'use strict';
	
	__webpack_require__(359);
	
	__webpack_require__(344);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('analytics', '  <loader if="{loader}"></loader>\n  <div hide="{loader}">\n    <div class="row">\n      <div class="col-md-12">\n        <div class="well well-sm">\n          <div class="form-inline">\n            <div class="form-group">\n              <button class="btn btn-success" type="button" onclick="{reload}"><i class="fa fa-refresh"></i> Обновить</button>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Выберите период</label>\n              <datetime-picker class="form-control" name="startDate" format="DD.MM.YYYY"></datetime-picker> —\n              <datetime-picker class="form-control" name="endDate" format="DD.MM.YYYY"></datetime-picker>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <analytics-statictics value="{value}"></analytics-statictics>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <ul class="nav nav-tabs">\n          <li class="{active: name == tab}" each="{tabs}"><a href="#" onclick="{tabClick}">{title}</a></li>\n        </ul>\n      </div>\n    </div>\n    <div class="row" if="{tab == &quot;funnel&quot;}">\n      <div class="col-md-6 col-md-offset-3">\n        <loader if="{tabLoader == &quot;funnel&quot;}"></loader>\n        <chart type="funnel" data="{createChartFunnelData(value.funnel)}" options="{chartFunnelOptions}"></chart>\n      </div>\n    </div>\n    <div class="row" if="{tab == &quot;statisticsOrders&quot;}">\n      <div class="col-md-12">\n        <loader if="{tabLoader == &quot;statisticsOrders&quot;}"></loader>\n        <chart type="bar" data="{createChartStatisticsData(value.statisticsOrders)}" options="{chartFunnelOptions}"></chart>\n      </div>\n    </div>\n    <div class="row" if="{tab == &quot;products&quot;}">\n      <div class="col-md-12">\n        <loader if="{tabLoader == &quot;products&quot;}"></loader>\n        <form class="form-inline text-right m-t-2 m-b-2">\n          <div class="input-group">\n            <input class="form-control" name="search" id="productSearch" type="text" placeholder="Поиск" oninput="{find}"><span class="input-group-btn">\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </form>\n        <catalog-static cols="{productsCols}" rows="{value.products}" remove-toolbar="1" search="true">\n          <yield to="body">\n            <datatable-cell name="name">{row.name}</datatable-cell>\n            <datatable-cell name="count">{row.count}</datatable-cell>\n            <datatable-cell name="profitability">{parseInt(row.profitability).toFixed(0)}%</datatable-cell>\n            <datatable-cell name="profit">{parseInt(row.profit).toFixed(2)}</datatable-cell>\n          </yield>\n        </catalog-static>\n      </div>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.loader = false;
	    self.value = {};
	    self.productAll = [];
	
	    self.tab = 'funnel';
	    self.tabLoader = 'funnel';
	    self.tabs = [{ title: 'Воронка', name: 'funnel' }, { title: 'Статистика', name: 'statisticsOrders' }, { title: 'Продукты', name: 'products' }];
	
	    self.productsCols = [{ name: 'name', value: 'Наименование товара/услуги' }, { name: 'count', value: 'Кол-во' }, { name: 'profitability', value: 'Рентабельность' }, { name: 'profit', value: 'Доход' }];
	
	    self.tabClick = function (e) {
	        if (e && e.item && e.item.name) {
	            if (self.tab === e.item.name) return;
	            self.tab = self.tabLoader = e.item.name;
	        }
	
	        var data = {
	            startDate: self.tags.startDate.root.value ? (0, _moment2.default)(self.tags.startDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : '',
	            endDate: self.tags.endDate.root.value ? (0, _moment2.default)(self.tags.endDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
	        };
	
	        API.request({
	            object: 'Analytics',
	            method: 'Info',
	            data: (0, _extends3.default)({}, data, {
	                data: self.tab
	            }),
	            success: function success(response) {
	                self.value = (0, _extends3.default)({}, self.value, response);
	                self.productAll = self.value.products;
	                console.log(self.value);
	                self.tabLoader = '';
	                self.update();
	            }
	        });
	    };
	
	    self.find = function (e) {
	        console.log(self.productAll);
	        self.value.products = [];
	        var find = $('#productSearch').val();
	        if (find) {
	            self.productAll.forEach(function (item) {
	                console.log(item);
	                if (item.name.toLowerCase().indexOf(find.toLowerCase()) !== -1) {
	                    self.value.products.push(item);
	                }
	            });
	        } else self.value.products = self.productAll;
	    };
	
	    self.createChartFunnelData = function (data) {
	        if (!(data instanceof Array)) return;
	
	        var result = {
	            labels: [],
	            datasets: [{
	                data: [],
	                backgroundColor: [],
	                borderWidth: 1
	            }]
	        };
	
	        data.forEach(function (value, index, array) {
	            result.labels.push(value.Title);
	            result.datasets[0].data.push(value.Value);
	            result.datasets[0].backgroundColor.push(value.Color);
	        });
	
	        return result;
	    };
	
	    self.createChartStatisticsData = function (data) {
	        var result = {
	            labels: [],
	            datasets: [{
	                label: 'Статистика',
	                data: [],
	                backgroundColor: 'rgba(34, 139, 34, 0.3)',
	                borderColor: 'rgba(34, 139, 34, 1)',
	                borderWidth: 1
	            }]
	        };
	
	        data.forEach(function (value, index, array) {
	            var dateOrder = (0, _moment2.default)(value.dateOrder, 'YYYY-MM-DD').format('DD.MM.YYYY');
	            result.labels.push(dateOrder);
	            result.datasets[0].data.push(value.sum);
	        });
	
	        return result;
	    };
	
	    self.chartFunnelOptions = {};
	
	    self.reload = function () {
	        var data = {
	            startDate: self.tags.startDate.root.value ? (0, _moment2.default)(self.tags.startDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : '',
	            endDate: self.tags.endDate.root.value ? (0, _moment2.default)(self.tags.endDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
	        };
	
	        self.loader = true;
	        self.update();
	
	        if (self.root.parentNode) {
	            API.request({
	                object: 'Analytics',
	                method: 'Info',
	                data: data,
	                success: function success(response) {
	                    self.value = (0, _extends3.default)({}, self.value, response);
	                    self.update();
	                },
	                complete: function complete() {
	                    self.loader = false;
	                    self.update();
	                }
	            });
	        }
	
	        self.tabClick();
	    };
	
	    self.one('updated', function () {
	        self.tags.startDate.root.value = (0, _moment2.default)().startOf('month').format('DD.MM.YYYY');
	        self.tags.endDate.root.value = (0, _moment2.default)().format('DD.MM.YYYY');
	        self.reload();
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(16)))

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app) {'use strict';
	
	var _md5Min = __webpack_require__(62);
	
	var _md5Min2 = _interopRequireDefault2(_md5Min);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('auth', '  <div class="layout"></div>\n  <div class="container">\n    <div class="row">\n      <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4">\n        <div class="auth-logo"></div>\n        <form onsubmit="{auth}">\n          <div class="panel panel-default" style="margin-top: 30px;">\n            <div class="panel-heading text-center">\n              <div class="panel-title">Авторизация</div>\n            </div>\n            <div class="panel-body">\n              <div class="alert alert-danger" if="{error}"><a class="close" href="#" onclick="{closeErrorAlert}">&times;</a>Неправильный или неактивный логин или пароль!</div>\n              <div class="form-group">\n                <div class="input-group"><span class="input-group-addon">\n                    <div class="fa fa-user fa-fw"></div></span>\n                  <input class="form-control" name="serial" placeholder="Логин">\n                </div>\n              </div>\n              <div class="form-group">\n                <div class="input-group"><span class="input-group-addon">\n                    <div class="fa fa-key fa-fw"></div></span>\n                  <input class="form-control" name="password" placeholder="Пароль" type="password">\n                </div>\n              </div>\n              <div class="form-group" style="margin-bottom: 0;">\n                <div class="checkbox">\n                  <label>\n                    <input name="remember" type="checkbox">Запомнить меня\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class="panel-footer text-center">\n              <input class="btn btn-success" type="submit" value="Продолжить">\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n', 'auth .layout,[riot-tag="auth"] .layout,[data-is="auth"] .layout{ position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: #c7c7c7; z-index: -1; }', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.closeErrorAlert = function () {
	        self.error = false;
	    };
	
	    self.auth = function () {
	
	        app.login({
	            serial: self.serial.value.trim(),
	            password: (0, _md5Min2.default)(self.password.value.trim()),
	            success: function success(response, secookie) {
	                var mainUser = {
	                    login: self.serial.value.trim(),
	                    hash: (0, _md5Min2.default)(self.password.value.trim()),
	                    project: response.project
	                };
	
	                localStorage.setItem('shop24_main_user', (0, _stringify2.default)(mainUser));
	
	                if (self.remember.checked) localStorage.setItem('shop24_user', (0, _stringify2.default)(response.config));
	
	                if (response.permissions) localStorage.setItem('shop24_permissions', (0, _stringify2.default)(response.permissions));
	
	                localStorage.setItem('shop24_cookie', secookie);
	                localStorage.setItem('shop24', (0, _stringify2.default)(response.config));
	                app.init();
	            },
	            error: function error(response) {
	                self.error = true;
	                self.update();
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12)))

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(161);
	
	__webpack_require__(160);
	
	riot.tag2('comments', '  <div class="column" if="{!notFound}">\n    <comments-list if="{!edit}"></comments-list>\n    <comment-edit if="{edit}"></comment-edit>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.edit = false;
	
	    route('/reviews/comments', function () {
	        self.notFound = false;
	        self.edit = false;
	        self.update();
	    });
	
	    route('/reviews/comments/([0-9]+)', function (id) {
	        observable.trigger('comment-edit', id);
	        self.notFound = false;
	        self.edit = true;
	        self.update();
	    });
	
	    route('/reviews/comments/new', function () {
	        self.notFound = false;
	        self.edit = true;
	        observable.trigger('comment-new');
	        self.update();
	    });
	
	    route('/reviews/comments..', function () {
	        self.notFound = true;
	        self.update();
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('delivery-condition-param-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Условие доставки</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" value="{item.name ? item.name : item.price}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="h4">Условия</div>\n            <div class="form-group">\n              <label class="control-label">Критерий заказа</label>\n              <select class="form-control" name="typeParam" value="{item.typeParam}">\n                <option value="sum">Сумма</option>\n                <option value="weight">Вес</option>\n                <option value="volume">Объем</option>\n              </select>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">От</label>\n              <input class="form-control" name="minValue" value="{item.minValue}" min="0" type="{\'number\'}">\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">До</label>\n              <input class="form-control" name="maxValue" value="{item.maxValue}" min="0" type="{\'number\'}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Приоритет</label>\n              <input class="form-control" name="priority" value="{item.priority}" type="{\'number\'}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="h4">Формирование цены (алгоритм подсчета)</div>\n            <div class="form-group">\n              <label class="control-label">Арифметика</label>\n              <select class="form-control" name="operation" value="{item.operation}">\n                <option value="=">Приравнивать</option>\n                <option value="+">Добавлять</option>\n                <option value="-">Вычитать</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Тип формирования</label>\n              <select class="form-control" name="typePrice" value="{item.typePrice}">\n                <option value="a">Абсолютное значение</option>\n                <option value="s">Процент от суммы заказа</option>\n                <option value="d">Процент от цены доставки</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">{item.typePrice == ⁗a⁗ ? ⁗Цена⁗ : ⁗Процент⁗}</label>\n              <input class="form-control" name="price" value="{item.price}" min="0" type="{\'number\'}">\n            </div>\n            <hr>\n            <input class="form-control" value="{parent.opts.formatPrice(item)}" disabled="disabled">\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = opts.item || {
	            typeParam: 'sum',
	            minValue: 0,
	            maxValue: 0,
	            priority: 0,
	            operation: '=',
	            typePrice: 'a',
	            price: 0
	        };
	        modal.mixin('change');
	        modal.mixin('validation');
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('delivery-condition-regions-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Регион доставки</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}" type="text">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Страна</label>\n          <autocomplete name="idCountryTo" value-field="name" data="{countries}" onchange="{changeCountry}" min-symbols="2" value="{item.idCountryTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Регион</label>\n          <autocomplete name="idRegionTo" value-field="name" data="{getRegions(tags.idCountryTo.value)}" __disabled="{tags.region.data.length == 0 &amp;&amp; tags.country.value == undefined}" onchange="{changeRegion}" min-symbols="2" value="{item.idRegionTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Город</label>\n          <autocomplete name="idCityTo" value-field="name" data="{cities}" __disabled="{tags.country.value == undefined}" min-symbols="2" value="{item.idCityTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Срок доставки (1, 1-2)</label>\n          <input class="form-control" name="period" value="{item.period}" type="text">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Цена</label>\n          <input class="form-control" name="price" value="{item.price}" min="0" type="{\'number\'}">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Макс. объем</label>\n          <div class="input-group">\n            <input class="form-control" name="maxVolume" value="{item.maxVolume}" min="0" type="{\'number\'}">\n            <div class="input-group-addon">м<sup>3</sup></div>\n          </div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Макс. вес</label>\n          <div class="input-group">\n            <input class="form-control" name="maxWeight" value="{item.maxWeight}" min="0" type="{\'number\'}">\n            <div class="input-group-addon">гр.</div>\n          </div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Адрес склада/примечание</label>\n          <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n        </div>\n        <div class="form-group">\n          <div class="checkbox-inline">\n            <label>\n              <input type="checkbox" name="isActive" __checked="{item.isActive}">Активная\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = opts.item || {
	            isActive: true
	        };
	        modal.mixin('change');
	        modal.mixin('validation');
	
	        modal.getRegions = function (id) {
	            if (modal.regions instanceof Array && id !== undefined) return modal.regions.filter(function (item) {
	                return item.idCountry == id;
	            });else return [];
	        };
	
	        modal.changeCountry = function (e) {
	            modal.getCities(this.idCountryTo.value, this.idRegionTo.value);
	        };
	
	        modal.changeRegion = function (e) {
	            modal.getCities(this.idCountryTo.value, this.idRegionTo.value);
	        };
	
	        modal.getCities = function (country, region) {
	            return API.request({
	                object: 'GeoCity',
	                method: 'Fetch',
	                data: { idCountry: country, idRegion: region },
	                success: function success(response) {
	                    modal.cities = response.items;
	                    modal.update();
	                }
	            });
	        };
	
	        (0, _parallel2.default)([function (callback) {
	            API.request({
	                object: 'GeoCountry',
	                method: 'Fetch',
	                success: function success(response) {
	                    modal.countries = response.items;
	                    callback(null, 'Countries');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'GeoRegion',
	                method: 'Fetch',
	                success: function success(response) {
	                    modal.regions = response.items;
	                    callback(null, 'Regions');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function (err, res) {
	            if (modal.item.idCityTo != null) {
	                var ids = [modal.item.idCityTo];
	
	                API.request({
	                    object: 'GeoCity',
	                    method: 'Fetch',
	                    data: { ids: ids },
	                    success: function success(response) {
	                        modal.item.idCountryTo = response.items[0].idCountry;
	                        modal.item.idRegionTo = response.items[0].idRegion;
	
	                        modal.countries.forEach(function (item) {
	                            if (item.id == modal.item.idCountryTo) modal.tags.idCountryTo.filterValue = item.name;
	                        });
	
	                        modal.regions.forEach(function (item) {
	                            if (item.id == modal.item.idRegionTo) modal.tags.idRegionTo.filterValue = item.name;
	                        });
	
	                        modal.tags.idCityTo.filterValue = response.items[0].name;
	
	                        modal.loader = false;
	                        modal.update();
	                    }
	                });
	            } else {
	                modal.loader = false;
	                modal.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, $, observable) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault2(_parallel);
	
	__webpack_require__(162);
	
	__webpack_require__(363);
	
	__webpack_require__(364);
	
	__webpack_require__(159);
	
	__webpack_require__(342);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('delivery-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/delivery"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;deliveries&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4" onclick="{wipedata}">{isNew ? item.name || \'Добавление типа доставки\' : item.name || \'Редактирование типа доставки\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#delivery-edit-delivery">Доставка</a></li>\n      <li if="{~regions.indexOf(item.code)}"><a data-toggle="tab" href="#delivery-edit-terms-of-pricing">Условия формирования цен</a></li>\n      <li><a data-toggle="tab" href="#delivery-edit-setup-payments">Настройка оплат</a></li>\n      <li><a data-toggle="tab" href="#delivery-edit-product-groups">Группы товаров</a></li>\n      <li if="{~regions.indexOf(item.code)}"><a data-toggle="tab" href="#delivery-edit-regions-geolocation">Регионы геолокации</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="delivery-edit-delivery">\n          <div class="row">\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Наименование</label>\n                <input class="form-control" name="name" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.code}">\n                <label class="control-label">Способ доставки</label>\n                <select class="form-control" name="code" value="{item.code}" onchange="{isExt}">\n                  <option each="{deliveriesTypes}" value="{code}" __selected="{code == item.code}" no-reorder>{name}</option>\n                </select>\n                <div class="help-block">{error.code}</div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.currency}">\n                <label class="control-label">Валюта</label>\n                <select class="form-control" name="currency" value="{item.curr}">\n                  <option each="{c, i in currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n                </select>\n                <div class="help-block">{error.currency}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{isIn}">\n              <div class="form-group">\n                <label class="control-label">Дни недели</label><br>\n                <week-days-checkbox name="week" value="{item.week}"></week-days-checkbox>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-3" if="{isIn}">\n              <div class="form-group">\n                <label class="control-label">Время в пути (1, 1-3)</label>\n                <input class="form-control" name="period" type="text" value="{item.period}">\n              </div>\n            </div>\n            <div class="col-md-3" if="{true}">\n              <div class="form-group">\n                <label class="control-label">Базовая цена</label>\n                <input class="form-control" name="price" min="0" step="0.01" value="{item.price}" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Макс. вес</label>\n                <div class="input-group">\n                  <input class="form-control" name="maxWeight" min="0" step="0.01" value="{item.maxWeight}" type="{\'number\'}"><span class="input-group-addon">гр</span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Макс. объем</label>\n                <div class="input-group">\n                  <input class="form-control" name="maxVolume" min="0" step="1" value="{item.maxVolume}" type="{\'number\'}"><span class="input-group-addon">см<sup>3</sup></span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.sms}">\n                <label class="control-label">SMS-уведомление</label>\n                <input class="form-control" name="sms" type="phone" value="{item.sms}">\n                <div class="help-block">{error.sms}</div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.email}">\n                <label class="control-label">Email-уведомление</label>\n                <input class="form-control" name="email" type="text" value="{item.email}">\n                <div class="help-block">{error.email}</div>\n              </div>\n            </div>\n          </div>\n          <hr>\n          <div class="row treasure" if="{!isIn}">\n            <div class="col-md-3" if="{fields.from_index}">\n              <div class="form-group">\n                <label class="control-label">{fields.from_index.name}</label>\n                <input class="form-control" id="treasure{fields.from_index.code} " name="{fields.from_index.code}" type="{fields.from_index.type}" value="{fields.from_index.value}">\n                <div class="help-block" if="{fields.from_index.description}"><i class="icon-append fa fa-info-circle"></i> {fields.from_index.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.declared_value}">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label class="control-label">\n                    <input name="{fields.declared_value.code}" type="checkbox" __checked="{fields.declared_value.value}">{fields.declared_value.name}\n                  </label>\n                </div>\n                <div class="help-block" if="{fields.declared_value.description}"><i class="icon-append fa fa-info-circle"></i> {fields.declared_value.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.type_delivery}">\n              <div class="form-group">\n                <label class="control-label">{fields.type_delivery.name}</label>\n                <select class="form-control" id="treasuretype_delivery " name="type_delivery">\n                  <option each="{val, i in fields.type_delivery.values}" __selected="{val == fields.type_delivery.value}" value="{val}" no-reorder>{i}</option>\n                </select>\n                <div class="help-block" if="{fields.type_delivery.description}"><i class="icon-append fa fa-info-circle"></i> {fields.type_delivery.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.from_city}">\n              <div class="form-group">\n                <label class="control-label">{fields.from_city.name}</label>\n                <input class="form-control" id="treasure{fields.from_city.code} " name="{fields.from_city.code}" autocomplete="off" oninput="{cityChange}" datavalue="{fields.from_city.value}" value="{fields.from_city.valueName}" type="text">\n                <div class="help-block">\n                  <ul class="list-group from-city-list">\n                    <li class="list-group-item" each="{i in fields.from_city.values}" value="{i.id}" onclick="{citySet}" title="{i.region}, {i.country}">{i.city}</li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.login}">\n              <div class="form-group">\n                <label class="control-label">{fields.login.name}</label>\n                <input class="form-control" id="treasure{fields.login.code}" name="{fields.login.code}" type="text" value="{fields.login.value}" autocomplete="off">\n                <div class="help-block" if="{fields.login.description}"><i class="icon-append fa fa-info-circle"></i> {fields.login.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.password}">\n              <div class="form-group">\n                <label class="control-label">{fields.password.name}</label>\n                <input class="form-control" id="treasure{fields.password.code}" name="{fields.password.code}" type="password" value="{fields.password.value}" autocomplete="off">\n                <div class="help-block" if="{fields.password.description}"><i class="icon-append fa fa-info-circle"></i> {fields.password.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.map_key}">\n              <div class="form-group">\n                <label class="control-label">{fields.map_key.name}</label>\n                <input class="form-control" id="treasure{fields.map_key.code}" name="{fields.map_key.code}" type="text" value="{fields.map_key.value}" autocomplete="off">\n                <div class="help-block" if="{fields.map_key.description}"><i class="icon-append fa fa-info-circle"></i> {fields.map_key.description}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Примечание</label>\n                <textarea class="form-control" name="note" rows="5" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="isActive" type="checkbox" __checked="{item.isActive}">Активная\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="onePosition" type="checkbox" __checked="{item.onePosition}">Для одной позиции\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="needAddress" type="checkbox" __checked="{item.needAddress}">Требовать адрес\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-terms-of-pricing" if="{~regions.indexOf(item.code)}">\n          <div class="row">\n            <div class="col-md-12">\n              <ul class="nav nav-tabs m-b-2">\n                <li class="active"><a data-toggle="tab" href="#delivery-edit-terms-of-pricing-params">По параметрам</a></li>\n                <li><a data-toggle="tab" href="#delivery-edit-terms-of-pricing-regions">По регионам</a></li>\n              </ul>\n              <div class="tab-content">\n                <div class="tab-pane fade in active" id="delivery-edit-terms-of-pricing-params">\n                  <catalog-static name="conditionsParams" rows="{item.conditionsParams}" cols="{conditionsParamsCols}" handlers="{conditionsParamsHandlers}" add="{conditionsParamsEdit}" dblclick="{conditionsParamsEdit}" remove="true">\n                    <yield to="body">\n                      <datatable-cell name="name">{row.name}</datatable-cell>\n                      <datatable-cell name="formatPrice">{handlers.formatPrice(row)}</datatable-cell>\n                      <datatable-cell name="typeParam">{handlers.typeParam[row.typeParam]}</datatable-cell>\n                      <datatable-cell name="minValue">{row.minValue}</datatable-cell>\n                      <datatable-cell name="maxValue">{row.maxValue}</datatable-cell>\n                      <datatable-cell name="priority">{row.priority}</datatable-cell>\n                    </yield>\n                  </catalog-static>\n                </div>\n                <div class="tab-pane fade" id="delivery-edit-terms-of-pricing-regions">\n                  <catalog-static name="conditionsRegions" rows="{item.conditionsRegions}" cols="{conditionsRegionsCols}" handlers="{conditionsRegionsHandlers}" add="{conditionsRegionsEdit}" dblclick="{conditionsRegionsEdit}" remove="true">\n                    <yield to="body">\n                      <datatable-cell name="name">{row.name}</datatable-cell>\n                      <datatable-cell name="geo">{handlers.locationTextRender(row)}</datatable-cell>\n                      <datatable-cell name="price">{row.price}</datatable-cell>\n                      <datatable-cell name="period">{row.period} дн.</datatable-cell>\n                      <datatable-cell name="note">{row.note}</datatable-cell>\n                    </yield>\n                  </catalog-static>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-setup-payments">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog object="PaySystem" cols="{paysystemsCols}" disable-col-select="true" handlers="{paysystemsHandlers}">\n                <yield to="body">\n                  <datatable-cell name="name"><i class="fa fa-fw {handlers.checked.indexOf(row.id) &gt; -1 ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.toggleCheckbox}"></i> {row.name}</datatable-cell>\n                </yield>\n              </catalog>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-product-groups">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-tree-check object="Category" label-field="{&quot;name&quot;}" hidepanel="false" children-field="{&quot;childs&quot;}" remove="{remove}" handlers="{productsGroupsHandlers}" store="delivery-edit-product-groups"></catalog-tree-check>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-regions-geolocation" if="{~regions.indexOf(item.code)}">\n          <catalog-static name="geoLocationsRegions" rows="{item.geoLocationsRegions}" handlers="{geoLocationsRegionsHandlers}" add="{addGeoLocationsRegions}" cols="{geoLocationsRegionsCols}" dblclick="{geoLocationsRegionsEdit}" remove="true">\n            <yield to="body">\n              <datatable-cell name="name">{handlers.locationTextRender(row)}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '.from-city-list li { cursor: pointer; } .from-city-list li:hover { background-color: #337ab7; color: #fff; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	    self.item = {};
	    self.isIn = false;
	    self.citiesItems = {};
	    self.hidePanel = true;
	
	    function locationTextRender(item) {
	        if (item.idCityTo) {
	            var _self$citiesItems$ite = self.citiesItems[item.idCityTo],
	                idCountry = _self$citiesItems$ite.idCountry,
	                idRegion = _self$citiesItems$ite.idRegion,
	                city = _self$citiesItems$ite.name;
	            var country = self.countriesItems[idCountry].name;
	
	            if (idRegion != 0) {
	                var region = self.regionsItems[idRegion].name;
	
	                return country + ', ' + region + ', ' + city;
	            } else return country + ', ' + city;
	        }
	
	        if (item.idRegionTo) {
	            var _self$regionsItems$it = self.regionsItems[item.idRegionTo],
	                _idCountry = _self$regionsItems$it.idCountry,
	                _region = _self$regionsItems$it.name;
	            var _country = self.countriesItems[_idCountry].name;
	
	            return _country + ', ' + _region;
	        }
	
	        if (item.idCountryTo) {
	            return self.countriesItems[item.idCountryTo].name;
	        }
	    }
	
	    self.rules = {
	        name: 'empty',
	        code: 'empty',
	        currency: 'empty',
	        email: {
	            required: false,
	            rules: [{
	                type: 'email'
	            }]
	        },
	        sms: {
	            required: false,
	            rules: [{
	                type: 'phone'
	            }]
	        }
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.regions = ['region', 'subregion'];
	
	    self.isExt = function (e) {
	        self.deliveriesTypes.forEach(function (item) {
	            if (e.target.value == item.code) {
	                self.isIn = item.isIn;
	                self.fields = item.fields;
	            }
	        });
	    };
	
	    self.cityChange = function (e) {
	        if (e.target.value.length > 1) {
	            API.request({
	                object: 'DeliveryType',
	                method: 'Info',
	                data: {
	                    type: 'city',
	                    value: e.target.value
	                },
	                success: function success(response) {
	                    self.fields.from_city.values = response;
	                    if (self.fields.from_city.values.length == 1) {
	                        self.fields.from_city.values.forEach(function (item) {
	                            self.fields.from_city.value = item.id;
	                            self.fields.from_city.valueName = item.city;
	                            e.target.value = item.city;
	                            self.fields.from_city.values = null;
	                        });
	                    } else {
	                        console.log(response);
	                        self.update();
	                    }
	                }
	            });
	        } else {
	            self.fields.from_city.values = null;
	        }
	    };
	
	    self.citySet = function (e) {
	        e.preventDefault();
	        self.fields.from_city.value = e.target.value;
	        self.fields.from_city.valueName = e.target.innerText;
	
	        if (self.fields.from_city.valueName == e.target.innerText) {
	            self.fields.from_city.values = null;
	        }
	        $('#treasurefrom_city').val(e.target.innerText);
	        //self.update()
	    };
	
	    self.paysystemsCols = [{ name: 'name', value: 'Наименование' }];
	
	    self.productsGroupsCols = [{ name: '', value: '', width: '30px' }, { name: 'name', value: 'Наименование' }];
	
	    self.conditionsParamsCols = [{ name: 'name', value: 'Наименование' }, { name: 'formatprice', value: 'цена' }, { name: 'typeParam', value: 'Аргумент' }, { name: 'minValue', value: 'Мин. знач.' }, { name: 'maxValue', value: 'Макс. знач.' }, { name: 'priority', value: 'Приоритет' }];
	
	    self.conditionsRegionsCols = [{ name: 'name', value: 'Наименование' }, { name: 'geo', value: 'Страна/Регион/Город' }, { name: 'price', value: 'Цена' }, { name: 'period', value: 'Срок' }, { name: 'note', value: 'Адрес склада/примечание' }];
	
	    self.conditionsRegionsHandlers = {
	        locationTextRender: locationTextRender
	    };
	
	    self.geoLocationsRegionsCols = [{ name: 'name', value: 'Страна/Регион/Город' }];
	
	    self.conditionsParamsHandlers = {
	        typeParam: {
	            sum: 'Сумма',
	            weight: 'Вес',
	            volume: 'Объем'
	        },
	        formatPrice: function formatPrice(row) {
	            var result = '';
	            var operation = row.operation,
	                typePrice = row.typePrice,
	                price = row.price;
	
	            price = price || 0;
	
	            if (typePrice === 'a') {
	                switch (operation) {
	                    case '=':
	                        result = '' + price;
	                        break;
	                    case '+':
	                        result = '+' + price + ' \u043A \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0441\u0443\u043C\u043C\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                    case '-':
	                        result = '-' + price + ' \u043E\u0442 \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                }
	            }
	
	            if (typePrice === 's') {
	                switch (operation) {
	                    case '=':
	                        result = price + '% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B \u0437\u0430\u043A\u0430\u0437\u0430';
	                        break;
	                    case '+':
	                        result = '+' + price + '% \u0441\u0443\u043C\u043C\u044B \u0437\u0430\u043A\u0430\u0437\u0430 \u043A \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                    case '-':
	                        result = '-' + price + '% \u0441\u0443\u043C\u043C\u044B \u0437\u0430\u043A\u0430\u0437\u0430 \u043E\u0442 \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                }
	            }
	
	            if (typePrice === 'd') {
	                switch (operation) {
	                    case '=':
	                        result = (price || 0) + '% \u043E\u0442 \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                    case '+':
	                        result = 100 + price + '% \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                    case '-':
	                        result = 100 - price + '% \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
	                        break;
	                }
	            }
	
	            return result;
	        }
	    };
	
	    self.conditionsParamsEdit = function (e) {
	        var item = void 0;
	
	        if (e && e.item) item = e.item.row;
	
	        modals.create('delivery-condition-param-modal', {
	            type: 'modal-primary',
	            item: item,
	            formatPrice: self.conditionsParamsHandlers.formatPrice,
	            submit: function submit() {
	                var _this = this;
	                if (!item) {
	                    self.item.conditionsParams.push(_this.item);
	                }
	
	                self.update();
	                _this.modalHide();
	            }
	        });
	    };
	
	    self.conditionsRegionsEdit = function (e) {
	        var item = void 0;
	
	        if (e && e.item) item = e.item.row;
	
	        modals.create('delivery-condition-regions-modal', {
	            type: 'modal-primary',
	            item: item,
	            submit: function submit() {
	                if (this.tags.idCityTo.value) {
	                    self.citiesItems[this.tags.idCityTo.value] = {};
	                    self.citiesItems[this.tags.idCityTo.value].name = this.tags.idCityTo.filterValue;
	
	                    if (this.tags.idRegionTo.value) self.citiesItems[this.tags.idCityTo.value].idRegion = this.tags.idRegionTo.value;else self.citiesItems[this.tags.idCityTo.value].idRegion = 0;
	
	                    if (this.tags.idCountryTo.value) self.citiesItems[this.tags.idCityTo.value].idCountry = this.tags.idCountryTo.value;else self.citiesItems[this.tags.idCityTo.value].idCountry = 0;
	                }
	
	                var _this = this;
	                if (!item) {
	                    self.item.conditionsRegions.push(_this.item);
	                }
	
	                self.update();
	                _this.modalHide();
	            }
	        });
	    };
	
	    self.geoLocationsRegionsHandlers = {
	        locationTextRender: locationTextRender
	    };
	
	    self.paysystemsHandlers = {
	        checked: [],
	        toggleCheckbox: function toggleCheckbox(e) {
	            var idx = this.handlers.checked.indexOf(this.row.id);
	
	            if (idx > -1) this.handlers.checked.splice(idx, 1);else this.handlers.checked.push(this.row.id);
	
	            self.update();
	        }
	    };
	
	    self.productsGroupsHandlers = {
	        checked: [],
	        toggleCheckbox: function toggleCheckbox(e) {
	            var idx = self.productsGroupsHandlers.checked.indexOf(this.row.id);
	
	            if (idx > -1) self.productsGroupsHandlers.checked.splice(idx, 1);else self.productsGroupsHandlers.checked.push(this.row.id);
	
	            self.update();
	        }
	    };
	
	    self.addGeoLocationsRegions = function (e) {
	        modals.create('delivery-regions', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var item = {
	                    idCountryTo: this.tags.idCountryTo.value,
	                    idRegionTo: this.tags.idRegionTo.value,
	                    idCityTo: this.tags.idCityTo.value
	                };
	
	                if (this.tags.idCityTo.value) {
	                    self.citiesItems[this.tags.idCityTo.value] = {};
	                    self.citiesItems[this.tags.idCityTo.value].name = this.tags.idCityTo.filterValue;
	
	                    if (this.tags.idRegionTo.value) self.citiesItems[this.tags.idCityTo.value].idRegion = this.tags.idRegionTo.value;else self.citiesItems[this.tags.idCityTo.value].idRegion = 0;
	
	                    if (this.tags.idCountryTo.value) self.citiesItems[this.tags.idCityTo.value].idCountry = this.tags.idCountryTo.value;else self.citiesItems[this.tags.idCityTo.value].idCountry = 0;
	                }
	
	                self.item.geoLocationsRegions = self.item.geoLocationsRegions || [];
	                self.item.geoLocationsRegions.push(item);
	                this.modalHide();
	                self.update();
	            }
	        });
	    };
	
	    self.geoLocationsRegionsEdit = function (e) {
	        modals.create('delivery-regions', {
	            type: 'modal-primary',
	            item: e.item.row,
	            submit: function submit() {
	                if (this.tags.idCityTo.value) {
	                    self.citiesItems[this.tags.idCityTo.value] = {};
	                    self.citiesItems[this.tags.idCityTo.value].name = this.tags.idCityTo.filterValue;
	
	                    if (this.tags.idRegionTo.value) self.citiesItems[this.tags.idCityTo.value].idRegion = this.tags.idRegionTo.value;else self.citiesItems[this.tags.idCityTo.value].idRegion = 0;
	
	                    if (this.tags.idCountryTo.value) self.citiesItems[this.tags.idCityTo.value].idCountry = this.tags.idCountryTo.value;else self.citiesItems[this.tags.idCityTo.value].idCountry = 0;
	                }
	
	                this.parent.item.idCountryTo = this.tags.idCountryTo.value;
	                this.parent.item.idRegionTo = this.tags.idRegionTo.value;
	                this.parent.item.idCityTo = this.tags.idCityTo.value;
	                this.modalHide();
	                self.update();
	            }
	        });
	    };
	    self.wipedata = function (e) {
	        var fields = [];
	
	        for (var i in self.fields) {
	            var field = [];
	            switch (self.fields[i].code) {
	                case 'from_city':
	                    field['value'] = document.getElementsByName(self.fields[i].code)[0].getAttribute('datavalue');
	                    break;
	                default:
	                    field['value'] = document.getElementsByName(self.fields[i].code)[0].value;
	                    break;
	            }
	            field['code'] = self.fields[i].code;
	            fields.push(field);
	        }
	    };
	
	    self.submit = function () {
	        self.error = self.validation.validate(self.item, self.rules);
	        if (!self.error) {
	            (function () {
	
	                var items = self.tags['catalog-tree-check'].getSelectedNodes();
	                var itemsList = [];
	                items.forEach(function (item) {
	                    itemsList.push(item.id);
	                });
	                self.item.idsGroups = itemsList;
	
	                self.loader = true;
	
	                /* Сохраняем основные настройки */
	
	                API.request({
	                    object: 'Delivery',
	                    method: 'Save',
	                    data: self.item,
	                    success: function success(response) {
	                        self.item = response;
	                        observable.trigger('delivery-reload');
	                        popups.create({ title: 'Успех!', text: 'Тип доставки сохранен!', style: 'popup-success' });
	                        /* Сохраняем дополнительные настройки */
	                        var fields = [];
	
	                        for (var i in self.fields) {
	                            var field = {};
	                            switch (self.fields[i].code) {
	                                case 'from_city':
	                                    field.value = document.getElementsByName(self.fields[i].code)[0].getAttribute('datavalue');
	                                    break;
	                                default:
	                                    if (document.getElementsByName(self.fields[i].code)[0] != null) field.value = document.getElementsByName(self.fields[i].code)[0].value;
	                                    break;
	                            }
	                            field.code = self.fields[i].code;
	                            fields.push(field);
	                        }
	                        API.request({
	                            object: 'DeliveryType',
	                            method: 'Info',
	                            data: {
	                                fields: fields,
	                                id_delivery: self.item.id,
	                                type: 'save'
	                            },
	                            success: function success(response) {}
	                        });
	                    },
	                    complete: function complete() {
	                        self.loader = false;
	                        self.update();
	                    }
	                });
	            })();
	        } else {
	            popups.create({ title: 'Ошибка!', text: 'Ошибка заполнения данных!', style: 'popup-danger' });
	        }
	    };
	
	    self.reload = function () {
	        observable.trigger('delivery-edit', self.item.id);
	    };
	
	    observable.on('delivery-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        //self.update()
	        self.tags['catalog-tree-check'].tags['treeview-check'].deselectAll();
	        (0, _parallel2.default)([function (callback) {
	            API.request({
	                object: 'Delivery',
	                method: 'Info',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    self.deliveriesTypes = response.deliveriesTypes;
	
	                    self.deliveriesTypes.forEach(function (item) {
	                        if (self.item.code == item.code) {
	                            self.isIn = item.isIn;
	                        }
	                        if (item.isIn == false && !item.fields) {
	
	                            API.request({
	                                object: 'DeliveryType',
	                                method: 'Info',
	                                data: {
	                                    type: 'settings',
	                                    id_delivery: self.item.id,
	                                    code: item.code
	                                },
	                                success: function success(response) {
	                                    item.fields = response;
	                                    if (self.item.code == item.code) {
	                                        self.fields = response;
	                                    }
	                                    self.update();
	                                }
	                            });
	                        }
	                    });
	                    self.currencies = response.currencies;
	                    self.paysystemsHandlers.checked = response.idsPaySystems || [];
	                    self.productsGroupsHandlers.checked = response.idsGroups || [];
	                    self.update();
	                    callback(null, 'Deliveries');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function (err, res) {
	            if (self.item.geoLocationsRegions && self.item.geoLocationsRegions instanceof Array) {
	                var geoLocationsRegionsIds = self.item.geoLocationsRegions.map(function (item) {
	                    return item.idCityTo;
	                }).filter(function (item) {
	                    return item;
	                });
	                var conditionsRegionsIds = self.item.conditionsRegions.map(function (item) {
	                    return item.idCityTo;
	                }).filter(function (item) {
	                    return item;
	                });
	                API.request({
	                    object: 'GeoCity',
	                    method: 'Fetch',
	                    data: { ids: [].concat(geoLocationsRegionsIds, conditionsRegionsIds) },
	                    success: function success(response) {
	                        self.citiesItems = {};
	
	                        response.items.forEach(function (item) {
	                            self.citiesItems[item.id] = {
	                                idCountry: item.idCountry,
	                                idRegion: item.idRegion,
	                                name: item.name
	                            };
	                        });
	
	                        self.loader = false;
	                        self.tags['catalog-tree-check'].tags['treeview-check'].setNodes(self.productsGroupsHandlers.checked);
	                        self.update();
	                    }
	                });
	            } else {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('delivery-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = {};
	        (0, _parallel2.default)([function (callback) {
	            API.request({
	                object: 'DeliveryType',
	                method: 'Fetch',
	                success: function success(response) {
	                    self.deliveriesTypes = response.items;
	                    callback(null, 'Deliveries');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'Currency',
	                method: 'Fetch',
	                success: function success(response) {
	                    self.currencies = response.items;
	                    callback(null, 'Deliveries');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function (err, res) {
	            if (self.item.geoLocationsRegions && self.item.geoLocationsRegions instanceof Array) {
	                var geoLocationsRegionsIds = self.item.geoLocationsRegions.map(function (item) {
	                    return item.idCityTo;
	                }).filter(function (item) {
	                    return item;
	                });
	                var conditionsRegionsIds = self.item.conditionsRegions.map(function (item) {
	                    return item.idCityTo;
	                }).filter(function (item) {
	                    return item;
	                });
	                API.request({
	                    object: 'GeoCity',
	                    method: 'Fetch',
	                    data: { ids: [].concat(geoLocationsRegionsIds, conditionsRegionsIds) },
	                    success: function success(response) {
	                        self.citiesItems = {};
	
	                        response.items.forEach(function (item) {
	                            self.citiesItems[item.id] = {
	                                idCountry: item.idCountry,
	                                idRegion: item.idRegion,
	                                name: item.name
	                            };
	                        });
	
	                        self.loader = false;
	                        self.update();
	                    }
	                });
	            } else {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.on('mount', function () {
	        API.request({
	            object: 'GeoCountry',
	            method: 'Fetch',
	            success: function success(response) {
	                self.countriesItems = {};
	                response.items.forEach(function (item) {
	                    self.countriesItems[item.id] = { code: item.code, name: item.name };
	                });
	                self.update();
	            }
	        });
	        API.request({
	            object: 'GeoRegion',
	            method: 'Fetch',
	            success: function success(response) {
	                self.regionsItems = {};
	                response.items.forEach(function (item) {
	                    self.regionsItems[item.id] = { code: item.code, idCountry: item.idCountry, name: item.name };
	                });
	                self.update();
	            }
	        });
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(16), __webpack_require__(5)))

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('delivery-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Справочник доставок\'}</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Delivery" cols="{parent.cols}" reload="true" handlers="{parent.handlers}" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="code">{handlers.types[row.code].name}</datatable-cell>\n          <datatable-cell name="period">{row.period != 0 ? row.period + ⁗ дн.⁗ : ⁗⁗}</datatable-cell>\n          <datatable-cell name="price"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {parseInt(row.price).toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n          <datatable-cell name="note">{row.note}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.collection = 'Delivery';
	    self.handlers = {};
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Тип' }, { name: 'period', value: 'Период' }, { name: 'price', value: 'Цена' }, { name: 'note', value: 'Примечание' }];
	
	    self.on('mount', function () {
	        API.request({
	            object: 'DeliveryType',
	            method: 'Fetch',
	            success: function success(response) {
	                self.handlers.types = {};
	                response.items.forEach(function (item) {
	                    self.handlers.types[item.id] = {
	                        code: item.code,
	                        name: item.name
	                    };
	                });
	            },
	            error: function error(response) {
	                self.handlers.types = {};
	            },
	            complete: function complete() {
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('delivery-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новую доставку</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(367);
	
	riot.tag2('delivery', '  <catalog object="Delivery" cols="{cols}" allselect="true" reload="true" handlers="{handlers}" sortable="true" reorder="true" add="{permission(add, &quot;deliveries&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;deliveries&quot;, &quot;0001&quot;)}" dblclick="{permission(dOpen, &quot;deliveries&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name"><i class="fa {row.status == &quot;Y&quot; ? &quot;fa-eye&quot; : &quot;fa-eye-slash text-noactive&quot;}"></i> {row.name}</datatable-cell>\n      <datatable-cell name="code">{handlers.types[row.code]}</datatable-cell>\n      <datatable-cell name="period"><span> {row.period != 0 ? row.period : ⁗⁗}</span><span style="color: #ccc;">{row.period != 0 ? ⁗ дн.⁗ : ⁗⁗}</span></datatable-cell>\n      <datatable-cell name="price"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {parseInt(row.price).toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Delivery';
	    self.handlers = {
	        types: {
	            simple: 'Простая доставка',
	            region: 'Доставка по регионам',
	            subregion: 'Доставка по регионам с подпункта',
	            ems: 'EMS',
	            post: 'Почта России',
	            sdek: 'СДЭК'
	        }
	    };
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Тип' }, { name: 'period', value: 'Период' }, { name: 'price', value: 'Цена' }, { name: 'note', value: 'Примечание' }];
	
	    //self.add = () => riot.route('/products/delivery/new')
	
	    self.add = function (e) {
	        e.stopPropagation();
	
	        var id, item;
	        if (e.item && e.item.id) {
	            id = e.item.id;
	            item = e.item;
	        }
	
	        modals.create('delivery-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (_this.name.value.toString().trim() != '' && !_this.error) {
	
	                    var params;
	                    params = { name: _this.name.value, code: 'simple' };
	
	                    API.request({
	                        object: 'Delivery',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            //childs.push(response)
	                            popups.create({
	                                title: 'Успех!',
	                                text: 'Доставка добавлена',
	                                style: 'popup-success'
	                            });
	                            self.update();
	                            riot.route('/products/delivery/' + response.id);
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.dOpen = function (e) {
	        return riot.route('/products/delivery/' + e.item.row.id);
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'Delivery',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	            self.update();
	        });
	    });
	
	    self.on('mount', function () {
	        /*API.request({
	            object: 'DeliveryType',
	            method: 'Fetch',
	            success(response) {
	                self.handlers.types = {}
	                response.items.forEach(item => {
	                    self.handlers.types[item.id] = {
	                        code: item.code,
	                        name: item.name
	                    }
	                })
	            },
	            error(response) {
	                self.handlers.types = {}
	            },
	            complete() {
	                self.update()
	            }
	        })*/
	    });
	
	    observable.on('delivery-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(163);
	
	riot.tag2('images-manager', '  <div class="main-container">\n    <div class="col-md-12">\n      <div class="row" if="{!notFound}">\n        <div class="col-sm-10 col-xs-12">\n          <image-gallery name="gallery" dblclick="{dblclick}" autoselect="{autoselect}"></image-gallery>\n        </div>\n      </div>\n    </div>\n  </div>\n', '.main-container { margin: 10px; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.state = {};
	    self.state.section = '';
	
	    self.on('update', function () {
	        if (!self.state.section || self.state.section != localStorage.getItem('CMS_section')) {
	            self.update();
	            self.state.section = localStorage.getItem('SE_section');
	            self.state.limit = self.tags.gallery.pages.limit;
	            self.state.offset = 0;
	
	            self.tags.gallery.update({ params: self.state });
	            self.tags.gallery.reload();
	
	            self.update();
	        }
	    });
	
	    observable.on('images-page-change', function (params) {
	        self.state = params;
	    });
	
	    self.autoselect = function (item) {
	        window.top.opener.CKEDITOR.tools.callFunction(self.callback, item.imageUrl);
	        window.top.close();
	        window.top.opener.focus();
	    };
	
	    self.dblclick = function (e) {
	        self.autoselect(e.item.row);
	    };
	
	    self.menuSelect = function (e) {
	        riot.route('/imageUpload/' + e.target.value);
	    };
	
	    self.on('mount', function () {
	        //riot.route.exec()
	        self.callback = riot.route.query();
	        self.callback = self.callback['CKEditorFuncNum'];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(163);
	
	riot.tag2('images', '  <div class="row" if="{!notFound}">\n    <div class="col-sm-2 hidden-xs">\n      <ul class="nav nav-pills nav-stacked">\n        <li class="{active: name == tab}" each="{tabs}"><a href="#images/{link}">{title}</a></li>\n      </ul>\n    </div>\n    <div class="col-xs-12 hidden-sm hidden-lg hidden-md form-group">\n      <select class="form-control" onchange="{menuSelect}">\n        <option each="{tabs}" value="{name}" __selected="{name == tab}" no-reorder>{title}</option>\n      </select>\n    </div>\n    <div class="col-sm-10 col-xs-12">\n      <image-gallery name="gallery"></image-gallery>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create(),
	        path;
	
	    self.state = {};
	
	    route('/images/*', function (tab) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.notFound = false;
	            self.tab = tab;
	
	            self.tabs.forEach(function (item) {
	                if (item.name == tab) path = item.path;
	            });
	
	            if (!self.state[self.tab]) {
	                self.state[self.tab] = {};
	                self.state[self.tab].section = path;
	                self.state[self.tab].limit = self.tags.gallery.pages.limit;
	                self.state[self.tab].offset = 0;
	            }
	
	            self.tags.gallery.update({ params: self.state[self.tab] });
	            self.tags.gallery.reload();
	
	            self.update();
	        } else {
	            self.notFound = true;
	            self.update();
	            observable.trigger('not-found');
	        }
	    });
	
	    observable.on('images-page-change', function (params) {
	        self.state[self.tab] = params;
	    });
	
	    self.tab = '';
	    self.tabs = [{ title: 'Товары', name: 'products', link: 'products', path: 'shopprice' }, { title: 'Категории товаров', name: 'categories', link: 'categories', path: 'shopgroup' }, { title: 'Новости', name: 'news', link: 'news', path: 'newsimg' }, { title: 'Бренды', name: 'brands', link: 'brands', path: 'shopbrand' }, { title: 'Параметры товаров', name: 'products-options', link: 'products-options', path: 'shopfeature' }, { title: 'Платежные системы', name: 'pay-systems', link: 'pay-systems', path: 'shoppayment' }, { title: 'Контакты', name: 'persons', link: 'persons', path: 'contacts' }, { title: 'Разделы', name: 'sections', link: 'sections', path: 'sections' }, { title: 'Заказы', name: 'orders', link: 'orders', path: 'orders' }];
	
	    self.menuSelect = function (e) {
	        riot.route('/images/' + e.target.value);
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('new-categories-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории новостей</div>\n    </yield>\n    <yield to="body">\n      <catalog object="NewsCategory" cols="{parent.cols}" dblclick="{parent.opts.submit.bind(this)}" reload="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('news-categories-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.title}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="title" value="{item.title}">\n          <div class="help-block">{error.title}</div>\n        </div>\n        <div class="form-group {has-error: error.ident}">\n          <label class="control-label">Код</label>\n          <input class="form-control" name="ident" value="{item.ident}">\n          <div class="help-block">{error.ident}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            title: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        if (opts.id) {
	            modal.loader = true;
	
	            API.request({
	                object: 'NewsCategory',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                },
	                complete: function complete() {
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(372);
	
	riot.tag2('news-categories-list', '  <catalog object="NewsCategory" cols="{cols}" remove="{remove}" dblclick="{addEdit}" add="{addEdit}" reload="true" store="news-categories-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="title">{row.title}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.collection = 'NewsCategory';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }];
	
	    self.addEdit = function (e) {
	        var id = void 0;
	        if (e.item && e.item.row) {
	            id = e.item.row.id;
	        }
	
	        modals.create('news-categories-edit-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'NewsCategory',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            popups.create({ title: 'Успех!', text: 'Категория сохранена!', style: 'popup-success' });
	                            observable.trigger('news-categories-reload');
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    observable.on('news-categories-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(158);
	
	__webpack_require__(371);
	
	__webpack_require__(478);
	
	riot.tag2('news-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#news"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;news&quot;, &quot;0100&quot;) : checkPermission(&quot;news&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4"> {isNew ? item.name || \'Добавление новости\' : item.name || \'Редактирование новости\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#news-edit-home">Основная информация</a></li>\n      <li><a data-toggle="tab" href="#news-edit-images">Галерея</a></li>\n      <li if="{item.customFields &amp;&amp; item.customFields.length}"><a data-toggle="tab" href="#news-edit-fields">Доп. информация</a></li>\n      <li><a data-toggle="tab" href="#news-edit-subscribers">Группы подписчиков</a></li>\n      <li><a data-toggle="tab" href="#news-edit-seo">SEO</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="news-edit-home">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="newsimg" alt="0" size="256" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-8">\n                  <div class="form-group {has-error: error.name}">\n                    <label class="control-label">Заголовок</label>\n                    <input class="form-control" name="name" type="text" value="{item.name}">\n                    <div class="help-block">{error.name}</div>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group {has-error: error.url}">\n                    <label class="control-label">URL</label>\n                    <input class="form-control" name="url" type="text" value="{item.url}">\n                    <div class="help-block">{error.url}</div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Дата</label>\n                    <datetime-picker class="form-control" name="newsDate" format="DD.MM.YYYY" value="{item.newsDateDisplay}" title="Дата публикации"></datetime-picker>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group">\n                    <label class="control-label">Категория</label>\n                    <div class="input-group">\n                      <input class="form-control" name="nameCategory" value="{item.nameCategory}" readonly>\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{changeCategory}"><i class="fa fa-list text-primary"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Регион</label>\n                    <div class="input-group">\n                      <tags class="form-control" name="geoCity" value="{item.geoCity}"></tags><span class="input-group-addon" onclick="{addCity}"><i class="fa fa-plus"></i></span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать на сайте\n                      </label>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group">\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isDatePublic" __checked="{item.isDatePublic}">Отложенная публикация\n                      </label>\n                    </div>\n                    <div class="form-group" if="{item.isDatePublic}">\n                      <datetime-picker class="form-control" name="publicationDate" format="DD.MM.YYYY" value="{item.publicationDateDisplay}"></datetime-picker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Анонс ({countAnonse} из 500 знаков)</label>\n                <textarea class="form-control text-anonse" name="shortTxt" value="{item.shortTxt}" oninput="{changeCountAnonse}"></textarea>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Подробный текст</label>\n                <ckeditor name="text" value="{item.text}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="news-edit-images">\n          <product-edit-images name="images" value="{item.images}" section="newsimg"></product-edit-images>\n        </div>\n        <div class="tab-pane fade" id="news-edit-fields" if="{item.customFields &amp;&amp; item.customFields.length}">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </div>\n        <div class="tab-pane fade" id="news-edit-subscribers">\n          <catalog-static name="subscribersGroups" rows="{item.subscribersGroups}" add="{addSubscribersGroups}" cols="{subscribersGroupsCols}" remove="true">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="news-edit-seo">\n          <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label"> Заголовок</label>\n                  <input class="form-control" name="seotitle" type="text" onfocus="{seoTag.focus}" value="{item.seotitle}">\n                </div>\n                <div class="form-group">\n                  <label class="control-label"> Ключевые слова</label>\n                  <input class="form-control" name="keywords" type="text" onfocus="{seoTag.focus}" value="{item.keywords}">\n                </div>\n                <div class="form-group">\n                  <label class="control-label"> Описание</label>\n                  <textarea class="form-control" rows="5" name="description" onfocus="{seoTag.focus}" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n                </div>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', 'textarea.text-anonse { min-height: 100px; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.isNew = false;
	
	    self.item = {};
	    self.orders = [];
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.countAnonse = 0;
	
	    self.rules = {
	        name: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'News',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	                    self.item = response;
	                    self.update();
	                    if (self.isNew) riot.route('/news/' + self.item.id);
	                    observable.trigger('news-reload');
	                }
	            });
	        }
	    };
	
	    self.changeCategory = function () {
	        modals.create('new-categories-list-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0) {
	                    self.item.idCategory = items[0].id;
	                    self.item.nameCategory = items[0].title;
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    self.subscribersGroupsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.changeCountAnonse = function (e) {
	        var value = e === undefined ? self.item.shortTxt : e.target.value;
	        value = value || '';
	        self.countAnonse = value.length;
	    };
	
	    self.addCity = function () {
	        modals.create('geotargeting-list-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.item.geoCity = self.item.geoCity || [];
	                var items = this.tags.geotargeting.tags.datatable.getSelectedRows();
	                var ids = self.item.geoCity.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) self.item.geoCity.push(item);
	                });
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.addSubscribersGroups = function () {
	        modals.create('persons-category-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.item.subscribersGroups = self.item.subscribersGroups || [];
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.subscribersGroups.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        self.item.subscribersGroups.push(item);
	                    }
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    observable.on('news-new', function (item) {
	        var category = item.category,
	            name = item.name;
	
	        self.error = false;
	        self.isNew = true;
	        self.item = {
	            publicationDate: new Date().toLocaleDateString(),
	            publicationDateDisplay: new Date().toLocaleDateString(),
	            idCategory: category,
	            nameCategory: decodeURI(name)
	        };
	        self.update();
	    });
	
	    observable.on('news-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.loader = true;
	        self.item = {};
	
	        API.request({
	            object: 'News',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                self.loader = false;
	                self.changeCountAnonse();
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'newsimg');
	    });
	
	    self.reload = function () {
	        self.item.id ? observable.trigger('news-edit', self.item.id) : observable.trigger('news-new');
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	riot.tag2('news-list', '  <catalog object="News" search="true" sortable="true" cols="{cols}" reload="true" add="{permission(add, &quot;news&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;news&quot;, &quot;0001&quot;)}" dblclick="{permission(newsOpen, &quot;news&quot;, &quot;1000&quot;)}" store="news-list" new-filter="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">Категории</label>\n            <select class="form-control" data-name="idCategory" onclick="{parent.selectCategory}">\n              <option value="">Все</option>\n              <option each="{category, i in parent.newsCategories}" value="{category.id}" no-reorder>{category.title}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="image"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n      <datatable-cell name="newsDate">{row.newsDateDisplay}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="name">{row.url}</datatable-cell>\n      <datatable-cell name="nameCategory">{row.nameCategory}</datatable-cell>\n      <datatable-cell name="localize">{row.localize}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'News';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'image', value: 'Фото' }, { name: 'newsDate', value: 'Дата публ.' }, { name: 'name', value: 'Заголовок' }, { name: 'url', value: 'URL страницы' }, { name: 'nameCategory', value: 'Категории' }, { name: 'localize', value: 'Регион' }];
	
	    self.add = function () {
	        if (self.selectedCategory) riot.route('/news/new?category=' + self.selectedCategory + '&name=' + self.selectedCategoryName);else riot.route('/news/new');
	    };
	
	    self.newsOpen = function (e) {
	        riot.route('/news/' + e.item.row.id);
	    };
	
	    self.getNewsCategories = function () {
	        API.request({
	            object: 'NewsCategory',
	            method: 'Fetch',
	            success: function success(response) {
	                self.newsCategories = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.selectCategory = function (e) {
	        self.selectedCategory = e.target.value || undefined;
	        self.selectedCategoryName = '';
	        self.newsCategories.forEach(function (item) {
	            if (self.selectedCategory == item.id) {
	                self.selectedCategoryName = item.title;
	            }
	        });
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.on('reload', function () {
	            self.getNewsCategories();
	        });
	    });
	
	    observable.on('news-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    self.getNewsCategories();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(375);
	
	__webpack_require__(374);
	
	__webpack_require__(373);
	
	riot.tag2('news', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}"><a href="#news/{link}"><span>{title}</span></a></li>\n  </ul>\n  <div class="column">\n    <news-list if="{tab == &quot;news&quot; &amp;&amp; !edit}"></news-list>\n    <news-edit if="{tab == &quot;news&quot; &amp;&amp; edit}"></news-edit>\n    <news-categories-list if="{tab == &quot;categories&quot; &amp;&amp; !edit}"></news-categories-list>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.tab = '';
	
	    self.tabs = [{ title: 'Список новостей', name: 'news', link: '' }, { title: 'Категории', name: 'categories', link: 'categories' }];
	
	    route('/news/([0-9]+)', function (id) {
	        self.tab = 'news';
	        observable.trigger('news-edit', id);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/news/new..', function () {
	        var q = riot.route.query();
	        var category = q.category;
	        var name = q.name;
	        self.tab = 'news';
	        self.edit = true;
	        observable.trigger('news-new', { category: category, name: name });
	        self.update();
	    });
	
	    route('/news/*/([0-9]+)', function (tab, id) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: true, tab: tab });
	            observable.trigger(tab + '-edit', id);
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/news', function () {
	        self.edit = false;
	        self.tab = 'news';
	        self.update();
	    });
	
	    route('/news/*', function (tab) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: false, tab: tab });
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/news..', function () {
	        self.update({ edit: true, tab: 'not-found' });
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('not-found', '  <div class="row">\n    <div class="col-md-12 text-center"><i class="fa fa-exclamation-triangle fa-5x text-danger"></i>\n      <div class="h4 text-danger">Страница не найдена</div>\n    </div>\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('order-add-service-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Услуга</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование*</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Цена</label>\n              <input class="form-control" name="price" min="0" max="999999999" value="{item.price}" type="{\'number\'}">\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Скидка</label>\n              <input class="form-control" name="discount" min="0" max="999999999" value="{item.discount}" type="{\'number\'}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Количество</label>\n              <input class="form-control" name="count" min="0.001" step="0.001" max="999999999" value="{item.count}" type="{\'number\'}">\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Итого</label>\n              <input class="form-control" name="total" readonly="true" value="{item.total}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Описание</label>\n              <textarea class="form-control" name="note" cols="2"></textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" if="{!error}" onclick="{parent.opts.submit.bind(this)}" type="button">Добавить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.item = {};
	        modal.item.article = '';
	        modal.item.name = '';
	        modal.error = true;
	        modal.mixin('validation');
	        modal.mixin('change');
	        modal.rules = function () {
	            var rules = {
	                name: 'empty',
	                count: 'empty',
	                price: 'empty'
	            };
	        };
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	        modal.on('update', function () {
	            modal.item.price = modal.item.price || 0;
	            modal.item.discount = modal.item.discount || 0;
	            modal.item.count = modal.item.count || 1;
	            modal.item.total = (modal.item.price - modal.item.discount) * modal.item.count;
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable, app) {'use strict';
	
	__webpack_require__(80);
	
	__webpack_require__(81);
	
	__webpack_require__(366);
	
	__webpack_require__(405);
	
	__webpack_require__(171);
	
	__webpack_require__(394);
	
	__webpack_require__(392);
	
	__webpack_require__(378);
	
	__webpack_require__(33);
	
	__webpack_require__(10);
	
	__webpack_require__(397);
	
	riot.tag2('order-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#orders/{back}" onclick="{backClick}"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;orders&quot;, &quot;0100&quot;) : checkPermission(&quot;orders&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reloadButton}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n      <button class="btn btn-default" if="{item.id &gt; 0}" onclick="{send}" title="Отослать письмо повторно" type="button"><i class="fa fa-paper-plane {text-noactive: item.send}"></i></button>\n    </div>\n    <button class="btn btn-default" if="{!isNew}" onclick="{showOrderLog}" title="Журнал действий" type="button"><i class="fa fa-list-alt"></i></button>\n    <div class="h4">{isNew ? \'Новый заказ\' : \'Редактирование заказа № \' + item.id}<span if="{item.inStock}">&nbsp;<a href="#orders/stock/{item.inStock}" target="_blank">[партия №{item.inStock}]</a></span>&nbsp;<span class="label label-info" if="{!isNew &amp;&amp; item.isAutoReserved}">Забронирован</span>\n      &nbsp;<span class="label label-{item.stageColor}" if="{!isNew &amp;&amp; item.stageStatus}">{item.stageStatus}</span>&nbsp;<span class="label" if="{item.isPaid &amp;&amp; item.isDelete != &quot;Y&quot;}">\n        <label>\n          <datetime-picker class="form-control" if="{!item.inStock}" name="datePayee" format="YYYY-MM-DD" value="{item.datePayee}" icon="glyphicon glyphicon-calendar"></datetime-picker>\n          <input class="form-control" if="{item.inStock}" value="{item.datePayee}" readonly>\n          <div class="help-block">{error.datePayee}</div>\n        </label></span>\n    </div>\n    <div class="tab-content">\n      <div id="order-edit-home">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row">\n            <div class="col-md-6">\n              <div class="row">\n                <div class="col-md-2" if="{!isNew}">\n                  <div class="form-group">\n                    <label class="control-label">Ид</label>\n                    <input class="form-control" name="id" value="{item.id}" readonly>\n                  </div>\n                </div>\n                <div class="col-md-4" if="{!isNew}">\n                  <div class="form-group">\n                    <label class="control-label">Дата заказа</label>\n                    <datetime-picker class="form-control" if="{!item.inStock}" name="dateOrder" format="YYYY-MM-DD HH:mm:ss" value="{item.dateOrder}" icon="glyphicon glyphicon-calendar"></datetime-picker>\n                    <input class="form-control" if="{item.inStock}" value="{item.dateOrder}" readonly>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group {has-error: (error.idAuthor || error.idCompany)}">\n                    <label class="control-label">Заказчик</label><span class="pull-right">Скидка на момент заказа: {item.personalDiscount}%</span>\n                    <div class="input-group">\n                      <div class="input-group-btn" if="{(item.idAuthor || item.idCompany)}"><a class="btn btn-default" target="_blank" href="{item.idAuthor ? &quot;#persons/&quot; + item.idAuthor : &quot;#persons/companies/&quot; + item.idCompany}"><i class="fa fa-eye"></i></a></div>\n                      <input class="form-control" name="idAuthor" value="{(item.idAuthor || item.idCompany) ? &quot;[&quot; + (item.idAuthor || item.idCompany) + &quot;] - &quot; + item.customerEmail : &quot;&quot;}" readonly>\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{changeCustomer}"><i class="fa fa-list"></i></div>\n                      </div>\n                    </div>\n                    <div class="help-block">{(error.idAuthor || error.idCompany)}</div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Оплата</label>\n                    <div class="input-group">\n                      <input class="form-control" name="paymentName" value="{item.paymentName}" readonly>\n                      <div class="input-group-btn" onclick="{changePayment}">\n                        <div class="btn btn-default"><i class="fa fa-list"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Доставка</label>\n                    <div class="input-group">\n                      <input class="form-control" name="deliveryName" value="{item.deliveryName} {item.deliveryNote}" readonly>\n                      <div class="input-group-btn" onclick="{changeDelivery}">\n                        <div class="btn btn-default"><i class="fa fa-list"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isUserPaid" __checked="{item.isUserPaid == 1}">Я оплатил (клиент)\n                </label>\n              </div>\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isPartPaid" __checked="{item.isPartPaid == 1}" onchange="{partPaidChange}">Оплачен частично\n                </label>\n              </div>\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isPaid" __checked="{item.isPaid == 1}" onchange="{paidChange}">Оплачен полностью\n                </label>\n              </div>\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isReserved" __checked="{item.isReserved == 1}" onchange="{reservedChange}">Забронирован\n                </label>\n              </div>\n              <div class="checkbox-inline text-danger pull-right" if="{checkPermission(&quot;settings&quot;, &quot;0010&quot;)}">\n                <label>\n                  <input type="checkbox" name="isFromStock" __checked="{item.isFromStock == 1}">Списать заказ со склада\n                </label>\n              </div>\n            </div>\n          </div><br>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="well well-sm">\n                <catalog-static name="items" rows="{item.items}" cols="{itemsCols}" remove="{true}" handlers="{itemsHandlers}" dblclick="{itemsHandlers.editProduct}">\n                  <yield to="toolbar">\n                    <div class="form-group" if="{true}">\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.addProducts}"><i class="fa fa-plus"></i> Добавить товар</button>\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.itemsToText}" title="Текст"><i class="fa fa-file-text"></i></button>\n                    </div><span class="pull-right"><strong class="text-muted pull-left">Курс BTC: {parent.item.btc}</strong><br><strong class="text-muted pull-left">Курс USDT: {parent.item.usdt}</strong></span>\n                  </yield>\n                  <yield to="body">\n                    <datatable-cell name="article" style="max-width: 60px;">\n                      <input value="{row.article}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell name="nameBrand" style="max-width: 120px;">\n                      <input value="{row.nameBrand}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell name="name" style="min-width: 200px;">\n                      <input value="{row.name}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell class="bg-info" name="count" style="max-width: 20px;">\n                      <input value="{row.count}" step="1" min="1" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-warning" name="stock" style="max-width: 50px;">{row.stock}</datatable-cell>\n                    <datatable-cell class="bg-info" name="price" style="max-width: 50px;">\n                      <input value="{row.price}" step="1.00" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-info" name="amount1" style="max-width: 25px;">{(row.count * row.price).toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-warning" name="personal" style="max-width: 25px;">{row.percentPersonal.toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-warning" name="coupon" style="max-width: 25px;">{row.percentCoupon.toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-warning" name="action" style="max-width: 25px;">{row.percentAction.toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-danger" name="discountPercent" style="max-width: 25px;">\n                      <input value="{(row.discount / row.price * 100).toFixed(0)}" step="0.01" min="0" onchange="{handlers.numberChange2}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-danger" name="discount" style="max-width: 25px;">\n                      <input value="{row.discount}" step="1.00" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-info text-danger" name="price2" style="max-width: 25px;">{((row.price - row.discount)).toFixed(0).toLocaleString()}</datatable-cell>\n                    <datatable-cell class="bg-info" name="amount" style="max-width: 25px;">{(row.count * (row.price - row.discount)).toFixed(0).toLocaleString()}</datatable-cell>\n                  </yield>\n                </catalog-static>\n                <div class="alert alert-danger" if="{error.items}">{error.items}</div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Сумма товаров:</label><strong class="text-info"> {amountProducts}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2" if="{item.paymentName}">\n                    <label>{item.paymentName}:</label><strong class="text-success {text-danger: discountPayment &gt; 0}"> {discountPayment}</strong>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Доставка ({item.deliveryName}):</label><strong class="text-info"> {amountDelivery}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2">\n                    <label>Итого к оплате:</label><strong class="text-primary"> {amountTotal}</strong>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Скидка:</label><strong class="text-success"> {-discountOrder}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2">\n                    <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BTC:</label><strong class="text-primary"> {amountTotalBTC}</strong>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Итого заказ:</label><strong class="text-info"> {amountOrder}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2">\n                    <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;USDT:</label><strong class="text-primary"> {amountTotalUSDT}</strong>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="h4">Информация о доставке/оплате</div>\n          <div class="row">\n            <div class="col-md-6">\n\n              <div class="form-group">\n                <label class="control-label">Реквизиты</label>\n                <input class="form-control" name="requisites" value="{item.requisites}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Карта заказчика</label>\n                <input class="form-control" name="cardUser" value="{item.cardUser}">\n              </div>\n              <div class="form-group">\n                <div class="pull-right">\n                  <div class="checkbox-inline">\n                    <label>\n                      <input type="checkbox" name="isSendCard" __checked="{item.isSendCard}">Отправить карту\n                    </label>\n                  </div>\n                </div>\n                <label class="control-label">Карта для перевода</label>\n                <input class="form-control" name="cardTransfer" value="{item.cardTransfer}" __disabled="{!item.isSendCard}">\n              </div>\n\n              <div class="form-group">\n                <label class="control-label">Пункт доставки</label>\n                <input class="form-control" name="subDelivery" value="{item.subDelivery} ">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Стоимость доставки</label>\n                <input class="form-control" name="deliveryPayee" value="{item.deliveryPayee}" min="0" type="{\'number\'}">\n              </div>\n\n              <div class="form-group">\n                <label class="control-label">Комментарий заказчика</label>\n                <textarea class="form-control" rows="3" name="commentary" style="min-width: 100%; max-width: 100%;" value="{item.commentary}"></textarea>\n              </div>\n            </div>\n            <div class="col-md-6">\n\n              <div class="form-group">\n                <label class="control-label">ФИО</label>\n                <input class="form-control" name="nameRecipient" value="{item.nameRecipient}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Адрес</label>\n                <input class="form-control" name="address" style="min-width: 100%; max-width: 100%;" value="{item.address}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Почтовый индекс</label>\n                <input class="form-control" name="postindex" value="{item.postindex}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Телефон</label>\n                <input class="form-control" name="telnumber" value="{item.telnumber}">\n                <div class="help-block">{error.telnumber}</div>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Трек номер</label>\n                <input class="form-control" name="track" value="{item.track}" readonly>\n              </div>\n\n              <div class="form-group">\n                <label class="control-label">Примечание администратора</label>\n                <textarea class="form-control" rows="3" name="adminCommentary" style="min-width: 100%; max-width: 100%;" value="{item.adminCommentary}"></textarea>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </virtual>\n', '.text-noactive { color: #cccccc; }', '', function (opts) {
	    'use strict';
	
	    var _assign = __webpack_require__(83);
	
	    var _assign2 = _interopRequireDefault(_assign);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this,
	        route = riot.route.create();
	
	    self.isNew = false;
	    self.item = {};
	    self.loader = false;
	    self.sumProducts = 0;
	    self.total = 0;
	    self.snd = false;
	    self.back = '';
	    self.personalDiscount = 5;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.backClick = function () {
	        if (history.length > 2) history.back();else return true;
	    };
	
	    self.send = function () {
	        if (self.item.send) {
	            return;
	        }
	        self.item.send = true;
	        var params = {
	            id: self.item.id,
	            sendcode: 'orduserch'
	        };
	        API.request({
	            object: 'Order',
	            method: 'SendMail',
	            data: params,
	            success: function success(response) {
	                self.snd = false;
	            }
	        });
	
	        self.update();
	    };
	
	    self.rules = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "rules" }));
	
	        var rules = {
	            items: {
	                required: true,
	                rules: [{
	                    type: 'minLength[1]',
	                    prompt: 'В списке должно быть не менее одного элемента'
	                }]
	            }
	        };
	
	        if (self.item.isPaid) rules.datePayee = 'empty';
	
	        if (self.item && (self.item.idAuthor || self.item.idCompany)) return (0, _extends3.default)({}, rules);else return (0, _extends3.default)({}, rules, { idAuthor: 'empty' });
	    };
	
	    self.changeStatus = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeStatus" }));
	
	        if (e.target.value == 'Y') {
	            self.addPayment();
	        }
	    };
	
	    self.afterChange = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "afterChange" }));
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules(), name));
	    };
	
	    self.dynFieldsChange = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dynFieldsChange" }));
	        var type = e.item.field.type;
	
	        if (type !== 'checkbox') {
	            e.item.field.value = e.target.value;
	        } else {
	            var checkedValues = (e.item.field.value || '').split(',');
	            var checkedValue = e.target.getAttribute('data-value');
	            var idx = checkedValues.indexOf(checkedValue);
	
	            if (idx !== -1) checkedValues.splice(idx, 1);else checkedValues.push(checkedValue);
	
	            e.item.field.value = checkedValues.filter(function (i) {
	                return i;
	            }).join(',');
	        }
	    };
	
	    self.itemsCols = [{ name: 'article', value: 'Артикул' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: 'count', value: 'Кол-во' }, { name: 'stock', value: 'Остаток' }, { name: 'price', value: 'Цена1' }, { name: 'amount1', value: 'Сумма1' }, { name: 'personal', value: 'Накоп.' }, { name: 'coupon', value: 'Промо' }, { name: 'action', value: 'Акция' }, { name: 'discountPercent', value: 'Скидка, %' }, { name: 'discount', value: 'Скидка, р.' }, { name: 'price2', value: 'Цена2' }, { name: 'amount', value: 'Сумма2' }];
	
	    self.displayFormat = function (price) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "displayFormat" }));
	
	        return Math.ceil(price);
	
	        if (self.currPrefix != null) return self.currPrefix + ' ' + price.toLocaleString();
	        if (self.currSuffix != null) return price.toLocaleString() + ' ' + self.currSuffix;
	    };
	
	    self.displayFormatBTC = function (price) {
	        return price.toLocaleString() + ' BTC';
	    };
	
	    self.paidChange = function (e) {
	        if (!self.item.isPaid) {
	            self.item.datePayee = new Date().toISOString().split('T')[0];
	            self.item.isPartPaid = 0;
	            self.item.isReserved = 0;
	        }
	    };
	
	    self.partPaidChange = function (e) {
	        if (!self.item.isPartPaid) {
	            self.item.isPaid = 0;
	            self.item.isReserved = 0;
	        }
	    };
	
	    self.reservedChange = function (e) {
	        if (!self.item.isReserved) {
	            self.item.isPaid = 0;
	            self.item.isPartPaid = 0;
	        }
	    };
	
	    /** элементы Обработчики */
	    self.itemsHandlers = {
	        numberChange: function numberChange(e) {
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "numberChange" }));
	            this.row[this.opts.name] = e.target.value;
	        },
	        numberChange2: function numberChange2(e) {
	            this.row['discount'] = (this.row['price'] * e.target.value / 100).toFixed(2);
	            //console.log(this.row['discount'])
	        },
	        stringChange: function stringChange(e) {
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "stringChange" }));
	            this.row[this.opts.name] = e.target.value;
	        },
	        addServices: function addServices() {
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addServices" }));
	            modals.create('order-add-service-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    var _this = this;
	                    if (_this.item.name && _this.item.count > 0) {
	                        _this.item.curr = self.item.curr;
	                        self.item.items = self.item.items || [];
	                        self.item.items.push(_this.item);
	                        self.update();
	                        this.modalHide();
	                    }
	                }
	            });
	        },
	        addProducts: function addProducts() {
	
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts" }));
	
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                groupLog: "addProdD", dComment: ">Добавить self.item.items",
	                dArray: self.item.items }));
	
	            var order = self.item;
	            modals.create('products-list-select-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	
	                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                        groupLog: "addProdD", dComment: "submit данные добавлены",
	                        dArray: self.item.items }));
	
	                    var _this = this;
	                    var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                    self.item.items = self.item.items || [];
	
	                    if (items.length > 0) {
	                        if ('countModifications' in items[0] && items[0].countModifications > 0) {
	                            (function () {
	                                var idPrice = items[0].id;
	                                var brand = items[0].nameBrand;
	                                var article = items[0].article;
	                                var discountValue = items[0].discount;
	                                var additionalDiscount = items[0].additionalDiscount;
	                                modals.create('modifications-list-modal', {
	                                    type: 'modal-primary',
	                                    size: 'modal-lg',
	                                    id: items[0].id,
	                                    submit: function submit() {
	                                        var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
	                                        items.forEach(function (item) {
	                                            var discount = Math.round(item.price * (Math.max(discountValue, self.item.personalDiscount) + additionalDiscount)) / 100;
	                                            self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: discount, id: null, idPrice: idPrice, nameBrand: brand, idsModifications: item.id, article: article, discountValue: discountValue, additionalDiscount: additionalDiscount }));
	                                        });
	                                        self.update();
	                                        this.modalHide();
	                                        _this.modalHide();
	
	                                        var event = document.createEvent('Event');
	                                        event.initEvent('change', true, true);
	                                        self.tags.items.root.dispatchEvent(event);
	                                    }
	                                });
	                            })();
	                        } else {
	                            (function () {
	                                var ids = self.item.items.map(function (item) {
	                                    return item.id;
	                                });
	
	                                var discount = 0;
	
	                                items.forEach(function (item) {
	                                    if (ids.indexOf(item.id) === -1) {
	                                        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                                            groupLog: "addProdD", dComment: "до добавления массив item",
	                                            dArray: item }));
	
	                                        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                                            groupLog: "addProdD", dComment: "до добавления self.item.items",
	                                            dArray: self.item.items }));
	
	                                        discount = Math.round(item.price * (Math.max(item.discount, self.item.personalDiscount) + item.additionalDiscount)) / 100;
	
	                                        self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: discount, id: null, idPrice: item.id, discountValue: item.discount, additionalDiscount: item.additionalDiscount }));
	                                    }
	                                });
	
	                                self.update();
	                                _this.modalHide();
	
	                                var event = document.createEvent('Event');
	                                event.initEvent('change', true, true);
	                                self.tags.items.root.dispatchEvent(event);
	                            })();
	                        }
	                    }
	
	                    // self.convertPrices()
	                }
	            });
	        },
	        editProduct: function editProduct(e) {
	
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "editProduct" }));
	
	            var oldItem = (0, _assign2.default)({}, e.item.row);
	            var index = -1;
	            self.item.items.forEach(function (item, i) {
	                if (item.id === oldItem.id) index = i;
	            });
	
	            if (oldItem.idPrice) {
	
	                if (oldItem["idsModifications"]) {
	                    modals.create('modifications-list-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        id: oldItem.idPrice,
	                        submit: function submit() {
	                            var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
	                            if (items.length > 0) {
	                                self.item.items[index] = (0, _extends3.default)({}, items[0]);
	                                self.item.items[index].id = oldItem.id;
	                                self.item.items[index].count = oldItem.count;
	                                self.item.items[index].discount = oldItem.discount;
	                                self.item.items[index].idPrice = oldItem.idPrice;
	                                self.item.items[index].idsModifications = items[0].id;
	                            }
	
	                            self.update();
	                            this.modalHide();
	
	                            var event = document.createEvent('Event');
	                            event.initEvent('change', true, true);
	                            self.tags.items.root.dispatchEvent(event);
	                        }
	                    });
	                } else {
	                    var filters = {
	                        field: 'id',
	                        value: e.item.row.idPrice
	                    };
	                    modals.create('products-list-select-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        systemFilters: filters,
	                        submit: function submit() {
	                            var _this = this;
	                            var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                            if (items.length > 0) {
	                                self.item.items[index] = (0, _extends3.default)({}, items[0]);
	                                self.item.items[index].id = oldItem.id;
	                                self.item.items[index].count = oldItem.count;
	                                self.item.items[index].discount = oldItem.discount;
	                                self.item.items[index].idPrice = oldItem.id;
	                            }
	
	                            self.update();
	                            _this.modalHide();
	
	                            var event = document.createEvent('Event');
	                            event.initEvent('change', true, true);
	                            self.tags.items.root.dispatchEvent(event);
	                        }
	                    });
	                }
	            } else {}
	        },
	        itemsToText: function itemsToText(e) {
	            modals.create('order-items-to-text', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                item: self.item,
	                submit: function submit(e) {
	                    this.modalHide();
	                }
	            });
	        }
	    };
	
	    self.showOrderLog = function (e) {
	        modals.create('order-log', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            item: self.item,
	            submit: function submit(e) {
	                this.modalHide();
	            }
	        });
	    };
	
	    self.orderItems = {
	        Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	    };
	
	    self.deliveryItems = {
	        Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	    };
	
	    self.changeDelivery = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeDelivery" }));
	        modals.create('delivery-list-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var _this = this;
	                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                self.item.deliveryName = items[0].name;
	                self.item.deliveryType = items[0].id;
	                self.item.deliveryPayee = items[0].price;
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.changePayment = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changePayment" }));
	        modals.create('paysystem-list-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var _this = this;
	                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                self.item.paymentName = items[0].name;
	                self.item.paymentDiscount = items[0].discount;
	                self.item.paymentType = items[0].id;
	                self.item.requisites = items[0].requisites;
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.changeCustomer = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeCustomer" }));
	        modals.create('persons-company-list-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var _this = this.tags['bs-modal'];
	                var items = _this.tags[_this.tab].tags.datatable.getSelectedRows();
	                if (!items.length) return;
	
	                if (_this.tab == 'contacts') {
	                    self.item.idAuthor = items[0].id;
	                    self.item.customer = items[0].displayName;
	                    self.item.customerEmail = items[0].email;
	                    self.item.idCompany = null;
	                    self.item.personalDiscount = Math.max(items[0].discount, items[0].progressiveDiscount);
	                    if (self.isNew && self.item.items) {
	                        self.item.items.forEach(function (item, i) {
	                            item.discount = Math.round(item.price * (Math.max(item.discountValue, self.item.personalDiscount) + item.additionalDiscount)) / 100;
	                        });
	                    }
	                } else {
	                    self.item.idCompany = items[0].id;
	                    self.item.customer = items[0].name;
	                    self.item.idAuthor = null;
	                    self.item.customerEmail = items[0].email;
	                }
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.addPayment = function () {
	
	        /** ПЕРЕРАСЧЕТ ДОПЛАТЫ
	         *  1 подсчет суммы оплаты
	         *  2 подсчет суммы стоимости
	         *  3 подсчет cуммы оставшейся оплаты
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addPayment" }));
	
	        var sumAmountItems = 0;
	        var totalValue = 0;
	        self.item.payments.forEach(function (item) {
	            sumAmountItems += item.amount;
	        }); // 1
	        self.item.items.forEach(function (item) {
	            totalValue += item.count * item.price - item.discount;
	        }); // 2
	        self.item.paid = sumAmountItems;
	        self.item.surcharge = (totalValue - sumAmountItems).toFixed(2); // 3
	
	        /**
	         * @param {array}   self.item.payments     строки платежей
	         * @param {str/int} _this.item.paymentType тип платежа
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addPayment",
	            groupLog: "addPayment", dComment: "данные в payments-add-modal",
	            dArray: self.item }));
	
	        modals.create('payments-add-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            order: self.item,
	            submit: function submit() {
	                var _this = this;
	                if (_this.submit()) {
	
	                    var params = _this.item;
	
	                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addPayment",
	                        groupLog: "addPayment", dComment: "из всплывающего params",
	                        dArray: params }));
	
	                    params["nameFront"] = self.item.pageCurr.nameFront;
	                    params["titleCurr"] = self.item.pageCurr.title;
	
	                    self.getPaymentTypeName(params);
	                    params.payer = self.item.customer;
	                    params.orderAmount = self.item.amount;
	                    if (_this.item.amount + self.item.paid >= self.item.amount) {
	                        self.item.status = 'Y';
	                        self.item.datePayee = _this.item.date;
	                        self.update();
	                    }
	
	                    /** @param {object} params данные платежа */
	                    self.item.payments.push(params);
	                    observable.trigger('datacatalog', { "OrderPaymen": self.item.payments });
	
	                    self.update();
	                    self.tags.catalog.reload();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    self.getPaymentTypeName = function (params) {
	
	        /** получить имя платежной системы
	         * @param  {array}   params.paymentTypeNames данные по типам платежей
	         * @param  {int/str} params.paymentType      id типа платежа
	         * @return {str}     params.name             имя платежной
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getPaymentTypeName" }));
	
	        var paySystemsId = {};
	        params.paymentTypeNames.forEach(function (item) {
	            paySystemsId[item["id"]] = item;
	        });
	        params.name = paySystemsId[Number(params.paymentType)]["name"];
	        delete params.paymentTypeNames;
	    };
	
	    self.removePayment = function (e, itemsToRemove, self) {
	
	        /** удаление групп из временного списка
	         *  (нужно, что бы все группы были на листе - нужны id для allDelete)
	         *  @param  {object}          e             MouseEvent данные мыши
	         *  @param  {array or object} itemsToRemove массив id's на удаление или объект с allMode and allModeLastParams
	         *  @param  {object}          self          данные по контакту
	         *  @return {object}          observable.trigger 'datacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removePayment" }));
	
	        /** если "удалить все" - получаем список id групп для последующего удаления */
	        if (itemsToRemove.allMode != undefined) {
	            itemsToRemove = [];
	            self.items.forEach(function (item) {
	                itemsToRemove.push(item.id);
	            });
	        }
	
	        var iddatacatalog = {};
	        self.datacatalog.OrderPaymen.forEach(function (item) {
	            // получаем id
	            iddatacatalog[item.id] = item;
	        });
	        self.datacatalog.OrderPaymen = []; // чистим
	
	        itemsToRemove.forEach(function (item) {
	            delete iddatacatalog[item]; // удаляем по id
	        });
	
	        for (var item in iddatacatalog) {
	            // возвращаем
	            self.datacatalog.OrderPaymen.push(iddatacatalog[item]);
	        }
	        observable.trigger('datacatalog', self.datacatalog); // записываем в транс-табличные данные
	
	        self.update();
	        return true;
	    };
	
	    self.convertPrices = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices" }));
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
	            groupLog: "addProdD", dComment: "при конвертации self.item.items",
	            dArray: self.item.items }));
	
	        self.item.items.forEach(function (item, i) {
	            if (item.curr != self.item.curr) {
	
	                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
	                    groupLog: "addProdD", dComment: "конвертация item.price",
	                    dArray: { 'price': item.price, 'source': item.curr, 'target': self.item.curr, 'item': item } }));
	
	                var params = { 'price': item.price, 'source': item.curr, 'target': self.item.curr };
	                API.request({
	                    object: 'Currency',
	                    method: 'CONVERT',
	                    data: params,
	                    success: function success(response) {
	                        item.price = response.price;
	                        item.curr = self.item.curr;
	                        self.update();
	                    }
	                });
	            }
	        });
	    };
	
	    self.submit = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit" }));
	
	        /** @param {array} self.payments нумерованный массив платежей */
	
	        var paramsPayments = { "payments": self.item.payments,
	            "idOrder": self.item.id };
	        var params = self.item;
	        params.send = self.snd;
	
	        self.error = self.validation.validate(self.item, self.rules());
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit",
	            groupLog: "submit", dComment: "API Payment Save", dArray: paramsPayments }));
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit",
	            groupLog: "submit", dComment: "API Order Save", dArray: params }));
	
	        if (!self.error) {
	            API.request({
	                object: 'Order',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    self.isNew = false;
	
	                    self.update();
	                    if (self.isNew) riot.route('/orders/' + self.item.id);
	                    popups.create({ title: 'Успех!', text: 'Заказ сохранен!', style: 'popup-success' });
	                    if (self.tags.catalog) self.tags.catalog.reload(); // перезагрузка каталога
	                    //observable.trigger('orders-reload')
	                }
	            });
	        }
	    };
	
	    self.reloadButton = function () {
	
	        /** обновление страницы карточки контакта с всплывающим предупреждением */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadButton" }));
	
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: 'Будут потеряны не сохраненные данные. Вы точно хотите обновить эту страницу?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Обновить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    self.reload();
	                }
	                this.modalHide();
	            }
	        });
	    };
	
	    self.reload = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
	        observable.trigger('orders-edit', self.item.id);
	    }; // перезагрузить
	
	    self.on('update', function () {
	
	        if (self.item && self.item.items) {
	            self.sumProducts = self.item.items.map(function (i) {
	                return i.count * i.price;
	            }).reduce(function (p, c) {
	                return p + c;
	            }, 0);
	            self.sumProductsDsc = self.item.items.map(function (i) {
	                return i.count * (i.price - i.discount);
	            }).reduce(function (p, c) {
	                return p + c;
	            }, 0);
	            if (self.sumProductsDsc < 0) self.sumProductsDsc = 0;
	            var summ = parseFloat(self.sumProductsDsc || 0) - parseFloat(self.item.discount || 0);
	            if (summ < 0) summ = 0;
	            if (parseFloat(self.sumProducts) > 0) self.total = summ + parseFloat(self.item.deliveryPayee || 0);else self.total = 0;
	            //self._amount = self.total + self.total * parseFloat(self.item.paymentDiscount || 0) / 100
	            self.discountOrder = self.displayFormat(self.sumProducts - self.sumProductsDsc);
	            if (self.discountOrder < self.item.coupon) {
	                self.total += self.discountOrder;
	                self.discountOrder = self.item.coupon;
	                self.total -= self.discountOrder;
	            }
	
	            self.discountPayment = self.displayFormat(self.total * parseFloat(self.item.paymentDiscount || 0) / 100);
	            self.amountProducts = self.displayFormat(self.sumProducts);
	            self.amountTotal = self.displayFormat(self.item.amount);
	            self.amountTotalBTC = self.displayFormat(self.item.amount / self.item.btc * 100000) / 100000;
	            self.amountTotalUSDT = self.displayFormat(self.item.amount / self.item.usdt * 100) / 100;
	            self.amountOrder = self.displayFormat(self.total);
	            //self.amountOrderBTC = self.displayFormatBTC((self.total / self.item.btc).toFixed(5))
	            //self.amountProductsBTC = self.displayFormatBTC((self.sumProducts / self.item.btc).toFixed(5))
	            //self.amountProductsWithDiscount = self.displayFormat(self.sumProductsDsc)
	            //self.amountProductsWithDiscountBTC = self.displayFormatBTC((self.sumProductsDsc / self.item.btc).toFixed(5))
	            self.amountDelivery = self.displayFormat(parseFloat(self.item.deliveryPayee || 0));
	        }
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	
	    observable.on('order-new', function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "order-new" }));
	
	        self.error = false;
	        self.isNew = true;
	        self.sumProducts = 0;
	        self.item = {
	            deliveryPayee: 0,
	            personalDiscount: 0,
	            discount: 0,
	            status: 'N',
	            statusOrder: 'N',
	            deliveryStatus: 'N',
	            idAdmin: null,
	            isReserved: 1
	        };
	        if (app.config.idUser && app.config.idUser != 'admin') self.item.idAdmin = app.config.idUser;
	        self.total = 0;
	        self.update();
	        self.getManagers();
	        self.getBaseCurrency();
	
	        API.request({
	            object: 'Order',
	            method: 'fetchBtc',
	            data: {},
	            success: function success(response) {
	                if (response && response.btc) self.item.btc = response.btc;
	            }
	        });
	    });
	
	    observable.on('orders-edit', function (id) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-edit" }));
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-edit",
	            groupLog: "ordersEdit", dComment: "self start",
	            dArray: self }));
	
	        var params = { id: id };
	        params["curr"] = self.item.curr;
	        self.error = false;
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        self.back = '';
	        self.update();
	        self.getManagers();
	
	        var query = riot.route.query();
	
	        if (query && query.back) self.back = query.back;
	
	        API.request({
	            object: 'Order',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-edit",
	                    groupLog: "ordersEdit", dComment: "response", dArray: response }));
	                self.item = response;
	                self.loader = false;
	                self.getBaseCurrency();
	                self.update();
	                if (self.tags.catalog && self.catalogReload) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
	                self.catalogReload = true; // перезагружать каталог, только после первой прогрузки
	            }
	        });
	    });
	
	    observable.on('datacatalog', function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "datacatalog" }));
	
	        /** получение транс-табличных данных
	         *  @param {object} e именаТаблиц-массивыСтрок
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.datacatalog = e;
	        self.item.payments = self.datacatalog.OrderPaymen;
	    });
	
	    self.getManagers = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers" }));
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers", groupLog: "getManagers", dComment: "self", dArray: self }));
	        self.managers = [];
	        API.request({
	            object: 'PermissionUser',
	            method: 'Fetch',
	            success: function success(response) {
	                self.managers = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.getBaseCurrency = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getBaseCurrency" }));
	        API.request({
	            object: 'Main',
	            method: 'Info',
	            success: function success(response) {
	                if (!self.item.curr) self.item.curr = response.basecurr;
	                self.basecurr = response.basecurr;
	                response.listCurrency.forEach(function (item) {
	                    if (item.name.toLowerCase() == self.item.curr.toLowerCase()) {
	                        self.currSuffix = item.nameFlang;
	                        self.currPrefix = item.nameFront;
	                    }
	                });
	                self.update();
	            }
	        });
	    };
	
	    self.debugParam = {
	        module: "order-edit.tag",
	        dClass: "ord-ed",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true,
	            addProdD: false,
	            submit: false,
	            addPayment: false,
	            ordersEdit: false,
	            getManagers: false
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	riot.tag2('order-items-to-text', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Состав заказа № {item.id}</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <button class="btn btn-primary" onclick="{parent.textCopy}" type="button"><i class="fa fa-copy"></i></button>\n          <textarea class="form-control" id="textItems" rows="6" style="min-width: 100%; mi-width: 100%;">{item.text}</textarea>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.textCopy = function () {
	        textItems.select();
	        document.execCommand("copy");
	    };
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        modal.item.text = opts.item.items.map(function (row) {
	            return row.nameBrand + ' ' + row.name + ' ' + row.count;
	        }).reduce(function (text, row) {
	            return text + '\n' + row;
	        });
	        self.update();
	    });
	});
	riot.tag2('order-log', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Журнал действий по заказу № {item.id}</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <datatable cols="{parent.logCols}" rows="{item.log}">\n            <datatable-cell name="action" style="max-width: 60px;">{row.action}</datatable-cell>\n            <datatable-cell name="user" style="max-width: 60px;">{row.user}</datatable-cell>\n            <datatable-cell name="detail" style="max-width: 60px;">{row.detail}</datatable-cell>\n            <datatable-cell name="date" style="max-width: 60px;">{row.date}</datatable-cell>\n          </datatable>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.logCols = [{ name: 'action', value: 'Действие' }, { name: 'user', value: 'Пользователь' }, { name: 'detail', value: 'Дополнительно' }, { name: 'date', value: 'Дата' }];
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(12)))

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('orders-list-archive', '  <catalog object="Order" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" remove="{permission(remove, &quot;orders&quot;, &quot;0001&quot;)}" dblclick="{permission(orderOpen, &quot;orders&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="orders-list-archive" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <input class="hidden" type="checkbox" data-name="isDelete" readonly checked data-bool="Y,N" data-required="true">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n      <div class="dropdown" if="{checkPermission(&quot;orders&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n        <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n        <ul class="dropdown-menu">\n          <li onclick="{handlers.toggleCancel}"><a if="{items[0].isDelete == &quot;N&quot;}" href="#"><i class="fa fa-trash"></i> Отменить</a><a if="{items[0].isDelete == &quot;Y&quot;}" href="#"><i class="fa fa-refresh"></i> Восстановить</a></li>\n        </ul>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell style="width:10px;"><span class="fa fa-fw select-row {row.__selected__ ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}"></span></datatable-cell>\n      <datatable-cell name="id" riot-style="width:100px; {&quot;background: #f9c8f5;&quot;: row.coupon};"><a class="open-page-item" href="#orders/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell class="{bg-danger: row.isPaid , bg-warning: row.isPartPaid}" name="status" style="width:180px;"><i class="fa {row.isViewed ? &quot;fa-eye text-noactive&quot; : &quot;fa-eye-slash&quot;}"></i> {row.status}</datatable-cell>\n      <datatable-cell name="dateOrder" onclick="{handlers.copyText}" style="width:100px;">{row.dateOrderDisplay}</datatable-cell>\n      <datatable-cell name="timeOrder" onclick="{handlers.copyText}" style="width:100px;">{row.timeOrder}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}" style="width:100px;"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(0)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="personalDiscount" onclick="{handlers.copyText}" style="width:100px;">{row.personalDiscount.toFixed(0)}%</datatable-cell>\n      <datatable-cell name="couponDiscount" onclick="{handlers.copyText}" style="width:100px;">{(row.coupon > 0) ? row.coupon.toFixed(0) : row.couponDiscount.toFixed(0)+\'%\'}</datatable-cell>\n      <datatable-cell name="customerEmail" onclick="{handlers.copyText}" style="width:180px;">{row.customerEmail}</datatable-cell>\n      <datatable-cell name="paymentName" onclick="{handlers.copyText}" style="width:180px;">{row.paymentName}</datatable-cell>\n      <datatable-cell name="deliveryName" onclick="{handlers.copyText}" style="width:180px;">{row.deliveryName}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Order';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: '', value: '' }, { name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус' }, { name: 'dateOrder', value: 'Дата' }, { name: 'timeOrder', value: 'Время' }, { name: 'amount', value: 'Сумма' }, { name: 'personalDiscount', value: 'Скидка' }, { name: 'couponDiscount', value: 'Промокод' }, { name: 'customerEmail', value: 'Email' }, { name: 'paymentName', value: 'Оплата' }, { name: 'deliveryName', value: 'Доставка' }, { name: 'commentary', value: 'Комментарий заказчика' }];
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', A: '#FFFF00', K: '#FFAAAA', P: null, W: null, C: null, T: null
	            Y: 'bg-success', N: 'bg-danger', A: 'bg-warning', K: 'bg-info', D: 'bg-danger', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', M: null, P: null
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlers = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText,
	        toggleCancel: function toggleCancel(e) {
	            var rows = this.tags.datatable.getSelectedRows();
	
	            var params = self.tags.catalog.getSelectedMode();
	            params['isDelete'] = rows[0]['isDelete'] === 'Y' ? 'N' : 'Y';
	
	            params['restore'] = rows[0]['isDelete'] === 'Y';
	
	            API.request({
	                object: 'Order',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        }
	    };
	
	    self.orderOpen = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orderOpen" }));
	        riot.route('/orders/' + e.item.row.id + '?back=archive');
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getAggregation" }));
	        self.totalAmount = parseFloat(response.totalAmount);
	        self.currTotal = response.currTotal;
	        if (response.counts) observable.trigger('tabs-update', response.counts);
	    };
	
	    self.add = function () {
	        return riot.route('/orders/new');
	    };
	
	    observable.on('orders-reload', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-reload" }));
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    function copyToClipboard(elem) {
	        //self.debuger({ ...self.debugParam, method:"copyToClipboard" })
	        var target = {};
	        // create hidden text element, if it doesn't already exist
	        var targetId = "_hiddenCopyText_";
	        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	        var origSelectionStart, origSelectionEnd;
	        if (isInput) {
	            // can just use the original source element for the selection and copy
	            target.assign(elem);
	            origSelectionStart = target.selectionStart;
	            origSelectionEnd = target.selectionEnd;
	        } else {
	            // must use a temporary form element for the selection and copy
	            target = document.getElementById(targetId);
	            if (!target) {
	                var target = document.createElement("textarea");
	                target.style.position = "absolute";
	                target.style.left = "-9999px";
	                target.style.top = "0";
	                target.id = targetId;
	                document.body.appendChild(target);
	            }
	            target.textContent = target.textContent.trim();
	        }
	        // select the content
	        var currentFocus = document.activeElement;
	        target.focus();
	        target.setSelectionRange(0, target.value.length);
	
	        // copy the selection
	        var succeed;
	        try {
	            succeed = document.execCommand("copy");
	        } catch (e) {
	            succeed = false;
	        }
	        /*
	        // restore original focus
	        if (currentFocus && typeof currentFocus.focus === "function") {
	            currentFocus.focus();
	        }
	             if (isInput) {
	            // restore prior selection
	            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	        } else {
	            // clear temporary content
	            target.textContent = "";
	        }
	        */
	        return succeed;
	    }
	
	    self.debugParam = {
	        module: "orders-list.tag",
	        dClass: "orders-list",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('orders-list-check', '  <catalog object="OrderCheck" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" dblclick="{permission(orderOpen, &quot;orders&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="orders-list-check" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <input class="hidden" type="checkbox" data-name="isSentUser" readonly data-required="true">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n      <div class="dropdown" if="{checkPermission(&quot;orders&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n        <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n        <ul class="dropdown-menu">\n          <li onclick="{handlers.sendToUser}"><a href="#"><i class="fa fa-paper-plane"></i> Отправить клиенту</a></li>\n          <li onclick="{handlers.sendToSent}"><a href="#"><i class="fa fa-share"></i> Перенести в отправленные</a></li>\n          <li class="divider"></li>\n          <li onclick="{handlers.cancelOrder}"><a href="#"><i class="fa fa-share-square-o fa-flip-horizontal"></i> Вернуть в оплаченные</a></li>\n        </ul>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell style="width:10px;"><span class="fa fa-fw select-row {row.__selected__ ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}"></span></datatable-cell>\n      <datatable-cell name="id" style="width:100px;"><a class="open-page-item" href="#orders/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="inStock" style="width:100px;"><a class="open-page-item" href="#orders/stock/{row.inStock}" target="_blank">{row.inStock}</a></datatable-cell>\n      <datatable-cell name="dateOrder" onclick="{handlers.copyText}" style="width:100px;">{row.dateOrderDisplay}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}" style="width:100px;"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(0)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="customerEmail" onclick="{handlers.copyText}">{row.customerEmail}</datatable-cell>\n      <datatable-cell name="nameRecipient" onclick="{handlers.copyText}">{row.nameRecipient}</datatable-cell>\n      <datatable-cell name="track" onclick="{handlers.copyText}">{row.track}</datatable-cell>\n      <datatable-cell name="image">\n        <button class="btn btn-sm btn-success" onclick="{handlers.showImages}" __disabled="{!row.images}"><i class="fa fa-picture-o"></i></button>\n      </datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'OrderCheck';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: '', value: '' }, { name: 'id', value: 'Заказ' }, { name: 'inStock', value: 'Партия' }, { name: 'dateOrder', value: 'Дата' }, { name: 'amount', value: 'Сумма' }, { name: 'customerEmail', value: 'Email' }, { name: 'nameRecipient', value: 'ФИО' }, { name: 'track', value: 'Трек номер' }, { name: 'image', value: 'Фото' }];
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', A: '#FFFF00', K: '#FFAAAA', P: null, W: null, C: null, T: null
	            Y: 'bg-success', N: 'bg-danger', A: 'bg-warning', K: 'bg-info', D: 'bg-danger', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', M: null, P: null
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlers = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText,
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        },
	        sendToSent: function sendToSent(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['isSentUser'] = true;
	
	            API.request({
	                object: 'OrderCheck',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        cancelOrder: function cancelOrder(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['cancelOrder'] = true;
	
	            API.request({
	                object: 'OrderCheck',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        sendToUser: function sendToUser(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['sendToUser'] = true;
	
	            API.request({
	                object: 'OrderCheck',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        showImages: function showImages(e) {
	            modals.create('order-image-modal', {
	                type: 'modal-primary',
	                item: e.item.row,
	                images: opts.images,
	                submit: function submit() {
	                    //e.item.row = this.item
	                    this.modalHide();
	                    //self.update()
	                }
	            });
	        }
	    };
	
	    self.orderOpen = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orderOpen" }));
	        riot.route('/orders/' + e.item.row.id + '?back=check');
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getAggregation" }));
	        self.totalAmount = parseFloat(response.totalAmount);
	        self.currTotal = response.currTotal;
	        if (response.counts) observable.trigger('tabs-update', response.counts);
	    };
	
	    self.add = function () {
	        return riot.route('/orders/new');
	    };
	
	    observable.on('orders-reload', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-reload" }));
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    function copyToClipboard(elem) {
	        //self.debuger({ ...self.debugParam, method:"copyToClipboard" })
	        var target = {};
	        // create hidden text element, if it doesn't already exist
	        var targetId = "_hiddenCopyText_";
	        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	        var origSelectionStart, origSelectionEnd;
	        if (isInput) {
	            // can just use the original source element for the selection and copy
	            target.assign(elem);
	            origSelectionStart = target.selectionStart;
	            origSelectionEnd = target.selectionEnd;
	        } else {
	            // must use a temporary form element for the selection and copy
	            target = document.getElementById(targetId);
	            if (!target) {
	                var target = document.createElement("textarea");
	                target.style.position = "absolute";
	                target.style.left = "-9999px";
	                target.style.top = "0";
	                target.id = targetId;
	                document.body.appendChild(target);
	            }
	            target.textContent = target.textContent.trim();
	        }
	        // select the content
	        var currentFocus = document.activeElement;
	        target.focus();
	        target.setSelectionRange(0, target.value.length);
	
	        // copy the selection
	        var succeed;
	        try {
	            succeed = document.execCommand("copy");
	        } catch (e) {
	            succeed = false;
	        }
	        /*
	        // restore original focus
	        if (currentFocus && typeof currentFocus.focus === "function") {
	            currentFocus.focus();
	        }
	             if (isInput) {
	            // restore prior selection
	            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	        } else {
	            // clear temporary content
	            target.textContent = "";
	        }
	        */
	        return succeed;
	    }
	
	    self.debugParam = {
	        module: "orders-list-paid.tag",
	        dClass: "orders-list-paid",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	riot.tag2('order-image-modal', '  <bs-modal>\n    <yield to="body">\n      <form action="">\n        <div class="row">\n          <div class="col-md-12">\n            <product-edit-images name="images" value="{item.images}" section="orders" hidecatalog="true"></product-edit-images>\n          </div>\n        </div>\n      </form>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        modal.images = opts.images || {};
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	__webpack_require__(389);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('orders-list-paid', '  <catalog object="OrderPaid" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" remove="{permission(remove, &quot;orders-paid&quot;, &quot;0001&quot;)}" dblclick="{permission(orderOpen, &quot;orders&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="orders-list-paid" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">Склад</label>\n            <select class="form-control" data-name="isStock">\n              <option value="">Все</option>\n              <option value="1">На складе</option>\n              <option value="0">Нет</option>\n            </select>\n\n          </div>\n\n\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n      <div class="dropdown" if="{checkPermission(&quot;orders&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n        <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n        <ul class="dropdown-menu">\n          <li onclick="{handlers.sendToStock}"><a href="#"><i class="fa fa-share-square-o"></i> Отправить на склад</a></li>\n          <li onclick="{handlers.addToPart}"><a href="#"><i class="fa fa-plus-square"></i> Добавить в партию</a></li>\n        </ul>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell style="width:10px;"><span class="fa fa-fw select-row {row.__selected__ ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}"></span></datatable-cell>\n      <datatable-cell name="id" style="width:100px;"><a class="open-page-item" href="#orders/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell class="{bg-danger: (row.isPaid), bg-warning: (row.isPartPaid), bg-success: (row.isSentUser)}" name="status" style="width:180px;">{row.status}</datatable-cell>\n      <datatable-cell name="dateOrder" onclick="{handlers.copyText}" style="width:100px;">{row.dateOrderDisplay}</datatable-cell>\n      <datatable-cell name="timeOrder" onclick="{handlers.copyText}" style="width:100px;">{row.timeOrder}</datatable-cell>\n      <datatable-cell name="datePayee" onclick="{handlers.copyText}" style="width:100px;">{row.datePayeeDisplay}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}" style="width:100px;"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(0)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="personalDiscount" onclick="{handlers.copyText}" style="width:100px;">{row.personalDiscount.toFixed(0)}%</datatable-cell>\n\n      <datatable-cell name="customerEmail" onclick="{handlers.copyText}" style="width:180px;">{row.customerEmail}</datatable-cell>\n      <datatable-cell name="paymentName" onclick="{handlers.copyText}" style="width:180px;">{row.paymentName}</datatable-cell>\n      <datatable-cell name="deliveryName" onclick="{handlers.copyText}" style="width:180px;">{row.deliveryName}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'OrderPaid';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: '', value: '' }, { name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус' }, { name: 'dateOrder', value: 'Дата' }, { name: 'timeOrder', value: 'Время' }, { name: 'datePayee', value: 'Дата оплаты' }, { name: 'amount', value: 'Сумма' }, { name: 'personalDiscount', value: 'Скидка' },
	    //{ name: 'idStock' , value: 'Партия' },
	    { name: 'customerEmail', value: 'Email' }, { name: 'paymentName', value: 'Оплата' }, { name: 'deliveryName', value: 'Доставка' }, { name: 'commentary', value: 'Комментарий заказчика' }];
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', A: '#FFFF00', K: '#FFAAAA', P: null, W: null, C: null, T: null
	            Y: 'bg-success', N: 'bg-danger', A: 'bg-warning', K: 'bg-info', D: 'bg-danger', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', M: null, P: null
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlers = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText,
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        },
	        sendToStock: function sendToStock(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['toStock'] = true;
	
	            API.request({
	                object: 'OrderPaid',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        addToPart: function addToPart(e) {
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addToPart" }));
	            modals.create('stock-list-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                    var params = self.tags.catalog.getSelectedMode();
	                    params['toPart'] = { id: items[0].id, name: items[0].name };
	
	                    API.request({
	                        object: 'OrderPaid',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags.catalog.reload();
	                        }
	                    });
	                    this.modalHide();
	                }
	            });
	        }
	    };
	
	    self.orderOpen = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orderOpen" }));
	        riot.route('/orders/' + e.item.row.id + '?back=paid');
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getAggregation" }));
	        self.totalAmount = parseFloat(response.totalAmount);
	        self.currTotal = response.currTotal;
	        if (response.counts) observable.trigger('tabs-update', response.counts);
	    };
	
	    self.add = function () {
	        return riot.route('/orders/new');
	    };
	
	    observable.on('orders-reload', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-reload" }));
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    function copyToClipboard(elem) {
	        //self.debuger({ ...self.debugParam, method:"copyToClipboard" })
	        var target = {};
	        // create hidden text element, if it doesn't already exist
	        var targetId = "_hiddenCopyText_";
	        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	        var origSelectionStart, origSelectionEnd;
	        if (isInput) {
	            // can just use the original source element for the selection and copy
	            target.assign(elem);
	            origSelectionStart = target.selectionStart;
	            origSelectionEnd = target.selectionEnd;
	        } else {
	            // must use a temporary form element for the selection and copy
	            target = document.getElementById(targetId);
	            if (!target) {
	                var target = document.createElement("textarea");
	                target.style.position = "absolute";
	                target.style.left = "-9999px";
	                target.style.top = "0";
	                target.id = targetId;
	                document.body.appendChild(target);
	            }
	            target.textContent = target.textContent.trim();
	        }
	        // select the content
	        var currentFocus = document.activeElement;
	        target.focus();
	        target.setSelectionRange(0, target.value.length);
	
	        // copy the selection
	        var succeed;
	        try {
	            succeed = document.execCommand("copy");
	        } catch (e) {
	            succeed = false;
	        }
	        /*
	        // restore original focus
	        if (currentFocus && typeof currentFocus.focus === "function") {
	            currentFocus.focus();
	        }
	             if (isInput) {
	            // restore prior selection
	            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	        } else {
	            // clear temporary content
	            target.textContent = "";
	        }
	        */
	        return succeed;
	    }
	
	    self.debugParam = {
	        module: "orders-list-paid.tag",
	        dClass: "orders-list-paid",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('orders-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Заказы</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Order" cols="{parent.cols}" search="true" reload="false" disable-col-select="1" dblclick="{parent.opts.submit.bind(this)}" filters="{parent.filters}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="dateOrder">{row.dateOrderDisplay}</datatable-cell>\n          <datatable-cell name="customer">{row.customer}</datatable-cell>\n          <datatable-cell name="amount"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'dateOrder', value: 'Дата' }, { name: 'customer', value: 'Заказчик' }, { name: 'amount', value: 'Сумма' }];
	
	    self.filters = [{ "field": "is_delete",
	        "value": "N"
	    }, { "field": "status",
	        "sign": "<>",
	        "value": "Y"
	    }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('orders-list-sent', '  <catalog object="OrderCheck" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" dblclick="{permission(orderOpen, &quot;orders&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="orders-list-sent" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <input class="hidden" type="checkbox" data-name="isSentUser" checked readonly data-required="true">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n      <div class="dropdown" if="{checkPermission(&quot;orders&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n        <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n        <ul class="dropdown-menu">\n          <li onclick="{handlers.sendToUser}"><a href="#"><i class="fa fa-paper-plane"></i> Повторно отправить</a></li>\n          <li class="divider"></li>\n          <li onclick="{handlers.cancelOrder}"><a href="#"><i class="fa fa-share-square-o fa-flip-horizontal"></i> Вернуть в оплаченные</a></li>\n        </ul>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell style="width:10px;"><span class="fa fa-fw select-row {row.__selected__ ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}"></span></datatable-cell>\n      <datatable-cell name="id" style="width:100px;"><a class="open-page-item" href="#orders/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="inStock" style="width:100px;"><a class="open-page-item" href="#orders/stock/{row.inStock}" target="_blank">{row.inStock}</a></datatable-cell>\n      <datatable-cell name="dateOrder" onclick="{handlers.copyText}" style="width:100px;">{row.dateOrderDisplay}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}" style="width:100px;"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="customerEmail" onclick="{handlers.copyText}">{row.customerEmail}</datatable-cell>\n      <datatable-cell name="nameRecipient" onclick="{handlers.copyText}">{row.nameRecipient}</datatable-cell>\n      <datatable-cell name="track" onclick="{handlers.copyText}">{row.track}</datatable-cell>\n      <datatable-cell name="image">\n        <button class="btn btn-sm btn-success" onclick="{handlers.showImages}" __disabled="{!row.images}"><i class="fa fa-picture-o"></i></button>\n      </datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'OrderCheck';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: '', value: '' }, { name: 'id', value: 'Заказ' }, { name: 'inStock', value: 'Партия' }, { name: 'dateOrder', value: 'Дата' }, { name: 'amount', value: 'Сумма' }, { name: 'customerEmail', value: 'Email' }, { name: 'nameRecipient', value: 'ФИО' }, { name: 'track', value: 'Трек номер' }, { name: 'image', value: 'Фото' }];
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', A: '#FFFF00', K: '#FFAAAA', P: null, W: null, C: null, T: null
	            Y: 'bg-success', N: 'bg-danger', A: 'bg-warning', K: 'bg-info', D: 'bg-danger', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', M: null, P: null
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlers = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText,
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        },
	        sendToUser: function sendToUser(e) {
	            var rows = this.tags.datatable.getSelectedRows();
	
	            var params = self.tags.catalog.getSelectedMode();
	            params['sendToUser'] = true;
	
	            API.request({
	                object: 'OrderCheck',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        cancelOrder: function cancelOrder(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['cancelOrder'] = true;
	
	            API.request({
	                object: 'OrderCheck',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        showImages: function showImages(e) {
	            modals.create('order-image-modal', {
	                type: 'modal-primary',
	                item: e.item.row,
	                images: opts.images,
	                submit: function submit() {
	                    //e.item.row = this.item
	                    this.modalHide();
	                    //self.update()
	                }
	            });
	        }
	    };
	
	    self.orderOpen = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orderOpen" }));
	        riot.route('/orders/' + e.item.row.id + '?back=sent');
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getAggregation" }));
	        self.totalAmount = parseFloat(response.totalAmount);
	        self.currTotal = response.currTotal;
	        if (response.counts) observable.trigger('tabs-update', response.counts);
	    };
	
	    self.add = function () {
	        return riot.route('/orders/new');
	    };
	
	    observable.on('orders-reload', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-reload" }));
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    function copyToClipboard(elem) {
	        //self.debuger({ ...self.debugParam, method:"copyToClipboard" })
	        var target = {};
	        // create hidden text element, if it doesn't already exist
	        var targetId = "_hiddenCopyText_";
	        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	        var origSelectionStart, origSelectionEnd;
	        if (isInput) {
	            // can just use the original source element for the selection and copy
	            target.assign(elem);
	            origSelectionStart = target.selectionStart;
	            origSelectionEnd = target.selectionEnd;
	        } else {
	            // must use a temporary form element for the selection and copy
	            target = document.getElementById(targetId);
	            if (!target) {
	                var target = document.createElement("textarea");
	                target.style.position = "absolute";
	                target.style.left = "-9999px";
	                target.style.top = "0";
	                target.id = targetId;
	                document.body.appendChild(target);
	            }
	            target.textContent = target.textContent.trim();
	        }
	        // select the content
	        var currentFocus = document.activeElement;
	        target.focus();
	        target.setSelectionRange(0, target.value.length);
	
	        // copy the selection
	        var succeed;
	        try {
	            succeed = document.execCommand("copy");
	        } catch (e) {
	            succeed = false;
	        }
	        /*
	        // restore original focus
	        if (currentFocus && typeof currentFocus.focus === "function") {
	            currentFocus.focus();
	        }
	             if (isInput) {
	            // restore prior selection
	            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	        } else {
	            // clear temporary content
	            target.textContent = "";
	        }
	        */
	        return succeed;
	    }
	
	    self.debugParam = {
	        module: "orders-list-paid.tag",
	        dClass: "orders-list-paid",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	riot.tag2('order-image-modal', '  <bs-modal>\n    <yield to="body">\n      <form action="">\n        <div class="row">\n          <div class="col-md-12">\n            <product-edit-images name="images" value="{item.images}" section="orders" hidecatalog="true"></product-edit-images>\n          </div>\n        </div>\n      </form>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        modal.images = opts.images || {};
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('orders-list', '  <catalog object="Order" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" add="{permission(add, &quot;orders&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;orders&quot;, &quot;0001&quot;)}" dblclick="{permission(orderOpen, &quot;orders&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="orders-list" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <input class="hidden" type="checkbox" data-name="isDelete" readonly data-bool="Y,N" data-required="true">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="checkbox-inline">\n              <input type="checkbox" data-name="isViewed" data-bool="0,1">Непросмотренные\n            </label>\n          </div>\n          <div class="form-group">\n            <label class="checkbox-inline">\n              <input type="checkbox" data-name="isUserPaid">Поступила оплата\n            </label>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n      <div class="dropdown" if="{checkPermission(&quot;orders&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n        <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n        <ul class="dropdown-menu">\n          <li onclick="{handlers.cancelViewed}"><a href="#"><i class="fa fa-eye-slash"></i> Отметить непросмотренным</a></li>\n          <li class="divider"></li>\n          <li onclick="{handlers.sendEmailOrder}"><a href="#"><i class="fa fa-paper-plane"></i> Отправить письмо о заказе</a></li>\n\n        </ul>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell style="width:10px;"><span class="fa fa-fw select-row {row.__selected__ ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}"></span></datatable-cell>\n      <datatable-cell name="id" riot-style="width:100px; {&quot;background: #f9c8f5;&quot;: row.coupon};"><a class="open-page-item" href="#orders/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell class="{bg-danger: row.isUserPaid, bg-info: row.isReserved, bg-danger: row.cardUser &amp;&amp; !row.isSendCard}" name="status" riot-style="width:180px;{&quot;background: #ffdb85;&quot;: row.paymentStatus==1 &amp;&amp; !row.cardUser};"><i class="fa {row.isViewed ? &quot;fa-eye text-noactive&quot; : &quot;fa-eye-slash&quot;}"></i> {row.status}</datatable-cell>\n      <datatable-cell name="dateOrder" onclick="{handlers.copyText}" style="width:100px;">{row.dateOrderDisplay}</datatable-cell>\n      <datatable-cell name="timeOrder" onclick="{handlers.copyText}" style="width:100px;">{row.timeOrder}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}" style="width:100px;"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(0)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="personalDiscount" onclick="{handlers.copyText}" style="width:100px;">{row.personalDiscount.toFixed(0)}%</datatable-cell>\n      <datatable-cell name="couponDiscount" onclick="{handlers.copyText}" style="width:100px;">{(row.coupon > 0) ? row.coupon.toFixed(0) : row.couponDiscount.toFixed(0)+\'%\'}</datatable-cell>\n      <datatable-cell name="customerEmail" onclick="{handlers.copyText}" style="width:180px;">{row.customerEmail}</datatable-cell>\n      <datatable-cell name="paymentName" onclick="{handlers.copyText}" style="width:180px;">{row.paymentName}</datatable-cell>\n      <datatable-cell name="deliveryName" onclick="{handlers.copyText}" style="width:180px;">{row.deliveryName}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Order';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: '', value: '' }, { name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус' }, { name: 'dateOrder', value: 'Дата' }, { name: 'timeOrder', value: 'Время' }, { name: 'amount', value: 'Сумма' }, { name: 'personalDiscount', value: 'Скидка' }, { name: 'couponDiscount', value: 'Промокод' }, { name: 'customerEmail', value: 'Email' }, { name: 'paymentName', value: 'Оплата' }, { name: 'deliveryName', value: 'Доставка' }, { name: 'commentary', value: 'Комментарий заказчика' }];
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', A: '#FFFF00', K: '#FFAAAA', P: null, W: null, C: null, T: null
	            Y: 'bg-success', N: 'bg-danger', A: 'bg-warning', K: 'bg-info', D: 'bg-danger', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            //Y: '#98FB98', N: '#FFC1C1', M: null, P: null
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlers = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText,
	        cancelViewed: function cancelViewed(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['isViewed'] = 0;
	
	            API.request({
	                object: 'Order',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        toggleCancel: function toggleCancel(e) {
	            var rows = this.tags.datatable.getSelectedRows();
	
	            var params = self.tags.catalog.getSelectedMode();
	            params['isDelete'] = rows[0]['isDelete'] === 'Y' ? 'N' : 'Y';
	
	            API.request({
	                object: 'Order',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	        sendEmailOrder: function sendEmailOrder(e) {
	            var params = self.tags.catalog.getSelectedMode();
	            params['sendEmailOrder'] = true;
	
	            API.request({
	                object: 'Order',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.tags.catalog.reload();
	                }
	            });
	        },
	
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        }
	    };
	
	    self.orderOpen = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orderOpen" }));
	        riot.route('/orders/' + e.item.row.id + '?back=new');
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getAggregation" }));
	        self.totalAmount = parseFloat(response.totalAmount);
	        self.currTotal = response.currTotal;
	        if (response.counts) observable.trigger('tabs-update', response.counts);
	    };
	
	    self.add = function () {
	        return riot.route('/orders/add');
	    };
	
	    observable.on('orders-reload', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-reload" }));
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    function copyToClipboard(elem) {
	        //self.debuger({ ...self.debugParam, method:"copyToClipboard" })
	        var target = {};
	        // create hidden text element, if it doesn't already exist
	        var targetId = "_hiddenCopyText_";
	        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	        var origSelectionStart, origSelectionEnd;
	        if (isInput) {
	            // can just use the original source element for the selection and copy
	            target.assign(elem);
	            origSelectionStart = target.selectionStart;
	            origSelectionEnd = target.selectionEnd;
	        } else {
	            // must use a temporary form element for the selection and copy
	            target = document.getElementById(targetId);
	            if (!target) {
	                var target = document.createElement("textarea");
	                target.style.position = "absolute";
	                target.style.left = "-9999px";
	                target.style.top = "0";
	                target.id = targetId;
	                document.body.appendChild(target);
	            }
	            target.textContent = target.textContent.trim();
	        }
	        // select the content
	        var currentFocus = document.activeElement;
	        target.focus();
	        target.setSelectionRange(0, target.value.length);
	
	        // copy the selection
	        var succeed;
	        try {
	            succeed = document.execCommand("copy");
	        } catch (e) {
	            succeed = false;
	        }
	        /*
	        // restore original focus
	        if (currentFocus && typeof currentFocus.focus === "function") {
	            currentFocus.focus();
	        }
	             if (isInput) {
	            // restore prior selection
	            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	        } else {
	            // clear temporary content
	            target.textContent = "";
	        }
	        */
	        return succeed;
	    }
	
	    self.debugParam = {
	        module: "orders-list.tag",
	        dClass: "orders-list",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(385);
	
	__webpack_require__(379);
	
	__webpack_require__(382);
	
	__webpack_require__(390);
	
	__webpack_require__(388);
	
	__webpack_require__(381);
	
	__webpack_require__(384);
	
	__webpack_require__(380);
	
	__webpack_require__(391);
	
	__webpack_require__(387);
	
	riot.tag2('orders', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: link == tab}" each="{tabs}" if="{checkPermission(permission, 1000)}"><a href="#orders/{link}"><span>{title}</span>&nbsp;<span class="badge" if="{isCount}">{count}</span></a></li>\n  </ul>\n  <div class="column">\n    <orders-list if="{tab == &quot;new&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-new&quot;, 1000)}"></orders-list>\n    <orders-list-paid if="{tab == &quot;paid&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-paid&quot;, 1000)}"></orders-list-paid>\n    <stock-list if="{tab == &quot;stock&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-stock&quot;, 1000)}"></stock-list>\n    <orders-list-check if="{tab == &quot;check&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-check&quot;, 1000)}"></orders-list-check>\n    <orders-list-sent if="{tab == &quot;sent&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-sent&quot;, 1000)}"></orders-list-sent>\n    <orders-list-archive if="{tab == &quot;archive&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-archive&quot;, 1000)}"></orders-list-archive>\n    <warehouse-list if="{tab == &quot;warehouse&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-archive&quot;, 1000)}"></warehouse-list>\n    <sales-list if="{tab == &quot;sales&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-archive&quot;, 1000)}"></sales-list>\n    <order-edit if="{tab == &quot;&quot; &amp;&amp; edit}"></order-edit>\n    <stock-edit if="{tab == &quot;stock&quot; &amp;&amp; edit}"></stock-edit>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	
	    self.tab = '';
	
	    self.tabs = [{ title: 'Новые', name: 'orders', link: 'new', tag: 'orders-list', count: 0, permission: 'orders-new', isCount: true }, { title: 'Оплаченные', name: 'paid', link: 'paid', tag: 'orders-list-paid', count: 0, permission: 'orders-paid' }, { title: 'Склад', name: 'stock', link: 'stock', tag: 'stock-list', count: 0, permission: 'stock' }, { title: 'На проверке', name: 'check', link: 'check', tag: 'orders-list-check', count: 0, permission: 'orders-check', isCount: true }, { title: 'Отправленные', name: 'sent', link: 'sent', tag: 'orders-list-sent', count: 0, permission: 'orders-sent' }, { title: 'Архив', name: 'archive', link: 'archive', tag: 'orders-list-archive', count: 0, permission: 'orders-archive' }, { title: 'Склад товара', name: 'warehouse', link: 'warehouse', tag: 'warehouse-list', count: 0, permission: 'orders-archive' }, { title: 'Продажи', name: 'sales', link: 'sales', tag: 'sales-list', count: 0, permission: 'orders-archive' }];
	
	    self.edit = false;
	    self.notFound = false;
	
	    var route = riot.route.create();
	
	    route('/orders', function () {
	        self.tabs.every(function (tab) {
	            if (self.checkPermission(tab.permission, "1000")) {
	                riot.route('/orders/' + tab.link);
	                return false;
	            }
	            return true;
	        });
	    });
	
	    route('/orders/([0-9]+)..', function (id) {
	        observable.trigger('orders-edit', id);
	        self.edit = true;
	        self.notFound = false;
	        self.tab = '';
	        self.update();
	    });
	
	    route('/orders/add', function () {
	        self.edit = true;
	        self.notFound = false;
	        self.tab = '';
	        observable.trigger('order-new');
	        self.update();
	    });
	
	    route('/orders/stock/([0-9]+)', function (id) {
	        observable.trigger('stock-edit', id);
	        self.edit = true;
	        self.notFound = false;
	        self.tab = 'stock';
	        self.update();
	    });
	
	    route('/orders/*', function (tab) {
	        var idx = self.tabs.map(function (i) {
	            return i.link;
	        }).indexOf(tab);
	        if (idx !== -1 && self.checkPermission(self.tabs[idx].permission, "1000")) {
	            var tag = self.tabs[idx].tag;
	            if (self.tags[tag] && self.tags[tag].tags.catalog) self.tags[tag].tags.catalog.reload();
	            self.update({ edit: false, tab: tab });
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/orders..', function () {
	        self.notFound = true;
	        self.tab = 'orders';
	        self.update();
	        observable.trigger('not-found');
	    });
	
	    observable.on('tabs-update', function (counts) {
	        self.tabs.forEach(function (tab) {
	            var name = tab.name;
	            if (name && counts[name]) {
	                tab.count = counts[name];
	            }
	        });
	        self.update();
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, app) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('sales-list', '\n  <virtual hide="{loader}">\n\n\n    <div class="col-md-3 hidden-xs hidden-sm">\n      <catalog-tree object="SalesBrand" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" descendants="true" deselall="true"></catalog-tree>\n    </div>\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog object="Sales" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" before-success="{getAggregation}" store="warehouse-list" disablepagination="true" filters="{allFilters}" combine-filters="true">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group">\n                <label class="control-label">От даты</label>\n                <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n              </div>\n              <div class="form-group">\n                <label class="control-label">До даты</label>\n                <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n              </div>\n            </div>\n          </div>\n        </yield>\n        <yield to="head-right">\n          <div class="form-group pull-right">\n            <div>\n              <label class="text-muted pull-left">\n                 Итого стоимость по продаже:<strong> {parent.item.totalAmount}</strong></label>\n            </div>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="pos">{parent.i + 1}</datatable-cell>\n          <datatable-cell name="article" onclick="{handlers.copyText}">{row.article}</datatable-cell>\n          <datatable-cell name="nameBrand" onclick="{handlers.copyText}">{row.nameBrand}</datatable-cell>\n          <datatable-cell name="name" onclick="{handlers.copyText}" style="width: 40%;">{row.name}</datatable-cell>\n          <datatable-cell name="expend">{row.expend}</datatable-cell>\n\n          <datatable-cell name="amount" onclick="{handlers.copyText}" style="max-width: 20px;">{row.amount}</datatable-cell>\n          <datatable-cell name="stock" onclick="{handlers.copyText}" style="max-width: 20px;">{row.stock}</datatable-cell>\n\n        </yield>\n        <yield to="aggregation"></yield>\n      </catalog>\n    </div>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	    self.mixin('change');
	    self.mixin('permissions');
	    self.allFilters = false;
	
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: '', value: '#' }, { name: 'article', value: 'Артикул' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: 'expend', value: 'Продано' },
	    //{name: 'price', value: 'Цена'},
	    { name: 'amount', value: 'Стоимость' }, { name: 'stock', value: 'Остаток' }];
	
	    self.Filters = function () {
	        self.update();
	        self.tags.catalog.reload();
	    };
	
	    self.handlers = {
	        copyText: function copyText(elem) {
	            copyToClipboard(elem.target);
	        }
	    };
	
	    function copyToClipboard(elem) {
	
	        var target = document.createElement("textarea");
	        target.style.position = "absolute";
	        target.style.left = "-9999px";
	        target.style.top = "0";
	        document.body.appendChild(target);
	        target.value = elem.innerHTML.trim();
	
	        target.focus();
	        target.select();
	
	        try {
	            var successful = document.execCommand('copy');
	            var msg = successful ? 'successful' : 'unsuccessful';
	        } catch (err) {}
	    }
	
	    self.getAggregation = function (response, xhr) {
	        self.item = response;
	    };
	    /*
	    self.reload = () => {
	        self.loader = true
	        self.update()
	    
	        API.request({
	            object: 'Warehouse',
	            method: 'Fetch',
	            data: {},
	            success(response) {
	                self.item = response
	            },
	            complete() {
	                self.loader = false
	                self.update()
	            }
	        })
	    }
	    */
	
	    self.one('updated', function () {
	        self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
	
	            self.selectedCategory = node.__selected__ ? node.id : undefined;
	            var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.code;
	                }).join(',');
	                self.allFilters = [{ field: 'codeBrand', sign: 'IN', value: value }];
	            } else {
	                self.allFilters = false;
	            }
	            self.Filters();
	
	            //self.update()
	            //self.tags.catalog.reload()
	        });
	    });
	
	    observable.on('warehouse-reload', function () {
	        self.allFilters = [];
	        self.update();
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    /*
	    route('/orders/warehouse', () => {
	        self.reload()
	    })
	    
	    self.on('mount', () => {
	        riot.route.exec()
	    })
	    */
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(12)))

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	__webpack_require__(80);
	
	__webpack_require__(81);
	
	__webpack_require__(33);
	
	__webpack_require__(10);
	
	__webpack_require__(104);
	
	riot.tag2('stock-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#orders/stock"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;stock&quot;, &quot;0100&quot;) : checkPermission(&quot;stock&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? \'Новая партия\' : \'Редактирование партии № \' + item.id}</div>\n    <div id="stock-edit-home">\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="row">\n          <div class="col-md-1" if="{!isNew}">\n            <div class="form-group">\n              <label class="control-label">Ид</label>\n              <input class="form-control" name="id" value="{item.id}" readonly>\n            </div>\n          </div>\n          <div class="col-md-2" if="{!isNew}">\n            <div class="form-group">\n              <label class="control-label">Дата партии</label>\n              <datetime-picker class="form-control" name="date" format="YYYY-MM-DD" value="{item.date}" icon="glyphicon glyphicon-calendar"></datetime-picker>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="well well-sm">\n              <h4>Заказы</h4>\n              <catalog-static name="orders" rows="{item.orders}" cols="{orderCols}" remove="true" handlers="{handlers}" dblclick="{handlers.orderItemsShow}">\n                <yield to="toolbar">\n                  <label class="checkbox-inline pull-right" style="width:10%;">\n                    <input type="checkbox" __checked="{parent.isAllSent}" onchange="{opts.handlers.isAllSentClick}">Отправлен\n                  </label>\n                  <label class="checkbox-inline pull-right" style="width:10%;">\n                    <input type="checkbox" __checked="{parent.isAllChecked}" onchange="{opts.handlers.isAllCheckedClick}">Проверен\n                  </label>\n                  <label class="checkbox-inline pull-right" style="width:10%;">\n                    <input type="checkbox" __checked="{parent.isAllCollected}" onchange="{opts.handlers.isAllCollectedClick}">Собран\n                  </label>\n                </yield>\n                <yield to="body">\n                  <datatable-cell name="idOrder"><a class="open-page-item" href="#orders/{row.idOrder}" target="_blank">{row.idOrder}</a></datatable-cell>\n                  <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n                  <datatable-cell name="track" style="width: 20%;">\n                    <input class="form-control" if="{row.isSent}" value="{row.track}" type="text" onchange="{handlers.stringChange}">\n                  </datatable-cell>\n                  <datatable-cell name="image">\n                    <button class="btn btn-sm btn-success" if="{row.isCollected}" onclick="{handlers.imageEdit}"><i class="fa fa-picture-o"></i></button>\n                  </datatable-cell>\n                  <datatable-cell name="email">{row.email}</datatable-cell>\n                  <datatable-cell name="customer">{row.nameRecipient}</datatable-cell>\n                  <datatable-cell name="isCollected" style="width:10%;"><i class="fa fa-fw {row.isCollected ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.isCollectedClick}"></i></datatable-cell>\n                  <datatable-cell name="isChecked" style="width:10%;"><i class="fa fa-fw {row.isChecked ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" if="{row.isCollected}" onclick="{handlers.isCheckedClick}"></i></datatable-cell>\n                  <datatable-cell name="isSent" style="width:10%;"><i class="fa fa-fw {row.isSent ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" if="{row.isCollected}" onclick="{handlers.isSentClick}"></i></datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="well well-sm">\n              <h4>Наличие на складе</h4>\n              <catalog-static name="items" rows="{item.items}" cols="{itemsCols}" remove-toolbar="1" handlers="{handlers}">\n                <yield to="body">\n                  <datatable-cell name="article">{row.article}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                  <datatable-cell name="count">{row.count}</datatable-cell>\n                  <datatable-cell name="stock">{row.stock}</datatable-cell>\n                  <datatable-cell class="{bg-danger: row.stock &lt; row.count}" name="result">{row.stock - row.count}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Примечание администратора</label>\n              <textarea class="form-control" rows="5" name="commentary" value="{item.commentary}"></textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.isNew = false;
	    self.item = {};
	    self.loader = false;
	
	    self.isAllCollected = false;
	    self.isAllChecked = false;
	    self.isAllSent = false;
	
	    self.orderCols = [{ name: 'idOrder', value: '#' }, { name: 'dateOrder', value: 'Дата' }, { name: 'track', value: 'Трек номер' }, { name: 'image', value: 'Фото' }, { name: 'email', value: 'Заказчик' }, { name: 'customer', value: 'ФИО' }, { name: 'isCollected', value: 'Собран' }, { name: 'isChecked', value: 'Проверен' }, { name: 'isSent', value: 'Отправлен' }];
	
	    self.itemsCols = [{ name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'count', value: 'В заказах' }, { name: 'stock', value: 'На складе' }, { name: 'result', value: 'Результат' }];
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.rules = {
	        id: 'empty'
	    };
	
	    observable.on('stock-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'Stock',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.checkAll = function () {
	        var cntColl = 0,
	            cntCkeck = 0,
	            cntSent = 0;
	
	        if (self.item && self.item.orders) {
	            self.item.orders.forEach(function (order) {
	                cntColl += order.isCollected;
	                cntCkeck += order.isChecked;
	                cntSent += order.isSent;
	            });
	
	            self.isAllCollected = cntColl == self.item.orders.length && cntColl > 0;
	            self.isAllChecked = cntCkeck == cntColl && cntCkeck > 0;
	            self.isAllSent = cntSent == cntColl && cntSent > 0;
	        }
	    };
	
	    self.on('update', function () {
	        self.checkAll();
	    });
	
	    self.handlers = {
	        stringChange: function stringChange(e) {
	            this.row[this.opts.name] = e.target.value;
	        },
	        isAllCollectedClick: function isAllCollectedClick() {
	            if (self.item && self.item.orders) {
	                self.item.orders.forEach(function (order, i) {
	                    if (self.isAllCollected) {
	                        self.item.orders[i].isCollected = 0;
	                        self.item.orders[i].isChecked = 0;
	                        self.item.orders[i].isSent = 0;
	                    } else {
	                        self.item.orders[i].isCollected = 1;
	                    }
	                });
	            }
	
	            self.checkAll();
	        },
	        isAllCheckedClick: function isAllCheckedClick() {
	            if (self.item && self.item.orders) {
	                self.item.orders.forEach(function (order, i) {
	                    if (self.isAllChecked) {
	                        self.item.orders[i].isChecked = 0;
	                    } else {
	                        if (order.isCollected) {
	                            self.item.orders[i].isChecked = 1;
	                        }
	                    }
	                });
	            }
	
	            self.checkAll();
	        },
	        isAllSentClick: function isAllSentClick() {
	            if (self.item && self.item.orders) {
	                self.item.orders.forEach(function (order, i) {
	                    if (self.isAllSent) {
	                        self.item.orders[i].isSent = 0;
	                    } else {
	                        if (order.isCollected) {
	                            self.item.orders[i].isSent = 1;
	                        }
	                    }
	                });
	            }
	
	            self.checkAll();
	        },
	        isCollectedClick: function isCollectedClick(e) {
	            e.item.row.isCollected = !e.item.row.isCollected;
	            e.item.row.isChecked = 0;
	            e.item.row.isSent = 0;
	            self.checkAll();
	        },
	        isCheckedClick: function isCheckedClick(e) {
	            e.item.row.isChecked = !e.item.row.isChecked;
	            //e.item.row.isSent = 0
	            self.checkAll();
	        },
	        isSentClick: function isSentClick(e) {
	            e.item.row.isSent = !e.item.row.isSent;
	            self.checkAll();
	        },
	        imageEdit: function imageEdit(e) {
	            modals.create('order-edit-modal', {
	                type: 'modal-primary',
	                item: e.item.row,
	                images: opts.images,
	                submit: function submit() {
	                    e.item.row = this.item;
	                    this.modalHide();
	                    self.update();
	                }
	            });
	        },
	        orderItemsShow: function orderItemsShow(e) {
	            modals.create('order-items-show-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                item: e.item.row,
	                submit: function submit(e) {
	                    this.modalHide();
	                }
	            });
	        }
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        params.send = self.snd;
	
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'Stock',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    self.isNew = false;
	                    self.update();
	                    if (self.isNew) riot.route('/orders/stock/' + self.item.id);
	                    popups.create({ title: 'Успех!', text: 'Предзаказ сохранен!', style: 'popup-success' });
	                    //observable.trigger('stock-reload')
	                }
	            });
	        }
	    };
	
	    self.reload = function (e) {
	        observable.trigger('stock-edit', self.item.id);
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	riot.tag2('order-items-show-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Состав заказа №{item.idOrder}</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <div class="well well-sm">\n            <catalog-static name="items" rows="{item.items}" cols="{parent.itemsCols}" remove-toolbar="1">\n              <yield to="body">\n                <datatable-cell name="article">{row.article}</datatable-cell>\n                <datatable-cell name="name">{row.name}</datatable-cell>\n                <datatable-cell name="nameBrand">{row.nameBrand}</datatable-cell>\n                <datatable-cell name="count">{row.count}</datatable-cell>\n                <datatable-cell name="price">{row.price}</datatable-cell>\n                <datatable-cell name="discount">{row.discount}</datatable-cell>\n                <datatable-cell name="amount">{(row.count * (row.price - row.discount)).toFixed(2).toLocaleString()}</datatable-cell>\n              </yield>\n            </catalog-static>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        self.update();
	    });
	
	    self.itemsCols = [{ name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'count', value: 'Кол-во' }, { name: 'price', value: 'Цена' }, { name: 'discount', value: 'Скидка' }, { name: 'amount', value: 'Сумма' }];
	});
	riot.tag2('order-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Настроить заказ</div>\n    </yield>\n    <yield to="body">\n      <form action="" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <product-edit-images name="images" value="{item.images}" section="orders" hidecatalog="true"></product-edit-images>\n          </div>\n        </div>\n        <hr>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Комментарий</label>\n              <textarea class="form-control" rows="5" name="commentary" value="{item.commentary}"></textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Применить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        modal.images = opts.images || {};
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('stock-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Список партий\'}</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Stock" cols="{parent.cols}" reload="true" handlers="{parent.handlers}" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="id" onclick="{handlers.copyText}">{row.id}</datatable-cell>\n          <datatable-cell name="date" onclick="{handlers.copyText}">{row.date}</datatable-cell>\n          <datatable-cell name="countOrders" onclick="{handlers.copyText}">{row.countOrders}</datatable-cell>\n          <datatable-cell class="{bg-success: row.countOrders == row.countCollected}" name="countCollected" onclick="{handlers.copyText}">{row.countCollected}</datatable-cell>\n          <datatable-cell class="{bg-success: row.countOrders == row.countChecked}" name="countChecked" onclick="{handlers.copyText}">{row.countChecked}</datatable-cell>\n          <datatable-cell class="{bg-success: row.countOrders == row.countSent}" name="countSent" onclick="{handlers.copyText}">{row.countSent}</datatable-cell>\n          <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.mixin('remove');
	  self.collection = 'Stock';
	  self.handlers = {};
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'countOrders', value: 'Заказов' }, { name: 'countCollected', value: 'Собранных' }, { name: 'countChecked', value: 'Проверенных' }, { name: 'countSent', value: 'Отправленных' }, { name: 'commentary', value: 'Примечание' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('stock-list', '  <catalog object="Stock" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" remove="{permission(remove, &quot;stock&quot;, &quot;0001&quot;)}" dblclick="{permission(stockOpen, &quot;stock&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="stock-list" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateStock" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateStock" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id" style="width:100px;"><a class="open-page-item" href="#orders/stock/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="date" onclick="{handlers.copyText}" style="width:100px;">{row.date}</datatable-cell>\n      <datatable-cell name="countOrders" onclick="{handlers.copyText}" style="width:100px;">{row.countOrders}</datatable-cell>\n      <datatable-cell class="{bg-success: row.countOrders == row.countCollected}" name="countCollected" onclick="{handlers.copyText}" style="width:100px;">{row.countCollected}</datatable-cell>\n      <datatable-cell class="{bg-success: row.countOrders == row.countChecked}" name="countChecked" onclick="{handlers.copyText}" style="width:100px;">{row.countChecked}</datatable-cell>\n      <datatable-cell class="{bg-success: row.countOrders == row.countSent}" name="countSent" onclick="{handlers.copyText}" style="width:100px;">{row.countSent}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Stock';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: 'id', value: 'Партия' }, { name: 'date', value: 'Дата' }, { name: 'countOrders', value: 'Заказов' }, { name: 'countCollected', value: 'Собранных' }, { name: 'countChecked', value: 'Проверенных' }, { name: 'countSent', value: 'Отправленных' }, { name: 'commentary', value: 'Примечание администратора' }];
	
	    self.handlers = {
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        }
	    };
	
	    self.stockOpen = function (e) {
	        riot.route('/orders/stock/' + e.item.row.id);
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.totalAmount = parseFloat(response.totalAmount).toFixed(2);
	        self.currTotal = response.currTotal;
	        if (response.counts) observable.trigger('tabs-update', response.counts);
	    };
	
	    observable.on('stock-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(5)))

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable, app) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('warehouse-list', '\n  <virtual hide="{loader}">\n\n\n    <div class="col-md-3 hidden-xs hidden-sm">\n      <catalog-tree object="WarehouseBrand" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" descendants="true" deselall="true"></catalog-tree>\n    </div>\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog object="Warehouse" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" disablecolselect="true" combine-filters="true" before-success="{getAggregation}" store="warehouse-list" disablepagination="true" filters="{allFilters}">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group" style="width: 200px;" each="{purchase, i in parent.purchases}">\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="idPurchase" data-sign="in" value="{purchase.id}" checked>&nbsp; {purchase.id} - {purchase.provider}\n                </label>\n              </div>\n            </div>\n          </div>\n        </yield>\n        <yield to="head-right">\n          <div class="form-group pull-right">\n            <div>\n              <label class="text-muted pull-left">\n                 Общее количество упаковок:<strong> {parent.item.totalStock}</strong></label>\n            </div>\n            <div>\n              <label class="text-muted pull-left">\n                 Итого стоимость по закупке:<strong> {parent.item.totalAmountPurchase}</strong></label>\n            </div>\n            <div>\n              <label class="text-muted pull-left">\n                 Итого стоимость по продаже:<strong> {parent.item.totalAmount}</strong></label>\n            </div>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell class="{text-muted: !row.calc}" name="pos"><span class="fa fa-fw select-row-calc {row.calc ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.clk1}"></span>{parent.i + 1}</datatable-cell>\n          <datatable-cell name="article" onclick="{handlers.copyText}">{row.article}</datatable-cell>\n          <datatable-cell name="nameBrand" onclick="{handlers.copyText}">{row.nameBrand}</datatable-cell>\n          <datatable-cell name="name" onclick="{handlers.copyText}" style="width: 50%;">{row.name}</datatable-cell>\n          <datatable-cell name="purchase"><span each="{id, i in row.purchase}"><a class="open-page-item" href="#purchases/{id}" target="_blank">{id}</a>&nbsp;</span></datatable-cell>\n          <datatable-cell name="stock" onclick="{handlers.copyText}" style="max-width: 20px;">{row.stock}</datatable-cell>\n          <datatable-cell name="amountPurchase" onclick="{handlers.copyText}" style="max-width: 20px;">{row.amountPurchase}</datatable-cell>\n          <datatable-cell name="amount" onclick="{handlers.copyText}" style="max-width: 20px;">{row.amount}</datatable-cell>\n        </yield>\n\n      </catalog>\n    </div>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	    self.purchases = [];
	    self.mixin('change');
	    self.mixin('permissions');
	    self.allFilters = false;
	
	    self.cols = [{ name: '', value: '#' }, { name: 'article', value: 'Артикул' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: '', value: '№ закупки' }, { name: 'stock', value: 'Остаток' }, { name: 'amountPurchase', value: 'Сумма закупки' }, { name: 'amount', value: 'Сумма продажи' }];
	
	    self.Filters = function () {
	        self.update();
	        self.tags.catalog.reload();
	    };
	
	    self.handlers = {
	        copyText: function copyText(elem) {
	            copyToClipboard(elem.target);
	        },
	        clk1: function clk1(e) {
	            e.stopPropagation();
	            console.log(e);
	            e.item.row.calc = !e.item.row.calc;
	            self.update();
	        },
	        selectPurchase: function selectPurchase(elem) {
	            console.log(elem.target.value);
	        }
	    };
	
	    function copyToClipboard(elem) {
	
	        var target = document.createElement("textarea");
	        target.style.position = "absolute";
	        target.style.left = "-9999px";
	        target.style.top = "0";
	        document.body.appendChild(target);
	        target.value = elem.innerHTML.trim();
	
	        target.focus();
	        target.select();
	
	        try {
	            var successful = document.execCommand('copy');
	            var msg = successful ? 'successful' : 'unsuccessful';
	        } catch (err) {}
	    }
	
	    self.getAggregation = function (response, xhr) {
	        self.item = response;
	    };
	    /*
	    self.reload = () => {
	        self.loader = true
	        self.update()
	    
	        API.request({
	            object: 'Warehouse',
	            method: 'Fetch',
	            data: {},
	            success(response) {
	                self.item = response
	            },
	            complete() {
	                self.loader = false
	                self.update()
	            }
	        })
	    }
	    */
	
	    self.getPurchases = function () {
	        API.request({
	            object: 'Purchase',
	            method: 'Fetch',
	            success: function success(response) {
	                self.purchases = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.on('update', function () {
	        if (self.item && self.item.items) {
	            self.item.totalAmount = self.item.items.map(function (i) {
	                return i.amount * i.calc;
	            }).reduce(function (p, c) {
	                return p + c;
	            }, 0);
	        }
	    });
	
	    self.one('updated', function () {
	        self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
	
	            self.selectedCategory = node.__selected__ ? node.id : undefined;
	            var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.code;
	                }).join(',');
	                self.allFilters = [{ field: 'codeBrand', sign: 'IN', value: value }];
	            } else {
	                self.allFilters = false;
	            }
	            self.Filters();
	
	            //self.update()
	            //self.tags.catalog.reload()
	        });
	    });
	
	    observable.on('warehouse-reload', function () {
	        self.allFilters = [];
	        self.update();
	        self.getPurchases();
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    /*
	    route('/orders/warehouse', () => {
	        self.getPurchases()
	        self.reload()
	    })
	    
	    self.on('mount', () => {
	        self.getPurchases()
	        riot.route.exec()
	    })
	    */
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(12)))

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, app) {'use strict';
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('payments-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Новый платёж</div>\n    </yield>\n    <yield to="body">\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="row">\n          <div class="col-md-12">\n            <h4>Информация о заказе</h4>\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label">Заказ</label>\n                  <div class="input-group">\n                    <input class="form-control" value="{item.idOrder ? &quot;Заказ № &quot; + item.idOrder + &quot; от &quot; + order.dateOrder + &quot; [&quot; + order.customer + &quot;]&quot; : &quot;&quot;}" __readonly="{true}">\n                    <div class="input-group-btn">\n                      <div class="btn btn-default" onclick="{selectOrder}"><i class="fa fa-list text-primary"></i></div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="row" if="{item.idOrder}">\n              <div class="col-md-4">\n                <div class="form-group">\n                  <label class="control-label">Сумма заказа</label>\n                  <input class="form-control" value="{order.amount}" __readonly="{true}">\n                </div>\n              </div>\n              <div class="col-md-4">\n                <div class="form-group">\n                  <label class="control-label">Оплачено</label>\n                  <input class="form-control" value="{order.paid}" __readonly="{true}">\n                </div>\n              </div>\n              <div class="col-md-4">\n                <div class="form-group">\n                  <label class="control-label">Доплата</label>\n                  <input class="form-control" value="{order.surcharge % 1 == 0 ? Number(order.surcharge) : order.surcharge}" __readonly="{true}">\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <h4>Информация о платеже</h4>\n            <div class="row">\n              <div class="col-md-6">\n                <div class="form-group">\n                  <label class="control-label">Дата платежа</label>\n                  <datetime-picker class="form-control" name="date" format="DD.MM.YYYY HH:mm" value="{item.dateDisplay}"></datetime-picker>\n                </div>\n              </div>\n              <div class="col-md-6">\n                <div class="form-group {has-error: error.amount}">\n                  <label class="control-label">Сумма оплаты*</label>\n                  <input class="form-control" name="amount" min="0" step="1" value="{item.amount % 1 == 0 ? Number(item.amount) : item.amount}" type="{\'number\'}">\n                  <div class="help-block">{error.amount}</div>\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-8">\n                <div class="form-group">\n                  <label class="control-label">Тип оплаты</label>\n                  <select class="form-control" name="paymentType" value="{item.paymentType}">\n                    <option each="{paySystems}" value="{id}" __selected="{id == item.paymentType}" no-reorder>{name}</option>\n                  </select>\n                </div>\n              </div>\n              <div class="col-md-4" if="{item.paymentType == 0}">\n                <div class="form-group">\n                  <label class="control-label">Сумма на лицевом счёте</label>\n                  <input class="form-control" value="{item.contact.balance}" __readonly="{true}">\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label">Примечание</label>\n                  <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Добавить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    function loadPaySystems(modal) {
	        var params = {};
	        modal.paySystems = [];
	        API.request({
	            object: 'PaySystem',
	            method: 'Fetch',
	            data: params,
	            success: function success(response, xhr) {
	                modal.paySystems.push({ id: 0, name: "С лицевого счёта" });
	                modal.paySystems = modal.paySystems.concat(response.items);
	                modal.item.paymentTypeNames = modal.paySystems;
	                modal.update();
	            }
	        });
	    }
	
	    self.reload = function () {
	        //observable.trigger('payments-new')
	    };
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.order = {};
	        modal.paySystems = [];
	        modal.error = false;
	
	        modal.item.paymentTarget = opts.order.inpayee == "Y" ? 1 : 0;
	        modal.item.idOrder = opts.order.id;
	        modal.item.idAuthor = opts.order.idAuthor;
	        modal.item.idCompany = opts.order.idCompany;
	        modal.item.num = 1;
	        modal.item.note = '';
	        modal.item.date = (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	        modal.item.dateDisplay = (0, _moment2.default)().format('DD.MM.YYYY HH:mm');
	        modal.item.year = (0, _moment2.default)().format('YYYY');
	        modal.item.paymentType = 1;
	        modal.item.idManager = app.config.idManager;
	        modal.item.amount = opts.order.surcharge;
	        modal.item.curr = opts.order.curr;
	
	        modal.order.paid = opts.order.paid;
	        modal.order.amount = opts.order.amount;
	        modal.order.surcharge = opts.order.surcharge;
	        modal.order.dateOrder = opts.order.dateOrder;
	        modal.order.customer = opts.order.customer;
	
	        modal.mixin('validation');
	        modal.mixin('permissions');
	        modal.mixin('change');
	
	        modal.rules = function () {
	            var rules = {
	                amount: ['empty', 'number']
	            };
	            modal.item.amount = parseFloat(modal.item.amount);
	            if (self.item && (self.item.idAuthor || self.item.idCompany)) return (0, _extends3.default)({}, rules);else return (0, _extends3.default)({}, rules, { idAuthor: 'empty' });
	        };
	
	        loadPaySystems(modal);
	        //modal.update
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules(), name));
	        };
	
	        modal.checkForSave = function () {
	            if (modal.item.amount <= 0) {
	                popups.create({
	                    title: 'Сохранение платежа!',
	                    text: 'Не указана сумма оплаты!',
	                    style: 'popup-danger'
	                });
	                return false;
	            }
	
	            if (modal.item.paymentType == 0 && modal.item.amount > modal.item.contact.balance) {
	                popups.create({
	                    title: 'Сохранение платежа!',
	                    text: 'Сумма платежа превышает сумму на лицевом счете плательщика!',
	                    style: 'popup-danger'
	                });
	                return false;
	            }
	            return true;
	        };
	
	        modal.submit = function (e) {
	            var params = modal.item;
	            if (!modal.checkForSave()) return;
	            modal.error = modal.validation.validate(modal.item, modal.rules());
	            if (!modal.error) {
	                return true;
	            }
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(12)))

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(33);
	
	__webpack_require__(383);
	
	__webpack_require__(106);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('payments-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#payments"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;payments&quot;, &quot;0100&quot;) : checkPermission(&quot;payments&quot;, &quot;0010&quot;)}" onclick="{submit}"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? \'Новый платёж\' : [\'Редактирование платежа:\', ⁗[#⁗ + item.id + ⁗]⁗].join(⁗ ⁗)}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Назначение платежа</label>\n            <select class="form-control" name="paymentTarget" value="{item.paymentTarget}">\n              <option value="0">Оплата заказа</option>\n              <option value="1">Пополнение счёта</option>\n            </select>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Дата платежа</label>\n            <datetime-picker class="form-control" name="date" format="DD.MM.YYYY HH:mm" value="{item.dateDisplay}"></datetime-picker>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.amount}">\n            <label class="control-label">Сумма оплаты*</label>\n            <input class="form-control" name="amount" min="0" step="0.01" value="{parseFloat(item.amount)}" type="{\'number\'}">\n            <div class="help-block">{error.amount}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row" if="{item.paymentTarget == 0}">\n        <div class="col-md-12">\n          <h4>Информация о заказе</h4>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Заказ</label>\n                <div class="input-group">\n                  <input class="form-control" value="{item.idOrder ? &quot;Заказ № &quot; + item.idOrder + &quot; от &quot; + item.order.dateOrder + &quot; [&quot; + item.order.customer + &quot;]&quot; : &quot;&quot;}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{selectOrder}"><i class="fa fa-list text-primary"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row" if="{item.idOrder}">\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">Сумма заказа</label>\n                <input class="form-control" value="{item.order.amount}" __readonly="{true}">\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">Оплачено</label>\n                <input class="form-control" value="{item.order.paid}" __readonly="{true}">\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">Доплата</label>\n                <input class="form-control" value="{item.order.surcharge}" __readonly="{true}">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <h4>Информация о платеже</h4>\n          <div class="row">\n            <div class="col-md-8">\n              <div class="form-group">\n                <label class="control-label">Тип оплаты</label>\n                <select class="form-control" name="paymentType" value="{item.paymentType}">\n                  <option each="{paySystems}" value="{id}" __selected="{id == item.paymentType}" no-reorder>{name}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-4" if="{item.paymentType == 0}">\n              <div class="form-group">\n                <label class="control-label">Сумма на лицевом счёте</label>\n                <input class="form-control" value="{item.contact.balance}" __readonly="{true}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: (error.idAuthor || error.idCompany)}">\n                <label class="control-label">Плательщик*</label>\n                <div class="input-group">\n                  <input class="form-control" value="{item.payer}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{selectPayer}"><i class="fa fa-list text-primary"></i></div>\n                  </div>\n                </div>\n                <div class="help-block">{(error.idAuthor || error.idCompany)}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Примечание</label>\n                <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.isNew = false;
	
	    self.item = {};
	    self.paySystems = [];
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.rules = function () {
	        var rules = {
	            amount: ['empty', 'number']
	        };
	
	        if (self.item && (self.item.idAuthor || self.item.idCompany)) return (0, _extends3.default)({}, rules);else return (0, _extends3.default)({}, rules, { idAuthor: 'empty' });
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules(), name));
	    };
	
	    self.checkForSave = function () {
	        if (!self.item.idOrder && !self.item.paymentTarget) {
	            popups.create({
	                title: 'Сохранение платежа!',
	                text: 'Не выбран заказ!',
	                style: 'popup-danger'
	            });
	            return false;
	        }
	
	        if (self.item.amount <= 0) {
	            popups.create({
	                title: 'Сохранение платежа!',
	                text: 'Не указана сумма оплаты!',
	                style: 'popup-danger'
	            });
	            return false;
	        }
	
	        if (self.item.paymentType == 0 && self.item.amount > self.item.contact.balance) {
	            popups.create({
	                title: 'Сохранение платежа!',
	                text: 'Сумма платежа превышает сумму на лицевом счете плательщика!',
	                style: 'popup-danger'
	            });
	            return false;
	        }
	
	        return true;
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        if (!self.checkForSave()) return;
	
	        self.error = self.validation.validate(self.item, self.rules());
	
	        if (!self.error) {
	            API.request({
	                object: 'Payment',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Платёж сохранен!', style: 'popup-success' });
	                    if (self.isNew) riot.route('payments/' + response.id);
	                    observable.trigger('payments-reload');
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        self.item.id ? observable.trigger('payments-edit', self.item.id) : observable.trigger('payments-new');
	    };
	
	    function getOrderInfo(id) {
	        var params = { id: id };
	
	        API.request({
	            object: 'Order',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item.order = response;
	                self.item.amount = self.item.order.surcharge;
	                self.update();
	            }
	        });
	    }
	
	    function getContactInfo(id) {
	        var params = { id: id };
	
	        API.request({
	            object: 'Contact',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item.contact = response;
	                self.update();
	            }
	        });
	    }
	
	    function getCompanyInfo(id) {
	        var params = { id: id };
	
	        API.request({
	            object: 'Company',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item.contact = response;
	                self.update();
	            }
	        });
	    }
	
	    function loadPaySystems() {
	        var params = {};
	        self.paySystems = [];
	        API.request({
	            object: 'PaySystem',
	            method: 'Fetch',
	            data: params,
	            success: function success(response, xhr) {
	                self.paySystems.push({ id: 0, name: "С лицевого счёта" });
	                self.paySystems = self.paySystems.concat(response.items);
	                self.update();
	            }
	        });
	    }
	
	    observable.on('payments-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = {
	            paymentTarget: 0,
	            paymentType: 1,
	            date: (0, _moment2.default)().format('DD.MM.YYYY HH:mm'),
	            amount: 0
	        };
	        loadPaySystems();
	        self.update();
	    });
	
	    observable.on('payments-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.loader = true;
	        self.item = {};
	        self.isNew = false;
	        loadPaySystems();
	        self.update();
	
	        API.request({
	            object: 'Payment',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.selectOrder = function () {
	        if (!self.isNew) return;
	        modals.create('orders-list-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                if (items.length) {
	                    self.item.idOrder = items[0].id;
	                    getOrderInfo(self.item.idOrder);
	
	                    if (items[0].idCompany) {
	                        self.item.idCompany = items[0].idCompany;
	                        self.item.idAuthor = null;
	                        getCompanyInfo(self.item.idCompany);
	                    } else {
	                        self.item.idAuthor = items[0].idAuthor;
	                        self.item.idCompany = null;
	                        getContactInfo(self.item.idAuthor);
	                    }
	
	                    self.item.payer = items[0].customer;
	
	                    self.update();
	                }
	                this.modalHide();
	            }
	        });
	    };
	
	    self.selectPayer = function () {
	        modals.create('persons-company-list-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var _this = this.tags['bs-modal'];
	                var items = _this.tags[_this.tab].tags.datatable.getSelectedRows();
	                if (!items.length) return;
	
	                if (_this.tab == 'contacts') {
	                    self.item.idAuthor = items[0].id;
	                    self.item.payer = items[0].displayName;
	                    self.item.idCompany = null;
	                    getContactInfo(self.item.idAuthor);
	                } else {
	                    self.item.idCompany = items[0].id;
	                    self.item.payer = items[0].name;
	                    self.item.idAuthor = null;
	                    getCompanyInfo(self.item.idCompany);
	                }
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'shoppayment');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('payments-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Контакты</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Payment" cols="{parent.cols}" search="true" reload="false" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="num">{row.num}</datatable-cell>\n          <datatable-cell name="date">{row.date}</datatable-cell>\n          <datatable-cell name="paymentTarget">{row.paymentTarget ? \'Пополнение счёта\' : \'Оплата заказа\'}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="payer">{row.payer}</datatable-cell>\n          <datatable-cell name="amount">{row.amount}</datatable-cell>\n          <datatable-cell name="idOrder">{row.idOrder}</datatable-cell>\n          <datatable-cell name="note">{row.note}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'num', value: '№' }, { name: 'date', value: 'Дата' }, { name: 'paymentTarget', value: 'Назначение' }, { name: 'name', value: 'Наименование' }, { name: 'payer', value: 'Плательщик' }, { name: 'amount', value: 'Сумма' }, { name: 'idOrder', value: '№ заказа' }, { name: 'note', value: 'Примечание' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(10);
	
	riot.tag2('payments-list', '  <catalog object="Payment" search="true" sortable="true" cols="{cols}" allselect="true" reload="true" store="payments-list" add="{permission(add, &quot;payments&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;payments&quot;, &quot;0001&quot;)}" dblclick="{permission(paymentOpen, &quot;payments&quot;, &quot;1000&quot;)}" before-success="{getAggregation}">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control" data-name="date" data-sign="&gt;=" format="DD.MM.YYYY"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control" data-name="date" data-sign="&lt;=" format="DD.MM.YYYY"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">Назначение</label>\n            <select class="form-control" data-name="paymentTarget">\n              <option value="">Все</option>\n              <option value="0">Оплата заказа</option>\n              <option value="1">Пополнение счета</option>\n            </select>\n          </div>\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input type="checkbox" data-name="paymentType" data-bool="1,0" data-sign="&gt;=">Поступления\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="num">{row.num}</datatable-cell>\n      <datatable-cell name="date">{row.dateDisplay}</datatable-cell>\n      <datatable-cell name="paymentTarget">{row.paymentTarget ? \'Пополнение счёта\' : \'Оплата заказа\'}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="payer">{row.payer}</datatable-cell>\n      <datatable-cell name="amount"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="idOrder">{row.idOrder}</datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong>Сумма платежей:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0) + ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Payment';
	    self.totalAmount = 0;
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'num', value: '№' }, { name: 'date', value: 'Дата' }, { name: 'paymentTarget', value: 'Назначение' }, { name: 'name', value: 'Наименование' }, { name: 'payer', value: 'Плательщик' }, { name: 'amount', value: 'Сумма' }, { name: 'idOrder', value: '№ заказа' }, { name: 'note', value: 'Примечание' }];
	
	    self.getAggregation = function (response, xhr) {
	        if (response.totalAmount) {
	            self.totalAmount = response.totalAmount.toFixed(2);
	            self.currTotal = response.currTotal;
	        }
	    };
	
	    self.add = function () {
	        return riot.route('/payments/new');
	    };
	
	    self.paymentOpen = function (e) {
	        riot.route('/payments/' + e.item.row.id);
	    };
	
	    self.paymentOpenItem = function (id) {
	        riot.route('/payments/' + id);
	    };
	
	    observable.on('payments-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(395);
	
	__webpack_require__(393);
	
	riot.tag2('payments', '  <div class="column" if="{!notFound}">\n    <payments-list if="{!edit}"></payments-list>\n    <payments-edit if="{edit}"></payments-edit>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.edit = false;
	
	    route('/payments', function () {
	        self.notFound = false;
	        self.edit = false;
	        self.update();
	    });
	
	    route('/payments/new', function () {
	        observable.trigger('payments-new');
	        self.notFound = false;
	        self.edit = true;
	        self.update();
	    });
	
	    route('/payments/([0-9]+)', function (id) {
	        observable.trigger('payments-edit', id);
	        self.notFound = false;
	        self.edit = true;
	        self.update();
	    });
	
	    route('/payments..', function () {
	        self.notFound = true;
	        self.update();
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('paysystem-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Платежные системы</div>\n    </yield>\n    <yield to="body">\n      <catalog object="PaySystem" cols="{parent.cols}" search="true" reload="false" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="imageFile"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="discount">{row.discount}</datatable-cell>\n          <datatable-cell name="max">{row.maxAmount}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'imageFile', value: 'Картинка' }, { name: 'name', value: 'Наименование' }, { name: 'discount', value: 'Скидка' }, { name: 'max', value: 'Max cумма' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(167);
	
	riot.tag2('accounts-list', '  <div class="col-md-12">\n    <catalog search="true" sortable="true" object="UserAccount" handlers="{handlers}" cols="{cols}" reload="true" before-success="{getAggregation}" dblclick="{permission(personOpen, &quot;contacts&quot;, &quot;1000&quot;)}" store="accounts-list" filters="{allFilters}">\n      <yield to="body">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="name">{row.name}</datatable-cell>\n        <datatable-cell name="inPay"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.inPay.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n        <datatable-cell name="outPay"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.outPay.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      </yield>\n      <yield to="head">\n        <button class="btn btn-primary" onclick="{parent.exportAccount}" title="Экспорт списка (XLS)" type="button"><i class="fa fa-file-excel-o" aria-hidden="true"></i></button>\n      </yield>\n      <yield to="filters">\n        <div class="well well-sm">\n          <div class="form-inline row">\n            <div class="form-group col-sm-3">\n              <label class="control-label">От даты</label>\n              <datetime-picker class="form-control" data-name="datePayee" data-sign="&gt;=" format="YYYY-MM-DD" value="{parent.startDate}"></datetime-picker>\n            </div>\n            <div class="form-group col-sm-3">\n              <label class="control-label">До даты</label>\n              <datetime-picker class="form-control" data-name="datePayee" data-sign="&lt;=" format="YYYY-MM-DD" value="{parent.endDate}"></datetime-picker>\n            </div>\n            <div class="form-group col-sm-6">\n              <label class="control-label">Тип</label>\n              <select class="form-control" data-name="isBonus">\n                <option value="">Все</option>\n                <option value="1">Только бонусы</option>\n              </select>\n            </div>\n          </div>\n        </div>\n      </yield>\n      <yield to="aggregation"><strong> Начислено:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalInPay || 0).toFixed(2) +  ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><strong> Списано:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalOutPay || 0).toFixed(2) +  ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><strong> Остаток:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalBalansePay || 0).toFixed(2) +  ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong></yield>\n    </catalog>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'UserAccount';
	    self.categoryFilters = false;
	    self.typeFilters = false;
	    self.allFilters = false;
	    self.managers = {};
	    self.operations = [];
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Ф.И.О' }, { name: 'inPay', value: 'Начисление' }, { name: 'outPay', value: 'Списание' }];
	
	    self.handlers = {
	        params: {}
	    };
	
	    /*
	    self.change = e => {
	        var value = e.target.value
	        if (value == '') {
	            self.typeFilters = false
	        } else {
	            //var filter = {field: 'priceType', sign: 'IN', value: value}
	            self.typeFilters = [{field: 'priceType', sign: 'IN', value: value}]
	        }
	        self.Filters()
	    }
	    */
	
	    self.getAggregation = function (response, xhr) {
	        self.totalInPay = response.totalInPay;
	        self.totalOutPay = response.totalOutPay;
	        self.totalBalansePay = response.totalBalansePay;
	        self.currTotal = response.currTotal;
	    };
	
	    self.Filters = function () {
	        if (self.typeFilters && self.categoryFilters) self.allFilters = [].concat(self.typeFilters, self.categoryFilters);else if (self.typeFilters) self.allFilters = self.typeFilters;else self.allFilters = self.categoryFilters;
	        self.update();
	        self.tags.catalog.reload();
	    };
	
	    self.personOpen = function (e) {
	        riot.route('/persons/' + e.item.row.id);
	    };
	
	    /*
	    self.personOpenItem = id => {
	        riot.route(`/persons/${id}`)
	    }
	    
	    self.importPersons = (e) => {
	        var formData = new FormData();
	        for (var i = 0; i < e.target.files.length; i++) {
	            formData.append('file' + i, e.target.files[i], e.target.files[i].name)
	        }
	    
	        API.upload({
	            object: 'Contact',
	            data: formData,
	            success(response) {
	                self.update();
	            }
	        })
	    }
	    
	    self.exportPersons = () => {
	        var params = { filters: self.allFilters }
	        API.request({
	            object: 'Contact',
	            method: 'Export',
	            data: params,
	            success(response, xhr) {
	                let a = document.createElement('a')
	                a.href = response.url
	                a.download = response.name
	                document.body.appendChild(a)
	                a.click()
	                a.remove()
	            }
	        })
	    }
	    
	    self.exportCard = (e) => {
	        var _this = this
	    
	        var rows = self.tags.catalog.tags.datatable.getSelectedRows()
	        var params = { id: rows[0].id }
	    
	        API.request({
	            object: 'Contact',
	            method: 'Export',
	            data: params,
	            success(response, xhr) {
	                let a = document.createElement('a')
	                a.href = response.url
	                a.download = response.name
	                document.body.appendChild(a)
	                a.click()
	                a.remove()
	            }
	        })
	    } */
	
	    self.exportAccount = function (e) {
	        var _this = _this2;
	        var params = self.handlers.params;
	
	        API.request({
	            object: 'UserAccount',
	            method: 'Export',
	            data: params,
	            success: function success(response, xhr) {
	                var a = document.createElement('a');
	                a.href = response.url;
	                a.download = response.name;
	                document.body.appendChild(a);
	                a.click();
	                a.remove();
	            }
	        });
	    };
	
	    /* self.getOperations = () => {
	        API.request({
	            object: 'BankAccountTypeOperation',
	            method: 'Fetch',
	            success: (response, xhr) => {
	                self.operations = response.items
	                self.update()
	            }
	        })
	    }
	    
	    self.getManagers = () => {
	        self.managers = []
	        API.request({
	            object: 'PermissionUser',
	            method: 'Fetch',
	            success(response) {
	                self.managers = response.items
	                self.update()
	            }
	        })
	    
	    }
	    
	    self.getContactCategory = () => {
	        self.categories = []
	        API.request({
	            object: 'ContactCategory',
	            method: 'Fetch',
	            success(response) {
	                for (var i = 0; i < response.items.length; i++) {
	                    self.categories.push(response.items[i])
	                    if (response.items[i].childs!== undefined) {
	                        for (var ii = 0; ii < response.items[i].childs.length; ii++) {
	                            self.categories.push(response.items[i].childs[ii])
	                        }
	                    }
	                }
	                self.update()
	            }
	        })
	    }
	    */
	
	    self.one('updated', function () {
	        /*self.tags['catalog-tree'].tags.treeview.on('nodeselect', node => {
	            self.selectedCategory = node.__selected__ ? node.id : undefined
	            let items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes()
	            if (items.length > 0) {
	                let value = items.map(i => i.id).join(',')
	                self.categoryFilters = [{field: 'idGroup', sign: 'IN', value}]
	                } else {
	                self.categoryFilters = false
	            }
	            self.Filters()
	                 //self.update()
	            //self.tags.catalog.reload()
	        })*/
	    });
	
	    //self.getContactCategory()
	    //self.getManagers()
	    //self.getOperations();
	
	    observable.on('persons-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('companies-list', '  <catalog search="true" sortable="true" object="Company" cols="{cols}" allselect="true" reload="true" add="{permission(add, &quot;contacts&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;contacts&quot;, &quot;0001&quot;)}" dblclick="{permission(companyOpen, &quot;contacts&quot;, &quot;1000&quot;)}" store="persons-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="inn">{row.inn}</datatable-cell>\n      <datatable-cell name="kpp">{row.kpp}</datatable-cell>\n      <datatable-cell name="email">{row.email}</datatable-cell>\n      <datatable-cell name="phone">{row.phone}</datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n    </yield>\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">Группа</label>\n            <select class="form-control" data-name="idGroup" data-sign="IN">\n              <option value="">Все</option>\n              <option each="{category, i in parent.categories}" value="{category.id}" no-reorder>{category.name}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Company';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'inn', value: 'ИНН' }, { name: 'kpp', value: 'KPP' }, { name: 'email', value: 'E-mail' }, { name: 'phone', value: 'Телефоны' }, { name: 'note', value: 'Примечание' }];
	
	    self.add = function () {
	        return riot.route('/persons/companies/new');
	    };
	
	    self.companyOpen = function (e) {
	        return riot.route('/persons/companies/' + e.item.row.id);
	    };
	
	    self.getContactCategory = function () {
	        API.request({
	            object: 'ContactCategory',
	            method: 'Fetch',
	            success: function success(response) {
	                self.categories = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.on('reload', function () {
	            self.getContactCategory();
	        });
	    });
	
	    observable.on('companies-reload', function () {
	        return self.tags.catalog.reload();
	    });
	
	    self.getContactCategory();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	__webpack_require__(82);
	
	var _md5Min = __webpack_require__(62);
	
	var _md5Min2 = _interopRequireDefault2(_md5Min);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('company-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#persons/companies"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;contacts&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Новая компания\' : item.name || \'Редактирование компании\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#company-edit-home">Основная информация</a></li>\n      <li><a data-toggle="tab" href="#company-edit-contacts">Контакты</a></li>\n      <li><a data-toggle="tab" href="#company-edit-orders">Заказы</a></li>\n      <li if="{item.customFields &amp;&amp; item.customFields.length}"><a data-toggle="tab" href="#company-edit-fields">Доп. информация</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="company-edit-home">\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Наименование</label>\n                <input class="form-control" name="name" type="text" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.fullname}">\n                <label class="control-label">Полное наименование</label>\n                <input class="form-control" name="fullname" type="text" value="{item.fullname}">\n                <div class="help-block">{error.fullname}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.inn}">\n                <label class="control-label">ИНН</label>\n                <input class="form-control" name="inn" type="text" value="{item.inn}">\n                <div class="help-block">{error.inn}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.kpp}">\n                <label class="control-label">КПП</label>\n                <input class="form-control" name="kpp" type="text" value="{item.kpp}">\n                <div class="help-block">{error.kpp}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.phone}">\n                <label class="control-label">Телефон</label>\n                <input class="form-control" name="phone" type="text" value="{item.phone}">\n                <div class="help-block">{error.phone}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group {has-error: error.email}">\n                <label class="control-label">E-mail</label>\n                <input class="form-control" name="email" type="text" value="{item.email}">\n                <div class="help-block">{error.email}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: error.address}">\n                <label class="control-label">Адрес</label>\n                <input class="form-control" name="address" type="text" value="{item.address}">\n                <div class="help-block">{error.address}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Логин</label>\n                <input class="form-control" name="username" type="text" value="{item.username}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Пароль</label>\n                <input class="form-control" name="password" type="password" value="{item.password}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: error.note}">\n                <label class="control-label">Примечание</label>\n                <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n                <div class="help-block">{error.note}</div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="company-edit-contacts">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="contacts" add="{addModal(&quot;persons-list-select-modal&quot;)}" cols="{contactsCols}" rows="{item.contacts}">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="lastName">{[row.lastName, row.firstName, row.secondName].join(\' \')}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="company-edit-orders">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="orders" remove-toolbar="true" cols="{ordersCols}" rows="{item.orders}" handlers="{handlersOrders}">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n                  <datatable-cell name="amount">{row.amount}</datatable-cell>\n                  <datatable-cell class="{handlers.orderText.colors[row.status]}" name="status">{handlers.orderText.text[row.status]}</datatable-cell>\n                  <datatable-cell class="{handlers.deliveryText.colors[row.deliveryStatus]}" name="deliveryStatus">{handlers.deliveryText.text[row.deliveryStatus]}</datatable-cell>\n                  <datatable-cell name="note">{row.note}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="company-edit-fields" if="{item.customFields &amp;&amp; item.customFields.length}">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.loader = false;
	    self.item = {};
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty',
	        email: {
	            rules: [{
	                type: 'email'
	            }]
	        }
	    };
	
	    self.contactsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.ordersCols = [{ name: 'id', value: '#' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'amount', value: 'Сумма' }, { name: 'status', value: 'Статус заказа' }, { name: 'deliveryStatus', value: 'Статус доставки' }, { name: 'note', value: 'Примечание' }];
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            Y: 'bg-success', N: 'bg-danger', K: 'bg-warning', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlersOrders = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText
	    };
	
	    self.addModal = function (modal) {
	        return function () {
	            var _this = this;
	
	            modals.create(modal, {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    _this.value = _this.value || [];
	
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    var ids = _this.value.map(function (item) {
	                        return item.id;
	                    });
	
	                    items.forEach(function (item) {
	                        if (ids.indexOf(item.id) === -1) _this.value.push(item);
	                    });
	
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        };
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.reload = function () {
	        observable.trigger('companies-edit', self.item.id);
	    };
	
	    self.submit = function (e) {
	
	        if (self.item && self.item.password && self.item.password.trim() === '') delete self.item.password;else self.item.password = (0, _md5Min2.default)(self.item.password);
	
	        var params = self.item;
	        self.error = self.validation.validate(params, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'Company',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Компания сохранена!', style: 'popup-success' });
	                    self.item = response;
	                    self.item.password = new Array(8).join(' ');
	                    self.update();
	                    if (self.isNew) riot.route('/persons/companies/' + self.item.id);
	                    observable.trigger('companies-reload');
	                }
	            });
	        }
	    };
	
	    observable.on('companies-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'Company',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                self.item.password = new Array(8).join(' ');
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('companies-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = {};
	        self.update();
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('person-balance-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Лицевой счёт</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Дата</label>\n              <datetime-picker class="form-control" name="datePayee" format="YYYY-MM-DD HH:mm:ss" value="{item.datePayee}"></datetime-picker>\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Тип</label>\n              <select class="form-control" name="operation">\n                <option each="{typeOperation, i in parent.opts.typeOperations}" value="{typeOperation.operationId}" no-reorder>{typeOperation.name}</option>\n              </select>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Приход</label>\n              <input class="form-control" name="inPayee" value="{parseFloat(item.inPayee)}" type="{\'number\'}">\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Расход</label>\n              <input class="form-control" name="outPayee" value="{item.outPayee}" type="{\'number\'}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Документ/примечание</label>\n              <textarea class="form-control" rows="3" name="docum" style="min-width: 100%; max-width: 100%;" value="{item.docum}"></textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        self.tags['bs-modal'].mixin('change');
	        self.tags['bs-modal'].item = opts.item || { inPayee: 0, outPayee: 0 };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(33);
	
	__webpack_require__(105);
	
	__webpack_require__(401);
	
	__webpack_require__(106);
	
	__webpack_require__(489);
	
	__webpack_require__(82);
	
	var _md5Min = __webpack_require__(62);
	
	var _md5Min2 = _interopRequireDefault2(_md5Min);
	
	__webpack_require__(10);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('person-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#persons" onclick="{backClick}"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;contacts&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reloadButton}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{[\'Редактирование контакта:\', ⁗[#⁗ + item.id + ⁗]⁗, item.lastName, item.firstName, item.secondName].join(⁗ ⁗)}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#person-edit-home">Информация</a></li>\n      <li if="{checkPermission(&quot;products&quot;, &quot;1000&quot;)}"><a data-toggle="tab" href="#person-edit-groups">Группы</a></li>\n      <li><a data-toggle="tab" href="#person-edit-referals">Приглашенные</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="person-edit-home">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="contacts" alt="0" size="256" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isActive" __checked="{item.isActive == 1}">Активен\n                    </label>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="form-group"><span>Зарегистрирован:\n                      <nbsp></nbsp><b>{item.regDate}</b></span></div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Фамилия</label>\n                    <input class="form-control" name="lastName" type="text" value="{item.lastName}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group {has-error: error.firstName}">\n                    <label class="control-label">Имя*</label>\n                    <input class="form-control" name="firstName" type="text" value="{item.firstName}">\n                    <div class="help-block">{error.firstName}</div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Отчество</label>\n                    <input class="form-control" name="secName" type="text" value="{item.secName}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group {has-error: error.email}">\n                    <label class="control-label">Email</label>\n                    <input class="form-control" name="email" type="text" value="{item.email}">\n                    <div class="help-block">{error.email}</div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Логин</label>\n                    <input class="form-control" name="login" type="text" value="{item.login}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Пароль</label>\n                    <input class="form-control" name="password" type="password" value="{item.password}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">Персональная скидка</label>\n                    <div class="input-group">\n                      <input class="form-control" name="discount" min="0" step="0.01" value="{item.discount}" type="{\'number\'}"><span class="input-group-addon">%</span>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">Накопительная скидка</label>\n                    <input class="form-control" value="{item.progressiveDiscount + 0}%" disabled readonly>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Примечание по контакту</label>\n                    <textarea class="form-control" rows="3" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div id="person-edit-orders" if="{checkPermission(&quot;orders&quot;, &quot;1000&quot;)}">\n            <div class="h4">Заказы пользователя</div>\n            <div class="row">\n              <div class="col-md-12">\n                <datatable cols="{cols}" rows="{orders}" handlers="{handlersOrders}" dblclick="{dblclickOrder}">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell class="{handlers.orderText.colors[row.status]}" name="status">{row.status}</datatable-cell>\n                  <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n                  <datatable-cell name="amount"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.curr !== null && row.curr !== ⁗⁗ ? row.curr : row.titleCurr}</span></datatable-cell>\n                  <datatable-cell name="note">{row.note}</datatable-cell>\n                </datatable>\n                <div class="pull-right"><strong> Суммма:</strong><strong> {currTotal.nameFront !== null && currTotal.nameFront !== ⁗⁗ ? currTotal.nameFront : ⁗⁗}</strong><strong> {(totalAmount || 0)}</strong><strong> {currTotal.nameFront !== null && currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : currTotal.nameFlang !== null && currTotal.nameFlang !== ⁗⁗ ? currTotal.nameFlang : currTotal.titleCurr}</strong></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="person-edit-groups" if="{checkPermission(&quot;products&quot;, &quot;1000&quot;)}">\n          <catalog if="{item.id}" object="Contact" id="{item.id}" method="Info" items="groups" count="groupsCount" cols="{groupsCols}" allselect="true" store="person-edit" add="{permission(addGroup, &quot;persons-category-select-modal&quot;, &quot;0100&quot;)}" remove="{permission(removeGroups, &quot;persons-category-select-modal&quot;, &quot;0001&quot;)}" getdc="Contact" sortable="true" disablepagination="true">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog>\n        </div>\n        <div class="tab-pane fade" id="person-edit-referals">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="referals" cols="{referalCols}" rows="{item.referals}">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="username">{row.username}</datatable-cell>\n                  <datatable-cell name="refName">{row.refName}</datatable-cell>\n                  <datatable-cell name="email">{row.email}</datatable-cell>\n                  <datatable-cell name="phone">{row.phone}</datatable-cell>\n                  <datatable-cell name="refCount">{row.refCount}</datatable-cell>\n                  <datatable-cell name="regDate">{row.regDate}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _assign = __webpack_require__(83);
	
	    var _assign2 = _interopRequireDefault(_assign);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.item = {};
	    self.orders = [];
	    self.groupsSelectedCount = 0;
	    self.accountOperations = [];
	    self.referalFields = [];
	    self.allMode = false;
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.priceTypeTitle = [{ id: 0, name: 'Розничная' }, { id: 1, name: 'Мелкий опт' }, { id: 2, name: 'Оптовая' }];
	
	    self.backClick = function () {
	        if (history.length > 2) history.back();else return true;
	    };
	
	    self.rules = {
	        firstName: 'empty',
	        email: {
	            rules: [{
	                type: 'email'
	            }]
	        } /*,
	          phone: {
	             rules:[{
	                 type: 'phone'
	             }]
	          }*/
	    };
	    //email: {rules: [{type: 'email'}]}
	
	    self.afterChange = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "afterChange" }));
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.cols = [{ name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус заказа' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'amount', value: 'Сумма' }, { name: 'note', value: 'Примечание' }];
	
	    self.groupsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.balanceCols = [{ name: 'datePayee', value: 'Дата' }, { name: 'inPayee', value: 'Приход' }, { name: 'outPayee', value: 'Расход' }, { name: 'balance', value: 'Баланс' }, { name: 'docum', value: 'Примечание' }];
	
	    self.referalCols = [{ name: 'id', value: '#' }, { name: 'username', value: 'Логин' }, { name: 'refName', value: 'Имя контакта' }, { name: 'email', value: 'E-mail' }, { name: 'phone', value: 'Телефон' }, { name: 'refCount', value: 'Пригл.' }, { name: 'regDate', value: 'Дата регистр.' }];
	
	    self.companyRequisitesHandlers = {
	        valueChange: function valueChange(e) {
	            var selectionStart = e.target.selectionStart;
	            var selectionEnd = e.target.selectionEnd;
	            this.row.value = e.target.value;
	
	            this.update();
	            e.target.selectionStart = selectionStart;
	            e.target.selectionEnd = selectionEnd;
	        }
	    };
	
	    self.addGroup = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addGroup" }));
	        modals.create('persons-category-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.item.groups = self.item.groups || [];
	                var items = this.tags.catalog.getSelectedMode();
	
	                var ids = self.item.groups.map(function (item) {
	                    return item.id;
	                });
	
	                items.ids.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        self.item.groups.push({ id: item,
	                            name: "0"
	                        });
	                    }
	                });
	
	                if (self.datacatalog.ContactCategory && self.datacatalog.Contact) {
	                    // переносим id и name в таблицу групп
	                    var iddatacatalog = {}; // получаем id
	
	                    self.datacatalog.ContactCategory.forEach(function (item) {
	                        // получаем id
	                        iddatacatalog[item.id] = item;
	                    });
	
	                    items.ids.forEach(function (item) {
	                        // по id составляем окончательный массив
	                        var unit = {
	                            id: item,
	                            name: iddatacatalog[item]["name"]
	                        };
	                        self.datacatalog.Contact.push(unit);
	                    });
	
	                    var uniq = {};
	                    self.datacatalog.Contact.forEach(function (item) {
	                        // фильтруем уникальные значения по id
	                        uniq[item.id] = item;
	                    });
	                    self.datacatalog.Contact = []; // очистка исходного массива
	                    for (var item in uniq) {
	                        // возвращаем уникальные значения
	                        self.datacatalog.Contact.push(uniq[item]);
	                    }
	
	                    observable.trigger('datacatalog', self.datacatalog); // записываем в транс-табличные данные
	                }
	
	                self.update();
	                self.tags.catalog.reload();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.recalcBalance = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "recalcBalance" }));
	        var balance = 0.0;
	        self.item.personalAccount.forEach(function (item) {
	            balance += parseFloat(item.inPayee) - parseFloat(item.outPayee);
	            item.balance = parseFloat(balance);
	        });
	    };
	
	    self.addBalance = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addBalance" }));
	        modals.create('person-balance-modal', {
	            type: 'modal-primary',
	            typeOperations: self.accountOperations,
	            submit: function submit() {
	                self.item.personalAccount.push(this.item);
	                self.recalcBalance();
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.editBalance = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "editBalance" }));
	        modals.create('person-balance-modal', {
	            type: 'modal-primary',
	            typeOperations: self.accountOperations,
	            item: e.item.row,
	            submit: function submit() {
	                self.recalcBalance();
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.removeGroups = function (e, itemsToRemove, self) {
	
	        /** удаление групп из временного списка
	         *  (нужно, что бы все группы были на листе - нужны id для allDelete)
	         *  @param {object} e MouseEvent - данные мыши
	         *  @param {array or object}  itemsToRemove массив id's на удаление или объект с allMode and allModeLastParams
	         *  @param {object} self данные по контакту
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removeGroups" }));
	
	        self.groupsSelectedCount = 0;
	        //self.item.groups = self.tags.groups.getUnselectedRows()
	
	        /** если "удалить все" - получаем список id групп для последующего удаления */
	        if (itemsToRemove.allMode != undefined) {
	            itemsToRemove = [];
	            self.items.forEach(function (item) {
	                itemsToRemove.push(item.id);
	            });
	        }
	
	        var iddatacatalog = {};
	        self.datacatalog.Contact.forEach(function (item) {
	            // получаем id
	            iddatacatalog[item.id] = item;
	        });
	        self.datacatalog.Contact = []; // чистим
	
	        itemsToRemove.forEach(function (item) {
	            delete iddatacatalog[item]; // удаляем по id
	        });
	
	        for (var item in iddatacatalog) {
	            // возвращаем
	            self.datacatalog.Contact.push(iddatacatalog[item]);
	        }
	        observable.trigger('datacatalog', self.datacatalog); // записываем в транс-табличные данные
	
	        self.update();
	    }; // удаление групп из временного списка
	
	    self.submit = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit" }));
	
	        self.item.groups = self.datacatalog.Contact; // загрузка изменений в группы перед сохранением
	        var params = self.item;
	        self.error = self.validation.validate(params, self.rules);
	
	        if (!self.error) {
	            if (self.item && self.item.password && self.item.password.trim() === '') delete self.item.password;else self.item.password = (0, _md5Min2.default)(self.item.password);
	
	            API.request({
	                object: 'Contact',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Контакт сохранен!', style: 'popup-success' });
	                    self.item = response;
	                    self.item.password = new Array(8).join(' ');
	                    self.update();
	                    observable.trigger('persons-reload');
	                }
	            });
	        } else {
	            popups.create({ title: 'Ошибка!', text: 'Имеются незаполненые поля !', style: 'popup-warning' });
	        }
	    };
	
	    self.reloadButton = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadButton" }));
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: 'Будут потеряны не сохраненные данные. Вы точно хотите обновить эту страницу?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Обновить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    self.reload();
	                }
	                this.modalHide();
	            }
	        });
	    }; // обновление страницы карточки контакта с всплывающим предупреждением
	
	    self.reload = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
	        self.tags.catalog.reload(); // перезагрузка каталога
	        observable.trigger('persons-edit', self.item.id);
	    };
	
	    observable.on('persons-edit', function (id) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "persons-edit" }));
	        var params = { id: id };
	        self.error = false;
	        self.loader = true;
	        API.request({
	            object: 'Contact',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                self.item.password = new Array(8).join(' ');
	                self.accountOperations = response.accountOperations;
	                self.loader = false;
	                getOrders(self.item.id);
	                getReferals(self.item.id);
	                self.update();
	                if (self.tags.catalog) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	                if (self.tags.catalog) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
	            }
	        });
	    });
	
	    function getReferals(idCustomer) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getReferals" }));
	        var params = { id: idCustomer };
	        //self.referalFields = []
	        API.request({
	            object: 'Referals',
	            method: 'Fetch',
	            data: params,
	            success: function success(response, xhr) {
	                if (!(response.items instanceof Array)) response.items = [];
	                self.item.referals = response.items;
	                self.update();
	            }
	        });
	    }
	
	    function getOrders(idCustomer) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getOrders" }));
	        var params = { filters: { field: "idAuthor", value: idCustomer } };
	
	        API.request({
	            object: 'Order',
	            method: 'Fetch',
	            data: params,
	            success: function success(response, xhr) {
	                if (!(response.items instanceof Array)) response.items = [];
	                self.orders = response.items;
	                self.totalAmount = parseFloat(response.totalAmount);
	                self.currTotal = response.currTotal;
	                self.update();
	            }
	        });
	    }
	
	    self.changeManager = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeManager" }));
	        modals.create('permission-user-list-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.managerName = '';
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                if (!items.length) return;
	
	                self.item.managerId = items[0].id;
	                if (items[0].lastName) self.item.managerName = items[0].lastName + ' ';
	                if (items[0].firstName) self.item.managerName += items[0].firstName + ' ';
	                if (items[0].secName) self.item.managerName += items[0].secName;
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.removeManager = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removeManager" }));
	        self.item.managerId = null;
	        self.item.managerName = null;
	    };
	
	    self.changeReferContact = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeReferContact" }));
	        var id = self.item.id;
	        modals.create('persons-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            id: id,
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                if (!items.length) return;
	
	                self.item.idUp = items[0].id;
	                self.item.referName = items[0].displayName;
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.removeReferContact = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removeReferContact" }));
	        self.item.idUp = null;
	        self.item.referName = null;
	    };
	
	    self.one('updated', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "one" }));
	        observable.trigger('datacatalog', {}); // очищаем транс-табличные данные
	        self.tags.groups.on('row-selected', function (count) {
	            self.groupsSelectedCount = count;
	            self.update();
	        });
	    });
	
	    self.orderText = {
	        text: {
	            Y: 'Оплачен', N: 'Не оплачен', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
	        },
	        colors: {
	            Y: 'bg-success', N: 'bg-danger', K: 'bg-warning', P: null, W: null, C: null, T: null
	        }
	    };
	
	    self.deliveryText = {
	        text: {
	            Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
	        },
	        colors: {
	            Y: 'bg-success', N: 'bg-danger', M: null, P: null
	        }
	    };
	
	    self.handlersOrders = {
	        orderText: self.orderText,
	        deliveryText: self.deliveryText
	    };
	
	    self.dblclickOrder = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dblclickOrder" }));
	        riot.route('/orders/' + e.item.row.id);
	    };
	
	    self.on('update', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "update" }));
	        localStorage.setItem('SE_section', 'contacts');
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        riot.route.exec();
	    });
	
	    observable.on('datacatalog', function (e) {
	        /** получение транс-табличных данных
	         *  @param {object} e именаТаблиц-массивыСтрок
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "datacatalog" }));
	        self.datacatalog = e;
	    });
	
	    observable.on('tempdatacatalog', function (e) {
	        /** получение транс-табличных временных данных
	         *  и слияние массивов (данные таблицы + данные селектора)
	         *  @param {object} e именаТаблиц-массивыСтрок
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "tempdatacatalog" }));
	        self.datacatalog = (0, _assign2.default)(self.datacatalog, e);
	        observable.trigger('datacatalog', self.datacatalog);
	    });
	
	    self.debugParam = {
	        module: "person-edit.tag",
	        dClass: "person-edit",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('person-pricetype-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Тип цены</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group col-sm-12 {has-error: error.parentName}">\n          <label class="control-label">Выберите тип цены</label>\n          <div class="input-group" style="width: 100%;">\n            <select class="form-control" name="priceType">\n              <option each="{priceTypeTitle}" value="{id}" __selected="{id == item.priceType}" no-reorder>{name}</option>\n            </select>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.item = {};
	        modal.item.priceType = 0;
	        modal.priceTypeTitle = [{ id: 0, name: 'Розничная' }, { id: 1, name: 'Корпоративная' }, { id: 2, name: 'Оптовая' }];
	
	        modal.mixin('change');
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(166);
	
	riot.tag2('persons-categories-list', '  <catalog-tree object="ContactCategory" label-field="{&quot;name&quot;}" search="true" sortable="true" allselect="true" cols="{cols}" reload="true" add="{permission(addEdit, &quot;contacts&quot;, &quot;0100&quot;)}" children-field="{&quot;childs&quot;}" remove="{permission(remove, &quot;contacts&quot;, &quot;0001&quot;)}" handlers="{handlers}" dblclick="{permission(addEdit, &quot;contacts&quot;, &quot;1000&quot;)}" store="persons-category-list">\n    <yield to="after">\n      <span class="small">({this.userCount})</span><span class="form-inline pull-right"><i class="fa fa-envelope-o" if="{this.emailSettings}" title="Установлен код рассылки"></i><span class="f-sort" title="Вес сортировки группы">{this.sort}</span></span>\n    </yield>\n  </catalog-tree>\n', 'persons-categories-list,[riot-tag="persons-categories-list"],[data-is="persons-categories-list"]{ position: relative; display: block; } persons-categories-list treenodes .treenode,[riot-tag="persons-categories-list"] treenodes .treenode,[data-is="persons-categories-list"] treenodes .treenode{ padding: 2px; width: 100%; display: inline-block; line-height: 2.2; } persons-categories-list .f-sort,[riot-tag="persons-categories-list"] .f-sort,[data-is="persons-categories-list"] .f-sort{ margin-left: 30px; margin-right: 30px; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'ContactCategory';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    function up(e) {}
	
	    function down(e) {}
	
	    self.handlers = {
	        checkMask: self.checkMask,
	        checkPermission: self.checkPermission,
	        permission: self.permission,
	        btnup: up,
	        btndown: down
	    };
	
	    self.addEdit = function (e) {
	        var item = {};
	
	        if (e.item && e.item.id) item = e.item;
	
	        modals.create('person-category-new-modal', {
	            type: 'modal-primary',
	            item: item,
	            submit: function submit() {
	                var _this = this;
	
	                API.request({
	                    object: 'ContactCategory',
	                    data: _this.item,
	                    method: 'Save',
	                    success: function success(response) {
	                        observable.trigger('persons-category-reload');
	                        popups.create({ title: 'Успех!', text: 'Категория сохранена!', style: 'popup-success' });
	                        _this.modalHide();
	                        self.tags['catalog-tree'].reload();
	                    }
	                });
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('persons-company-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Контакты</div>\n    </yield>\n    <yield to="body">\n      <ul class="nav nav-tabs m-b-2">\n        <li class="{active: name == tab}" each="{tabs}"><a href="#" onclick="{tabClick}"><span>{title}</span></a></li>\n      </ul>\n      <catalog if="{tab == &quot;contacts&quot;}" name="contacts" object="Contact" cols="{contactCols}" dblclick="{submit}" search="true" reload="false" disable-col-select="1" add="{add}">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="date">{row.regDate}</datatable-cell>\n        <datatable-cell name="email">{row.email}</datatable-cell>\n        <datatable-cell name="discount">{row.discount + 0} / {row.progressiveDiscount + 0}</datatable-cell>\n      </catalog>\n      <catalog if="{tab == &quot;companies&quot;}" name="companies" object="Company" cols="{companyCols}" dblclick="{submit}" search="true" reload="false" disable-col-select="1">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="displayName">{row.name}</datatable-cell>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.item = {};
	        modal.tab = 'contacts';
	
	        modal.tabClick = function (e) {
	            modal.tab = e.item.name;
	        };
	
	        modal.submit = function (e) {
	            parent.opts.submit.bind(modal)();
	        };
	
	        modal.tabs = [{ name: 'contacts', title: 'Контакты' }, { name: 'companies', title: 'Компании' }];
	
	        modal.contactCols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'email', value: 'Email' }, { name: 'discount', value: 'Скидка / Накоп., %' }];
	
	        modal.companyCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	        modal.add = function () {
	            modals.create('person-new-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var _this = this;
	                    var params = { firstName: _this.name.value, email: _this.email.value };
	                    API.request({
	                        object: 'Contact',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response, xhr) {
	                            // modals.update()
	                            modal.tags[modal.tab].reload();
	                            popups.create({ title: 'Успех!', text: 'Контакт добавлен!', style: 'popup-success' });
	                            modal.update();
	                            _this.modalHide();
	                            //let e = { item: { id: response.id, }}
	                            //opts.submit.bind(this)
	                            //self.update()
	                            //this.modalHide()
	                            //if (response && response.id)
	                            //self.personOpenItem(response.id)
	                        }
	                    });
	                }
	            });
	        };
	
	        modal.submit = function () {
	            var items = modal.tags[modal.tab].tags.datatable.getSelectedRows();
	            if (!items.length) return;
	
	            if (modal.tab == 'contacts') {
	                modal.item.idAuthor = items[0].id;
	                modal.item.customer = items[0].displayName;
	                modal.item.idCompany = null;
	            } else {
	                modal.item.idCompany = items[0].id;
	                modal.item.customer = items[0].name;
	                modal.item.idAuthor = null;
	            }
	            opts.submit.bind(_this2)();
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(167);
	
	__webpack_require__(105);
	
	__webpack_require__(403);
	
	__webpack_require__(356);
	
	__webpack_require__(354);
	
	riot.tag2('persons-list', '  <div class="col-md-3 hidden-xs hidden-sm">\n    <catalog-tree object="ContactCategory" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" descendants="true" deselall="true"></catalog-tree>\n  </div>\n  <div class="col-md-9 col-xs-12 col-sm-12">\n    <catalog search="true" sortable="true" object="Contact" cols="{cols}" allselect="true" reload="true" add="{permission(add, &quot;contacts&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;contacts&quot;, &quot;0001&quot;)}" handlers="{handlers}" dblclick="{permission(personOpen, &quot;contacts&quot;, &quot;1000&quot;)}" store="persons-list" filters="{allFilters}">\n      <yield to="body">\n        <datatable-cell name="id"><a class="open-page-item" href="#persons/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n        <datatable-cell name="regDate">{row.regDate}</datatable-cell>\n        <datatable-cell name="email"><i class="fa {row.isActive == &quot;Y&quot; ? &quot;fa-check&quot; : &quot;fa-check text-noactive&quot;}"></i> {row.email}</datatable-cell>\n        <datatable-cell name="countOrders">{row.countOrders}</datatable-cell>\n        <datatable-cell name="amountOrders"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {(row.amountOrders / 1)} / {(row.paidOrders / 1)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n        <datatable-cell name="discount">{row.discount + 0} / {row.progressiveDiscount + 0}</datatable-cell>\n      </yield>\n      <yield to="head">\n        <div class="dropdown" if="{checkPermission(&quot;contacts&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n          <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n          <ul class="dropdown-menu">\n            <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.addCategory}"><a href="#"><i class="fa fa-fw"></i> Добавить в группы</a></li>\n            <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.setCategory}"><a href="#"><i class="fa fa-fw"></i> Переопределить группы</a></li>\n            <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.setPrice}"><a href="#"><i class="fa fa-fw"></i> Назначить тип цены</a></li>\n          </ul>\n        </div>\n        <button class="btn btn-primary" if="{selectedCount == 1}" onclick="{parent.exportCard}" title="Карточка контакта (XLS)" type="button"><i class="fa fa-file-excel-o" aria-hidden="true"></i></button>\n        <button class="btn btn-primary" type="button" onclick="{parent.exportPersons}" title="Экспорт"><i class="fa fa-upload"></i></button>\n\n      </yield>\n      <yield to="filters">\n        <div class="well well-sm">\n          <div class="form-inline">\n            <div class="form-group col-sm-12 hidden-lg hidden-md">\n              <label class="control-label">Группа</label>\n              <select class="form-control" data-name="idGroup" data-sign="IN">\n                <option value="">Все</option>\n                <option each="{category, i in parent.categories}" value="{category.id}" no-reorder>{category.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Менеджер</label>\n              <select class="form-control" data-name="managerId" data-sign="IN">\n                <option value="">Все</option>\n                <option each="{manager, i in parent.managers}" value="{manager.id}" no-reorder>{manager.title}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Статус</label>\n              <select class="form-control" onchange="{parent.change}">\n                <option value="">Все цены</option>\n                <option value="0">Розничные</option>\n                <option value="1">Корпоративные</option>\n                <option value="2">Оптовые</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="checkbox-inline">\n                <input type="checkbox" data-name="isActive" checked data-bool="Y,N">Активные\n              </label>\n            </div>\n          </div>\n        </div>\n      </yield>\n    </catalog>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _this2 = this;
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Contact';
	    self.categoryFilters = false;
	    self.typeFilters = false;
	    self.allFilters = false;
	    self.managers = {};
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'regDate', value: 'Регистрация' }, { name: 'email', value: 'Email' }, { name: 'countOrders', value: 'Заказов' }, { name: 'amountOrders', value: 'Сумма / оплачено' }, { name: 'discount', value: 'Скидка / Накоп., %' }];
	
	    self.handlers = {
	        addCategory: function addCategory(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            });
	
	            modals.create('persons-category-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    var groups = [];
	                    if (items.length > 0) {
	                        items.forEach(function (item) {
	                            if (groups.indexOf(item.id) === -1) {
	                                groups.push({ id: item.id, name: item.name });
	                            }
	                        });
	
	                        var params = { ids: ids, add: true, groups: groups };
	                        API.request({
	                            object: 'Contact',
	                            method: 'Save',
	                            data: params,
	                            success: function success(response) {
	                                self.tags.catalog.reload();
	                            }
	                        });
	                    }
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        },
	        setCategory: function setCategory(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            });
	
	            modals.create('persons-category-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    var groups = [];
	                    if (items.length > 0) {
	                        items.forEach(function (item) {
	                            if (groups.indexOf(item.id) === -1) {
	                                groups.push({ id: item.id, name: item.name });
	                            }
	                        });
	
	                        var params = { ids: ids, upd: true, groups: groups };
	                        API.request({
	                            object: 'Contact',
	                            method: 'Save',
	                            data: params,
	                            success: function success(response) {
	                                self.tags.catalog.reload();
	                            }
	                        });
	                    }
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        },
	        setPrice: function setPrice() {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            });
	            modals.create('person-pricetype-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var params = { ids: ids, upd: true, priceType: this.item.priceType };
	                    API.request({
	                        object: 'Contact',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags.catalog.reload();
	                        }
	                    });
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        }
	    };
	
	    self.change = function (e) {
	        var value = e.target.value;
	        if (value == '') {
	            self.typeFilters = false;
	        } else {
	            //var filter = {field: 'priceType', sign: 'IN', value: value}
	            self.typeFilters = [{ field: 'priceType', sign: 'IN', value: value }];
	        }
	        self.Filters();
	    };
	
	    self.add = function () {
	        modals.create('person-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var params = { firstName: _this.name.value, email: _this.email.value };
	                API.request({
	                    object: 'Contact',
	                    method: 'Save',
	                    data: params,
	                    success: function success(response, xhr) {
	                        popups.create({ title: 'Успех!', text: 'Контакт добавлен!', style: 'popup-success' });
	                        _this.modalHide();
	                        self.tags.catalog.reload();
	                        if (response && response.id) self.personOpenItem(response.id);
	                    }
	                });
	            }
	        });
	    };
	
	    self.Filters = function () {
	        if (self.typeFilters && self.categoryFilters) self.allFilters = [].concat(self.typeFilters, self.categoryFilters);else if (self.typeFilters) self.allFilters = self.typeFilters;else self.allFilters = self.categoryFilters;
	        self.update();
	        self.tags.catalog.reload();
	    };
	
	    self.personOpen = function (e) {
	        riot.route('/persons/' + e.item.row.id);
	    };
	
	    self.personOpenItem = function (id) {
	        riot.route('/persons/' + id);
	    };
	
	    self.importPersons = function (e) {
	        modals.create('import-persons-modal', {
	            type: 'modal-primary'
	        });
	    };
	
	    self.exportPersons = function () {
	        var params = { filters: self.allFilters };
	        /*API.request({
	            object: 'Contact',
	            method: 'Export',
	            data: params,
	            success(response, xhr) {
	                let a = document.createElement('a')
	                a.href = response.url
	                a.download = response.name
	                document.body.appendChild(a)
	                a.click()
	                a.remove()
	            }
	        })*/
	        modals.create('export-persons-modal', {
	            type: 'modal-primary'
	        });
	    };
	
	    self.exportCard = function (e) {
	        var _this = _this2;
	
	        var rows = self.tags.catalog.tags.datatable.getSelectedRows();
	        var params = { id: rows[0].id };
	
	        API.request({
	            object: 'Contact',
	            method: 'Export',
	            data: params,
	            success: function success(response, xhr) {
	                var a = document.createElement('a');
	                a.href = response.url;
	                a.download = response.name;
	                document.body.appendChild(a);
	                a.click();
	                a.remove();
	            }
	        });
	    };
	
	    self.getManagers = function () {
	        self.managers = [];
	        API.request({
	            object: 'PermissionUser',
	            method: 'Fetch',
	            success: function success(response) {
	                self.managers = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.getContactCategory = function () {
	        self.categories = [];
	        API.request({
	            object: 'ContactCategory',
	            method: 'Fetch',
	            success: function success(response) {
	                for (var i = 0; i < response.items.length; i++) {
	                    self.categories.push(response.items[i]);
	                    if (response.items[i].childs !== undefined) {
	                        for (var ii = 0; ii < response.items[i].childs.length; ii++) {
	                            self.categories.push(response.items[i].childs[ii]);
	                        }
	                    }
	                }
	                self.update();
	            }
	        });
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.on('reload', function () {
	            self.getContactCategory();
	        });
	        self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
	            self.selectedCategory = node.__selected__ ? node.id : undefined;
	            var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.id;
	                }).join(',');
	                self.categoryFilters = [{ field: 'idGroup', sign: 'IN', value: value }];
	            } else {
	                self.categoryFilters = false;
	            }
	            self.Filters();
	
	            //self.update()
	            //self.tags.catalog.reload()
	        });
	    });
	
	    self.getContactCategory();
	    self.getManagers();
	
	    observable.on('persons-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(406);
	
	__webpack_require__(402);
	
	__webpack_require__(399);
	
	__webpack_require__(400);
	
	__webpack_require__(398);
	
	__webpack_require__(404);
	
	riot.tag2('persons', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}"><a href="#persons/{link}"><span>{title}</span></a></li>\n  </ul>\n  <div class="column" if="{!notFound}">\n    <persons-list if="{tab == &quot;contacts&quot; &amp;&amp; !edit}"></persons-list>\n    <person-edit if="{tab == &quot;contacts&quot; &amp;&amp; edit}"></person-edit>\n    <companies-list if="{tab == &quot;companies&quot; &amp;&amp; !edit}"></companies-list>\n    <company-edit if="{tab == &quot;companies&quot; &amp;&amp; edit}"></company-edit>\n    <persons-categories-list if="{tab == &quot;categories&quot; &amp;&amp; !edit}"></persons-categories-list>\n    <accounts-list if="{tab == &quot;accounts&quot; &amp;&amp; !edit}"></accounts-list>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.edit = false;
	
	    self.tab = '';
	
	    self.tabs = [{ title: 'Контакты', name: 'contacts', link: '' }, { title: 'Компании', name: 'companies', link: 'companies' }, { title: 'Группы', name: 'categories', link: 'categories' }, { title: 'Операции по счетам', name: 'accounts', link: 'accounts' }];
	
	    route('/persons', function () {
	        self.edit = false;
	        self.tab = 'contacts';
	        self.update();
	    });
	
	    route('/persons/([0-9]+)', function (id) {
	        self.tab = 'contacts';
	        observable.trigger('persons-edit', id);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/persons/*', function (tab) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: false, tab: tab });
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/persons/*/([0-9]+)', function (tab, id) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: true, tab: tab });
	            observable.trigger(tab + '-edit', id);
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/persons/companies/new', function (tab) {
	        self.update({ edit: true, tab: 'companies' });
	        observable.trigger('companies-new');
	    });
	
	    route('/persons..', function () {
	        self.update({ edit: true, tab: 'not-found' });
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(33);
	
	riot.tag2('brand-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/brands"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование бренда\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#brand-edit-home">Основная информация</a></li>\n      <li><a data-toggle="tab" href="#brand-edit-seo">SEO</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="brand-edit-home">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="shopbrand" alt="0" size="256" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="form-group {has-error: error.name}">\n                    <label class="control-label">Наименование</label>\n                    <input class="form-control" name="name" type="text" value="{item.name}">\n                    <div class="help-block">{error.name}</div>\n                  </div>\n                </div>\n                <div class="col-md-12">\n                  <div class="form-group">\n                    <label class="control-label">URL страницы</label>\n                    <input class="form-control" name="code" type="text" value="{item.code}">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Краткое описание</label>\n                <ckeditor name="description" value="{item.description}"></ckeditor>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Подробное описание</label>\n                <ckeditor name="content" value="{item.content}" style="min-height: 500px;"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="brand-edit-seo">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Заголовок</label>\n                <input class="form-control" name="seoHeader" type="text" value="{item.seoHeader}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Ключевые слова</label>\n                <input class="form-control" name="seoKeywords" type="text" value="{item.seoKeywords}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Описание</label>\n                <textarea class="form-control" rows="5" name="seoDescription" style="min-width: 100%; max-width: 100%;" value="{item.seoDescription}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	    self.loader = false;
	    self.error = false;
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        self.error = self.validation.validate(self.item, self.rules, e.target.name);
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        self.error = self.validation.validate(params, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'Brand',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Бренд сохранен!', style: 'popup-success' });
	                    observable.trigger('brands-reload');
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        observable.trigger('brands-edit', self.item.id);
	    };
	
	    observable.on('brands-edit', function (id) {
	        self.loader = true;
	        self.error = false;
	        var params = { id: id };
	
	        API.request({
	            object: 'Brand',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'shopbrand');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('brand-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новый бренд</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Добавить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('brands-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Бренды</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Brand" cols="{parent.cols}" search="true" dblclick="{parent.opts.submit.bind(this)}" reload="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(409);
	
	riot.tag2('brands-list', '  <catalog search="true" sortable="true" object="Brand" cols="{cols}" reorder="true" allselect="true" reload="true" store="brands-list" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(brandOpen, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="img"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-width: 200px;"></datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n    </yield>\n  </catalog>\n', 'brands-list .table td,[riot-tag="brands-list"] .table td,[data-is="brands-list"] .table td{ vertical-align: middle !important; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Brand';
	
	    self.cols = [{ name: 'id', value: '#', width: '50px' }, { name: 'img', value: 'Логотип' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'URL' }];
	
	    self.add = function (e) {
	        modals.create('brand-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var params = { name: _this.name.value };
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'Brand',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            popups.create({ title: 'Успех!', text: 'Бренд добавлен!', style: 'popup-success' });
	                            _this.modalHide();
	                            observable.trigger('brands-reload');
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.brandOpen = function (e) {
	        riot.route('/products/brands/' + e.item.row.id);
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'Brand',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	            self.update();
	        });
	    });
	
	    observable.on('brands-reload', function () {
	        //self.tags.catalog.reload()
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	var _md5Min = __webpack_require__(62);
	
	var _md5Min2 = _interopRequireDefault2(_md5Min);
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault2(_parallel);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('coupon-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/coupons"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;products&quot;, &quot;0100&quot;) : checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.code || \'Добавление купона\' : item.code || \'Редактирование купона\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#coupon-edit-home">Параметры купона</a></li>\n      <li if="{item.type == &quot;g&quot;}"><a data-toggle="tab" href="#coupon-edit-products">Товары</a></li>\n      <li if="{item.type == &quot;g&quot;}"><a data-toggle="tab" href="#coupon-edit-categories">Категории товаров</a></li>\n      <li if="{item.type == &quot;g&quot; &amp;&amp; checkPermission(&quot;orders&quot;, &quot;1000&quot;)}"><a data-toggle="tab" href="#coupon-edit-history">История использования</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="coupon-edit-home">\n          <div class="row">\n            <div class="col-md-4">\n              <div class="form-group {has-error: error.code}">\n                <label class="control-label">Код</label>\n                <div class="input-group">\n                  <input class="form-control" name="code" value="{item.code}" __readonly="{!isNew}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{generateCode}"><i class="fa fa-random text-primary"></i></div>\n                  </div>\n                </div>\n                <div class="help-block">{error.code}</div>\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group {has-error: error.type}">\n                <label class="control-label">Тип скидки</label>\n                <select class="form-control" name="type" value="{item.type}">\n                  <option value="p">Процент на скидку</option>\n                  <option value="a">Абсолютная скидка на корзину</option>\n                  <option value="g">Процент на позиции товаров</option>\n                </select>\n                <div class="help-block">{error.type}</div>\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">До даты</label>\n                <datetime-picker class="form-control" name="expireDate" value="{item.expireDate}" format="YYYY-MM-DD"></datetime-picker>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Значение</label>\n                <div class="{&quot;input-group&quot;: item.type != &quot;a&quot;}">\n                  <input class="form-control" name="discount" value="{item.discount}" type="{\'number\'}"><span class="input-group-addon" if="{item.type != &quot;a&quot;}">%</span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Кол-во</label>\n                <input class="form-control" name="countUsed" value="{item.countUsed}" step="1" min="0" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Мин. сумма заказа</label>\n                <input class="form-control" name="minSumOrder" value="{item.minSumOrder}" step="0.01" min="0" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3" if="{item.type == &quot;a&quot;}">\n              <div class="form-group">\n                <label class="control-label">Валюта</label>\n                <select class="form-control" name="currency" value="{item.curr}">\n                  <option each="{c, i in currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Пользователь</label>\n                <div class="input-group">\n                  <div class="input-group-btn" if="{item.idUser}"><a class="btn btn-default" href="#persons/{item.idUser}" target="_blank"><i class="fa fa-eye"></i></a></div>\n                  <input class="form-control" value="{item.idUser ? item.idUser + &quot; - &quot;  + item.userName : &quot;&quot;}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" if="{checkPermission(&quot;contacts&quot;, &quot;1000&quot;)}" onclick="{changeUser}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{removeUser}"><i class="fa fa-remove text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="onlyRegistered" type="checkbox" __checked="{item.onlyRegistered == &quot;Y&quot;}" data-bool="Y,N">Для авторизованных\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="status" type="checkbox" __checked="{item.status == &quot;Y&quot;}" data-bool="Y,N">Активен\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="coupon-edit-products" if="{item.type == &quot;g&quot;}">\n          <catalog-static name="products" rows="{item.products}" cols="{productsCols}" add="{addProducts}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="code">{row.code}</datatable-cell>\n              <datatable-cell name="article">{row.article}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="price">{row.price}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="coupon-edit-categories" if="{item.type == &quot;g&quot;}">\n          <catalog-static name="groups" rows="{item.groups}" cols="{groupsCols}" add="{addGroups}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="coupon-edit-history" if="{checkPermission(&quot;orders&quot;, &quot;1000&quot;)}">\n          <catalog-static remove-toolbar="true" rows="{item.orders}" cols="{ordersCols}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n              <datatable-cell name="customer">{row.customer}</datatable-cell>\n              <datatable-cell name="amount">{row.amount}</datatable-cell>\n              <datatable-cell name="couponDiscount">{row.couponDiscount}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	    self.item = {};
	
	    self.rules = {
	        code: 'empty',
	        type: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.productsCols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'price', value: 'Цена' }];
	
	    self.groupsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.ordersCols = [{ name: 'id', value: '#' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'customer', value: 'Заказчик' }, { name: 'amount', value: 'Сумма заказа' }, { name: 'couponDiscount', value: 'Скидка' }];
	
	    self.addProducts = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.products = self.item.products || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.products.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        self.item.products.push(item);
	                    }
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.addGroups = function () {
	        modals.create('group-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.item.groups = self.item.groups || [];
	
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                var ids = self.item.groups.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) self.item.groups.push(item);
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.submit = function () {
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'Coupon',
	                method: 'Save',
	                data: self.item,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Купон сохранен!', style: 'popup-success' });
	                    if (self.isNew) riot.route('products/coupons/' + self.item.id);
	                    self.update();
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        return observable.trigger('coupons-edit', self.item.id);
	    };
	
	    self.generateCode = function () {
	        if (self.isNew) self.item.code = (0, _md5Min2.default)(Math.random().toString(36).substring(7));
	        self.error = self.validation.validate(self.item, self.rules, 'code');
	    };
	
	    self.changeUser = function () {
	        modals.create('persons-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                self.item.idUser = items[0].id;
	                self.item.userName = items[0].displayName;
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.removeUser = function () {
	        self.item.idUser = null;
	        self.item.userName = null;
	    };
	
	    observable.on('coupons-new', function () {
	        self.error = false;
	        self.item = {};
	        self.isNew = true;
	        self.update();
	
	        API.request({
	            object: 'Currency',
	            method: 'Fetch',
	            data: {},
	            success: function success(response) {
	                self.currencies = response.items;
	            },
	            complete: function complete() {
	                self.update();
	            }
	        });
	    });
	
	    observable.on('coupons-edit', function (id) {
	        self.error = false;
	        self.loader = true;
	        self.item = {};
	        self.isNew = false;
	        self.update();
	
	        (0, _parallel2.default)([function (callback) {
	            API.request({
	                object: 'Coupon',
	                method: 'Info',
	                data: { id: id },
	                success: function success(response) {
	                    self.item = response;
	                    callback(null, 'Coupon');
	                },
	                error: function error() {
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'Currency',
	                method: 'Fetch',
	                data: {},
	                success: function success(response) {
	                    self.currencies = response.items;
	                    callback(null, 'Currencies');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function () {
	            self.loader = false;
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('coupons-list', '  <catalog object="Coupon" cols="{cols}" search="true" sortable="true" handlers="{handlers}" allselect="true" reload="true" store="coupons-list" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code"><i class="fa {row.status == &quot;Y&quot; ? &quot;fa-check&quot; : &quot;fa-check text-noactive&quot;}"></i> {row.code}</datatable-cell>\n      <datatable-cell name="type">{handlers.typeValues[row.type]}</datatable-cell>\n      <datatable-cell name="discount"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.discount.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="minSumOrder"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.minSumOrder.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="status">{row.status == \'Y\' ? \'Да\' : \'Нет\'}</datatable-cell>\n      <datatable-cell name="countUsed">{row.countUsed}</datatable-cell>\n      <datatable-cell name="onlyRegistered">{row.onlyRegistered == \'Y\' ? \'Да\' : \'Нет\'}</datatable-cell>\n      <datatable-cell name="expireDate">{row.expireDate}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.mixin('permissions');
	    self.mixin('change');
	    self.collection = 'Coupon';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'type', value: 'Тип' }, { name: 'discount', value: 'Скидка' }, { name: 'minSumOrder', value: 'Мин. сумма' }, { name: 'status', value: 'Активен' }, { name: 'countUsed', value: 'Кол-во' }, { name: 'onlyRegistered', value: 'Зарегистрированным' }, { name: 'expireDate', value: 'Окончание' }];
	
	    self.add = function (e) {
	        return riot.route('products/coupons/new');
	    };
	
	    self.open = function (e) {
	        return riot.route('products/coupons/' + e.item.row.id);
	    };
	
	    self.handlers = {
	        typeValues: {
	            'p': 'Процент на скидку',
	            'a': 'Абсолютная скидка на корзину',
	            'g': 'Процент на позиции товаров'
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	__webpack_require__(159);
	
	__webpack_require__(103);
	
	riot.tag2('discount-edit', '  <loader if="{loader}"></loader>\n  <virtual if="{!loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/discounts"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;products&quot;, &quot;0100&quot;) : checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.title || \'Добавление скидки\' : item.title || \'Редактирование скидки\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#discount-edit-parameters">Параметры</a></li>\n      <li><a data-toggle="tab" href="#discount-edit-groups" if="{item.type == &quot;action&quot;}">Группы товаров</a></li>\n      <li><a data-toggle="tab" href="#discount-edit-products" if="{item.type == &quot;action&quot;}">Товары</a></li>\n\n\n\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="discount-edit-parameters">\n          <div class="row">\n            <div class="col-md-4">\n              <div class="form-group {has-error: error.title}">\n                <label class="control-label">Наименование</label>\n                <input class="form-control" name="title" value="{item.title}">\n                <div class="help-block">{error.title}</div>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group">\n                <label class="control-label">Тип скидки</label>\n                <select class="form-control" name="type" value="{item.type}">\n                  <option value="action">Акция</option>\n                  <option value="cumulative">Накопительная</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2" if="{item.type == &quot;action&quot;}">\n              <div class="form-group">\n                <label class="control-label">Тип контакта</label>\n                <select class="form-control" name="customerType" value="{item.customerType}">\n                  <option value="">Для всех</option>\n                  <option value="1">Для физических лиц</option>\n                  <option value="2">Для юридических лиц (компаний)</option>\n                  <option value="3">Все авторизированные</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group">\n                <label class="control-label">Тип значения</label>\n                <select class="form-control" name="typeDiscount" value="{item.typeDiscount}">\n                  <option value="absolute">Сумма</option>\n                  <option value="percent">Процент</option>\n                  <option value="optcorp">Мелкий орт</option>\n                  <option value="opt">Опт</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group" if="{item.typeDiscount == &quot;percent&quot; || item.typeDiscount == &quot;absolute&quot;}">\n                <label class="control-label">Скидка</label>\n                <div class="input-group">\n                  <input class="form-control" name="discount" step="0.01" min="0" value="{item.discount}" type="{\'number\'}"><span class="input-group-addon">{item.typeDiscount == \'percent\' ? \'%\' : \'р.\'}</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row" if="{item.type == &quot;action&quot;}">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input type="checkbox" __checked="{floatingDiscount}" onchange="{toggleFloatingDiscount}">Плавающая скидка\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="additional" type="checkbox" __checked="{item.additional}">Доп. скидка\n                  </label>\n                </div>\n              </div>\n            </div>\n\n\n          </div>\n          <div class="row" if="{item.type == &quot;action&quot;}" riot-style="display: {item.isAction ? &quot;block;&quot;: &quot;none;&quot;};">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="picture" section="shopaction" alt="0" size="256" value="{item.picture}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <label class="control-label">Описание акции</label>\n              <textarea class="form-control" name="description" value="{item.description}" style="min-height: 165px;"></textarea>\n            </div>\n          </div>\n          <div class="row" if="{item.type == &quot;action&quot;}">\n            <div class="col-md-6">\n              <div class="form-group" if="{floatingDiscount}">\n                <label class="control-label">Шаг скидки</label>\n                <div class="input-group">\n                  <input class="form-control" name="stepDiscount" step="0.01" value="{item.stepDiscount}" type="{\'number\'}"><span class="input-group-addon">{item.typeDiscount == \'percent\' ? \'%\' : \'р.\'}</span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group" if="{floatingDiscount}">\n                <label class="control-label">Шаг времени</label>\n                <div class="input-group">\n                  <input class="form-control" name="stepTime" min="0" value="{item.stepTime}" type="{\'number\'}"><span class="input-group-addon">ч.</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <h4>Условия предоставления скидки</h4>\n              <div class="row" if="{item.type == &quot;action&quot;}">\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">От даты</label>\n                    <div class="input-group"><span class="input-group-addon" style="padding: 3px;">\n                        <input type="checkbox" __checked="{item.dateFrom}" onclick="{checkDateFrom}" style="width: 14px;"></span>\n                      <datetime-picker class="form-control" name="dateFrom" format="DD.MM.YYYY HH:mm" value="{item.dateFrom}"></datetime-picker>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">До даты</label>\n                    <div class="input-group"><span class="input-group-addon" style="padding: 3px;">\n                        <input type="checkbox" __checked="{item.dateTo}" onclick="{checkDateTo}" style="width: 14px;"></span>\n                      <datetime-picker class="form-control" name="dateTo" format="DD.MM.YYYY HH:mm" value="{item.dateTo}"></datetime-picker>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-4">\n                  <div class="form-group">\n                    <label class="control-label">Дни недели</label><br>\n                    <week-days-checkbox name="week" value="{item.week}"></week-days-checkbox>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="row" if="{item.type == &quot;action&quot;}">\n                <div class="col-md-4">\n                  <div class="form-group">\n                    <label class="control-label">Тип суммы</label>\n                    <select class="form-control" name="summType" value="{item.summType}">\n                      <option value="0">Сумма текущей корзины</option>\n                      <option value="1">Сумма всех заказов</option>\n                      <option value="2">Сумма всех заказов + сумма текущей корзины</option>\n                      <option value="3">Только сумма корзины первого заказа</option>\n                    </select>\n                  </div>\n                </div>\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">Тип цены пользователя</label>\n                    <select class="form-control" name="priceType" value="{item.priceType}">\n                      <option each="{priceTypeTitle}" value="{id}" __selected="{item.priceType == id}">{name}</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">От суммы</label>\n                    <div class="input-group">\n                      <input class="form-control" name="summFrom" step="0.01" min="0" value="{item.summFrom}" type="{\'number\'}"><span class="input-group-addon">р.</span>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">До суммы</label>\n                    <div class="input-group">\n                      <input class="form-control" name="summTo" step="0.01" min="0" value="{item.summTo}" type="{\'number\'}"><span class="input-group-addon">р.</span>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-3" if="{item.type == &quot;action&quot;}">\n                  <div class="form-group">\n                    <label class="control-label">От кол-ва</label>\n                    <input class="form-control" name="countFrom" min="0" value="{item.countFrom}" type="{\'number\'}">\n                  </div>\n                </div>\n                <div class="col-md-3" if="{item.type == &quot;action&quot;}">\n                  <div class="form-group">\n                    <label class="control-label">До кол-ва</label>\n                    <input class="form-control" name="countTo" min="0" value="{item.countTo}" type="{\'number\'}">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="discount-edit-groups">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="listGroupsProducts" add="{addGroupsProductsPersons(&quot;group-select-modal&quot;)}" cols="{cols}" rows="{item.listGroupsProducts}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="discount-edit-products">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="listProducts" add="{addGroupsProductsPersons(&quot;products-list-select-modal&quot;)}" cols="{cols}" rows="{item.listProducts}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="discount-edit-personsgroup">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="listGroupsContacts" add="{addGroupsProductsPersons(&quot;persons-category-select-modal&quot;)}" cols="{cols}" rows="{item.listGroupsContacts}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                  <datatable-cell name="title">{row.title}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="discount-edit-persons">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="listContacts" add="{addGroupsProductsPersons(&quot;persons-list-select-modal&quot;)}" cols="{cols}" rows="{item.listContacts}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="lastName">{[row.lastName, row.firstName, row.secondName].join(\' \')}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="discount-edit-seo">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Заголовок (title)</label>\n                <input class="form-control" name="seoHeader" type="text" onfocus="{seoTag.focus}" value="{item.seoHeader}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Ключевые слова (keywords)</label>\n                <input class="form-control" name="seoKeywords" type="text" onfocus="{seoTag.focus}" value="{item.seoKeywords}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Оглавление страницы (H1)</label>\n                <input class="form-control" name="pageTitle" type="text" onfocus="{seoTag.focus}" value="{item.pageTitle}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Описание (description)</label>\n                <textarea class="form-control" rows="5" name="seoDescription" onfocus="{seoTag.focus}" style="min-width: 100%; max-width: 100%;" value="{item.seoDescription}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.prevStepDiscount = 0;
	    self.prevStepTime = 0;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	    self.seoTag = new app.insertText();
	    self.item = {};
	
	    self.rules = {
	        title: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.priceTypeTitle = [{ id: 0, name: 'Розничный' }, { id: 1, name: 'Мелкий оптовик' }, { id: 2, name: 'Оптовик' }];
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.checkDateFrom = function (e) {
	        if (self.item['dateFrom']) {
	            self.item['dateFrom'] = '';
	        }
	    };
	
	    self.checkDateTo = function (e) {
	        if (self.item['dateTo']) {
	            self.item['dateTo'] = '';
	        }
	    };
	
	    self.submit = function () {
	        var params = self.item;
	
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'Discount',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Скидка сохранена!', style: 'popup-success' });
	                    if (self.isNew) riot.route('products/discounts/' + self.item.id);
	                    observable.trigger('discount-reload');
	                }
	            });
	        }
	    };
	
	    self.addGroupsProductsPersons = function (modal) {
	        return function () {
	            var _this = this;
	
	            modals.create(modal, {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    _this.value = _this.value || [];
	                    var items = [];
	
	                    if (modal == 'group-select-modal') {
	                        items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                    } else {
	                        items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    }
	                    var ids = _this.value.map(function (item) {
	                        return item.id;
	                    });
	
	                    items.forEach(function (item) {
	                        if (ids.indexOf(item.id) === -1) _this.value.push(item);
	                    });
	
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        };
	    };
	
	    self.reload = function () {
	        observable.trigger('discounts-edit', self.item.id);
	    };
	
	    observable.on('discounts-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'Discount',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                self.floatingDiscount = parseInt(self.item.stepDiscount) !== 0 && parseInt(self.item.stepTime) !== 0;
	                self.update();
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.toggleFloatingDiscount = function () {
	        self.floatingDiscount = !self.floatingDiscount;
	        if (self.floatingDiscount) {
	            self.item.stepDiscount = self.prevStepDiscount;
	            self.item.stepTime = self.prevStepTime;
	        } else {
	            self.prevStepDiscount = self.item.stepDiscount;
	            self.prevStepTime = self.item.stepTime;
	            self.item.stepDiscount = 0;
	            self.item.stepTime = 0;
	        }
	    };
	
	    observable.on('discounts-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = {};
	        self.item.typeDiscount = 'percent';
	        self.item.type = 'action';
	
	        self.update();
	    });
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'shopaction');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('discounts-list-modal-select', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Скидки</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Discount" cols="{parent.cols}" reload="true" store="discounts-list-modal-select" dblclick="{parent.opts.submit.bind(this)}" handlers="{parent.handlers}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n          <datatable-cell name="dateFrom">{row.dateFrom}</datatable-cell>\n          <datatable-cell name="dateTo">{row.dateTo}</datatable-cell>\n          <datatable-cell name="stepTime">{row.stepTime}ч.</datatable-cell>\n          <datatable-cell name="stepDiscount">{row.stepDiscount}</datatable-cell>\n          <datatable-cell name="summFrom">{row.summFrom}</datatable-cell>\n          <datatable-cell name="summTo">{row.summTo}</datatable-cell>\n          <datatable-cell name="countFrom">{row.countFrom}</datatable-cell>\n          <datatable-cell name="countTo">{row.countTo}</datatable-cell>\n          <datatable-cell name="week">{handlers.getListOfDays(row.week)}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }, { name: 'dateFrom', value: 'Старт' }, { name: 'dateTo', value: 'Завершение' }, { name: 'stepTime', value: 'Шаг времени' }, { name: 'stepDiscount', value: 'Шаг скидки' }, { name: 'summFrom', value: 'От суммы' }, { name: 'summTo', value: 'До суммы' }, { name: 'countFrom', value: 'От кол-ва' }, { name: 'countTo', value: 'До кол-ва' }, { name: 'week', value: 'Дни недели' }];
	
	    self.handlers = {
	        daysOfWeek: ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'],
	        getListOfDays: function getListOfDays(days) {
	            var _this = this;
	
	            var items = days.split('');
	
	            var result = items.map(function (item, i) {
	                return item == 1 ? _this.daysOfWeek[i] : undefined;
	            }).filter(function (item) {
	                return item;
	            }).join(',');
	
	            return result;
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	riot.tag2('discounts-list', '  <catalog object="Discount" cols="{cols}" allselect="true" reload="true" handlers="{handlers}" store="discounts-list" reorder="true" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell class="{bg-info: row.type==&quot;cumulative&quot;}" name="title"><i class="fa fa-percent" if="{!row.additional}" title="Основная скидка"></i><i class="fa fa-plus" if="{row.additional}" title="Добавочная скидка"></i>&nbsp;{row.title}</datatable-cell>\n      <datatable-cell name="discount">{row.discount} {row.typeDiscount == \'percent\' ? \'%\' : \'р.\'}</datatable-cell>\n      <datatable-cell class="text-left" name="period">{handlers.period(row)}</datatable-cell>\n      <datatable-cell name="summFrom"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summFrom.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="summTo"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summTo.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="countFrom"><span if="{row.type!=&quot;cumulative&quot;}">{row.countFrom}</span><span if="{row.type==&quot;cumulative&quot;}">-</span></datatable-cell>\n      <datatable-cell name="countTo"><span if="{row.type!=&quot;cumulative&quot;}">{row.countTo}</span><span if="{row.type==&quot;cumulative&quot;}">-</span></datatable-cell>\n      <datatable-cell name="week"><span if="{row.type!=&quot;cumulative&quot;}">{handlers.getListOfDays(row.week)}</span><span if="{row.type==&quot;cumulative&quot;}">-</span></datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Discount';
	    self.cols = [{ name: 'title', value: 'Наименование' }, { name: 'discount', value: 'Скидка' }, { name: 'period', value: 'Период' }, { name: 'summFrom', value: 'От суммы' }, { name: 'summTo', value: 'До суммы' }, { name: 'countFrom', value: 'От кол-ва' }, { name: 'countTo', value: 'До кол-ва' }, { name: 'week', value: 'Дни недели' }];
	
	    self.handlers = {
	        daysOfWeek: ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'],
	        getListOfDays: function getListOfDays(days) {
	            var _this = this;
	
	            var items = days.split('');
	
	            var result = items.map(function (item, i) {
	                return item == 1 ? _this.daysOfWeek[i] : undefined;
	            }).filter(function (item) {
	                return item;
	            }).join(',');
	
	            return result;
	        },
	        period: function period(item) {
	            var period = '';
	            if (item.dateFrom) period = 'с ' + item.dateFrom;
	            if (period) period = period + ' - ' + item.dateTo;
	            if (!period) period = '-';
	            return period;
	        }
	    };
	
	    observable.on('discount-reload', function () {
	        return self.tags.catalog.reload();
	    });
	
	    self.add = function () {
	        riot.route('products/discounts/new');
	    };
	
	    self.open = function (e) {
	        riot.route('products/discounts/' + e.item.row.id);
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: self.collection,
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('filters-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Фильтры</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Filter" filters="{parent.filters}" cols="{parent.cols}" search="true" reload="true" disable-col-select="true" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Код' }];
	  var value = opts.idGroup || 0;
	  self.filters = [{ field: 'idGroup', sign: 'IN', value: value }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(33);
	
	__webpack_require__(164);
	
	__webpack_require__(174);
	
	__webpack_require__(175);
	
	__webpack_require__(417);
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault2(_parallel);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('group-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/categories"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isMulti}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isMulti ? \'Мультиредактирование категорий\' : item.name || \'Редактирование категории\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="{active: !isMulti}" if="{!isMulti}"><a data-toggle="tab" href="#group-edit-home">Основная информация</a></li>\n      <li if="{!isMulti}"><a data-toggle="tab" href="#group-edit-similar">Похожие категории</a></li>\n      <li if="{!isMulti}"><a data-toggle="tab" href="#group-edit-full-text">Полное описание</a></li>\n      <li class="{active: isMulti}" if="{app.config.version==&quot;5.3.1&quot;} "><a data-toggle="tab" href="#group-edit-images">Картинки</a></li>\n      <li><a data-toggle="tab" href="#group-edit-parameters-filters">Фильтры параметров</a></li>\n      <li><a data-toggle="tab" href="#group-edit-discounts">Скидки</a></li>\n      <li><a data-toggle="tab" href="#group-edit-seo">SEO</a></li>\n      <li><a data-toggle="tab" href="#group-edit-fields" if="{item.customFields}">Поля</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n\n        <div class="tab-pane fade {&quot;in active&quot;: !isMulti}" id="group-edit-home" show="{!isMulti}">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="picture" section="shopgroup" alt="0" size="256" value="{item.picture}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group {has-error: error.name}">\n                    <label class="control-label">Наименование</label>\n                    <input class="form-control" name="name" type="text" value="{item.name}">\n                    <div class="help-block">{error.name}</div>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Родитель</label>\n                    <div class="input-group">\n                      <input class="form-control" name="nameGroup" value="{item.nameParent}" __readonly="{true}">\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{selectGroup}"><i class="fa fa-list text-primary"></i></div>\n                        <div class="btn btn-default" onclick="{removeGroup}"><i class="fa fa-times text-danger"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">URL страницы</label>\n                    <input class="form-control" name="codeGr" type="text" value="{item.codeGr}">\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Группа модификаций по умолчанию</label>\n                    <select class="form-control" name="idModificationGroupDef" value="{item.idModificationGroupDef}">\n                      <option value=""></option>\n                      <option each="{item.modificationsGroups}" value="{id}" __selected="{id == item.idModificationGroupDef}" no-reorder>{name}</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-3">\n                  <label class="hidden-xs">&nbsp;</label>\n                  <div class="checkbox">\n                    <label>\n                      <input name="active" type="checkbox" __checked="{item.active == &quot;Y&quot;}">Отображать на сайте\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-3">\n                  <label class="hidden-xs">&nbsp;</label>\n                  <div class="checkbox">\n                    <label>\n                      <input name="discount" type="checkbox" __checked="{item.discount == &quot;Y&quot;}">Предоставлять скидку\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Порядок вывода</label>\n                    <input class="form-control" name="position" step="1" value="{item.position}" type="{\'number\'}">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Краткое описание</label>\n                <ckeditor name="commentary" value="{item.commentary}"></ckeditor>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Похожие группы</label>\n                <product-edit-additional-categories name="relatedGroups" value="{item.relatedGroups}"></product-edit-additional-categories>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label>Категория Яндекс.Маркет</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameMarketGroup" value="{item.nameMarketGroup}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{selectMarketGroup}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{removeMarketGroup}"><i class="fa fa-times text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n        </div>\n\n        <div class="tab-pane fade" id="group-edit-similar" show="{!isMulti}">\n          <catalog-static name="similar" rows="{item.similar}" cols="{similarCols}" add="{addChild}" reorder="true" dblclick="{openGroup}" remove="true">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="position">{parseInt(row.position) || 0}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n\n        <div class="tab-pane fade" id="group-edit-full-text" show="{!isMulti}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Полный текст</label>\n                <ckeditor name="footertext" value="{item.footertext}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class="tab-pane fade {&quot;in active&quot;: isMulti}" id="group-edit-images">\n          <product-edit-images name="images" value="{item.images}" section="shopgroup"></product-edit-images>\n        </div>\n        <div class="tab-pane fade" id="group-edit-parameters-filters">\n          <catalog-static name="parametersFilters" add="{addParametersFilters}" reorder="true" remove="true" cols="{parametersFiltersCols}" rows="{item.parametersFilters}" handlers="{parametersFiltersHandlers}">\n            <yield to="body">\n              <datatable-cell name="isActive"><i class="fa fa-fw {row.isActive ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.toggleCheckbox}"></i></datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="sortIndex">{row.sortIndex}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="group-edit-discounts">\n          <product-edit-discounts name="discounts" value="{item.discounts}"></product-edit-discounts>\n        </div>\n        <div class="tab-pane fade" id="group-edit-seo">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <button class="btn btn-primary btn-sm" each="{seoTags}" title="{note}" type="button" onclick="{seoTag.insert}" no-reorder>{name}</button>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Заголовок (title)</label>\n                <input class="form-control" name="title" type="text" onfocus="{seoTag.focus}" value="{item.title}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Ключевые слова (keywords)</label>\n                <input class="form-control" name="keywords" type="text" onfocus="{seoTag.focus}" value="{item.keywords}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Оглавление страницы (H1)</label>\n                <input class="form-control" name="pageTitle" type="text" onfocus="{seoTag.focus}" value="{item.pageTitle}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Описание (description)</label>\n                <textarea class="form-control" rows="5" name="description" onfocus="{seoTag.focus}" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="group-edit-fields" if="{item.customFields}">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	    self.edit = false;
	    self.app = app;
	    self.item = {};
	    self.loader = false;
	    self.error = false;
	    self.reloaded = false;
	    self.seoTags = [];
	
	    self.parametersFiltersCols = [{ name: 'isActive', value: '', width: '40px' }, { name: 'name', value: 'Наименование' }, { name: 'sortIndex', value: 'Индекс' }];
	
	    // шапка таблицы похожие категории
	    self.similarCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'position', value: 'Индекс' }];
	
	    self.seoTag = new app.insertText();
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        if (name == 'name') self.reloaded = true;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    // отправить
	    self.submit = function (e) {
	        var params = self.item;
	
	        if (self.isMulti) {
	            self.error = false;
	            params = (0, _extends3.default)({ ids: self.multiIds }, self.item);
	            if (params.commentary == '') params.commentary = null;
	        } else {
	            self.error = self.validation.validate(params, self.rules);
	        }
	
	        self.loader = true;
	
	        if (!self.error) {
	            self.loader = true;
	
	            API.request({
	                object: 'Category',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Категория сохранена!', style: 'popup-success' });
	                    if (self.reloaded) observable.trigger('categories-reload', self.item);
	                },
	                complete: function complete() {
	                    self.loader = false;
	                    self.update();
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        observable.trigger('categories-edit', self.item.id);
	    };
	
	    self.selectGroup = function (e) {
	        var id = self.item.id;
	        modals.create('group-select-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	
	                if (items.length && items[0].id != self.item.id) {
	                    self.item.upid = items[0].id;
	                    self.item.nameParent = items[0].name;
	                    self.update();
	                    self.reloaded = true;
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    self.openGroup = function (e) {
	        window.open('#products/categories/' + e.item.row.id, '_blank');
	    };
	
	    // добавление новой похожей категории
	    self.addChild = function () {
	        modals.create('group-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.item.similar = self.item.similar || [];
	
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                var ids = self.item.similar.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) self.item.similar.push(item);
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.addParametersFilters = function () {
	        modals.create('filters-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            idGroup: self.item.id,
	            submit: function submit() {
	                self.item.parametersFilters = self.item.parametersFilters || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.parametersFilters.map(function (item) {
	                    return item.id;
	                });
	                var cods = self.item.parametersFilters.map(function (item) {
	                    return item.code;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1 || cods.indexOf(item.code) === -1) self.item.parametersFilters.push(item);
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.parametersFiltersHandlers = {
	        toggleCheckbox: function toggleCheckbox(e) {
	            this.row.isActive = !this.row.isActive;
	        }
	    };
	
	    self.removeGroup = function (e) {
	        self.item.upid = null;
	        self.item.nameParent = '';
	    };
	
	    // Выбор Yandex группы
	    self.selectMarketGroup = function (e) {
	        modals.create('mgroup-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                self.item.marketCategory = items[0].id;
	                self.item.nameMarketGroup = items[0].name;
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Удалить группу market
	    self.removeMarketGroup = function (e) {
	        self.item.marketCategory = 0;
	        self.item.nameMarketGroup = '';
	    };
	
	    // получение наддых по редактируемой категории
	    observable.on('categories-edit', function (id) {
	        self.item = {};
	        self.isMulti = false;
	        self.loader = true;
	        self.error = false;
	        self.update();
	
	        (0, _parallel2.default)([function (callback) {
	            var params = { id: id };
	
	            API.request({
	                object: 'Category',
	                method: 'Info',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    callback(null, 'success');
	                },
	                error: function error(response) {
	                    self.item = {};
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'SeoVariable',
	                method: 'Fetch',
	                data: { type: 'goodsGroups' },
	                success: function success(response) {
	                    self.seoTags = response.items;
	                    callback(null, 'success');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function (err, res) {
	            self.loader = false;
	            self.update();
	        });
	    });
	
	    observable.on('categories-multi-edit', function (ids) {
	        self.item = {};
	        self.isMulti = true;
	        self.error = false;
	        self.multiIds = ids;
	        self.update();
	    });
	
	    self.one('updated', function () {
	        self.tags.similar.tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
	            var _self$tags$similar$pa = self.tags.similar.pages,
	                current = _self$tags$similar$pa.current,
	                limit = _self$tags$similar$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.similar.value.splice(offset + newIndex, 0, self.tags.similar.value.splice(offset + oldIndex, 1)[0]);
	            var temp = self.tags.similar.value;
	            self.rows = [];
	            self.update();
	            self.tags.similar.value = temp;
	
	            self.tags.similar.items.forEach(function (item, sort) {
	                item.sortIndex = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'Category',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	
	            self.update();
	        });
	        self.tags.parametersFilters.tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
	            var _self$tags$similar$pa2 = self.tags.similar.pages,
	                current = _self$tags$similar$pa2.current,
	                limit = _self$tags$similar$pa2.limit;
	
	            var offset = current > 0 ? (current - 1) * limit : 0;
	            self.tags.parametersFilters.value.splice(offset + newIndex, 0, self.tags.parametersFilters.value.splice(offset + oldIndex, 1)[0]);
	            var temp = self.tags.parametersFilters.value;
	            self.rows = [];
	            self.update();
	            self.tags.parametersFilters.value = temp;
	
	            self.tags.parametersFilters.items.forEach(function (item, sort) {
	                item.sortIndex = sort + offset;
	            });
	
	            self.update();
	        });
	    });
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'shopgroup');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('group-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новую группу</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('mgroup-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории Яндекс.Маркет</div>\n    </yield>\n    <yield to="body">\n      <catalog-tree object="Market" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" handlers="{handlers}" reload="true" search="true" dblclick="{parent.opts.submit.bind(this)}" exception="{parent.opts.id}">\n        <yield to="after"><span>{this[parent.childrenField].length ? ⁗[⁗ + this[parent.childrenField].length + ⁗]⁗ : ⁗⁗}</span></yield>\n      </catalog-tree>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', 'mgroup-select-modal .tree,[riot-tag="mgroup-select-modal"] .tree,[data-is="mgroup-select-modal"] .tree{ display : inline-block; border-left : 1px solid grey; border-bottom : 1px solid grey; width : 10px; height : 10px; margin-bottom : 5px; margin-right : 5px; }', '', function (opts) {
	  "use strict";
	
	  var self = this;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(107);
	
	riot.tag2('label-edit', '  <loader if="{loader}"></loader>\n  <div>\n    <div class="btn-group"><a class="btn btn-default" href="#products/labels"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Новая метка товара\' : item.name || \'Редактирование метки\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#label-edit-main">Информация о метки</a></li>\n      <li><a data-toggle="tab" href="#label-edit-products">Товары</a></li>\n    </ul>\n    <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="label-edit-main">\n          <div class="form-group {has-error: error.name}">\n            <div class="row">\n              <div class="col-md-2">\n                <div class="form-group">\n                  <label class="control-label">Иконка</label>\n                  <div class="well well-sm">\n                    <image-select name="imageFile" alt="0" section="labels" size="64" value="{item.imageFile}"></image-select>\n                  </div>\n                </div>\n              </div>\n              <div class="col-md-10">\n                <div class="form-group">\n                  <label class="control-label">Название метки</label>\n                  <input class="form-control" name="name" type="text" value="{item.name}">\n                  <div class="help-block">{error.name}</div>\n                </div>\n                <div class="form-group">\n                  <label class="control-label">Код</label>\n                  <input class="form-control" name="code" type="text" value="{item.code}">\n                  <div class="help-block">{error.code}</div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="label-edit-products">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="products" add="{addProducts}" cols="{productsCols}" rows="{item.products}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	    self.item = {};
	
	    self.productsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.rules = {
	        name: 'empty',
	        code: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.submit = function () {
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'ProductLabel',
	                method: 'Save',
	                data: self.item,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Метка для товара сохранена!', style: 'popup-success' });
	                    if (self.isNew) riot.route('products/labels/' + self.item.id);
	                    observable.trigger('products-labels-reload');
	                    self.update();
	                }
	            });
	        }
	    };
	
	    self.addProducts = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.products = self.item.products || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.products.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        self.item.products.push(item);
	                    }
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.reload = function () {
	        return observable.trigger('labels-edit', self.item.id);
	    };
	
	    observable.on('label-new', function () {
	        self.error = false;
	        self.item = {};
	        self.isNew = true;
	        self.update();
	    });
	
	    observable.on('labels-edit', function (id) {
	        self.error = false;
	        self.loader = true;
	        self.item = {};
	        self.isNew = false;
	        self.update();
	
	        API.request({
	            object: 'ProductLabel',
	            method: 'Info',
	            data: { id: id },
	            success: function success(response) {
	                self.item = response;
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(10);
	
	riot.tag2('labels-list', '  <catalog object="ProductLabel" cols="{cols}" search="true" reorder="true" handlers="{handlers}" reload="true" store="products-labels-list" allselect="true" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(edit, &quot;products&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="imageUrlPreview"><img riot-src="{row.imageUrlPreview}" alt="" width="32" height="32"></datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'ProductLabel';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'imageUrlPreview', value: 'Иконка' }, { name: 'code', value: 'Код' }, { name: 'name', value: 'Наименование' }];
	
	    self.add = function () {
	        return riot.route('/products/labels/new');
	    };
	
	    self.edit = function (e) {
	        return riot.route('products/labels/' + e.item.row.id);
	    };
	
	    observable.on('products-labels-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('modification-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{title}</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.type}">\n              <label class="control-label">Тип цены</label>\n              <select class="form-control" name="vtype" value="{item.vtype}">\n                <option value="0">Добавляет к цене</option>\n                <option value="1">Умножает на цену</option>\n                <option value="2">Замещает цену</option>\n              </select>\n              <div class="help-block">{error.vtype}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = opts.item || {};
	        modal.mixin('validation');
	        modal.mixin('change');
	        modal.title = opts.title;
	
	        modal.rules = {
	            name: 'empty',
	            values: {
	                required: true,
	                rules: [{
	                    vtype: 'minLength[1]',
	                    prompt: 'В списке должно быть не менее одного элемента'
	                }]
	            }
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	riot.tag2('modifications-list', '  <catalog object="Modification" cols="{cols}" allselect="true" reload="true" handlers="{handlers}" store="modifications-list" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="vtype">{handlers.types[row.vtype]}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Modification';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'vtype', value: 'Тип ценообразования' }];
	
	    self.handlers = {
	        types: {
	            "0": 'Добавляет к цене',
	            "1": 'Умножает на цену',
	            "2": 'Замещает цену'
	        }
	    };
	
	    self.add = function () {
	        riot.route('products/modifications/new');
	    };
	
	    self.open = function (e) {
	        riot.route('products/modifications/' + e.item.row.id);
	    };
	
	    observable.on('modifications-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('option-group-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить группу опций</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group {has-error: error.description}">\n          <label class="control-label">Описание</label>\n          <textarea class="form-control" rows="3" name="description" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n          <div class="help-block">{error.description}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.item = {};
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        if (opts.id) {
	            modal.loader = true;
	
	            API.request({
	                object: 'OptionGroup',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                },
	                complete: function complete() {
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('option-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить опцию</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-sm-5">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" section="options" alt="0" size="256" value="{item.image}"></image-select>\n              </div>\n            </div>\n          </div>\n          <div class="col-sm-7">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label"> Наименование</label>\n              <input class="form-control" name="name" type="text" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Метка (системное примечание)</label>\n              <input class="form-control" name="code" value="{item.code}">\n              <div class="help-block">{error.code}</div>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Группа</label>\n              <select class="form-control" name="idGroup" value="{item.idGroup}">\n                <option value="">Без группы</option>\n                <option each="{group in groups}" __selected="{item.idGroup == group.id}" value="{group.id}">{group.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Тип цены</label>\n              <select class="form-control" name="typePrice" value="{item.typePrice}">\n                <option each="{tp in ptypes}" __selected="{item.typePrice == tp.val}" value="{tp.val}">{tp.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Тип отображения</label>\n              <select class="form-control" name="type" value="{item.type}">\n                <option each="{tp in vtypes}" __selected="{item.type == tp.val}" value="{tp.val}">{tp.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Описание</label>\n              <textarea class="form-control" name="description" value="{item.description}"></textarea>\n            </div>\n            <div class="form-group">\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" name="isCounted" __checked="{item.isCounted}">Позволять менять количество значений\n                </label>\n              </div>\n            </div>\n            <div class="form-group">\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать в магазине\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.item.idGroup = opts.category || 0;
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.groups = [];
	
	        modal.ptypes = [{ val: 0, name: 'абсолютное значение' }, { val: 1, name: 'процент' }];
	
	        modal.vtypes = [{ val: 0, name: 'радиокнопки' }, { val: 1, name: 'список' }, { val: 2, name: 'чекбокс (множественный выбор)' }];
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        modal.getOptionGroup = function () {
	            API.request({
	                object: 'OptionGroup',
	                method: 'Fetch',
	                success: function success(response) {
	                    modal.groups = response.items;
	                    modal.update();
	                }
	            });
	        };
	
	        if (opts.item) {
	            modal.item = opts.item;
	        }
	
	        modal.getOptionGroup();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('optionitem-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Карточка элемента</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-5">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" section="options" alt="0" size="256" value="{item.image}"></image-select>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-7">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" type="text" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Описание</label>\n              <textarea class="form-control" name="description" value="{item.description}"></textarea>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Цена/%</label>\n              <input class="form-control" name="price" type="text" value="{item.price}">\n            </div>\n            <div class="form-group">\n              <label class="control-label">Опция</label>\n              <select class="form-control" name="idOption" value="{item.idOption}">\n                <option each="{group in options}" __selected="{item.idOption == group.id}" value="{group.id}">{group.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать в магазине\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.cannotBeClosed = true;
	        modal.eChange = false;
	
	        //let filters = []
	
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.item = {};
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        if (opts.item) {
	            modal.item = opts.item;
	        } else {
	            modal.item.idOption = opts.option || 0;
	        }
	
	        modal.loader = true;
	
	        modal.getOptionGroup = function () {
	            API.request({
	                object: 'Option',
	                method: 'Fetch',
	                success: function success(response) {
	                    modal.options = response.items;
	                    if (!modal.item.idOption) {
	                        modal.options.forEach(function (item) {
	                            modal.item.idOption = item.id;
	                            return true;
	                        });
	                    }
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        };
	        modal.getOptionGroup();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(425);
	
	riot.tag2('options-groups-list', '  <catalog object="OptionGroup" cols="{cols}" search="true" add="{permission(addEdit , &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;products&quot;, &quot;1000&quot;)}" reorder="true" reload="true" store="parameters-groups-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="sort">{row.sort}</datatable-cell>\n      <datatable-cell name="description">{row.description}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'OptionGroup';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'sort', value: 'Индекс' }, { name: 'description', value: 'Описание' }];
	
	    self.addEdit = function (e) {
	        var id;
	        if (e.item && e.item.row) {
	            id = e.item.row.id;
	        }
	
	        modals.create('option-group-new-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'OptionGroup',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'OptionGroup',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	
	            self.update();
	        });
	    });
	
	    observable.on('options-groups-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(427);
	
	riot.tag2('options-items-list', '  <catalog name="optionItem" object="OptionItems" cols="{cols}" search="true" allselect="true" reorder="true" handlers="{handlers}" reload="true" store="parameters-list" filters="{opts.filters}" add="{permission(addItem, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(editItem, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="image"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="price"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.price.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="nameOption">{row.nameOption}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'OptionItems';
	
	    self.addItem = function () {
	        var idOption = 0;
	        if (opts.filters !== undefined) {
	            idOption = opts.filters[0].value;
	        }
	        modals.create('optionitem-edit-modal', {
	            type: 'modal-primary',
	            option: idOption,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'OptionItems',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags['optionItem'].reload();
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.editItem = function (e) {
	        var item = void 0;
	
	        if (e.item && e.item.row) item = e.item.row;
	        modals.create('optionitem-edit-modal', {
	            type: 'modal-primary',
	            item: item,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'OptionItems',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags['optionItem'].reload();
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.cols = [{ name: 'image', value: 'Фото' }, { name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'measure', value: 'Цена' }, { name: 'nameOption', value: 'Опция' }];
	
	    self.one('updated', function () {
	        self.tags['optionItem'].tags.datatable.on('reorder-end', function () {
	            var _self$tags$optionItem = self.tags['optionItem'].pages,
	                current = _self$tags$optionItem.current,
	                limit = _self$tags$optionItem.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags['optionItem'].items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'OptionItems',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(426);
	
	__webpack_require__(429);
	
	riot.tag2('options-list', '  <div class="row">\n    <div class="col-md-4">\n      <catalog name="option" object="Option" cols="{colsOption}" handlers="{handlers}" allselect="true" reload="true" sortable="true" reorder="true" store="options-list" filters="{categoryFilters}" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(optionEdit, &quot;products&quot;, &quot;1000&quot;)}">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group">\n                <label class="control-label">Группы</label>\n                <select class="form-control" data-name="idGroup" onclick="{parent.selectCategory}">\n                  <option value="">Все</option>\n                  <option each="{category, i in parent.optionCategories}" value="{category.id}" no-reorder>{category.name}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="groupName">{row.groupName}</datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n    <div class="col-md-8 col-xs-12 col-sm-12">\n      <options-items-list name="optionList" filters="{optionFilters}"></options-items-list>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Option';
	    self.optionFilters = false;
	    self.optionCategories = [];
	    //self.categoryFilters = []
	    self.categoryId = 0;
	
	    var getFeaturesTypes = function getFeaturesTypes() {
	        API.request({
	            object: 'Option',
	            method: 'Fetch',
	            data: {},
	            success: function success(response) {
	                self.featuresTypes = response.items;
	                self.update();
	            }
	        });
	    };
	
	    var featureName = function featureName(type) {
	        for (var i = 0; i < self.featuresTypes.length; i++) {
	            if (self.featuresTypes[i].code === type) return self.featuresTypes[i].name;
	        }
	    };
	
	    self.optionEdit = function (e) {
	        var item = void 0;
	
	        if (e.item && e.item.row) item = e.item.row;
	
	        modals.create('option-new-modal', {
	            type: 'modal-primary',
	            item: item,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'Option',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags['option'].reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.add = function () {
	        if (self.handlers.params.filters != undefined && self.handlers.params.filters.length > 0) self.categoryId = self.handlers.params.filters[0].value;else self.categoryId = 0;
	        modals.create('option-new-modal', {
	            type: 'modal-primary',
	            category: self.categoryId,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'Option',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags['option'].reload();
	                            //self.optionFilters = [{field: 'idOption', sign: 'IN', value}]
	                            //self.update()
	                            //self.tags['optionList'].tags['optionItem'].reload()
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.colsOption = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'groupName', value: 'Группа' }];
	
	    self.handlers = {
	        featureName: featureName
	    };
	
	    self.one('updated', function () {
	        var datatable = self.tags['option'].tags.datatable;
	        datatable.on('row-selected', function (count, row) {
	            var items = datatable.getSelectedRows();
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.id;
	                }).join(',');
	                self.optionFilters = [{ field: 'idOption', sign: 'IN', value: value }];
	            } else {
	                self.optionFilters = false;
	            }
	            self.update();
	            self.tags['optionList'].tags['optionItem'].reload();
	        });
	        self.tags['option'].tags.datatable.on('reorder-end', function () {
	            var _self$tags$option$pag = self.tags['option'].pages,
	                current = _self$tags$option$pag.current,
	                limit = _self$tags$option$pag.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags['option'].items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'Option',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	
	            self.update();
	        });
	    });
	    self.getOptionGroup = function () {
	        API.request({
	            object: 'OptionGroup',
	            method: 'Fetch',
	            success: function success(response) {
	                self.optionCategories = response.items;
	                self.update();
	            }
	        });
	    };
	
	    observable.on('options-groups-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    self.getOptionGroup();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(428);
	
	__webpack_require__(430);
	
	riot.tag2('options', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="active"><a data-toggle="tab" href="#options-list">Опции</a></li>\n    <li><a data-toggle="tab" href="#options-groups">Группы</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="options-list">\n      <options-list></options-list>\n    </div>\n    <div class="tab-pane fade" id="options-groups">\n      <options-groups-list></options-groups-list>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable, app) {'use strict';
	
	__webpack_require__(61);
	
	__webpack_require__(172);
	
	__webpack_require__(435);
	
	riot.tag2('parameter-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/parameters"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование параметра\'}</div>\n    <div class="tab-content">\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="row">\n          <div class="col-md-2">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" section="shopfeature" alt="0" size="256" value="{item.image}"></image-select>\n              </div>\n            </div>\n            <div class="form-group">\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать\n                </label>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-10">\n            <div class="row">\n              <div class="col-md-10">\n                <div class="form-group {has-error: error.name}">\n                  <label class="control-label">Наименование</label>\n                  <input class="form-control" name="name" type="text" value="{item.name}">\n                  <div class="help-block">{error.name}</div>\n                </div>\n              </div>\n\n              <div class="col-md-2">\n                <div class="form-group {has-error: error.type}">\n                  <label class="control-label">Тип переменной</label>\n                  <select class="form-control" name="type" value="{item.type}">\n                    <option each="{feature, i in featuresTypes}" value="{feature.code}">{feature.name}</option>\n                  </select>\n                  <div class="help-block">{error.type}</div>\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-2">\n                <div class="form-group">\n                  <label class="control-label">Ед. изм.</label>\n                  <input class="form-control" name="measure" type="text" value="{item.measure}">\n                </div>\n              </div>\n              <div class="col-md-5">\n                <div class="form-group">\n                  <label class="control-label">Подсказка</label>\n                  <input class="form-control" name="placeholder" type="text" value="{item.placeholder}">\n                </div>\n              </div>\n              <div class="col-md-5">\n                <div class="form-group">\n                  <label class="control-label">Категория</label>\n                  <div class="input-group">\n                    <input class="form-control" name="nameGroup" type="text" value="{item.nameGroup}" readonly>\n                    <div class="input-group-btn">\n                      <div class="btn btn-default" onclick="{selectGroup}"><i class="fa fa-list text-primary"></i></div>\n                      <div class="btn btn-default" onclick="{removeGroup}"><i class="fa fa-times text-danger"></i></div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label">Описание</label>\n                  <textarea class="form-control" rows="5" name="description" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n      <div class="row" if="{listTypes.indexOf(item.type) !== -1}">\n        <div class="col-md-12">\n\n\n          <div class="form-group">\n            <label class="control-label">Список значений параметра</label><br>\n            <button class="btn btn-primary" onclick="{addFeatureValue}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n            <button class="btn btn-danger" if="{featuresSelectedCount}" onclick="{removeFeatureValue}" title="Удалить" type="button"><i class="fa fa-trash">{(featuresSelectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{featuresSelectedCount &gt; 1}">{featuresSelectedCount}</span></button>\n            <button class="btn btn-primary" if="{featuresSelectedCount &gt; 0}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n            <button class="btn btn-primary" if="{featuresSelectedCount &gt; 0}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n            <div class="dropdown" style="display: inline-block;">\n              <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n              <ul class="dropdown-menu">\n                <li onclick="{sortAsc}"><a href="#"><i class="fa fa-fw fa-sort"></i> Сортировать по возрастанию</a></li>\n                <li onclick="{sortDesc}"><a href="#"><i class="fa fa-fw fa-sort"></i> Сортировать по убыванию</a></li>\n              </ul>\n            </div>\n          </div>\n          <datatable name="features" cols="{featuresValuesCols}" rows="{item.values}" dblclick="{editFeatureValue}" reorder="true">\n            <datatable-cell name="image" style="width: 50px; overflow: hidden;"><img if="{row.image.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 40px;"></datatable-cell>\n            <datatable-cell name="value"><i class="color" if="{parent.parent.parent.item.type === &quot;colorlist&quot;}" riot-style="background-color: {row.color};"></i>{row.value}</datatable-cell>\n            <datatable-cell name="code">{row.code}</datatable-cell>\n          </datatable>\n        </div>\n      </div>\n\n    </div>\n  </virtual>\n', 'parameter-edit .color,[riot-tag="parameter-edit"] .color,[data-is="parameter-edit"] .color{ height: 12px; width: 12px; display: inline-block; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.item = {};
	    self.listTypes = ['list', 'colorlist', 'check'];
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty',
	        type: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.featuresValuesCols = [
	    //{name: 'id', value: '#'},
	    { name: 'image', value: 'Фото' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Код (URL)' }];
	
	    self.sortAsc = function () {
	        self.item.values = self.item.values.sort(function (a, b) {
	            var c = a.value,
	                d = b.value;
	            if (c * 1 > 0) c = c * 1;
	            if (d * 1 > 0) d = d * 1;
	            if (c < d) {
	                return -1;
	            } else if (c > d) {
	                return 1;
	            }
	            return 0;
	        });
	        for (var i = 0; i < self.item.values.length; i++) {
	            self.item.values[i]['sort'] = i;
	        }
	    };
	
	    self.sortDesc = function () {
	        self.item.values = self.item.values.sort(function (a, b) {
	            var c = a.value,
	                d = b.value;
	            if (c * 1 > 0) c = c * 1;
	            if (d * 1 > 0) d = d * 1;
	            if (c > d) {
	                return -1;
	            } else if (c < d) {
	                return 1;
	            }
	            return 0;
	        });
	        for (var i = 0; i < self.item.values.length; i++) {
	            self.item.values[i]['sort'] = i;
	        }
	    };
	
	    self.submit = function (e) {
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'Feature',
	                method: 'Save',
	                data: self.item,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Параметр сохранен!', style: 'popup-success' });
	                    observable.trigger('parameters-groups-reload');
	                    self.update();
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        observable.trigger('parameters-edit', self.item.id);
	    };
	
	    self.reorderNext = function () {
	        self.tags['features'].reorderNext();
	    };
	
	    self.reorderPrev = function () {
	        self.tags['features'].reorderPrev();
	    };
	
	    function getImageUrl(name) {
	        if (name.indexOf('http://') == -1 && name.indexOf('https://') == -1) {
	            return app.getImagePreviewURL(name, 'shopfeature');
	        } else {
	            return name;
	        }
	    }
	
	    self.addFeatureValue = function () {
	        modals.create('feature-new-edit-modal', {
	            type: 'modal-primary',
	            typeparam: self.item.type,
	            submit: function submit() {
	                var _this = this,
	                    params = {};
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    params.idFeature = self.item.id;
	                    params.value = _this.item.value;
	                    if (params.value.image && !params.value.imageUrlPreview) {
	                        params.value.imageUrlPreview = getImageUrl(params.value.image);
	                    }
	
	                    self.item.values = [params].concat(self.item.values);
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    self.editFeatureValue = function (e) {
	        modals.create('feature-new-edit-modal', {
	            item: e.item.row,
	            type: 'modal-primary',
	            typeparam: self.item.type,
	            submit: function submit() {
	                e.item.row = this.item;
	                if (e.item.row.image && !e.item.row.imageUrlPreview) {
	                    e.item.row.imageUrlPreview = getImageUrl(e.item.row.image);
	                }
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.removeFeatureValue = function () {
	        self.item.values = self.tags.features.getUnselectedRows();
	        self.update();
	    };
	
	    var getFeaturesTypes = function getFeaturesTypes() {
	        return API.request({
	            object: 'FeatureType',
	            method: 'Fetch',
	            data: {},
	            success: function success(response) {
	                self.featuresTypes = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.selectGroup = function () {
	        modals.create('parameters-groups-list-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length) {
	                    self.item.idFeatureGroup = items[0].id;
	                    self.item.nameGroup = items[0].name;
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	    self.removeGroup = function (e) {
	        self.item.idFeatureGroup = null;
	        self.item.nameGroup = '';
	    };
	
	    observable.on('parameters-edit', function (id) {
	        var params = { id: id };
	        self.item = {};
	        self.loader = true;
	        self.error = false;
	        self.featuresSelectedCount = 0;
	        self.update();
	
	        API.request({
	            object: 'Feature',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                self.update({
	                    loader: false
	                });
	            },
	            error: function error(response) {
	                self.update({
	                    loader: false
	                });
	            }
	        });
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	
	    self.on('updated', function () {
	        if (self.listTypes.indexOf(self.item.type) !== -1) {
	            self.tags.features.on('row-selected', function (count) {
	                self.featuresSelectedCount = count;
	                self.update();
	            });
	            self.tags.features.on('reorder-end', function () {
	                self.item.values.forEach(function (item, index) {
	                    item.sort = index;
	                });
	
	                self.update();
	            });
	            self.off('updated');
	        }
	    });
	
	    getFeaturesTypes();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(12)))

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('parameter-group-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить группу параметров</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-5">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" style="height: 100%;" section="shopfeaturegroup" alt="0" size="50" value="{item.image}"></image-select>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-7">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" type="text" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n            <div class="form-group {has-error: error.description}">\n              <label class="control-label">Описание</label>\n              <textarea class="form-control" rows="3" name="description" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n              <div class="help-block">{error.description}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.item = {};
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        if (opts.id) {
	            modal.loader = true;
	
	            API.request({
	                object: 'FeatureGroup',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                },
	                complete: function complete() {
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('parameter-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить параметр</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label"> Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('parameters-groups-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Группы параметров</div>\n    </yield>\n    <yield to="body">\n      <catalog object="FeatureGroup" cols="{parent.cols}" store="parameters-groups-list-modal" search="true" remove="{parent.remove}" reload="true" disable-col-select="true" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="sort">{row.sort}</datatable-cell>\n          <datatable-cell name="description">{row.description}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.mixin('remove');
	  self.collection = 'FeatureGroup';
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'sort', value: 'Индекс' }, { name: 'description', value: 'Описание' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(433);
	
	riot.tag2('parameters-groups-list', '  <catalog object="FeatureGroup" cols="{cols}" search="true" add="{permission(addEdit , &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;products&quot;, &quot;1000&quot;)}" reorder="true" reload="true" store="parameters-groups-list">\n    <yield to="body">\n      <datatable-cell name="id" style="width: 5%;">{row.id}</datatable-cell>\n      <datatable-cell name="img" style="width: 100px;"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 32px;"></datatable-cell>\n      <datatable-cell name="name" style="width: 20%;">{row.name}</datatable-cell>\n      <datatable-cell name="description">{row.description}</datatable-cell>\n      <datatable-cell name="sort" style="width: 2%;">{row.sort}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'FeatureGroup';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'img', value: 'Фото' }, { name: 'name', value: 'Наименование' }, { name: 'description', value: 'Описание' }, { name: 'sort', value: 'Индекс' }];
	
	    self.addEdit = function (e) {
	        var id;
	        if (e.item && e.item.row) {
	            id = e.item.row.id;
	        }
	
	        modals.create('parameter-group-new-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'FeatureGroup',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'FeatureGroup',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	
	            self.update();
	        });
	    });
	
	    observable.on('parameters-groups-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(434);
	
	riot.tag2('parameters-list', '  <div class="row">\n    <div class="col-md-3 hidden-xs hidden-sm">\n\n      <catalog-tree object="FeatureGroup" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" allselect="true" reload="true" descendants="true"></catalog-tree>\n    </div>\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog object="Feature" cols="{cols}" search="true" sortable="true" reorder="true" handlers="{handlers}" allselect="true" reload="true" store="parameters-list" filters="{categoryFilters}" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(parameterOpen, &quot;products&quot;, &quot;1000&quot;)}">\n        <yield to="head">\n          <div class="dropdown" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 1}" style="display: inline-block;">\n            <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n            <ul class="dropdown-menu">\n              <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.merge}"><a href="#"><i class="fa fa-fw fa-pencil"></i> Объеденить параметры</a></li>\n            </ul>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="id" style="width: 5%;">{row.id}</datatable-cell>\n          <datatable-cell name="img" style="width: 50px;"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 32px;"></datatable-cell>\n          <datatable-cell name="name"><i class="fa {row.isActive ? &quot;fa-eye&quot; : &quot;fa-eye-slash text-noactive&quot;}"></i> {row.name}</datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n          <datatable-cell name="measure">{row.measure}</datatable-cell>\n          <datatable-cell name="type">{handlers.featureName(row.type)}</datatable-cell>\n          <datatable-cell name="valCount">{row.valCount}</datatable-cell>\n          <datatable-cell name="nameGroup">{row.nameGroup}</datatable-cell>\n          <datatable-cell name="sort" style="width: 2%;">{row.sort}</datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Feature';
	    self.categoryFilters = false;
	
	    var getFeaturesTypes = function getFeaturesTypes() {
	        API.request({
	            object: 'FeatureType',
	            method: 'Fetch',
	            data: {},
	            success: function success(response) {
	                self.featuresTypes = response.items;
	                self.update();
	            }
	        });
	    };
	
	    var featureName = function featureName(type) {
	        for (var i = 0; i < self.featuresTypes.length; i++) {
	            if (self.featuresTypes[i].code === type) return self.featuresTypes[i].name;
	        }
	    };
	
	    self.add = function () {
	        modals.create('parameter-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var params = { name: _this.name.value };
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'Feature',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            if (response.id) riot.route('products/parameters/' + response.id);
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.parameterOpen = function (e) {
	        return riot.route('/products/parameters/' + e.item.row.id);
	    };
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'img', value: 'Фото' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Код (URL)' }, { name: 'measure', value: 'Ед. изм.' }, { name: 'type', value: 'Тип параметра' }, { name: 'valCount', value: 'Значений' }, { name: 'nameGroup', value: 'Группа параметра' }, { name: 'sort', value: 'Индекс' }];
	
	    self.handlers = {
	        featureName: featureName,
	        merge: setMerge
	    };
	
	    function setMerge(e) {
	        var _this = this;
	        var params = {};
	
	        var items = _this.tags.datatable.getSelectedRows();
	        var ids = items.map(function (item) {
	            return item.id;
	        });
	        params = { ids: ids };
	        params = _this.allParams(params);
	        API.request({
	            object: 'Feature',
	            method: 'Merge',
	            data: params,
	            success: function success(response) {
	                _this.reload();
	            }
	        });
	    }
	
	    self.one('updated', function () {
	        self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
	            self.selectedCategory = node.__selected__ ? node.id : undefined;
	            var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.id;
	                }).join(',');
	                self.categoryFilters = [{ field: 'idFeatureGroup', sign: 'IN', value: value }];
	            } else {
	                self.categoryFilters = false;
	            }
	            self.update();
	            self.tags.catalog.reload();
	        });
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'Feature',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	
	            self.update();
	        });
	    });
	
	    observable.on('parameters-groups-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    getFeaturesTypes();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(436);
	
	__webpack_require__(437);
	
	riot.tag2('parameters', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="active"><a data-toggle="tab" href="#palametrs-list">Список параметров</a></li>\n    <li><a data-toggle="tab" href="#parameters-groups">Категории</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="palametrs-list">\n      <parameters-list></parameters-list>\n    </div>\n    <div class="tab-pane fade" id="parameters-groups">\n      <parameters-groups-list></parameters-groups-list>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('products-types-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Тип товара</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="h4">Параметры</div>\n        <div class="alert alert-danger" if="{error.features}">{error.features}</div>\n        <catalog-static name="features" rows="{item.features}" cols="{cols}" dblclick="{parent.opts.submit.bind(this)}" add="{add}" remove="true">\n          <yield to="body">\n            <datatable-cell name="name">{row.name}</datatable-cell>\n          </yield>\n        </catalog-static>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.loader = opts.id;
	        modal.error = false;
	        modal.item = {};
	        modal.cols = [{ name: "name", value: "Наименование" }];
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty',
	            features: {
	                required: true,
	                rules: [{
	                    type: 'minLength[1]',
	                    prompt: 'Добавьте хотя бы один элемент в список'
	                }]
	            }
	        };
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	        };
	
	        modal.add = function () {
	            modals.create('parameters-list-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    modal.item.features = modal.item.features || [];
	
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    var ids = modal.item.features.map(function (item) {
	                        return item.id;
	                    });
	
	                    items.forEach(function (item) {
	                        if (ids.indexOf(item.id) === -1) modal.item.features.push(item);
	                    });
	
	                    modal.update();
	                    this.modalHide();
	
	                    var event = document.createEvent('Event');
	                    event.initEvent('change', true, true);
	                    modal.tags.features.root.dispatchEvent(event);
	                }
	            });
	        };
	
	        if (opts.id) {
	            API.request({
	                object: 'ProductType',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                },
	                complete: function complete() {
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	var _truncate = __webpack_require__(839);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	__webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('products-types-list', '  <catalog object="ProductType" cols="{cols}" search="true" reorder="true" handlers="{handlers}" allselect="true" reload="true" store="products-types-list" add="{permission(addEdit, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;products&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="features">{handlers.truncate(row.features, {length: 75})}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'ProductType';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'features', value: 'Параметры' }];
	
	    self.addEdit = function (e) {
	        var id = void 0;
	        if (e && e.item && e.item.row) id = e.item.row.id;
	
	        modals.create('products-types-edit-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'ProductType',
	                        method: 'Save',
	                        data: _this.item,
	                        success: function success(response) {
	                            popups.create({ title: 'Успех!', text: 'Тип продукта сохранен!', style: 'popup-success' });
	                            observable.trigger('products-types-list-reload');
	                            if (!id) _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    observable.on('products-types-list-reload', function () {
	        return self.tags.catalog.reload();
	    });
	
	    self.handlers = { truncate: _truncate2.default };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, observable) {'use strict';
	
	__webpack_require__(454);
	
	__webpack_require__(451);
	
	__webpack_require__(169);
	
	__webpack_require__(418);
	
	__webpack_require__(411);
	
	__webpack_require__(408);
	
	__webpack_require__(438);
	
	__webpack_require__(424);
	
	__webpack_require__(170);
	
	__webpack_require__(416);
	
	__webpack_require__(414);
	
	__webpack_require__(413);
	
	__webpack_require__(412);
	
	__webpack_require__(440);
	
	__webpack_require__(432);
	
	__webpack_require__(431);
	
	__webpack_require__(368);
	
	__webpack_require__(365);
	
	__webpack_require__(422);
	
	__webpack_require__(421);
	
	riot.tag2('products', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}" title="{title}" if="{access}"><a href="#products/{link}"><i class="{icon}"></i><span class="hidden-xs">&nbsp;{title}</span></a></li>\n  </ul>\n  <div class="column">\n    <products-list if="{tab == &quot;products&quot; &amp;&amp; !edit}"></products-list>\n    <product-edit if="{tab == &quot;products&quot; &amp;&amp; edit}"></product-edit>\n    <groups-list if="{tab == &quot;categories&quot; &amp;&amp; !edit}"></groups-list>\n    <group-edit if="{tab == &quot;categories&quot; &amp;&amp; edit}"></group-edit>\n    <labels-list if="{tab == &quot;labels&quot; &amp;&amp; !edit}"></labels-list>\n    <label-edit if="{tab == &quot;labels&quot; &amp;&amp; edit}"></label-edit>\n    <products-types-list if="{tab == &quot;types&quot; &amp;&amp; !edit}"></products-types-list>\n    <brands-list if="{tab == &quot;brands&quot; &amp;&amp; !edit}"></brands-list>\n    <brand-edit if="{tab == &quot;brands&quot; &amp;&amp; edit}"></brand-edit>\n    <options if="{tab == &quot;options&quot;}"></options>\n    <parameters if="{tab == &quot;parameters&quot; &amp;&amp; !edit}"></parameters>\n    <parameter-edit if="{tab == &quot;parameters&quot; &amp;&amp; edit}"></parameter-edit>\n    <modifications-list if="{tab == &quot;modifications&quot; &amp;&amp; !edit}"></modifications-list>\n    <modification-edit if="{tab == &quot;modifications&quot; &amp;&amp; edit}"></modification-edit>\n    <discounts-list if="{tab == &quot;discounts&quot; &amp;&amp; !edit}"></discounts-list>\n    <discount-edit if="{tab == &quot;discounts&quot; &amp;&amp; edit}"></discount-edit>\n    <delivery if="{tab == &quot;delivery&quot; &amp;&amp; !edit}"></delivery>\n    <delivery-edit if="{tab == &quot;delivery&quot; &amp;&amp; edit}"></delivery-edit>\n    <coupons-list if="{tab == &quot;coupons&quot; &amp;&amp; !edit}"></coupons-list>\n    <coupon-edit if="{tab == &quot;coupons&quot; &amp;&amp; edit}"></coupon-edit>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.edit = false;
	    self.tab = '';
	    self.app = app;
	    self.bigaccess = self.app.config.version > 530;
	
	    self.tabs = [{ title: 'Список товаров', name: 'products', link: '', icon: 'fa fa-shopping-bag', access: true }, { title: 'Категории', name: 'categories', link: 'categories', icon: 'fa fa-folder-open', access: true }, { title: 'Бренды', name: 'brands', link: 'brands', icon: 'fa fa-adn', access: true }, { title: 'Ярлыки', name: 'labels', link: 'labels', icon: 'fa fa-tags', access: true }, { title: 'Опции', name: 'options', link: 'options', icon: 'fa fa-list', access: true }, { title: 'Параметры', name: 'parameters', link: 'parameters', icon: 'fa fa-cog', access: true }, { title: 'Характеристики', name: 'types', link: 'types', icon: 'fa fa-check-square', access: true }, { title: 'Модификации', name: 'modifications', link: 'modifications', icon: 'fa fa-sliders', access: true }, { title: 'Доставка', name: 'delivery', link: 'delivery', icon: 'fa fa-truck', access: true }, { title: 'Скидки', name: 'discounts', link: 'discounts', icon: 'fa fa-percent', access: true }, { title: 'Купоны', name: 'coupons', link: 'coupons', icon: 'fa fa-money', access: true }];
	
	    var route = riot.route.create();
	
	    route('/products/([0-9]+)', function (id) {
	        self.tab = 'products';
	        observable.trigger('products-edit', id);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/products/*/([0-9]+)', function (tab, id) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: true, tab: tab });
	            observable.trigger(tab + '-edit', id);
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/products/multi..', function () {
	        var q = riot.route.query();
	        var ids = q.ids.split(',');
	        self.tab = 'products';
	        observable.trigger('products-multi-edit', ids);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/products/clone..', function () {
	        var q = riot.route.query();
	        var id = q.id;
	        self.tab = 'products';
	        observable.trigger('products-clone', id);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/products/categories/multi..', function () {
	        var q = riot.route.query();
	        var ids = q.ids.split(',');
	        self.tab = 'categories';
	        observable.trigger('categories-multi-edit', ids);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/products/labels/new', function (tab) {
	        self.update({ edit: true, tab: 'labels' });
	        observable.trigger('label-new');
	    });
	
	    route('/products/modifications/new', function (tab) {
	        self.update({ edit: true, tab: 'modifications' });
	        observable.trigger('modifications-new');
	    });
	
	    route('/products/discounts/new', function (tab) {
	        self.update({ edit: true, tab: 'discounts' });
	        observable.trigger('discounts-new');
	    });
	
	    route('/products/coupons/new', function (tab) {
	        self.update({ edit: true, tab: 'coupons' });
	        observable.trigger('coupons-new');
	    });
	
	    route('/products', function () {
	        self.edit = false;
	        self.tab = 'products';
	        self.update();
	    });
	
	    route('/products/*', function (tab) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: false, tab: tab });
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/products..', function () {
	        self.update({ edit: true, tab: 'not-found' });
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(5)))

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('description-tabs', '  <ul class="nav nav-tabs" if="{value.length &gt; 0}">\n    <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.tabTitle}</span>\n        <button class="close" onclick="{closeTab}" type="button"><span> &times;</span></button></a></li>\n  </ul>\n  <div class="row" each="{item, i in value}" show="{active: activeTab === i}" no-reorder>\n    <div class="col-md-12">\n      <div class="form-inline m-t-3">\n        <div class="form-group">\n          <input class="form-control" name="tabTitle" value="{item.tabTitle}" oninput="{change}">\n        </div>\n        <div class="form-group">\n          <button class="btn btn-default" type="button" title="Добавить вкладку" onclick="{addTab}"><i class="fa fa-plus"></i></button>\n        </div>\n      </div>\n      <div class="form-group m-t-3">\n        <ckeditor name="text" value="{item.text}" onchange="{change}"></ckeditor>\n      </div>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.value = [];
	    self.activeTab = 0;
	
	    function xmlToArray(xml) {
	        var matches = xml.match(/(<tab(.*?)>.*?[\s\S]*?<\/tab>)/g);
	
	        if (matches) {
	            return matches.map(function (item) {
	                if (matches.length < self.activeTab) {
	                    self.activeTab = 0;
	                }
	                return {
	                    tabTitle: item.replace(/<tab.*?title="(.*?)".*?>.*[\s\S]*?<\/tab>/g, '$1'),
	                    text: item.replace(/<tab.*?>(.*[\s\S]*?)<\/tab>/g, '$1')
	                };
	            });
	        } else {
	            self.activeTab = 0;
	            return [{
	                tabTitle: 'Описание товара',
	                text: xml
	            }];
	        }
	    }
	
	    function arrayToText(array) {
	        if (array instanceof Array && array.length != 0) {
	            if (array.length > 1) {
	                var result = '';
	
	                array.forEach(function (item) {
	                    result += '<tab title="' + item.tabTitle + '">' + item.text + '</tab>';
	                });
	
	                return result;
	            } else {
	                return array[0].text;
	            }
	        } else {
	            return '';
	        }
	    }
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return arrayToText(self.value);
	        },
	        set: function set(value) {
	            self.value = xmlToArray(value || '');
	            self.update();
	        }
	    });
	
	    self.change = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	
	        var _e$target = e.target,
	            value = _e$target.value,
	            name = _e$target.name;
	
	        self.value[e.item.i][name] = value;
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.changeTab = function (e) {
	        self.activeTab = e.item.i;
	    };
	
	    self.addTab = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	
	        self.value.push({
	            tabTitle: 'Новая вкладка',
	            text: ''
	        });
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.closeTab = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        self.value = self.value.slice(0, self.value.length);
	        self.value.splice(e.item.i, 1);
	
	        if (e.item.i <= self.activeTab) if (self.activeTab > 0) self.activeTab -= 1;
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.on('update', function () {
	        if (!opts.value) self.value = [{
	            tabTitle: 'Описание товара',
	            text: ''
	        }];
	
	        if (opts.name) self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('markup-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Наценка товаров</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label">Тип наценки</label>\n          <select class="form-control" name="value" value="{item.value}">\n            <option value="p">Наценка в процентах</option>\n            <option value="a">Наценка в абсолютном значении</option>\n          </select>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Источник цены</label>\n          <select class="form-control" name="source" value="{item.source}">\n            <option value="0">Розничная цена</option>\n            <option value="1">Закупочная цена</option>\n          </select>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Значение</label>\n          <div class="{&quot;input-group&quot;: item.value == &quot;p&quot;}">\n            <input class="form-control" name="price" step="0.01" value="{item.price}" type="{\'number\'}"><span class="input-group-addon" if="{item.value == &quot;p&quot;}">%</span>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        self.tags['bs-modal'].mixin('change');
	        self.tags['bs-modal'].item = {
	            value: "p",
	            price: 0,
	            source: 0
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('price-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Цена товаров</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label">Цена</label>\n          <input class="form-control" name="price" step="0.01" value="{item.price}" type="{\'number\'}">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Валюта</label>\n          <select class="form-control" name="currency" value="{item.currency}">\n            <option each="{c, i in parent.currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n          </select>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    API.request({
	        object: 'Currency',
	        method: 'Fetch',
	        data: {},
	        success: function success(response) {
	            self.currencies = response.items;
	            self.update();
	        }
	    });
	
	    self.on('mount', function () {
	        self.tags['bs-modal'].mixin('change');
	        self.tags['bs-modal'].item = {
	            price: opts.price || 0
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API) {'use strict';
	
	__webpack_require__(61);
	
	__webpack_require__(104);
	
	riot.tag2('product-edit-images', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" cols="{cols}" rows="{value}" handlers="{handlers}" catalog="{catalog}" upload="{upload}" remove="true" reorder="true">\n        <yield to="toolbar">\n          <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0100&quot;)}">\n            <div class="input-group btn btn-primary btn-file">\n              <input name="files" onchange="{opts.upload}" type="file" multiple="multiple" accept="image/*"><i class="fa fa-plus"></i> Добавить\n            </div>\n          </div>\n          <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;1000&quot;) &amp;&amp; !parent.opts.hidecatalog}">\n            <button class="btn btn-success" onclick="{opts.catalog}" type="button"><i class="fa fa-picture-o"></i> Каталог</button>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="" style="width: 100px;"><i class="fa fa-fw {row.isMain ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.isMainClick}"></i>&nbsp;<a onclick="{handlers.showImage}" href="{row.imageUrl}"><img riot-src="{row.imageUrlPreview}" height="64px" width="64px"></a></datatable-cell>\n          <datatable-cell name="">\n            <p class="form-control-static">{row.imageFile}</p>\n            <label class="form-control-title">Title\n              <input class="form-control" value="{row.imageTitle}" onchange="{handlers.imageTitleChange}">\n            </label>\n            <label class="form-control-title">Alt\n              <input class="form-control" value="{row.imageAlt}" onchange="{handlers.imageAltChange}">\n            </label>\n          </datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.mixin('permissions');
	    self.newIndex = -1;
	    self.oldIndex = -1;
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value || [];
	            self.update();
	        }
	    });
	
	    self.add = function () {};
	
	    self.cols = [{ name: '', value: 'Картинка' }, { name: '', value: 'Наименование' }];
	
	    self.handlers = {
	        imageAltChange: function imageAltChange(e) {
	            e.item.row.imageAlt = e.target.value;
	        },
	        imageTitleChange: function imageTitleChange(e) {
	            e.item.row.imageTitle = e.target.value;
	        },
	        isMainClick: function isMainClick(e) {
	            self.tags['catalog-static'].items.forEach(function (item, sort) {
	                item.isMain = false;
	            });
	            e.item.row.isMain = true;
	            self.update();
	        },
	        showImage: function showImage(e) {
	            window.open(e.item.row.imageUrl, "", "resizable=yes,width=800,height=600");
	        }
	    };
	
	    self.catalog = function (e) {
	        modals.create('images-gallery-modal', {
	            type: 'modal-primary',
	            section: opts.section,
	            submit: function submit() {
	                self.value = self.value || [];
	                this.tags.gallery.items.forEach(function (item) {
	                    if (item.__selected__) self.value.push({
	                        imageFile: item.name,
	                        imageAlt: self.parent.item.name,
	                        imageUrlPreview: app.getImagePreviewURL(item.name, opts.section, opts.size),
	                        imageUrl: app.getImageUrl(item.name, opts.section)
	                    });
	                });
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.upload = function (e) {
	        var formData = new FormData();
	        var items = [];
	
	        for (var i = 0; i < e.target.files.length; i++) {
	            formData.append('file' + i, e.target.files[i], e.target.files[i].name);
	            items.push(e.target.files[i].name);
	        }
	
	        API.upload({
	            section: opts.section,
	            count: e.target.files.length,
	            data: formData,
	            success: function success(response) {
	                items = response.items;
	                self.value = self.value || [];
	                items.forEach(function (item) {
	                    self.value.push({
	                        imageFile: item.name,
	                        imageAlt: '',
	                        imageUrlPreview: item.imageUrlPreview,
	                        imageUrl: item.imageUrl
	                    });
	                });
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                self.update();
	            }
	        });
	    };
	
	    self.on('updated', function () {
	        self.tags['catalog-static'].tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
	            if (newIndex === self.newIndex && oldIndex === self.oldIndex) {
	                return false;
	            }
	
	            self.newIndex = newIndex;
	            self.oldIndex = oldIndex;
	
	            //let {current, limit} = self.tags.childs.pages
	            //let offset = current > 0 ? (current - 1) * limit : 0
	            self.tags['catalog-static'].value.splice(newIndex, 0, self.tags['catalog-static'].value.splice(oldIndex, 1)[0]);
	            //self.tags['catalog-static'].value.splice(offset + newIndex, 0, self.tags['catalog-static'].value.splice(offset + oldIndex, 1)[0])
	            var temp = self.tags['catalog-static'].value;
	            self.rows = [];
	            self.update();
	            self.tags['catalog-static'].value = temp;
	
	            self.tags['catalog-static'].items.forEach(function (item, sort) {
	                item.sortIndex = sort;
	            });
	            //self.update()
	        });
	    });
	
	    self.on('update', function () {
	        if ('name' in opts && opts.name !== '') self.root.name = opts.name;
	
	        if ('value' in opts) self.value = opts.value || [];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4)))

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('product-edit-modifications-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Модификации товаров</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}">\n        <product-edit-modifications name="modifications" value="{item.modifications}">\n          <yield to="toolbar">\n            <button class="btn btn-success" type="button" onclick="{parent.copyModifications}" title="Скопировать из другого товара"><i class="fa fa-copy"></i></button>\n          </yield>\n        </product-edit-modifications>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        self.tags['bs-modal'].mixin('change');
	        self.tags['bs-modal'].item = {
	            modifications: opts.modifications
	        };
	
	        self.tags['bs-modal'].copyModifications = function () {
	            modals.create('products-list-select-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    var _this = this;
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                    if (items.length) {
	                        API.request({
	                            object: 'Product',
	                            method: 'Info',
	                            data: { id: items[0].id },
	                            success: function success(response) {
	                                self.tags['bs-modal'].item = {
	                                    modifications: response.modifications
	                                };
	                                _this.modalHide();
	                                self.update();
	                            }
	                        });
	                    }
	                }
	            });
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	__webpack_require__(37);
	
	__webpack_require__(61);
	
	__webpack_require__(170);
	
	__webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('product-edit-modifications', '  <div class="row">\n    <div class="col-md-12">\n      <div class="form-inline m-b-3">\n        <div class="form-group">\n          <button class="btn btn-primary" type="button" onclick="{addGroup}"><i class="fa fa-plus"></i> Добавить группу</button>\n          <yield to="toolbar">\n            <yield from="toolbar"></yield>\n          </yield>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <ul class="nav nav-tabs m-b-2" if="{value.length &gt; 0}">\n        <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.name}</span>\n            <button class="close" onclick="{closeTab}" type="button"><span>&times;</span></button></a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <product-edit-modifications-group if="{value.length &gt; 0}" value="{value[activeTab]}" images="{images}"></product-edit-modifications-group>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.images = [];
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	            self.update();
	        }
	    });
	
	    self.activeTab = 0;
	
	    self.changeTab = function (e) {
	        self.activeTab = e.item.i;
	    };
	
	    self.closeTab = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        self.value = self.value.slice(0, self.value.length);
	        self.value.splice(e.item.i, 1);
	
	        if (e.item.i <= self.activeTab) if (self.activeTab > 0) self.activeTab -= 1;
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.addGroup = function () {
	        modals.create('product-edit-modifications-group-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            beforeSuccess: function beforeSuccess(response, xhr) {
	                if (self.value && self.value instanceof Array && self.value.length > 0) {
	                    (function () {
	                        var ids = self.value.map(function (item) {
	                            return item.id;
	                        });
	                        var items = response.items.filter(function (item) {
	                            return ids.indexOf(item.id) === -1;
	                        });
	
	                        response.items = items;
	                    })();
	                }
	            },
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0 && !(self.value instanceof Array)) self.value = [];
	
	                items = items.map(function (item) {
	                    item.items = [];
	                    return item;
	                });
	
	                self.value = self.value.concat(items);
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	                this.modalHide();
	            }
	        });
	    };
	
	    self.on('update', function () {
	        if (opts.value) self.value = opts.value;
	        if (opts.images) self.images = opts.images;
	
	        if (opts.name) self.root.name = opts.name;
	    });
	});
	riot.tag2('product-edit-modifications-group', '  <div class="form-inline m-b-3">\n    <div class="form-group">\n      <button class="btn btn-primary" type="button" onclick="{addModification}"><i class="fa fa-plus"></i> Добавить модификацию</button>\n    </div>\n    <div class="form-group">\n      <button class="btn btn-danger" if="{selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n    </div>\n  </div>\n  <div class="table-responsive">\n    <datatable cols="{cols}" rows="{items}" handlers="{handlers}">\n      <datatable-cell each="{item, i in parent.parent.newCols}" name="{item.name}">{row.values[i].value}</datatable-cell>\n      <datatable-cell name="article" style="width-max: 150px;">\n        <input name="article" value="{row.article}" onchange="{handlers.change}">\n      </datatable-cell>\n      <datatable-cell name="stock" style="width-max: 80px;">\n        <input name="stock" min="-1" value="{row.stock}" readonly type="{\'number\'}">\n      </datatable-cell>\n      <datatable-cell name="priceRetail" style="width-max: 100px;">\n        <input name="priceRetail" min="0" step="0.01" value="{row.priceRetail}" onchange="{handlers.change}" type="{\'number\'}">\n      </datatable-cell>\n\n\n      <datatable-cell name="description">\n        <input name="description" value="{row.description}" onchange="{handlers.change}">\n      </datatable-cell>\n      <datatable-cell name="id" onclick="{handlers.edit}"><i class="fa fa-edit"></i> Настроить</datatable-cell>\n      <datatable-cell name="default" style="width-max: 40px;"><i class="fa fa-fw {row.default ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.isDefaultClick}"></i></datatable-cell>\n    </datatable>\n  </div>\n  <bs-pagination if="{value.items.length &gt; pages.limit}" name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.cols = [];
	    self.items = [];
	    self.images = [];
	
	    self.pages = {
	        count: 0,
	        current: 1,
	        limit: 15,
	        change: function change(e) {
	            self.pages.current = e.currentTarget.page;
	        }
	    };
	
	    self.getPageItems = function () {
	        var count = self.value.items.length;
	
	        self.pages.count = Math.ceil(count / self.pages.limit);
	
	        if (self.pages.current > self.pages.count) {
	            self.pages.current = self.pages.count;
	        }
	
	        self.pages.current = self.pages.current == 0 ? 1 : self.pages.current;
	
	        var offset = (self.pages.current - 1) * self.pages.limit;
	        var end = offset + self.pages.limit;
	
	        var items = self.value.items.filter(function (item, i) {
	            return i > offset - 1 && i < end;
	        });
	
	        return items;
	    };
	
	    self.initCols = [{ name: 'article', value: 'Артикул' }, { name: 'stock', value: 'Остаток' }, { name: 'priceRetail', value: 'Розница' },
	    //{name: 'priceSmallOpt', value: 'Малый опт'},
	    //{name: 'priceOpt', value: 'Опт'},
	    { name: 'description', value: 'Описание' }, { name: 'id', value: '' }, { name: 'default', value: '', classes: 'fa fa-2x fa-check', title: 'Выбор модификации по умолчанию' }];
	
	    self.addModification = function () {
	        modals.create('product-edit-modifications-add-modal', {
	            type: 'modal-primary',
	            columns: self.value.columns,
	            submit: function submit() {
	                var getIndexs = function getIndexs() {
	                    var counts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	                    var count = counts.reduce(function (p, c) {
	                        return p * c;
	                    });
	                    index = index > count ? count : index;
	                    var result = [];
	
	                    counts.reduceRight(function (p, c, i) {
	                        result[i] = p % c;
	                        return Math.floor(p / c);
	                    }, index);
	
	                    return result;
	                };
	
	                var getValues = function getValues(items, indexs) {
	                    return items.map(function (item, i) {
	                        return item[indexs[i]];
	                    });
	                };
	
	                var items = [];
	
	                if (this.tags.datatable instanceof Array) {
	                    this.tags.datatable.forEach(function (item) {
	                        items.push(item.getSelectedRows());
	                    });
	                } else {
	                    items.push(this.tags.datatable.getSelectedRows());
	                }
	
	                var counts = items.map(function (item) {
	                    return item.length;
	                });
	                var count = counts.reduce(function (p, c) {
	                    return p * c;
	                });
	                count = count > 1000 ? 1000 : count;
	
	                for (var i = 0; i < counts.length; i++) {
	                    if (counts[i] == 0) {
	                        popups.create({
	                            style: 'popup-danger',
	                            title: 'Ошибка',
	                            text: 'Должны быть выбраны один или несколько пунктов в каждой категории',
	                            timeout: 0
	                        });
	                        return;
	                    }
	                }
	
	                for (var _i = 0; _i < count; _i++) {
	                    var indexs = getIndexs(counts, _i);
	                    var values = getValues(items, indexs);
	                    self.value.items.push({
	                        article: self.parent.parent.item.article,
	                        count: -1,
	                        priceRetail: 0,
	                        priceSmallOpt: 0,
	                        priceOpt: 0,
	                        description: '',
	                        values: values
	                    });
	                }
	
	                this.modalHide();
	                self.update();
	            }
	        });
	    };
	
	    self.remove = function () {
	        self.selectedCount = 0;
	
	        var items = self.tags.datatable.getSelectedRows();
	
	        self.value.items = self.value.items.filter(function (item) {
	            return items.indexOf(item) === -1;
	        });
	    };
	
	    self.handlers = {
	        change: function change(e) {
	            if (!e.target.name) return;
	
	            var bannedTypes = ['checkbox', 'file', 'color', 'range', 'number'];
	
	            if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
	                var selectionStart = e.target.selectionStart;
	                var selectionEnd = e.target.selectionEnd;
	            }
	
	            if (e.target && e.target.type === 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.checked;
	            if (e.target && e.target.type !== 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.value;
	            if (e.currentTarget.tagName !== 'FORM' && e.currentTarget.name !== '') e.item.row[e.currentTarget.name] = e.currentTarget.value;
	
	            if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
	                this.update();
	                e.target.selectionStart = selectionStart;
	                e.target.selectionEnd = selectionEnd;
	            }
	        },
	        edit: function edit(e) {
	            modals.create('product-edit-modifications-edit-modal', {
	                type: 'modal-primary',
	                item: e.item.row,
	                images: opts.images,
	                submit: function submit() {
	                    e.item.row = this.item;
	                    this.modalHide();
	                    self.update();
	                }
	            });
	        },
	        isDefaultClick: function isDefaultClick(e) {
	            var selIndex = e.item.row.default;
	            self.items.forEach(function (item, index) {
	                item.default = false;
	            });
	            e.item.row.default = !selIndex;
	            self.update();
	        }
	    };
	
	    self.on('update', function () {
	        if (opts.value) {
	            if (self.value !== opts.value) self.selectedCount = 0;
	
	            self.value = opts.value;
	            self.items = self.getPageItems() || [];
	
	            if (self.value.columns && self.value.columns instanceof Array) {
	
	                self.newCols = self.value.columns.map(function (item, i) {
	                    return { name: i, value: item.name };
	                });
	                self.newCols.sort(function (varA, varB) {
	                    return varA.id - varB.id;
	                });
	
	                self.cols = self.newCols.concat(self.initCols);
	            }
	        }
	        if (opts.images) self.images = opts.images;
	    });
	
	    self.one('updated', function () {
	        self.tags.datatable.on('row-selected', function (count) {
	            self.selectedCount = count;
	            self.update();
	        });
	    });
	});
	riot.tag2('product-edit-modifications-group-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Модификации</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Modification" cols="{parent.cols}" add="{parent.add}" remove="{parent.remove}" dblclick="{parent.opts.submit.bind(this)}" store="product-edit-modifications-group-select-modal" reload="true" handlers="{parent.handlers}" before-success="{parent.opts.beforeSuccess}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="type" style="width: 150px;">{handlers.types[row.vtype]}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.collection = 'Modification';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип ценообразования' }];
	
	    self.add = function (e) {
	        modals.create('modification-edit-modal', {
	            type: 'modal-primary',
	            title: 'Добавить модификацию',
	            submit: function submit(e) {
	                var params = this.item;
	                var _this = this;
	                if (!this.error) {
	                    API.request({
	                        object: 'Modification',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags['bs-modal'].update();
	                            self.tags['bs-modal'].tags.catalog.reload();
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.handlers = {
	        types: {
	            0: 'Добавляет к цене',
	            1: 'Умножает на цену',
	            2: 'Замещает цену'
	        }
	    };
	});
	riot.tag2('product-edit-modifications-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить модификации</div>\n    </yield>\n    <yield to="body">\n      <div each="{table, i in parent.items}">\n        <h4>{table.name}</h4>\n        <datatable cols="{table.cols}" rows="{table.items}">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="value">{row.value}</datatable-cell>\n        </datatable>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">OK</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.columns = opts.columns;
	    self.items = [];
	    self.initCols = [{ name: 'id', value: '#', width: '60px' }];
	
	    var request = function request(index, id) {
	        return function (callback) {
	            API.request({
	                object: 'FeatureValue',
	                method: 'Fetch',
	                data: { filters: { field: 'idFeature', value: id } },
	                success: function success(response) {
	                    var _self$columns$index = self.columns[index],
	                        name = _self$columns$index.id,
	                        value = _self$columns$index.name;
	
	                    self.columns[index].items = response.items;
	                    self.columns[index].cols = self.initCols.concat([{ name: name, value: value }]);
	                    self.items[index] = self.columns[index];
	
	                    callback(null, 'success');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        };
	    };
	
	    self.on('mount', function () {
	        var requests = self.columns.map(function (item, i) {
	            return new request(i, item.id);
	        });
	
	        (0, _parallel2.default)(requests, function (err, res) {
	            self.update();
	        });
	    });
	});
	riot.tag2('product-edit-modifications-images-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Выбрать из библиотеки</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <catalog-static name="gallery" cols="{cols}" rows="{value}" catalog="{catalog}" upload="{upload}">\n\n            <yield to="body">\n              <datatable-cell name="" style="width: 100px;"><img riot-src="{row.imageUrlPreview}" style="max-width: 64px;"></datatable-cell>\n              <datatable-cell name="">\n                <p class="form-control-static">{row.imageFile}</p>\n              </datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.cols = [{ name: '', value: 'Картинка' }, { name: '', value: 'Наименование' }];
	        if ('value' in opts) {
	            modal.value = opts.value || [];
	            console.log(modal.value);
	            modal.update();
	        }
	    });
	});
	riot.tag2('product-edit-modifications-list-images', '  <catalog-static name="{opts.name}" cols="{cols}" rows="{value}" catalog="{catalog}" upload="{upload}" remove="true" reorder="true">\n    <yield to="toolbar">\n\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;1000&quot;)}">\n        <button class="btn btn-success" onclick="{opts.catalog}" type="button"><i class="fa fa-picture-o"></i> выбрать</button>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="" style="width: 100px;"><img riot-src="{row.imageUrlPreview}" style="max-widt: 40px;"></datatable-cell>\n      <datatable-cell name="">\n        <p class="form-control-static">{row.imageFile}</p>\n      </datatable-cell>\n    </yield>\n  </catalog-static>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.mixin('permissions');
	    self.value = [];
	    self.newIndex = -1;
	    self.oldIndex = -1;
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value || [];
	            self.update();
	        }
	    });
	
	    self.cols = [{ name: '', value: 'Картинка' }, { name: '', value: 'Наименование' }];
	
	    self.catalog = function (e) {
	        //console.log(self.images)
	        modals.create('product-edit-modifications-images-modal', {
	            type: 'modal-primary',
	            value: self.images,
	            submit: function submit() {
	                self.value = self.value || [];
	                var sort = 0;
	                self.value.forEach(function (item) {
	                    if (item.sortIndex > sort) sort = item.sortIndex;
	                });
	                this.tags.gallery.items.forEach(function (item) {
	                    if (item.__selected__) {
	                        var find = false;
	                        self.value.forEach(function (item1) {
	                            if (item1.id == item.id) find = true;
	                        });
	                        if (!find) {
	                            self.value.push({
	                                id: item.id,
	                                imageFile: item.imageFile,
	                                imageUrlPreview: item.imageUrlPreview,
	                                imageUrl: item.imageUrl,
	                                sortIndex: sort + 1
	                            });
	                        }
	                    }
	                });
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                //console.log(self.value)
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	    self.on('update', function () {
	        if ('name' in opts && opts.name !== '') self.root.name = opts.name;
	
	        if ('images' in opts) self.images = opts.images || [];
	
	        if ('value' in opts && !self.value) self.value = opts.value || [];
	    });
	    self.on('updated', function () {
	        self.tags['catalog-static'].tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
	            if (newIndex === self.newIndex && oldIndex === self.oldIndex) {
	                return false;
	            }
	
	            //console.log(newIndex, oldIndex, self.newIndex, self.oldIndex)
	            self.newIndex = newIndex;
	            self.oldIndex = oldIndex;
	
	            self.tags['catalog-static'].value.splice(newIndex, 0, self.tags['catalog-static'].value.splice(oldIndex, 1)[0]);
	            var temp = self.tags['catalog-static'].value;
	            self.rows = [];
	            self.update();
	
	            self.tags['catalog-static'].value = temp;
	
	            self.tags['catalog-static'].items.forEach(function (item, sort) {
	                item.sortIndex = sort;
	            });
	        });
	    });
	});
	riot.tag2('product-edit-modifications-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Настроить модификацию</div>\n    </yield>\n    <yield to="body">\n      <form action="" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <product-edit-modifications-list-images name="images" value="{item.images}" images="{images}"></product-edit-modifications-list-images>\n          </div>\n        </div>\n        <hr>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Описание</label>\n              <ckeditor name="description" value="{item.description}"></ckeditor>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Применить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        modal.images = opts.images || {};
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('product-edit-options', '  <div class="row">\n    <div class="col-md-12">\n      <div class="form-inline m-b-3">\n        <div class="form-group">\n          <button class="btn btn-primary" type="button" onclick="{addOption}"><i class="fa fa-plus"></i> Добавить опции</button>\n          <yield to="toolbar">\n            <yield from="toolbar"></yield>\n          </yield>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <ul class="nav nav-tabs m-b-2" if="{value.length &gt; 0}">\n        <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.name}</span>\n            <button class="close" onclick="{closeTab}" type="button"><span>&times;</span></button></a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <product-edit-option-values if="{value.length &gt; 0}" value="{value[activeTab]}" modifications="{opts.modifications}"></product-edit-option-values>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.modifications = [];
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value;
	            self.update();
	        }
	    });
	
	    self.activeTab = 0;
	
	    self.changeTab = function (e) {
	        self.activeTab = e.item.i;
	    };
	
	    self.closeTab = function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        self.value = self.value.slice(0, self.value.length);
	        self.value.splice(e.item.i, 1);
	
	        if (e.item.i <= self.activeTab) if (self.activeTab > 0) self.activeTab -= 1;
	
	        var event = document.createEvent('Event');
	        event.initEvent('change', true, true);
	        self.root.dispatchEvent(event);
	    };
	
	    self.addOption = function () {
	        modals.create('product-edit-options-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            beforeSuccess: function beforeSuccess(response, xhr) {
	                if (self.value && self.value instanceof Array && self.value.length > 0) {
	                    (function () {
	                        var ids = self.value.map(function (item) {
	                            return item.id;
	                        });
	                        var items = response.items.filter(function (item) {
	                            return ids.indexOf(item.id) === -1;
	                        });
	
	                        response.items = items;
	                    })();
	                }
	            },
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0 && !(self.value instanceof Array)) self.value = [];
	
	                items = items.map(function (item) {
	                    item.columns = [{ id: item.id, name: item.name }];
	                    item.items = [];
	                    return item;
	                });
	
	                self.value = self.value.concat(items);
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	                this.modalHide();
	            }
	        });
	    };
	
	    self.on('update', function () {
	        if (opts.modifications) self.modifications = opts.modifications;
	        if (opts.value) self.value = opts.value;
	
	        if (opts.name) self.root.name = opts.name;
	    });
	});
	riot.tag2('product-edit-option-values', '  <div class="form-inline m-b-3">\n    <div class="form-group">\n      <button class="btn btn-primary" type="button" onclick="{addValue}"><i class="fa fa-plus"></i> Добавить</button>\n    </div>\n    <div class="form-group">\n      <button class="btn btn-danger" if="{selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n    </div>\n  </div>\n  <div class="table-responsive">\n    <div class="col-sm-12">\n      <datatable cols="{cols}" rows="{items}" handlers="{handlers}">\n        <datatable-cell each="{item, i in parent.parent.newCols}" name="{item.name}">{row.values[i].value}</datatable-cell>\n        <datatable-cell name="name" style="width: 60%;">{row.name}</datatable-cell>\n        <datatable-cell name="priceValue">\n          <input name="priceValue" min="-1000000" step="0.01" value="{row.priceValue}" onchange="{handlers.change}" type="{\'number\'}">\n        </datatable-cell>\n        <datatable-cell name="modificationId">\n          <select class="form-control" name="idModification" value="{row.idModification}" onchange="{handlers.changeselect}">\n            <option value="">Для всех</option>\n            <optgroup each="{mod in parent.parent.parent.opts.modifications}" label="{mod.name}">\n              <option each="{mi in mod.items}" value="{mi.id}" __selected="{row.idModification==mi.id}" no-reorder>{mi.values[0].value}</option>\n            </optgroup>\n          </select>\n        </datatable-cell>\n        <datatable-cell name="isDefault"><i class="fa fa-fw {row.isDefault ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.toggleCheckbox}"></i></datatable-cell>\n      </datatable>\n    </div>\n  </div>\n  <bs-pagination if="{value.items.length &gt; pages.limit}" name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.items = [];
	
	    self.pages = {
	        count: 0,
	        current: 1,
	        limit: 15,
	        change: function change(e) {
	            self.pages.current = e.currentTarget.page;
	        }
	    };
	
	    self.getPageItems = function () {
	        var count = self.value.items.length;
	
	        self.pages.count = Math.ceil(count / self.pages.limit);
	
	        if (self.pages.current > self.pages.count) {
	            self.pages.current = self.pages.count;
	        }
	
	        self.pages.current = self.pages.current == 0 ? 1 : self.pages.current;
	
	        var offset = (self.pages.current - 1) * self.pages.limit;
	        var end = offset + self.pages.limit;
	
	        var items = self.value.items.filter(function (item, i) {
	            return i > offset - 1 && i < end;
	        });
	
	        return items;
	    };
	
	    self.сols = [{ name: 'name', value: 'Наименование' }, { name: 'priceValue', value: 'Цена' }, { name: 'isDefault', value: 'По умолчанию' }];
	
	    self.addValue = function () {
	        modals.create('product-edit-option-values-add-modal', {
	            type: 'modal-primary',
	            columns: self.value.columns,
	            submit: function submit() {
	                var getIndexs = function getIndexs() {
	                    var counts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	                    var count = counts.reduce(function (p, c) {
	                        return p * c;
	                    });
	                    index = index > count ? count : index;
	                    var result = [];
	
	                    counts.reduceRight(function (p, c, i) {
	                        result[i] = p % c;
	                        return Math.floor(p / c);
	                    }, index);
	
	                    return result;
	                };
	
	                var getValues = function getValues(items, indexs) {
	                    return items.map(function (item, i) {
	                        return item[indexs[i]];
	                    });
	                };
	
	                var items = [];
	
	                if (this.tags.datatable instanceof Array) {
	                    this.tags.datatable.forEach(function (item) {
	                        items.push(item.getSelectedRows());
	                    });
	                } else {
	                    items.push(this.tags.datatable.getSelectedRows());
	                }
	
	                var counts = items.map(function (item) {
	                    return item.length;
	                });
	                var count = counts.reduce(function (p, c) {
	                    return p * c;
	                });
	                count = count > 1000 ? 1000 : count;
	
	                for (var i = 0; i < counts.length; i++) {
	                    if (counts[i] == 0) {
	                        popups.create({
	                            style: 'popup-danger',
	                            title: 'Ошибка',
	                            text: 'Должны быть выбраны один или несколько пунктов в каждой категории',
	                            timeout: 0
	                        });
	                        return;
	                    }
	                }
	
	                var _loop = function _loop(_i) {
	                    var indexs = getIndexs(counts, _i);
	                    var values = getValues(items, indexs);
	                    fl = false;
	
	                    self.value.items.forEach(function (item) {
	                        if (item.idOptionValue == values[0].id) {
	                            //console.log(item.idOptionValue, values[0].id)
	                            //fl = true;
	                        }
	                    });
	                    if (!fl) {
	                        self.value.items.push({
	                            name: values[0].name,
	                            idOptionValue: values[0].id,
	                            priceValue: values[0].price,
	                            isDefault: 0
	                        });
	                    }
	                };
	
	                for (var _i = 0; _i < count; _i++) {
	                    var fl;
	
	                    _loop(_i);
	                }
	
	                this.modalHide();
	                self.update();
	            }
	        });
	    };
	
	    self.remove = function () {
	        self.selectedCount = 0;
	
	        var items = self.tags.datatable.getSelectedRows();
	
	        self.value.items = self.value.items.filter(function (item) {
	            return items.indexOf(item) === -1;
	        });
	    };
	
	    self.handlers = {
	        toggleCheckbox: function toggleCheckbox(e) {
	            this.row.isDefault = !this.row.isDefault;
	            this.update();
	        },
	        change: function change(e) {
	            if (!e.target.name) return;
	
	            var bannedTypes = ['checkbox', 'file', 'color', 'range', 'number'];
	
	            if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
	                var selectionStart = e.target.selectionStart;
	                var selectionEnd = e.target.selectionEnd;
	            }
	
	            if (e.target && e.target.type === 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.checked;
	            if (e.target && e.target.type !== 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.value;
	            if (e.currentTarget.tagName !== 'FORM' && e.currentTarget.name !== '') e.item.row[e.currentTarget.name] = e.currentTarget.value;
	
	            if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
	                this.update();
	                e.target.selectionStart = selectionStart;
	                e.target.selectionEnd = selectionEnd;
	            }
	        },
	        changeselect: function changeselect(e) {
	            e.item.row.idModification = e.target.value;
	        }
	    };
	
	    self.on('update', function () {
	        if (opts.value) {
	            if (self.value !== opts.value) self.selectedCount = 0;
	
	            self.value = opts.value;
	            self.items = self.getPageItems() || [];
	        }
	    });
	
	    self.one('updated', function () {
	        self.tags.datatable.on('row-selected', function (count) {
	            self.selectedCount = count;
	            self.update();
	        });
	    });
	});
	riot.tag2('product-edit-options-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Опции</div>\n    </yield>\n    <yield to="body">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">Группы</label>\n            <select class="form-control" name="idGroup" onclick="{parent.selectCategory}">\n              <option value="">Все</option>\n              <option each="{category, i in parent.optionCategories}" value="{category.id}" no-reorder>{category.name}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n      <catalog object="Option" cols="{parent.cols}" remove="{parent.remove}" dblclick="{parent.opts.submit.bind(this)}" disablepagination="true" disable-col-select="true" reload="true" handlers="{parent.handlers}" before-success="{parent.opts.beforeSuccess}" store="product-edit-options-select-modal" filters="{parent.categoryFilters}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="type" style="width: 150px;">{row.groupName}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.collection = 'Options';
	    self.categoryFilters = false;
	    self.optionCategories = [];
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'groupName', value: 'Группа' }];
	    self.selectCategory = function (e) {
	        var value = e.target.value;
	        if (value) self.categoryFilters = [{ field: 'idGroup', sign: 'IN', value: value }];else self.categoryFilters = false;
	        self.update();
	        self.tags['bs-modal'].tags.catalog.reload();
	    };
	
	    self.getOptionGroup = function () {
	        API.request({
	            object: 'OptionGroup',
	            method: 'Fetch',
	            success: function success(response) {
	                self.optionCategories = response.items;
	                self.update();
	            }
	        });
	    };
	    self.getOptionGroup();
	});
	riot.tag2('product-edit-option-values-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить значения</div>\n    </yield>\n    <yield to="body">\n      <div each="{table, i in parent.items}">\n        <h4>{table.name}</h4>\n        <datatable cols="{table.cols}" rows="{table.items}">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n        </datatable>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">OK</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.columns = opts.columns || [];
	    self.items = [];
	    self.initCols = [{ name: 'id', value: '#', width: '60px' }];
	
	    var request = function request(index, id) {
	        return function (callback) {
	            API.request({
	                object: 'OptionItems',
	                method: 'Fetch',
	                data: { filters: { field: 'idOption', value: id } },
	                success: function success(response) {
	                    var _self$columns$index = self.columns[index],
	                        name = _self$columns$index.id,
	                        value = _self$columns$index.name;
	
	                    self.columns[index].items = response.items;
	                    self.columns[index].cols = self.initCols.concat([{ name: name, value: value }]);
	                    self.items[index] = self.columns[index];
	
	                    callback(null, 'success');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        };
	    };
	
	    self.on('mount', function () {
	        var requests = self.columns.map(function (item, i) {
	            return new request(i, item.id);
	        });
	
	        (0, _parallel2.default)(requests, function (err, res) {
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('product-edit-parameters-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Характеристики товаров</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}">\n        <product-edit-parameters name="specifications" value="{item.specifications}">\n          <yield to="toolbar">\n            <button class="btn btn-success" type="button" onclick="{parent.parent.copySpecifications}" title="Скопировать из другого товара"><i class="fa fa-copy"></i></button>\n\n          </yield>\n        </product-edit-parameters>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        self.tags['bs-modal'].mixin('change');
	        self.tags['bs-modal'].item = {
	            specifications: opts.specifications
	        };
	
	        /*self.tags['bs-modal'].isAddSpecifications = 1
	             self.tags['bs-modal'].typeChange = e => {
	            self.tags['bs-modal'].isAddSpecifications = e.target.value
	        }*/
	
	        self.tags['bs-modal'].copySpecifications = function () {
	            modals.create('products-list-select-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    var _this = this;
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                    if (items.length) {
	                        API.request({
	                            object: 'Product',
	                            method: 'Info',
	                            data: { id: items[0].id },
	                            success: function success(response) {
	                                self.tags['bs-modal'].item = {
	                                    specifications: response.specifications
	                                };
	                                _this.modalHide();
	                                self.update();
	                            }
	                        });
	                    }
	                }
	            });
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(172);
	
	riot.tag2('product-edit-parameters', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" add="{addParameters}" handlers="{parametersHandlers}" cols="{parametersCols}" rows="{value}" responsive="false" remove="true" limit="199">\n        <yield to="toolbar">\n          <yield from="toolbar"></yield>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="value">\n            <input class="form-control" if="{row.type == &quot;number&quot;}" value="{row.valueNumber}" min="0.00" oninput="{handlers.changeValue}" type="{\'number\'}"><i class="fa fa-fw {row.valueBool ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" if="{row.type == &quot;bool&quot;}" onclick="{handlers.toggleCheckbox}"></i>\n            <input class="form-control" if="{row.type == &quot;string&quot;}" value="{row.valueString}" type="text" oninput="{handlers.changeValue}">\n            <autocomplete if="{row.type == &quot;colorlist&quot;}" load-data="{handlers.getOptions(row.idFeature)}" value="{row.idValue}" value-field="value" id-field="id" onchange="{handlers.changeColorValue}"><i class="color" riot-style="background-color: #{item.color};"></i>&nbsp;&nbsp;{item.value}</autocomplete>\n            <autocomplete if="{row.type == &quot;list&quot;}" load-data="{handlers.getOptions(row.idFeature)}" value="{row.idValue}" text="{row.resvalue}" value-field="value" id-field="id" onchange="{handlers.changeColorValue}" add="{handlers.addParam}">{item.value}</autocomplete>\n          </datatable-cell>\n          <datatable-cell name="modificationId">\n            <select class="form-control" name="idModification" value="{row.idModification}" onchange="{handlers.changeselect}">\n              <option value="">Для всех</option>\n              <optgroup each="{mod in parent.parent.parent.parent.modifications}" label="{mod.name}">\n                <option each="{mi in mod.items}" value="{mi.id}" __selected="{row.idModification==mi.id}" no-reorder>{mi.values[0].value}</option>\n              </optgroup>\n            </select>\n          </datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.modifications = [];
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value || [];
	        },
	        set: function set(value) {
	            self.value = value || [];
	            self.update();
	        }
	    });
	
	    self.parametersCols = [{ name: 'name', value: 'Наименование' }, { name: 'value', value: 'Значение' }, { name: 'modificationId', value: 'Модификация' }];
	
	    self.addParameters = function (e) {
	        modals.create('parameters-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.value = self.value || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.value.map(function (item) {
	                    return item.idFeature;
	                });
	
	                items.forEach(function (item) {
	                    //  if (ids.indexOf(item.id) === -1) {
	                    self.value.push({
	                        idFeature: item.id,
	                        name: item.name,
	                        type: item.type
	                    });
	                    //}
	                });
	
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	    console.log(opts);
	    // Параметры Обработчики
	    self.parametersHandlers = {
	        getOptions: function getOptions(id) {
	            var id = id;
	            return function () {
	                var _this = this;
	                return API.request({
	                    object: 'FeatureValue',
	                    method: 'Fetch',
	                    data: { filters: { field: 'idFeature', value: id } },
	                    success: function success(response) {
	                        _this.data = response.items;
	                        if (!_this.isOpen) {
	                            _this.data.forEach(function (item) {
	                                if (item[_this.idField] == _this.opts.value) {
	                                    _this.filterValue = item[_this.valueField];
	                                }
	                            });
	                        }
	                        _this.update();
	                    }
	                });
	            };
	        },
	
	        // переключатель
	        toggleCheckbox: function toggleCheckbox(e) {
	            this.row.valueBool = !this.row.value;
	        },
	
	        // изменить значение
	        changeValue: function changeValue(e) {
	            if (e.target.type == '' || e.target.type == 'text') {
	                var selectionStart = e.target.selectionStart;
	                var selectionEnd = e.target.selectionEnd;
	                this.row.valueString = e.target.value;
	                this.update();
	                e.target.selectionStart = selectionStart;
	                e.target.selectionEnd = selectionEnd;
	            } else if (e.target.type == 'number') {
	                this.row.valueNumber = e.target.value;
	                this.update();
	            } else
	                // если тип цели bool...
	                if (e.target.type == 'bool') {
	                    this.row.valueBool = e.target.value;
	                    this.update();
	                }
	        },
	        changeColorValue: function changeColorValue(e) {
	            this.row.idValue = this.row.valueIdList = e.target.value;
	            //console.log(e.target)
	        },
	        changeListValue: function changeListValue(e) {
	            this.row.idValue = this.row.valueIdList = e.target.value;
	        },
	
	        modifications: self.modifications,
	        changeselect: function changeselect(e) {
	            e.item.row.idModification = e.target.value;
	        },
	        addParam: function addParam(e) {
	            //console.log(this)
	            var pthis = this,
	                idFeature = pthis.parent.row.idFeature,
	                idValue = pthis.parent.row.idValue,
	                data = pthis.data,
	                itemval = [],
	                f = false;
	
	            itemval.value = this.filterValue || '';
	            data.forEach(function (item) {
	                if (item.value == itemval.value) {
	                    pthis.parent.row.idValue = item.id;
	                    pthis.opts.value = item.id;
	                    pthis.parent.row.value = itemval.value;
	                    pthis.value = item.id;
	                    f = true;
	                    //self.update()
	                    return;
	                }
	            });
	            if (f) return;
	
	            modals.create('feature-new-edit-modal', {
	                type: 'modal-primary',
	                typeparam: pthis.type,
	                item: itemval,
	                submit: function submit() {
	                    var _this = this,
	                        params = {};
	
	                    _this.error = _this.validation.validate(_this.item, _this.rules);
	                    data.forEach(function (item) {
	                        if (item.value == _this.item.value) {
	                            _this.error = true;
	                        }
	                    });
	
	                    if (!_this.error) {
	                        params.idFeature = idFeature;
	                        params.value = _this.item.value;
	                        params.image = _this.item.image;
	                        params.color = _this.item.color;
	                        params.code = _this.item.code;
	
	                        API.request({
	                            object: 'FeatureValue',
	                            method: 'Save',
	                            data: params,
	                            success: function success(response) {
	                                pthis.parent.row.idValue = response.id;
	                                pthis.value = response.id;
	                                pthis.opts.value = response.id;
	                                pthis.parent.row.value = itemval.value;
	                                data.push(response);
	                                _this.modalHide();
	                            }
	                        });
	                    }
	                }
	            });
	        }
	    };
	
	    self.on('update', function () {
	        if ('value' in opts) self.value = opts.value || [];
	
	        if ('modifications' in opts) self.modifications = opts.modifications || [];
	
	        if ('name' in opts) self.root.name = opts.name;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, API, observable) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(33);
	
	__webpack_require__(80);
	
	__webpack_require__(345);
	
	__webpack_require__(82);
	
	__webpack_require__(445);
	
	__webpack_require__(447);
	
	__webpack_require__(450);
	
	__webpack_require__(174);
	
	__webpack_require__(175);
	
	__webpack_require__(452);
	
	__webpack_require__(448);
	
	__webpack_require__(168);
	
	__webpack_require__(420);
	
	__webpack_require__(173);
	
	__webpack_require__(107);
	
	__webpack_require__(410);
	
	__webpack_require__(442);
	
	__webpack_require__(165);
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault2(_parallel);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('product-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isMulti}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isMulti ? item.name || \'Мультиредактирование товаров\' : isClone ? \'Клонирование товара\' : item.name || \'Редактирование товара\'}</div>\n\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a class="fa fa-shopping-bag" data-toggle="tab" href="#product-edit-home" title="Основная информация"><span class="hidden-xs"> Главная</span></a></li>\n      <li><a class="fa fa-sticky-note-o" data-toggle="tab" href="#product-edit-full-text" title="Полное описание"><span class="hidden-xs"> Описание</span></a></li>\n      <li><a class="fa fa-picture-o" data-toggle="tab" href="#product-edit-images" title="Картинки"><span class="hidden-xs"> Картинки</span></a></li>\n      <li><a class="fa fa-cog" data-toggle="tab" href="#product-edit-prices" title="Цены"><span class="hidden-xs"> Цены</span></a></li>\n      <li><a class="fa fa-list" data-toggle="tab" href="#product-edit-options" title="Опции"><span class="hidden-xs"> Опции</span></a></li>\n      <li><a class="fa fa-check-square" data-toggle="tab" href="#product-edit-parameters" title="Характеристики товара"><span class="hidden-xs"> Характеристики</span></a></li>\n      <li><a class="fa fa-sliders" data-toggle="tab" href="#product-edit-modifications" title="Модификации"><span class="hidden-xs"> Модифик.</span></a></li>\n      <li><a class="fa fa-object-ungroup" data-toggle="tab" href="#product-edit-similar-products" title="Похожие товары"><span class="hidden-xs"> Похожие</span></a></li>\n      <li><a class="fa fa-cubes" data-toggle="tab" href="#product-edit-other-warehouse-products" title="Товары с другого склада"><span class="hidden-xs"> Похожие2</span></a></li>\n      <li><a class="fa fa-share-alt" data-toggle="tab" href="#product-edit-accompanying-products" title="Проекты"><span class="hidden-xs"> Проекты</span></a></li>\n      <li><a class="fa fa-files-o" data-toggle="tab" href="#product-edit-files" title="Файлы"><span class="hidden-xs"> Файлы</span></a></li>\n      <li><a class="fa fa-percent" data-toggle="tab" href="#product-edit-discounts" title="Скидки"><span class="hidden-xs"> Скидки</span></a></li>\n      <li><a data-toggle="tab" href="#product-edit-seo"><i class="fa">SEO</i><span class="hidden-xs"> Продвижение</span></a></li>\n      <li><a class="fa fa-comment-o" data-toggle="tab" href="#product-edit-reviews" title="Отзывы"><span class="hidden-xs"> Отзывы</span></a></li>\n      <li if="{item.customFields}"><a data-toggle="tab" href="#product-edit-fields" title="Дополнительная информация">Доп.</a></li>\n    </ul>\n\n    <div class="tab-content">\n      <div class="tab-pane fade in active" id="product-edit-home">\n\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row" if="{!isMulti}">\n            <div class="col-md-2">\n              <div class="form-group">\n                <label class="control-label">Артикул</label>\n                <input class="form-control" name="article" type="text" value="{item.article}">\n              </div>\n            </div>\n            <div class="col-md-4" if="{!isMulti}">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Наименование</label>\n                <input class="form-control" name="name" type="text" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">URL товара</label>\n                <div class="input-group">\n                  <input class="form-control" name="code" value="{item.code}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{permission(translite, &quot;products&quot;, &quot;0010&quot;)}">Транслитерация</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label>Категория</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameGroup" value="{item.nameGroup}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{permission(selectGroup, &quot;products&quot;, &quot;0010&quot;)}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{permission(removeGroup, &quot;products&quot;, &quot;0010&quot;)}"><i class="fa fa-times text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label>Бренд</label>\n                <div class="input-group">\n                  <input class="form-control" value="{item.nameBrand}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{permission(selectBrand, &quot;products&quot;, &quot;0010&quot;)}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{permission(removeBrand, &quot;products&quot;, &quot;0010&quot;)}"><i class="fa fa-times text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n\n                <label class="control-label">Розничная цена</label>\n                <input class="form-control" name="price" min="0" step="0.01" value="{parseFloat(item.price)}" type="{\'number\'}">\n              </div>\n\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Валюта</label>\n                <select class="form-control" name="curr" value="{item.curr}">\n                  <option each="{c, i in currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Ед. измерения</label>\n                <input class="form-control" name="measure" value="{item.measure}">\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-4">\n\n\n              <div class="form-group">\n                <label class="control-label">Общий остаток</label>\n                <input class="form-control" value="{item.stock}" readonly>\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-2">\n              <label class="hidden-xs">&nbsp;</label>\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" __checked="{item.presenceCount == null || item.presenceCount &lt; 0}" onchange="{presenceChange}">Неограниченное\n                </label>\n              </div>\n            </div>\n            <div class="col-md-1 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Мин.кол-во</label>\n                <input class="form-control" name="minCount" min="0" step="1" value="{parseFloat(item.minCount)}" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-1 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Шаг количества</label>\n                <input class="form-control" name="stepCount" min="0" step="0.01" value="{parseFloat(item.stepCount)}" type="{\'number\'}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Вес</label>\n                <input class="form-control" name="weight" min="0.000" step="1.000" value="{item.weightEdit ? parseFloat(item.weightEdit) : &quot;&quot;}" onkeyup="{weightClick}" placeholder="0,000" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Редакт. вес</label>\n                <select class="form-control" name="idWeightEdit" value="{item.idWeightEdit}" onchange="{idWeightEditChange}">\n                  <option each="{c, i in weights}" value="{c.id}" __selected="{c.id == item.idWeightEdit}" no-reorder>{c.name}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Отображ. вес</label>\n                <select class="form-control" name="idWeightView" value="{item.idWeightView}">\n                  <option each="{c, i in weights}" value="{c.id}" __selected="{c.id == item.idWeightView}" no-reorder>{c.name}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Объем</label>\n                <input class="form-control" name="volume" min="0.000" step="1.000" value="{item.volumeEdit ? parseFloat(item.volumeEdit) : &quot;&quot;}" onkeyup="{volumeClick}" placeholder="0,000" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Редакт. объем</label>\n                <select class="form-control" name="idVolumeEdit" value="{item.idVolumeEdit}" onchange="{idVolumeEditChange}">\n                  <option each="{c, i in volumes}" value="{c.id}" __selected="{c.id == item.idVolumeEdit}" no-reorder>{c.name}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-2 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Отображ.объем</label>\n                <select class="form-control" name="idVolumeView" value="{item.idVolumeView}">\n                  <option each="{c, i in volumes}" value="{c.id}" __selected="{c.id == item.idVolumeView}" no-reorder>{c.name}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-sm-6">\n              <div class="form-group">\n                <label class="control-label">Срок поставки</label>\n                <div class="input-group">\n                  <input class="form-control" name="deliveryTime" type="text" value="{item.deliveryTime}">\n                  <div class="input-group-btn">\n                    <select class="input-group-addon form-control" name="signalDt" value="{item.signalDt}" riot-style="width: 150px;;background: {item.signalDt ? item.signalDt : \'#fff\'};">\n                      <option each="{c, i in signal}" value="{c.value}" riot-style="background: {c.value ? c.value : \'#fff\'};" __selected="{c.value == item.signalDt}" no-reorder>{c.name}</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group col-sm-3">\n                <label class="hidden-xs">&nbsp;</label>\n                <div class="checkbox">\n                  <label>\n                    <input type="checkbox" name="flagNew" __checked="{(item.flagNew == &quot;Y&quot;)}" data-bool="Y,N">Новинка\n                  </label>\n                </div>\n              </div>\n              <div class="form-group col-sm-3">\n                <label class="hidden-xs">&nbsp;</label>\n                <div class="checkbox">\n                  <label>\n                    <input type="checkbox" name="flagHit" __checked="{(item.flagHit == &quot;Y&quot;)}" data-bool="Y,N">Хит\n                  </label>\n                </div>\n              </div>\n              <div class="form-group col-sm-3">\n                <label class="hidden-xs">&nbsp;</label>\n                <div class="checkbox">\n                  <label>\n                    <input type="checkbox" name="specialOffer" __checked="{(item.specialOffer == &quot;Y&quot;)}" data-bool="Y,N">Спец.\n                  </label>\n                </div>\n                <checkbox-list-inline items="{item.labels}"></checkbox-list-inline>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Дополнительные категории</label>\n                <product-edit-additional-categories name="crossGroups" value="{item.crossGroups}"></product-edit-additional-categories>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Краткое описание</label>\n                <ckeditor name="note" value="{item.note}"></ckeditor>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-10">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input type="checkbox" name="enabled" __checked="{(item.enabled == &quot;Y&quot;)}" data-bool="Y,N">Отображать на сайте\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input type="checkbox" name="isShowWarehouse" __checked="{item.isShowWarehouse}">Отображать на складе\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input type="checkbox" name="isShowPriceWarehouse" __checked="{item.isShowPriceWarehouse}">Отображать цену продажи на складе\n                  </label>\n                </div>\n\n\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-10">\n              <div class="form-group">\n                <label>Категория Яндекс.Маркет</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameMarketGroup" value="{item.nameMarketGroup}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{permission(selectMarketGroup, &quot;products&quot;, &quot;0010&quot;)}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{permission(removeMarketGroup, &quot;products&quot;, &quot;0010&quot;)}"><i class="fa fa-times text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group">\n                <label class="control-label">Популярность\n                  <input class="form-control" name="sort" step="1" value="{parseFloat(item.sort)}" type="{\'number\'}">\n                </label>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-full-text">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <description-tabs name="text" value="{item.text}"></description-tabs>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-images">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <product-edit-images name="images" value="{item.images}" section="shopprice"></product-edit-images>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-prices">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row">\n            <div class="col-md-3 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Закупочная цена</label>\n                <input class="form-control" name="pricePurchase" min="0" step="0.01" value="{parseFloat(item.pricePurchase)}" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Мелкий опт</label>\n                <input class="form-control" name="priceOpt" min="0" step="0.01" value="{parseFloat(item.priceOpt)}" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Опт</label>\n                <input class="form-control" name="priceOptCorp" min="0" step="0.01" value="{parseFloat(item.priceOptCorp)}" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3 col-xs-6">\n              <div class="form-group">\n                <label class="control-label">Балловая стоимость</label>\n                <input class="form-control" name="bonus" min="0" step="0.01" value="{parseFloat(item.bonus)}" type="{\'number\'}">\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-parameters">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <product-edit-parameters name="specifications" value="{item.specifications}" modifications="{item.modifications}">\n            <yield to="toolbar">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input type="checkbox" name="isShowFeature" __checked="{parent.parent.item.isShowFeature}">Отображать на сайте\n                  </label>\n                </div>\n              </div>\n              <div class="form-group" if="{parent.parent.productTypes.length}">\n                <label class="control-label">Выбрать шаблон</label>\n                <select class="form-control" onchange="{parent.parent.parametersChange}">\n                  <option value=""></option>\n                  <option each="{type, i in parent.parent.productTypes}" value="{type.id}">{type.name}</option>\n                </select>\n              </div>\n            </yield>\n          </product-edit-parameters>\n        </form>\n      </div>\n      <div class="tab-pane fade" id="product-edit-options">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <product-edit-options name="options" value="{item.options}" modifications="{item.modifications}"></product-edit-options>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-modifications">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <product-edit-modifications name="modifications" value="{item.modifications}" images="{item.images}"></product-edit-modifications>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-similar-products">\n        <div class="row">\n          <div class="col-md-12">\n            <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n              <catalog-static name="similarProducts" add="{permission(addSimilarProducts, &quot;products&quot;, &quot;0010&quot;)}" cols="{productsCols}" rows="{item.similarProducts}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="code">{row.code}</datatable-cell>\n                  <datatable-cell name="article">{row.article}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                  <datatable-cell name="price">{row.price}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </form>\n          </div>\n        </div>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-other-warehouse-products">\n        <div class="row">\n          <div class="col-md-12">\n            <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n              <catalog-static name="otherWarehouseProducts" add="{permission(addOtherWarehouseProducts, &quot;products&quot;, &quot;0010&quot;)}" cols="{otherWarehouseProductsCols}" rows="{item.otherWarehouseProducts}" remove="true" handlers="{otherWarehouseProductsHandlers}">\n                <yield to="body">\n                  <datatable-cell name="warehouse">\n                    <div class="input-group input-group-sm"><span class="input-group-addon">Склад #</span>\n                      <input class="form-control" name="warehouse" min="1" step="1" value="{row.warehouse || i + 2}" onkeyup="{handlers.change}" onchange="{handlers.change}" type="{\'number\'}">\n                    </div>\n                  </datatable-cell>\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="code">{row.code}</datatable-cell>\n                  <datatable-cell name="article">{row.article}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                  <datatable-cell name="price">{row.price}</datatable-cell>\n                  <datatable-cell name="stock">{row.stock}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </form>\n          </div>\n        </div>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-accompanying-products">\n        <div class="row">\n          <div class="col-md-12">\n            <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n              <catalog-static name="accompanyingProducts" cols="{accompCols}" rows="{item.accompanyingProducts}" remove="true">\n                <yield to="toolbar">\n                  <button class="btn btn-primary" onclick="{parent.addAccompanyingProducts}" type="button"><i class="fa fa-plus"></i> Добавить проект</button>\n                </yield>\n                <yield to="body">\n                  <datatable-cell name="type">{row.id}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </form>\n          </div>\n        </div>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-files">\n        <form action="" method="POST">\n          <product-files name="files" value="{item.files}" section="shopprice"></product-files>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-discounts">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <product-edit-discounts name="discounts" value="{item.discounts}">\n            <yield to="toolbar">\n              <div class="form-group">\n                <label class="control-label">Макс.скидка %</label>\n                <input class="form-control" value="{parent.parent.item.maxDiscount}" min="0" max="100" type="{\'number\'}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Скидка</label>\n                <select class="form-control select" onchange="{parent.parent.discountChange}">\n                  <option each="{v, n in parent.parent.discountTypes}" value="{v}" __selected="{v == parent.parent.parent.item.discount}" no-reorder>{n}</option>\n                </select>\n              </div>\n            </yield>\n          </product-edit-discounts>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-seo">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <button class="btn btn-primary btn-sm" each="{seoTags}" title="{note}" type="button" onclick="{seoTag.insert}" no-reorder>{name}</button>\n              </div>\n              <div class="form-group">\n                <label class="control-label"> Заголовок</label>\n                <input class="form-control" name="title" type="text" onfocus="{seoTag.focus}" value="{item.title}">\n              </div>\n              <div class="form-group">\n                <label class="control-label"> Ключевые слова</label>\n                <input class="form-control" name="keywords" type="text" onfocus="{seoTag.focus}" value="{item.keywords}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Оглавление страницы (H1)</label>\n                <input class="form-control" name="pageTitle" type="text" onfocus="{seoTag.focus}" value="{item.pageTitle}">\n              </div>\n              <div class="form-group">\n                <label class="control-label"> Описание</label>\n                <textarea class="form-control" rows="5" name="description" onfocus="{seoTag.focus}" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-reviews">\n        <div class="row">\n          <div class="col-md-12">\n            <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n              <catalog-static name="reviews" dblclick="{editReview}" cols="{reviewsCols}" rows="{item.reviews}" remove="true">\n                <yield to="body">\n                  <datatable-cell name="date">{row.date}</datatable-cell>\n                  <datatable-cell name="nameUser">{row.nameUser}</datatable-cell>\n                  <datatable-cell name="mark">\n                    <star-rating count="5" value="{row.mark}"></star-rating>\n                  </datatable-cell>\n                  <datatable-cell name="likes">{row.likes}</datatable-cell>\n                  <datatable-cell name="dislikes">{row.dislikes}</datatable-cell>\n                  <datatable-cell name="comment">{row.comment}</datatable-cell>\n                  <datatable-cell name="merits">{row.merits}</datatable-cell>\n                  <datatable-cell name="demerits">{row.demerits}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </form>\n          </div>\n        </div>\n      </div>\n\n      <div class="tab-pane fade" id="product-edit-fields" if="{item.customFields}">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <add-fields-edit-block name="customFields" value="{item.customFields}"></add-fields-edit-block>\n        </form>\n      </div>\n    </div>\n  </virtual>\n', 'product-edit .color,[riot-tag="product-edit"] .color,[data-is="product-edit"] .color{ height: 12px; width: 12px; display: inline-block; border: 1px solid #ccc; } product-edit a.fa span,[riot-tag="product-edit"] a.fa span,[data-is="product-edit"] a.fa span{ font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.app = app;
	    self.item = {};
	    self.currencies = [];
	    self.seoTags = [];
	    self.loader = false;
	    self.error = false;
	
	    self.wieghts = [];
	    self.volumes = [];
	
	    self.seoTag = new app.insertText();
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty'
	    };
	
	    // клик по весу
	    self.weightClick = function (e) {
	        if (isNaN(e.target.value)) e.target.v = 0;
	
	        self.item.weightEdit = e.target.value;
	        self.item.weight = self.item.weightEdit / self.rateMeasure(self.weights, self.item.idWeightEdit);
	        console.log(self.item.weightEdit);
	    };
	
	    // изменение веса (обработка) [при совершении события отпускания кнопки мыши]
	    self.idWeightEditChange = function (e) {
	        self.item.idWeightEdit = e.target.value;
	        self.item.weightEdit = self.rateMeasure(self.weights, self.item.idWeightEdit) * self.item.weight;
	        self.update();
	    };
	
	    // изменение объемы (обработка) [при совершении события отпускания кнопки мыши]
	    self.idVolumeEditChange = function (e) {
	        self.item.idVolumeEdit = e.target.value;
	        self.item.volumeEdit = self.rateMeasure(self.volumes, self.item.idVolumeEdit) * self.item.volume;
	        self.update();
	    };
	
	    // получение ед измерения
	    self.rateMeasure = function (items, id) {
	        var res = 1;
	        items.forEach(function (item) {
	            if (id == item.id) {
	                res = item.value;
	            }
	        });
	        return res;
	    };
	
	    // клик по объему
	    self.volumeClick = function (e) {
	        if (!isNaN(e.target.value)) {
	            self.item.volumeEdit = e.target.value;
	            self.item.volume = self.item.volumeEdit / self.rateMeasure(self.volumes, self.item.idVolumeEdit);
	        }
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.productsCols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'price', value: 'Цена' }];
	
	    self.otherWarehouseProductsCols = [{ name: 'warehouse', value: 'Склад' }, { name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'price', value: 'Цена' }, { name: 'stock', value: 'Остаток' }];
	
	    self.accompCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
	
	    self.signal = [{ name: 'Выключен', value: '' }, { name: 'Без цвета', value: 'white' }, { name: 'Красный', value: 'red' }, { name: 'Желтый', value: 'yellow' }, { name: 'Зеленый', value: 'green' }];
	
	    self.reviewsCols = [{ name: 'date', value: 'Дата/время' }, { name: 'nameUser', value: 'Пользователь' }, { name: 'mark', value: 'Звёзд' }, { name: 'likes', value: 'Лайков' }, { name: 'dislikes', value: 'Дислайков' }, { name: 'comment', value: 'Отзыв' }, { name: 'merits', value: 'Достоинства' }, { name: 'demerits', value: 'Недостатки' }];
	
	    // скидка вкл/выкл
	    self.discountTypes = {
	        'Y': 'Включена',
	        'N': 'Отключена'
	    };
	
	    // Скидка Изменить
	    self.discountChange = function (e) {
	        self.item.discount = e.target.value;
	    };
	
	    // Добавить похожие продукты
	    self.addSimilarProducts = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.similarProducts = self.item.similarProducts || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.similarProducts.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        self.item.similarProducts.push(item);
	                    }
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.otherWarehouseProductsHandlers = {};
	
	    self.otherWarehouseProductsHandlers.change = function (e) {
	        e.stopPropagation();
	        e.item.row.warehouse = parseInt(e.target.value) || '';
	        self.item._edit_ = true;
	    };
	
	    // Добавить товары с другого склада
	    self.addOtherWarehouseProducts = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.otherWarehouseProducts = self.item.otherWarehouseProducts || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.otherWarehouseProducts.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        item.warehouse = self.item.otherWarehouseProducts.length + 2;
	                        self.item.otherWarehouseProducts.push(item);
	                    }
	                });
	
	                self.item._edit_ = true;
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Добавить сопроводительные продукты
	    self.addAccompanyingProducts = function () {
	        modals.create('news-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.accompanyingProducts = self.item.accompanyingProducts || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.accompanyingProducts.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        var goods = {
	                            id: item.id,
	                            name: item.name,
	                            type: 'Товар',
	                            code: item.code,
	                            article: item.article,
	                            price: item.price
	                        };
	                        self.item.accompanyingProducts.push(goods);
	                    }
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Добавить сопроводительные группы
	    self.addAccompanyingGroups = function () {
	        modals.create('group-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                self.item.accompanyingProducts = self.item.accompanyingProducts || [];
	
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                var ids = self.item.accompanyingProducts.map(function (item) {
	                    return item.idGroup;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) {
	                        var group = {};
	                        group.idGroup = item.id;
	                        group.type = "Группа";
	                        group.name = item.name;
	                        self.item.accompanyingProducts.push(group);
	                    }
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Наличие изменений
	    self.presenceChange = function (e) {
	        if (e.target.checked) self.item.presenceCount = -1;else self.item.presenceCount = 0;
	    };
	
	    // По запросу
	
	    self.priceRequestChange = function (e) {
	        if (e.target.checked) self.item.priceRequest = true;else self.item.priceRequest = false;
	    };
	
	    // Отправить
	    self.submit = function (e) {
	        var params = self.item;
	
	        if (self.isMulti) {
	            self.error = false;
	            params = (0, _extends3.default)({ ids: self.multiIds }, self.item);
	        } else {
	            self.error = self.validation.validate(params, self.rules);
	        }
	
	        console.log('save1111');
	
	        if (!self.error) {
	            self.loader = true;
	
	            // запрос на сохранение товара
	            API.request({
	                object: 'Product',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Товар сохранен!', style: 'popup-success' });
	                    if (self.isClone) {
	                        riot.route('/products/' + self.item.id);
	                        observable.trigger('products-reload');
	                    } else if (self.isMulti) {
	                        riot.route('/products');
	                    } else observable.trigger('products-reload', self.item);
	                },
	                complete: function complete() {
	                    self.loader = false;
	                    self.update();
	                }
	            });
	            console.log(params);
	        }
	    };
	
	    // Выбор группы
	    self.selectGroup = function (e) {
	        modals.create('group-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                self.item.idGroup = items[0].id;
	                self.item.nameGroup = items[0].name;
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Удалить группу
	    self.removeGroup = function (e) {
	        self.item.idGroup = 0;
	        self.item.nameGroup = '';
	    };
	
	    // Выбор Yandex группы
	    self.selectMarketGroup = function (e) {
	        modals.create('mgroup-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                self.item.marketCategory = items[0].id;
	                self.item.nameMarketGroup = items[0].name;
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Удалить группу market
	    self.removeMarketGroup = function (e) {
	        self.item.marketCategory = 0;
	        self.item.nameMarketGroup = '';
	    };
	
	    // Выберите бренд
	    self.selectBrand = function (e) {
	        modals.create('brands-list-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                self.item.idBrand = items[0].id;
	                self.item.nameBrand = items[0].name;
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    // Удалить бренд
	    self.removeBrand = function (e) {
	        self.item.idBrand = null;
	        self.item.nameBrand = '';
	    };
	
	    // Редактировать обзор
	    self.editReview = function (e) {
	        riot.route('/reviews/' + e.item.row.id);
	    };
	
	    // перевести
	    self.translite = function (e) {
	        var params = { vars: [self.item.name] };
	        API.request({
	            object: 'Functions',
	            method: 'Translit',
	            data: params,
	            success: function success(response, xhr) {
	                self.item.code = response.items[0];
	                self.update();
	            }
	        });
	    };
	
	    // Изменение параметров
	    self.parametersChange = function (e) {
	        if (parseInt(e.target.value)) {
	            API.request({
	                object: 'ProductType',
	                method: 'Items',
	                data: { id: parseInt(e.target.value) },
	                success: function success(response) {
	                    self.item.specifications = response.features;
	                },
	                complete: function complete() {
	                    self.update();
	                }
	            });
	        }
	    };
	
	    // Получить продукт
	    function getProduct(id, callback) {
	        var _this = this;
	
	        var params = { id: id };
	
	        (0, _parallel2.default)([function (callback) {
	            API.request({
	                object: 'Product',
	                method: 'Info',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    callback(null, 'Product');
	                },
	                error: function error(response) {
	                    self.item = {};
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'Currency',
	                method: 'Fetch',
	                data: {},
	                success: function success(response) {
	                    self.currencies = response.items;
	                    callback(null, 'Currencies');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	
	            // получение ед измерения (Сравнивает/вычисляет?)
	        }, function (callback) {
	            API.request({
	                object: 'Measure',
	                method: 'Info',
	                data: {},
	                success: function success(response) {
	                    self.weights = response.weights;
	                    self.volumes = response.volumes;
	                    callback(null, 'Measures');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'SeoVariable',
	                method: 'Fetch',
	                data: { type: 'goods' },
	                success: function success(response) {
	                    self.seoTags = response.items;
	                    callback(null, 'SEOTagsVars');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }, function (callback) {
	            API.request({
	                object: 'ProductType',
	                method: 'Fetch',
	                success: function success(response) {
	                    self.productTypes = response.items;
	                    callback(null, 'ProductType');
	                },
	                error: function error(response) {
	                    callback('error', null);
	                }
	            });
	        }], function (err, res) {
	            if (typeof callback === 'function') callback.bind(_this)();
	        });
	    }
	
	    // перезагружать
	    self.reload = function () {
	        observable.trigger('products-edit', self.item.id);
	    };
	
	    // Продукты-редактировать
	    observable.on('products-edit', function (id) {
	        self.error = false;
	        self.isMulti = false;
	        self.isClone = false;
	        self.loader = true;
	        self.update();
	
	        getProduct(id, function () {
	            self.loader = false;
	            self.update();
	        });
	    });
	
	    // продукты-клон
	    observable.on('products-clone', function (id) {
	        self.error = false;
	        self.isMulti = false;
	        self.isClone = true;
	        self.loader = true;
	        self.update();
	
	        // Получить продукт
	        getProduct(id, function () {
	            self.loader = false;
	            delete self.item.id;
	            delete self.item.code;
	            self.item.images.forEach(function (item) {
	                delete item.id;
	            });
	            self.item.modifications.forEach(function (item) {
	                item.items.forEach(function (mod) {
	                    delete mod.article;
	                });
	            });
	
	            self.update();
	        });
	    });
	
	    // Автовключение СКИДКИ в товаре при добавлении новой
	    // событие в product-edit-discounts.tag | observable.trigger('discount-on')
	    observable.on('discount-on', function () {
	        self.item.discount = 'Y';
	        self.update();
	    });
	
	    // Продукты-мульти-редактирование
	    observable.on('products-multi-edit', function (ids) {
	        self.error = false;
	        self.isMulti = true;
	        self.isClone = false;
	        self.item = {};
	        self.multiIds = ids;
	        self.update();
	    });
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'shopprice');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(61);
	
	__webpack_require__(103);
	
	__webpack_require__(353);
	
	riot.tag2('product-files', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" cols="{cols}" rows="{value}" handlers="{handlers}" upload="{upload}" remove="{handlers.remove}" reorder="true">\n        <yield to="toolbar">\n          <div class="form-group" if="{checkPermission(&quot;files&quot;, &quot;0100&quot;)}">\n            <div class="input-group btn btn-primary btn-file">\n              <input name="files" onchange="{opts.upload}" type="file" multiple="multiple"><i class="fa fa-plus"></i> Загрузить\n            </div>\n            <button class="btn btn-default" name="link" onclick="{parent.addLink}" type="button"><i class="fa fa-plus"></i> Ссылку</button>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name=""><i class="fa fa-4x fa-file-o icon-file"><span class="icon-ext">{row.fileExt}</span></i>\n\n          </datatable-cell>\n          <datatable-cell name="">\n            <input class="form-control" value="{row.fileText}" onchange="{handlers.fileAltChange}">\n            <div class="help-block"><a href="{row.fileURL}" target="_blank">{row.fileName}</a></div>\n          </datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', 'product-files .icon-file,[riot-tag="product-files"] .icon-file,[data-is="product-files"] .icon-file{ position: relative; } product-files .icon-ext,[riot-tag="product-files"] .icon-ext,[data-is="product-files"] .icon-ext{ position: absolute; font-size: 13px; font-weight: bold; right: 7px; bottom: 7px; }', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.mixin('permissions');
	    self.items = [];
	
	    Object.defineProperty(self.root, 'value', {
	        get: function get() {
	            return self.value;
	        },
	        set: function set(value) {
	            self.value = value || [];
	            self.update();
	        }
	    });
	
	    self.add = function () {};
	
	    self.cols = [{ name: '', value: 'Файл' }, { name: '', value: 'Текст' }];
	
	    self.handlers = {
	        fileAltChange: function fileAltChange(e) {
	            e.item.row.fileText = e.target.value;
	        },
	        remove: function remove(e) {
	            var rows = self.tags['catalog-static'].tags.datatable.getSelectedRows();
	
	            rows.forEach(function (row) {
	                self.value.splice(self.value.indexOf(row), 1);
	            });
	        }
	
	    };
	
	    self.addLink = function (e) {
	        modals.create('add-link-modal', {
	            type: 'modal-primary',
	            title: 'Добавить ссылку',
	            submit: function submit() {
	                self.value.push({
	                    fileText: this.item.name,
	                    fileURL: this.item.name,
	                    fileExt: 'http',
	                    fileName: this.item.name
	                });
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	    self.upload = function (e) {
	        var formData = new FormData();
	        var FilesItems = [];
	
	        for (var i = 0; i < e.target.files.length; i++) {
	            formData.append('file' + i, e.target.files[i], e.target.files[i].name);
	            //items.push(e.target.files[i].name)
	        }
	
	        API.upload({
	            section: opts.section,
	            object: 'Files',
	            count: e.target.files.length,
	            data: formData,
	            progress: function progress(e) {},
	            success: function success(response) {
	                FilesItems = response.items;
	                self.value = self.value || [];
	
	                if (FilesItems.length == 0) {
	                    popups.create({ title: 'Ошибка!', text: 'Данные файлы уже есть на сервере', style: 'popup-danger' });
	                }
	                FilesItems.forEach(function (i) {
	                    self.value.push({
	                        fileText: i.name,
	                        fileURL: i.url,
	                        fileExt: i.ext,
	                        fileName: i.file
	                    });
	                });
	                var event = document.createEvent('Event');
	                event.initEvent('change', true, true);
	                self.root.dispatchEvent(event);
	                self.update();
	            }
	        });
	    };
	
	    self.on('updated', function () {
	        self.tags['catalog-static'].tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
	            self.tags['catalog-static'].value.splice(newIndex, 0, self.tags['catalog-static'].value.splice(oldIndex, 1)[0]);
	            var temp = self.tags['catalog-static'].value;
	            self.rows = [];
	            self.update();
	            self.tags['catalog-static'].value = temp;
	            self.tags['catalog-static'].items.forEach(function (item, sort) {
	                item.sortIndex = sort;
	            });
	        });
	    });
	
	    self.on('update', function () {
	        if ('name' in opts && opts.name !== '') self.root.name = opts.name;
	
	        if ('value' in opts) self.value = opts.value || [];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('product-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новый товар</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(358);
	
	__webpack_require__(357);
	
	__webpack_require__(355);
	
	__webpack_require__(453);
	
	__webpack_require__(169);
	
	__webpack_require__(443);
	
	__webpack_require__(444);
	
	__webpack_require__(446);
	
	__webpack_require__(449);
	
	riot.tag2('products-list', '  <div class="row">\n\n    <div class="col-md-3 hidden-xs hidden-sm">\n      <catalog-tree object="Category" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" deselall="true" descendants="true" handlers="{handlersGroups}"></catalog-tree>\n    </div>\n\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog search="true" sortable="true" object="Product" cols="{cols}" combine-filters="true" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(productOpen, &quot;products&quot;, &quot;1000&quot;)}" handlers="{handlers}" allselect="true" reload="true" store="products-list" filters="{categoryFilters}">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group">\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="flagHit" data-bool="Y,N">Хиты\n                </label>\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="flagNew" data-bool="Y,N">Новинки\n                </label>\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="specialOffer" data-bool="Y,N">Спецпредложения\n                </label>\n              </div>\n              <div class="form-group" if="{parent.labels.length}">\n                <select class="form-control" data-name="idLabel" onchange="{parent.selectLabel}">\n                  <option value="">Все ярлыки</option>\n                  <option each="{label, i in parent.labels}" value="{label.id}" no-reorder>{label.name}</option>\n                </select>\n              </div>\n              <div class="form-group">\n                <div class="input-group" style="width: 48%; float: left; margin: 0 2% 0 0;"><span class="input-group-addon"><i class="fa fa-percent"></i></span>\n                  <select class="form-control" data-name="discount">\n                    <option value="">Все</option>\n                    <option value="Y">Со скидкой</option>\n                    <option value="N">Без скидки</option>\n                  </select>\n                </div>\n                <div class="input-group" style="width: 48%; float: left; margin: 0 0 0 2%;"><span class="input-group-addon"><i class="fa fa-eye"></i></span>\n                  <select class="form-control" data-name="enabled">\n                    <option value="">Все</option>\n                    <option value="Y">Отображаемые</option>\n                    <option value="N">Неотображаемые</option>\n                  </select>\n                </div>\n              </div>\n              <div class="form-group">\n                <select class="form-control" data-name="idBrand" onchange="{parent.selectBrand}">\n                  <option value="">Все бренды</option>\n                  <option each="{brand, i in parent.brands}" value="{brand.id}" no-reorder>{brand.name}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </yield>\n\n        <yield to="head">\n          <div class="dropdown" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n            <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n            <ul class="dropdown-menu">\n              <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.multiEdit}"><a href="#"><i class="fa fa-fw fa-pencil"></i> Мультиредактирование товаров</a></li>\n              <li class="{disabled: selectedCount &gt; 1}" onclick="{handlers.cloneProduct}"><a href="#"><i class="fa fa-fw fa-clone"></i> Клонирование товара</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="enabled"><i class="fa fa-fw fa-eye"></i> Видимость (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="flagNew"><i class="fa fa-fw fa-asterisk"></i> Новинка (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="flagHit"><i class="fa fa-fw fa-star"></i> Хит (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleBool}"><a href="#" data-field="isMarket"><i class="fa fa-fw fa-money"></i> Маркет (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="specialOffer"><i class="fa fa-fw fa-check"></i> Спец.</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setCategory}"><a href="#"><i class="fa fa-fw"></i> Переопределить категорию</a></li>\n              <li onclick="{handlers.setBrand}"><a href="#"><i class="fa fa-fw"></i> Назначить бренд</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setAddCategory}"><a href="#"><i class="fa fa-fw"></i> Назначить доп. категории</a></li>\n              <li onclick="{handlers.addCategory}"><a href="#"><i class="fa fa-fw"></i> Добавить доп. категории</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setFeatures}"><a href="#"><i class="fa fa-fw"></i> Назначить характеристики</a></li>\n              <li onclick="{handlers.addFeatures}"><a href="#"><i class="fa fa-fw"></i> Добавить характеристики</a></li>\n              <li onclick="{handlers.showFeatures}"><a href="#"><i class="fa fa-fw"></i> Отображать атрибуты на сайте</a></li>\n              <li onclick="{handlers.hideFeatures}"><a href="#"><i class="fa fa-fw"></i> Скрывать атрибуты на сайте</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setModifications}"><a href="#"><i class="fa fa-fw"></i> Назначить модификации</a></li>\n              <li onclick="{handlers.addModifications}"><a href="#"><i class="fa fa-fw"></i> Добавить модификации</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setPrice}"><a href="#"><i class="fa fa-fw fa-money"></i> Задать цены</a></li>\n              <li onclick="{handlers.setMarkup}"><a href="#"><i class="fa fa-fw"></i> Произвести наценку</a></li>\n            </ul>\n          </div>\n          <yield to="head">\n            <button class="btn btn-primary" type="button" onclick="{parent.exportProducts}" title="Экспорт"><i class="fa fa-upload"></i></button>\n            <button class="btn btn-primary" if="{checkPermission(&quot;products&quot;, &quot;0111&quot;)}" type="button" onclick="{parent.importProducts}" title="Импорт"><i class="fa fa-download"></i></button>\n          </yield>\n        </yield>\n\n        <yield to="body">\n          <datatable-cell name="id" style="max-width: 80px;"><a class="open-page-item" href="#products/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n          <datatable-cell name="img" style="max-width: 50px; overflow: hidden;"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 40px;"></datatable-cell>\n          <datatable-cell name="article" style="max-width: 100px;" title="{row.article}">{row.article}</datatable-cell>\n          <datatable-cell name="name" style="min-width: 150px; overflow: hidden; text-overflow: ellipsis;" title="{row.name}">{row.name}</datatable-cell>\n\n          <datatable-cell name="stock" style="max-width: 80px;">{row.stock}</datatable-cell>\n          <datatable-cell name="nameBrand" style="max-width: 80px; overflow: hidden; text-overflow: ellipsis;">{row.nameBrand}</datatable-cell>\n          <datatable-cell name="nameGroup" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis;">{row.nameGroup}</datatable-cell>\n          <datatable-cell name="sort" style="max-width: 50px;">{row.sort}</datatable-cell>\n          <datatable-cell name="enabled" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.enabled == &quot;Y&quot; ? &quot;fa-eye text-active&quot; : &quot;fa-eye-slash text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="flagNew" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.flagNew == &quot;Y&quot; ? &quot;fa-asterisk text-active&quot; : &quot;fa-asterisk text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="flagHit" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.flagHit == &quot;Y&quot; ? &quot;fa-star text-active&quot; : &quot;fa-star text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="isMarket" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.isMarket ? &quot;fa-money text-active&quot; : &quot;fa-money text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="specialOffer" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.specialOffer == &quot;Y&quot; ? &quot;fa-check text-active&quot; : &quot;fa-check text-noactive&quot;} "></i></button>\n          </datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n  </div>\n', 'products-list,[riot-tag="products-list"],[data-is="products-list"]{ display: block; position: relative; } products-list .text-active,[riot-tag="products-list"] .text-active,[data-is="products-list"] .text-active{ color: #000; } products-list .text-noactive,[riot-tag="products-list"] .text-noactive,[data-is="products-list"] .text-noactive{ color: #ccc; } products-list .table td,[riot-tag="products-list"] .table td,[data-is="products-list"] .table td{ vertical-align: middle !important; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Product';
	    self.brands = [];
	    self.labels = [];
	    self.categoryFilters = false;
	
	    self.add = function (e) {
	        /*
	        * СОЗДАНИЕ ТОВАРА
	        * получаем базовыю валюту
	        * формируем данные: name, idGroup, idBrand, curr
	        * передаем в Product Save
	        */
	        API.request({
	            object: 'Main',
	            method: 'Info',
	            data: {},
	            success: function success(response) {
	                self.basecurr = response.basecurr;
	                modals.create('product-new-modal', {
	                    type: 'modal-primary',
	                    submit: function submit() {
	                        var _this = this;
	                        var params = {
	                            name: this.name.value,
	                            idGroup: self.selectedCategory,
	                            idBrand: self.selectedBrand,
	                            curr: self.basecurr
	                        };
	                        _this.error = _this.validation.validate(_this.item, _this.rules);
	                        if (!_this.error) {
	                            API.request({
	                                object: 'Product',
	                                method: 'Save',
	                                data: params,
	                                success: function success(response, xhr) {
	                                    popups.create({ title: 'Успех!', text: 'Товар добавлен!', style: 'popup-success' });
	                                    _this.modalHide();
	                                    self.tags.catalog.reload();
	                                    if (response && response.id) riot.route('/products/' + response.id);
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	        });
	    };
	    self.cols = [{ name: 'id', value: '#' }, { name: 'img', value: 'Фото' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' },
	    //{ name:'price', value:'Цена'},
	    { name: 'stock', value: 'Остаток' }, { name: 'nameBrand', value: 'Бренд' }, { name: 'nameGroup', value: 'Группа' }, { name: 'sort', value: 'Индекс' }, { name: 'enabled', value: 'Вид' }, { name: 'flagNew', value: 'Нв' }, { name: 'flagHit', value: 'Хит' }, { name: 'isMarket', value: 'ЯМ' }, { name: 'specialOffer', value: 'Спец.' }];
	
	    function afterChangeParent(idParent, id, position) {
	        var params = {};
	        params.id = id;
	        params.upid = idParent;
	        params.position = position;
	
	        API.request({
	            object: 'Category',
	            method: 'Save',
	            data: params,
	            success: function success() {
	                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	            }
	        });
	    }
	
	    function afterChangePosition(indexes) {
	        var params = { indexes: indexes };
	        API.request({
	            object: 'Category',
	            method: 'Sort',
	            data: params,
	            success: function success() {
	                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	            }
	        });
	    }
	
	    self.handlersGroups = {
	        afterChangeParent: afterChangeParent,
	        afterChangePosition: afterChangePosition
	    };
	
	    // сохранение измененных через лист параметров
	    self.handlers = {
	        checkPermission: self.checkPermission,
	        permission: self.permission,
	        boolChange: function boolChange(e) {
	            var _this = this;
	            e.stopPropagation();
	            e.stopImmediatePropagation();
	
	            if (_this.opts.name == 'presenceCount') {
	                this.row[this.opts.name] = e.target.value;
	                _this.row[_this.opts.name] = e.target.value;
	            } else if (_this.opts.name == 'isMarket') _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;else _this.row[_this.opts.name] = _this.row[_this.opts.name] === 'Y' ? 'N' : 'Y';
	
	            self.update();
	
	            var params = {};
	            params.id = _this.row.id;
	            params[_this.opts.name] = _this.row[_this.opts.name];
	
	            params = self.tags.catalog.allParams(params);
	            API.request({
	                object: 'Product',
	                method: 'Save',
	                data: params,
	                error: function error(response) {
	                    if (_this.opts.name == 'isMarket') _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;else _this.row[_this.opts.name] = _this.row[_this.opts.name] === 'Y' ? 'N' : 'Y';
	                    self.update();
	                }
	            });
	        },
	
	        // селекторы
	        toggleSelected: function toggleSelected(e) {
	            var field = e.target.getAttribute('data-field');
	
	            var oldValues = {};
	            var rows = this.tags.datatable.getSelectedRows();
	            var ids = rows.map(function (item) {
	                return item.id;
	            });
	            var newValue = rows[0][field] === 'Y' ? 'N' : 'Y';
	
	            var params = self.tags.catalog.getSelectedMode();
	            params[field] = newValue;
	
	            rows.forEach(function (item) {
	                var _oldValues$item$id;
	
	                oldValues[item.id] = (_oldValues$item$id = {}, _oldValues$item$id[field] = item[field], _oldValues$item$id);
	                item[field] = newValue;
	            });
	            API.request({
	                object: 'Product',
	                method: 'Save',
	                data: params,
	                error: function error(response) {
	                    rows.forEach(function (item) {
	                        item[field] = oldValues[item.id][field];
	                    });
	
	                    self.update();
	                }
	            });
	        },
	        toggleBool: function toggleBool(e) {
	            var field = e.target.getAttribute('data-field');
	            var oldValues = {};
	            var rows = this.tags.datatable.getSelectedRows();
	            var ids = rows.map(function (item) {
	                return item.id;
	            });
	            var newValue = rows[0][field] ? 0 : 1;
	
	            var params = self.tags.catalog.getSelectedMode();
	            params[field] = newValue;
	
	            rows.forEach(function (item) {
	                var _oldValues$item$id2;
	
	                oldValues[item.id] = (_oldValues$item$id2 = {}, _oldValues$item$id2[field] = item[field], _oldValues$item$id2);
	                item[field] = newValue;
	            });
	            API.request({
	                object: 'Product',
	                method: 'Save',
	                data: params,
	                error: function error(response) {
	                    rows.forEach(function (item) {
	                        item[field] = oldValues[item.id][field];
	                    });
	                    self.update();
	                }
	            });
	        },
	
	        // МЕНЮ ДЕЙСТВИЙ
	        // мультиредактирование товаров
	        multiEdit: function multiEdit(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            }).join(',');
	            riot.route('/products/multi?ids=' + ids);
	        },
	
	        // клонирование товара
	        cloneProduct: function cloneProduct(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            }).join(',');
	            riot.route('/products/clone?id=' + ids);
	        },
	
	        /*
	        * ПЕРЕОПРЕДЕЛИТЬ КАТЕГОРИЮ
	        * ids                    id выделенных товаров
	        * items                    id выбранных категорий для товаров
	        * items[0], params        данные выбраннОЙ категории для товаров
	        */
	        setCategory: function setCategory(e) {
	            var _this = this;
	            var params = {};
	
	            var items = _this.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	            params = { ids: ids };
	            params = _this.allParams(params);
	
	            modals.create('group-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var citems = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	
	                    if (citems.length > 0) {
	                        params = (0, _extends3.default)({ idGroup: citems[0].id }, params);
	
	                        console.log(params);
	
	                        API.request({
	                            object: 'Product',
	                            method: 'Save',
	                            data: params,
	                            success: function success(response) {
	                                _this.reload();
	                            }
	                        });
	
	                        self.update();
	                        this.modalHide();
	                    }
	                }
	            });
	        },
	
	        /*
	        * НАЗНАЧЕНИЕ ДОП.КАТЕГОРИЙ
	        * ids                    id выделенных товаров
	        * items, params            данные выбранных категорий для товаров
	        * itemsCrossGroups        массивы с данными по доп.категориям (отправляются нумерованным массивом)
	        */
	        setAddCategory: function setAddCategory(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            });
	
	            modals.create('group-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	
	                    if (items.length > 0) {
	                        var itemsCrossGroups = {};
	                        for (var i = 0; i < items.length; i++) {
	                            itemsCrossGroups[i] = items[i];
	                        }var params = {
	                            ids: ids,
	                            crossGroups: itemsCrossGroups
	                        };
	
	                        params = self.tags.catalog.allParams(params);
	                        API.request({
	                            object: 'Product',
	                            method: 'Save',
	                            data: params,
	                            success: function success(response) {
	                                self.tags.catalog.reload();
	                            }
	                        });
	
	                        self.update();
	                        this.modalHide();
	                    }
	                }
	            });
	        },
	
	        /** ДОБАВИТЬ ДОП.КАТЕГОРИИ
	        * @param ids                id выделенных товаров
	        * @param items, params      данные выбранных категорий для товаров
	        */
	        addCategory: function addCategory(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            });
	
	            modals.create('group-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	
	                    if (items.length > 0) {
	                        var itemsCrossGroups = {};
	                        for (var i = 0; i < items.length; i++) {
	                            itemsCrossGroups[i] = items[i];
	                        }var params = {
	                            ids: ids,
	                            crossGroups: itemsCrossGroups,
	                            delCrosGroups: "False"
	                        };
	
	                        params = self.tags.catalog.allParams(params);
	                        API.request({
	                            object: 'Product',
	                            method: 'Save',
	                            data: params,
	                            success: function success(response) {
	                                self.tags.catalog.reload();
	                            }
	                        });
	
	                        self.update();
	                        this.modalHide();
	                    }
	                }
	            });
	        },
	
	        // добавить модификации
	        addModifications: function addModifications(e) {
	            var items = this.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	            API.request({
	                object: 'Product',
	                method: 'Info',
	                data: { id: items[0].id },
	                success: function success(response) {
	                    var modifications = response.modifications;
	
	                    modals.create('product-edit-modifications-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        modifications: modifications,
	                        submit: function submit() {
	                            var _this = this;
	                            var params = (0, _extends3.default)({ ids: ids, add: true }, this.item);
	                            params = self.tags.catalog.allParams(params);
	                            API.request({
	                                object: 'Product',
	                                method: 'Save',
	                                data: params,
	                                success: function success(response) {
	                                    _this.modalHide();
	                                    self.tags.catalog.reload();
	                                }
	                            });
	                        }
	                    });
	                }
	            });
	        },
	        contextMenu: function contextMenu(Event, SelectedRow) {
	            return true;
	        },
	
	        // задать модификации
	        setModifications: function setModifications(e) {
	            var items = this.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	
	            API.request({
	                object: 'Product',
	                method: 'Info',
	                data: { id: items[0].id },
	                success: function success(response) {
	                    var modifications = response.modifications;
	
	                    modals.create('product-edit-modifications-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        modifications: modifications,
	                        submit: function submit() {
	                            var _this = this;
	                            var params = (0, _extends3.default)({ ids: ids }, this.item);
	
	                            params = self.tags.catalog.allParams(params);
	                            API.request({
	                                object: 'Product',
	                                method: 'Save',
	                                data: params,
	                                success: function success(response) {
	                                    _this.modalHide();
	                                    self.tags.catalog.reload();
	                                }
	                            });
	                        }
	                    });
	                }
	            });
	        },
	
	        // задать характеристики
	        setFeatures: function setFeatures(e) {
	            var items = this.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	            var specifications = [];
	
	            API.request({
	                object: 'Product',
	                method: 'Info',
	                data: { id: ids, set: true },
	                success: function success(response) {
	                    specifications = response;
	
	                    modals.create('product-edit-parameters-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        specifications: specifications,
	                        submit: function submit() {
	                            var _this = this;
	                            var params = (0, _extends3.default)({ ids: ids }, this.item, { isAddSpecifications: false });
	
	                            params = self.tags.catalog.allParams(params);
	                            API.request({
	                                object: 'Product',
	                                method: 'Save',
	                                data: params,
	                                success: function success(response) {
	                                    _this.modalHide();
	                                    self.tags.catalog.reload();
	                                }
	                            });
	                        }
	                    });
	                }
	            });
	        },
	
	        // добавить характеристики
	        addFeatures: function addFeatures(e) {
	            var items = this.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	            //let specifications = []
	
	            API.request({
	                object: 'Product',
	                method: 'Info',
	                data: { id: ids, set: true },
	                success: function success(response) {
	                    var specifications = response;
	
	                    modals.create('product-edit-parameters-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        specifications: specifications,
	                        submit: function submit() {
	                            var _this = this;
	                            var params = (0, _extends3.default)({ ids: ids }, this.item, { isAddSpecifications: true });
	
	                            params = self.tags.catalog.allParams(params);
	                            API.request({
	                                object: 'Product',
	                                method: 'Save',
	                                data: params,
	                                success: function success(response) {
	                                    _this.modalHide();
	                                    self.tags.catalog.reload();
	                                }
	                            });
	                        }
	                    });
	                }
	            });
	        },
	
	        // задать бренд
	        setBrand: function setBrand(e) {
	            var ids = this.tags.datatable.getSelectedRows().map(function (item) {
	                return item.id;
	            });
	            var catalog = this;
	
	            modals.create('brands-list-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                    var params = self.tags.catalog.getSelectedMode();
	                    params['brand'] = { id: items[0].id, name: items[0].name };
	
	                    /* let params = { ids, brand: { id: items[0].id, name: items[0].name }};
	                         params = catalog.allParams(params); */
	
	                    API.request({
	                        object: 'Product',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            self.tags.catalog.reload();
	                        }
	                    });
	
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        },
	
	        // задать цену
	        setPrice: function setPrice(e) {
	            var items = self.tags.catalog.tags.datatable.getSelectedRows();
	            var price = items[0].price;
	
	            modals.create('price-modal', {
	                type: 'modal-primary',
	                price: price,
	                submit: function submit() {
	                    var _this = this;
	                    var item = this.item;
	                    var ids = items.map(function (item) {
	                        return item.id;
	                    });
	                    var params = (0, _extends3.default)({ ids: ids }, item);
	
	                    params = self.tags.catalog.allParams(params);
	                    API.request({
	                        object: 'Product',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            });
	        },
	        showFeatures: function showFeatures(e) {
	            var items = self.tags.catalog.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	            var params = { ids: ids };
	            params["isShowFeature"] = true;
	            params = self.tags.catalog.allParams(params);
	            API.request({
	                object: 'Product',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	                }
	            });
	        },
	        hideFeatures: function hideFeatures(e) {
	            var items = self.tags.catalog.tags.datatable.getSelectedRows();
	            var ids = items.map(function (item) {
	                return item.id;
	            });
	            var params = { ids: ids };
	            params["isShowFeature"] = false;
	            params = self.tags.catalog.allParams(params);
	            API.request({
	                object: 'Product',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	                }
	            });
	        },
	
	        // задать наценку
	        setMarkup: function setMarkup(e) {
	            modals.create('markup-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var _this = this;
	                    var item = this.item;
	                    var params = self.tags.catalog.getSelectedMode();
	                    params.value = item.value;
	                    params.price = item.price;
	                    params.source = item.source;
	                    API.request({
	                        object: 'Product',
	                        method: 'AddPrice',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            });
	        }
	    };
	
	    self.productOpen = function (e) {
	        return riot.route('/products/' + e.item.row.id);
	    };
	
	    // получить бренды
	    self.getBrands = function () {
	        API.request({
	            object: 'Brand',
	            method: 'Fetch',
	            success: function success(response) {
	                self.brands = response.items;
	                self.update();
	            }
	        });
	    };
	
	    // получить ярлыки
	    self.getLabels = function () {
	        API.request({
	            object: 'ProductLabel',
	            method: 'Fetch',
	            success: function success(response) {
	                self.labels = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.selectBrand = function (e) {
	        self.selectedBrand = e.target.value || undefined;
	    };
	
	    self.selectLabel = function (e) {
	        self.selectLabel = e.target.value || undefined;
	    };
	
	    // перезагрузка каталога продуктов
	    observable.on('products-reload', function (item) {
	        console.log(self.tags.catalog);
	        // принимаем группы для фильтрации
	        if (item && item.name) {
	            (function () {
	                self.update();
	                var items = self.tags.catalog.items;
	                if (items && items.length > 0) items.forEach(function (it, i) {
	                    if (it.__selected__) {
	                        items[i].name = item.name;
	                        items[i].article = item.article;
	                        items[i].imageUrlPreview = item.imageUrlPreview;
	                        items[i].price = item.price;
	                        items[i].flagHit = item.flagHit;
	                        items[i].flagNew = item.flagNew;
	                        items[i].specialOffer = item.specialOffer;
	                        items[i].nameGroup = item.nameGroup;
	                        items[i].nameBrand = item.nameBrand;
	                        items[i].presenceCount = item.presenceCount;
	                        items[i].discount = item.discount;
	                        items[i].isMarket = item.isMarket;
	                        items[i].enabled = item.enabled;
	                        return;
	                    }
	                });
	                //tags.datatable.getSelectedRows()
	                //items[0] = item
	
	                /*
	                if (item.idGroup > 0) {
	                    let value = item.idGroup
	                    //items.map(i => i.id).join(',')
	                    self.categoryFilters = [{field: 'idGroup', sign: 'IN', value}]
	                } else {
	                    self.categoryFilters = false
	                    self.selectedCategory = 0
	                }
	                */
	                self.update();
	            })();
	        } else {
	            self.update();
	            self.tags.catalog.reload();
	        }
	    });
	
	    // перезагрузка дерева категорий
	    observable.on('categories-reload', function (e) {
	        self.tags['catalog-tree'].reload();
	    });
	
	    self.one('updated', function () {
	        self.tags.catalog.on('reload', function () {
	            self.getBrands();
	            self.getLabels();
	        });
	        self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
	            self.selectedCategory = node.__selected__ ? node.id : undefined;
	            var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.id;
	                }).join(',');
	                self.categoryFilters = [{ field: 'idGroup', sign: 'IN', value: value }];
	            } else {
	                self.categoryFilters = false;
	                self.selectedCategory = 0;
	            }
	            self.update();
	            self.tags.catalog.reload();
	        });
	    });
	
	    self.import = {};
	
	    observable.on('products-imports', function () {
	        modals.create('import-products-modal-continue', {
	            type: 'modal-primary'
	        });
	    });
	    observable.on('products-imports-end', function () {
	        modal.modalHide();
	    });
	
	    self.importProducts = function (e) {
	        modals.create('import-products-modal', {
	            type: 'modal-primary',
	            idGroup: self.selectedCategory
	        });
	        //var formData = new FormData();
	        //for (var i = 0; i < e.target.files.length; i++) {
	        //   formData.append('file' + i, e.target.files[i], e.target.files[i].name)
	        //}
	        //
	        //API.upload({
	        //    object: 'Product',
	        //    data: formData,
	        //    success(response) {
	        //        self.update();
	        //    }
	        //})
	    };
	
	    self.exportProducts = function (e) {
	        var items = self.tags.catalog.tags.datatable.getSelectedRows();
	        var ids = items.map(function (item) {
	            return item.id;
	        });
	        var params = {};
	        if (ids) {
	            params = { ids: ids };
	        }
	        params = self.tags.catalog.allParams(params);
	        modals.create('export-products-modal', {
	            type: 'modal-primary',
	            idGroup: self.selectedCategory,
	            params: params
	        });
	    };
	
	    self.getBrands();
	    self.getLabels();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable, app) {'use strict';
	
	__webpack_require__(80);
	
	__webpack_require__(81);
	
	__webpack_require__(171);
	
	__webpack_require__(33);
	
	__webpack_require__(10);
	
	riot.tag2('purchases-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#purchases"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;purchases&quot;, &quot;0100&quot;) : checkPermission(&quot;purchases&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reloadButton}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? \'Новая закупка\' : \'Редактирование закупки № \' + item.id}</div>\n    <div class="tab-content-purchase">\n      <div id="purchase-edit-home">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row">\n            <div class="col-md-1" if="{!isNew}">\n              <div class="form-group">\n                <label class="control-label">Ид</label>\n                <input class="form-control" name="id" value="{item.id}" readonly>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group">\n                <label class="control-label">Дата закупки</label>\n                <datetime-picker class="form-control" name="date" format="YYYY-MM-DD" value="{item.date}" icon="glyphicon glyphicon-calendar" onchange="{purchaseDateChange}"></datetime-picker>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Поставщик</label>\n                <input class="form-control" name="provider" value="{item.provider}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="well well-sm">\n                <div class="h4">Платежи</div>\n                <catalog-static name="payments" rows="{item.payments}" cols="{paymentsCols}" remove="{item.status!=&quot;N&quot;}" handlers="{itemsHandlers}" responsive="false" limit="999">\n                  <yield to="toolbar">\n                    <div class="form-group" if="{parent.item.status!=&quot;N&quot;}">\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.addPayment}"><i class="fa fa-plus"></i> Добавить платеж</button>\n                    </div>\n                  </yield>\n                  <yield to="body">\n                    <datatable-cell name="pos" style="width:100px;">{parent.i + 1}</datatable-cell>\n                    <datatable-cell name="date" style="width:150px;">\n                      <datetime-picker class="form-control" format="YYYY-MM-DD" value="{row.date}" icon="glyphicon glyphicon-calendar" onchange="{handlers.stringChange}"></datetime-picker>\n                    </datatable-cell>\n                    <datatable-cell name="amount" style="width:150px;">\n                      <input class="form-control" value="{row.amount}" step="1" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="commentary">\n                      <input class="form-control" value="{row.commentary}" type="text" onchange="{handlers.stringChange}">\n                    </datatable-cell>\n                  </yield>\n                </catalog-static>\n                <div class="row">\n                  <div class="col-md-12">\n                    <div class="pull-right">\n                      <label>Итого:</label><strong> {amountPayments}</strong>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="well well-sm">\n                <catalog-static name="items" rows="{item.items}" cols="{itemsCols}" remove="{item.status!=&quot;N&quot;}" handlers="{itemsHandlers}" limit="999">\n                  <yield to="toolbar">\n                    <div class="form-group" if="{parent.item.status!=&quot;N&quot;}">\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.addProducts}"><i class="fa fa-plus"></i> Добавить товар</button>\n                    </div><span class="pull-right"><strong class="text-muted pull-left">Курс EUR: {parent.item.courses.eur}</strong></span>\n                  </yield>\n                  <yield to="body">\n                    <datatable-cell name="pos">{parent.i + 1}</datatable-cell>\n                    <datatable-cell name="nameBrand">{row.nameBrand}</datatable-cell>\n                    <datatable-cell name="name" style="width: 50%;">\n                      <input value="{row.name}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell name="count" style="max-width: 20px;">\n                      <input value="{row.count}" step="1" min="1" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="priceEuro" style="max-width: 50px;">\n                      <input value="{row.priceEuro}" step="0.01" min="0" oninput="{handlers.numberChange}" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="price" style="max-width: 50px;">\n                      <input class="{text-muted: (row.priceEuro &gt; 0)}" value="{row.price}" __readonly="{row.priceEuro &gt; 0}" step="1.00" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="discount" style="max-width: 20px;">\n                      <input value="{row.discount}" step="0.01" min="0" max="100" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="amount" style="max-width: 20px;">{(row.count * (row.price * (1 - row.discount/100))).toFixed(0).toLocaleString()}</datatable-cell>\n                    <datatable-cell name="markup" style="min-width: 60px;">\n                      <input value="{row.markup}" step="0.01" min="0" max="100" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="sellingPrice" onclick="{handlers.copyText}">{(row.count * (row.price  * (1 - row.discount/100)) * (row.markup > 0 ? row.markup: 0) ).toFixed(0).toLocaleString()}</datatable-cell>\n                  </yield>\n                </catalog-static>\n                <div class="alert alert-danger" if="{error.items}">{error.items}</div>\n                <div class="row">\n                  <div class="col-md-12">\n                    <div class="pull-right">\n                      <label>Сумма закупки:</label><strong> {sumProductsDisplay}</strong><br>\n                      <label>Сумма продажи:</label><strong>{sellngTotalDisplay}</strong>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Комментарий</label>\n                <textarea class="form-control" rows="5" name="commentary" value="{item.commentary}"></textarea>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _assign = __webpack_require__(83);
	
	    var _assign2 = _interopRequireDefault(_assign);
	
	    var _isNan = __webpack_require__(515);
	
	    var _isNan2 = _interopRequireDefault(_isNan);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this,
	        route = riot.route.create();
	
	    self.isNew = false;
	    self.item = {};
	    self.items = [];
	    self.loader = false;
	    self.sumProducts = 0;
	    self.sellingTotal = 0;
	    self.amountPayments = 0;
	    self.total = 0;
	    self.pos = 1;
	    self.snd = true;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.send = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "send" }));
	
	        self.snd = !self.snd;
	        self.update();
	    };
	
	    self.rules = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "rules" }));
	
	        var rules = {
	            items: {
	                required: true,
	                rules: [{
	                    type: 'minLength[1]',
	                    prompt: 'В списке должно быть не менее одного элемента'
	                }]
	            }
	        };
	    };
	
	    self.afterChange = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "afterChange" }));
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules(), name));
	    };
	
	    self.dynFieldsChange = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dynFieldsChange" }));
	        var type = e.item.field.type;
	
	        if (type !== 'checkbox') {
	            e.item.field.value = e.target.value;
	        } else {
	            var checkedValues = (e.item.field.value || '').split(',');
	            var checkedValue = e.target.getAttribute('data-value');
	            var idx = checkedValues.indexOf(checkedValue);
	
	            if (idx !== -1) checkedValues.splice(idx, 1);else checkedValues.push(checkedValue);
	
	            e.item.field.value = checkedValues.filter(function (i) {
	                return i;
	            }).join(',');
	        }
	    };
	
	    self.itemsCols = [{ name: 'num', value: '#' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: 'count', value: 'Кол-во' }, { name: 'priceEuro', value: 'Цена EUR' }, { name: 'price', value: 'Цена RUB' }, { name: 'discount', value: 'Скидка, %' }, { name: 'amount', value: 'Сумма' }, { name: 'markup', value: 'Кэф.' }, { name: 'sellingPrice', value: 'Цена продажи' }];
	
	    self.paymentsCols = [{ name: 'num', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'amount', value: 'Сумма' }, { name: 'commentary', value: 'Комментарий' }];
	
	    self.displayFormat = function (price) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "displayFormat" }));
	
	        if (self.currPrefix != null) return self.currPrefix + ' ' + price.toLocaleString();
	        if (self.currSuffix != null) return price.toLocaleString() + ' ' + self.currSuffix;
	    };
	
	    self.convertEuroPrice = function (item) {
	        if (!item || item.priceEuro === '' || item.priceEuro === null || typeof item.priceEuro === 'undefined') return;
	
	        var priceEuro = parseFloat(item.priceEuro);
	        if ((0, _isNan2.default)(priceEuro)) return;
	
	        API.request({
	            object: 'Currency',
	            method: 'CONVERT',
	            data: {
	                price: priceEuro,
	                source: 'EUR',
	                target: self.item.curr || self.basecurr || 'RUB',
	                rateDate: self.item.date
	            },
	            success: function success(response) {
	                if (response && typeof response.price !== 'undefined') {
	                    item.price = response.price;
	                    if (self.tags.items) self.tags.items.update();
	                    self.update();
	                }
	            }
	        });
	    };
	
	    self.convertEuroPrices = function () {
	        if (!self.item || !self.item.items) return;
	
	        self.item.items.forEach(function (item) {
	            if (item.priceEuro !== '' && item.priceEuro !== null && typeof item.priceEuro !== 'undefined') self.convertEuroPrice(item);
	        });
	    };
	
	    self.purchaseDateChange = function (e) {
	        self.item.date = e.target.value;
	        self.convertEuroPrices();
	    };
	
	    /** элементы Обработчики */
	    self.itemsHandlers = {
	        numberChange: function numberChange(e) {
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "numberChange" }));
	            this.row[this.opts.name] = e.target.value;
	            if (this.opts.name == 'priceEuro' && e.target.value > 0) {
	                this.row['price'] = (self.item.courses.eur * e.target.value).toFixed(0);
	            }
	            //if (this.opts.name == 'priceEuro')
	            //    self.convertEuroPrice(this.row)
	        },
	        stringChange: function stringChange(e) {
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "stringChange" }));
	            this.row[this.opts.name] = e.target.value;
	        },
	        addPayment: function addPayment() {
	            self.item.payments.push({ id: null, date: new Date().toISOString().split('T')[0], amount: 0, commentary: null });
	            self.update();
	        },
	        addProducts: function addProducts() {
	
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts" }));
	
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                groupLog: "addProdD", dComment: ">Добавить self.item.items",
	                dArray: self.item.items }));
	
	            var purchase = self.item;
	            modals.create('products-list-select-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	
	                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                        groupLog: "addProdD", dComment: "submit данные добавлены",
	                        dArray: self.item.items }));
	
	                    var _this = this;
	                    var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                    self.item.items = self.item.items || [];
	
	                    if (items.length > 0) {
	                        if ('countModifications' in items[0] && items[0].countModifications > 0) {
	                            (function () {
	                                var idPrice = items[0].id;
	                                var brand = items[0].nameBrand;
	                                modals.create('modifications-list-modal', {
	                                    type: 'modal-primary',
	                                    size: 'modal-lg',
	                                    id: idPrice,
	                                    submit: function submit() {
	                                        var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
	                                        items.forEach(function (item) {
	                                            self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: 0, id: null, idPrice: idPrice, modifications: item.id, nameBrand: brand, markup: self.item.defaultMarkup }));
	                                        });
	                                        self.update();
	                                        this.modalHide();
	                                        _this.modalHide();
	
	                                        //let event = document.createEvent('Event')
	                                        //event.initEvent('change', true, true)
	                                        //console.log(self.tags.items)
	                                        //self.tags.items.items.root.dispatchEvent(event)
	                                    }
	                                });
	                            })();
	                        } else {
	                            (function () {
	                                var ids = self.item.items.map(function (item) {
	                                    return item.id;
	                                });
	
	                                items.forEach(function (item) {
	                                    if (ids.indexOf(item.id) === -1) {
	
	                                        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                                            groupLog: "addProdD", dComment: "до добавления массив item",
	                                            dArray: item }));
	
	                                        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
	                                            groupLog: "addProdD", dComment: "до добавления self.item.items",
	                                            dArray: self.item.items }));
	
	                                        self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: 0, id: null, idPrice: item.id }));
	                                    }
	                                });
	
	                                self.update();
	                                _this.modalHide();
	
	                                var event = document.createEvent('Event');
	                                event.initEvent('change', true, true);
	                                self.tags.items.root.dispatchEvent(event);
	                            })();
	                        }
	                    }
	
	                    // self.convertPrices()
	                }
	            });
	        },
	        editProduct: function editProduct(e) {
	
	            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "editProduct" }));
	
	            var oldItem = (0, _assign2.default)({}, e.item.row);
	            var index = -1;
	            self.item.items.forEach(function (item, i) {
	                if (item.id === oldItem.id) index = i;
	            });
	
	            if (oldItem.idPrice) {
	
	                if (oldItem["idsModifications"]) {
	                    modals.create('modifications-list-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        id: oldItem.idPrice,
	                        submit: function submit() {
	                            var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
	                            if (items.length > 0) {
	                                self.item.items[index] = (0, _extends3.default)({}, items[0]);
	                                self.item.items[index].id = oldItem.id;
	                                self.item.items[index].count = oldItem.count;
	                                self.item.items[index].discount = oldItem.discount;
	                                self.item.items[index].idPrice = oldItem.idPrice;
	                                self.item.items[index].idsModifications = items[0].id;
	                            }
	
	                            self.update();
	                            this.modalHide();
	
	                            var event = document.createEvent('Event');
	                            event.initEvent('change', true, true);
	                            self.tags.items.root.dispatchEvent(event);
	                        }
	                    });
	                } else {
	                    var filters = {
	                        field: 'id',
	                        value: e.item.row.idPrice
	                    };
	                    modals.create('products-list-select-modal', {
	                        type: 'modal-primary',
	                        size: 'modal-lg',
	                        systemFilters: filters,
	                        submit: function submit() {
	                            var _this = this;
	                            var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                            if (items.length > 0) {
	                                self.item.items[index] = (0, _extends3.default)({}, items[0]);
	                                self.item.items[index].id = oldItem.id;
	                                self.item.items[index].count = oldItem.count;
	                                self.item.items[index].discount = oldItem.discount;
	                                self.item.items[index].idPrice = oldItem.id;
	                            }
	
	                            self.update();
	                            _this.modalHide();
	
	                            var event = document.createEvent('Event');
	                            event.initEvent('change', true, true);
	                            self.tags.items.root.dispatchEvent(event);
	                        }
	                    });
	                }
	            } else {}
	        }
	    };
	
	    self.convertPrices = function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices" }));
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
	            groupLog: "addProdD", dComment: "при конвертации self.item.items",
	            dArray: self.item.items }));
	
	        self.item.items.forEach(function (item, i) {
	            if (item.curr != self.item.curr) {
	
	                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
	                    groupLog: "addProdD", dComment: "конвертация item.price",
	                    dArray: { 'price': item.price, 'source': item.curr, 'target': self.item.curr, 'item': item } }));
	
	                var params = { 'price': item.price, 'source': item.curr, 'target': self.item.curr };
	                API.request({
	                    object: 'Currency',
	                    method: 'CONVERT',
	                    data: params,
	                    success: function success(response) {
	                        item.price = response.price;
	                        item.curr = self.item.curr;
	                        self.update();
	                    }
	                });
	            }
	        });
	    };
	
	    self.submit = function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit" }));
	
	        var params = self.item;
	        params.send = self.snd;
	
	        self.error = self.validation.validate(self.item, self.rules());
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit",
	            groupLog: "submit", dComment: "API Purchase Save", dArray: params }));
	
	        if (!self.error) {
	            API.request({
	                object: 'Purchase',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    self.isNew = false;
	
	                    self.update();
	                    if (self.isNew) riot.route('/purchases/' + self.item.id);
	                    popups.create({ title: 'Успех!', text: 'Запись сохранена!', style: 'popup-success' });
	                    if (self.tags.catalog) self.tags.catalog.reload(); // перезагрузка каталога
	                    observable.trigger('purchases-reload');
	                }
	            });
	        }
	    };
	
	    self.reloadButton = function () {
	
	        /** обновление страницы карточки контакта с всплывающим предупреждением */
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadButton" }));
	
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: 'Будут потеряны не сохраненные данные. Вы точно хотите обновить эту страницу?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Обновить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    self.reload();
	                }
	                this.modalHide();
	            }
	        });
	    };
	
	    self.reload = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
	        observable.trigger('purchase-edit', self.item.id);
	    }; // перезагрузить
	
	    self.on('update', function () {
	
	        if (self.item && self.item.payments) {
	            self.amountPayments = self.item.payments.reduce(function (p, c) {
	                return p + c.amount * 1;
	            }, 0);
	            self.amountPayments = self.displayFormat(self.amountPayments.toFixed(2));
	        }
	
	        if (self.item && self.item.items) {
	            self.sumProducts = self.item.items.map(function (i) {
	                return i.count * (i.price * (1 - i.discount / 100));
	            }).reduce(function (p, c) {
	                return p + c;
	            }, 0);
	            self.sellingTotal = self.item.items.map(function (i) {
	                return i.count * (i.price * (i.markup > 0 ? i.markup : 0) * (1 - i.discount / 100));
	            }).reduce(function (p, c) {
	                return p + c;
	            }, 0);
	            if (parseFloat(self.sumProducts) > 0) self.total = parseFloat(self.sumProducts || 0) + parseFloat(self.item.deliveryPayee || 0) - parseFloat(self.item.discount || 0);else self.total = 0;
	            self.totalDisplay = self.displayFormat(self.total.toFixed(2));
	            self.sumProductsDisplay = self.displayFormat(self.sumProducts.toFixed(0));
	            self.sellngTotalDisplay = self.displayFormat(self.sellingTotal.toFixed(0));
	        }
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	
	    observable.on('purchase-new', function () {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchase-new" }));
	
	        self.error = false;
	        self.isNew = true;
	        self.sumProducts = 0;
	        self.item = {
	            discount: 0,
	            status: '',
	            idAdmin: null
	        };
	        if (app.config.idUser && app.config.idUser != 'admin') self.item.idAdmin = app.config.idUser;
	        self.total = 0;
	        self.update();
	        self.getManagers();
	        self.getBaseCurrency();
	    });
	
	    observable.on('purchase-edit', function (id) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchases-edit" }));
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchases-edit",
	            groupLog: "purchasesEdit", dComment: "self start",
	            dArray: self }));
	
	        var params = { id: id };
	        params["curr"] = self.item.curr;
	        self.error = false;
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        self.update();
	        self.getManagers();
	
	        API.request({
	            object: 'Purchase',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchases-edit",
	                    groupLog: "purchasesEdit", dComment: "response", dArray: response }));
	                self.item = response;
	                self.loader = false;
	                self.getBaseCurrency();
	                self.update();
	                if (self.tags.catalog && self.catalogReload) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
	                self.catalogReload = true; // перезагружать каталог, только после первой прогрузки
	            }
	        });
	    });
	
	    observable.on('datacatalog', function (e) {
	
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "datacatalog" }));
	
	        /** получение транс-табличных данных
	         *  @param {object} e именаТаблиц-массивыСтрок
	         *  @return {object} observable.trigger 'datacatalog'
	         */
	
	        self.datacatalog = e;
	    });
	
	    self.getManagers = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers" }));
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers", groupLog: "getManagers", dComment: "self", dArray: self }));
	        self.managers = [];
	        API.request({
	            object: 'PermissionUser',
	            method: 'Fetch',
	            success: function success(response) {
	                self.managers = response.items;
	                self.update();
	            }
	        });
	    };
	
	    self.getBaseCurrency = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getBaseCurrency" }));
	        API.request({
	            object: 'Main',
	            method: 'Info',
	            success: function success(response) {
	                if (!self.item.curr) self.item.curr = response.basecurr;
	                self.basecurr = response.basecurr;
	                response.listCurrency.forEach(function (item) {
	                    if (item.name.toLowerCase() == self.item.curr.toLowerCase()) {
	                        self.currSuffix = item.nameFlang;
	                        self.currPrefix = item.nameFront;
	                    }
	                });
	                self.update();
	            }
	        });
	    };
	
	    self.debugParam = {
	        module: "purchase-edit.tag",
	        dClass: "ord-ed",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	         *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true,
	            addProdD: false,
	            submit: false,
	            purchasesEdit: false,
	            getManagers: false
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(12)))

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, observable) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(10);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('purchases-list', '  <catalog object="Purchase" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" add="{permission(add, &quot;purchases&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;purchases&quot;, &quot;0001&quot;)}" dblclick="{permission(purchaseOpen, &quot;purchases&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="purchases-list" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="date" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="date" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id"><a class="open-page-item" href="#purchases/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="provider" onclick="{handlers.copyText}">{row.provider}</datatable-cell>\n      <datatable-cell name="date" onclick="{handlers.copyText}">{row.date}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}">{row.amount.toFixed(2)}</datatable-cell>\n      <datatable-cell name="amountPaid" onclick="{handlers.copyText}">{row.amountPaid}</datatable-cell>\n      <datatable-cell class="{bg-success: true, bg-danger: (row.credited &lt; 100), bg-warning: (row.credited &gt; 100)}" name="credited" onclick="{handlers.copyText}">{row.credited}%</datatable-cell>\n      <datatable-cell name="stockAmount" onclick="{handlers.copyText}">{(row.amount - row.amountPaid).toFixed(2)}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Purchase';
	    self.idManager = app.config.idUser;
	    self.startDate = '';
	    self.endDate = '';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'provider', value: 'Поставщик' }, { name: 'date', value: 'Дата' }, { name: 'commentary', value: 'Примечание' }, { name: 'amount', value: 'Сумма' }, { name: 'amountPaid', value: 'Оплачен' }, { name: 'credited', value: 'Заприходован' }, { name: 'stockAmount', value: 'Остаток суммы' }];
	
	    self.handlers = {
	        copyText: function copyText(elem) {
	            //copyToClipboard(elem.target)
	        }
	    };
	
	    self.purchaseOpen = function (e) {
	        riot.route('/purchases/' + e.item.row.id);
	    };
	
	    self.getAggregation = function (response, xhr) {
	        self.totalAmount = parseFloat(response.totalAmount).toFixed(2);
	        self.currTotal = response.currTotal;
	    };
	
	    self.add = function () {
	        return riot.route('/purchases/new');
	    };
	
	    observable.on('purchases-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    self.on('mount', function () {
	        self.idManager = app.config.idUser;
	        self.update();
	    });
	
	    function copyToClipboard(elem) {
	        var target = {};
	        // create hidden text element, if it doesn't already exist
	        var targetId = "_hiddenCopyText_";
	        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	        var origSelectionStart, origSelectionEnd;
	        if (isInput) {
	            // can just use the original source element for the selection and copy
	            target.assign(elem);
	            origSelectionStart = target.selectionStart;
	            origSelectionEnd = target.selectionEnd;
	        } else {
	            // must use a temporary form element for the selection and copy
	            target = document.getElementById(targetId);
	            if (!target) {
	                var target = document.createElement("textarea");
	                target.style.position = "absolute";
	                target.style.left = "-9999px";
	                target.style.top = "0";
	                target.id = targetId;
	                document.body.appendChild(target);
	            }
	            target.textContent = target.textContent.trim();
	        }
	        // select the content
	        var currentFocus = document.activeElement;
	        target.focus();
	        target.setSelectionRange(0, target.value.length);
	
	        // copy the selection
	        var succeed;
	        try {
	            succeed = document.execCommand("copy");
	        } catch (e) {
	            succeed = false;
	        }
	        /*
	        // restore original focus
	        if (currentFocus && typeof currentFocus.focus === "function") {
	            currentFocus.focus();
	        }
	             if (isInput) {
	            // restore prior selection
	            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	        } else {
	            // clear temporary content
	            target.textContent = "";
	        }
	        */
	        return succeed;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(5)))

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(456);
	
	__webpack_require__(455);
	
	riot.tag2('purchases', '  <div class="column" if="{!notFound}">\n    <purchases-list if="{!edit}"></purchases-list>\n    <purchases-edit if="{edit}"></purchases-edit>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.edit = false;
	
	    route('/purchases', function () {
	        self.notFound = false;
	        self.edit = false;
	        self.update();
	    });
	
	    route('/purchases/new', function () {
	        observable.trigger('purchase-new');
	        self.notFound = false;
	        self.edit = true;
	        self.update();
	    });
	
	    route('/purchases/([0-9]+)', function (id) {
	        observable.trigger('purchase-edit', id);
	        self.notFound = false;
	        self.edit = true;
	        self.update();
	    });
	
	    route('/purchases..', function () {
	        self.notFound = true;
	        self.update();
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('review-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#reviews"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4"> Отзыв к товару:<b> {isNew ? \'\' : item.nameProduct}</b></div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Дата</label>\n            <datetime-picker class="form-control" name="date" format="YYYY.MM.DD HH:mm" value="{item.date}"></datetime-picker>\n          </div>\n        </div>\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Оценка</label>\n            <star-rating name="mark" count="5" size="middle" value="{item.mark}"></star-rating>\n          </div>\n        </div>\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Опыт использования</label>\n            <select class="form-control" name="useTime" value="{item.useTime}">\n              <option value="1">Менее месяца</option>\n              <option value="2">Несколько месяцев</option>\n              <option value="3">Более года</option>\n            </select>\n          </div>\n        </div>\n        <div class="col-md-3">\n          <div class="form-group">\n            <label class="control-label">Лайков</label>\n            <div class="input-group">\n              <input class="form-control" name="likes" value="{item.likes}" min="0" type="{\'number\'}"><span class="input-group-addon"><i class="fa fa-thumbs-o-up"></i></span>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-3">\n          <div class="form-group">\n            <label class="control-label">Дислайков</label>\n            <div class="input-group">\n              <input class="form-control" name="dislikes" value="{item.dislikes}" min="0" type="{\'number\'}"><span class="input-group-addon"><i class="fa fa-thumbs-o-down"></i></span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Автор отзыва</label>\n            <div class="input-group">\n              <div class="input-group-btn"><a class="btn btn-default" if="{item.idUser}" href="#persons/{item.idUser}" target="_blank"><i class="fa fa-eye"></i></a></div>\n              <input class="form-control" name="nameUser" type="text" value="{item.nameUser}" readonly>\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{changePerson}"><i class="fa fa-list text-primary"></i></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Товар</label>\n            <div class="input-group">\n              <div class="input-group-btn"><a class="btn btn-default" if="{item.idPrice}" href="#products/{item.idPrice}" target="_blank"><i class="fa fa-eye"></i></a></div>\n              <input class="form-control" name="nameProduct" type="text" value="{item.nameProduct}" readonly>\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{changeProduct}"><i class="fa fa-list text-primary"></i></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Email</label>\n            <input class="form-control" name="contactEmail" type="text" value="{item.contactEmail}">\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Достоинства</label>\n            <textarea class="form-control" rows="5" name="merits" style="min-width: 100%; max-width: 100%;" value="{item.merits}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Недостатки</label>\n            <textarea class="form-control" rows="5" name="demerits" style="min-width: 100%; max-width: 100%;" value="{item.demerits}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Отзыв</label>\n            <textarea class="form-control" rows="5" name="comment" style="min-width: 100%; max-width: 100%;" value="{item.comment}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input name="isActive" type="checkbox" value="{parseInt(item.isActive)}">Активен\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	    self.orders = [];
	
	    self.mixin('change');
	
	    self.submit = function (e) {
	        var params = self.item;
	        self.loader = true;
	
	        API.request({
	            object: 'Review',
	            method: 'Save',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                if (self.isNew) riot.route('/reviews/' + self.item.id);
	                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	                observable.trigger('reviews-reload');
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.changePerson = function () {
	        modals.create('persons-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0) {
	                    self.item.idUser = items[0].id;
	                    self.item.nameUser = items[0].displayName;
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    self.changeProduct = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length > 0) {
	                    self.item.idPrice = items[0].id;
	                    self.item.nameProduct = items[0].name;
	                    self.update();
	                    this.modalHide();
	                }
	            }
	        });
	    };
	
	    observable.on('review-edit', function (id) {
	        var params = { id: id };
	        self.loader = true;
	        self.isNew = false;
	
	        API.request({
	            object: 'Review',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('review-new', function () {
	        self.item = {};
	        self.isNew = true;
	        self.update();
	    });
	
	    self.reload = function () {
	        observable.trigger('review-edit', self.item.id);
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(10);
	
	__webpack_require__(350);
	
	riot.tag2('reviews-list', '  <catalog object="Review" cols="{cols}" reload="true" search="true" sortable="true" store="reviews-list" add="{permission(add, &quot;reviews&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;reviews&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;reviews&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id"><a class="open-page-item" href="#reviews/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="dateTime">{row.dateTimeTitle}</datatable-cell>\n      <datatable-cell name="nameProduct">{row.nameProduct}</datatable-cell>\n      <datatable-cell name="nameUser">{row.nameUser}</datatable-cell>\n      <datatable-cell name="mark">\n        <star-rating count="5" value="{row.mark}"></star-rating>\n      </datatable-cell>\n      <datatable-cell name="likes">{row.likes}</datatable-cell>\n      <datatable-cell name="dislikes">{row.dislikes}</datatable-cell>\n      <datatable-cell name="comment">{row.comment}</datatable-cell>\n      <datatable-cell name="merits">{row.merits}</datatable-cell>\n      <datatable-cell name="demerits">{row.demerits}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Review';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'dateTime', value: 'Дата' }, { name: 'nameProduct', value: 'Наименование товара' }, { name: 'nameUser', value: 'Пользователь' }, { name: 'mark', value: 'Звёзд' }, { name: 'likes', value: 'Лайков' }, { name: 'dislikes', value: 'Дислайков' }, { name: 'comment', value: 'Отзыв' }, { name: 'merits', value: 'Достоинства' }, { name: 'demerits', value: 'Недостатки' }];
	
	    self.add = function (e) {
	        return riot.route('/reviews/new');
	    };
	
	    self.open = function (e) {
	        return riot.route('/reviews/' + e.item.row.id);
	    };
	
	    observable.on('reviews-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(164);
	
	__webpack_require__(107);
	
	__webpack_require__(165);
	
	riot.tag2('section-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#sections"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;news&quot;, &quot;0100&quot;) : checkPermission(&quot;news&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Добавление содержания\' : item.name || \'Редактирование содержания\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <div class="well well-sm">\n              <image-select name="picture" alt="0" size="256" section="sections" value="{item.picture}"></image-select>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-10">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Заголовок</label>\n                <input class="form-control" name="name" type="text" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row" if="{item.type == \'url\'}">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">URL</label>\n                <input class="form-control" name="url" type="text" value="{item.url}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Тип элемента</label>\n                <select class="form-control" name="type" onchange="{menuSelect}" value="{item.type}">\n                  <option each="{type, index in itemTypes}" value="{type.code}" __selected="{type.code == item.type}" no-reorder>{type.value}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idPrice\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите товар</label>\n                <div class="input-group">\n                  <input class="form-control" name="priceName" value="{item.priceName}" data-value="{item.idPrice}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectProducts}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idGroup\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите категорию товаров</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameGroup" value="{item.nameGroup}" data-value="{item.idGroup}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectGroup}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idBrand\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите бренд товаров</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameBrand" value="{item.nameBrand}" data-value="{item.idBrand}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectBrand}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-6" if="{item.type == \'idNew\'}">\n              <div class="form-group">\n                <label class="control-label">Выберите новость</label>\n                <div class="input-group">\n                  <input class="form-control" name="nameNews" value="{item.nameNews}" data-value="{item.idNew}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{itemsHandlers.selectNews}"><i class="fa fa-list"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Текст примечания</label>\n            <ckeditor name="note" value="{item.note}"></ckeditor>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Подробный текст</label>\n            <ckeditor name="text" value="{item.text}"></ckeditor>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input type="checkbox" name="enabled" __checked="{item.enabled}">Отображать на сайте\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.isNew = false;
	
	    self.item = {};
	    self.orders = [];
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty'
	    };
	
	    self.itemTypes = [{ code: 'idPrice', value: 'Товар' }, { code: 'idGroup', value: 'Категория товара' }, { code: 'idBrand', value: 'Бренд' }, { code: 'idNew', value: 'Новость' }, { code: 'url', value: 'Ссылка' }];
	
	    self.itemsHandlers = {
	        selectProducts: function selectProducts() {
	            modals.create('products-list-select-modal', {
	                type: 'modal-primary',
	                size: 'modal-lg',
	                submit: function submit() {
	                    var _this = this;
	                    var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	                    self.item.items = self.item.items || [];
	
	                    if (items.length == 1) {
	                        self.item.idPrice = items[0].id;
	                        self.item.priceName = items[0].name;
	                        self.update();
	                    }
	                    this.modalHide();
	                    _this.modalHide();
	                }
	            });
	        },
	        selectGroup: function selectGroup() {
	            modals.create('group-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
	                    self.item.idGroup = items[0].id;
	                    self.item.nameGroup = items[0].name;
	
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        },
	        selectBrand: function selectBrand() {
	            modals.create('brands-list-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    self.item.idBrand = items[0].id;
	                    self.item.nameBrand = items[0].name;
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        },
	        selectNews: function selectNews() {
	            modals.create('news-list-select-modal', {
	                type: 'modal-primary',
	                submit: function submit() {
	                    var items = this.tags.catalog.tags.datatable.getSelectedRows();
	                    self.item.idNew = items[0].id;
	                    self.item.nameNews = items[0].title;
	                    self.update();
	                    this.modalHide();
	                }
	            });
	        }
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	
	        self.error = self.validation.validate(self.item, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'SectionItem',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
	                    self.item = response;
	                    self.update();
	                    if (self.isNew) riot.route('/sections/' + self.item.id);
	                    observable.trigger('section-reload');
	                }
	            });
	        }
	    };
	
	    self.menuSelect = function (e) {
	        var type = self.item.type = e.target.value;
	        if (type != 'idPrice') {
	            self.item.priceName = null;
	        }
	        self.itemTypes.forEach(function (elem) {
	            if (elem.code != 'url') {
	                if (elem.code != type) {
	                    self.item[elem.code] = null;
	                }
	            }
	        });
	    };
	
	    observable.on('section-new', function (id) {
	        self.error = false;
	        self.isNew = true;
	        self.item = {
	            idSection: id,
	            type: 'url'
	        };
	        self.update();
	    });
	
	    observable.on('section-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.loader = true;
	        self.item = {};
	
	        API.request({
	            object: 'SectionItem',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                if (!self.item.type) self.item.type = 'url';
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.on('update', function () {
	        localStorage.setItem('SE_section', 'sections');
	    });
	    self.reload = function () {
	        self.item.id ? observable.trigger('section-edit', self.item.id) : observable.trigger('section-new');
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('section-list-items', '  <catalog name="section-item" sortable="true" object="SectionItem" cols="{cols}" combine-filters="true" disable-limit="true" handlers="{itemsHandlers}" disable-col-select="true" store="section-list-items" add="{add}" remove="{remove}" dblclick="{objectOpen}" filters="{opts.filters}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="enabled">\n        <button class="btn btn-default btn-sm" type="button" onclick="{handlers.boolChange}" ontouchend="{handlers.boolChange}" ontouchstart="{stopPropagation}"><i class="fa {row.enabled ? &quot;fa-eye text-active&quot; : &quot;fa-eye-slash text-noactive&quot;} "></i></button>\n      </datatable-cell>\n      <datatable-cell name="imageUrlPreview"><img riot-src="{row.imageUrlPreview}" alt="" width="60"></datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="type">{handlers.types[row.type]}</datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n      <datatable-cell name="sort" style="width: 10px;">{row.sort}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.collection = 'SectionItem';
	    self.idSection = 0;
	
	    self.mixin('remove');
	
	    var route = riot.route.create();
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'enabled', value: 'Вид' }, { name: 'imageUrlPreview', value: '' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип элемента' }, { name: 'note', value: 'Примечание' }, { name: 'sort', value: 'Поряок' }];
	
	    self.itemsHandlers = {
	        types: {
	            idPrice: 'Товар',
	            idGroup: 'Категория товара',
	            idBrand: 'Бренд',
	            idNew: 'Новость',
	            url: 'Ссылка'
	        },
	        boolChange: function boolChange(e) {
	            var _this = this;
	            e.stopPropagation();
	            e.stopImmediatePropagation();
	            _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;
	            self.update();
	
	            var params = {};
	            params.id = _this.row.id;
	            params[_this.opts.name] = _this.row[_this.opts.name];
	            API.request({
	                object: 'SectionItem',
	                method: 'Save',
	                data: params,
	                error: function error(response) {
	                    rows.forEach(function (item) {
	                        item[field] = oldValues[item.id][field];
	                    });
	                    self.update();
	                }
	            });
	        }
	    };
	
	    observable.on('section-reload', function () {
	        self.tags['section-item'].reload();
	    });
	
	    self.add = function (e) {
	        if (opts.section) riot.route('/sections/new?section=' + opts.section);else popups.create({ title: 'Внимание!', text: 'Для добавления записи необходимо выбрать раздел!', style: 'popup-warning' });
	    };
	
	    self.objectOpen = function (e) {
	        return riot.route('/sections/' + e.item.row.id);
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('section-list', '  <div class="row">\n    <div class="col-md-4 col-xs-12">\n      <catalog name="section-page" object="SectionPage" cols="{pageCols}" reload="true" onclick="{pageclick}" disable-limit="true" disable-col-select="true" remove="{remove}" handlers="{handlers}" store="section-list">\n        <yield to="body">\n          <datatable-cell name="enabled">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.boolChange}" ontouchend="{handlers.boolChange}" ontouchstart="{stopPropagation}"><i class="fa {row.enabled ? &quot;fa-eye text-active&quot; : &quot;fa-eye-slash text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n          <datatable-cell name="page">{row.page}</datatable-cell>\n\n        </yield>\n      </catalog>\n    </div>\n    <div class="col-md-8 col-xs-12">\n      <section-list-items name="section-item" filters="{categoryFilters}" section="{idSection}"></section-list-items>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.collection = 'SectionPage';
	    self.idSection = 0;
	    self.categoryFilters = [{ field: 'idSection', sign: 'IN', value: self.idSection }];
	
	    self.mixin('remove');
	
	    var route = riot.route.create();
	
	    self.handlers = {
	        checkPermission: self.checkPermission,
	        permission: self.permission,
	        boolChange: function boolChange(e) {
	            var _this = this;
	            e.stopPropagation();
	            e.stopImmediatePropagation();
	            _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;
	            self.update();
	
	            var params = {};
	            params.id = _this.row.id;
	            params[_this.opts.name] = _this.row[_this.opts.name];
	            API.request({
	                object: 'SectionPage',
	                method: 'Save',
	                data: params,
	                error: function error(response) {
	                    rows.forEach(function (item) {
	                        item[field] = oldValues[item.id][field];
	                    });
	                    self.update();
	                }
	            });
	        }
	    };
	
	    self.pageCols = [{ name: 'enabled', value: 'Вид' }, { name: 'code', value: 'Код' }, { name: 'title', value: 'Наименование' }, { name: 'page', value: 'Страница' }];
	
	    self.one('updated', function () {});
	
	    self.pageclick = function (e) {
	        var rows = self.tags['section-page'].tags.datatable.getSelectedRows();
	        self.idSection = rows[0].idSection;
	        self.categoryFilters = [{ field: 'idSection', sign: 'IN', value: self.idSection }];
	        self.update();
	        observable.trigger('section-reload');
	    };
	
	    self.on('mount', function () {});
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(462);
	
	__webpack_require__(461);
	
	__webpack_require__(460);
	
	riot.tag2('sections', '  <section-list if="{!edit}"></section-list>\n  <section-edit if="{edit}"></section-edit>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.edit = false;
	
	    var route = riot.route.create();
	
	    route('/sections/([0-9]+)', function (id) {
	        observable.trigger('section-edit', id);
	        self.edit = true;
	        self.update();
	    });
	
	    route('/sections', function () {
	        self.edit = false;
	        self.update();
	    });
	
	    route('/sections/new..', function () {
	        var q = riot.route.query();
	        var sect = q.section;
	        self.edit = true;
	        observable.trigger('section-new', sect);
	        self.update();
	    });
	
	    route('/sections/new', function () {
	        riot.route('/sections');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault(_parallel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('add-fields-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Карточка элемента</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Код</label>\n          <input class="form-control" name="code" value="{item.code}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Группа</label>\n          <select class="form-control" name="idGroup" value="{item.idGroup}">\n            <option value="">Без группы</option>\n            <option each="{group in groups}" __selected="{item.idGroup == group.id}" value="{group.id}">{group.name}</option>\n          </select>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Тип элемента</label>\n          <select class="form-control" name="type" value="{item.type}">\n            <option value="string">Строка</option>\n            <option value="number">Число</option>\n            <option value="text">Текст</option>\n            <option value="select">Список</option>\n            <option value="checkbox">Флажок</option>\n            <option value="radio">Переключатель</option>\n            <option value="date">Дата</option>\n          </select>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Подсказка</label>\n          <input class="form-control" name="placeholder" value="{item.placeholder}">\n        </div>\n        <div class="form-group" if="{~[&quot;select&quot;, &quot;checkbox&quot;, &quot;radio&quot;].indexOf(item.type)}">\n          <label class="control-label">Значения</label>\n          <input class="form-control" name="values" value="{item.values}" placeholder="Возможные значения (через запятую)">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Описание</label>\n          <textarea class="form-control" name="description" value="{item.description}" style="resize: none;"></textarea>\n        </div>\n        <div class="form-group">\n          <div class="checkbox-inline">\n            <label>\n              <input name="enabled" type="checkbox" __checked="{parseInt(item.enabled)}" data-bool="1,0">Активный\n            </label>\n          </div>\n          <div class="checkbox-inline">\n            <label>\n              <input name="required" type="checkbox" __checked="{parseInt(item.required)}" data-bool="1,0">Обязательный\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        var filters = [];
	
	        if (opts.data) filters.push({
	            field: 'data',
	            value: opts.data
	        });
	
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.item = {
	            idGroup: '',
	            type: 'string',
	            enabled: 1
	        };
	
	        modal.rules = {
	            name: 'empty',
	            code: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        modal.loader = true;
	
	        if (opts.id) {
	            (0, _parallel2.default)([function (callback) {
	                API.request({
	                    object: 'CustomField',
	                    method: 'Info',
	                    data: { id: opts.id },
	                    success: function success(response) {
	                        modal.item = response;
	                        callback(null, 'AddFieldOrder');
	                    },
	                    error: function error() {
	                        callback('error', null);
	                    }
	                });
	            }, function (callback) {
	                API.request({
	                    object: 'CustomFieldGroup',
	                    method: 'Fetch',
	                    data: { filters: filters },
	                    success: function success(response) {
	                        modal.groups = response.items;
	                        callback(null, 'AddFieldOrderGroup');
	                    },
	                    error: function error() {
	                        callback('error', null);
	                    }
	                });
	            }], function (err, res) {
	                modal.loader = false;
	                modal.update();
	            });
	        } else {
	            API.request({
	                object: 'CustomFieldGroup',
	                method: 'Fetch',
	                data: { filters: filters },
	                success: function success(response) {
	                    modal.groups = response.items;
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('add-fields-group-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категория поля</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Описание</label>\n          <textarea class="form-control" name="description" value="{item.description}" style="resize: none;"></textarea>\n        </div>\n        <div class="form-group">\n          <div class="checkbox-inline">\n            <label>\n              <input name="enabled" type="checkbox" __checked="{parseInt(item.enabled)}" data-bool="1,0">Активный\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.mixin('validation');
	        modal.mixin('change');
	        modal.item = {
	            enabled: 1
	        };
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	
	        if (opts.id) {
	            modal.loader = true;
	
	            API.request({
	                object: 'CustomFieldGroup',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(465);
	
	riot.tag2('add-fields-groups', '  <catalog object="CustomFieldGroup" cols="{cols}" filters="{filters}" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}" reload="true" disable-limit="true" disable-col-select="true" disable-pagination="true">\n    <yield to="body">\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'CustomFieldGroup';
	
	    self.filters = [{
	        field: 'data',
	        value: opts.type
	    }];
	
	    self.addEdit = function (e) {
	        var id = void 0;
	
	        if (e.item && e.item.row) id = e.item.row.id;
	
	        modals.create('add-fields-group-edit-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	                var item = _this.item;
	
	                if (opts.type) item = (0, _extends3.default)({}, this.item, { data: opts.type });
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'CustomFieldGroup',
	                        method: 'Save',
	                        data: item,
	                        success: function success(response) {
	                            popups.create({
	                                title: 'Успех!',
	                                text: 'Дополнительное поле сохранено!',
	                                style: 'popup-success'
	                            });
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.cols = [{ name: 'name', value: 'Наименование' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('add-fields-list', '  <div class="row">\n    <div class="col-md-3">\n      <add-fields-groups type="{opts.type}"></add-fields-groups>\n    </div>\n    <div class="col-md-9">\n      <catalog object="CustomField" cols="{cols}" reload="true" handlers="{handlers}" filters="{filters}" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="enabled"><i class="fa {row.enabled == 1 ? &quot;fa-check-circle-o&quot; : &quot;fa-circle-o  text-muted&quot;} "></i></datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="type">{handlers.types[row.type]}</datatable-cell>\n          <datatable-cell name="required">{row.required == 0 ? \'Нет\' : \'Да\'}</datatable-cell>\n          <datatable-cell name="placeholder">{row.placeholder}</datatable-cell>\n          <datatable-cell name="description">{row.description}</datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'CustomField';
	
	    self.filter = [{
	        field: 'data',
	        value: opts.type }];
	
	    self.filters = [].concat(self.filter);
	
	    self.addEdit = function (e) {
	        var id = void 0;
	
	        if (e.item && e.item.row) id = e.item.row.id;
	
	        modals.create('add-fields-edit-modal', {
	            type: 'modal-primary',
	            id: id,
	            data: opts.type,
	            submit: function submit() {
	                var _this = this;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	                var item = _this.item;
	
	                if (opts.type) item = (0, _extends3.default)({}, this.item, { data: opts.type });
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'CustomField',
	                        method: 'Save',
	                        data: item,
	                        success: function success(response) {
	                            popups.create({
	                                title: 'Успех!',
	                                text: 'Дополнительное поле сохранено!',
	                                style: 'popup-success'
	                            });
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'enabled', value: 'Активно' }, { name: 'code', value: 'Код' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип переменной' }, { name: 'required', value: 'Обязательное' }, { name: 'placeholder', value: 'Подсказка' }, { name: 'description', value: 'Описание' }];
	
	    self.handlers = {
	        types: {
	            string: 'Строка',
	            number: 'Число',
	            text: 'Текст',
	            select: 'Список',
	            checkbox: 'Флажок',
	            radio: 'Переключатель',
	            date: 'Дата'
	        }
	    };
	
	    self.one('updated', function () {
	        var datatable = self.tags['add-fields-groups'].tags['catalog'].tags.datatable;
	        datatable.on('row-selected', function (count, row) {
	            var items = datatable.getSelectedRows();
	
	            if (items.length > 0) {
	                var value = items.map(function (i) {
	                    return i.id;
	                }).join(',');
	                self.filters = [{ field: 'idGroup', sign: 'IN', value: value }].concat(self.filter);
	            } else {
	                self.filters = [].concat(self.filter);
	            }
	
	            self.update();
	            self.tags.catalog.reload();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(464);
	
	__webpack_require__(466);
	
	__webpack_require__(467);
	
	riot.tag2('add-fields', '  <h4>Поля</h4>\n  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#add-fields-orders">Заказы</a></li>\n    <li><a data-toggle="tab" href="#add-fields-contacts">Контакты</a></li>\n    <li><a data-toggle="tab" href="#add-fields-company">Компании</a></li>\n    <li><a data-toggle="tab" href="#add-fields-product">Продукт</a></li>\n    <li><a data-toggle="tab" href="#add-fields-productgroup">Категории</a></li>\n    <li><a data-toggle="tab" href="#add-fields-public">Публикации</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="add-fields-orders">\n      <add-fields-list type="{&quot;order&quot;}"></add-fields-list>\n    </div>\n    <div class="tab-pane fade" id="add-fields-contacts">\n      <add-fields-list type="{&quot;contact&quot;}"></add-fields-list>\n    </div>\n    <div class="tab-pane fade" id="add-fields-company">\n      <add-fields-list type="{&quot;company&quot;}"></add-fields-list>\n    </div>\n    <div class="tab-pane fade" id="add-fields-product">\n      <add-fields-list type="{&quot;product&quot;}"></add-fields-list>\n    </div>\n    <div class="tab-pane fade" id="add-fields-productgroup">\n      <add-fields-list type="{&quot;productgroup&quot;}"></add-fields-list>\n    </div>\n    <div class="tab-pane fade" id="add-fields-public">\n      <add-fields-list type="{&quot;public&quot;}"></add-fields-list>\n    </div>\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(470);
	
	riot.tag2('currencies', '  <catalog object="Currency" cols="{cols}" add="{permission(add, &quot;currencies&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;currencies&quot;, &quot;0001&quot;)}" dblclick="{permission(currencyEdit, &quot;currencies&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="title">{row.title}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="dateReplace">{row.dateReplace}</datatable-cell>\n      <datatable-cell name="rate">{row.rate}</datatable-cell>\n      <datatable-cell name="rateDisplay">{row.rateDisplay}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'Currency';
	
	    self.cols = [{ name: 'title', value: 'Наименование' }, { name: 'name', value: 'Код' }, { name: 'rateDate', value: 'Дата' }, { name: 'rate', value: 'Курс' }, { name: 'rateDisplay', value: 'Текст' }];
	
	    self.add = function () {
	        modals.create('currency-new-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'Currency',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            popups.create({ title: 'Успех!', text: 'Валюта добавлена!', style: 'popup-success' });
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.currencyEdit = function (e) {
	        modals.create('currency-new-modal', {
	            item: e.item.row,
	            type: 'modal-primary',
	            title: 'Редактор валюты',
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	
	                API.request({
	                    object: 'Currency',
	                    method: 'Save',
	                    data: params,
	                    success: function success(response) {
	                        popups.create({ title: 'Успех!', text: 'Валюта изменена!', style: 'popup-success' });
	                        _this.modalHide();
	                        self.tags.catalog.reload();
	                    }
	                });
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('currency-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Добавить новую валюту\'}</div>\n    </yield>\n    <yield to="body">\n      <form name="form" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Обозначение*</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Предустановки</label>\n              <select class="form-control" value="{item.name}" onchange="{currencyChange}">\n                <option value=""></option>\n                <option each="{currencies}" value="{charCode}">{name}</option>\n              </select>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group {has-error: error.title}">\n              <label class="control-label">Название*</label>\n              <input class="form-control" name="title" value="{item.title}">\n              <div class="help-block">{error.title}</div>\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Пред. текст</label>\n              <input class="form-control" name="nameFront" value="{item.nameFront}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Заверш. текст</label>\n              <input class="form-control" name="nameFlang" value="{item.nameFlang}">\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Код по ЦБРФ</label>\n              <input class="form-control" name="cbrKod" value="{item.cbrKod}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Мин. сумма</label>\n              <input class="form-control" name="minSum" min="0.01" step="0.01" value="{item.minSum}" type="{\'number\'}">\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.mixin('validation');
	        modal.mixin('change');
	        modal.item = opts.item || { minSum: 0.01 };
	        modal.error = false;
	
	        modal.rules = {
	            name: 'empty',
	            title: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	        };
	
	        modal.currencyChange = function (e) {
	            var value = e.target.value;
	            var item = modal.currencies.filter(function (item) {
	                return item.charCode == value;
	            });
	
	            if (item.length) {
	                modal.item.cbrKod = item[0].id;
	                modal.item.name = item[0].charCode;
	                modal.item.title = item[0].name;
	            }
	
	            modal.error = modal.validation.validate(modal.item, modal.rules);
	        };
	
	        API.request({
	            object: 'EnumValutes',
	            method: 'Fetch',
	            success: function success(response) {
	                modal.currencies = response.items;
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('email-settings', '  <loader if="{loader}"></loader>\n  <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group">\n          <div class="btn-group">\n            <button class="btn btn-default" type="button" onclick="{save}"><i class="fa fa-save"></i> Сохранить</button>\n            <button class="btn btn-default" type="button" onclick="{reload}"><i class="fa fa-refresh"></i></button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group">\n          <label class="control-label">Провайдер</label>\n          <div class="input-group">\n            <select class="form-control" name="id" value="{item.id}">\n              <option each="{p, i in providers}" __selected="{p.id == item.id}" value="{p.id}" no-reorder>{p.name}</option>\n            </select>\n            <div class="input-group-btn" if="{link}"><a class="btn btn-default" target="_blank" href="{link}" title="Перейти на сайт"><i class="fa fa-link"></i></a></div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <virtual each="{settings}">\n          <div class="form-group" if="{name == &quot;password&quot;}">\n            <label class="control-label">{name}</label>\n            <input class="form-control" name="{name}" value="{parent.item[name]}" type="password">\n          </div>\n          <div class="form-group" if="{type == &quot;string&quot; &amp;&amp; name != &quot;password&quot;}">\n            <label class="control-label">{name}</label>\n            <input class="form-control" name="{name}" value="{parent.item[name]}" type="text">\n          </div>\n        </virtual>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group" if="{balance !== undefined}">\n          <label class="control-label">Баланс</label>\n          <p class="form-control-static">{balance || 0}</p>\n        </div>\n      </div>\n    </div>\n  </form>\n', 'email-settings,[riot-tag="email-settings"],[data-is="email-settings"]{ display: block; position: relative; }', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.loader = false;
	    self.item = {};
	    self.mixin('change');
	    self.link = '';
	
	    self.providers = [];
	    self.settings = [];
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        var value = e.target.value;
	
	        if (name === 'id') {
	            self.settings = [];
	            var active = self.providers.filter(function (item) {
	                return item.id == self.item.id;
	            });
	
	            if (active.length) {
	                self.link = /http(s)*:\/\//.test(active[0].url) ? active[0].url : 'http://' + active[0].url;
	                self.item = { id: value };
	                self.balance = undefined;
	
	                API.request({
	                    object: 'EmailProvider',
	                    method: 'info',
	                    data: { id: value },
	                    success: function success(response) {
	                        self.balance = response.balance;
	                        self.update();
	                    }
	                });
	
	                try {
	                    var settings = JSON.parse(active[0].settings);
	                    for (var param in settings) {
	                        var item = (0, _extends3.default)({ name: param }, settings[param]);
	                        self.settings.push(item);
	                        self.item[param] = settings[param].value || '';
	                    }
	                } catch (e) {
	                    self.settings = [];
	                }
	            }
	        }
	    };
	
	    self.save = function () {
	        var params = {
	            id: self.item.id,
	            settings: '',
	            isActive: '1'
	        };
	
	        var active = self.providers.filter(function (item) {
	            return item.id == self.item.id;
	        })[0];
	        var activeSettings = JSON.parse(active.settings);
	        var settings = {};
	
	        for (var param in self.item) {
	            if (param !== 'id') {
	                settings[param] = (0, _extends3.default)({}, activeSettings[param], { value: self.item[param] });
	            }
	        }
	
	        params.settings = (0, _stringify2.default)(settings);
	
	        API.request({
	            object: 'EmailProvider',
	            method: 'Save',
	            data: params,
	            success: function success(response) {
	                popups.create({ title: 'Успех!', text: 'Сохраненно!', style: 'popup-success' });
	            }
	        });
	    };
	
	    self.reload = function () {
	        self.settings = [];
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'EmailProvider',
	            method: 'Fetch',
	            success: function success(response) {
	                self.providers = response.items;
	                var active = self.providers.filter(function (item) {
	                    return item.isActive == 1;
	                });
	                self.balance = undefined;
	                self.update();
	
	                if (active.length) {
	                    self.link = /http(s)*:\/\//.test(active[0].url) ? active[0].url : 'http://' + active[0].url;
	                    API.request({
	                        object: 'EmailProvider',
	                        method: 'info',
	                        data: { id: active[0].id },
	                        success: function success(response) {
	                            self.balance = response.balance;
	                            self.update();
	                        }
	                    });
	
	                    self.item = { id: active[0].id };
	
	                    try {
	                        var settings = JSON.parse(active[0].settings);
	                        for (var param in settings) {
	                            var item = (0, _extends3.default)({ name: param }, settings[param]);
	                            self.settings.push(item);
	                            self.item[param] = settings[param].value || '';
	                        }
	                    } catch (e) {
	                        self.settings = [];
	                    }
	                }
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.on('mount', function () {
	        self.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	__webpack_require__(475);
	
	riot.tag2('email-template-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/email"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;mails&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование шаблона письма\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="form-group {has-error: error.title}">\n        <label class="control-label">Заголовок</label>\n        <input class="form-control" name="title" type="text" value="{item.title}">\n        <div class="help-block">{error.title}</div>\n      </div>\n      <div class="form-group {has-error: error.subject}">\n        <label class="control-label">Тема письма</label>\n        <input class="form-control" name="subject" type="text" value="{item.subject}">\n        <div class="help-block">{error.subject}</div>\n      </div>\n      <div class="form-group {has-error: error.mailtype}">\n        <label class="control-label">Код письма</label>\n        <input class="form-control" name="mailtype" type="text" value="{item.mailtype}">\n        <div class="help-block">{error.mailtype}</div>\n      </div>\n      <div class="form-group">\n        <label class="control-label">Тело шаблона</label>\n        <textarea class="form-control" name="letter" value="{item.letter}" rows="20"></textarea>\n\n      </div>\n      <div class="form-group">\n        <div class="checkbox-inline">\n          <label>\n            <input type="checkbox" name="isActive" __checked="{item.isActive}">Отправлять шаблон\n          </label>\n        </div>\n      </div>\n      <div class="form-group">\n        <label class="control-label">Вид письма</label>\n        <showhtml value="{item.letter}"></showhtml>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.loader = false;
	    self.item = {};
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.rules = {
	        title: 'empty',
	        subject: 'empty',
	        mailtype: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.reload = function () {
	        observable.trigger('email-edit', self.item.id);
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        self.error = self.validation.validate(params, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'EmailTemplate',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    popups.create({ title: 'Успех!', text: 'Шаблон сохранен!', style: 'popup-success' });
	                    self.item = response;
	                    self.update();
	                    if (self.isNew) riot.route('/settings/email/' + self.item.id);
	                    observable.trigger('email-reload');
	                }
	            });
	        }
	    };
	
	    observable.on('email-edit', function (id) {
	        var params = { id: id };
	        self.error = false;
	        self.isNew = false;
	        self.item = {};
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'EmailTemplate',
	            method: 'Info',
	            data: params,
	            success: function success(response, xhr) {
	                self.item = response;
	                self.loader = false;
	                self.update();
	            },
	            error: function error(response) {
	                self.item = {};
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('email-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = {};
	        self.update();
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	riot.tag2('email-templates', '  <catalog object="EmailTemplate" cols="{cols}" reload="true" handlers="{handlers}" add="{permission(add, &quot;mails&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;mails&quot;, &quot;0001&quot;)}" dblclick="{permission(letterOpen, &quot;mails&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="title"><i class="fa {row.isActive ? &quot;fa-paper-plane&quot; : &quot;fa-paper-plane text-noactive&quot;}"></i> {row.title}</datatable-cell>\n      <datatable-cell name="mailtype">{row.mailtype}</datatable-cell>\n      <datatable-cell name="subject">{row.subject}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	
	    self.collection = 'EmailTemplate';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }, { name: 'itempost', value: 'Код' }, { name: 'subject', value: 'Тема' }];
	
	    self.add = function () {
	        return riot.route('settings/email/new');
	    };
	
	    self.letterOpen = function (e) {
	        return riot.route('settings/email/' + e.item.row.id);
	    };
	
	    observable.on('email-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(471);
	
	__webpack_require__(473);
	
	riot.tag2('email', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#email-templates">Шаблоны</a></li>\n    <li><a data-toggle="tab" href="#email-settings">Настройки</a></li>\n\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="email-templates">\n      <email-templates></email-templates>\n    </div>\n    <div class="tab-pane fade" id="email-settings">\n      <email-settings></email-settings>\n    </div>\n\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('showhtml', '', '', 'style="width: 100%;"', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.root.innerHTML = opts.value;
	    self.on('update', function () {
	        self.unmount(true);
	        self.mount();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(37);
	
	riot.tag2('geotargeting-addpage-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить базовую страницу</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}" if="{!item.id}">\n          <label class="control-label"> URL страницы</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = opts.item || {};
	        modal.error = false;
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	        //modal.update()
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	var _parallel = __webpack_require__(26);
	
	var _parallel2 = _interopRequireDefault2(_parallel);
	
	__webpack_require__(162);
	
	__webpack_require__(479);
	
	__webpack_require__(476);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('geotargeting-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/geotargeting"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Добавление контакта\' : item.name || \'Редактирование контакта\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Наименование</label>\n            <input class="form-control" name="name" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.city}">\n            <label class="control-label">Город привязки</label>\n            <div class="input-group">\n              <input class="form-control" value="{item.city}" __readonly="{true}">\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{selectCity}"><i class="fa fa-list text-primary"></i></div>\n                <div class="btn btn-default" onclick="{removeCity}"><i class="fa fa-times text-danger"></i></div>\n              </div>\n            </div>\n            <div class="help-block">{error.city}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.address}">\n            <label class="control-label">Адрес</label>\n            <input class="form-control" name="address" value="{item.address}">\n            <div class="help-block">{error.address}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.phone}">\n            <label class="control-label">Телефон</label>\n            <input class="form-control" name="phone" value="{item.phone}">\n            <div class="help-block">{error.phone}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.additionalPhones}">\n            <label class="control-label">Доп. телефоны</label>\n            <input class="form-control" name="additionalPhones" value="{item.additionalPhones}">\n            <div class="help-block">{error.additionalPhones}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.url}">\n            <label class="control-label">URL домена</label>\n            <input class="form-control" name="url" value="{item.url}">\n            <div class="help-block">{error.url}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Примечание</label>\n            <textarea class="form-control" name="description" rows="5" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <catalog-static name="variables" rows="{item.variables}" cols="{variablesCols}" handlers="{variablesHandlers}">\n              <yield to="toolbar"><a class="control-label" href="#settings/seo-variables">SEO переменные</a></yield>\n              <yield to="body">\n                <datatable-cell name="id" style="width: 1%;">{row.id}</datatable-cell>\n                <datatable-cell name="name" style="width: 15%;">{row.name}</datatable-cell>\n                <datatable-cell name="value">\n                  <input class="form-control" value="{row.value}" type="text" oninput="{handlers.changeValue}">\n                </datatable-cell>\n                <datatable-cell name="edit" style="width: 1%;">\n                  <button class="btn btn-default" onclick="{handlers.editVars}" title="Редактор"><i class="fa fa-edit"></i></button>\n                </datatable-cell>\n              </yield>\n            </catalog-static>\n          </div>\n        </div>\n      </div>\n      <div class="row" if="{isPages}">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Список страниц для переопределения<br><br>\n              <button class="btn btn-primary" onclick="{addpage}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n              <button class="btn btn-danger" onclick="{removepage}" title="Удалить" type="button"><i class="fa fa-trash"></i></button>\n            </label>\n            <datatable name="pages" rows="{item.pages}" cols="{pagesCols}" handlers="{pagesHandlers}">\n              <datatable-cell name="page" style="width: 33%;">{row.page}</datatable-cell>\n              <datatable-cell name="altpage" style="width: 33%;">\n                <input class="form-control" value="{row.altpage}" type="text" oninput="{handlers.changeAltPage}">\n              </datatable-cell>\n              <datatable-cell name="skin">\n                <input class="form-control" value="{row.skin}" type="text" oninput="{handlers.changeSkin}">\n              </datatable-cell>\n            </datatable>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Порядок</label>\n            <input class="form-control" name="sort" min="0" step="1" value="{item.sort}" type="{\'number\'}">\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input name="isVisible" type="checkbox" __checked="{item.isVisible}">Отображать контакт в магазине\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.mixin('validation');
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.mixin('change');
	    self.item = {};
	    self.isPages = false;
	    self.removepage = 0;
	    self.pagesCount = 0;
	
	    self.variablesCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'value', value: 'Значение' }, { name: '', value: '' }];
	    self.pagesCols = [{ name: 'page', value: 'Страница сайта' }, { name: 'altpage', value: 'Новая страница' }, { name: 'skin', value: 'Дизайн' }];
	
	    self.variablesHandlers = {
	        changeValue: function changeValue(e) {
	            this.row.value = e.target.value;
	        },
	        editVars: function editVars(e) {
	            var _this = this;
	            //this.row.value = e.target.value
	            modals.create('geotargeting-vars-modal', {
	                type: 'modal-primary',
	                item: this.row,
	                submit: function submit() {
	                    this.row = this.item;
	                    this.modalHide();
	                    self.update();
	                }
	            });
	        }
	    };
	
	    self.pagesHandlers = {
	        changeAltPage: function changeAltPage(e) {
	            this.row.altpage = e.target.value;
	        },
	        changeSkin: function changeSkin(e) {
	            this.row.skin = e.target.value;
	        }
	    };
	
	    self.isPageName = function (name) {
	        for (var i = 0; i < self.item.pages.length; i++) {
	            if (self.item.pages[i]['page'] === name) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    self.addpage = function () {
	        modals.create('geotargeting-addpage-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                if (self.isPageName(this.item.name) == false) {
	                    self.item.pages.push({ page: this.item.name, altpage: '', skin: '' });
	                    this.modalHide();
	                    self.update();
	                }
	            }
	        });
	    };
	
	    observable.on('geotargeting-edit', function (id) {
	        self.error = false;
	        self.loader = true;
	        self.isNew = false;
	        self.item = {};
	        self.update();
	
	        API.request({
	            object: 'GeoTargeting',
	            method: 'Info',
	            data: { id: id },
	            success: function success(response) {
	                self.item = response;
	                self.isPages = typeof self.item.pages != 'undefined' && self.item.pages != null;
	            },
	            error: function error() {
	                self.item = {};
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.submit = function () {
	        var params = self.item;
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'GeoTargeting',
	            method: 'Save',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	                popups.create({ title: 'Успех!', text: 'Контакт геотаргетинга сохранен!', style: 'popup-success' });
	                observable.trigger('geotargeting-reload');
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.rules = {
	        name: 'empty',
	        phone: {
	            required: true,
	            rules: [{
	                type: 'phone'
	            }]
	        },
	        additionalPhones: {
	            required: true,
	            rules: [{
	                type: 'phone'
	            }]
	        },
	        url: {
	            rules: [{
	                type: 'url'
	            }]
	        },
	        text: 'empty'
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    observable.on('geotargeting-new', function () {
	        self.error = false;
	        self.isNew = true;
	        self.item = { sort: 0, isVisible: true };
	        self.update();
	    });
	
	    self.selectCity = function () {
	        modals.create('delivery-regions', {
	            type: 'modal-primary',
	            item: { idCityTo: self.item.idCity },
	            submit: function submit() {
	                if (this.tags.idCityTo.value) {
	                    self.item.idCity = this.tags.idCityTo.value;
	                    self.item.city = this.tags.idCityTo.filterValue;
	                }
	                this.modalHide();
	                self.update();
	            }
	        });
	    };
	
	    self.removeCity = function () {
	        self.item.idCity = null;
	        self.item.city = null;
	        self.update();
	    };
	
	    self.reload = function () {
	        observable.trigger('geotargeting-edit', self.item.id);
	    };
	
	    self.removepage = function () {
	        self.item.pages = self.tags.pages.getUnselectedRows();
	        self.update();
	    };
	
	    self.on('updated', function () {
	        self.tags.pages.on('row-selected', function (count) {
	            self.pagesCount = count;
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('geotargeting-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Список городов</div>\n    </yield>\n    <yield to="body">\n      <catalog name="geotargeting" object="GeoTargeting" cols="{geoCols}" search="true" reload="false" disable-col-select="1" dblclick="{parent.opts.submit}" handlers="{handlers}">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="name" onclick="{handlers.select}">{row.name}</datatable-cell>\n        <datatable-cell name="url" onclick="{handlers.select}">{row.url}</datatable-cell>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.tab = 'contacts';
	
	        modal.tabClick = function (e) {
	            modal.tab = e.item.name;
	        };
	
	        modal.handlers = {};
	
	        modal.geoCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Город' }, { name: 'url', value: 'Домен' }];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('geotargeting-vars-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Изменить макропеременную</div>\n    </yield>\n    <yield to="body">\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label"> Значение</label>\n          <textarea class="form-control" name="value" value="{item.value}" style="min-height: 200px;"></textarea>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	        modal.mixin('change');
	        modal.item = opts.item || {};
	        self.update();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	riot.tag2('geotargeting', '  <catalog object="GeoTargeting" cols="{cols}" reload="true" reorder="true" add="{add}" remove="{remove}" dblclick="{edit}" disable-col-select="true" limit="1000">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="address">{row.address}</datatable-cell>\n      <datatable-cell name="city">{row.city}</datatable-cell>\n      <datatable-cell name="phone">{row.phone}</datatable-cell>\n      <datatable-cell name="additionalPhones">{row.additionalPhones}</datatable-cell>\n      <datatable-cell name="url">{row.url}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'GeoTargeting';
	    self.handlers = {};
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'address', value: 'Адрес' }, { name: 'city', value: 'Город' }, { name: 'phone', value: 'Телефон' }, { name: 'additionalPhones', value: 'Доп. телефоны' }, { name: 'url', value: 'Домен' }];
	
	    self.add = function () {
	        return riot.route('/settings/geotargeting/new');
	    };
	
	    self.edit = function (e) {
	        return riot.route('settings/geotargeting/' + e.item.row.id);
	    };
	
	    observable.on('geotargeting-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'GeoTargeting',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	            self.update();
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	riot.tag2('measure-edit', '  <loader if="{loader}">\n    <virtual hide="{loader}">\n      <div class="btn-group"><a class="btn btn-default" href="#measurements"><i class="fa fa-chevron-left"></i></a>\n        <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;paysystems&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n        <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n      </div>\n      <div class="h4">{isNew ? item.namePayment || \'Добавление платежной системы\' : item.namePayment || \'Редактирование платежной системы\'}</div>\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="form-group {has-error: error.namePayment}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="namePayment" type="text" value="{item.namePayment}">\n          <div class="help-block">{error.namePayment}</div>\n        </div>\n      </form>\n    </virtual>\n  </loader>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    observable.on('measure-edit', function (id, section) {
	        console.log("ok");
	
	        self.error = false;
	        self.loader = true;
	        self.isNew = false;
	        self.item = {};
	        self.update();
	
	        API.request({
	            object: 'PaySystem',
	            method: 'Info',
	            data: { id: id },
	            success: function success(response) {
	                self.item = response;
	                observable.trigger('pay-systems-reload');
	            },
	            error: function error(response) {
	                self.item = {};
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	riot.tag2('measure-volume', '  <catalog object="MeasureVolume" cols="{cols}" reload="true" add="{add}" remove="{remove}" dblclick="{measureOpen}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="designation">{row.designation}</datatable-cell>\n      <datatable-cell name="precision">{row.precision}</datatable-cell>\n      <datatable-cell name="value">{row.value}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'MeasureVolume';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код ОКЕИ' }, { name: 'name', value: 'Наименование' }, { name: 'designation', value: 'Обозначение' }, { name: 'precision', value: 'Точность' }, { name: 'value', value: 'Мера' }];
	
	    observable.on('measurement-reload', function () {
	        self.tags.catalog.reload();
	    });
	
	    self.measureOpen = function (e) {
	        riot.route('/settings/measurement/volume/' + e.item.row.id);
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	riot.tag2('measure-weight', '  <catalog object="MeasureWeight" cols="{cols}" reload="true" add="{add}" remove="{remove}" dblclick="{measureOpen}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="designation">{row.designation}</datatable-cell>\n      <datatable-cell name="precision">{row.precision}</datatable-cell>\n      <datatable-cell name="value">{row.value}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	     'use strict';
	
	     var self = this;
	
	     self.mixin('permissions');
	     self.mixin('remove');
	     self.collection = 'MeasureWeight';
	
	     self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код ОКЕИ' }, { name: 'name', value: 'Наименование' }, { name: 'designation', value: 'Обозначение' }, { name: 'precision', value: 'Точность' }, { name: 'value', value: 'Мера' }];
	
	     observable.on('measurement-reload', function () {
	          self.tags.catalog.reload();
	     });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(483);
	
	__webpack_require__(482);
	
	riot.tag2('measurements', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#measure-weight">Меры веса</a></li>\n    <li><a data-toggle="tab" href="#measure-volume">Меры объема</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="measure-weight">\n      <measure-weight></measure-weight>\n    </div>\n    <div class="tab-pane fade" id="measure-volume">\n      <measure-volume></measure-volume>\n    </div>\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable, API) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(33);
	
	__webpack_require__(81);
	
	__webpack_require__(486);
	
	riot.tag2('pay-system-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/pay-systems"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;paysystems&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.namePayment || \'Добавление платежной системы\' : item.namePayment || \'Редактирование платежной системы\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="form-group {has-error: error.namePayment}">\n        <label class="control-label">Наименование</label>\n        <input class="form-control" name="namePayment" type="text" value="{item.namePayment}">\n        <div class="help-block">{error.namePayment}</div>\n      </div>\n      <ul class="nav nav-tabs m-b-2">\n        <li class="active"><a data-toggle="tab" href="#pay-system-edit-settings">Настройки</a></li>\n        <li><a data-toggle="tab" href="#pay-system-edit-main-info">Страница пояснений</a></li>\n        <li if="{item.identifier == null}"><a data-toggle="tab" href="#pay-system-edit-blank">Бланк счета</a></li>\n        <li if="{item.identifier == null}"><a data-toggle="tab" href="#pay-system-edit-emailTemplate">Email шаблон</a></li>\n        <li if="{item.identifier == null}"><a data-toggle="tab" href="#pay-system-edit-result">Результат</a></li>\n        <li if="{item.identifier == null}"><a data-toggle="tab" href="#pay-system-edit-success">Успех</a></li>\n        <li if="{item.identifier == null}"><a data-toggle="tab" href="#pay-system-edit-fail">Неудача</a></li>\n        <li><a data-toggle="tab" href="#pay-system-edit-hosts">Хосты</a></li>\n\n      </ul>\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="pay-system-edit-settings">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="shoppayment" alt="0" size="64" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row" if="{isNew}">\n                <div class="col-md-12">\n                  <div class="form-group">\n                    <label class="control-label">Плагин</label>\n                    <div class="input-group">\n                      <select class="form-control" name="identifier" value="{item.identifier}">\n                        <option each="{plugin in item.plugins}" value="{plugin.id}">{plugin.name}</option>\n                      </select>\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{submit}">Получить параметры</div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Тип контакта</label>\n                    <div class="input-group">\n                      <select class="form-control" name="customerType" value="{item.customerType}">\n                        <option value="">Для всех</option>\n                        <option value="1">Для физических лиц</option>\n                        <option value="2">Для юридических лиц (компаний)</option>\n                      </select>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Скидка/комиссия, %</label>\n                    <input class="form-control" name="discount" min="-100" max="100" step="0.01" value="{item.discount}" type="{\'number\'}">\n                  </div>\n                </div>\n                <div class="col-md-2">\n                  <div class="form-group">\n                    <label class="control-label">Max сумма оплаты</label>\n                    <input class="form-control" name="maxAmount" min="0" step="0.01" value="{item.maxAmount}" type="{\'number\'}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="form-group">\n                    <label class="control-label">Справка URL</label>\n                    <input class="form-control" name="urlHelp" type="text" value="{item.urlHelp}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="form-group">\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isExtBlank" __checked="{item.isExtBlank}">Внешний бланк\n                      </label>\n                    </div>\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isAuthorize" __checked="{item.isAuthorize}">Авторизация\n                      </label>\n                    </div>\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isActive" __checked="{item.isActive}">Показывать\n                      </label>\n                    </div>\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isAdvance" __checked="{item.isAdvance}">Предоплата\n                      </label>\n                    </div>\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isTestMode" __checked="{item.isTestMode}">Тестовый режим\n                      </label>\n                    </div>\n                    <div class="checkbox-inline">\n                      <label>\n                        <input type="checkbox" name="isTicket" __checked="{item.isTicket}">Выписывать чек\n                      </label>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row" if="{!isNew}">\n            <div class="col-md-12">\n              <h4>Параметры</h4>\n            </div>\n          </div>\n          <catalog-static if="{!isNew}" name="params" cols="{paramsCols}" rows="{item.params}" dblclick="{editParam}" add="{!item.ident ? addParams : false}">\n            <yield to="body">\n              <datatable-cell name="code">{row.code}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="value">{row.tvalue}</datatable-cell>\n            </yield>\n          </catalog-static>\n          <div class="row">\n            <div class="col-md-12">\n              <h4>Дни недели и время</h4>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isMon" __checked="{item.isMon}">Понедельник\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="monFrom" format="HH:mm" value="{item.monFrom}" __disabled="{!item.isMon}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="monTo" format="HH:mm" value="{item.monTo}" __disabled="{!item.isMon}"></datetime-picker>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isTue" __checked="{item.isTue}">Вторник\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="tueFrom" format="HH:mm" value="{item.tueFrom}" __disabled="{!item.isTue}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="tueTo" format="HH:mm" value="{item.tueTo}" __disabled="{!item.isTue}"></datetime-picker>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isWed" __checked="{item.isWed}">Среда\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="wedFrom" format="HH:mm" value="{item.wedFrom}" __disabled="{!item.isWed}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="wedTo" format="HH:mm" value="{item.wedTo}" __disabled="{!item.isWed}"></datetime-picker>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isThu" __checked="{item.isThu}">Четверг\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="thuFrom" format="HH:mm" value="{item.thuFrom}" __disabled="{!item.isThu}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="thuTo" format="HH:mm" value="{item.thuTo}" __disabled="{!item.isThu}"></datetime-picker>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isFri" __checked="{item.isFri}">Пятница\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="friFrom" format="HH:mm" value="{item.friFrom}" __disabled="{!item.isFri}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="friTo" format="HH:mm" value="{item.friTo}" __disabled="{!item.isFri}"></datetime-picker>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isSat" __checked="{item.isSat}">Суббота\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="satFrom" format="HH:mm" value="{item.satFrom}" __disabled="{!item.isSat}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="satTo" format="HH:mm" value="{item.satTo}" __disabled="{!item.isSat}"></datetime-picker>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-2">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isSun" __checked="{item.isSun}">Воскресенье\n                    </label>\n                  </div>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="sunFrom" format="HH:mm" value="{item.sunFrom}" __disabled="{!item.isSun}"></datetime-picker>\n                </div>\n                <div class="col-md-1">\n                  <datetime-picker class="form-control" name="sunTo" format="HH:mm" value="{item.sunTo}" __disabled="{!item.isSun}"></datetime-picker>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-main-info">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <ckeditor name="pageMainInfo" value="{item.pageMainInfo}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-blank" if="{item.identifier == null}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <ckeditor name="pageBlank" value="{item.pageBlank}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-emailTemplate" if="{item.identifier == null}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <ckeditor name="emailTemplate" value="{item.emailTemplate}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-result" if="{item.identifier == null}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <ckeditor name="pageResult" value="{item.pageResult}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-success" if="{item.identifier == null}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <ckeditor name="pageSuccess" value="{item.pageSuccess}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-fail" if="{item.identifier == null}">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <ckeditor name="pageFail" value="{item.pageFail}"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-hosts">\n          <catalog-static name="hosts" rows="{item.hosts}" add="{addHosts}" cols="{[{name: &quot;name&quot;, value: &quot;Наименование&quot;}]}">\n            <yield to="body">\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="pay-system-edit-filters">\n          <catalog-static name="filters" rows="{item.filters}" add="{addFilters}" cols="{filtersCols}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="code">{row.code}</datatable-cell>\n              <datatable-cell name="article">{row.article}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="price">{row.price}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.isNew = false;
	    self.paramsSelectedCount = 0;
	
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	    self.item = {};
	
	    self.rules = {
	        namePayment: 'empty'
	    };
	
	    self.value = [];
	
	    self.afterChange = function (e) {
	        if (e.target && e.target.name) {
	            (function () {
	                var name = e.target.name;
	                var value = e.target.value;
	                if (name === 'identifier') {
	                    var item = self.item.plugins.filter(function (item) {
	                        return item.name === value;
	                    });
	                    if (item.length) {
	                        self.item.namePayment = item[0].name;
	                    }
	                }
	            })();
	        }
	
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.paramsCols = [{ name: 'code', value: 'Код' }, { name: 'name', value: 'Заголовок' }, { name: 'value', value: 'Значение' }];
	
	    self.filtersCols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'price', value: 'Цена' }];
	
	    self.reload = function () {
	        observable.trigger('pay-systems-edit', self.item.id);
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        self.error = self.validation.validate(params, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'PaySystem',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'Платежная система сохранена!', style: 'popup-success' });
	                    if (self.isNew) riot.route('settings/pay-systems/' + response.id);
	                    observable.trigger('pay-systems-reload');
	                }
	            });
	        }
	    };
	
	    self.addHosts = function () {
	        modals.create('bs-prompt', {
	            type: 'modal-primary',
	            title: 'Хост',
	            label: 'Наименование сайта (без http://)',
	            submit: function submit() {
	                if (!(self.item.hosts instanceof Array)) self.item.hosts = [];
	
	                self.item.hosts.push({ name: this.name.value });
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.addFilters = function () {
	        modals.create('products-list-select-modal', {
	            type: 'modal-primary',
	            size: 'modal-lg',
	            submit: function submit() {
	                self.item.filters = self.item.filters || [];
	
	                var items = this.tags.catalog.tags.datatable.getSelectedRows();
	
	                var ids = self.item.filters.map(function (item) {
	                    return item.id;
	                });
	
	                items.forEach(function (item) {
	                    if (ids.indexOf(item.id) === -1) self.item.filters.push(item);
	                });
	
	                self.update();
	                this.modalHide();
	            }
	        });
	    };
	
	    self.addParams = function () {
	        modals.create('pay-system-params-edit-modal', {
	            type: 'modal-primary',
	            isNew: true,
	            submit: function submit() {
	                var _this = this;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'BankAccount',
	                        method: 'Save',
	                        data: _this.item,
	                        success: function success(response) {
	                            _this.item.id = response.id;
	                            self.item.params.push(_this.item);
	                            self.update();
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.editParam = function (e) {
	        var oldParam = {};
	
	        for (var key in e.item.row) {
	            oldParam[key] = e.item.row[key];
	        }modals.create('pay-system-params-edit-modal', {
	            type: 'modal-primary',
	            item: e.item.row,
	            title: 'Редактирование параметра',
	            submit: function submit() {
	                var _this = this;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    self.update();
	                    observable.trigger('pay-systems-reload');
	                    _this.modalHide();
	                    /*
	                     				API.request({
	                    	object: 'BankAccount',
	                    	method: 'Save',
	                    	data: _this.item,
	                    	success(response) {
	                     					}
	                    })
	                    */
	                }
	            }
	        });
	    };
	    self.removeParams = function () {
	        self.paramsSelectedCount = 0;
	        self.item.params = self.tags.params.getUnselectedRows();
	        self.update();
	    };
	
	    observable.on('pay-systems-edit', function (id) {
	        self.error = false;
	        self.loader = true;
	        self.isNew = false;
	        self.item = {};
	        self.update();
	
	        API.request({
	            object: 'PaySystem',
	            method: 'Info',
	            data: { id: id },
	            success: function success(response) {
	                self.item = response;
	                observable.trigger('pay-systems-reload');
	            },
	            error: function error(response) {
	                self.item = {};
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('pay-systems-reload', function (item) {
	        for (var i in self.item.params) {
	            var element = self.item.params[i];
	            var t = String(element.code);
	            if (t.search(/(CODE|SECRET|KEY|PASS|CERT)/ig) + 1 && t.length !== 0) {
	                self.item.params[i].tvalue = '**********';
	            } else {
	                self.item.params[i].tvalue = element.value;
	            }
	        }
	        self.update({ loader: false });
	    });
	
	    observable.on('pay-systems-new', function () {
	        self.error = false;
	        self.loader = true;
	        self.isNew = true;
	        self.item = {};
	        self.update();
	
	        API.request({
	            object: 'PaySystem',
	            method: 'Info',
	            success: function success(response) {
	                self.item = response;
	                observable.trigger('pay-systems-reload');
	            },
	            error: function error(response) {
	                self.item = {};
	                self.item.plugins = [];
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(4)))

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('pay-system-params-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Новый параметр\'}</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.code}">\n              <label class="control-label">Код</label>\n              <input class="form-control" name="code" value="{item.code}">\n              <div class="help-block">{error.code}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Заголовок</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.value}">\n              <label class="control-label">Значение</label>\n              <textarea class="form-control" name="value" value="{item.value}" type="{type}"></textarea>\n              <div class="help-block">{error.value}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.error = false;
	        modal.isNew = opts.isNew || false;
	        modal.item = opts.item || {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.type = 'text';
	
	        modal.rules = {
	            code: 'empty',
	            name: 'empty',
	            value: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('pay-systems', '  <catalog object="PaySystem" cols="{cols}" reload="true" reorder="true" sortable="true" add="{permission(add, &quot;paysystems&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;paysystems&quot;, &quot;0001&quot;)}" dblclick="{permission(paySystemOpen, &quot;paysystems&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="imageFile"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n      <datatable-cell name="name"><i class="fa {row.active == &quot;Y&quot; ? &quot;fa-eye&quot; : &quot;fa-eye-slash text-noactive&quot;}"></i> {row.name}</datatable-cell>\n      <datatable-cell name="discount">{row.discount}</datatable-cell>\n      <datatable-cell name="maxAmount">{row.maxAmount}</datatable-cell>\n      <datatable-cell name="sort">{row.sort}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	    self.collection = 'PaySystem';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'imageFile', value: 'Картинка' }, { name: 'name', value: 'Наименование' }, { name: 'discount', value: 'Скидка, %' }, { name: 'maxAmount', value: 'Max сумма' }, { name: 'sort', value: 'Индекс' }];
	
	    self.add = function () {
	        return riot.route('/settings/pay-systems/new');
	    };
	
	    self.paySystemOpen = function (e) {
	        return riot.route('settings/pay-systems/' + e.item.row.id);
	    };
	
	    self.one('updated', function () {
	        self.tags.catalog.tags.datatable.on('reorder-end', function () {
	            var _self$tags$catalog$pa = self.tags.catalog.pages,
	                current = _self$tags$catalog$pa.current,
	                limit = _self$tags$catalog$pa.limit;
	
	            var params = { indexes: [] };
	            var offset = current > 0 ? (current - 1) * limit : 0;
	
	            self.tags.catalog.items.forEach(function (item, sort) {
	                item.sort = sort + offset;
	                params.indexes.push({ id: item.id, sort: sort + offset });
	            });
	
	            API.request({
	                object: 'PaySystem',
	                method: 'Sort',
	                data: params,
	                notFoundRedirect: false
	            });
	            self.update();
	        });
	    });
	
	    observable.on('pay-systems-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('permission-rights-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/permissions"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование прав\'}</div>\n    <div class="row">\n      <div class="col-md-12">\n        <datatable rows="{item.permissions}" cols="{cols}" handlers="{handlers}">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggleAll}" __checked="{row.mask == 15}">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 8)}" data-value="8">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 4)}" data-value="4">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 2)}" data-value="2">\n          </datatable-cell>\n          <datatable-cell name="">\n            <input type="checkbox" onclick="{stopPropagation}" onchange="{handlers.toggle}" __checked="{handlers.calc(row.mask, 1)}" data-value="1">\n          </datatable-cell>\n        </datatable>\n      </div>\n    </div>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.item = {};
	
	    self.cols = [{ name: 'name', value: 'Объект' }, { name: '', value: 'Полный доступ', classes: 'text-center' }, { name: '', value: 'Чтение', classes: 'text-center' }, { name: '', value: 'Добавление', classes: 'text-center' }, { name: '', value: 'Редактирование', classes: 'text-center' }, { name: '', value: 'Удаление', classes: 'text-center' }];
	
	    self.submit = function () {
	        self.loader = true;
	
	        API.request({
	            object: 'PermissionRole',
	            method: 'Save',
	            data: self.item,
	            success: function success(response) {
	                self.item = response;
	                popups.create({ title: 'Успех!', text: 'Права сохранены!', style: 'popup-success' });
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.reload = function () {
	        if (self.item && self.item.id) observable.trigger('permissions-edit', self.item.id);
	    };
	
	    self.handlers = {
	        calc: function calc(value, k) {
	            return parseInt(value || 0) & k;
	        },
	        toggleAll: function toggleAll(e) {
	            var checked = e.target.checked;
	            e.item.row.mask = checked ? 15 : 0;
	        },
	        toggle: function toggle(e) {
	            var checked = e.target.checked;
	            var k = parseInt(e.target.getAttribute('data-value'));
	            e.item.row.mask = parseInt(e.item.row.mask || 0) + (checked ? k : -k);
	        }
	    };
	
	    observable.on('permissions-edit', function (id) {
	        self.item = {};
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'PermissionRole',
	            method: 'Info',
	            data: { id: id },
	            success: function success(response) {
	                self.item = response;
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('permission-user-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Менеджеры</div>\n    </yield>\n    <yield to="body">\n      <catalog object="PermissionUser" cols="{parent.cols}" search="true" reload="false" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="1">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="lastName">{row.lastName} {row.firstName} {row.secName}</datatable-cell>\n          <datatable-cell name="roles">{row.roles}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	  'use strict';
	
	  var self = this;
	
	  self.cols = [{ name: 'id', value: '#' }, { name: 'lastName', value: 'Ф.И.О' }, { name: 'roles', value: 'Роль' }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('permissions-roles-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Роли</div>\n    </yield>\n    <yield to="body">\n      <catalog object="PermissionRole" cols="{cols}" disable-col-select="true" store="permissions-roles-list-modal" dblclick="{parent.opts.submit.bind(this)}" disable-limit="true">\n        <yield to="body">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        self.tags['bs-modal'].cols = [{ name: 'name', value: 'Наименование' }];
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(494);
	
	riot.tag2('permissions-roles', '  <catalog object="PermissionRole" cols="{cols}" add="{add}" remove="{remove}" dblclick="{open}" reload="true" store="permissions-roles">\n    <yield to="body">\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.collection = 'PermissionRole';
	
	    self.add = function () {
	        modals.create('permissons-roles-add-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'PermissionRole',
	                        method: 'Save',
	                        data: { name: this.name.value },
	                        success: function success(response) {
	                            popups.create({ title: 'Успех!', text: 'Роль добавлен!', style: 'popup-success' });
	                            observable.trigger('permissions-roles-reload');
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    observable.on('permissions-roles-reload', function () {
	        return self.tags.catalog.reload();
	    });
	
	    self.open = function (e) {
	        return riot.route('/settings/permissions/' + e.item.row.id);
	    };
	
	    self.cols = [{ name: "name", value: "Наименование" }];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(106);
	
	__webpack_require__(490);
	
	riot.tag2('permissions-users', '  <catalog object="PermissionUser" cols="{cols}" add="{add}" remove="{remove}" reload="true" store="permissions-users" dblclick="{edit}">\n    <yield to="head">\n      <button class="btn btn-success" if="{selectedCount &gt; 1}" type="button" onclick="{parent.edit}"><i class="fa fa-group"></i></button>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="regDate">{row.regDate}</datatable-cell>\n      <datatable-cell name="login">{row.login}</datatable-cell>\n      <datatable-cell name="lastName">{[row.firstName, row.secondName, row.lastName].join(\' \').trim()}</datatable-cell>\n      <datatable-cell name="roles">{row.roles}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.collection = 'PermissionUser';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'regDate', value: 'Дата. рег.' }, { name: 'login', value: 'Логин' }, { name: 'lastName', value: 'Ф.И.О.' }, { name: 'roles', value: 'Роли' }];
	
	    self.add = function () {
	        modals.create('persons-list-select-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length) {
	                    var ids = items.map(function (i) {
	                        return i.id;
	                    });
	                    API.request({
	                        object: 'PermissionUser',
	                        method: 'Save',
	                        data: { ids: ids },
	                        success: function success(response) {
	                            self.tags.catalog.reload();
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    self.edit = function (e) {
	        var ids = void 0;
	
	        if (e.item) {
	            ids = [e.item.row.id];
	        } else {
	            ids = self.tags.catalog.tags.datatable.getSelectedRows().map(function (i) {
	                return i.id;
	            });
	        }
	
	        modals.create('permissions-roles-list-modal', {
	            type: 'modal-primary',
	            submit: function submit() {
	                var _this = this;
	                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
	
	                if (items.length) {
	                    var idsRoles = items.map(function (i) {
	                        return i.id;
	                    });
	                    API.request({
	                        object: 'PermissionUser',
	                        method: 'Save',
	                        data: { ids: ids, idsRoles: idsRoles },
	                        success: function success(response) {
	                            self.tags.catalog.reload();
	                            _this.modalHide();
	                        }
	                    });
	                }
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(492);
	
	__webpack_require__(491);
	
	riot.tag2('permissions', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#permissions-users">Пользователи</a></li>\n    <li><a data-toggle="tab" href="#permissions-roles">Роли</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="permissions-users">\n      <permissions-users></permissions-users>\n    </div>\n    <div class="tab-pane fade" id="permissions-roles">\n      <permissions-roles></permissions-roles>\n    </div>\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	riot.tag2('permissons-roles-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новую роль</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
	        };
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(37);
	
	riot.tag2('seo-var-macro-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить макропеременную</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}" if="{!item.id}">\n          <label class="control-label"> Наименование</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label"> Значение</label>\n          <textarea class="form-control" name="value" value="{item.value}" style="min-height: 150px;"></textarea>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.error = false;
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	        //modal.update()
	
	        modal.rules = {
	            name: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	        };
	
	        if (opts.id) {
	            modal.loader = true;
	            API.request({
	                object: 'SeoVariable',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                },
	                complete: function complete() {
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	__webpack_require__(495);
	
	riot.tag2('seo-vars-macro', '  <catalog object="SeoVariable" cols="{cols}" reload="true" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" handlers="{variablesHandlers}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id" style="width: 1%;">{row.id}</datatable-cell>\n      <datatable-cell name="name" style="width: 15%;">{row.name}</datatable-cell>\n      <datatable-cell name="value">\n        <input class="form-control" value="{row.value}" type="text" readonly="true">\n      </datatable-cell>\n      <datatable-cell name="" style="width: 1%;">\n        <button class="btn btn-default" onclick="{handlers.editVars}" title="Редактор"><i class="fa fa-edit"></i></button>\n      </datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	
	    self.collection = "SeoVariable";
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'value', value: 'Значение' }, { name: 'button', value: '' }];
	
	    self.variablesHandlers = {
	        editVars: function editVars(e) {
	            return self.addEdit(e);
	        }
	    };
	
	    self.addEdit = function (e) {
	        var id;
	        if (e.item && e.item.row) {
	            id = e.item.row.id;
	        }
	
	        modals.create('seo-var-macro-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'SeoVariable',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    observable.on('seo-vars-reload', function () {
	        self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('seo-vars-word-exclude-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Слова исключения</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.value}">\n          <label class="control-label"> Значение</label>\n          <input class="form-control" name="value" type="text" value="{item.value}">\n          <div class="help-block">{error.value}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.on('mount', function () {
	        var modal = self.tags['bs-modal'];
	
	        modal.error = false;
	        modal.item = {};
	        modal.mixin('validation');
	        modal.mixin('change');
	
	        modal.rules = {
	            value: 'empty'
	        };
	
	        modal.afterChange = function (e) {
	            var name = e.target.name;
	            delete modal.error[name];
	            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
	        };
	
	        if (opts.id) {
	            modal.loader = true;
	
	            API.request({
	                object: 'WordExclude',
	                method: 'Info',
	                data: { id: opts.id },
	                success: function success(response) {
	                    modal.item = response;
	                },
	                complete: function complete() {
	                    modal.loader = false;
	                    modal.update();
	                }
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	__webpack_require__(497);
	
	riot.tag2('seo-vars-word-exclude', '  <catalog object="WordExclude" cols="{cols}" reload="true" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="value">{row.value}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('permissions');
	    self.mixin('remove');
	
	    self.collection = 'WordExclude';
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'value', value: 'Значение' }];
	
	    self.addEdit = function (e) {
	        var id;
	        if (e.item && e.item.row) {
	            id = e.item.row.id;
	        }
	
	        modals.create('seo-vars-word-exclude-modal', {
	            type: 'modal-primary',
	            id: id,
	            submit: function submit() {
	                var _this = this;
	                var params = _this.item;
	
	                _this.error = _this.validation.validate(_this.item, _this.rules);
	
	                if (!_this.error) {
	                    API.request({
	                        object: 'WordExclude',
	                        method: 'Save',
	                        data: params,
	                        success: function success(response) {
	                            _this.modalHide();
	                            self.tags.catalog.reload();
	                        }
	                    });
	                }
	            }
	        });
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(496);
	
	__webpack_require__(498);
	
	riot.tag2('seo-vars', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#seo-vars-macro">Макропеременные</a></li>\n    <li><a data-toggle="tab" href="#seo-vars-word-exclude">Слова исключения</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="seo-vars-macro">\n      <seo-vars-macro></seo-vars-macro>\n    </div>\n    <div class="tab-pane fade" id="seo-vars-word-exclude">\n      <seo-vars-word-exclude></seo-vars-word-exclude>\n    </div>\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('settings-main-preferences', '  <loader if="{loader}"></loader>\n  <div show="{!loader}">\n    <div class="row">\n      <div class="col-md-8 col-sm-12 col-xs-12">\n        <catalog-static onchange="{change}" onkeyup="{change}" cols="{cols}" rows="{items[0].parameters}" remove-toolbar="{true}" handlers="{handlers}">\n          <yield to="body">\n            <datatable-cell name="name">{row.name}</datatable-cell>\n            <datatable-cell name="value">\n              <input if="{row.valueType == &quot;S&quot;}" type="text" value="{row.value}" onclick="{stopPropagation}" onchange="{handlers.change}" onkeyup="{handlers.change}">\n              <input if="{row.valueType == &quot;B&quot;}" type="checkbox" __checked="{parseInt(row.value)}" onclick="{stopPropagation}" onchange="{handlers.change}" onmousedown="{handlers.change}">\n              <input if="{row.valueType == &quot;I&quot;}" step="1" value="{row.value}" onclick="{stopPropagation}" onchange="{handlers.change}" onkeyup="{handlers.change}" type="{\'number\'}">\n              <input if="{row.valueType == &quot;D&quot;}" step="0.01" value="{row.value}" onclick="{stopPropagation}" onchange="{handlers.change}" onkeyup="{handlers.change}" type="{\'number\'}">\n            </datatable-cell>\n          </yield>\n        </catalog-static>\n      </div>\n      <div class="col-md-4 hidden-sm hidden-sm">\n        <div class="h5"><b>Примечание по параметру</b></div>\n        <p>{note}</p>\n      </div>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.items = [];
	    self.note = '';
	
	    self.mixin('permissions');
	
	    self.cols = [{ name: 'name', value: 'Наименование параметра' }, { name: 'value', value: 'Значение' }];
	
	    var save = (0, _debounce2.default)(function (e) {
	        API.request({
	            object: 'Integration',
	            method: 'Save',
	            data: { parameters: self.items[0].parameters },
	            complete: function complete() {
	                return self.update();
	            }
	        });
	    }, 600);
	
	    self.change = function (e) {
	        if (self.checkPermission('settings', '0010')) save();
	    };
	
	    self.handlers = {
	        change: function change(e) {
	            if (self.checkPermission('settings', '0010')) {
	                if (e.target.type === 'checkbox') this.row.value = e.target.checked;else this.row.value = e.target.value;
	            } else {
	                if (e.target.type === 'checkbox') e.target.checked = parseInt(this.row.value);else e.target.value = this.row.value;
	            }
	            this.update();
	        }
	    };
	
	    self.reload = function () {
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'Integration',
	            method: 'Fetch',
	            success: function success(response) {
	                self.items = response.items;
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.one('updated', function () {
	        self.tags['catalog-static'].tags.datatable.on('row-selected', function (count, item) {
	            self.note = item.note;
	            self.update();
	        });
	    });
	
	    self.on('mount', function () {
	        self.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, app, observable, API, $) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault2(_debounce);
	
	__webpack_require__(500);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault2(_moment);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('settings-main', '  <div class="restore-layout" if="{restoreDBlayout}">\n    <loader text="Восстановление БД" indeterminate="true" size="large" inverted="true"></loader>\n  </div>\n  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#settings-main-home">Настройка магазина</a></li>\n      <li><a data-toggle="tab" href="#settings-main-company">Компания</a></li>\n      <li><a data-toggle="tab" href="#settings-values">Параметры магазина</a></li>\n      <li><a data-toggle="tab" href="#settings-main-preferences">Настройки Яндекс.Маркет</a></li>\n    </ul>\n    <div class="tab-content">\n      <div class="tab-pane fade in active" id="settings-main-home">\n        <form action="" onchange="{changeSettings}" onkeyup="{changeSettings}" method="POST">\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Имя магазина</label>\n                <input class="form-control" type="text" name="shopname" value="{item.shopname}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Подзаголовок</label>\n                <input class="form-control" type="text" name="subname" value="{item.subname}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Имя сайта</label>\n                <input class="form-control" type="text" name="domain" value="{item.domain}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Папка магазина</label>\n                <input class="form-control" type="text" name="folder" value="{item.folder}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> URL логотипа</label>\n                <input class="form-control" type="text" name="logo" value="{item.logo}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Базовая валюта</label>\n                <select class="form-control" name="basecurr">\n                  <option each="{c, i in item.listCurrency}" value="{c.name}" __selected="{c.name == parent.item.basecurr}" no-reorder>{c.title}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> E-mail продажи</label>\n                <input class="form-control" type="text" name="esales" value="{item.esales}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> E-mail поддержки</label>\n                <input class="form-control" type="text" name="esupport" value="{item.esupport}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Телефоны для СМС информирования</label>\n                <input class="form-control" type="text" name="smsPhone" value="{item.smsPhone}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Отправитель СМС по умолчанию</label>\n                <input class="form-control" type="text" name="smsSender" value="{item.smsSender}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Доставка (город отправления)</label>\n                <input class="form-control" name="cityFromDelivery" type="text" value="{item.cityFromDelivery}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Коэфициент цены закупки</label>\n                <input class="form-control" name="purchasePriceRatio" min="0" step="0.1" value="{item.purchasePriceRatio}" type="{\'number\'}">\n              </div>\n            </div>\n          </div>\n        </form>\n        <div class="row" if="{app.config.isAdmin}">\n          <div class="col-md-12">\n            <div class="form-group">\n              <div class="form-inline">\n                <div class="form-group">\n                  <button class="btn btn-primary" type="button" onclick="{dumpDB}">Создать резервную копию БД</button>\n                </div>\n                <div class="form-group">\n                  <div class="btn btn-file btn-primary">Восстановить БД из резервной копии\n                    <input name="file" type="file" accept=".arh" onchange="{restoreDB}">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="tab-pane fade" id="settings-values">\n        <form action="" onchange="{changeSettings}" method="POST">\n          <ul class="nav nav-tabs m-b-2">\n            <li class="{active: i==0}" each="{group,i in values.groups}"><a data-toggle="tab" href="#settings-values-num{group.id}" title="{group.description}">{group.name}</a></li>\n          </ul>\n          <div class="tab-content">\n            <div class="tab-pane fade {active:g==0} {in:g==0}" each="{group, g in values.groups}" id="settings-values-num{group.id}">\n              <div class="col-md-6" each="{setting, s in values.settings}" if="{values.settings[s].idGroup == group.id}">\n                <div class="form-group">\n                  <label class="control-label">{setting.name + \' \'}<i class="icon-append fa fa-question-circle text-muted" if="{values.settings[s].description}" data-toggle="tooltip" data-placement="auto" title="" data-original-title="{values.settings[s].description}"></i></label>\n                  <div class="input-group"><span class="input-group-addon">\n                      <input type="checkbox" name="settings_checked_{s}" __checked="{values.settings[s].enabled == 1}" style="width:13px;"></span>\n\n                    <input class="form-control" if="{values.settings[s].type == \'string\'}" type="text" name="settings_{s}" value="{values.settings[s].value}" placeholder="{setting.default}">\n\n                    <select class="form-control text-white" if="{values.settings[s].type == \'bool\'}" riot-style="background-color: {values.settings[s].value == 0 ? \'#d9534f\' : \'#5cb85c\'}; color:white;" name="settings_{s}">\n                      <option value="0" style="color:black;background-color:white;" __selected="{values.settings[s].value == 0}">Выключено</option>\n                      <option value="1" style="color:black;background-color:white;" __selected="{values.settings[s].value == 1}">Включено</option>\n                    </select>\n\n                    <select class="form-control" if="{values.settings[s].type == \'select\'}" name="settings_{s}">\n                      <option each="{value, name in values.settings[s].listValues}" value="{value}" __selected="{values.settings[s].value == value}">{name}</option>\n                    </select>\n\n                    <input class="form-control" if="{values.settings[s].type == \'password\'}" type="password" name="settings_{s}" value="{values.settings[s].value}" placeholder="{setting.default}">\n                  </div>\n\n                </div>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n      <div class="tab-pane fade" id="settings-main-company">\n        <form action="" onchange="{changeSettings}" onkeyup="{changeSettings}" method="POST">\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Компания</label>\n                <input class="form-control" type="text" name="company" value="{item.company}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Руководитель (Ф.И.О)</label>\n                <input class="form-control" type="text" name="director" value="{item.director}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Руководитель (должность)</label>\n                <input class="form-control" type="text" name="posthead" value="{item.posthead}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Гл. бухгалтер (Ф.И.О)</label>\n                <input class="form-control" type="text" name="bookkeeper" value="{item.bookkeeper}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Физический адрес</label>\n                <input class="form-control" type="text" name="addrF" value="{item.addrF}">\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label"> Юридический адрес</label>\n                <input class="form-control" type="text" name="addrU" value="{item.addrU}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label"> Телефон</label>\n                <input class="form-control" type="text" name="phone" value="{item.phone}">\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label"> Факс</label>\n                <input class="form-control" type="text" name="fax" value="{item.fax}">\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label"> НДС</label>\n                <input class="form-control" step="0.10" name="nds" value="{parseFloat(item.nds)}" type="{\'number\'}">\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n      <div class="tab-pane fade" id="settings-main-preferences">\n        <settings-main-preferences></settings-main-preferences>\n      </div>\n    </div>\n  </virtual>\n', 'settings-main .restore-layout,[riot-tag="settings-main"] .restore-layout,[data-is="settings-main"] .restore-layout{ position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: #000; opacity: 0.7; z-index: 1100; }', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this,
	        route = riot.route.create();
	
	    self.item = {};
	    self.values = {};
	    self.mixin('permissions');
	    self.mixin('change');
	    self.app = app;
	
	    var save = (0, _debounce2.default)(function (e) {
	        observable.trigger('settings-save');
	        API.request({
	            object: 'Main',
	            method: 'Save',
	            data: self.item,
	            complete: function complete() {
	                return self.update();
	            }
	        });
	    }, 600);
	
	    self.changeSettings = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeSettings" }));
	        if (self.checkPermission('settings', '0010')) {
	            if (e.target.localName == "select") {
	                var index = e.target.selectedIndex;
	                self.item[e.target.name] = e.target.children[index].value;
	            }
	            self.change(e);
	            save();
	        } else {
	            e.target.value = self.item[e.target.getAttribute('name')];
	        }
	    };
	
	    observable.on('settings-add', function (settings) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "settings-add" }));
	        self.startbasecurr = self.item.basecurr;
	        self.values = settings;
	    });
	
	    observable.on('settings-save', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "settings-save" }));
	        for (var prop in self.values.settings) {
	            if (self.item['settings_' + prop]) {
	                self.values.settings[prop].value = self.item['settings_' + prop];
	            }
	            if ('settings_checked_' + prop in self.item) {
	                self.values.settings[prop].enabled = Number(self.item['settings_checked_' + prop]);
	            }
	        }
	
	        API.request({
	            object: 'Settings',
	            method: 'Save',
	            data: self.values,
	            complete: function complete() {
	                return self.update();
	            }
	        });
	        if (self.item.basecurr != self.startbasecurr) window.location.reload(true); // после смены баз валюты - перезагрузить ВЕСЬ сайт
	    });
	
	    self.reload = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'Main',
	            method: 'Info',
	            data: {},
	            success: function success(response) {
	                self.item = response;
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	
	        API.request({
	            object: 'Settings',
	            method: 'Fetch',
	            data: {},
	            success: function success(response) {
	                observable.trigger('settings-add', response);
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.dumpDB = function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dumpDB" }));
	        API.request({
	            object: 'Dump',
	            method: 'Info',
	            success: function success(response, xhr) {
	                var a = document.createElement('a');
	                a.href = response.url;
	                a.download = response.name;
	                document.body.appendChild(a);
	                a.click();
	                a.remove();
	            }
	        });
	    };
	
	    self.restoreDB = function (e) {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "restoreDB" }));
	        var target = e.target;
	        var formData = new FormData();
	
	        if (target.files && target.files.length) {
	            formData.append('file', target.files[0], target.files[0].name);
	            self.restoreDBlayout = true;
	
	            API.upload({
	                object: 'Dump',
	                data: formData,
	                success: function success(response) {
	                    window.location.reload(true);
	                },
	                error: function error() {
	                    self.restoreDBlayout = true;
	                    self.update();
	                }
	            });
	        }
	    };
	
	    route('/settings', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "/settings" }));
	        self.reload();
	    });
	
	    self.on('updated', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "updated" }));
	        $('[data-toggle="tooltip"]').tooltip();
	    });
	
	    self.on('mount', function () {
	        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
	        riot.route.exec();
	    });
	
	    self.debugParam = {
	        module: "settings-main.tag",
	        dClass: "settings-main",
	        method: "",
	        dComment: "",
	        groupLog: "norm",
	        dArray: undefined
	    };
	    self.debuger = function () {
	        var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;
	
	        /** ДЕБАГЕР
	         * 1 Запуск логов
	         * 2 Настройки
	         * 3 Формирование строки
	         * 4 Отступ
	         * 5 Очередность и отображение
	         *
	         * self.debuger({ ...self.debugParam, method:"allParams" })
	         *
	         * self.debuger({ ...self.debugParam, method:"reload",
	                 *                groupLog: "reload", dComment:"response", dArray: response })
	         */
	
	        // 1
	        var startList = {
	            norm: true
	        };
	
	        if (startList[dp.groupLog] == true && document.domain == "localhost") {
	
	            // 2
	            var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
	            var gr = true;var com = true;var met = true;var cl = true;var mod = true;
	
	            // 3
	            var groupLog = "gr: " + dp.groupLog;
	            var comment = "com: " + dp.dComment;
	            var method = "met: " + dp.method;
	            var clas = "cl: " + dp.dClass;
	            var module = "mod: " + dp.module;
	
	            // 4
	            var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
	            var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
	            var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
	            var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
	            var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;
	
	            // 5
	            var consoleLog = "|";
	            if (gr == true) consoleLog += groupLog + groupLogLen;
	            if (com == true) consoleLog += comment + commentLen;
	            if (met == true) consoleLog += method + methodLen;
	            if (cl == true) consoleLog += clas + clasLen;
	            if (mod == true) consoleLog += module + modLen;
	
	            console.warn(consoleLog);
	            if (dp.dArray != undefined) console.log(dp.dArray);
	        }
	    };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(12), __webpack_require__(5), __webpack_require__(4), __webpack_require__(16)))

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(501);
	
	__webpack_require__(469);
	
	__webpack_require__(484);
	
	__webpack_require__(481);
	
	__webpack_require__(487);
	
	__webpack_require__(485);
	
	__webpack_require__(474);
	
	__webpack_require__(472);
	
	__webpack_require__(499);
	
	__webpack_require__(468);
	
	__webpack_require__(493);
	
	__webpack_require__(488);
	
	__webpack_require__(508);
	
	__webpack_require__(507);
	
	__webpack_require__(505);
	
	__webpack_require__(480);
	
	__webpack_require__(477);
	
	riot.tag2('settings', '  <div class="row">\n    <div class="col-sm-2 hidden-xs" if="{!edit}">\n      <ul class="nav nav-pills nav-stacked" style="height: calc(100vh - 65px); position: fixed; overflow-y: auto; padding-right: 20px; width: 15%;">\n        <li class="{active: name == tab}" each="{tabs}" if="{admin ? isAdmin() : checkPermission(permission, 1000)}"><a href="#settings/{link}">{title}</a></li>\n      </ul>\n    </div>\n    <div class="col-xs-12 hidden-sm hidden-lg hidden-md form-group" if="{!edit}">\n      <select class="form-control" onchange="{menuSelect}">\n        <option each="{tabs}" if="{admin ? isAdmin() : checkPermission(permission, 1000)}" value="{name}" __selected="{name == tab}" no-reorder>{title}</option>\n      </select>\n    </div>\n    <div class="col-sm-10 col-xs-12">\n      <settings-main if="{tab == &quot;&quot;}"></settings-main>\n\n      <pay-systems if="{tab == &quot;pay-systems&quot; &amp;&amp; !edit}"></pay-systems>\n      <email if="{tab == &quot;email&quot; &amp;&amp; !edit}"></email>\n      <currencies if="{tab == &quot;currencies&quot;}"></currencies>\n      <measurements if="{tab == &quot;measurements&quot; &amp;&amp; !edit}"></measurements>\n      <permissions if="{tab == &quot;permissions&quot; &amp;&amp; !edit}"></permissions>\n      <seo-vars if="{tab == &quot;seo-variables&quot;}"></seo-vars>\n      <add-fields if="{tab == &quot;fields&quot;}"></add-fields>\n      <settings-yandex-photos if="{tab == &quot;yandex-photos&quot;}">\n        <h4>Яндекс.Фотки - в разработке</h4>\n      </settings-yandex-photos>\n      <settings-synhro-1c if="{tab == &quot;settings-synhro-1c&quot; &amp;&amp; !edit}"></settings-synhro-1c>\n      <sms if="{tab == &quot;sms&quot; &amp;&amp; !edit}"></sms>\n      <geotargeting if="{tab == &quot;geotargeting&quot; &amp;&amp; !edit}"></geotargeting>\n    </div>\n    <div class="col-md-12">\n\n      <pay-system-edit if="{tab == &quot;pay-systems&quot; &amp;&amp; edit}"></pay-system-edit>\n      <email-template-edit if="{tab == &quot;email&quot; &amp;&amp; edit}"></email-template-edit>\n      <permission-rights-edit if="{tab == &quot;permissions&quot; &amp;&amp; edit}"></permission-rights-edit>\n      <sms-template-edit if="{tab == &quot;sms&quot; &amp;&amp; edit}"></sms-template-edit>\n      <measure-edit if="{tab == &quot;measurements&quot; &amp;&amp; edit}"></measure-edit>\n      <geotargeting-edit if="{tab == &quot;geotargeting&quot; &amp;&amp; edit}"></geotargeting-edit>\n    </div>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.mixin('permissions');
	    self.tab = '';
	
	    route('/settings', function () {
	        self.edit = false;
	        self.tab = '';
	        self.update();
	    });
	
	    route('/settings/*', function (tab) {
	        var idx = self.tabs.map(function (item) {
	            return item.name;
	        }).indexOf(tab);
	        var value = void 0;
	        if (idx !== -1) value = self.tabs[idx].admin ? self.isAdmin() : self.checkPermission(self.tabs[idx].permission, 1000);
	        if (idx !== -1 && value) {
	            self.update({ edit: false, tab: tab });
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/settings/measurements/*/([0-9]+)', function (section, id) {
	        self.update({ edit: true, tab: 'measurements' });
	        observable.trigger('measure-edit', id, section);
	    });
	
	    route('/settings/*/([0-9]+)', function (tab, id) {
	        if (self.tabs.map(function (i) {
	            return i.name;
	        }).indexOf(tab) !== -1) {
	            self.update({ edit: true, tab: tab });
	            observable.trigger(tab + '-edit', id);
	        } else {
	            self.update({ edit: true, tab: 'not-found' });
	            observable.trigger('not-found');
	        }
	    });
	
	    route('/settings/pay-systems/new', function (tab) {
	        self.update({ edit: true, tab: 'pay-systems' });
	        observable.trigger('pay-systems-new');
	    });
	
	    //route('/settings/delivery/new', tab => {
	    //    self.update({edit: true, tab: 'delivery'})
	    //    observable.trigger('delivery-new')
	    //})
	
	    route('/settings/email/new', function (tab) {
	        self.update({ edit: true, tab: 'email' });
	        observable.trigger('email-new');
	    });
	
	    route('/settings/sms/new', function (tab) {
	        self.update({ edit: true, tab: 'sms' });
	        observable.trigger('sms-new');
	    });
	
	    route('/settings/geotargeting/new', function (tab) {
	        self.update({ edit: true, tab: 'geotargeting' });
	        observable.trigger('geotargeting-new');
	    });
	
	    route('/settings..', function () {
	        self.update({ edit: true, tab: 'not-found' });
	        observable.trigger('not-found');
	    });
	
	    self.tab = '';
	    self.tabs = [{ title: 'Основные настройки', name: '', link: '', permission: 'settings' },
	    //{title: 'Доставки', name: 'delivery', link: 'delivery', permission: 'deliveries'},
	    { title: 'Платежные системы', name: 'pay-systems', link: 'pay-systems', permission: 'paysystems' }, { title: 'Валюты', name: 'currencies', link: 'currencies', permission: 'currencies' }, { title: 'Меры', name: 'measurements', link: 'measurements', permission: 'settings' }, { title: 'Права доступа', name: 'permissions', link: 'permissions', permission: 'settings', admin: true }, { title: 'SEO переменные', name: 'seo-variables', link: 'seo-variables', permission: 'settings' }, { title: 'Поля', name: 'fields', link: 'fields', permission: 'settings' }, { title: 'Геотаргетинг', name: 'geotargeting', link: 'geotargeting', permission: 'settings' }, { title: 'E-mail уведомления', name: 'email', link: 'email', permission: 'mails' }, { title: 'SMS уведомления', name: 'sms', link: 'sms', permission: 'settings' },
	    //{title: 'Яндекс.Фотки', name: 'yandex-photos', link: 'yandex-photos', permission: 'settings'},
	    { title: 'Интеграция с 1С', name: 'settings-synhro-1c', link: 'settings-synhro-1c', permission: 'settings' }];
	
	    self.menuSelect = function (e) {
	        return riot.route('/settings/' + e.target.value);
	    };
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	riot.tag2('sms-journal', '  <catalog search="true" sortable="true" object="SmsLog" cols="{cols}" reload="true" store="sms-log">\n    <yield to="body">\n      <datatable-cell name="date">{row.date}</datatable-cell>\n      <datatable-cell name="phone">{row.phone}</datatable-cell>\n      <datatable-cell name="userName">{row.userName}</datatable-cell>\n      <datatable-cell name="text">{row.text}</datatable-cell>\n      <datatable-cell name="cost">{row.cost}</datatable-cell>\n      <datatable-cell name="count">{row.count}</datatable-cell>\n      <datatable-cell name="provider">{row.provider}</datatable-cell>\n      <datatable-cell name="status">{row.status}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.cols = [{ name: 'date', value: 'Время' }, { name: 'phone', value: 'Телефон' }, { name: 'userName', value: 'Пользователь' }, { name: 'text', value: 'Текст' }, { name: 'cost', value: 'Стоимость' }, { name: 'count', value: 'Кол-во' }, { name: 'provider', value: 'Провайдер' }, { name: 'status', value: 'Статус' }];
	
	    observable.on('sms-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	riot.tag2('sms-settings', '  <loader if="{loader}"></loader>\n  <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group">\n          <div class="btn-group">\n            <button class="btn btn-default" type="button" onclick="{save}"><i class="fa fa-save"></i> Сохранить</button>\n            <button class="btn btn-default" type="button" onclick="{reload}"><i class="fa fa-refresh"></i></button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group">\n          <label class="control-label">Провайдер</label>\n          <div class="input-group">\n            <select class="form-control" name="id" value="{item.id}">\n              <option each="{p, i in providers}" __selected="{p.id == item.id}" value="{p.id}" no-reorder>{p.name}</option>\n            </select>\n            <div class="input-group-btn" if="{link}"><a class="btn btn-default" target="_blank" href="{link}" title="Перейти на сайт"><i class="fa fa-link"></i></a></div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <virtual each="{settings}">\n          <div class="form-group" if="{name == &quot;password&quot;}">\n            <label class="control-label">{name}</label>\n            <input class="form-control" name="{name}" value="{parent.item[name]}" type="password">\n          </div>\n          <div class="form-group" if="{type == &quot;string&quot; &amp;&amp; name != &quot;password&quot;}">\n            <label class="control-label">{name}</label>\n            <input class="form-control" name="{name}" value="{parent.item[name]}" type="text">\n          </div>\n        </virtual>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group" if="{balance !== undefined}">\n          <label class="control-label">Баланс</label>\n          <p class="form-control-static">{balance || 0}</p>\n        </div>\n      </div>\n    </div>\n    <div class="row" if="{description}">\n      <div class="col-md-12">\n        <blockquote>\n          <p class="form-control-static" each="{d in description}">{d}</p>\n        </blockquote>\n      </div>\n    </div>\n  </form>\n', 'sms-settings,[riot-tag="sms-settings"],[data-is="sms-settings"]{ display: block; position: relative; }', '', function (opts) {
	    'use strict';
	
	    var _stringify = __webpack_require__(29);
	
	    var _stringify2 = _interopRequireDefault(_stringify);
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.loader = false;
	    self.item = {};
	    self.mixin('change');
	
	    self.providers = [];
	    self.settings = [];
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        var value = e.target.value;
	
	        if (name === 'id') {
	            self.settings = [];
	            var active = self.providers.filter(function (item) {
	                return item.id == self.item.id;
	            });
	
	            if (active.length) {
	                self.link = /http(s)*:\/\//.test(active[0].url) ? active[0].url : 'http://' + active[0].url;
	                self.item = { id: value };
	                self.balance = undefined;
	
	                API.request({
	                    object: 'SmsProvider',
	                    method: 'info',
	                    data: { id: value },
	                    success: function success(response) {
	                        self.balance = response.balance;
	                        self.description = response.description;
	                        self.update();
	                    }
	                });
	
	                try {
	                    var settings = JSON.parse(active[0].settings);
	                    for (var param in settings) {
	                        var item = (0, _extends3.default)({ name: param }, settings[param]);
	                        self.settings.push(item);
	                        self.item[param] = settings[param].value || '';
	                    }
	                } catch (e) {
	                    self.settings = [];
	                }
	            }
	        }
	    };
	
	    self.save = function () {
	        var params = {
	            id: self.item.id,
	            settings: '',
	            isActive: '1'
	        };
	
	        var active = self.providers.filter(function (item) {
	            return item.id == self.item.id;
	        })[0];
	        var activeSettings = JSON.parse(active.settings);
	        var settings = {};
	
	        for (var param in self.item) {
	            if (param !== 'id') {
	                settings[param] = (0, _extends3.default)({}, activeSettings[param], { value: self.item[param] });
	            }
	        }
	
	        params.settings = (0, _stringify2.default)(settings);
	
	        API.request({
	            object: 'SmsProvider',
	            method: 'Save',
	            data: params,
	            success: function success(response) {
	                popups.create({ title: 'Успех!', text: 'Сохраненно!', style: 'popup-success' });
	            }
	        });
	    };
	
	    self.reload = function () {
	        self.settings = [];
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'SmsProvider',
	            method: 'Fetch',
	            success: function success(response) {
	                self.providers = response.items;
	                var active = self.providers.filter(function (item) {
	                    return item.isActive == 1;
	                });
	                self.balance = undefined;
	                self.update();
	
	                if (active.length) {
	                    self.link = /http(s)*:\/\//.test(active[0].url) ? active[0].url : 'http://' + active[0].url;
	                    API.request({
	                        object: 'SmsProvider',
	                        method: 'info',
	                        data: { id: active[0].id },
	                        success: function success(response) {
	                            self.balance = response.balance;
	                            self.description = response.description;
	                            self.update();
	                        }
	                    });
	
	                    self.item = { id: active[0].id };
	
	                    try {
	                        var settings = JSON.parse(active[0].settings);
	                        for (var param in settings) {
	                            var item = (0, _extends3.default)({ name: param }, settings[param]);
	                            self.settings.push(item);
	                            self.item[param] = settings[param].value || '';
	                        }
	                    } catch (e) {
	                        self.settings = [];
	                    }
	                }
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    self.on('mount', function () {
	        self.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API, observable) {'use strict';
	
	riot.tag2('sms-template-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/sms"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Новый SMS шаблон\' : item.name || \'Редактирование SMS шаблона\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Заголовок</label>\n            <input class="form-control" name="name" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.code}">\n            <label class="control-label">Код</label>\n            <input class="form-control" name="code" value="{item.code}">\n            <div class="help-block">{error.code}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.phone}">\n            <label class="control-label">Телефон</label>\n            <input class="form-control" name="phone" value="{item.phone}">\n            <div class="help-block">{error.phone}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group">\n            <label class="control-label">Отправитель</label>\n            <input class="form-control" name="sender" value="{item.sender}">\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group {has-error: error.text}">\n            <label class="control-label">Текст</label>\n            <textarea class="form-control" name="text" value="{item.text}" rows="5" style="min-width: 100%; max-width: 100%;"></textarea>\n            <div class="help-block">{error.text}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input name="isActive" type="checkbox" __checked="{item.isActive == 1}">Активен\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var _extends2 = __webpack_require__(6);
	
	    var _extends3 = _interopRequireDefault(_extends2);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : { 'default': obj };
	    }
	
	    var self = this;
	
	    self.item = {};
	    self.loader = false;
	    self.error = false;
	    self.mixin('permissions');
	    self.mixin('validation');
	    self.mixin('change');
	
	    self.rules = {
	        name: 'empty',
	        code: 'empty',
	        text: 'empty',
	        phone: {
	            required: true,
	            rules: [{
	                type: 'phone'
	            }]
	        }
	    };
	
	    self.afterChange = function (e) {
	        var name = e.target.name;
	        delete self.error[name];
	        self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
	    };
	
	    self.submit = function (e) {
	        var params = self.item;
	        self.error = self.validation.validate(params, self.rules);
	
	        if (!self.error) {
	            API.request({
	                object: 'SmsTemplate',
	                method: 'Save',
	                data: params,
	                success: function success(response) {
	                    self.item = response;
	                    popups.create({ title: 'Успех!', text: 'SMS шаблон сохранен!', style: 'popup-success' });
	                    observable.trigger('sms-reload');
	                }
	            });
	        }
	    };
	
	    self.reload = function () {
	        observable.trigger('sms-edit', self.item.id);
	    };
	
	    observable.on('sms-edit', function (id) {
	        self.item = {};
	        self.loader = true;
	        self.error = false;
	        var params = { id: id };
	        self.update();
	
	        API.request({
	            object: 'SmsTemplate',
	            method: 'Info',
	            data: params,
	            success: function success(response) {
	                self.item = response;
	            },
	            error: function error(response) {
	                self.item = {};
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    });
	
	    observable.on('sms-new', function () {
	        self.item = {};
	        self.loader = false;
	        self.error = false;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(5)))

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	riot.tag2('sms-templates', '  <catalog search="true" sortable="true" object="SmsTemplate" cols="{cols}" reload="true" add="{permission(add, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;settings&quot;, &quot;1000&quot;)}" store="sms-templates">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	
	    self.mixin('remove');
	    self.mixin('permissions');
	
	    self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'name', value: 'Наименование' }];
	
	    self.add = function () {
	        riot.route('/settings/sms/new');
	    };
	
	    self.open = function (e) {
	        riot.route('/settings/sms/' + e.item.row.id);
	    };
	
	    observable.on('sms-reload', function () {
	        return self.tags.catalog.reload();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(504);
	
	__webpack_require__(506);
	
	__webpack_require__(503);
	
	riot.tag2('sms', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#sms-templates">Шаблоны</a></li>\n    <li><a data-toggle="tab" href="#sms-settings">Настройки</a></li>\n    <li><a data-toggle="tab" href="#sms-journal">Журнал</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="sms-templates">\n      <sms-templates></sms-templates>\n    </div>\n    <div class="tab-pane fade" id="sms-settings">\n      <sms-settings></sms-settings>\n    </div>\n    <div class="tab-pane fade" id="sms-journal">\n      <sms-journal></sms-journal>\n    </div>\n  </div>\n', '', '', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var _debounce = __webpack_require__(19);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	riot.tag2('settings-synhro-1c', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="row">\n      <div class="col-md-12">\n        <div class="h4"><a href="http://help.siteedit.ru/1c/" target="blank"><i class="fa fa-fw fa-info-circle"></i>Справка</a></div>\n      </div>\n    </div>\n    <form action="" onchange="{changeSettings1c}" onkeyup="{changeSettings1c}" method="POST">\n      <div class="row">\n        <div class="col-xs-12 col-md-6">\n          <div class="panel panel-default">\n            <div class="panel-heading">\n              <h3 class="panel-title">Основные настройки обмена</h3>\n            </div>\n            <div class="panel-body">\n              <div class="form-group">\n                <label class="control-label">Имя пользователя (логин) для авторизации</label>\n                <input class="form-control input-sm" name="login" value="{item.login}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Пароль пользователя для авторизации</label>\n                <input class="form-control input-sm" name="password" value="{item.password}" type="password">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Язык сайта для импорта</label>\n                <input class="form-control input-sm" name="lang" value="{item.lang}" type="text">\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="zip" __checked="{item.zip == &quot;yes&quot;}" type="checkbox" data-bool="Y,N"> Использовать zip сжатие при обмене\n                </label>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Максимальный размер пакета в байтах</label>\n                <input class="form-control input-sm" name="limit_filesize" value="{item.limit_filesize}" type="{\'number\'}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Максимальное время обработки в секундах</label>\n                <input class="form-control input-sm" name="max_execution_time" min="1" max="90" value="{item.max_execution_time}" type="{\'number\'}">\n              </div>\n            </div>\n          </div>\n          <div class="panel panel-default">\n            <div class="panel-heading">\n              <h3 class="panel-title">Настройки обмена заказами</h3>\n            </div>\n            <div class="panel-body">\n              <div class="form-group">\n                <label class="control-label">Изменить статус если заказ проведен</label>\n                <select class="form-control input-sm" name="change_status" value="{item.change_status}">\n                  <option value="Y">Оплачен</option>\n                  <option value="N">Не оплачен</option>\n                  <option value="K">Кредит</option>\n                  <option value="P">Подарок</option>\n                  <option value="false">Не менять</option>\n                </select>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="new_date_order" __checked="{item.new_date_order == &quot;Y&quot;}" type="checkbox" data-bool="Y,N">                        Записывать дату заказа на сайте датой по 1с\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="new_date_payee" type="checkbox" data-bool="Y,N" __checked="{item.new_date_payee == &quot;Y&quot;}">                        Записывать дату оплаты на сайте датой по 1с\n                </label>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Дата с которой необходимо экспортировать заказы</label>\n                <input class="form-control input-sm" name="date_export_orders" value="{item.date_export_orders}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Соответствие валют сайта и 1с при обмене заказами</label>\n                <input class="form-control input-sm" name="conform_currency" value="{item.conform_currency}" type="text">\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="export_only_update" __checked="{item.export_only_update == &quot;Y&quot;}" type="checkbox" data-bool="Y,N">                        Выгружать только измененные заказы с сайта\n                </label>\n              </div>\n            </div>\n          </div>\n          <div class="panel panel-default">\n            <div class="panel-heading">\n              <h3 class="panel-title">Настройки синхронизации с существующими товарами на сайте*</h3>\n            </div>\n            <div class="panel-body">\n              <div class="checkbox">\n                <label>\n                  <input name="=&quot;ex_group_name&quot;" type="checkbox" data-bool="Y,N" __checked="{item.ex_group_name == &quot;Y&quot;}">                        Синхронизация групп товаров по наименованию\n                </label>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Синхронизация каталога товаров</label>\n                <select class="form-control input-sm" name="ex_catalog_product" value="{item.ex_catalog_product}">\n                  <option value="1" selected="">Не использовать</option>\n                  <option value="2">По наименованию</option>\n                  <option value="3">По артиклу</option>\n                  <option value="4">По наименованию или артиклу</option>\n                  <option value="5">По наименованию и артиклу</option>\n                </select>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="ex_catalog_group" type="checkbox" data-bool="Y,N" __checked="{item.ex_catalog_group == &quot;Y&quot;}">                        Соблюдение иерархии групп при идентификации товаров\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="col-xs-12 col-md-6">\n          <div class="panel panel-default">\n            <div class="panel-heading">\n              <h3 class="panel-title">Настройки импорта каталога товаров</h3>\n            </div>\n            <div class="panel-body">\n              <div class="form-group">\n                <label class="control-label">Наименование доп. реквизита используемого как производитель</label>\n                <input class="form-control input-sm" name="manufacturer" value="{item.manufacturer}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Название доп. параметра для неизвестных характеристик т.овара</label>\n                <input class="form-control input-sm" name="new_param" value="{item.new_param}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Тип записи кода групп товаров</label>\n                <select class="form-control input-sm" name="code_group" value="{item.code_group}">\n                  <option value="translit">Транслит</option>\n                  <option value="id">Ид по 1с</option>\n                </select>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Тип записи кода товаров</label>\n                <select class="form-control input-sm" name="code_product" value="{item.code_product}">\n                  <option value="translit">Транслит</option>\n                  <option value="article">Артикул</option>\n                  <option value="barcode">Штрихкод по 1с</option>\n                  <option value="id">Ид по 1с</option>\n                </select>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Основная картинка товара</label>\n                <select class="form-control input-sm" name="main_image" value="{item.main_image}">\n                  <option value="first">Первая</option>\n                  <option value="last">Последняя</option>\n                </select>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Id группы для всех импортируемых товаров</label>\n                <input class="form-control input-sm" name="parent_group" value="{item.parent_group}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Тип цены (типовое соглашение) для импорта основной цены товара</label>\n                <input class="form-control input-sm" name="price_main" value="{item.price_main}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Типа цен (типовое соглашение) для импорта оптовой цены товара</label>\n                <input class="form-control input-sm" name="price_opt" value="{item.price_opt}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Тип цены (типовое соглашение) для импорта цены "мелкий опт"</label>\n                <input class="form-control input-sm" name="price_opt_corp" value="{item.price_opt_corp}" type="text">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Обновления полей и товаров</label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_name_group" __checked="{item.upd_name_group == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Наименования групп товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_code_group" __checked="{item.upd_code_group == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Коды групп товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_upid_group" __checked="{item.upd_upid_group == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Родители групп товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_name_product" __checked="{item.upd_name_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Наименования товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_group_product" __checked="{item.upd_group_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Группы, указанные в товарах\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_code_product" __checked="{item.upd_code_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Коды товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_article_product" __checked="{item.upd_article_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Артикулы товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_manufacturer_product" __checked="{item.upd_manufacturer_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Производители товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_note_product" __checked="{item.upd_note_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Краткие описания товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_text_product" __checked="{item.upd_text_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Подробные описания товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_measure_product" __checked="{item.upd_measure_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Единицы измерения у товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_weight_product" __checked="{item.upd_weight_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Значения веса товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_main_image_product" __checked="{item.upd_main_image_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Основные картинки товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_more_image_product" __checked="{item.upd_more_image_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Дополнительные картинки товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="remove_product" __checked="{item.remove_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Удалять товары, помеченые на удаление в 1С\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_price_product" __checked="{item.upd_price_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Обновление ценовых предложений товаров\n                </label>\n              </div>\n              <div class="checkbox">\n                <label>\n                  <input name="upd_count_product" __checked="{item.upd_count_product == &quot;Y&quot;}" type="checkbox" data-bool="Y,N"> Обновление остатков товаров\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this,
	        route = riot.route.create();
	
	    self.item = {};
	    self.mixin('change');
	    self.mixin('permissions');
	
	    var save = (0, _debounce2.default)(function (e) {
	        API.request({
	            object: 'SettingSynhro1C',
	            method: 'Save',
	            data: self.item,
	            complete: function complete() {
	                return self.update();
	            }
	        });
	    }, 600);
	
	    self.changeSettings1c = function (e) {
	        if (self.checkPermission('settings', '0010')) {
	            self.change(e);
	            save();
	        } else {
	            e.target.value = self.item[e.target.getAttribute('name')];
	        }
	    };
	
	    self.reload = function () {
	        self.loader = true;
	        self.update();
	
	        API.request({
	            object: 'SettingSynhro1C',
	            method: 'Info',
	            data: {},
	            success: function success(response) {
	                self.item = response;
	            },
	            complete: function complete() {
	                self.loader = false;
	                self.update();
	            }
	        });
	    };
	
	    route('/settings/settings-synhro-1c', function () {
	        self.reload();
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, observable) {'use strict';
	
	__webpack_require__(459);
	
	__webpack_require__(458);
	
	__webpack_require__(161);
	
	__webpack_require__(160);
	
	riot.tag2('user-reviews', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}" title="{title}"><a href="#reviews/{link}"><i class="{icon}"></i><span class="hidden-xs">&nbsp;{title}</span></a></li>\n  </ul>\n  <div class="column">\n    <reviews-list if="{tab == &quot;reviews&quot; &amp;&amp; !edit}"></reviews-list>\n    <review-edit if="{tab == &quot;reviews&quot; &amp;&amp; edit}"></review-edit>\n    <comments-list if="{tab == &quot;comments&quot; &amp;&amp; !edit}"></comments-list>\n    <comment-edit if="{tab == &quot;comments&quot; &amp;&amp; edit}"></comment-edit>\n  </div>\n', '', '', function (opts) {
	    'use strict';
	
	    var self = this;
	    self.tab = '';
	    self.edit = false;
	
	    self.tabs = [{ title: 'Отзывы', name: 'reviews', link: '', permission: 'reviews', icon: 'fa fa-comment-o' }, { title: 'Комментарии', name: 'comments', link: 'comments', permission: 'comments', icon: 'fa fa-comments-o' }];
	
	    var route = riot.route.create();
	    route('/reviews', function () {
	        self.edit = false;
	        self.tab = 'reviews';
	        self.update();
	    });
	
	    route('/reviews/([0-9]+)', function (id) {
	        observable.trigger('review-edit', id);
	        self.notFound = false;
	        self.tab = 'reviews';
	        self.edit = true;
	        self.update();
	    });
	
	    route('/reviews/new', function () {
	        self.update({ edit: true, notFound: false });
	        observable.trigger('review-new');
	    });
	
	    route('/reviews/comments', function () {
	        self.notFound = false;
	        self.edit = false;
	        self.tab = 'comments';
	        self.update();
	    });
	
	    route('/reviews/comments/([0-9]+)', function (id) {
	        observable.trigger('comment-edit', id);
	        self.notFound = false;
	        self.tab = 'comments';
	        self.edit = true;
	        self.update();
	    });
	
	    route('/reviews/comments/new', function () {
	        self.notFound = false;
	        self.edit = true;
	        self.tab = 'comments';
	
	        observable.trigger('comment-new');
	        self.update();
	    });
	
	    route('/reviews/comments..', function () {
	        self.notFound = true;
	        self.update();
	        observable.trigger('not-found');
	    });
	
	    self.on('mount', function () {
	        riot.route.exec();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(5)))

/***/ },
/* 510 */
/***/ function(module, exports) {

	'use strict';
	
	var helpers = Chart.helpers;
	
	Chart.defaults.funnel.sort = undefined;
	Chart.controllers.funnel.prototype.update = function (reset) {
	    var me = this;
	    var chart = me.chart,
	        chartArea = chart.chartArea,
	        opts = chart.options,
	        meta = me.getMeta(),
	        elements = meta.data,
	        borderWidth = opts.elements.borderWidth || 0,
	        availableWidth = chartArea.right - chartArea.left - borderWidth * 2,
	        availableHeight = chartArea.bottom - chartArea.top - borderWidth * 2;
	
	    // top and bottom width
	    var bottomWidth = availableWidth,
	        topWidth = (opts.topWidth < availableWidth ? opts.topWidth : availableWidth) || 0;
	    if (opts.bottomWidth) {
	        bottomWidth = opts.bottomWidth < availableWidth ? opts.bottomWidth : availableWidth;
	    }
	
	    // percentage calculation and sort data
	    var sort = opts.sort,
	        dataset = me.getDataset(),
	        valAndLabels = [],
	        visiableNum = 0,
	        dMax = 0;
	    helpers.each(dataset.data, function (val, index) {
	        var backgroundColor = helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index),
	            hidden = elements[index].hidden;
	        //if (!elements[index].hidden) {
	        valAndLabels.push({
	            hidden: hidden,
	            orgIndex: index,
	            val: val,
	            backgroundColor: backgroundColor,
	            borderColor: helpers.getValueAtIndexOrDefault(dataset.borderColor, index, backgroundColor),
	            label: helpers.getValueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
	        });
	        //}
	        if (!elements[index].hidden) {
	            visiableNum++;
	            dMax = val > dMax ? val : dMax;
	        }
	    });
	    var dwRatio = bottomWidth / dMax;
	    var sortedDataAndLabels = !sort ? valAndLabels : valAndLabels.sort(sort === 'asc' ? function (a, b) {
	        return a.val - b.val;
	    } : function (a, b) {
	        return b.val - a.val;
	    });
	    // For render hidden view
	    // TODO: optimization....
	    var _viewIndex = 0;
	    helpers.each(sortedDataAndLabels, function (dal, index) {
	        dal._viewIndex = !dal.hidden ? _viewIndex++ : -1;
	    });
	
	    // Elements height calculation
	    var gap = opts.gap || 0,
	        elHeight = (availableHeight - (visiableNum - 1) * gap) / visiableNum;
	
	    // save
	    me.topWidth = topWidth;
	    me.dwRatio = dwRatio;
	    me.elHeight = elHeight;
	    me.sortedDataAndLabels = sortedDataAndLabels;
	    me.maxVal = Math.max.apply(null, sortedDataAndLabels.map(function (value) {
	        return !value.hidden ? value.val : undefined;
	    }).filter(function (value) {
	        return value;
	    }));
	    me.minVal = Math.min.apply(null, sortedDataAndLabels.map(function (value) {
	        return !value.hidden ? value.val : undefined;
	    }).filter(function (value) {
	        return value;
	    }));
	    me.chartWidth = availableWidth;
	    me.deltaVal = me.maxVal - (opts.minWidth || 10) / me.chartWidth * me.maxVal || 0;
	
	    helpers.each(elements, function (trapezium, index) {
	        me.updateElement(trapezium, index, reset);
	    }, me);
	};
	
	Chart.controllers.funnel.prototype.updateElement = function updateElement(trapezium, index, reset) {
	    var me = this,
	        chart = me.chart,
	        chartArea = chart.chartArea,
	        opts = chart.options,
	        sort = opts.sort,
	        dwRatio = me.dwRatio,
	        elHeight = me.elHeight,
	        gap = opts.gap || 0,
	        minWidth = opts.minWidth || 10,
	        minValue = me.minVal,
	        chartWidth = me.chartWidth,
	        deltaValue = me.deltaVal,
	        borderWidth = opts.elements.borderWidth || 0;
	
	    // calculate x,y,base, width,etc.
	    var x,
	        y,
	        x1,
	        x2,
	        elementType = 'isosceles',
	        elementData = me.sortedDataAndLabels[index],
	        upperWidth,
	        bottomWidth,
	        viewIndex = elementData._viewIndex < 0 ? index : elementData._viewIndex,
	        base = chartArea.top + (viewIndex + 1) * (elHeight + gap) - gap;
	
	    if (sort === 'asc') {
	        // Find previous element which is visible
	        var previousElement = helpers.findPreviousWhere(me.sortedDataAndLabels, function (el) {
	            return !el.hidden;
	        }, index);
	        upperWidth = nextElement ? (chartWidth - minWidth) * (previousElement.val * (1 - minWidth / chartWidth) / deltaValue) + minWidth : me.topWidth;
	        bottomWidth = (chartWidth - minWidth) * (elementData.val * (1 - minWidth / chartWidth) / deltaValue) + minWidth;
	    } else {
	        var nextElement = helpers.findNextWhere(me.sortedDataAndLabels, function (el) {
	            return !el.hidden;
	        }, index);
	        upperWidth = (chartWidth - minWidth) * (elementData.val * (1 - minWidth / chartWidth) / deltaValue) + minWidth;
	        bottomWidth = nextElement ? (chartWidth - minWidth) * (nextElement.val * (1 - minWidth / chartWidth) / deltaValue) + minWidth : me.topWidth;
	    }
	
	    y = chartArea.top + viewIndex * (elHeight + gap);
	    if (opts.keep === 'left') {
	        elementType = 'scalene';
	        x1 = chartArea.left + upperWidth / 2;
	        x2 = chartArea.left + bottomWidth / 2;
	    } else if (opts.keep === 'right') {
	        elementType = 'scalene';
	        x1 = chartArea.right - upperWidth / 2;
	        x2 = chartArea.right - bottomWidth / 2;
	    } else {
	        x = (chartArea.left + chartArea.right) / 2;
	    }
	
	    helpers.extend(trapezium, {
	        // Utility
	        _datasetIndex: me.index,
	        _index: elementData.orgIndex,
	
	        // Desired view properties
	        _model: {
	            type: elementType,
	            y: y,
	            base: base > chartArea.bottom ? chartArea.bottom : base,
	            x: x,
	            x1: x1,
	            x2: x2,
	            upperWidth: reset || !!elementData.hidden ? 0 : upperWidth,
	            bottomWidth: reset || !!elementData.hidden ? 0 : bottomWidth,
	            borderWidth: borderWidth,
	            backgroundColor: elementData && elementData.backgroundColor,
	            borderColor: elementData && elementData.borderColor,
	            label: elementData && elementData.label
	        }
	    });
	
	    trapezium.pivot();
	};

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(app, riot) {'use strict';
	
	var permissions = {
	    isAdmin: function isAdmin() {
	        return app.config.isAdmin || false;
	    },
	    checkMask: function checkMask(mask, objectMask) {
	        mask = parseInt(mask.toString(), 2);
	        objectMask = parseInt(objectMask.toString());
	        return (mask & objectMask) === mask;
	    },
	    checkPermission: function checkPermission(object, mask) {
	        var p = app.permissions || {};
	        if (this.isAdmin() || !(object in p)) {
	            return true;
	        } else {
	            return this.checkMask(mask, p[object]);
	        }
	    },
	    permission: function permission(f, object, mask) {
	        return this.checkPermission(object, mask) ? f : undefined;
	    }
	};
	
	riot.mixin('permissions', permissions);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(1)))

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot, API) {'use strict';
	
	var changeMixin = {
	    change: function change(e) {
	        if (!e.target && !e.target.name) return;
	
	        if (typeof this.beforeChange === 'function') this.beforeChange(e);
	
	        var bannedTypes = ['checkbox', 'file', 'color', 'range', 'number', 'radio'];
	
	        if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
	            var selectionStart = e.target.selectionStart;
	            var selectionEnd = e.target.selectionEnd;
	        }
	
	        if (e.target && e.target.type === 'checkbox' && e.target.name) {
	            var bool = e.target.getAttribute('data-bool');
	            if (!bool) this.item[e.target.name] = e.target.checked;else this.item[e.target.name] = e.target.checked ? bool.split(',')[0] : bool.split(',')[1];
	        }
	
	        if (e.target && e.target.type !== 'checkbox' && e.target.name) this.item[e.target.name] = e.target.value;
	        if (e.currentTarget.tagName !== 'FORM' && e.currentTarget.name !== '') this.item[e.currentTarget.name] = e.currentTarget.value;
	
	        if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
	            this.update();
	            e.target.selectionStart = selectionStart;
	            e.target.selectionEnd = selectionEnd;
	        }
	
	        if (typeof this.afterChange === 'function') this.afterChange(e);
	        this.item['_edit_'] = true;
	    }
	};
	
	riot.mixin('change', changeMixin);
	
	var removeMixin = {
	    remove: function remove(e, items, tag) {
	        var self = this,
	            params = { ids: items };
	
	        if (items.allMode !== undefined) {
	            params = items;
	        }
	
	        //tag.loader = true
	        modals.create('bs-alert', {
	            type: 'modal-danger',
	            title: 'Предупреждение',
	            text: items.length > 1 ? 'Вы точно хотите удалить эти записи?' : 'Вы точно хотите удалить эту запись?',
	            size: 'modal-sm',
	            buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
	            callback: function callback(action) {
	                if (action === 'yes') {
	                    /**
	                     * @param  str  object  self.collection   exm:"Product"
	                     * @param  str  method  'Delete'
	                     * @param  array  data  params  список ид на удаление
	                     *                              или при всех выбранных: отметка + параметры
	                     */
	                    API.request({
	                        object: self.collection,
	                        method: 'Delete',
	                        data: params,
	                        success: function success(response) {
	                            popups.create({ title: 'Успешно удалено!', style: 'popup-success' });
	                            tag.afterRemove();
	                        }
	                    });
	                }
	                this.modalHide();
	            }
	        });
	    }
	};
	
	riot.mixin('remove', removeMixin);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, riot) {'use strict';
	
	var _keys = __webpack_require__(108);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(74);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var validation = {
	    regExp: {
	        bracket: /\[(.*)\]/i,
	        decimal: /^\d*(\.)\d+/,
	        email: /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
	        escape: /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
	        flags: /^\/(.*)\/(.*)?/,
	        phone: /^(\+[0-9_\-\s\)\(]+)/,
	        integer: /^\-?\d+$/,
	        number: /^\-?\d*(\.\d+)?$/,
	        url: /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/i
	    },
	    prompt: {
	        empty: 'Поле не должно быть пустым',
	        checked: 'Флажок должен быть включен',
	        email: 'Введите правильный e-mail',
	        phone: 'Введите правильный номер телефона',
	        url: 'Введите правильную ссылку',
	        regExp: ' ',
	        integer: 'Поле должно быть целым числом',
	        decimal: 'Поле должно быть вещественным числом',
	        number: 'Поле должно быть числом',
	        is: 'Поле должно быть "{ruleValue}"',
	        isExactly: 'Поле должно быть "{ruleValue}"',
	        not: 'Поле не должно быть "{ruleValue}"',
	        notExactly: 'Поле не должно быть "{ruleValue}"',
	        contain: 'Поле должно содержать "{ruleValue}"',
	        containExactly: 'Поле должно содержать "{ruleValue}"',
	        doesntContain: 'Поле не должно содержать "{ruleValue}"',
	        doesntContainExactly: 'Поле не должно содержать "{ruleValue}"',
	        minLength: 'Поле должно быть не менее {ruleValue} символов',
	        maxLength: 'Поле должно быть не более {ruleValue} символов',
	        match: ' ',
	        different: ' ',
	        minCount: ' ',
	        maxCount: ' '
	    },
	
	    bracketedRule: function bracketedRule(rule) {
	        return rule.type && rule.type.match(this.regExp.bracket);
	    },
	    ancillaryValue: function ancillaryValue(rule) {
	        if (!rule.type || !this.bracketedRule(rule)) {
	            return false;
	        }
	        return rule.type.match(this.regExp.bracket)[1] + '';
	    },
	    ruleName: function ruleName(rule) {
	        if (this.bracketedRule(rule)) {
	            return rule.type.replace(rule.type.match(this.regExp.bracket)[0], '');
	        }
	        return rule.type;
	    },
	
	
	    rules: {
	        empty: function empty(value) {
	            return !(value === undefined || '' === value || Array.isArray(value) && value.length === 0);
	        },
	
	
	        // checkbox checked
	        checked: function checked(value) {
	            return value;
	        },
	
	
	        // is most likely an email
	        email: function email(value) {
	            return !value || this.regExp.email.test(value);
	        },
	
	
	        // value is most likely url
	        url: function url(value) {
	            return this.regExp.url.test(value);
	        },
	        phone: function phone(value) {
	            return !value || this.regExp.phone.test(value);
	        },
	        regExp: function regExp(value, _regExp) {
	            var regExpParts = _regExp.match(this.regExp.flags),
	                flags;
	            // regular expression specified as /baz/gi (flags)
	            if (regExpParts) {
	                _regExp = regExpParts.length >= 2 ? regExpParts[1] : _regExp;
	                flags = regExpParts.length >= 3 ? regExpParts[2] : '';
	            }
	            return value.match(new RegExp(_regExp, flags));
	        },
	
	
	        // is valid integer or matches range
	        integer: function integer(value, range) {
	            var intRegExp = this.regExp.integer,
	                min,
	                max,
	                parts;
	
	            if (!range || ['', '..'].indexOf(range) !== -1) {
	                // do nothing
	            } else if (range.indexOf('..') == -1) {
	                if (intRegExp.test(range)) min = max = range - 0;
	            } else {
	                parts = range.split('..', 2);
	                if (intRegExp.test(parts[0])) min = parts[0] - 0;
	                if (intRegExp.test(parts[1])) max = parts[1] - 0;
	            }
	            return intRegExp.test(value) && (min === undefined || value >= min) && (max === undefined || value <= max);
	        },
	        decimal: function decimal(value) {
	            return this.regExp.decimal.test(value);
	        },
	
	
	        // is valid number
	        number: function number(value) {
	            return this.regExp.number.test(value);
	        },
	
	
	        // is value (case insensitive)
	        is: function is(value, text) {
	            text = typeof text == 'string' ? text.toLowerCase() : text;
	            value = typeof value == 'string' ? value.toLowerCase() : value;
	            return value == text;
	        },
	
	
	        // is value
	        isExactly: function isExactly(value, text) {
	            return value == text;
	        },
	
	
	        // value is not another value (case insensitive)
	        not: function not(value, notValue) {
	            value = typeof value == 'string' ? value.toLowerCase() : value;
	            notValue = typeof notValue == 'string' ? notValue.toLowerCase() : notValue;
	            return value != notValue;
	        },
	
	
	        // value is not another value (case sensitive)
	        notExactly: function notExactly(value, notValue) {
	            return value != notValue;
	        },
	
	
	        // value contains text (insensitive)
	        contains: function contains(value, text) {
	            text = text.replace(this.regExp.escape, "\\$&");
	            return value.search(new RegExp(text, 'i')) !== -1;
	        },
	
	
	        // value contains text (case sensitive)
	        containsExactly: function containsExactly(value, text) {
	            text = text.replace(this.regExp.escape, "\\$&");
	            return value.search(new RegExp(text)) !== -1;
	        },
	
	
	        // value contains text (insensitive)
	        doesntContain: function doesntContain(value, text) {
	            text = text.replace(this.regExp.escape, "\\$&");
	            return value.search(new RegExp(text, 'i')) === -1;
	        },
	
	
	        // value contains text (case sensitive)
	        doesntContainExactly: function doesntContainExactly(value, text) {
	            text = text.replace(this.regExp.escape, "\\$&");
	            return value.search(new RegExp(text)) === -1;
	        },
	        match: function match(value, identifier) {
	            return identifier !== undefined ? value.toString() === identifier.toString() : false;
	        },
	
	
	        // different than another field
	        different: function different(value, identifier) {
	            return identifier !== undefined ? value.toString() !== identifier.toString() : false;
	        },
	        minLength: function minLength(value, requiredLength) {
	            return value !== undefined ? value.length >= requiredLength : false;
	        },
	
	
	        // is less than length
	        maxLength: function maxLength(value, _maxLength) {
	            return value !== undefined ? value.length <= _maxLength : false;
	        },
	        minCount: function minCount(value, _minCount) {
	            if (_minCount == 0) return true;
	            if (_minCount == 1) return value !== '';
	            return value.split(',').length >= _minCount;
	        },
	        maxCount: function maxCount(value, _maxCount) {
	            if (_maxCount == 0) return false;
	            if (_maxCount == 1) return value.search(',') === -1;
	            return value.split(',').length <= _maxCount;
	        }
	    },
	
	    validateRule: function validateRule(value, rule, item) {
	        var result = void 0;
	        var ruleValue = '';
	        var ruleName = this.ruleName(rule);
	        var prompt = this.prompt[ruleName];
	
	        if (this.rules.hasOwnProperty(ruleName) && typeof this.rules[ruleName] === 'function') {
	
	            if (this.bracketedRule(rule)) {
	                if (['match', 'different'].indexOf(ruleName) === -1) {
	                    ruleValue = this.ancillaryValue(rule);
	                    result = this.rules[ruleName].bind(this)(value, ruleValue);
	                } else {
	                    ruleValue = item[this.ancillaryValue(rule)];
	                    result = this.rules[ruleName].bind(this)(value, ruleValue);
	                }
	            } else {
	                result = this.rules[ruleName].bind(this)(value);
	            }
	
	            if (!result) {
	                return (rule.prompt || prompt).replace('{ruleValue}', ruleValue);
	            } else {
	                return undefined;
	            }
	        }
	    },
	    validateRules: function validateRules(value, ruleValues, item) {
	        var prompt = void 0;
	
	        if (typeof ruleValues === 'string') prompt = this.validateRule(value, { type: ruleValues }, item);
	
	        if (ruleValues instanceof Array && Array.isArray(ruleValues)) {
	            for (var i = 0; i < ruleValues.length; i++) {
	                var rule = ruleValues[i];
	
	                if (typeof rule === 'string') prompt = this.validateRule(value, { type: rule }, item);
	
	                if ((typeof rule === 'undefined' ? 'undefined' : (0, _typeof3.default)(rule)) === 'object' && !Array.isArray(rule)) prompt = this.validateRule(value, rule, item);
	
	                if (prompt) break;
	            }
	        }
	
	        if ((typeof ruleValues === 'undefined' ? 'undefined' : (0, _typeof3.default)(ruleValues)) === 'object' && !Array.isArray(ruleValues)) {
	            var required = ruleValues.hasOwnProperty('required') ? ruleValues.required : false;
	            var rules = ruleValues.rules || [];
	
	            if (!required && value === '') {
	                return;
	            }
	
	            if (Array.isArray(rules)) {
	                for (var _i = 0; _i < rules.length; _i++) {
	                    var _rule = rules[_i];
	
	                    if (typeof _rule === 'string') prompt = this.validateRule(value, { type: _rule }, item);
	
	                    if ((typeof _rule === 'undefined' ? 'undefined' : (0, _typeof3.default)(_rule)) === 'object' && !Array.isArray(_rule)) prompt = this.validateRule(value, _rule, item);
	
	                    if (prompt) break;
	                }
	            }
	        }
	        return prompt;
	    },
	    validate: function validate(item, fields, fieldName) {
	        var result = {};
	        var prompt = void 0;
	
	        if (typeof fieldName === 'string' && fieldName !== '') {
	            var ruleValues = fields[fieldName];
	            var value = item[fieldName] || '';
	            prompt = this.validateRules(value, ruleValues, item);
	            if (prompt) result[fieldName] = prompt;
	        } else {
	            for (var field in fields) {
	                var _ruleValues = fields[field];
	                var _value = item[field] || '';
	                prompt = this.validateRules(_value, _ruleValues, item);
	                if (prompt) result[field] = prompt;
	            }
	        }
	
	        return (0, _keys2.default)(result).length ? result : false;
	    }
	};
	
	module.export = validation;
	
	var validationMixin = {
	    validation: validation
	};
	
	riot.mixin('validation', validationMixin);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module), __webpack_require__(1)))

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(787);
	
	__webpack_require__(842);
	
	__webpack_require__(570);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(572), __esModule: true };

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(574), __esModule: true };

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(576), __esModule: true };

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(577), __esModule: true };

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
	this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ },
/* 520 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 521 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 522 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 523 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 524 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 525 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 526 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // scatter should not use a category axis
					position: 'bottom',
					id: 'x-axis-1' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-1'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				meta.stack = dataset.stack;
				// Use this to indicate that this is a bar dataset.
				meta.bar = true;
			},
	
			// Correctly calculate the bar width accounting for stacks and the fact that not all bars are visible
			getStackCount: function() {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var stacks = [];
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var dsMeta = me.chart.getDatasetMeta(datasetIndex);
					if (dsMeta.bar && me.chart.isDatasetVisible(datasetIndex) &&
						(yScale.options.stacked === false ||
						(yScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(yScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}, me);
	
				return stacks.length;
			},
	
			update: function(reset) {
				var me = this;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					me.updateElement(rectangle, index, reset);
				}, me);
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = yScale.getBasePixel();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
	
				rectangle._xScale = xScale;
				rectangle._yScale = yScale;
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				var ruler = me.getRuler(index); // The index argument for compatible
				rectangle._model = {
					x: me.calculateBarX(index, me.index, ruler),
					y: reset ? scaleBase : me.calculateBarY(index, me.index),
	
					// Tooltip
					label: me.chart.data.labels[index],
					datasetLabel: dataset.label,
	
					// Appearance
					horizontal: false,
					base: reset ? scaleBase : me.calculateBarBase(me.index, index),
					width: me.calculateBarWidth(ruler),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
				};
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var base = yScale.getBaseValue();
				var original = base;
	
				if ((yScale.options.stacked === true) ||
					(yScale.options.stacked === undefined && meta.stack !== undefined)) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i) &&
							meta.stack === currentDsMeta.stack) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, original) : Math.max(currentVal, original);
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				return yScale.getBasePixel();
			},
	
			getRuler: function() {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var stackCount = me.getStackCount();
	
				var tickWidth = xScale.width / xScale.ticks.length;
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / stackCount;
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					stackCount: stackCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function(ruler) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				if (xScale.options.barThickness) {
					return xScale.options.barThickness;
				}
				return ruler.barWidth;
			},
	
			// Get stack index from the given dataset index accounting for stacks and the fact that not all bars are visible
			getStackIndex: function(datasetIndex) {
				var me = this;
				var meta = me.chart.getDatasetMeta(datasetIndex);
				var yScale = me.getScaleForId(meta.yAxisID);
				var dsMeta, j;
				var stacks = [meta.stack];
	
				for (j = 0; j < datasetIndex; ++j) {
					dsMeta = this.chart.getDatasetMeta(j);
					if (dsMeta.bar && this.chart.isDatasetVisible(j) &&
						(yScale.options.stacked === false ||
						(yScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(yScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}
	
				return stacks.length - 1;
			},
	
			calculateBarX: function(index, datasetIndex, ruler) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var stackIndex = me.getStackIndex(datasetIndex);
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				leftTick -= me.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * stackIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * stackIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (yScale.options.stacked ||
					(yScale.options.stacked === undefined && meta.stack !== undefined)) {
					var base = yScale.getBaseValue();
					var sumPos = base,
						sumNeg = base;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && me.chart.isDatasetVisible(i) &&
							meta.stack === dsMeta.stack) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					}
					return yScale.getPixelForValue(sumPos + value);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				var metaData = me.getMeta().data;
				var dataset = me.getDataset();
				var i, len;
	
				Chart.canvasHelpers.clipArea(me.chart.chart.ctx, me.chart.chartArea);
				for (i = 0, len = metaData.length; i < len; ++i) {
					var d = dataset.data[i];
					if (d !== null && d !== undefined && !isNaN(d)) {
						metaData[i].transition(easingDecimal).draw();
					}
				}
				Chart.canvasHelpers.unclipArea(me.chart.chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
	
			// Correctly calculate the bar width accounting for stacks and the fact that not all bars are visible
			getStackCount: function() {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
	
				var stacks = [];
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var dsMeta = me.chart.getDatasetMeta(datasetIndex);
					if (dsMeta.bar && me.chart.isDatasetVisible(datasetIndex) &&
						(xScale.options.stacked === false ||
						(xScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(xScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}, me);
	
				return stacks.length;
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = xScale.getBasePixel();
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
	
				rectangle._xScale = xScale;
				rectangle._yScale = yScale;
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				var ruler = me.getRuler(index); // The index argument for compatible
				rectangle._model = {
					x: reset ? scaleBase : me.calculateBarX(index, me.index),
					y: me.calculateBarY(index, me.index, ruler),
	
					// Tooltip
					label: me.chart.data.labels[index],
					datasetLabel: dataset.label,
	
					// Appearance
					horizontal: true,
					base: reset ? scaleBase : me.calculateBarBase(me.index, index),
					height: me.calculateBarHeight(ruler),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
				};
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var base = xScale.getBaseValue();
				var originalBase = base;
	
				if (xScale.options.stacked ||
					(xScale.options.stacked === undefined && meta.stack !== undefined)) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.xAxisID === xScale.id && chart.isDatasetVisible(i) &&
							meta.stack === currentDsMeta.stack) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, originalBase) : Math.max(currentVal, originalBase);
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				return xScale.getBasePixel();
			},
	
			getRuler: function() {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var stackCount = me.getStackCount();
	
				var tickHeight = yScale.height / yScale.ticks.length;
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / stackCount;
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					stackCount: stackCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing
				};
			},
	
			calculateBarHeight: function(ruler) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				if (yScale.options.barThickness) {
					return yScale.options.barThickness;
				}
				return ruler.barHeight;
			},
	
			// Get stack index from the given dataset index accounting for stacks and the fact that not all bars are visible
			getStackIndex: function(datasetIndex) {
				var me = this;
				var meta = me.chart.getDatasetMeta(datasetIndex);
				var xScale = me.getScaleForId(meta.xAxisID);
				var dsMeta, j;
				var stacks = [meta.stack];
	
				for (j = 0; j < datasetIndex; ++j) {
					dsMeta = this.chart.getDatasetMeta(j);
					if (dsMeta.bar && this.chart.isDatasetVisible(j) &&
						(xScale.options.stacked === false ||
						(xScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(xScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}
	
				return stacks.length - 1;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (xScale.options.stacked ||
					(xScale.options.stacked === undefined && meta.stack !== undefined)) {
					var base = xScale.getBaseValue();
					var sumPos = base,
						sumNeg = base;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && me.chart.isDatasetVisible(i) &&
							meta.stack === dsMeta.stack) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					}
					return xScale.getPixelForValue(sumPos + value);
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function(index, datasetIndex, ruler) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var stackIndex = me.getStackIndex(datasetIndex);
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				topTick -= me.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * stackIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * stackIndex);
			}
		});
	};


/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						var dataLabel = data.labels[tooltipItem.index];
						var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
						if (helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
	
						return dataLabel;
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ },
/* 530 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePixel()
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth)) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function(ease) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data || [];
				var easingDecimal = ease || 1;
				var i, ilen;
	
				// Transition Point Locations
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].transition(easingDecimal);
				}
	
				Chart.canvasHelpers.clipArea(me.chart.chart.ctx, me.chart.chartArea);
				// Transition and Draw the line
				if (lineEnabled(me.getDataset(), me.chart.options)) {
					meta.dataset.transition(easingDecimal).draw();
				}
				Chart.canvasHelpers.unclipArea(me.chart.chart.ctx);
	
				// Draw the points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].draw(me.chart.chartArea);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ },
/* 531 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				lineArc: true, // so that lines are circular
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ },
/* 532 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			aspectRatio: 1,
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePosition()
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.radius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ },
/* 533 */
/***/ function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @function Chart.animationService.addAnimation
			 * @param chartInstance {ChartController} the chart to animate
			 * @param animationObject {IAnimation} the animation that we will animate
			 * @param duration {Number} length of animation in ms
			 * @param lazy {Boolean} if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
				var me = this;
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < me.animations.length; ++index) {
					if (me.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						me.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				me.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (me.animations.length === 1) {
					me.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
				var me = this;
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				var i = 0;
				while (i < me.animations.length) {
					if (me.animations[i].animationObject.currentStep === null) {
						me.animations[i].animationObject.currentStep = 0;
					}
	
					me.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (me.animations[i].animationObject.currentStep > me.animations[i].animationObject.numSteps) {
						me.animations[i].animationObject.currentStep = me.animations[i].animationObject.numSteps;
					}
	
					me.animations[i].animationObject.render(me.animations[i].chartInstance, me.animations[i].animationObject);
					if (me.animations[i].animationObject.onAnimationProgress && me.animations[i].animationObject.onAnimationProgress.call) {
						me.animations[i].animationObject.onAnimationProgress.call(me.animations[i].chartInstance, me.animations[i]);
					}
	
					if (me.animations[i].animationObject.currentStep === me.animations[i].animationObject.numSteps) {
						if (me.animations[i].animationObject.onAnimationComplete && me.animations[i].animationObject.onAnimationComplete.call) {
							me.animations[i].animationObject.onAnimationComplete.call(me.animations[i].chartInstance, me.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						me.animations[i].chartInstance.animating = false;
	
						me.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / me.frameDuration;
	
				me.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			}
		};
	};


/***/ },
/* 534 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				Chart.helpers.drawRoundedRectangle(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	
		helpers.clipArea = function(ctx, clipArea) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(clipArea.left, clipArea.top, clipArea.right - clipArea.left, clipArea.bottom - clipArea.top);
			ctx.clip();
		};
	
		helpers.unclipArea = function(ctx) {
			ctx.restore();
		};
	
	};


/***/ },
/* 535 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var plugins = Chart.plugins;
		var platform = Chart.platform;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				Chart.defaults.global,
				Chart.defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart.Controller} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		/**
		 * @class Chart.Controller
		 * The main controller of a chart.
		 */
		Chart.Controller = function(item, config, instance) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			instance.ctx = context;
			instance.canvas = canvas;
			instance.config = config;
			instance.width = width;
			instance.height = height;
			instance.aspectRatio = height? width / height : null;
	
			me.id = helpers.uid();
			me.chart = instance;
			me.config = config;
			me.options = config.options;
			me._bufferedRender = false;
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return me;
			}
	
			me.initialize();
			me.update();
	
			return me;
		};
	
		helpers.extend(Chart.Controller.prototype, /** @lends Chart.Controller.prototype */ {
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me.chart);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var chart = me.chart;
				var options = me.options;
				var canvas = chart.canvas;
				var aspectRatio = (options.maintainAspectRatio && chart.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
				var newWidth = Math.floor(helpers.getMaximumWidth(canvas));
				var newHeight = Math.floor(aspectRatio? newWidth / aspectRatio : helpers.getMaximumHeight(canvas));
	
				if (chart.width === newWidth && chart.height === newHeight) {
					return;
				}
	
				canvas.width = chart.width = newWidth;
				canvas.height = chart.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(chart);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear'};
						})
					);
				}
	
				if (options.scale) {
					items.push({options: options.scale, dtype: 'radialLinear', isDefault: true});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.chart.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						lazy: lazy,
						duration: animationDuration
					};
				} else {
					me.render(animationDuration, lazy);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.getDatasetMeta(i).controller.update();
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			render: function(duration, lazy) {
				var me = this;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function() {
					plugins.notify(me, 'afterRender');
					var callback = animationOptions && animationOptions.onComplete;
					if (callback && callback.call) {
						callback.call(me);
					}
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || animationOptions.duration) / 16.66; // 60 fps
					animation.easing = animationOptions.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = animationOptions.onProgress;
					animation.onAnimationComplete = onComplete;
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
					onComplete();
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (easingValue === undefined || easingValue === null) {
					easingValue = 1;
				}
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
	
				// Finally draw the tooltip
				me.tooltip.transition(easingValue).draw();
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						me.getDatasetMeta(datasetIndex).controller.draw(easingValue);
					}
				}, me, true);
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Chart.Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Chart.Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Chart.Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Chart.Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Chart.Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.chart.canvas;
				var meta, i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					meta = me.getDatasetMeta(i);
					if (meta.controller) {
						meta.controller.destroy();
						meta.controller = null;
					}
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.clear(me.chart);
					platform.releaseContext(me.chart.ctx);
					me.chart.canvas = null;
					me.chart.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me.chart,
					_chartInstance: me,
					_data: me.data,
					_options: me.options.tooltips
				}, me);
				me.tooltip.initialize();
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Responsiveness is currently based on the use of an iframe, however this method causes
				// performance issues and could be troublesome when used with ad blockers. So make sure
				// that the user is still able to create a chart without iframe when responsive is false.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest.duration, bufferedRequest.lazy);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					// Need to call with native event here to not break backwards compatibility
					hoverOptions.onHover.call(me, e.native, me.active);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	};


/***/ },
/* 536 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				var i, len;
				var metaData = this.getMeta().data;
				for (i = 0, len = metaData.length; i < len; ++i) {
					metaData[i].transition(easingDecimal).draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i=0; i<count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length-1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ },
/* 537 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = helpers.clone(me._view);
				return me;
			},
	
			transition: function(ease) {
				var me = this;
	
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
	
				// No animation -> No Transition
				if (ease === 1) {
					me._view = me._model;
					me._start = null;
					return me;
				}
	
				if (!me._start) {
					me.pivot();
				}
	
				helpers.each(me._model, function(value, key) {
	
					if (key[0] === '_') {
						// Only non-underscored properties
					// Init if doesn't exist
					} else if (!me._view.hasOwnProperty(key)) {
						if (typeof value === 'number' && !isNaN(me._view[key])) {
							me._view[key] = value * ease;
						} else {
							me._view[key] = value;
						}
					// No unnecessary computations
					} else if (value === me._view[key]) {
						// It's the same! Woohoo!
					// Color transitions if possible
					} else if (typeof value === 'string') {
						try {
							var color = helpers.color(me._model[key]).mix(helpers.color(me._start[key]), ease);
							me._view[key] = color.rgbString();
						} catch (err) {
							me._view[key] = value;
						}
					// Number transitions
					} else if (typeof value === 'number') {
						var startVal = me._start[key] !== undefined && isNaN(me._start[key]) === false ? me._start[key] : 0;
						me._view[key] = ((me._model[key] - startVal) * ease) + startVal;
					// Everything else
					} else {
						me._view[key] = value;
					}
				}, me);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	
	};


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(562);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					var baseHasProperty = base.hasOwnProperty(key);
					var baseVal = baseHasProperty ? base[key] : {};
	
					if (key === 'scales') {
						// Scale config merging is complex. Add our own function here for that
						base[key] = helpers.scaleMerge(baseVal, value);
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(baseVal, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (baseHasProperty
							&& typeof baseVal === 'object'
							&& !helpers.isArray(baseVal)
							&& baseVal !== null
							&& typeof value === 'object'
							&& !helpers.isArray(value)) {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(baseVal, value);
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.error('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ },
/* 539 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		/**
		 * Helper function to get relative position for an event
		 * @param {Event|IEvent} event - The event to get the position for
		 * @param {Chart} chart - The chart
		 * @returns {Point} the event position
		 */
		function getRelativePosition(e, chart) {
			if (e.native) {
				return {
					x: e.x,
					y: e.y
				};
			}
	
			return helpers.getRelativePosition(e, chart);
		}
	
		/**
		 * Helper function to traverse all of the visible elements in the chart
		 * @param chart {chart} the chart
		 * @param handler {Function} the callback to execute for each visible item
		 */
		function parseVisibleItems(chart, handler) {
			var datasets = chart.data.datasets;
			var meta, i, j, ilen, jlen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!chart.isDatasetVisible(i)) {
					continue;
				}
	
				meta = chart.getDatasetMeta(i);
				for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
					var element = meta.data[j];
					if (!element._view.skip) {
						handler(element);
					}
				}
			}
		}
	
		/**
		 * Helper function to get the items that intersect the event position
		 * @param items {ChartElement[]} elements to filter
		 * @param position {Point} the point to be nearest to
		 * @return {ChartElement[]} the nearest items
		 */
		function getIntersectItems(chart, position) {
			var elements = [];
	
			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
				}
			});
	
			return elements;
		}
	
		/**
		 * Helper function to get the items nearest to the event position considering all visible items in teh chart
		 * @param chart {Chart} the chart to look at elements from
		 * @param position {Point} the point to be nearest to
		 * @param intersect {Boolean} if true, only consider items that intersect the position
		 * @param distanceMetric {Function} Optional function to provide the distance between
		 * @return {ChartElement[]} the nearest items
		 */
		function getNearestItems(chart, position, intersect, distanceMetric) {
			var minDistance = Number.POSITIVE_INFINITY;
			var nearestItems = [];
	
			if (!distanceMetric) {
				distanceMetric = helpers.distanceBetweenPoints;
			}
	
			parseVisibleItems(chart, function(element) {
				if (intersect && !element.inRange(position.x, position.y)) {
					return;
				}
	
				var center = element.getCenterPoint();
				var distance = distanceMetric(position, center);
	
				if (distance < minDistance) {
					nearestItems = [element];
					minDistance = distance;
				} else if (distance === minDistance) {
					// Can have multiple items at the same distance in which case we sort by size
					nearestItems.push(element);
				}
			});
	
			return nearestItems;
		}
	
		function indexMode(chart, e, options) {
			var position = getRelativePosition(e, chart.chart);
			var distanceMetric = function(pt1, pt2) {
				return Math.abs(pt1.x - pt2.x);
			};
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
			var elements = [];
	
			if (!items.length) {
				return [];
			}
	
			chart.data.datasets.forEach(function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex),
						element = meta.data[items[0]._index];
	
					// don't count items that are skipped (null data)
					if (element && !element._view.skip) {
						elements.push(element);
					}
				}
			});
	
			return elements;
		}
	
		/**
		 * @interface IInteractionOptions
		 */
		/**
		 * If true, only consider items that intersect the point
		 * @name IInterfaceOptions#boolean
		 * @type Boolean
		 */
	
		/**
		 * Contains interaction related functions
		 * @namespace Chart.Interaction
		 */
		Chart.Interaction = {
			// Helper function for different modes
			modes: {
				single: function(chart, e) {
					var position = getRelativePosition(e, chart.chart);
					var elements = [];
	
					parseVisibleItems(chart, function(element) {
						if (element.inRange(position.x, position.y)) {
							elements.push(element);
							return elements;
						}
					});
	
					return elements.slice(0, 1);
				},
	
				/**
				 * @function Chart.Interaction.modes.label
				 * @deprecated since version 2.4.0
				 */
				label: indexMode,
	
				/**
				 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
				 * @function Chart.Interaction.modes.index
				 * @since v2.4.0
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				index: indexMode,
	
				/**
				 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect is false, we find the nearest item and return the items in that dataset
				 * @function Chart.Interaction.modes.dataset
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				dataset: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false);
	
					if (items.length > 0) {
						items = chart.getDatasetMeta(items[0]._datasetIndex).data;
					}
	
					return items;
				},
	
				/**
				 * @function Chart.Interaction.modes.x-axis
				 * @deprecated since version 2.4.0. Use index mode and intersect == true
				 */
				'x-axis': function(chart, e) {
					return indexMode(chart, e, true);
				},
	
				/**
				 * Point mode returns all elements that hit test based on the event position
				 * of the event
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				point: function(chart, e) {
					var position = getRelativePosition(e, chart.chart);
					return getIntersectItems(chart, position);
				},
	
				/**
				 * nearest mode returns the element closest to the point
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				nearest: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var nearestItems = getNearestItems(chart, position, options.intersect);
	
					// We have multiple items at the same distance from the event. Now sort by smallest
					if (nearestItems.length > 1) {
						nearestItems.sort(function(a, b) {
							var sizeA = a.getArea();
							var sizeB = b.getArea();
							var ret = sizeA - sizeB;
	
							if (ret === 0) {
								// if equal sort by dataset index
								ret = a._datasetIndex - b._datasetIndex;
							}
	
							return ret;
						});
					}
	
					// Return only 1 item
					return nearestItems.slice(0, 1);
				},
	
				/**
				 * x mode returns the elements that hit-test at the current x coordinate
				 * @function Chart.Interaction.modes.x
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				x: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inXRange(position.x)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				},
	
				/**
				 * y mode returns the elements that hit-test at the current y coordinate
				 * @function Chart.Interaction.modes.y
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				y: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inYRange(position.y)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				}
			}
		};
	};


/***/ },
/* 540 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.controller = new Chart.Controller(item, config, this);
			return this.controller;
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'nearest',
					intersect: true,
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ },
/* 541 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var layoutOptions = chartInstance.options.layout;
				var padding = layoutOptions ? layoutOptions.padding : null;
	
				var leftPadding = 0;
				var rightPadding = 0;
				var topPadding = 0;
				var bottomPadding = 0;
	
				if (!isNaN(padding)) {
					// options.layout.padding is a number. assign to all
					leftPadding = padding;
					rightPadding = padding;
					topPadding = padding;
					bottomPadding = padding;
				} else {
					leftPadding = padding.left || 0;
					rightPadding = padding.right || 0;
					topPadding = padding.top || 0;
					bottomPadding = padding.bottom || 0;
				}
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'left';
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'right';
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'top';
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'bottom';
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'chartArea';
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ },
/* 542 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels;
				var legendItems = labelOpts.generateLabels.call(me, me.chart);
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize),
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x,
					y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chartInstance, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chartInstance.chart.ctx,
				options: legendOpts,
				chart: chartInstance
			});
			chartInstance.legend = legend;
			Chart.layoutService.addBox(chartInstance, legend);
		}
	
		// Register the legend plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var legendOpts = chartInstance.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chartInstance, legendOpts);
				}
			},
			beforeUpdate: function(chartInstance) {
				var legendOpts = chartInstance.options.legend;
	
				if (legendOpts) {
					legendOpts = helpers.configMerge(Chart.defaults.global.legend, legendOpts);
	
					if (chartInstance.legend) {
						chartInstance.legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chartInstance, legendOpts);
					}
				} else {
					Chart.layoutService.removeBox(chartInstance, chartInstance.legend);
					delete chartInstance.legend;
				}
			},
			afterEvent: function(chartInstance, e) {
				var legend = chartInstance.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		});
	};


/***/ },
/* 543 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.plugins = {};
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i=0; i<ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var defaults = Chart.defaults.global.plugins;
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = helpers.inherits({});
	};


/***/ },
/* 544 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 0,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: Chart.Ticks.formatters.values
			}
		};
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var getValueOrDefault = helpers.getValueOrDefault;
			var globalDefaults = Chart.defaults.global;
			var size = getValueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = getValueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = getValueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		Chart.Scale = Chart.Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, me.ticks, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation;
					var sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var scaleLabelFontSize = parseFontOptions(scaleLabelOpts).size * 1.5;
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += scaleLabelFontSize;
					} else {
						minSize.width += scaleLabelFontSize;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFont.size * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickFont.font;
	
						var firstTick = me.ticks[0];
						var firstLabelWidth = computeTextSize(me.ctx, firstTick, tickFont.font);
	
						var lastTick = me.ticks[me.ticks.length - 1];
						var lastLabelWidth = computeTextSize(me.ctx, lastTick, tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom'? (cosRotation * firstLabelWidth) + 3: (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom'? (cosRotation * lineSpace) + 3: (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						// Account for padding
	
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							largestTextWidth += me.options.ticks.padding;
						}
						minSize.width += largestTextWidth;
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof(rawValue) === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
				var borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				var borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					// Only calculate the skip ratio with the half width of longestRotateLabel if we got an actual rotation
					// See #2584
					if (isRotated) {
						longestRotatedLabel /= 2;
					}
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated? 'top':'middle';
							textAlign = !isRotated? 'center': 'right';
							labelY = me.top + tl;
						} else {
							// top
							textBaseline = !isRotated? 'bottom':'middle';
							textAlign = !isRotated? 'center': 'left';
							labelY = me.bottom - tl;
						}
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var tickPadding = optionTicks.padding;
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickFont.font;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFont.size / 2) : me.top + (scaleLabelFont.size / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFont.size / 2) : me.right - (scaleLabelFont.size / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ },
/* 545 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};


/***/ },
/* 546 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
		 * Namespace to hold static tick generation functions
		 * @namespace Chart.Ticks
		 */
		Chart.Ticks = {
			/**
			 * Namespace to hold generators for different types of ticks
			 * @namespace Chart.Ticks.generators
			 */
			generators: {
				/**
				 * Interface for the options provided to the numeric tick generator
				 * @interface INumericTickGenerationOptions
				 */
				/**
				 * The maximum number of ticks to display
				 * @name INumericTickGenerationOptions#maxTicks
				 * @type Number
				 */
				/**
				 * The distance between each tick.
				 * @name INumericTickGenerationOptions#stepSize
				 * @type Number
				 * @optional
				 */
				/**
				 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
				 * @name INumericTickGenerationOptions#min
				 * @type Number
				 * @optional
				 */
				/**
				 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
				 * @name INumericTickGenerationOptions#max
				 * @type Number
				 * @optional
				 */
	
				/**
				 * Generate a set of linear ticks
				 * @method Chart.Ticks.generators.linear
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				linear: function(generationOptions, dataRange) {
					var ticks = [];
					// To get a "nice" value for the tick spacing, we will use the appropriately named
					// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
					// for details.
	
					var spacing;
					if (generationOptions.stepSize && generationOptions.stepSize > 0) {
						spacing = generationOptions.stepSize;
					} else {
						var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
						spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
					}
					var niceMin = Math.floor(dataRange.min / spacing) * spacing;
					var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
					// If min, max and stepSize is set and they make an evenly spaced scale use it.
					if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
						// If very close to our whole number, use it.
						if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
							niceMin = generationOptions.min;
							niceMax = generationOptions.max;
						}
					}
	
					var numSpaces = (niceMax - niceMin) / spacing;
					// If very close to our rounded value, use it.
					if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
						numSpaces = Math.round(numSpaces);
					} else {
						numSpaces = Math.ceil(numSpaces);
					}
	
					// Put the values into the ticks array
					ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
					for (var j = 1; j < numSpaces; ++j) {
						ticks.push(niceMin + (j * spacing));
					}
					ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
					return ticks;
				},
	
				/**
				 * Generate a set of logarithmic ticks
				 * @method Chart.Ticks.generators.logarithmic
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				logarithmic: function(generationOptions, dataRange) {
					var ticks = [];
					var getValueOrDefault = helpers.getValueOrDefault;
	
					// Figure out what the max number of ticks we can support it is based on the size of
					// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
					// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
					// the graph
					var tickVal = getValueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
					var endExp = Math.floor(helpers.log10(dataRange.max));
					var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(dataRange.minNotZero));
						significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
						ticks.push(tickVal);
						tickVal = significand * Math.pow(10, exp);
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp));
					}
	
					do {
						ticks.push(tickVal);
	
						++significand;
						if (significand === 10) {
							significand = 1;
							++exp;
						}
	
						tickVal = significand * Math.pow(10, exp);
					} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
					var lastTick = getValueOrDefault(generationOptions.max, tickVal);
					ticks.push(lastTick);
	
					return ticks;
				}
			},
	
			/**
			 * Namespace to hold formatters for different types of ticks
			 * @namespace Chart.Ticks.formatters
			 */
			formatters: {
				/**
				 * Formatter for value labels
				 * @method Chart.Ticks.formatters.values
				 * @param value the value to display
				 * @return {String|Array} the label to display
				 */
				values: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				},
	
				/**
				 * Formatter for linear numeric ticks
				 * @method Chart.Ticks.formatters.linear
				 * @param tickValue {Number} the value to be formatted
				 * @param index {Number} the position of the tickValue parameter in the ticks array
				 * @param ticks {Array<Number>} the list of ticks being converted
				 * @return {String} string representation of the tickValue parameter
				 */
				linear: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				},
	
				logarithmic: function(tickValue, index, ticks) {
					var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
					if (tickValue === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
						return tickValue.toExponential();
					}
					return '';
				}
			}
		};
	};


/***/ },
/* 547 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right,
						maxWidth;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0, maxWidth);
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chartInstance, titleOpts) {
			var title = new Chart.Title({
				ctx: chartInstance.chart.ctx,
				options: titleOpts,
				chart: chartInstance
			});
			chartInstance.titleBlock = title;
			Chart.layoutService.addBox(chartInstance, title);
		}
	
		// Register the title plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var titleOpts = chartInstance.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chartInstance, titleOpts);
				}
			},
			beforeUpdate: function(chartInstance) {
				var titleOpts = chartInstance.options.title;
	
				if (titleOpts) {
					titleOpts = helpers.configMerge(Chart.defaults.global.title, titleOpts);
	
					if (chartInstance.titleBlock) {
						chartInstance.titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chartInstance, titleOpts);
					}
				} else {
					Chart.layoutService.removeBox(chartInstance, chartInstance.titleBlock);
					delete chartInstance.titleBlock;
				}
			}
		});
	};


/***/ },
/* 548 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				labelColor: function(tooltipItem, chartInstance) {
					var meta = chartInstance.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = Chart.defaults.global;
			var getValueOrDefault = helpers.getValueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize,
				bodyFontSize = model.bodyFontSize,
				footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chartInstance.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize,
				caretPadding = vm.caretPadding,
				cornerRadius = vm.cornerRadius,
				xAlign = alignment.xAlign,
				yAlign = alignment.yAlign,
				paddingAndSize = caretSize + caretPadding,
				radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
				var chartInstance = me._chartInstance;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position](active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, chartInstance));
					});
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = helpers.getValueOrDefault(tooltipPosition.padding, 2);
					model.labelColors = labelColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size, opacity) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					// Left or right side
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
					}
	
					y2 = ptY + (height / 2);
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				} else {
					if (xAlign === 'left') {
						x1 = ptX + cornerRadius;
						x2 = x1 + caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x1 = ptX + width - cornerRadius;
						x2 = x1 - caretSize;
						x3 = x2 - caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
	
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
					}
				}
	
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var textColor = mergeOpacity(vm.bodyFontColor, opacity);
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
				ctx.fill();
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.enabled) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chartInstance.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
	
				var nearestElement;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len;
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ },
/* 549 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var halfAngle = (vm.startAngle + vm.endAngle) / 2;
				var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
				return {
					x: vm.x + Math.cos(halfAngle) * halfRadius,
					y: vm.y + Math.sin(halfAngle) * halfRadius
				};
			},
			getArea: function() {
				var vm = this._view;
				return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ },
/* 550 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var spanGaps = vm.spanGaps;
				var fillPoint = vm.scaleZero;
				var loop = me._loop;
	
				// Handle different fill modes for cartesian lines
				if (!loop) {
					if (vm.fill === 'top') {
						fillPoint = vm.scaleTop;
					} else if (vm.fill === 'bottom') {
						fillPoint = vm.scaleBottom;
					}
				}
	
				var ctx = me._chart.ctx;
				ctx.save();
	
				// Helper function to draw a line to a point
				function lineToPoint(previousPoint, point) {
					var pointVM = point._view;
					if (point._view.steppedLine === true) {
						ctx.lineTo(pointVM.x, previousPoint._view.y);
						ctx.lineTo(pointVM.x, pointVM.y);
					} else if (point._view.tension === 0) {
						ctx.lineTo(pointVM.x, pointVM.y);
					} else {
						ctx.bezierCurveTo(
							previousPoint._view.controlPointNextX,
							previousPoint._view.controlPointNextY,
							pointVM.controlPointPreviousX,
							pointVM.controlPointPreviousY,
							pointVM.x,
							pointVM.y
						);
					}
				}
	
				var points = me._children.slice(); // clone array
				var lastDrawnIndex = -1;
	
				// If we are looping, adding the first point again
				if (loop && points.length) {
					points.push(points[0]);
				}
	
				var index, current, previous, currentVM;
	
				// Fill Line
				if (points.length && vm.fill) {
					ctx.beginPath();
	
					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (loop) {
								ctx.moveTo(fillPoint.x, fillPoint.y);
							} else {
								ctx.moveTo(currentVM.x, fillPoint);
							}
	
							if (!currentVM.skip) {
								lastDrawnIndex = index;
								ctx.lineTo(currentVM.x, currentVM.y);
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
							if (currentVM.skip) {
								// Only do this if this is the first point that is skipped
								if (!spanGaps && lastDrawnIndex === (index - 1)) {
									if (loop) {
										ctx.lineTo(fillPoint.x, fillPoint.y);
									} else {
										ctx.lineTo(previous._view.x, fillPoint);
									}
								}
							} else {
								if (lastDrawnIndex !== (index - 1)) {
									// There was a gap and this is the first point after the gap. If we've never drawn a point, this is a special case.
									// If the first data point is NaN, then there is no real gap to skip
									if (spanGaps && lastDrawnIndex !== -1) {
										// We are spanning the gap, so simple draw a line to this point
										lineToPoint(previous, current);
									} else if (loop) {
										ctx.lineTo(currentVM.x, currentVM.y);
									} else {
										ctx.lineTo(currentVM.x, fillPoint);
										ctx.lineTo(currentVM.x, currentVM.y);
									}
								} else {
									// Line to next point
									lineToPoint(previous, current);
								}
								lastDrawnIndex = index;
							}
						}
					}
	
					if (!loop && lastDrawnIndex !== -1) {
						ctx.lineTo(points[lastDrawnIndex]._view.x, fillPoint);
					}
	
					ctx.fillStyle = vm.backgroundColor || globalDefaults.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Stroke Line Options
				var globalOptionLineElements = globalDefaults.elements.line;
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								lineToPoint(previous, current);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ },
/* 551 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		function xRange(mouseX) {
			var vm = this._view;
			return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		function yRange(mouseY) {
			var vm = this._view;
			return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
	
			inLabelRange: xRange,
			inXRange: xRange,
			inYRange: yRange,
	
			getCenterPoint: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			},
			getArea: function() {
				return Math.PI * Math.pow(this._view.radius, 2);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function(chartArea) {
				var vm = this._view;
				var model = this._model;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
				var color = Chart.helpers.color;
				var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
				var ratio = 0;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				// Cliping for Points.
				// going out from inner charArea?
				if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right*errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom*errMargin < model.y))) {
					// Point fade out
					if (model.x < chartArea.left) {
						ratio = (x - model.x) / (chartArea.left - model.x);
					} else if (chartArea.right*errMargin < model.x) {
						ratio = (model.x - x) / (model.x - chartArea.right);
					} else if (model.y < chartArea.top) {
						ratio = (y - model.y) / (chartArea.top - model.y);
					} else if (chartArea.bottom*errMargin < model.y) {
						ratio = (model.y - y) / (model.y - chartArea.bottom);
					}
					ratio = Math.round(ratio*100) / 100;
					ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
					ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
				}
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ },
/* 552 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		function isVertical(bar) {
			return bar._view.width !== undefined;
		}
	
		/**
		 * Helper function to get the bounds of the bar regardless of the orientation
		 * @private
		 * @param bar {Chart.Element.Rectangle} the bar
		 * @return {Bounds} bounds of the bar
		 */
		function getBarBounds(bar) {
			var vm = bar._view;
			var x1, x2, y1, y2;
	
			if (isVertical(bar)) {
				// vertical
				var halfWidth = vm.width / 2;
				x1 = vm.x - halfWidth;
				x2 = vm.x + halfWidth;
				y1 = Math.min(vm.y, vm.base);
				y2 = Math.max(vm.y, vm.base);
			} else {
				// horizontal bar
				var halfHeight = vm.height / 2;
				x1 = Math.min(vm.x, vm.base);
				x2 = Math.max(vm.x, vm.base);
				y1 = vm.y - halfHeight;
				y2 = vm.y + halfHeight;
			}
	
			return {
				left: x1,
				top: y1,
				right: x2,
				bottom: y2
			};
		}
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var left, right, top, bottom, signX, signY, borderSkipped;
				var borderWidth = vm.borderWidth;
	
				if (!vm.horizontal) {
					// bar
					left = vm.x - vm.width / 2;
					right = vm.x + vm.width / 2;
					top = vm.y;
					bottom = vm.base;
					signX = 1;
					signY = bottom > top? 1: -1;
					borderSkipped = vm.borderSkipped || 'bottom';
				} else {
					// horizontal bar
					left = vm.base;
					right = vm.x;
					top = vm.y - vm.height / 2;
					bottom = vm.y + vm.height / 2;
					signX = right > left? 1: -1;
					signY = 1;
					borderSkipped = vm.borderSkipped || 'left';
				}
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (borderWidth) {
					// borderWidth shold be less than bar width and bar height.
					var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
					borderWidth = borderWidth > barSize? barSize: borderWidth;
					var halfStroke = borderWidth / 2;
					// Adjust borderWidth when bar top position is near vm.base(zero).
					var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
					var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
					var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
					var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
					// not become a vertical line?
					if (borderLeft !== borderRight) {
						top = borderTop;
						bottom = borderBottom;
					}
					// not become a horizontal line?
					if (borderTop !== borderBottom) {
						left = borderLeft;
						right = borderRight;
					}
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[left, bottom],
					[left, top],
					[right, top],
					[right, bottom]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				var corner = cornerAt(0);
				ctx.moveTo(corner[0], corner[1]);
	
				for (var i = 1; i < 4; i++) {
					corner = cornerAt(i);
					ctx.lineTo(corner[0], corner[1]);
				}
	
				ctx.fill();
				if (borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var inRange = false;
	
				if (this._view) {
					var bounds = getBarBounds(this);
					inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inLabelRange: function(mouseX, mouseY) {
				var me = this;
				if (!me._view) {
					return false;
				}
	
				var inRange = false;
				var bounds = getBarBounds(me);
	
				if (isVertical(me)) {
					inRange = mouseX >= bounds.left && mouseX <= bounds.right;
				} else {
					inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inXRange: function(mouseX) {
				var bounds = getBarBounds(this);
				return mouseX >= bounds.left && mouseX <= bounds.right;
			},
			inYRange: function(mouseY) {
				var bounds = getBarBounds(this);
				return mouseY >= bounds.top && mouseY <= bounds.bottom;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var x, y;
				if (isVertical(this)) {
					x = vm.x;
					y = (vm.y + vm.base) / 2;
				} else {
					x = (vm.x + vm.base) / 2;
					y = vm.y;
				}
	
				return {x: x, y: y};
			},
			getArea: function() {
				var vm = this._view;
				return vm.width * Math.abs(vm.y - vm.base);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	// Chart.Platform implementation for targeting a web browser
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		// DOM event types -> Chart.js event types.
		// Note: only events with different types are mapped.
		// https://developer.mozilla.org/en-US/docs/Web/Events
		var eventTypeMap = {
			// Touch events
			touchstart: 'mousedown',
			touchmove: 'mousemove',
			touchend: 'mouseup',
	
			// Pointer events
			pointerenter: 'mouseenter',
			pointerdown: 'mousedown',
			pointermove: 'mousemove',
			pointerup: 'mouseup',
			pointerleave: 'mouseout',
			pointerout: 'mouseout'
		};
	
		/**
		 * The "used" size is the final value of a dimension property after all calculations have
		 * been performed. This method uses the computed style of `element` but returns undefined
		 * if the computed style is not expressed in pixels. That can happen in some cases where
		 * `element` has a size relative to its parent and this last one is not yet displayed,
		 * for example because of `display: none` on a parent node.
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
		 * @returns {Number} Size in pixels or undefined if unknown.
		 */
		function readUsedSize(element, property) {
			var value = helpers.getStyle(element, property);
			var matches = value && value.match(/(\d+)px/);
			return matches? Number(matches[1]) : undefined;
		}
	
		/**
		 * Initializes the canvas style and render size without modifying the canvas display size,
		 * since responsiveness is handled by the controller.resize() method. The config is used
		 * to determine the aspect ratio to apply in case no explicit height has been specified.
		 */
		function initCanvas(canvas, config) {
			var style = canvas.style;
	
			// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
			// returns null or '' if no explicit value has been set to the canvas attribute.
			var renderHeight = canvas.getAttribute('height');
			var renderWidth = canvas.getAttribute('width');
	
			// Chart.js modifies some canvas values that we want to restore on destroy
			canvas._chartjs = {
				initial: {
					height: renderHeight,
					width: renderWidth,
					style: {
						display: style.display,
						height: style.height,
						width: style.width
					}
				}
			};
	
			// Force canvas to display as block to avoid extra space caused by inline
			// elements, which would interfere with the responsive resize process.
			// https://github.com/chartjs/Chart.js/issues/2538
			style.display = style.display || 'block';
	
			if (renderWidth === null || renderWidth === '') {
				var displayWidth = readUsedSize(canvas, 'width');
				if (displayWidth !== undefined) {
					canvas.width = displayWidth;
				}
			}
	
			if (renderHeight === null || renderHeight === '') {
				if (canvas.style.height === '') {
					// If no explicit render height and style height, let's apply the aspect ratio,
					// which one can be specified by the user but also by charts as default option
					// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
					canvas.height = canvas.width / (config.options.aspectRatio || 2);
				} else {
					var displayHeight = readUsedSize(canvas, 'height');
					if (displayWidth !== undefined) {
						canvas.height = displayHeight;
					}
				}
			}
	
			return canvas;
		}
	
		function createEvent(type, chart, x, y, native) {
			return {
				type: type,
				chart: chart,
				native: native || null,
				x: x !== undefined? x : null,
				y: y !== undefined? y : null,
			};
		}
	
		function fromNativeEvent(event, chart) {
			var type = eventTypeMap[event.type] || event.type;
			var pos = helpers.getRelativePosition(event, chart);
			return createEvent(type, chart, pos.x, pos.y, event);
		}
	
		function createResizer(handler) {
			var iframe = document.createElement('iframe');
			iframe.className = 'chartjs-hidden-iframe';
			iframe.style.cssText =
				'display:block;'+
				'overflow:hidden;'+
				'border:0;'+
				'margin:0;'+
				'top:0;'+
				'left:0;'+
				'bottom:0;'+
				'right:0;'+
				'height:100%;'+
				'width:100%;'+
				'position:absolute;'+
				'pointer-events:none;'+
				'z-index:-1;';
	
			// Prevent the iframe to gain focus on tab.
			// https://github.com/chartjs/Chart.js/issues/3090
			iframe.tabIndex = -1;
	
			// If the iframe is re-attached to the DOM, the resize listener is removed because the
			// content is reloaded, so make sure to install the handler after the iframe is loaded.
			// https://github.com/chartjs/Chart.js/issues/3521
			helpers.addEvent(iframe, 'load', function() {
				helpers.addEvent(iframe.contentWindow || iframe, 'resize', handler);
	
				// The iframe size might have changed while loading, which can also
				// happen if the size has been changed while detached from the DOM.
				handler();
			});
	
			return iframe;
		}
	
		function addResizeListener(node, listener, chart) {
			var stub = node._chartjs = {
				ticking: false
			};
	
			// Throttle the callback notification until the next animation frame.
			var notify = function() {
				if (!stub.ticking) {
					stub.ticking = true;
					helpers.requestAnimFrame.call(window, function() {
						if (stub.resizer) {
							stub.ticking = false;
							return listener(createEvent('resize', chart));
						}
					});
				}
			};
	
			// Let's keep track of this added iframe and thus avoid DOM query when removing it.
			stub.resizer = createResizer(notify);
	
			node.insertBefore(stub.resizer, node.firstChild);
		}
	
		function removeResizeListener(node) {
			if (!node || !node._chartjs) {
				return;
			}
	
			var resizer = node._chartjs.resizer;
			if (resizer) {
				resizer.parentNode.removeChild(resizer);
				node._chartjs.resizer = null;
			}
	
			delete node._chartjs;
		}
	
		return {
			acquireContext: function(item, config) {
				if (typeof item === 'string') {
					item = document.getElementById(item);
				} else if (item.length) {
					// Support for array based queries (such as jQuery)
					item = item[0];
				}
	
				if (item && item.canvas) {
					// Support for any object associated to a canvas (including a context2d)
					item = item.canvas;
				}
	
				if (item instanceof HTMLCanvasElement) {
					// To prevent canvas fingerprinting, some add-ons undefine the getContext
					// method, for example: https://github.com/kkapsner/CanvasBlocker
					// https://github.com/chartjs/Chart.js/issues/2807
					var context = item.getContext && item.getContext('2d');
					if (context instanceof CanvasRenderingContext2D) {
						initCanvas(item, config);
						return context;
					}
				}
	
				return null;
			},
	
			releaseContext: function(context) {
				var canvas = context.canvas;
				if (!canvas._chartjs) {
					return;
				}
	
				var initial = canvas._chartjs.initial;
				['height', 'width'].forEach(function(prop) {
					var value = initial[prop];
					if (value === undefined || value === null) {
						canvas.removeAttribute(prop);
					} else {
						canvas.setAttribute(prop, value);
					}
				});
	
				helpers.each(initial.style || {}, function(value, key) {
					canvas.style[key] = value;
				});
	
				// The canvas render size might have been changed (and thus the state stack discarded),
				// we can't use save() and restore() to restore the initial state. So make sure that at
				// least the canvas context is reset to the default state by setting the canvas width.
				// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
				canvas.width = canvas.width;
	
				delete canvas._chartjs;
			},
	
			addEventListener: function(chart, type, listener) {
				var canvas = chart.chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					addResizeListener(canvas.parentNode, listener, chart.chart);
					return;
				}
	
				var stub = listener._chartjs || (listener._chartjs = {});
				var proxies = stub.proxies || (stub.proxies = {});
				var proxy = proxies[chart.id + '_' + type] = function(event) {
					listener(fromNativeEvent(event, chart.chart));
				};
	
				helpers.addEvent(canvas, type, proxy);
			},
	
			removeEventListener: function(chart, type, listener) {
				var canvas = chart.chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					removeResizeListener(canvas.parentNode, listener);
					return;
				}
	
				var stub = listener._chartjs || {};
				var proxies = stub.proxies || {};
				var proxy = proxies[chart.id + '_' + type];
				if (!proxy) {
					return;
				}
	
				helpers.removeEvent(canvas, type, proxy);
			}
		};
	};


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// By default, select the browser (DOM) platform.
	// @TODO Make possible to select another platform at build time.
	var implementation = __webpack_require__(553);
	
	module.exports = function(Chart) {
		/**
		 * @namespace Chart.platform
		 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
		 * @since 2.4.0
		 */
		Chart.platform = {
			/**
			 * Called at chart construction time, returns a context2d instance implementing
			 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
			 * @param {*} item - The native item from which to acquire context (platform specific)
			 * @param {Object} options - The chart options
			 * @returns {CanvasRenderingContext2D} context2d instance
			 */
			acquireContext: function() {},
	
			/**
			 * Called at chart destruction time, releases any resources associated to the context
			 * previously returned by the acquireContext() method.
			 * @param {CanvasRenderingContext2D} context - The context2d instance
			 * @returns {Boolean} true if the method succeeded, else false
			 */
			releaseContext: function() {},
	
			/**
			 * Registers the specified listener on the given chart.
			 * @param {Chart} chart - Chart from which to listen for event
			 * @param {String} type - The ({@link IEvent}) type to listen for
			 * @param {Function} listener - Receives a notification (an object that implements
			 * the {@link IEvent} interface) when an event of the specified type occurs.
			 */
			addEventListener: function() {},
	
			/**
			 * Removes the specified listener previously registered with addEventListener.
			 * @param {Chart} chart -Chart from which to remove the listener
			 * @param {String} type - The ({@link IEvent}) type to remove
			 * @param {Function} listener - The listener function to remove from the event target.
			 */
			removeEventListener: function() {}
		};
	
		/**
		 * @interface IPlatform
		 * Allows abstracting platform dependencies away from the chart
		 * @borrows Chart.platform.acquireContext as acquireContext
		 * @borrows Chart.platform.releaseContext as releaseContext
		 * @borrows Chart.platform.addEventListener as addEventListener
		 * @borrows Chart.platform.removeEventListener as removeEventListener
		 */
	
		/**
		 * @interface IEvent
		 * @prop {String} type - The event type name, possible values are:
		 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
		 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
		 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
		 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
		 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
		 */
	
		Chart.helpers.extend(Chart.platform, implementation(Chart));
	};


/***/ },
/* 555 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
			// Implement this so that
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (value !== undefined && isNaN(index)) {
					var labels = me.getLabels();
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ },
/* 556 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Chart.Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ },
/* 557 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Chart.Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ },
/* 558 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Chart.Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Chart.Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ },
/* 559 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Chart.Ticks.formatters.linear
			},
	
			pointLabels: {
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			return !scale.options.lineArc ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.getValueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.getValueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.getValueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				l: scale.width,
				r: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i;
			var textSize;
			var pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y+= spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var getValueOrDefault = helpers.getValueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;
	
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.lineArc) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.lineArc) {
					fit(this);
				} else {
					fitWithPointLabels(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea,
					maxTop = topMovement + me.drawingArea,
					maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (!opts.lineArc) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(2);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (typeof this.labelMoments[datasetIndex] !== 'undefined') {
					return this.labelMoments[datasetIndex][index];
				}
	
				return null;
			},
			getLabelDiff: function(datasetIndex, index) {
				var me = this;
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (me.labelDiffs === undefined) {
					me.buildLabelDiffs();
				}
	
				if (typeof me.labelDiffs[datasetIndex] !== 'undefined') {
					return me.labelDiffs[datasetIndex][index];
				}
	
				return null;
			},
			getMomentStartOf: function(tick) {
				var me = this;
				if (me.options.time.unit === 'week' && me.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(me.options.time.isoWeekday);
				}
				return tick.clone().startOf(me.tickUnit);
			},
			determineDataLimits: function() {
				var me = this;
				me.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, me);
	
					me.firstTick = moment.min.call(me, scaleLabelMoments);
					me.lastTick = moment.max.call(me, scaleLabelMoments);
				} else {
					me.firstTick = null;
					me.lastTick = null;
				}
	
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = me.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									me.firstTick = me.firstTick !== null ? moment.min(me.firstTick, labelMoment) : labelMoment;
									me.lastTick = me.lastTick !== null ? moment.max(me.lastTick, labelMoment) : labelMoment;
								}
							}
						}, me);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					me.labelMoments.push(momentsForDataset);
				}, me);
	
				// Set these after we've done all the data
				if (me.options.time.min) {
					me.firstTick = me.parseTime(me.options.time.min);
				}
	
				if (me.options.time.max) {
					me.lastTick = me.parseTime(me.options.time.max);
				}
	
				// We will modify these, so clone for later
				me.firstTick = (me.firstTick || moment()).clone();
				me.lastTick = (me.lastTick || moment()).clone();
			},
			buildLabelDiffs: function() {
				var me = this;
				me.labelDiffs = [];
				var scaleLabelDiffs = [];
				// Parse common labels once
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelDiffs.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
						}
					}, me);
				}
	
				helpers.each(me.chart.data.datasets, function(dataset) {
					var diffsForDataset = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								diffsForDataset.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
							}
						}, me);
					} else {
						// We have no labels. Use common ones
						diffsForDataset = scaleLabelDiffs;
					}
	
					me.labelDiffs.push(diffsForDataset);
				}, me);
			},
			buildTicks: function() {
				var me = this;
	
				me.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(me.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(me.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				me.ctx.font = tickLabelFont;
	
				me.ticks = [];
				me.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				me.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (me.options.time.unit) {
					me.tickUnit = me.options.time.unit || 'day';
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = me.isHorizontal() ? me.width : me.height;
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = me.tickFormatFunction(me.firstTick, 0, []);
					var tickLabelWidth = me.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(me.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(me.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					me.tickUnit = me.options.time.minUnit;
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						me.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(me.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the predefined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(me.scaleSizeInUnits / labelCapacity)) {
									me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(me.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, Math.ceil(me.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							me.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = me.firstTick.diff(me.getMomentStartOf(me.firstTick), me.tickUnit, true);
							var trailingUnitBuffer = me.getMomentStartOf(me.lastTick.clone().add(1, me.tickUnit)).diff(me.lastTick, me.tickUnit, true);
							me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							me.displayFormat = me.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!me.options.time.min) {
					me.firstTick = me.getMomentStartOf(me.firstTick);
					roundedStart = me.firstTick;
				} else {
					roundedStart = me.getMomentStartOf(me.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!me.options.time.max) {
					var roundedEnd = me.getMomentStartOf(me.lastTick);
					var delta = roundedEnd.diff(me.lastTick, me.tickUnit, true);
					if (delta < 0) {
						// Do not use end of because we need me to be in the next time unit
						me.lastTick = me.getMomentStartOf(me.lastTick.add(1, me.tickUnit));
					} else if (delta >= 0) {
						me.lastTick = roundedEnd;
					}
	
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
				}
	
				// Tick displayFormat override
				if (me.options.time.displayFormat) {
					me.displayFormat = me.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				me.ticks.push(me.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = me.unitScale; i <= me.scaleSizeInUnits; i += me.unitScale) {
					var newTick = roundedStart.clone().add(i, me.tickUnit);
	
					// Are we greater than the max time
					if (me.options.time.max && newTick.diff(me.lastTick, me.tickUnit, true) >= 0) {
						break;
					}
	
					me.ticks.push(newTick);
				}
	
				// Always show the right tick
				var diff = me.ticks[me.ticks.length - 1].diff(me.lastTick, me.tickUnit);
				if (diff !== 0 || me.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (me.options.time.max) {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.ticks[0], me.tickUnit, true);
					} else {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				me.ctx.restore();
	
				// Invalidate label diffs cache
				me.labelDiffs = undefined;
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
				var value = me.chart.data.datasets[datasetIndex].data[index];
	
				if (value !== null && typeof value === 'object') {
					label = me.getRightValue(value);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = me.parseTime(label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.tickMoments = me.ticks;
				me.ticks = me.ticks.map(me.tickFormatFunction, me);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me.getLabelDiff(datasetIndex, index);
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = me.parseTime(me.getRightValue(value));
					}
					if (value && value.isValid && value.isValid()) {
						offset = value.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				if (offset !== null) {
					var decimal = offset !== 0 ? offset / me.scaleSizeInUnits : offset;
	
					if (me.isHorizontal()) {
						var valueOffset = (me.width * decimal);
						return me.left + Math.round(valueOffset);
					}
	
					var heightOffset = (me.height * decimal);
					return me.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickMoments[index], null, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width : me.height;
				var offset = (pixel - (me.isHorizontal() ? me.left : me.top)) / innerDimension;
				offset *= me.scaleSizeInUnits;
				return me.firstTick.clone().add(moment.duration(offset, me.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				var me = this;
				if (typeof me.options.time.parser === 'string') {
					return moment(label, me.options.time.parser);
				}
				if (typeof me.options.time.parser === 'function') {
					return me.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof me.options.time.format !== 'string' && me.options.time.format.call) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale');
					return me.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, me.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(568);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/,
	       hex =  /^#([a-fA-F0-9]{6})$/,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(567);
	var string = __webpack_require__(561);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *
	 * Main file of Chart.Funnel.js
	 * @author Jone Casper
	 * @email xu.chenhui@live.com
	 *
	 */
	
	/* global window */
	"use strict";
	
	var Chart = __webpack_require__(176);
	Chart = typeof(Chart) === 'function' ? Chart : window.Chart;
	
	__webpack_require__(565)(Chart);
	__webpack_require__(564)(Chart);
	
	module.exports = Chart;

/***/ },
/* 564 */
/***/ function(module, exports) {

	/**
	 *
	 * Extend funnel Charts
	 * @author Jone Casper
	 * @email xu.chenhui@live.com
	 *
	 * @example
	 * var data = {
	 *  labels: ["A", "B", "C"],
	 * 	datasets: [{
	 * 	  data: [300, 50, 100],
	 * 	  backgroundColor: [
	 *       "#FF6384",
	 *       "#36A2EB",
	 *       "#FFCE56"
	 *    ],
	 *    hoverBackgroundColor: [
	 *        "#FF6384",
	 *        "#36A2EB",
	 *        "#FFCE56"
	 *    ]
	 * 	}]
	 * }
	 *
	 */
	
	"use strict";
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		Chart.defaults.funnel = {
			hover: {
				mode: "label"
			},
			sort: 'asc',// sort options: 'asc', 'desc'
			gap: 2,
			bottomWidth: null,// the bottom width of funnel
			topWidth: 0, // the top width of funnel
			keep: 'auto', // Keep left or right
			elements: {
				borderWidth: 0
			},
			tooltips: {
				callbacks: {
					title: function (tooltipItem, data) {
						return '';
					},
					label: function (tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
					}
				}
			},
			legendCallback: function (chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join("");
			},
			legend: {
				labels: {
					generateLabels: function (chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function (label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var trap = meta.data[i];
								var custom = trap.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var trapeziumOpts = chart.options.elements.trapezium;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, trapeziumOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, trapeziumOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, trapeziumOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i,
									// Original Index
									_index: trap._index
								};
							});
						} else {
							return [];
						}
					}
				},
	
				onClick: function (e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			}
		};
	
		Chart.controllers.funnel = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Trapezium,
	
			linkScales: helpers.noop,
	
			update: function update(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					meta = me.getMeta(),
					elements = meta.data,
					borderWidth = opts.elements.borderWidth || 0,
					availableWidth = chartArea.right - chartArea.left - borderWidth * 2,
					availableHeight = chartArea.bottom - chartArea.top - borderWidth * 2;
	
				// top and bottom width
				var bottomWidth = availableWidth,
					topWidth = (opts.topWidth < availableWidth ? opts.topWidth : availableWidth) || 0;
				if (opts.bottomWidth) {
					bottomWidth = opts.bottomWidth < availableWidth ? opts.bottomWidth : availableWidth;
				}
	
				// percentage calculation and sort data
				var sort = opts.sort,
					dataset = me.getDataset(),
					valAndLabels = [],
					visiableNum = 0,
					dMax = 0;
				helpers.each(dataset.data, function (val, index) {
					var backgroundColor = helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index),
						hidden = elements[index].hidden;
					//if (!elements[index].hidden) {
					valAndLabels.push({
						hidden: hidden,
						orgIndex: index,
						val: val,
						backgroundColor: backgroundColor,
						borderColor: helpers.getValueAtIndexOrDefault(dataset.borderColor, index, backgroundColor),
						label: helpers.getValueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					});
					//}
					if (!elements[index].hidden) {
						visiableNum++;
						dMax = val > dMax ? val : dMax;
					}
				});
				var dwRatio = bottomWidth / dMax,
					sortedDataAndLabels = valAndLabels.sort(
						sort === 'asc' ?
							function (a, b) {
								return a.val - b.val;
							} :
							function (a, b) {
								return b.val - a.val;
							}
					);
				// For render hidden view
				// TODO: optimization....
				var _viewIndex = 0;
				helpers.each(sortedDataAndLabels, function (dal, index) {
					dal._viewIndex = !dal.hidden ? _viewIndex++ : -1;
				});
	
				// Elements height calculation
				var gap = opts.gap || 0,
					elHeight = (availableHeight - ((visiableNum - 1) * gap)) / visiableNum;
	
				// save
				me.topWidth = topWidth;
				me.dwRatio = dwRatio;
				me.elHeight = elHeight;
				me.sortedDataAndLabels = sortedDataAndLabels;
	
				helpers.each(elements, function (trapezium, index) {
					me.updateElement(trapezium, index, reset);
				}, me);
			},
	
			// update elements
			updateElement: function updateElement(trapezium, index, reset) {
				var me = this,
					chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					sort = opts.sort,
					dwRatio = me.dwRatio,
					elHeight = me.elHeight,
					gap = opts.gap || 0,
					borderWidth = opts.elements.borderWidth || 0;
	
				// calculate x,y,base, width,etc.
				var x, y, x1, x2,
					elementType = 'isosceles',
					elementData = me.sortedDataAndLabels[index], upperWidth, bottomWidth,
					viewIndex = elementData._viewIndex < 0 ? index : elementData._viewIndex,
					base = chartArea.top + (viewIndex + 1) * (elHeight + gap) - gap;
	
				if (sort === 'asc') {
					// Find previous element which is visible
					var previousElement = helpers.findPreviousWhere(me.sortedDataAndLabels,
						function (el) {
							return !el.hidden;
						},
						index
					);
					upperWidth = previousElement ? previousElement.val * dwRatio : me.topWidth;
					bottomWidth = elementData.val * dwRatio;
				} else {
					var nextElement = helpers.findNextWhere(me.sortedDataAndLabels,
						function (el) {
							return !el.hidden;
						},
						index
					);
					upperWidth = elementData.val * dwRatio;
					bottomWidth = nextElement ? nextElement.val * dwRatio : me.topWidth;
				}
	
				y = chartArea.top + viewIndex * (elHeight + gap);
				if (opts.keep === 'left') {
					elementType = 'scalene';
					x1 = chartArea.left + upperWidth / 2;
					x2 = chartArea.left + bottomWidth / 2;
				} else if (opts.keep === 'right') {
					elementType = 'scalene';
					x1 = chartArea.right - upperWidth/ 2;
					x2 = chartArea.right - bottomWidth / 2;
				} else {
					x = (chartArea.left + chartArea.right) / 2;
				}
	
				helpers.extend(trapezium, {
					// Utility
					_datasetIndex: me.index,
					_index: elementData.orgIndex,
	
					// Desired view properties
					_model: {
						type: elementType,
						y: y,
						base: base > chartArea.bottom ? chartArea.bottom : base,
						x: x,
						x1: x1,
						x2: x2,
						upperWidth: (reset || !!elementData.hidden) ? 0 : upperWidth,
						bottomWidth: (reset || !!elementData.hidden) ? 0 : bottomWidth,
						borderWidth: borderWidth,
						backgroundColor: elementData && elementData.backgroundColor,
						borderColor: elementData && elementData.borderColor,
						label: elementData && elementData.label
					}
				});
	
				trapezium.pivot();
			},
			removeHoverStyle: function (trapezium) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, trapezium, this.chart.options.elements.trapezium);
			}
		});
	};

/***/ },
/* 565 */
/***/ function(module, exports) {

	/**
	 *
	 * Extend trapezium element
	 * @author Jone Casper
	 * @email xu.chenhui@live.com
	 *
	 */
	
	"use strict";
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.trapezium = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom',
			type: 'isosceles'  // isosceles, scalene
		};
	
		// Thanks for https://github.com/substack/point-in-polygon
		var pointInPolygon = function (point, vs) {
			// ray-casting algorithm based on
			// http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
	
			var x = point[0], y = point[1];
	
			var inside = false;
			for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
				var xi = vs[i][0], yi = vs[i][1];
				var xj = vs[j][0], yj = vs[j][1];
	
				var intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
				if (intersect) inside = !inside;
			}
	
			return inside;
		};
	
		Chart.elements.Trapezium = Chart.Element.extend({
			getCorners: function () {
				var vm = this._view;
				var globalOptionTrapeziumElements = globalOpts.elements.trapezium;
	
				var corners = [],
					type = vm.type || globalOptionTrapeziumElements.type,
					top = vm.y,
					borderWidth = vm.borderWidth || globalOptionTrapeziumElements.borderWidth,
					upHalfWidth = vm.upperWidth / 2,
					botHalfWidth = vm.bottomWidth / 2,
					halfStroke = borderWidth / 2;
	
				halfStroke = halfStroke < 0 ? 0 : halfStroke;
	
				// An isosceles trapezium
				if (type == 'isosceles') {
					var x = vm.x;
	
					// Corner points, from bottom-left to bottom-right clockwise
					// | 1 2 |
					// | 0 3 |
					corners = [
						[x - botHalfWidth + halfStroke, vm.base],
						[x - upHalfWidth + halfStroke, top + halfStroke],
						[x + upHalfWidth - halfStroke, top + halfStroke],
						[x + botHalfWidth - halfStroke, vm.base]
					];
				} else if (type == 'scalene') {
					var x1 = vm.x1,
						x2 = vm.x2;
	
					corners = [
						[x2 - botHalfWidth + halfStroke, vm.base],
						[x1 - upHalfWidth + halfStroke, top + halfStroke],
						[x1 + upHalfWidth - halfStroke, top + halfStroke],
						[x2 + botHalfWidth - halfStroke, vm.base]
					];
				}
	
	
				return corners;
			},
			draw: function () {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var globalOptionTrapeziumElements = globalOpts.elements.trapezium;
	
				var corners = this.getCorners();
				this._cornersCache = corners;
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor || globalOptionTrapeziumElements.backgroundColor;
				ctx.strokeStyle = vm.borderColor || globalOptionTrapeziumElements.borderColor;
				ctx.lineWidth = vm.borderWidth || globalOptionTrapeziumElements.borderWidth;
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(
					vm.borderSkipped || globalOptionTrapeziumElements.borderSkipped,
					0);
				if (startCorner === -1)
					startCorner = 0;
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				ctx.moveTo.apply(ctx, cornerAt(0));
				for (var i = 1; i < 4; i++)
					ctx.lineTo.apply(ctx, cornerAt(i));
	
				ctx.fill();
				if (vm.borderWidth) {
					ctx.stroke();
				}
			},
			height: function () {
				var vm = this._view;
				if (!vm) {
					return 0;
				}
	
				return vm.base - vm.y;
			},
			inRange: function (mouseX, mouseY) {
				var vm = this._view;
				if (!vm) {
					return false;
				}
				var corners = this._cornersCache ? this._cornersCache : this.getCorners();
				return pointInPolygon([mouseX, mouseY], corners);
			},
			inLabelRange: function (mouseX) {
				var x,
					vm = this._view;
	
				if (!vm) {
					return false;
				}
	
				if (vm.type == 'scalene') {
					if (vm.x1 > vm.x2) {
						return mouseX >= vm.x2 - vm.bottomWidth / 2 && mouseX <= vm.x1 + vm.upperWidth / 2;
					} else {
						return mouseX <= vm.x2 + vm.bottomWidth / 2 && mouseX >= vm.x1 - vm.upperWidth / 2;
					}
				}
	
				var maxWidth = Math.max(vm.upperWidth, vm.bottomWidth);
				return mouseX >= vm.x - maxWidth / 2 && mouseX <= vm.x + maxWidth / 2;
	
			},
			tooltipPosition: function () {
				var vm = this._view;
				return {
					x: vm.x || vm.x2,
					y: vm.base - (vm.base - vm.y)/2
				};
			}
		});
	};

/***/ },
/* 566 */
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(566);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {// colResizable 1.6 - a jQuery plugin by Alvaro Prieto Lauroba http://www.bacubacu.com/colresizable/
	
	!function(t){var e,i=t(document),r=t("head"),o=null,s={},d=0,n="id",a="px",l="JColResizer",c="JCLRFlex",f=parseInt,h=Math,p=navigator.userAgent.indexOf("Trident/4.0")>0;try{e=sessionStorage}catch(g){}r.append("<style type='text/css'>  .JColResizer{table-layout:fixed;} .JColResizer > tbody > tr > td, .JColResizer > tbody > tr > th{overflow:hidden;padding-left:0!important; padding-right:0!important;}  .JCLRgrips{ height:0px; position:relative;} .JCLRgrip{margin-left:-5px; position:absolute; z-index:5; } .JCLRgrip .JColResizer{position:absolute;background-color:red;filter:alpha(opacity=1);opacity:0;width:10px;height:100%;cursor: e-resize;top:0px} .JCLRLastGrip{position:absolute; width:1px; } .JCLRgripDrag{ border-left:1px dotted black;	} .JCLRFlex{width:auto!important;} .JCLRgrip.JCLRdisabledGrip .JColResizer{cursor:default; display:none;}</style>");var u=function(e,i){var o=t(e);if(o.opt=i,o.mode=i.resizeMode,o.dc=o.opt.disabledColumns,o.opt.disable)return w(o);var a=o.id=o.attr(n)||l+d++;o.p=o.opt.postbackSafe,!o.is("table")||s[a]&&!o.opt.partialRefresh||("e-resize"!==o.opt.hoverCursor&&r.append("<style type='text/css'>.JCLRgrip .JColResizer:hover{cursor:"+o.opt.hoverCursor+"!important}</style>"),o.addClass(l).attr(n,a).before('<div class="JCLRgrips"/>'),o.g=[],o.c=[],o.w=o.width(),o.gc=o.prev(),o.f=o.opt.fixed,i.marginLeft&&o.gc.css("marginLeft",i.marginLeft),i.marginRight&&o.gc.css("marginRight",i.marginRight),o.cs=f(p?e.cellSpacing||e.currentStyle.borderSpacing:o.css("border-spacing"))||2,o.b=f(p?e.border||e.currentStyle.borderLeftWidth:o.css("border-left-width"))||1,s[a]=o,v(o))},w=function(t){var e=t.attr(n),t=s[e];t&&t.is("table")&&(t.removeClass(l+" "+c).gc.remove(),delete s[e])},v=function(i){var r=i.find(">thead>tr:first>th,>thead>tr:first>td");r.length||(r=i.find(">tbody>tr:first>th,>tr:first>th,>tbody>tr:first>td, >tr:first>td")),r=r.filter(":visible"),i.cg=i.find("col"),i.ln=r.length,i.p&&e&&e[i.id]&&m(i,r),r.each(function(e){var r=t(this),o=-1!=i.dc.indexOf(e),s=t(i.gc.append('<div class="JCLRgrip"></div>')[0].lastChild);s.append(o?"":i.opt.gripInnerHtml).append('<div class="'+l+'"></div>'),e==i.ln-1&&(s.addClass("JCLRLastGrip"),i.f&&s.html("")),s.bind("touchstart mousedown",J),o?s.addClass("JCLRdisabledGrip"):s.removeClass("JCLRdisabledGrip").bind("touchstart mousedown",J),s.t=i,s.i=e,s.c=r,r.w=r.width(),i.g.push(s),i.c.push(r),r.width(r.w).removeAttr("width"),s.data(l,{i:e,t:i.attr(n),last:e==i.ln-1})}),i.cg.removeAttr("width"),i.find("td, th").not(r).not("table th, table td").each(function(){t(this).removeAttr("width")}),i.f||i.removeAttr("width").addClass(c),C(i)},m=function(t,i){var r,o,s=0,d=0,n=[];if(i){if(t.cg.removeAttr("width"),t.opt.flush)return void(e[t.id]="");for(r=e[t.id].split(";"),o=r[t.ln+1],!t.f&&o&&(t.width(o*=1),t.opt.overflow&&(t.css("min-width",o+a),t.w=o));d<t.ln;d++)n.push(100*r[d]/r[t.ln]+"%"),i.eq(d).css("width",n[d]);for(d=0;d<t.ln;d++)t.cg.eq(d).css("width",n[d])}else{for(e[t.id]="";d<t.c.length;d++)r=t.c[d].width(),e[t.id]+=r+";",s+=r;e[t.id]+=s,t.f||(e[t.id]+=";"+t.width())}},C=function(t){t.gc.width(t.w);for(var e=0;e<t.ln;e++){var i=t.c[e];t.g[e].css({left:i.offset().left-t.offset().left+i.outerWidth(!1)+t.cs/2+a,height:t.opt.headerOnly?t.c[0].outerHeight(!1):t.outerHeight(!1)})}},b=function(t,e,i){var r=o.x-o.l,s=t.c[e],d=t.c[e+1],n=s.w+r,l=d.w-r;s.width(n+a),t.cg.eq(e).width(n+a),t.f?(d.width(l+a),t.cg.eq(e+1).width(l+a)):t.opt.overflow&&t.css("min-width",t.w+r),i&&(s.w=n,d.w=t.f?l:d.w)},R=function(e){var i=t.map(e.c,function(t){return t.width()});e.width(e.w=e.width()).removeClass(c),t.each(e.c,function(t,e){e.width(i[t]).w=i[t]}),e.addClass(c)},x=function(t){if(o){var e=o.t,i=t.originalEvent.touches,r=i?i[0].pageX:t.pageX,s=r-o.ox+o.l,d=e.opt.minWidth,n=o.i,l=1.5*e.cs+d+e.b,c=n==e.ln-1,f=n?e.g[n-1].position().left+e.cs+d:l,p=e.f?n==e.ln-1?e.w-l:e.g[n+1].position().left-e.cs-d:1/0;if(s=h.max(f,h.min(p,s)),o.x=s,o.css("left",s+a),c){var g=e.c[o.i];o.w=g.w+s-o.l}if(e.opt.liveDrag){c?(g.width(o.w),!e.f&&e.opt.overflow?e.css("min-width",e.w+s-o.l):e.w=e.width()):b(e,n),C(e);var u=e.opt.onDrag;u&&(t.currentTarget=e[0],u(t))}return!1}},y=function(r){if(i.unbind("touchend."+l+" mouseup."+l).unbind("touchmove."+l+" mousemove."+l),t("head :last-child").remove(),o){if(o.removeClass(o.t.opt.draggingClass),o.x-o.l!=0){var s=o.t,d=s.opt.onResize,n=o.i,a=n==s.ln-1,c=s.g[n].c;a?(c.width(o.w),c.w=o.w):b(s,n,!0),s.f||R(s),C(s),d&&(r.currentTarget=s[0],d(r)),s.p&&e&&m(s)}o=null}},J=function(e){var d=t(this).data(l),n=s[d.t],a=n.g[d.i],c=e.originalEvent.touches;if(a.ox=c?c[0].pageX:e.pageX,a.l=a.position().left,a.x=a.l,i.bind("touchmove."+l+" mousemove."+l,x).bind("touchend."+l+" mouseup."+l,y),r.append("<style type='text/css'>*{cursor:"+n.opt.dragCursor+"!important}</style>"),a.addClass(n.opt.draggingClass),o=a,n.c[d.i].l)for(var f,h=0;h<n.ln;h++)f=n.c[h],f.l=!1,f.w=f.width();return!1},L=function(){for(var t in s)if(s.hasOwnProperty(t)){t=s[t];var i,r=0;if(t.removeClass(l),t.f){for(t.w=t.width(),i=0;i<t.ln;i++)r+=t.c[i].w;for(i=0;i<t.ln;i++)t.c[i].css("width",h.round(1e3*t.c[i].w/r)/10+"%").l=!0}else R(t),"flex"==t.mode&&t.p&&e&&m(t);C(t.addClass(l))}};t(window).bind("resize."+l,L),t.fn.extend({colResizable:function(e){var i={resizeMode:"fit",draggingClass:"JCLRgripDrag",gripInnerHtml:"",liveDrag:!1,minWidth:15,headerOnly:!1,hoverCursor:"e-resize",dragCursor:"e-resize",postbackSafe:!1,flush:!1,marginLeft:null,marginRight:null,disable:!1,partialRefresh:!1,disabledColumns:[],onDrag:null,onResize:null},e=t.extend(i,e);switch(e.fixed=!0,e.overflow=!1,e.resizeMode){case"flex":e.fixed=!1;break;case"overflow":e.fixed=!1,e.overflow=!0}return this.each(function(){u(this,e)})}})}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(616);
	module.exports = __webpack_require__(39).RegExp.escape;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(38)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(598);
	module.exports = __webpack_require__(38).Number.isNaN;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(599);
	module.exports = __webpack_require__(38).Object.assign;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(600);
	var $Object = __webpack_require__(38).Object;
	module.exports = function defineProperties(T, D){
	  return $Object.defineProperties(T, D);
	};

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(601);
	module.exports = __webpack_require__(38).Object.keys;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(604);
	__webpack_require__(602);
	__webpack_require__(605);
	__webpack_require__(606);
	module.exports = __webpack_require__(38).Symbol;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(603);
	__webpack_require__(607);
	module.exports = __webpack_require__(121).f('iterator');

/***/ },
/* 578 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 579 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(49)
	  , toLength  = __webpack_require__(596)
	  , toIndex   = __webpack_require__(595);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(578);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(67)
	  , gOPS    = __webpack_require__(113)
	  , pIE     = __webpack_require__(86);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(43).document && document.documentElement;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(177);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(182)
	  , descriptor     = __webpack_require__(87)
	  , setToStringTag = __webpack_require__(114)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(65)(IteratorPrototype, __webpack_require__(68)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 586 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(67)
	  , toIObject = __webpack_require__(49);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(88)('meta')
	  , isObject = __webpack_require__(85)
	  , has      = __webpack_require__(48)
	  , setDesc  = __webpack_require__(66).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(64)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(67)
	  , gOPS     = __webpack_require__(113)
	  , pIE      = __webpack_require__(86)
	  , toObject = __webpack_require__(118)
	  , IObject  = __webpack_require__(180)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(64)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(86)
	  , createDesc     = __webpack_require__(87)
	  , toIObject      = __webpack_require__(49)
	  , toPrimitive    = __webpack_require__(119)
	  , has            = __webpack_require__(48)
	  , IE8_DOM_DEFINE = __webpack_require__(179)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(47) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(49)
	  , gOPN      = __webpack_require__(184).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(48)
	  , toObject    = __webpack_require__(118)
	  , IE_PROTO    = __webpack_require__(115)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(63)
	  , core    = __webpack_require__(38)
	  , fails   = __webpack_require__(64);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(117)
	  , defined   = __webpack_require__(109);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(117)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(117)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(579)
	  , step             = __webpack_require__(586)
	  , Iterators        = __webpack_require__(111)
	  , toIObject        = __webpack_require__(49);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(181)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(63);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(63);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(589)});

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(63);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(47), 'Object', {defineProperties: __webpack_require__(183)});

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(118)
	  , $keys    = __webpack_require__(67);
	
	__webpack_require__(593)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 602 */
/***/ function(module, exports) {



/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(594)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(181)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(43)
	  , has            = __webpack_require__(48)
	  , DESCRIPTORS    = __webpack_require__(47)
	  , $export        = __webpack_require__(63)
	  , redefine       = __webpack_require__(186)
	  , META           = __webpack_require__(588).KEY
	  , $fails         = __webpack_require__(64)
	  , shared         = __webpack_require__(116)
	  , setToStringTag = __webpack_require__(114)
	  , uid            = __webpack_require__(88)
	  , wks            = __webpack_require__(68)
	  , wksExt         = __webpack_require__(121)
	  , wksDefine      = __webpack_require__(120)
	  , keyOf          = __webpack_require__(587)
	  , enumKeys       = __webpack_require__(582)
	  , isArray        = __webpack_require__(584)
	  , anObject       = __webpack_require__(84)
	  , toIObject      = __webpack_require__(49)
	  , toPrimitive    = __webpack_require__(119)
	  , createDesc     = __webpack_require__(87)
	  , _create        = __webpack_require__(182)
	  , gOPNExt        = __webpack_require__(591)
	  , $GOPD          = __webpack_require__(590)
	  , $DP            = __webpack_require__(66)
	  , $keys          = __webpack_require__(67)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(184).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(86).f  = $propertyIsEnumerable;
	  __webpack_require__(113).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(112)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(65)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(120)('asyncIterator');

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(120)('observable');

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(597);
	var global        = __webpack_require__(43)
	  , hide          = __webpack_require__(65)
	  , Iterators     = __webpack_require__(111)
	  , TO_STRING_TAG = __webpack_require__(68)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11)
	  , isArray  = __webpack_require__(130)
	  , SPECIES  = __webpack_require__(13)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(608);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(7)
	  , toPrimitive = __webpack_require__(36)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(54)
	  , gOPS    = __webpack_require__(97)
	  , pIE     = __webpack_require__(77);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(54)
	  , toIObject = __webpack_require__(25);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(614)
	  , invoke    = __webpack_require__(93)
	  , aFunction = __webpack_require__(21);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(8);

/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3)
	  , $re     = __webpack_require__(615)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(188)});
	
	__webpack_require__(69)('copyWithin');

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $every  = __webpack_require__(34)(4);
	
	$export($export.P + $export.F * !__webpack_require__(32)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {fill: __webpack_require__(122)});
	
	__webpack_require__(69)('fill');

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $filter = __webpack_require__(34)(2);
	
	$export($export.P + $export.F * !__webpack_require__(32)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(34)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(69)(KEY);

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(34)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(69)(KEY);

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(3)
	  , $forEach = __webpack_require__(34)(0)
	  , STRICT   = __webpack_require__(32)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(40)
	  , $export        = __webpack_require__(3)
	  , toObject       = __webpack_require__(18)
	  , call           = __webpack_require__(197)
	  , isArrayIter    = __webpack_require__(129)
	  , toLength       = __webpack_require__(17)
	  , createProperty = __webpack_require__(123)
	  , getIterFn      = __webpack_require__(146);
	
	$export($export.S + $export.F * !__webpack_require__(95)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , $indexOf      = __webpack_require__(89)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(32)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(130)});

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(25)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(76) != Object || !__webpack_require__(32)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , toIObject     = __webpack_require__(25)
	  , toInteger     = __webpack_require__(46)
	  , toLength      = __webpack_require__(17)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(32)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $map    = __webpack_require__(34)(1);
	
	$export($export.P + $export.F * !__webpack_require__(32)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(3)
	  , createProperty = __webpack_require__(123);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(9)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(190);
	
	$export($export.P + $export.F * !__webpack_require__(32)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(190);
	
	$export($export.P + $export.F * !__webpack_require__(32)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(3)
	  , html       = __webpack_require__(127)
	  , cof        = __webpack_require__(30)
	  , toIndex    = __webpack_require__(57)
	  , toLength   = __webpack_require__(17)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(9)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $some   = __webpack_require__(34)(3);
	
	$export($export.P + $export.F * !__webpack_require__(32)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(18)
	  , fails     = __webpack_require__(9)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(32)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(56)('Array');

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(9)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(3)
	  , toObject    = __webpack_require__(18)
	  , toPrimitive = __webpack_require__(36);
	
	$export($export.P + $export.F * __webpack_require__(9)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(13)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(22)(proto, TO_PRIMITIVE, __webpack_require__(610));

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(23)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', {bind: __webpack_require__(191)});

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(11)
	  , getPrototypeOf = __webpack_require__(28)
	  , HAS_INSTANCE   = __webpack_require__(13)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(15).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(15).f
	  , createDesc = __webpack_require__(45)
	  , has        = __webpack_require__(20)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3)
	  , log1p   = __webpack_require__(199)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3)
	  , sign    = __webpack_require__(134);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3)
	  , $expm1  = __webpack_require__(133);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(3)
	  , sign      = __webpack_require__(134)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(9)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(199)});

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {sign: __webpack_require__(134)});

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(133)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(9)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(133)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(8)
	  , has               = __webpack_require__(20)
	  , cof               = __webpack_require__(30)
	  , inheritIfRequired = __webpack_require__(128)
	  , toPrimitive       = __webpack_require__(36)
	  , fails             = __webpack_require__(9)
	  , gOPN              = __webpack_require__(53).f
	  , gOPD              = __webpack_require__(27).f
	  , dP                = __webpack_require__(15).f
	  , $trim             = __webpack_require__(73).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(52)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(14) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(23)(global, NUMBER, $Number);
	}

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(3)
	  , _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(196)});

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(3)
	  , isInteger = __webpack_require__(196)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(206);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(207);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , toInteger    = __webpack_require__(46)
	  , aNumberValue = __webpack_require__(187)
	  , repeat       = __webpack_require__(141)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(9)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $fails       = __webpack_require__(9)
	  , aNumberValue = __webpack_require__(187)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(200)});

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(52)});

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(14), 'Object', {defineProperties: __webpack_require__(201)});

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(14), 'Object', {defineProperty: __webpack_require__(15).f});

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(11)
	  , meta     = __webpack_require__(44).onFreeze;
	
	__webpack_require__(35)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(25)
	  , $getOwnPropertyDescriptor = __webpack_require__(27).f;
	
	__webpack_require__(35)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(35)('getOwnPropertyNames', function(){
	  return __webpack_require__(202).f;
	});

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(18)
	  , $getPrototypeOf = __webpack_require__(28);
	
	__webpack_require__(35)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(11);
	
	__webpack_require__(35)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(11);
	
	__webpack_require__(35)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(11);
	
	__webpack_require__(35)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {is: __webpack_require__(208)});

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(18)
	  , $keys    = __webpack_require__(54);
	
	__webpack_require__(35)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(11)
	  , meta     = __webpack_require__(44).onFreeze;
	
	__webpack_require__(35)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(11)
	  , meta     = __webpack_require__(44).onFreeze;
	
	__webpack_require__(35)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(136).set});

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75)
	  , test    = {};
	test[__webpack_require__(13)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(23)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(206);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(207);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(51)
	  , global             = __webpack_require__(8)
	  , ctx                = __webpack_require__(40)
	  , classof            = __webpack_require__(75)
	  , $export            = __webpack_require__(3)
	  , isObject           = __webpack_require__(11)
	  , aFunction          = __webpack_require__(21)
	  , anInstance         = __webpack_require__(50)
	  , forOf              = __webpack_require__(70)
	  , speciesConstructor = __webpack_require__(138)
	  , task               = __webpack_require__(143).set
	  , microtask          = __webpack_require__(135)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(55)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(72)($Promise, PROMISE);
	__webpack_require__(56)(PROMISE);
	Wrapper = __webpack_require__(39)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(95)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(21)
	  , anObject  = __webpack_require__(7)
	  , rApply    = (__webpack_require__(8).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(9)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(3)
	  , create     = __webpack_require__(52)
	  , aFunction  = __webpack_require__(21)
	  , anObject   = __webpack_require__(7)
	  , isObject   = __webpack_require__(11)
	  , fails      = __webpack_require__(9)
	  , bind       = __webpack_require__(191)
	  , rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(15)
	  , $export     = __webpack_require__(3)
	  , anObject    = __webpack_require__(7)
	  , toPrimitive = __webpack_require__(36);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(9)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(3)
	  , gOPD     = __webpack_require__(27).f
	  , anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(7);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(27)
	  , $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(3)
	  , getProto = __webpack_require__(28)
	  , anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(27)
	  , getPrototypeOf = __webpack_require__(28)
	  , has            = __webpack_require__(20)
	  , $export        = __webpack_require__(3)
	  , isObject       = __webpack_require__(11)
	  , anObject       = __webpack_require__(7);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(3)
	  , anObject      = __webpack_require__(7)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(205)});

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(3)
	  , anObject           = __webpack_require__(7)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(3)
	  , setProto = __webpack_require__(136);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(15)
	  , gOPD           = __webpack_require__(27)
	  , getPrototypeOf = __webpack_require__(28)
	  , has            = __webpack_require__(20)
	  , $export        = __webpack_require__(3)
	  , createDesc     = __webpack_require__(45)
	  , anObject       = __webpack_require__(7)
	  , isObject       = __webpack_require__(11);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(8)
	  , inheritIfRequired = __webpack_require__(128)
	  , dP                = __webpack_require__(15).f
	  , gOPN              = __webpack_require__(53).f
	  , isRegExp          = __webpack_require__(94)
	  , $flags            = __webpack_require__(92)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(9)(function(){
	  re2[__webpack_require__(13)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(23)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(56)('RegExp');

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(91)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(91)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(91)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(91)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(94)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(212);
	var anObject    = __webpack_require__(7)
	  , $flags      = __webpack_require__(92)
	  , DESCRIPTORS = __webpack_require__(14)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(23)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(9)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(24)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(24)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(24)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(24)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(139)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(3)
	  , toLength  = __webpack_require__(17)
	  , context   = __webpack_require__(140)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(126)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(24)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(24)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(24)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(3)
	  , toIndex        = __webpack_require__(57)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(3)
	  , context  = __webpack_require__(140)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(126)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(24)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(139)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(132)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(24)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(25)
	  , toLength  = __webpack_require__(17);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(141)
	});

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(24)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(3)
	  , toLength    = __webpack_require__(17)
	  , context     = __webpack_require__(140)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(126)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(24)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(24)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(24)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(73)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(8)
	  , has            = __webpack_require__(20)
	  , DESCRIPTORS    = __webpack_require__(14)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(23)
	  , META           = __webpack_require__(44).KEY
	  , $fails         = __webpack_require__(9)
	  , shared         = __webpack_require__(98)
	  , setToStringTag = __webpack_require__(72)
	  , uid            = __webpack_require__(58)
	  , wks            = __webpack_require__(13)
	  , wksExt         = __webpack_require__(210)
	  , wksDefine      = __webpack_require__(145)
	  , keyOf          = __webpack_require__(612)
	  , enumKeys       = __webpack_require__(611)
	  , isArray        = __webpack_require__(130)
	  , anObject       = __webpack_require__(7)
	  , toIObject      = __webpack_require__(25)
	  , toPrimitive    = __webpack_require__(36)
	  , createDesc     = __webpack_require__(45)
	  , _create        = __webpack_require__(52)
	  , gOPNExt        = __webpack_require__(202)
	  , $GOPD          = __webpack_require__(27)
	  , $DP            = __webpack_require__(15)
	  , $keys          = __webpack_require__(54)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(53).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(77).f  = $propertyIsEnumerable;
	  __webpack_require__(97).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(51)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(22)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $typed       = __webpack_require__(99)
	  , buffer       = __webpack_require__(144)
	  , anObject     = __webpack_require__(7)
	  , toIndex      = __webpack_require__(57)
	  , toLength     = __webpack_require__(17)
	  , isObject     = __webpack_require__(11)
	  , ArrayBuffer  = __webpack_require__(8).ArrayBuffer
	  , speciesConstructor = __webpack_require__(138)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(9)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(56)(ARRAY_BUFFER);

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(99).ABV, {
	  DataView: __webpack_require__(144).DataView
	});

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(194);
	
	// 23.4 WeakSet Objects
	__webpack_require__(90)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(3)
	  , $includes = __webpack_require__(89)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(69)('includes');

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(3)
	  , microtask = __webpack_require__(135)()
	  , process   = __webpack_require__(8).process
	  , isNode    = __webpack_require__(30)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3)
	  , cof     = __webpack_require__(30);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(193)('Map')});

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(18)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(15);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(14) && $export($export.P + __webpack_require__(96), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(18)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(15);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(14) && $export($export.P + __webpack_require__(96), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(3)
	  , $entries = __webpack_require__(204)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(3)
	  , ownKeys        = __webpack_require__(205)
	  , toIObject      = __webpack_require__(25)
	  , gOPD           = __webpack_require__(27)
	  , createProperty = __webpack_require__(123);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(18)
	  , toPrimitive              = __webpack_require__(36)
	  , getPrototypeOf           = __webpack_require__(28)
	  , getOwnPropertyDescriptor = __webpack_require__(27).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(14) && $export($export.P + __webpack_require__(96), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(18)
	  , toPrimitive              = __webpack_require__(36)
	  , getPrototypeOf           = __webpack_require__(28)
	  , getOwnPropertyDescriptor = __webpack_require__(27).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(14) && $export($export.P + __webpack_require__(96), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3)
	  , $values = __webpack_require__(204)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(3)
	  , global      = __webpack_require__(8)
	  , core        = __webpack_require__(39)
	  , microtask   = __webpack_require__(135)()
	  , OBSERVABLE  = __webpack_require__(13)('observable')
	  , aFunction   = __webpack_require__(21)
	  , anObject    = __webpack_require__(7)
	  , anInstance  = __webpack_require__(50)
	  , redefineAll = __webpack_require__(55)
	  , hide        = __webpack_require__(22)
	  , forOf       = __webpack_require__(70)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(56)('Observable');

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(41)
	  , anObject                  = __webpack_require__(7)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(41)
	  , anObject               = __webpack_require__(7)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(213)
	  , from                    = __webpack_require__(189)
	  , metadata                = __webpack_require__(41)
	  , anObject                = __webpack_require__(7)
	  , getPrototypeOf          = __webpack_require__(28)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(41)
	  , anObject               = __webpack_require__(7)
	  , getPrototypeOf         = __webpack_require__(28)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(41)
	  , anObject                = __webpack_require__(7)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(41)
	  , anObject               = __webpack_require__(7)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(41)
	  , anObject               = __webpack_require__(7)
	  , getPrototypeOf         = __webpack_require__(28)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(41)
	  , anObject               = __webpack_require__(7)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(41)
	  , anObject                  = __webpack_require__(7)
	  , aFunction                 = __webpack_require__(21)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(193)('Set')});

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(139)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(3)
	  , defined     = __webpack_require__(31)
	  , toLength    = __webpack_require__(17)
	  , isRegExp    = __webpack_require__(94)
	  , getFlags    = __webpack_require__(92)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(209);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(209);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(73)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(73)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(145)('asyncIterator');

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(145)('observable');

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', {global: __webpack_require__(8)});

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(147)
	  , redefine      = __webpack_require__(23)
	  , global        = __webpack_require__(8)
	  , hide          = __webpack_require__(22)
	  , Iterators     = __webpack_require__(71)
	  , wks           = __webpack_require__(13)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , $task   = __webpack_require__(143);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(8)
	  , $export    = __webpack_require__(3)
	  , invoke     = __webpack_require__(93)
	  , partial    = __webpack_require__(613)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(736);
	__webpack_require__(675);
	__webpack_require__(677);
	__webpack_require__(676);
	__webpack_require__(679);
	__webpack_require__(681);
	__webpack_require__(686);
	__webpack_require__(680);
	__webpack_require__(678);
	__webpack_require__(688);
	__webpack_require__(687);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(682);
	__webpack_require__(674);
	__webpack_require__(685);
	__webpack_require__(689);
	__webpack_require__(690);
	__webpack_require__(642);
	__webpack_require__(644);
	__webpack_require__(643);
	__webpack_require__(692);
	__webpack_require__(691);
	__webpack_require__(662);
	__webpack_require__(672);
	__webpack_require__(673);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(669);
	__webpack_require__(670);
	__webpack_require__(671);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(655);
	__webpack_require__(656);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(661);
	__webpack_require__(723);
	__webpack_require__(728);
	__webpack_require__(735);
	__webpack_require__(726);
	__webpack_require__(718);
	__webpack_require__(719);
	__webpack_require__(724);
	__webpack_require__(729);
	__webpack_require__(731);
	__webpack_require__(714);
	__webpack_require__(715);
	__webpack_require__(716);
	__webpack_require__(717);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(722);
	__webpack_require__(725);
	__webpack_require__(727);
	__webpack_require__(730);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(637);
	__webpack_require__(639);
	__webpack_require__(638);
	__webpack_require__(641);
	__webpack_require__(640);
	__webpack_require__(626);
	__webpack_require__(624);
	__webpack_require__(630);
	__webpack_require__(627);
	__webpack_require__(633);
	__webpack_require__(635);
	__webpack_require__(623);
	__webpack_require__(629);
	__webpack_require__(620);
	__webpack_require__(634);
	__webpack_require__(618);
	__webpack_require__(632);
	__webpack_require__(631);
	__webpack_require__(625);
	__webpack_require__(628);
	__webpack_require__(617);
	__webpack_require__(619);
	__webpack_require__(622);
	__webpack_require__(621);
	__webpack_require__(636);
	__webpack_require__(147);
	__webpack_require__(708);
	__webpack_require__(713);
	__webpack_require__(212);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(693);
	__webpack_require__(211);
	__webpack_require__(213);
	__webpack_require__(214);
	__webpack_require__(748);
	__webpack_require__(737);
	__webpack_require__(738);
	__webpack_require__(743);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(741);
	__webpack_require__(744);
	__webpack_require__(742);
	__webpack_require__(745);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(694);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(701);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(707);
	__webpack_require__(706);
	__webpack_require__(749);
	__webpack_require__(775);
	__webpack_require__(778);
	__webpack_require__(777);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(776);
	__webpack_require__(781);
	__webpack_require__(782);
	__webpack_require__(760);
	__webpack_require__(763);
	__webpack_require__(759);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(752);
	__webpack_require__(774);
	__webpack_require__(783);
	__webpack_require__(751);
	__webpack_require__(753);
	__webpack_require__(755);
	__webpack_require__(754);
	__webpack_require__(756);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(768);
	__webpack_require__(767);
	__webpack_require__(770);
	__webpack_require__(769);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(773);
	__webpack_require__(750);
	__webpack_require__(764);
	__webpack_require__(786);
	__webpack_require__(785);
	__webpack_require__(784);
	module.exports = __webpack_require__(39);

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * animate.css -http://daneden.me/animate\n * Version - 3.5.1\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2016 Daniel Eden\n */.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.bounce{-webkit-animation-name:bounce;animation-name:bounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.headShake{-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:headShake;animation-name:headShake}@-webkit-keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}.swing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:swing;animation-name:swing}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}@keyframes wobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes jello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes jello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{-webkit-animation-name:jello;animation-name:jello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}.bounceIn{-webkit-animation-name:bounceIn;animation-name:bounceIn}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-name:bounceOut;animation-name:bounceOut}@-webkit-keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes flip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:flip;animation-name:flip}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInX;animation-name:flipInX}@-webkit-keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInY;animation-name:flipInY}@-webkit-keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{-webkit-animation-name:flipOutX;animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@-webkit-keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipOutY;animation-name:flipOutY}@-webkit-keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg);opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg);opacity:1}to{-webkit-transform:none;transform:none;opacity:1}}@keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg);opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg);opacity:1}to{-webkit-transform:none;transform:none;opacity:1}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}@keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{0%{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateIn{0%{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{0%{-webkit-transform-origin:center;transform-origin:center;opacity:1}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}@keyframes rotateOut{0%{-webkit-transform-origin:center;transform-origin:center;opacity:1}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}@keyframes rotateOutDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}@keyframes rotateOutUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}@keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}.hinge{-webkit-animation-name:hinge;animation-name:hinge}@-webkit-keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}@keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{0%{opacity:1}50%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}@keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}@keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInDown{-webkit-animation-name:slideInDown;animation-name:slideInDown}@-webkit-keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInLeft{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}@-webkit-keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInRight{-webkit-animation-name:slideInRight;animation-name:slideInRight}@-webkit-keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInUp{-webkit-animation-name:slideInUp;animation-name:slideInUp}@-webkit-keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.slideOutDown{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}@-webkit-keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.slideOutLeft{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}@-webkit-keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.slideOutRight{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}@-webkit-keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.slideOutUp{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}", ""]);
	
	// exports


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}legend{padding:0;border:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(215) + ");src:url(" + __webpack_require__(215) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(851) + ") format('woff2'),url(" + __webpack_require__(850) + ") format('woff'),url(" + __webpack_require__(854) + ") format('truetype'),url(" + __webpack_require__(856) + "#glyphicons_halflingsregular) format('svg')}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:'\\2014   \\A0'}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:''}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:'\\A0   \\2014'}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),all and (transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000',endColorstr='#00000000',GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000',endColorstr='#80000000',GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:'\\2039'}.carousel-control .icon-next:before{content:'\\203A'}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Datetimepicker for Bootstrap 3\n * version : 4.17.46\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */.bootstrap-datetimepicker-widget{list-style:none}.bootstrap-datetimepicker-widget.dropdown-menu{display:block;margin:2px 0;padding:4px;width:19em}@media (min-width:768px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:992px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:1200px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}.bootstrap-datetimepicker-widget.dropdown-menu:after,.bootstrap-datetimepicker-widget.dropdown-menu:before{content:'';display:inline-block;position:absolute}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);top:-7px;left:7px}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after{border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;top:-6px;left:8px}.bootstrap-datetimepicker-widget.dropdown-menu.top:before{border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #ccc;border-top-color:rgba(0,0,0,.2);bottom:-7px;left:6px}.bootstrap-datetimepicker-widget.dropdown-menu.top:after{border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid #fff;bottom:-6px;left:7px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before{left:auto;right:6px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after{left:auto;right:7px}.bootstrap-datetimepicker-widget .list-unstyled{margin:0}.bootstrap-datetimepicker-widget a[data-action]{padding:6px 0}.bootstrap-datetimepicker-widget a[data-action]:active{box-shadow:none}.bootstrap-datetimepicker-widget .timepicker-hour,.bootstrap-datetimepicker-widget .timepicker-minute,.bootstrap-datetimepicker-widget .timepicker-second{width:54px;font-weight:700;font-size:1.2em;margin:0}.bootstrap-datetimepicker-widget button[data-action]{padding:6px}.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Increment Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Increment Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Decrement Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Decrement Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=showHours]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Show Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Show Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Toggle AM/PM\"}.bootstrap-datetimepicker-widget .btn[data-action=clear]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Clear the picker\"}.bootstrap-datetimepicker-widget .btn[data-action=today]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Set the date to today\"}.bootstrap-datetimepicker-widget .picker-switch{text-align:center}.bootstrap-datetimepicker-widget .picker-switch:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Toggle Date and Time Screens\"}.bootstrap-datetimepicker-widget .picker-switch td{padding:0;margin:0;height:auto;width:auto;line-height:inherit}.bootstrap-datetimepicker-widget .picker-switch td span{line-height:2.5;height:2.5em;width:100%}.bootstrap-datetimepicker-widget table{width:100%;margin:0}.bootstrap-datetimepicker-widget table td,.bootstrap-datetimepicker-widget table th{text-align:center;border-radius:4px}.bootstrap-datetimepicker-widget table th{height:20px;line-height:20px;width:20px}.bootstrap-datetimepicker-widget table th.picker-switch{width:145px}.bootstrap-datetimepicker-widget table th.disabled,.bootstrap-datetimepicker-widget table th.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget table th.prev:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Previous Month\"}.bootstrap-datetimepicker-widget table th.next:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Next Month\"}.bootstrap-datetimepicker-widget table thead tr:first-child th{cursor:pointer}.bootstrap-datetimepicker-widget table thead tr:first-child th:hover{background:#eee}.bootstrap-datetimepicker-widget table td{height:54px;line-height:54px;width:54px}.bootstrap-datetimepicker-widget table td.cw{font-size:.8em;height:20px;line-height:20px;color:#777}.bootstrap-datetimepicker-widget table td.day{height:20px;line-height:20px;width:20px}.bootstrap-datetimepicker-widget table td.day:hover,.bootstrap-datetimepicker-widget table td.hour:hover,.bootstrap-datetimepicker-widget table td.minute:hover,.bootstrap-datetimepicker-widget table td.second:hover{background:#eee;cursor:pointer}.bootstrap-datetimepicker-widget table td.new,.bootstrap-datetimepicker-widget table td.old{color:#777}.bootstrap-datetimepicker-widget table td.today{position:relative}.bootstrap-datetimepicker-widget table td.today:before{content:'';display:inline-block;border:solid transparent;border-width:0 0 7px 7px;border-bottom-color:#337ab7;border-top-color:rgba(0,0,0,.2);position:absolute;bottom:4px;right:4px}.bootstrap-datetimepicker-widget table td.active,.bootstrap-datetimepicker-widget table td.active:hover{background-color:#337ab7;color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.bootstrap-datetimepicker-widget table td.active.today:before{border-bottom-color:#fff}.bootstrap-datetimepicker-widget table td.disabled,.bootstrap-datetimepicker-widget table td.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget table td span{display:inline-block;width:54px;height:54px;line-height:54px;margin:2px 1.5px;cursor:pointer;border-radius:4px}.bootstrap-datetimepicker-widget table td span:hover{background:#eee}.bootstrap-datetimepicker-widget table td span.active{background-color:#337ab7;color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.bootstrap-datetimepicker-widget table td span.old{color:#777}.bootstrap-datetimepicker-widget table td span.disabled,.bootstrap-datetimepicker-widget table td span.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget.usetwentyfour td.hour{height:27px;line-height:27px}.bootstrap-datetimepicker-widget.wider{width:21em}.bootstrap-datetimepicker-widget .datepicker-decades .decade{line-height:1.8em!important}.input-group.date .input-group-addon{cursor:pointer}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}", ""]);
	
	// exports


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(797) + ");src:url(" + __webpack_require__(796) + "?#iefix&v=4.7.0) format('embedded-opentype'),url(" + __webpack_require__(852) + ") format('woff2'),url(" + __webpack_require__(853) + ") format('woff'),url(" + __webpack_require__(855) + ") format('truetype'),url(" + __webpack_require__(857) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, ".m-t-0{margin-top:0!important}.m-t-1{margin-top:5px!important}.m-t-2{margin-top:10px!important}.m-t-3{margin-top:15px!important}.m-r-0{margin-right:0!important}.m-r-1{margin-right:5px!important}.m-r-2{margin-right:10px!important}.m-r-3{margin-right:15px!important}.m-b-0{margin-bottom:0!important}.m-b-1{margin-bottom:5px!important}.m-b-2{margin-bottom:10px!important}.m-b-3{margin-bottom:15px!important}.m-l-0{margin-left:0!important}.m-l-1{margin-left:5px!important}.m-l-2{margin-left:10px!important}.m-l-3{margin-left:15px!important}.m-x-0{margin-left:0!important;margin-right:0!important}.m-x-1{margin-left:5px!important;margin-right:5px!important}.m-x-2{margin-left:10px!important;margin-right:10px!important}.m-x-3{margin-left:15px!important;margin-right:15px!important}.m-y-0{margin-top:0!important;margin-bottom:0!important}.m-y-1{margin-top:5px!important;margin-bottom:5px!important}.m-y-2{margin-top:10px!important;margin-bottom:10px!important}.m-y-3{margin-top:15px!important;margin-bottom:15px!important}.m-a-0{margin:0!important}.m-a-1{margin:5px!important}.m-a-2{margin:10px!important}.m-a-3{margin:15px!important}.p-t-0{padding-top:0!important}.p-t-1{padding-top:5px!important}.p-t-2{padding-top:10px!important}.p-t-3{padding-top:15px!important}.p-r-0{padding-right:0!important}.p-r-1{padding-right:5px!important}.p-r-2{padding-right:10px!important}.p-r-3{padding-right:15px!important}.p-b-0{padding-bottom:0!important}.p-b-1{padding-bottom:5px!important}.p-b-2{padding-bottom:10px!important}.p-b-3{padding-bottom:15px!important}.p-l-0{padding-left:0!important}.p-l-1{padding-left:5px!important}.p-l-2{padding-left:10px!important}.p-l-3{padding-left:15px!important}.p-x-0{padding-left:0!important;padding-right:0!important}.p-x-1{padding-left:5px!important;padding-right:5px!important}.p-x-2{padding-left:10px!important;padding-right:10px!important}.p-x-3{padding-left:15px!important;padding-right:15px!important}.p-y-0{padding-top:0!important;padding-bottom:0!important}.p-y-1{padding-top:5px!important;padding-bottom:5px!important}.p-y-2{padding-top:10px!important;padding-bottom:10px!important}.p-y-3{padding-top:15px!important;padding-bottom:15px!important}.p-a-0{padding:0!important}.p-a-1{padding:5px!important}.p-a-2{padding:10px!important}.p-a-3{padding:15px!important}", ""]);
	
	// exports


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, ".old-browser{width:360px;margin:0 auto;border:1px solid #ccc;padding:5px 15px;border-radius:4px;margin-top:30px}.old-browser__browsers,.old-browser__content{text-align:center}.old-browser__browsers{display:inline-block}.old-browser__browser-link{float:left;width:109px;height:20px;padding:106px 0 13px;border-radius:4px;color:#2b587a;text-decoration:none;cursor:pointer}.old-browser__browsers .firefox{background:url(" + __webpack_require__(799) + ") no-repeat 50% 17px}.old-browser__browsers .chrome{background:url(" + __webpack_require__(798) + ") no-repeat 50% 17px}.old-browser__browsers .opera{background:url(" + __webpack_require__(800) + ") no-repeat 50% 15px}", ""]);
	
	// exports


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(59)();
	// imports
	
	
	// module
	exports.push([module.id, "html{width:100%;overflow-y:scroll}.btn,.form-control,.input-group-addon,.nav-pills>li>a,.nav-tabs>li>a,.well,.well-sm{border-radius:0!important}.form-group{margin-right:10px}@media screen and (max-width:1200px){.form-group{margin-top:5px}}.wrapper{width:100%;position:relative}.auth-logo{width:100%;height:170px;background-position:50%;background-size:contain}.sidebar-left ul:hover li.active a:hover,.sidebar-left ul li.active,.sidebar-left ul li a:hover{background-color:#198dd5}.sidebar-left ul:hover li.active{background-color:#2a5776}.sidebar-left ul li a{text-decoration:none;color:#aaa;padding:8px 20px;display:block}.sidebar-left ul li.active a,.sidebar-left ul li:hover a{color:#fff}@media screen and (min-width:768px){.sidebar-left{width:74px;position:fixed;float:left;min-height:100vh;background-color:#282f35;z-index:10;top:0}.main-container{position:relative;width:calc(100% - 84px)}.main-container .main{margin-left:74px;margin-top:61px}.main-container .navbar{margin-left:74px;box-shadow:0 0 8px rgba(0,0,0,.25)}.sidebar-left .logo{margin:18px auto;width:48px;height:0}.sidebar-left .menu{position:relative;overflow:hidden;height:calc(100vh - 76px)}.sidebar-left ul{list-style:none;line-height:1;padding:0;overflow-y:auto;height:calc(100vh - 96px);margin-right:-50px}.sidebar-left ul li{text-align:center;width:74px}.sidebar-left ul li a{text-decoration:none;color:#aaa;padding:8px 0;display:block}.sidebar-left ul li i{font-size:28px;display:block;margin:0 auto}.sidebar-left ul li span{font-size:10px;word-wrap:break-word}.sidebar-left .menu .menu__down{display:none}}@media screen and (max-width:767px){.sidebar-left{width:260px;position:fixed;float:left;min-height:100vh;height:100%;background-color:#282f35;z-index:1100;-webkit-transition:-webkit-transform .2s linear;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear;-webkit-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0);top:0}.sidebar-left.active{box-shadow:0 0 10px rgba(0,0,0,.5);-webkit-transform:translateZ(0);transform:translateZ(0)}.main-container{position:relative;width:100%}.main-container .main{margin-top:61px}.main-container .navbar{box-shadow:0 0 8px rgba(0,0,0,.25)}.sidebar-left .logo{margin:20px auto;background:url(" + __webpack_require__(801) + ") no-repeat;width:119px;height:47px}.sidebar-left .menu{position:relative;overflow:hidden;height:calc(100vh - 86px)}.sidebar-left ul{list-style:none;line-height:1;padding:0;overflow-y:scroll;height:calc(100vh - 96px)}.sidebar-left ul li i{font-size:24px;padding-bottom:5px;display:inline-block;width:32px;vertical-align:middle}.sidebar-left ul li span{font-size:14px;padding-left:4px;vertical-align:middle}}.table-hover>tbody>tr:hover>td,.table-hover>tbody>tr:hover>th{background-color:#d9edf7}.btn-file{position:relative;overflow:hidden}.btn-file>input[type=file]{position:absolute;top:0;right:0;width:100%;opacity:0;height:100%;z-index:5;cursor:pointer}select.form-control{background:#fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAMAAACzvE1FAAAADFBMVEUzMzMzMzMzMzMzMzMKAG/3AAAAA3RSTlMAf4C/aSLHAAAAPElEQVR42q3NMQ4AIAgEQTn//2cLdRKppSGzBYwzVXvznNWs8C58CiussPJj8h6NwgorrKRdTvuV9v16Afn0AYFOB7aYAAAAAElFTkSuQmCC) no-repeat scroll right .6rem center/8px 10px;padding:.375rem 1.75rem .375rem .75rem;-webkit-appearance:none;background-size:8px 10px;-moz-appearance:none}select.form-control::-ms-expand{display:none}.checkbox-inline>label{display:inline-block;max-width:100%;margin-bottom:1px;font-weight:700}.checkbox-inline>label>input[type=checkbox],.checkbox-inline>label>input[type=radio]{margin:0 0 1 -20px}.sortable-chosen{outline:1px dashed grey}.menu .menu__up{position:absolute;top:0;left:0;right:0;text-align:center;background:-webkit-linear-gradient(top,#282f35,transparent);background:linear-gradient(180deg,#282f35,transparent)}.menu .menu__up:before{content:\"\";border-width:5px;border-style:solid;border-top:5px solid transparent;border-color:transparent transparent #fff;-webkit-transform:translateY(-25%);transform:translateY(-25%);display:inline-block}.menu .menu__down{position:absolute;bottom:0;left:0;right:0;text-align:center;background:-webkit-linear-gradient(bottom,#282f35,transparent);background:linear-gradient(0deg,#282f35,transparent)}.menu .menu__down:before{content:\"\";border-width:5px;border-style:solid;border-right:5px solid transparent;border-color:#fff transparent transparent;-webkit-transform:translateY(25%);transform:translateY(25%);display:inline-block}.treenodes ul{padding-left:0!important}.date-picker input{max-width:100px}divider{display:inline-block;width:5px;border-left:2px solid gray;margin-left:5px;margin-bottom:-13px;height:33px}", ""]);
	
	// exports


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! version : 4.17.46
	 =========================================================
	 bootstrap-datetimejs
	 https://github.com/Eonasdan/bootstrap-datetimepicker
	 Copyright (c) 2015 Jonathan Peterson
	 =========================================================
	 */
	/*
	 The MIT License (MIT)
	
	 Copyright (c) 2015 Jonathan Peterson
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in
	 all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 THE SOFTWARE.
	 */
	/*global define:false */
	/*global exports:false */
	/*global require:false */
	/*global jQuery:false */
	/*global moment:false */
	(function (factory) {
	    'use strict';
	    if (true) {
	        // AMD is used - Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('jquery'), require('moment'));
	    } else {
	        // Neither AMD nor CommonJS used. Use global variables.
	        if (typeof jQuery === 'undefined') {
	            throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
	        }
	        if (typeof moment === 'undefined') {
	            throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
	        }
	        factory(jQuery, moment);
	    }
	}(function ($, moment) {
	    'use strict';
	    if (!moment) {
	        throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
	    }
	
	    var dateTimePicker = function (element, options) {
	        var picker = {},
	            date,
	            viewDate,
	            unset = true,
	            input,
	            component = false,
	            widget = false,
	            use24Hours,
	            minViewModeNumber = 0,
	            actualFormat,
	            parseFormats,
	            currentViewMode,
	            datePickerModes = [
	                {
	                    clsName: 'days',
	                    navFnc: 'M',
	                    navStep: 1
	                },
	                {
	                    clsName: 'months',
	                    navFnc: 'y',
	                    navStep: 1
	                },
	                {
	                    clsName: 'years',
	                    navFnc: 'y',
	                    navStep: 10
	                },
	                {
	                    clsName: 'decades',
	                    navFnc: 'y',
	                    navStep: 100
	                }
	            ],
	            viewModes = ['days', 'months', 'years', 'decades'],
	            verticalModes = ['top', 'bottom', 'auto'],
	            horizontalModes = ['left', 'right', 'auto'],
	            toolbarPlacements = ['default', 'top', 'bottom'],
	            keyMap = {
	                'up': 38,
	                38: 'up',
	                'down': 40,
	                40: 'down',
	                'left': 37,
	                37: 'left',
	                'right': 39,
	                39: 'right',
	                'tab': 9,
	                9: 'tab',
	                'escape': 27,
	                27: 'escape',
	                'enter': 13,
	                13: 'enter',
	                'pageUp': 33,
	                33: 'pageUp',
	                'pageDown': 34,
	                34: 'pageDown',
	                'shift': 16,
	                16: 'shift',
	                'control': 17,
	                17: 'control',
	                'space': 32,
	                32: 'space',
	                't': 84,
	                84: 't',
	                'delete': 46,
	                46: 'delete'
	            },
	            keyState = {},
	
	            /********************************************************************************
	             *
	             * Private functions
	             *
	             ********************************************************************************/
	
	            hasTimeZone = function () {
	                return moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '';
	            },
	
	            getMoment = function (d) {
	                var returnMoment;
	
	                if (d === undefined || d === null) {
	                    returnMoment = moment(); //TODO should this use format? and locale?
	                } else if (moment.isDate(d) || moment.isMoment(d)) {
	                    // If the date that is passed in is already a Date() or moment() object,
	                    // pass it directly to moment.
	                    returnMoment = moment(d);
	                } else if (hasTimeZone()) { // There is a string to parse and a default time zone
	                    // parse with the tz function which takes a default time zone if it is not in the format string
	                    returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
	                } else {
	                    returnMoment = moment(d, parseFormats, options.useStrict);
	                }
	
	                if (hasTimeZone()) {
	                    returnMoment.tz(options.timeZone);
	                }
	
	                return returnMoment;
	            },
	
	            isEnabled = function (granularity) {
	                if (typeof granularity !== 'string' || granularity.length > 1) {
	                    throw new TypeError('isEnabled expects a single character string parameter');
	                }
	                switch (granularity) {
	                    case 'y':
	                        return actualFormat.indexOf('Y') !== -1;
	                    case 'M':
	                        return actualFormat.indexOf('M') !== -1;
	                    case 'd':
	                        return actualFormat.toLowerCase().indexOf('d') !== -1;
	                    case 'h':
	                    case 'H':
	                        return actualFormat.toLowerCase().indexOf('h') !== -1;
	                    case 'm':
	                        return actualFormat.indexOf('m') !== -1;
	                    case 's':
	                        return actualFormat.indexOf('s') !== -1;
	                    default:
	                        return false;
	                }
	            },
	
	            hasTime = function () {
	                return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
	            },
	
	            hasDate = function () {
	                return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
	            },
	
	            getDatePickerTemplate = function () {
	                var headTemplate = $('<thead>')
	                        .append($('<tr>')
	                            .append($('<th>').addClass('prev').attr('data-action', 'previous')
	                                .append($('<span>').addClass(options.icons.previous))
	                                )
	                            .append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', (options.calendarWeeks ? '6' : '5')))
	                            .append($('<th>').addClass('next').attr('data-action', 'next')
	                                .append($('<span>').addClass(options.icons.next))
	                                )
	                            ),
	                    contTemplate = $('<tbody>')
	                        .append($('<tr>')
	                            .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
	                            );
	
	                return [
	                    $('<div>').addClass('datepicker-days')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate)
	                            .append($('<tbody>'))
	                            ),
	                    $('<div>').addClass('datepicker-months')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate.clone())
	                            .append(contTemplate.clone())
	                            ),
	                    $('<div>').addClass('datepicker-years')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate.clone())
	                            .append(contTemplate.clone())
	                            ),
	                    $('<div>').addClass('datepicker-decades')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate.clone())
	                            .append(contTemplate.clone())
	                            )
	                ];
	            },
	
	            getTimePickerMainTemplate = function () {
	                var topRow = $('<tr>'),
	                    middleRow = $('<tr>'),
	                    bottomRow = $('<tr>');
	
	                if (isEnabled('h')) {
	                    topRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours').append($('<span>').addClass(options.icons.up))));
	                    middleRow.append($('<td>')
	                        .append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
	                    bottomRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours').append($('<span>').addClass(options.icons.down))));
	                }
	                if (isEnabled('m')) {
	                    if (isEnabled('h')) {
	                        topRow.append($('<td>').addClass('separator'));
	                        middleRow.append($('<td>').addClass('separator').html(':'));
	                        bottomRow.append($('<td>').addClass('separator'));
	                    }
	                    topRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes')
	                            .append($('<span>').addClass(options.icons.up))));
	                    middleRow.append($('<td>')
	                        .append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
	                    bottomRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes')
	                            .append($('<span>').addClass(options.icons.down))));
	                }
	                if (isEnabled('s')) {
	                    if (isEnabled('m')) {
	                        topRow.append($('<td>').addClass('separator'));
	                        middleRow.append($('<td>').addClass('separator').html(':'));
	                        bottomRow.append($('<td>').addClass('separator'));
	                    }
	                    topRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds')
	                            .append($('<span>').addClass(options.icons.up))));
	                    middleRow.append($('<td>')
	                        .append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
	                    bottomRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds')
	                            .append($('<span>').addClass(options.icons.down))));
	                }
	
	                if (!use24Hours) {
	                    topRow.append($('<td>').addClass('separator'));
	                    middleRow.append($('<td>')
	                        .append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
	                    bottomRow.append($('<td>').addClass('separator'));
	                }
	
	                return $('<div>').addClass('timepicker-picker')
	                    .append($('<table>').addClass('table-condensed')
	                        .append([topRow, middleRow, bottomRow]));
	            },
	
	            getTimePickerTemplate = function () {
	                var hoursView = $('<div>').addClass('timepicker-hours')
	                        .append($('<table>').addClass('table-condensed')),
	                    minutesView = $('<div>').addClass('timepicker-minutes')
	                        .append($('<table>').addClass('table-condensed')),
	                    secondsView = $('<div>').addClass('timepicker-seconds')
	                        .append($('<table>').addClass('table-condensed')),
	                    ret = [getTimePickerMainTemplate()];
	
	                if (isEnabled('h')) {
	                    ret.push(hoursView);
	                }
	                if (isEnabled('m')) {
	                    ret.push(minutesView);
	                }
	                if (isEnabled('s')) {
	                    ret.push(secondsView);
	                }
	
	                return ret;
	            },
	
	            getToolbar = function () {
	                var row = [];
	                if (options.showTodayButton) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<span>').addClass(options.icons.today))));
	                }
	                if (!options.sideBySide && hasDate() && hasTime()) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<span>').addClass(options.icons.time))));
	                }
	                if (options.showClear) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<span>').addClass(options.icons.clear))));
	                }
	                if (options.showClose) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<span>').addClass(options.icons.close))));
	                }
	                return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
	            },
	
	            getTemplate = function () {
	                var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
	                    dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
	                    timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
	                    content = $('<ul>').addClass('list-unstyled'),
	                    toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());
	
	                if (options.inline) {
	                    template.removeClass('dropdown-menu');
	                }
	
	                if (use24Hours) {
	                    template.addClass('usetwentyfour');
	                }
	
	                if (isEnabled('s') && !use24Hours) {
	                    template.addClass('wider');
	                }
	
	                if (options.sideBySide && hasDate() && hasTime()) {
	                    template.addClass('timepicker-sbs');
	                    if (options.toolbarPlacement === 'top') {
	                        template.append(toolbar);
	                    }
	                    template.append(
	                        $('<div>').addClass('row')
	                            .append(dateView.addClass('col-md-6'))
	                            .append(timeView.addClass('col-md-6'))
	                    );
	                    if (options.toolbarPlacement === 'bottom') {
	                        template.append(toolbar);
	                    }
	                    return template;
	                }
	
	                if (options.toolbarPlacement === 'top') {
	                    content.append(toolbar);
	                }
	                if (hasDate()) {
	                    content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse in' : '')).append(dateView));
	                }
	                if (options.toolbarPlacement === 'default') {
	                    content.append(toolbar);
	                }
	                if (hasTime()) {
	                    content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
	                }
	                if (options.toolbarPlacement === 'bottom') {
	                    content.append(toolbar);
	                }
	                return template.append(content);
	            },
	
	            dataToOptions = function () {
	                var eData,
	                    dataOptions = {};
	
	                if (element.is('input') || options.inline) {
	                    eData = element.data();
	                } else {
	                    eData = element.find('input').data();
	                }
	
	                if (eData.dateOptions && eData.dateOptions instanceof Object) {
	                    dataOptions = $.extend(true, dataOptions, eData.dateOptions);
	                }
	
	                $.each(options, function (key) {
	                    var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
	                    if (eData[attributeName] !== undefined) {
	                        dataOptions[key] = eData[attributeName];
	                    }
	                });
	                return dataOptions;
	            },
	
	            place = function () {
	                var position = (component || element).position(),
	                    offset = (component || element).offset(),
	                    vertical = options.widgetPositioning.vertical,
	                    horizontal = options.widgetPositioning.horizontal,
	                    parent;
	
	                if (options.widgetParent) {
	                    parent = options.widgetParent.append(widget);
	                } else if (element.is('input')) {
	                    parent = element.after(widget).parent();
	                } else if (options.inline) {
	                    parent = element.append(widget);
	                    return;
	                } else {
	                    parent = element;
	                    element.children().first().after(widget);
	                }
	
	                // Top and bottom logic
	                if (vertical === 'auto') {
	                    if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
	                        widget.height() + element.outerHeight() < offset.top) {
	                        vertical = 'top';
	                    } else {
	                        vertical = 'bottom';
	                    }
	                }
	
	                // Left and right logic
	                if (horizontal === 'auto') {
	                    if (parent.width() < offset.left + widget.outerWidth() / 2 &&
	                        offset.left + widget.outerWidth() > $(window).width()) {
	                        horizontal = 'right';
	                    } else {
	                        horizontal = 'left';
	                    }
	                }
	
	                if (vertical === 'top') {
	                    widget.addClass('top').removeClass('bottom');
	                } else {
	                    widget.addClass('bottom').removeClass('top');
	                }
	
	                if (horizontal === 'right') {
	                    widget.addClass('pull-right');
	                } else {
	                    widget.removeClass('pull-right');
	                }
	
	                // find the first parent element that has a non-static css positioning
	                if (parent.css('position') === 'static') {
	                    parent = parent.parents().filter(function () {
	                        return $(this).css('position') !== 'static';
	                    }).first();
	                }
	
	                if (parent.length === 0) {
	                    throw new Error('datetimepicker component should be placed within a non-static positioned container');
	                }
	
	                widget.css({
	                    top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
	                    bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
	                    left: horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
	                    right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
	                });
	            },
	
	            notifyEvent = function (e) {
	                if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
	                    return;
	                }
	                element.trigger(e);
	            },
	
	            viewUpdate = function (e) {
	                if (e === 'y') {
	                    e = 'YYYY';
	                }
	                notifyEvent({
	                    type: 'dp.update',
	                    change: e,
	                    viewDate: viewDate.clone()
	                });
	            },
	
	            showMode = function (dir) {
	                if (!widget) {
	                    return;
	                }
	                if (dir) {
	                    currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
	                }
	                widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).show();
	            },
	
	            fillDow = function () {
	                var row = $('<tr>'),
	                    currentDate = viewDate.clone().startOf('w').startOf('d');
	
	                if (options.calendarWeeks === true) {
	                    row.append($('<th>').addClass('cw').text('#'));
	                }
	
	                while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
	                    row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
	                    currentDate.add(1, 'd');
	                }
	                widget.find('.datepicker-days thead').append(row);
	            },
	
	            isInDisabledDates = function (testDate) {
	                return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
	            },
	
	            isInEnabledDates = function (testDate) {
	                return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
	            },
	
	            isInDisabledHours = function (testDate) {
	                return options.disabledHours[testDate.format('H')] === true;
	            },
	
	            isInEnabledHours = function (testDate) {
	                return options.enabledHours[testDate.format('H')] === true;
	            },
	
	            isValid = function (targetMoment, granularity) {
	                if (!targetMoment.isValid()) {
	                    return false;
	                }
	                if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
	                    return false;
	                }
	                if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
	                    return false;
	                }
	                if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
	                    return false;
	                }
	                if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
	                    return false;
	                }
	                if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
	                    return false;
	                }
	                if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
	                    return false;
	                }
	                if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
	                    return false;
	                }
	                if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
	                    var found = false;
	                    $.each(options.disabledTimeIntervals, function () {
	                        if (targetMoment.isBetween(this[0], this[1])) {
	                            found = true;
	                            return false;
	                        }
	                    });
	                    if (found) {
	                        return false;
	                    }
	                }
	                return true;
	            },
	
	            fillMonths = function () {
	                var spans = [],
	                    monthsShort = viewDate.clone().startOf('y').startOf('d');
	                while (monthsShort.isSame(viewDate, 'y')) {
	                    spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
	                    monthsShort.add(1, 'M');
	                }
	                widget.find('.datepicker-months td').empty().append(spans);
	            },
	
	            updateMonths = function () {
	                var monthsView = widget.find('.datepicker-months'),
	                    monthsViewHeader = monthsView.find('th'),
	                    months = monthsView.find('tbody').find('span');
	
	                monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
	                monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
	                monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);
	
	                monthsView.find('.disabled').removeClass('disabled');
	
	                if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
	                    monthsViewHeader.eq(0).addClass('disabled');
	                }
	
	                monthsViewHeader.eq(1).text(viewDate.year());
	
	                if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
	                    monthsViewHeader.eq(2).addClass('disabled');
	                }
	
	                months.removeClass('active');
	                if (date.isSame(viewDate, 'y') && !unset) {
	                    months.eq(date.month()).addClass('active');
	                }
	
	                months.each(function (index) {
	                    if (!isValid(viewDate.clone().month(index), 'M')) {
	                        $(this).addClass('disabled');
	                    }
	                });
	            },
	
	            updateYears = function () {
	                var yearsView = widget.find('.datepicker-years'),
	                    yearsViewHeader = yearsView.find('th'),
	                    startYear = viewDate.clone().subtract(5, 'y'),
	                    endYear = viewDate.clone().add(6, 'y'),
	                    html = '';
	
	                yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
	                yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
	                yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);
	
	                yearsView.find('.disabled').removeClass('disabled');
	
	                if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
	                    yearsViewHeader.eq(0).addClass('disabled');
	                }
	
	                yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());
	
	                if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
	                    yearsViewHeader.eq(2).addClass('disabled');
	                }
	
	                while (!startYear.isAfter(endYear, 'y')) {
	                    html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
	                    startYear.add(1, 'y');
	                }
	
	                yearsView.find('td').html(html);
	            },
	
	            updateDecades = function () {
	                var decadesView = widget.find('.datepicker-decades'),
	                    decadesViewHeader = decadesView.find('th'),
	                    startDecade = moment({ y: viewDate.year() - (viewDate.year() % 100) - 1 }),
	                    endDecade = startDecade.clone().add(100, 'y'),
	                    startedAt = startDecade.clone(),
	                    minDateDecade = false,
	                    maxDateDecade = false,
	                    endDecadeYear,
	                    html = '';
	
	                decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
	                decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);
	
	                decadesView.find('.disabled').removeClass('disabled');
	
	                if (startDecade.isSame(moment({ y: 1900 })) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
	                    decadesViewHeader.eq(0).addClass('disabled');
	                }
	
	                decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());
	
	                if (startDecade.isSame(moment({ y: 2000 })) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
	                    decadesViewHeader.eq(2).addClass('disabled');
	                }
	
	                while (!startDecade.isAfter(endDecade, 'y')) {
	                    endDecadeYear = startDecade.year() + 12;
	                    minDateDecade = options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
	                    maxDateDecade = options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
	                    html += '<span data-action="selectDecade" class="decade' + (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') +
	                        (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
	                    startDecade.add(12, 'y');
	                }
	                html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even
	
	                decadesView.find('td').html(html);
	                decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
	            },
	
	            fillDate = function () {
	                var daysView = widget.find('.datepicker-days'),
	                    daysViewHeader = daysView.find('th'),
	                    currentDate,
	                    html = [],
	                    row,
	                    clsNames = [],
	                    i;
	
	                if (!hasDate()) {
	                    return;
	                }
	
	                daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
	                daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
	                daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);
	
	                daysView.find('.disabled').removeClass('disabled');
	                daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));
	
	                if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
	                    daysViewHeader.eq(0).addClass('disabled');
	                }
	                if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
	                    daysViewHeader.eq(2).addClass('disabled');
	                }
	
	                currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');
	
	                for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
	                    if (currentDate.weekday() === 0) {
	                        row = $('<tr>');
	                        if (options.calendarWeeks) {
	                            row.append('<td class="cw">' + currentDate.week() + '</td>');
	                        }
	                        html.push(row);
	                    }
	                    clsNames = ['day'];
	                    if (currentDate.isBefore(viewDate, 'M')) {
	                        clsNames.push('old');
	                    }
	                    if (currentDate.isAfter(viewDate, 'M')) {
	                        clsNames.push('new');
	                    }
	                    if (currentDate.isSame(date, 'd') && !unset) {
	                        clsNames.push('active');
	                    }
	                    if (!isValid(currentDate, 'd')) {
	                        clsNames.push('disabled');
	                    }
	                    if (currentDate.isSame(getMoment(), 'd')) {
	                        clsNames.push('today');
	                    }
	                    if (currentDate.day() === 0 || currentDate.day() === 6) {
	                        clsNames.push('weekend');
	                    }
	                    notifyEvent({
	                        type: 'dp.classify',
	                        date: currentDate,
	                        classNames: clsNames
	                    });
	                    row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="' + clsNames.join(' ') + '">' + currentDate.date() + '</td>');
	                    currentDate.add(1, 'd');
	                }
	
	                daysView.find('tbody').empty().append(html);
	
	                updateMonths();
	
	                updateYears();
	
	                updateDecades();
	            },
	
	            fillHours = function () {
	                var table = widget.find('.timepicker-hours table'),
	                    currentHour = viewDate.clone().startOf('d'),
	                    html = [],
	                    row = $('<tr>');
	
	                if (viewDate.hour() > 11 && !use24Hours) {
	                    currentHour.hour(12);
	                }
	                while (currentHour.isSame(viewDate, 'd') && (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
	                    if (currentHour.hour() % 4 === 0) {
	                        row = $('<tr>');
	                        html.push(row);
	                    }
	                    row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
	                    currentHour.add(1, 'h');
	                }
	                table.empty().append(html);
	            },
	
	            fillMinutes = function () {
	                var table = widget.find('.timepicker-minutes table'),
	                    currentMinute = viewDate.clone().startOf('h'),
	                    html = [],
	                    row = $('<tr>'),
	                    step = options.stepping === 1 ? 5 : options.stepping;
	
	                while (viewDate.isSame(currentMinute, 'h')) {
	                    if (currentMinute.minute() % (step * 4) === 0) {
	                        row = $('<tr>');
	                        html.push(row);
	                    }
	                    row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
	                    currentMinute.add(step, 'm');
	                }
	                table.empty().append(html);
	            },
	
	            fillSeconds = function () {
	                var table = widget.find('.timepicker-seconds table'),
	                    currentSecond = viewDate.clone().startOf('m'),
	                    html = [],
	                    row = $('<tr>');
	
	                while (viewDate.isSame(currentSecond, 'm')) {
	                    if (currentSecond.second() % 20 === 0) {
	                        row = $('<tr>');
	                        html.push(row);
	                    }
	                    row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
	                    currentSecond.add(5, 's');
	                }
	
	                table.empty().append(html);
	            },
	
	            fillTime = function () {
	                var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');
	
	                if (!use24Hours) {
	                    toggle = widget.find('.timepicker [data-action=togglePeriod]');
	                    newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');
	
	                    toggle.text(date.format('A'));
	
	                    if (isValid(newDate, 'h')) {
	                        toggle.removeClass('disabled');
	                    } else {
	                        toggle.addClass('disabled');
	                    }
	                }
	                timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
	                timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
	                timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));
	
	                fillHours();
	                fillMinutes();
	                fillSeconds();
	            },
	
	            update = function () {
	                if (!widget) {
	                    return;
	                }
	                fillDate();
	                fillTime();
	            },
	
	            setValue = function (targetMoment) {
	                var oldDate = unset ? null : date;
	
	                // case of calling setValue(null or false)
	                if (!targetMoment) {
	                    unset = true;
	                    input.val('');
	                    element.data('date', '');
	                    notifyEvent({
	                        type: 'dp.change',
	                        date: false,
	                        oldDate: oldDate
	                    });
	                    update();
	                    return;
	                }
	
	                targetMoment = targetMoment.clone().locale(options.locale);
	
	                if (hasTimeZone()) {
	                    targetMoment.tz(options.timeZone);
	                }
	
	                if (options.stepping !== 1) {
	                    targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping)).seconds(0);
	
	                    while (options.minDate && targetMoment.isBefore(options.minDate)) {
	                        targetMoment.add(options.stepping, 'minutes');
	                    }
	                }
	
	                if (isValid(targetMoment)) {
	                    date = targetMoment;
	                    viewDate = date.clone();
	                    input.val(date.format(actualFormat));
	                    element.data('date', date.format(actualFormat));
	                    unset = false;
	                    update();
	                    notifyEvent({
	                        type: 'dp.change',
	                        date: date.clone(),
	                        oldDate: oldDate
	                    });
	                } else {
	                    if (!options.keepInvalid) {
	                        input.val(unset ? '' : date.format(actualFormat));
	                    } else {
	                        notifyEvent({
	                            type: 'dp.change',
	                            date: targetMoment,
	                            oldDate: oldDate
	                        });
	                    }
	                    notifyEvent({
	                        type: 'dp.error',
	                        date: targetMoment,
	                        oldDate: oldDate
	                    });
	                }
	            },
	
	            /**
	             * Hides the widget. Possibly will emit dp.hide
	             */
	            hide = function () {
	                var transitioning = false;
	                if (!widget) {
	                    return picker;
	                }
	                // Ignore event if in the middle of a picker transition
	                widget.find('.collapse').each(function () {
	                    var collapseData = $(this).data('collapse');
	                    if (collapseData && collapseData.transitioning) {
	                        transitioning = true;
	                        return false;
	                    }
	                    return true;
	                });
	                if (transitioning) {
	                    return picker;
	                }
	                if (component && component.hasClass('btn')) {
	                    component.toggleClass('active');
	                }
	                widget.hide();
	
	                $(window).off('resize', place);
	                widget.off('click', '[data-action]');
	                widget.off('mousedown', false);
	
	                widget.remove();
	                widget = false;
	
	                notifyEvent({
	                    type: 'dp.hide',
	                    date: date.clone()
	                });
	
	                input.blur();
	
	                viewDate = date.clone();
	
	                return picker;
	            },
	
	            clear = function () {
	                setValue(null);
	            },
	
	            parseInputDate = function (inputDate) {
	                if (options.parseInputDate === undefined) {
	                    if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
	                        inputDate = getMoment(inputDate);
	                    }
	                } else {
	                    inputDate = options.parseInputDate(inputDate);
	                }
	                //inputDate.locale(options.locale);
	                return inputDate;
	            },
	
	            /********************************************************************************
	             *
	             * Widget UI interaction functions
	             *
	             ********************************************************************************/
	            actions = {
	                next: function () {
	                    var navFnc = datePickerModes[currentViewMode].navFnc;
	                    viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
	                    fillDate();
	                    viewUpdate(navFnc);
	                },
	
	                previous: function () {
	                    var navFnc = datePickerModes[currentViewMode].navFnc;
	                    viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
	                    fillDate();
	                    viewUpdate(navFnc);
	                },
	
	                pickerSwitch: function () {
	                    showMode(1);
	                },
	
	                selectMonth: function (e) {
	                    var month = $(e.target).closest('tbody').find('span').index($(e.target));
	                    viewDate.month(month);
	                    if (currentViewMode === minViewModeNumber) {
	                        setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
	                        if (!options.inline) {
	                            hide();
	                        }
	                    } else {
	                        showMode(-1);
	                        fillDate();
	                    }
	                    viewUpdate('M');
	                },
	
	                selectYear: function (e) {
	                    var year = parseInt($(e.target).text(), 10) || 0;
	                    viewDate.year(year);
	                    if (currentViewMode === minViewModeNumber) {
	                        setValue(date.clone().year(viewDate.year()));
	                        if (!options.inline) {
	                            hide();
	                        }
	                    } else {
	                        showMode(-1);
	                        fillDate();
	                    }
	                    viewUpdate('YYYY');
	                },
	
	                selectDecade: function (e) {
	                    var year = parseInt($(e.target).data('selection'), 10) || 0;
	                    viewDate.year(year);
	                    if (currentViewMode === minViewModeNumber) {
	                        setValue(date.clone().year(viewDate.year()));
	                        if (!options.inline) {
	                            hide();
	                        }
	                    } else {
	                        showMode(-1);
	                        fillDate();
	                    }
	                    viewUpdate('YYYY');
	                },
	
	                selectDay: function (e) {
	                    var day = viewDate.clone();
	                    if ($(e.target).is('.old')) {
	                        day.subtract(1, 'M');
	                    }
	                    if ($(e.target).is('.new')) {
	                        day.add(1, 'M');
	                    }
	                    setValue(day.date(parseInt($(e.target).text(), 10)));
	                    if (!hasTime() && !options.keepOpen && !options.inline) {
	                        hide();
	                    }
	                },
	
	                incrementHours: function () {
	                    var newDate = date.clone().add(1, 'h');
	                    if (isValid(newDate, 'h')) {
	                        setValue(newDate);
	                    }
	                },
	
	                incrementMinutes: function () {
	                    var newDate = date.clone().add(options.stepping, 'm');
	                    if (isValid(newDate, 'm')) {
	                        setValue(newDate);
	                    }
	                },
	
	                incrementSeconds: function () {
	                    var newDate = date.clone().add(1, 's');
	                    if (isValid(newDate, 's')) {
	                        setValue(newDate);
	                    }
	                },
	
	                decrementHours: function () {
	                    var newDate = date.clone().subtract(1, 'h');
	                    if (isValid(newDate, 'h')) {
	                        setValue(newDate);
	                    }
	                },
	
	                decrementMinutes: function () {
	                    var newDate = date.clone().subtract(options.stepping, 'm');
	                    if (isValid(newDate, 'm')) {
	                        setValue(newDate);
	                    }
	                },
	
	                decrementSeconds: function () {
	                    var newDate = date.clone().subtract(1, 's');
	                    if (isValid(newDate, 's')) {
	                        setValue(newDate);
	                    }
	                },
	
	                togglePeriod: function () {
	                    setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
	                },
	
	                togglePicker: function (e) {
	                    var $this = $(e.target),
	                        $parent = $this.closest('ul'),
	                        expanded = $parent.find('.in'),
	                        closed = $parent.find('.collapse:not(.in)'),
	                        collapseData;
	
	                    if (expanded && expanded.length) {
	                        collapseData = expanded.data('collapse');
	                        if (collapseData && collapseData.transitioning) {
	                            return;
	                        }
	                        if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
	                            expanded.collapse('hide');
	                            closed.collapse('show');
	                        } else { // otherwise just toggle in class on the two views
	                            expanded.removeClass('in');
	                            closed.addClass('in');
	                        }
	                        if ($this.is('span')) {
	                            $this.toggleClass(options.icons.time + ' ' + options.icons.date);
	                        } else {
	                            $this.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
	                        }
	
	                        // NOTE: uncomment if toggled state will be restored in show()
	                        //if (component) {
	                        //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
	                        //}
	                    }
	                },
	
	                showPicker: function () {
	                    widget.find('.timepicker > div:not(.timepicker-picker)').hide();
	                    widget.find('.timepicker .timepicker-picker').show();
	                },
	
	                showHours: function () {
	                    widget.find('.timepicker .timepicker-picker').hide();
	                    widget.find('.timepicker .timepicker-hours').show();
	                },
	
	                showMinutes: function () {
	                    widget.find('.timepicker .timepicker-picker').hide();
	                    widget.find('.timepicker .timepicker-minutes').show();
	                },
	
	                showSeconds: function () {
	                    widget.find('.timepicker .timepicker-picker').hide();
	                    widget.find('.timepicker .timepicker-seconds').show();
	                },
	
	                selectHour: function (e) {
	                    var hour = parseInt($(e.target).text(), 10);
	
	                    if (!use24Hours) {
	                        if (date.hours() >= 12) {
	                            if (hour !== 12) {
	                                hour += 12;
	                            }
	                        } else {
	                            if (hour === 12) {
	                                hour = 0;
	                            }
	                        }
	                    }
	                    setValue(date.clone().hours(hour));
	                    actions.showPicker.call(picker);
	                },
	
	                selectMinute: function (e) {
	                    setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
	                    actions.showPicker.call(picker);
	                },
	
	                selectSecond: function (e) {
	                    setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
	                    actions.showPicker.call(picker);
	                },
	
	                clear: clear,
	
	                today: function () {
	                    var todaysDate = getMoment();
	                    if (isValid(todaysDate, 'd')) {
	                        setValue(todaysDate);
	                    }
	                },
	
	                close: hide
	            },
	
	            doAction = function (e) {
	                if ($(e.currentTarget).is('.disabled')) {
	                    return false;
	                }
	                actions[$(e.currentTarget).data('action')].apply(picker, arguments);
	                return false;
	            },
	
	            /**
	             * Shows the widget. Possibly will emit dp.show and dp.change
	             */
	            show = function () {
	                var currentMoment,
	                    useCurrentGranularity = {
	                        'year': function (m) {
	                            return m.month(0).date(1).hours(0).seconds(0).minutes(0);
	                        },
	                        'month': function (m) {
	                            return m.date(1).hours(0).seconds(0).minutes(0);
	                        },
	                        'day': function (m) {
	                            return m.hours(0).seconds(0).minutes(0);
	                        },
	                        'hour': function (m) {
	                            return m.seconds(0).minutes(0);
	                        },
	                        'minute': function (m) {
	                            return m.seconds(0);
	                        }
	                    };
	
	                if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
	                    return picker;
	                }
	                if (input.val() !== undefined && input.val().trim().length !== 0) {
	                    setValue(parseInputDate(input.val().trim()));
	                } else if (unset && options.useCurrent && (options.inline || (input.is('input') && input.val().trim().length === 0))) {
	                    currentMoment = getMoment();
	                    if (typeof options.useCurrent === 'string') {
	                        currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
	                    }
	                    setValue(currentMoment);
	                }
	                widget = getTemplate();
	
	                fillDow();
	                fillMonths();
	
	                widget.find('.timepicker-hours').hide();
	                widget.find('.timepicker-minutes').hide();
	                widget.find('.timepicker-seconds').hide();
	
	                update();
	                showMode();
	
	                $(window).on('resize', place);
	                widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
	                widget.on('mousedown', false);
	
	                if (component && component.hasClass('btn')) {
	                    component.toggleClass('active');
	                }
	                place();
	                widget.show();
	                if (options.focusOnShow && !input.is(':focus')) {
	                    input.focus();
	                }
	
	                notifyEvent({
	                    type: 'dp.show'
	                });
	                return picker;
	            },
	
	            /**
	             * Shows or hides the widget
	             */
	            toggle = function () {
	                return (widget ? hide() : show());
	            },
	
	            keydown = function (e) {
	                var handler = null,
	                    index,
	                    index2,
	                    pressedKeys = [],
	                    pressedModifiers = {},
	                    currentKey = e.which,
	                    keyBindKeys,
	                    allModifiersPressed,
	                    pressed = 'p';
	
	                keyState[currentKey] = pressed;
	
	                for (index in keyState) {
	                    if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
	                        pressedKeys.push(index);
	                        if (parseInt(index, 10) !== currentKey) {
	                            pressedModifiers[index] = true;
	                        }
	                    }
	                }
	
	                for (index in options.keyBinds) {
	                    if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
	                        keyBindKeys = index.split(' ');
	                        if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
	                            allModifiersPressed = true;
	                            for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
	                                if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
	                                    allModifiersPressed = false;
	                                    break;
	                                }
	                            }
	                            if (allModifiersPressed) {
	                                handler = options.keyBinds[index];
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (handler) {
	                    handler.call(picker, widget);
	                    e.stopPropagation();
	                    e.preventDefault();
	                }
	            },
	
	            keyup = function (e) {
	                keyState[e.which] = 'r';
	                e.stopPropagation();
	                e.preventDefault();
	            },
	
	            change = function (e) {
	                var val = $(e.target).val().trim(),
	                    parsedDate = val ? parseInputDate(val) : null;
	                setValue(parsedDate);
	                e.stopImmediatePropagation();
	                return false;
	            },
	
	            attachDatePickerElementEvents = function () {
	                input.on({
	                    'change': change,
	                    'blur': options.debug ? '' : hide,
	                    'keydown': keydown,
	                    'keyup': keyup,
	                    'focus': options.allowInputToggle ? show : ''
	                });
	
	                if (element.is('input')) {
	                    input.on({
	                        'focus': show
	                    });
	                } else if (component) {
	                    component.on('click', toggle);
	                    component.on('mousedown', false);
	                }
	            },
	
	            detachDatePickerElementEvents = function () {
	                input.off({
	                    'change': change,
	                    'blur': blur,
	                    'keydown': keydown,
	                    'keyup': keyup,
	                    'focus': options.allowInputToggle ? hide : ''
	                });
	
	                if (element.is('input')) {
	                    input.off({
	                        'focus': show
	                    });
	                } else if (component) {
	                    component.off('click', toggle);
	                    component.off('mousedown', false);
	                }
	            },
	
	            indexGivenDates = function (givenDatesArray) {
	                // Store given enabledDates and disabledDates as keys.
	                // This way we can check their existence in O(1) time instead of looping through whole array.
	                // (for example: options.enabledDates['2014-02-27'] === true)
	                var givenDatesIndexed = {};
	                $.each(givenDatesArray, function () {
	                    var dDate = parseInputDate(this);
	                    if (dDate.isValid()) {
	                        givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
	                    }
	                });
	                return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
	            },
	
	            indexGivenHours = function (givenHoursArray) {
	                // Store given enabledHours and disabledHours as keys.
	                // This way we can check their existence in O(1) time instead of looping through whole array.
	                // (for example: options.enabledHours['2014-02-27'] === true)
	                var givenHoursIndexed = {};
	                $.each(givenHoursArray, function () {
	                    givenHoursIndexed[this] = true;
	                });
	                return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
	            },
	
	            initFormatting = function () {
	                var format = options.format || 'L LT';
	
	                actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
	                    var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
	                    return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) { //temp fix for #740
	                        return date.localeData().longDateFormat(formatInput2) || formatInput2;
	                    });
	                });
	
	
	                parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
	                if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
	                    parseFormats.push(actualFormat);
	                }
	
	                use24Hours = (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);
	
	                if (isEnabled('y')) {
	                    minViewModeNumber = 2;
	                }
	                if (isEnabled('M')) {
	                    minViewModeNumber = 1;
	                }
	                if (isEnabled('d')) {
	                    minViewModeNumber = 0;
	                }
	
	                currentViewMode = Math.max(minViewModeNumber, currentViewMode);
	
	                if (!unset) {
	                    setValue(date);
	                }
	            };
	
	        /********************************************************************************
	         *
	         * Public API functions
	         * =====================
	         *
	         * Important: Do not expose direct references to private objects or the options
	         * object to the outer world. Always return a clone when returning values or make
	         * a clone when setting a private variable.
	         *
	         ********************************************************************************/
	        picker.destroy = function () {
	            ///<summary>Destroys the widget and removes all attached event listeners</summary>
	            hide();
	            detachDatePickerElementEvents();
	            element.removeData('DateTimePicker');
	            element.removeData('date');
	        };
	
	        picker.toggle = toggle;
	
	        picker.show = show;
	
	        picker.hide = hide;
	
	        picker.disable = function () {
	            ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
	            ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
	            hide();
	            if (component && component.hasClass('btn')) {
	                component.addClass('disabled');
	            }
	            input.prop('disabled', true);
	            return picker;
	        };
	
	        picker.enable = function () {
	            ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
	            if (component && component.hasClass('btn')) {
	                component.removeClass('disabled');
	            }
	            input.prop('disabled', false);
	            return picker;
	        };
	
	        picker.ignoreReadonly = function (ignoreReadonly) {
	            if (arguments.length === 0) {
	                return options.ignoreReadonly;
	            }
	            if (typeof ignoreReadonly !== 'boolean') {
	                throw new TypeError('ignoreReadonly () expects a boolean parameter');
	            }
	            options.ignoreReadonly = ignoreReadonly;
	            return picker;
	        };
	
	        picker.options = function (newOptions) {
	            if (arguments.length === 0) {
	                return $.extend(true, {}, options);
	            }
	
	            if (!(newOptions instanceof Object)) {
	                throw new TypeError('options() options parameter should be an object');
	            }
	            $.extend(true, options, newOptions);
	            $.each(options, function (key, value) {
	                if (picker[key] !== undefined) {
	                    picker[key](value);
	                } else {
	                    throw new TypeError('option ' + key + ' is not recognized!');
	                }
	            });
	            return picker;
	        };
	
	        picker.date = function (newDate) {
	            ///<signature helpKeyword="$.fn.datetimepicker.date">
	            ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
	            ///<returns type="Moment">date.clone()</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
	            ///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                if (unset) {
	                    return null;
	                }
	                return date.clone();
	            }
	
	            if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
	                throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
	            }
	
	            setValue(newDate === null ? null : parseInputDate(newDate));
	            return picker;
	        };
	
	        picker.format = function (newFormat) {
	            ///<summary>test su</summary>
	            ///<param name="newFormat">info about para</param>
	            ///<returns type="string|boolean">returns foo</returns>
	            if (arguments.length === 0) {
	                return options.format;
	            }
	
	            if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
	                throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
	            }
	
	            options.format = newFormat;
	            if (actualFormat) {
	                initFormatting(); // reinit formatting
	            }
	            return picker;
	        };
	
	        picker.timeZone = function (newZone) {
	            if (arguments.length === 0) {
	                return options.timeZone;
	            }
	
	            if (typeof newZone !== 'string') {
	                throw new TypeError('newZone() expects a string parameter');
	            }
	
	            options.timeZone = newZone;
	
	            return picker;
	        };
	
	        picker.dayViewHeaderFormat = function (newFormat) {
	            if (arguments.length === 0) {
	                return options.dayViewHeaderFormat;
	            }
	
	            if (typeof newFormat !== 'string') {
	                throw new TypeError('dayViewHeaderFormat() expects a string parameter');
	            }
	
	            options.dayViewHeaderFormat = newFormat;
	            return picker;
	        };
	
	        picker.extraFormats = function (formats) {
	            if (arguments.length === 0) {
	                return options.extraFormats;
	            }
	
	            if (formats !== false && !(formats instanceof Array)) {
	                throw new TypeError('extraFormats() expects an array or false parameter');
	            }
	
	            options.extraFormats = formats;
	            if (parseFormats) {
	                initFormatting(); // reinit formatting
	            }
	            return picker;
	        };
	
	        picker.disabledDates = function (dates) {
	            ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
	            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
	            ///<returns type="array">options.disabledDates</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
	            ///options.enabledDates if such exist.</summary>
	            ///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
	            }
	
	            if (!dates) {
	                options.disabledDates = false;
	                update();
	                return picker;
	            }
	            if (!(dates instanceof Array)) {
	                throw new TypeError('disabledDates() expects an array parameter');
	            }
	            options.disabledDates = indexGivenDates(dates);
	            options.enabledDates = false;
	            update();
	            return picker;
	        };
	
	        picker.enabledDates = function (dates) {
	            ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
	            ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
	            ///<returns type="array">options.enabledDates</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
	            ///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
	            }
	
	            if (!dates) {
	                options.enabledDates = false;
	                update();
	                return picker;
	            }
	            if (!(dates instanceof Array)) {
	                throw new TypeError('enabledDates() expects an array parameter');
	            }
	            options.enabledDates = indexGivenDates(dates);
	            options.disabledDates = false;
	            update();
	            return picker;
	        };
	
	        picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
	            if (arguments.length === 0) {
	                return options.daysOfWeekDisabled.splice(0);
	            }
	
	            if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
	                options.daysOfWeekDisabled = false;
	                update();
	                return picker;
	            }
	
	            if (!(daysOfWeekDisabled instanceof Array)) {
	                throw new TypeError('daysOfWeekDisabled() expects an array parameter');
	            }
	            options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
	                currentValue = parseInt(currentValue, 10);
	                if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
	                    return previousValue;
	                }
	                if (previousValue.indexOf(currentValue) === -1) {
	                    previousValue.push(currentValue);
	                }
	                return previousValue;
	            }, []).sort();
	            if (options.useCurrent && !options.keepInvalid) {
	                var tries = 0;
	                while (!isValid(date, 'd')) {
	                    date.add(1, 'd');
	                    if (tries === 31) {
	                        throw 'Tried 31 times to find a valid date';
	                    }
	                    tries++;
	                }
	                setValue(date);
	            }
	            update();
	            return picker;
	        };
	
	        picker.maxDate = function (maxDate) {
	            if (arguments.length === 0) {
	                return options.maxDate ? options.maxDate.clone() : options.maxDate;
	            }
	
	            if ((typeof maxDate === 'boolean') && maxDate === false) {
	                options.maxDate = false;
	                update();
	                return picker;
	            }
	
	            if (typeof maxDate === 'string') {
	                if (maxDate === 'now' || maxDate === 'moment') {
	                    maxDate = getMoment();
	                }
	            }
	
	            var parsedDate = parseInputDate(maxDate);
	
	            if (!parsedDate.isValid()) {
	                throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
	            }
	            if (options.minDate && parsedDate.isBefore(options.minDate)) {
	                throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
	            }
	            options.maxDate = parsedDate;
	            if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
	                setValue(options.maxDate);
	            }
	            if (viewDate.isAfter(parsedDate)) {
	                viewDate = parsedDate.clone().subtract(options.stepping, 'm');
	            }
	            update();
	            return picker;
	        };
	
	        picker.minDate = function (minDate) {
	            if (arguments.length === 0) {
	                return options.minDate ? options.minDate.clone() : options.minDate;
	            }
	
	            if ((typeof minDate === 'boolean') && minDate === false) {
	                options.minDate = false;
	                update();
	                return picker;
	            }
	
	            if (typeof minDate === 'string') {
	                if (minDate === 'now' || minDate === 'moment') {
	                    minDate = getMoment();
	                }
	            }
	
	            var parsedDate = parseInputDate(minDate);
	
	            if (!parsedDate.isValid()) {
	                throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
	            }
	            if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
	                throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
	            }
	            options.minDate = parsedDate;
	            if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
	                setValue(options.minDate);
	            }
	            if (viewDate.isBefore(parsedDate)) {
	                viewDate = parsedDate.clone().add(options.stepping, 'm');
	            }
	            update();
	            return picker;
	        };
	
	        picker.defaultDate = function (defaultDate) {
	            ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
	            ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
	            ///<returns type="Moment">date.clone()</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
	            ///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
	            }
	            if (!defaultDate) {
	                options.defaultDate = false;
	                return picker;
	            }
	
	            if (typeof defaultDate === 'string') {
	                if (defaultDate === 'now' || defaultDate === 'moment') {
	                    defaultDate = getMoment();
	                } else {
	                    defaultDate = getMoment(defaultDate);
	                }
	            }
	
	            var parsedDate = parseInputDate(defaultDate);
	            if (!parsedDate.isValid()) {
	                throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
	            }
	            if (!isValid(parsedDate)) {
	                throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
	            }
	
	            options.defaultDate = parsedDate;
	
	            if ((options.defaultDate && options.inline) || input.val().trim() === '') {
	                setValue(options.defaultDate);
	            }
	            return picker;
	        };
	
	        picker.locale = function (locale) {
	            if (arguments.length === 0) {
	                return options.locale;
	            }
	
	            if (!moment.localeData(locale)) {
	                throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
	            }
	
	            options.locale = locale;
	            date.locale(options.locale);
	            viewDate.locale(options.locale);
	
	            if (actualFormat) {
	                initFormatting(); // reinit formatting
	            }
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.stepping = function (stepping) {
	            if (arguments.length === 0) {
	                return options.stepping;
	            }
	
	            stepping = parseInt(stepping, 10);
	            if (isNaN(stepping) || stepping < 1) {
	                stepping = 1;
	            }
	            options.stepping = stepping;
	            return picker;
	        };
	
	        picker.useCurrent = function (useCurrent) {
	            var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
	            if (arguments.length === 0) {
	                return options.useCurrent;
	            }
	
	            if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
	                throw new TypeError('useCurrent() expects a boolean or string parameter');
	            }
	            if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
	                throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
	            }
	            options.useCurrent = useCurrent;
	            return picker;
	        };
	
	        picker.collapse = function (collapse) {
	            if (arguments.length === 0) {
	                return options.collapse;
	            }
	
	            if (typeof collapse !== 'boolean') {
	                throw new TypeError('collapse() expects a boolean parameter');
	            }
	            if (options.collapse === collapse) {
	                return picker;
	            }
	            options.collapse = collapse;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.icons = function (icons) {
	            if (arguments.length === 0) {
	                return $.extend({}, options.icons);
	            }
	
	            if (!(icons instanceof Object)) {
	                throw new TypeError('icons() expects parameter to be an Object');
	            }
	            $.extend(options.icons, icons);
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.tooltips = function (tooltips) {
	            if (arguments.length === 0) {
	                return $.extend({}, options.tooltips);
	            }
	
	            if (!(tooltips instanceof Object)) {
	                throw new TypeError('tooltips() expects parameter to be an Object');
	            }
	            $.extend(options.tooltips, tooltips);
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.useStrict = function (useStrict) {
	            if (arguments.length === 0) {
	                return options.useStrict;
	            }
	
	            if (typeof useStrict !== 'boolean') {
	                throw new TypeError('useStrict() expects a boolean parameter');
	            }
	            options.useStrict = useStrict;
	            return picker;
	        };
	
	        picker.sideBySide = function (sideBySide) {
	            if (arguments.length === 0) {
	                return options.sideBySide;
	            }
	
	            if (typeof sideBySide !== 'boolean') {
	                throw new TypeError('sideBySide() expects a boolean parameter');
	            }
	            options.sideBySide = sideBySide;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.viewMode = function (viewMode) {
	            if (arguments.length === 0) {
	                return options.viewMode;
	            }
	
	            if (typeof viewMode !== 'string') {
	                throw new TypeError('viewMode() expects a string parameter');
	            }
	
	            if (viewModes.indexOf(viewMode) === -1) {
	                throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
	            }
	
	            options.viewMode = viewMode;
	            currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);
	
	            showMode();
	            return picker;
	        };
	
	        picker.toolbarPlacement = function (toolbarPlacement) {
	            if (arguments.length === 0) {
	                return options.toolbarPlacement;
	            }
	
	            if (typeof toolbarPlacement !== 'string') {
	                throw new TypeError('toolbarPlacement() expects a string parameter');
	            }
	            if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
	                throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
	            }
	            options.toolbarPlacement = toolbarPlacement;
	
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.widgetPositioning = function (widgetPositioning) {
	            if (arguments.length === 0) {
	                return $.extend({}, options.widgetPositioning);
	            }
	
	            if (({}).toString.call(widgetPositioning) !== '[object Object]') {
	                throw new TypeError('widgetPositioning() expects an object variable');
	            }
	            if (widgetPositioning.horizontal) {
	                if (typeof widgetPositioning.horizontal !== 'string') {
	                    throw new TypeError('widgetPositioning() horizontal variable must be a string');
	                }
	                widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
	                if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
	                    throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
	                }
	                options.widgetPositioning.horizontal = widgetPositioning.horizontal;
	            }
	            if (widgetPositioning.vertical) {
	                if (typeof widgetPositioning.vertical !== 'string') {
	                    throw new TypeError('widgetPositioning() vertical variable must be a string');
	                }
	                widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
	                if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
	                    throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
	                }
	                options.widgetPositioning.vertical = widgetPositioning.vertical;
	            }
	            update();
	            return picker;
	        };
	
	        picker.calendarWeeks = function (calendarWeeks) {
	            if (arguments.length === 0) {
	                return options.calendarWeeks;
	            }
	
	            if (typeof calendarWeeks !== 'boolean') {
	                throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
	            }
	
	            options.calendarWeeks = calendarWeeks;
	            update();
	            return picker;
	        };
	
	        picker.showTodayButton = function (showTodayButton) {
	            if (arguments.length === 0) {
	                return options.showTodayButton;
	            }
	
	            if (typeof showTodayButton !== 'boolean') {
	                throw new TypeError('showTodayButton() expects a boolean parameter');
	            }
	
	            options.showTodayButton = showTodayButton;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.showClear = function (showClear) {
	            if (arguments.length === 0) {
	                return options.showClear;
	            }
	
	            if (typeof showClear !== 'boolean') {
	                throw new TypeError('showClear() expects a boolean parameter');
	            }
	
	            options.showClear = showClear;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.widgetParent = function (widgetParent) {
	            if (arguments.length === 0) {
	                return options.widgetParent;
	            }
	
	            if (typeof widgetParent === 'string') {
	                widgetParent = $(widgetParent);
	            }
	
	            if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
	                throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
	            }
	
	            options.widgetParent = widgetParent;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.keepOpen = function (keepOpen) {
	            if (arguments.length === 0) {
	                return options.keepOpen;
	            }
	
	            if (typeof keepOpen !== 'boolean') {
	                throw new TypeError('keepOpen() expects a boolean parameter');
	            }
	
	            options.keepOpen = keepOpen;
	            return picker;
	        };
	
	        picker.focusOnShow = function (focusOnShow) {
	            if (arguments.length === 0) {
	                return options.focusOnShow;
	            }
	
	            if (typeof focusOnShow !== 'boolean') {
	                throw new TypeError('focusOnShow() expects a boolean parameter');
	            }
	
	            options.focusOnShow = focusOnShow;
	            return picker;
	        };
	
	        picker.inline = function (inline) {
	            if (arguments.length === 0) {
	                return options.inline;
	            }
	
	            if (typeof inline !== 'boolean') {
	                throw new TypeError('inline() expects a boolean parameter');
	            }
	
	            options.inline = inline;
	            return picker;
	        };
	
	        picker.clear = function () {
	            clear();
	            return picker;
	        };
	
	        picker.keyBinds = function (keyBinds) {
	            if (arguments.length === 0) {
	                return options.keyBinds;
	            }
	
	            options.keyBinds = keyBinds;
	            return picker;
	        };
	
	        picker.getMoment = function (d) {
	            return getMoment(d);
	        };
	
	        picker.debug = function (debug) {
	            if (typeof debug !== 'boolean') {
	                throw new TypeError('debug() expects a boolean parameter');
	            }
	
	            options.debug = debug;
	            return picker;
	        };
	
	        picker.allowInputToggle = function (allowInputToggle) {
	            if (arguments.length === 0) {
	                return options.allowInputToggle;
	            }
	
	            if (typeof allowInputToggle !== 'boolean') {
	                throw new TypeError('allowInputToggle() expects a boolean parameter');
	            }
	
	            options.allowInputToggle = allowInputToggle;
	            return picker;
	        };
	
	        picker.showClose = function (showClose) {
	            if (arguments.length === 0) {
	                return options.showClose;
	            }
	
	            if (typeof showClose !== 'boolean') {
	                throw new TypeError('showClose() expects a boolean parameter');
	            }
	
	            options.showClose = showClose;
	            return picker;
	        };
	
	        picker.keepInvalid = function (keepInvalid) {
	            if (arguments.length === 0) {
	                return options.keepInvalid;
	            }
	
	            if (typeof keepInvalid !== 'boolean') {
	                throw new TypeError('keepInvalid() expects a boolean parameter');
	            }
	            options.keepInvalid = keepInvalid;
	            return picker;
	        };
	
	        picker.datepickerInput = function (datepickerInput) {
	            if (arguments.length === 0) {
	                return options.datepickerInput;
	            }
	
	            if (typeof datepickerInput !== 'string') {
	                throw new TypeError('datepickerInput() expects a string parameter');
	            }
	
	            options.datepickerInput = datepickerInput;
	            return picker;
	        };
	
	        picker.parseInputDate = function (parseInputDate) {
	            if (arguments.length === 0) {
	                return options.parseInputDate;
	            }
	
	            if (typeof parseInputDate !== 'function') {
	                throw new TypeError('parseInputDate() sholud be as function');
	            }
	
	            options.parseInputDate = parseInputDate;
	
	            return picker;
	        };
	
	        picker.disabledTimeIntervals = function (disabledTimeIntervals) {
	            ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
	            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
	            ///<returns type="array">options.disabledTimeIntervals</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
	            ///options.enabledDates if such exist.</summary>
	            ///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
	            }
	
	            if (!disabledTimeIntervals) {
	                options.disabledTimeIntervals = false;
	                update();
	                return picker;
	            }
	            if (!(disabledTimeIntervals instanceof Array)) {
	                throw new TypeError('disabledTimeIntervals() expects an array parameter');
	            }
	            options.disabledTimeIntervals = disabledTimeIntervals;
	            update();
	            return picker;
	        };
	
	        picker.disabledHours = function (hours) {
	            ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
	            ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
	            ///<returns type="array">options.disabledHours</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
	            ///options.enabledHours if such exist.</summary>
	            ///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
	            }
	
	            if (!hours) {
	                options.disabledHours = false;
	                update();
	                return picker;
	            }
	            if (!(hours instanceof Array)) {
	                throw new TypeError('disabledHours() expects an array parameter');
	            }
	            options.disabledHours = indexGivenHours(hours);
	            options.enabledHours = false;
	            if (options.useCurrent && !options.keepInvalid) {
	                var tries = 0;
	                while (!isValid(date, 'h')) {
	                    date.add(1, 'h');
	                    if (tries === 24) {
	                        throw 'Tried 24 times to find a valid date';
	                    }
	                    tries++;
	                }
	                setValue(date);
	            }
	            update();
	            return picker;
	        };
	
	        picker.enabledHours = function (hours) {
	            ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
	            ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
	            ///<returns type="array">options.enabledHours</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
	            ///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
	            }
	
	            if (!hours) {
	                options.enabledHours = false;
	                update();
	                return picker;
	            }
	            if (!(hours instanceof Array)) {
	                throw new TypeError('enabledHours() expects an array parameter');
	            }
	            options.enabledHours = indexGivenHours(hours);
	            options.disabledHours = false;
	            if (options.useCurrent && !options.keepInvalid) {
	                var tries = 0;
	                while (!isValid(date, 'h')) {
	                    date.add(1, 'h');
	                    if (tries === 24) {
	                        throw 'Tried 24 times to find a valid date';
	                    }
	                    tries++;
	                }
	                setValue(date);
	            }
	            update();
	            return picker;
	        };
	        /**
	         * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.
	         * @param {Takes string, viewDate, moment, null parameter.} newDate
	         * @returns {viewDate.clone()}
	         */
	        picker.viewDate = function (newDate) {
	            if (arguments.length === 0) {
	                return viewDate.clone();
	            }
	
	            if (!newDate) {
	                viewDate = date.clone();
	                return picker;
	            }
	
	            if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
	                throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
	            }
	
	            viewDate = parseInputDate(newDate);
	            viewUpdate();
	            return picker;
	        };
	
	        // initializing element and component attributes
	        if (element.is('input')) {
	            input = element;
	        } else {
	            input = element.find(options.datepickerInput);
	            if (input.length === 0) {
	                input = element.find('input');
	            } else if (!input.is('input')) {
	                throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
	            }
	        }
	
	        if (element.hasClass('input-group')) {
	            // in case there is more then one 'input-group-addon' Issue #48
	            if (element.find('.datepickerbutton').length === 0) {
	                component = element.find('.input-group-addon');
	            } else {
	                component = element.find('.datepickerbutton');
	            }
	        }
	
	        if (!options.inline && !input.is('input')) {
	            throw new Error('Could not initialize DateTimePicker without an input element');
	        }
	
	        // Set defaults for date here now instead of in var declaration
	        date = getMoment();
	        viewDate = date.clone();
	
	        $.extend(true, options, dataToOptions());
	
	        picker.options(options);
	
	        initFormatting();
	
	        attachDatePickerElementEvents();
	
	        if (input.prop('disabled')) {
	            picker.disable();
	        }
	        if (input.is('input') && input.val().trim().length !== 0) {
	            setValue(parseInputDate(input.val().trim()));
	        }
	        else if (options.defaultDate && input.attr('placeholder') === undefined) {
	            setValue(options.defaultDate);
	        }
	        if (options.inline) {
	            show();
	        }
	        return picker;
	    };
	
	    /********************************************************************************
	     *
	     * jQuery plugin constructor and defaults object
	     *
	     ********************************************************************************/
	
	    /**
	    * See (http://jquery.com/).
	    * @name jQuery
	    * @class
	    * See the jQuery Library  (http://jquery.com/) for full details.  This just
	    * documents the function and classes that are added to jQuery by this plug-in.
	    */
	    /**
	     * See (http://jquery.com/)
	     * @name fn
	     * @class
	     * See the jQuery Library  (http://jquery.com/) for full details.  This just
	     * documents the function and classes that are added to jQuery by this plug-in.
	     * @memberOf jQuery
	     */
	    /**
	     * Show comments
	     * @class datetimepicker
	     * @memberOf jQuery.fn
	     */
	    $.fn.datetimepicker = function (options) {
	        options = options || {};
	
	        var args = Array.prototype.slice.call(arguments, 1),
	            isInstance = true,
	            thisMethods = ['destroy', 'hide', 'show', 'toggle'],
	            returnValue;
	
	        if (typeof options === 'object') {
	            return this.each(function () {
	                var $this = $(this),
	                    _options;
	                if (!$this.data('DateTimePicker')) {
	                    // create a private copy of the defaults object
	                    _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
	                    $this.data('DateTimePicker', dateTimePicker($this, _options));
	                }
	            });
	        } else if (typeof options === 'string') {
	            this.each(function () {
	                var $this = $(this),
	                    instance = $this.data('DateTimePicker');
	                if (!instance) {
	                    throw new Error('bootstrap-datetimepicker("' + options + '") method was called on an element that is not using DateTimePicker');
	                }
	
	                returnValue = instance[options].apply(instance, args);
	                isInstance = returnValue === instance;
	            });
	
	            if (isInstance || $.inArray(options, thisMethods) > -1) {
	                return this;
	            }
	
	            return returnValue;
	        }
	
	        throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
	    };
	
	    $.fn.datetimepicker.defaults = {
	        timeZone: '',
	        format: false,
	        dayViewHeaderFormat: 'MMMM YYYY',
	        extraFormats: false,
	        stepping: 1,
	        minDate: false,
	        maxDate: false,
	        useCurrent: true,
	        collapse: true,
	        locale: moment.locale(),
	        defaultDate: false,
	        disabledDates: false,
	        enabledDates: false,
	        icons: {
	            time: 'glyphicon glyphicon-time',
	            date: 'glyphicon glyphicon-calendar',
	            up: 'glyphicon glyphicon-chevron-up',
	            down: 'glyphicon glyphicon-chevron-down',
	            previous: 'glyphicon glyphicon-chevron-left',
	            next: 'glyphicon glyphicon-chevron-right',
	            today: 'glyphicon glyphicon-screenshot',
	            clear: 'glyphicon glyphicon-trash',
	            close: 'glyphicon glyphicon-remove'
	        },
	        tooltips: {
	            today: 'Go to today',
	            clear: 'Clear selection',
	            close: 'Close the picker',
	            selectMonth: 'Select Month',
	            prevMonth: 'Previous Month',
	            nextMonth: 'Next Month',
	            selectYear: 'Select Year',
	            prevYear: 'Previous Year',
	            nextYear: 'Next Year',
	            selectDecade: 'Select Decade',
	            prevDecade: 'Previous Decade',
	            nextDecade: 'Next Decade',
	            prevCentury: 'Previous Century',
	            nextCentury: 'Next Century',
	            pickHour: 'Pick Hour',
	            incrementHour: 'Increment Hour',
	            decrementHour: 'Decrement Hour',
	            pickMinute: 'Pick Minute',
	            incrementMinute: 'Increment Minute',
	            decrementMinute: 'Decrement Minute',
	            pickSecond: 'Pick Second',
	            incrementSecond: 'Increment Second',
	            decrementSecond: 'Decrement Second',
	            togglePeriod: 'Toggle Period',
	            selectTime: 'Select Time'
	        },
	        useStrict: false,
	        sideBySide: false,
	        daysOfWeekDisabled: false,
	        calendarWeeks: false,
	        viewMode: 'days',
	        toolbarPlacement: 'default',
	        showTodayButton: false,
	        showClear: false,
	        showClose: false,
	        widgetPositioning: {
	            horizontal: 'auto',
	            vertical: 'auto'
	        },
	        widgetParent: null,
	        ignoreReadonly: false,
	        keepOpen: false,
	        focusOnShow: true,
	        inline: false,
	        keepInvalid: false,
	        datepickerInput: '.datepickerinput',
	        keyBinds: {
	            up: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(7, 'd'));
	                } else {
	                    this.date(d.clone().add(this.stepping(), 'm'));
	                }
	            },
	            down: function (widget) {
	                if (!widget) {
	                    this.show();
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(7, 'd'));
	                } else {
	                    this.date(d.clone().subtract(this.stepping(), 'm'));
	                }
	            },
	            'control up': function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(1, 'y'));
	                } else {
	                    this.date(d.clone().add(1, 'h'));
	                }
	            },
	            'control down': function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(1, 'y'));
	                } else {
	                    this.date(d.clone().subtract(1, 'h'));
	                }
	            },
	            left: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(1, 'd'));
	                }
	            },
	            right: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(1, 'd'));
	                }
	            },
	            pageUp: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(1, 'M'));
	                }
	            },
	            pageDown: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(1, 'M'));
	                }
	            },
	            enter: function () {
	                this.hide();
	            },
	            escape: function () {
	                this.hide();
	            },
	            //tab: function (widget) { //this break the flow of the form. disabling for now
	            //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
	            //    if(toggle.length > 0) toggle.click();
	            //},
	            'control space': function (widget) {
	                if (!widget) {
	                    return;
	                }
	                if (widget.find('.timepicker').is(':visible')) {
	                    widget.find('.btn[data-action="togglePeriod"]').click();
	                }
	            },
	            t: function () {
	                this.date(this.getMoment());
	            },
	            'delete': function () {
	                this.clear();
	            }
	        },
	        debug: false,
	        allowInputToggle: false,
	        disabledTimeIntervals: false,
	        disabledHours: false,
	        enabledHours: false,
	        viewDate: false
	    };
	
	    return $.fn.datetimepicker;
	}));


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/9de0cab3839a62c2dd9ed9cfd174a6a1.png";

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/063a9bdba5b81d4f6210ff47cc086351.png";

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/aa2f12fd98737cdec97817ddc3f53d02.png";

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/af47e8347b0cf0c7f508390e8dc6c888.png";

/***/ },
/* 802 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(813),
	    isArguments = __webpack_require__(828),
	    isArray = __webpack_require__(220),
	    isBuffer = __webpack_require__(829),
	    isIndex = __webpack_require__(816),
	    isTypedArray = __webpack_require__(832);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 804 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(811);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ },
/* 806 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(78),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(78),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(78),
	    isLength = __webpack_require__(221),
	    isObjectLike = __webpack_require__(79);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(817),
	    nativeKeys = __webpack_require__(818);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 811 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 812 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 813 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(812);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(148);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 816 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 817 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(820);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 819 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 820 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(802);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(805),
	    hasUnicode = __webpack_require__(149),
	    unicodeSize = __webpack_require__(824);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(806),
	    hasUnicode = __webpack_require__(149),
	    unicodeToArray = __webpack_require__(825);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 824 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ },
/* 825 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(223);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	module.exports = before;


/***/ },
/* 827 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(807),
	    isObjectLike = __webpack_require__(79);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(150),
	    stubFalse = __webpack_require__(836);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(78),
	    isObject = __webpack_require__(101);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(808),
	    baseUnary = __webpack_require__(217),
	    nodeUtil = __webpack_require__(219);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(809),
	    baseUnary = __webpack_require__(217),
	    nodeUtil = __webpack_require__(219);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(803),
	    baseKeys = __webpack_require__(810),
	    isArrayLike = __webpack_require__(100);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(150);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var before = __webpack_require__(826);
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	module.exports = once;


/***/ },
/* 836 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(224);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(216);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(216),
	    castSlice = __webpack_require__(814),
	    hasUnicode = __webpack_require__(149),
	    isObject = __webpack_require__(101),
	    isRegExp = __webpack_require__(831),
	    stringSize = __webpack_require__(822),
	    stringToArray = __webpack_require__(823),
	    toInteger = __webpack_require__(223),
	    toString = __webpack_require__(838);
	
	/** Used as default options for `_.truncate`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object} [options={}] The options object.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.truncate('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function truncate(string, options) {
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (isObject(options)) {
	    var separator = 'separator' in options ? options.separator : separator;
	    length = 'length' in options ? toInteger(options.length) : length;
	    omission = 'omission' in options ? baseToString(options.omission) : omission;
	  }
	  string = toString(string);
	
	  var strLength = string.length;
	  if (hasUnicode(string)) {
	    var strSymbols = stringToArray(string);
	    strLength = strSymbols.length;
	  }
	  if (length >= strLength) {
	    return string;
	  }
	  var end = length - stringSize(omission);
	  if (end < 1) {
	    return omission;
	  }
	  var result = strSymbols
	    ? castSlice(strSymbols, 0, end).join('')
	    : string.slice(0, end);
	
	  if (separator === undefined) {
	    return result + omission;
	  }
	  if (strSymbols) {
	    end += (result.length - end);
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          substring = result;
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        var newEnd = match.index;
	      }
	      result = result.slice(0, newEnd === undefined ? end : newEnd);
	    }
	  } else if (string.indexOf(baseToString(separator), end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = truncate;


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 225,
		"./af.js": 225,
		"./ar": 231,
		"./ar-dz": 226,
		"./ar-dz.js": 226,
		"./ar-ly": 227,
		"./ar-ly.js": 227,
		"./ar-ma": 228,
		"./ar-ma.js": 228,
		"./ar-sa": 229,
		"./ar-sa.js": 229,
		"./ar-tn": 230,
		"./ar-tn.js": 230,
		"./ar.js": 231,
		"./az": 232,
		"./az.js": 232,
		"./be": 233,
		"./be.js": 233,
		"./bg": 235,
		"./bg-x": 234,
		"./bg-x.js": 234,
		"./bg.js": 235,
		"./bn": 236,
		"./bn.js": 236,
		"./bo": 237,
		"./bo.js": 237,
		"./br": 238,
		"./br.js": 238,
		"./bs": 239,
		"./bs.js": 239,
		"./ca": 240,
		"./ca.js": 240,
		"./cs": 241,
		"./cs.js": 241,
		"./cv": 242,
		"./cv.js": 242,
		"./cy": 243,
		"./cy.js": 243,
		"./da": 244,
		"./da.js": 244,
		"./de": 246,
		"./de-at": 245,
		"./de-at.js": 245,
		"./de.js": 246,
		"./dv": 247,
		"./dv.js": 247,
		"./el": 248,
		"./el.js": 248,
		"./en-au": 249,
		"./en-au.js": 249,
		"./en-ca": 250,
		"./en-ca.js": 250,
		"./en-gb": 152,
		"./en-gb.js": 152,
		"./en-ie": 251,
		"./en-ie.js": 251,
		"./en-nz": 252,
		"./en-nz.js": 252,
		"./eo": 253,
		"./eo.js": 253,
		"./es": 255,
		"./es-do": 254,
		"./es-do.js": 254,
		"./es.js": 255,
		"./et": 256,
		"./et.js": 256,
		"./eu": 257,
		"./eu.js": 257,
		"./fa": 258,
		"./fa.js": 258,
		"./fi": 259,
		"./fi.js": 259,
		"./fo": 260,
		"./fo.js": 260,
		"./fr": 263,
		"./fr-ca": 261,
		"./fr-ca.js": 261,
		"./fr-ch": 262,
		"./fr-ch.js": 262,
		"./fr.js": 263,
		"./fy": 264,
		"./fy.js": 264,
		"./gd": 265,
		"./gd.js": 265,
		"./gl": 266,
		"./gl.js": 266,
		"./he": 267,
		"./he.js": 267,
		"./hi": 268,
		"./hi.js": 268,
		"./hr": 269,
		"./hr.js": 269,
		"./hu": 270,
		"./hu.js": 270,
		"./hy-am": 271,
		"./hy-am.js": 271,
		"./id": 272,
		"./id.js": 272,
		"./is": 273,
		"./is.js": 273,
		"./it": 274,
		"./it.js": 274,
		"./ja": 275,
		"./ja.js": 275,
		"./jv": 276,
		"./jv.js": 276,
		"./ka": 277,
		"./ka.js": 277,
		"./kk": 278,
		"./kk.js": 278,
		"./km": 279,
		"./km.js": 279,
		"./ko": 280,
		"./ko.js": 280,
		"./ky": 281,
		"./ky.js": 281,
		"./lb": 282,
		"./lb.js": 282,
		"./lo": 283,
		"./lo.js": 283,
		"./lt": 284,
		"./lt.js": 284,
		"./lv": 285,
		"./lv.js": 285,
		"./me": 286,
		"./me.js": 286,
		"./mi": 287,
		"./mi.js": 287,
		"./mk": 288,
		"./mk.js": 288,
		"./ml": 289,
		"./ml.js": 289,
		"./mr": 290,
		"./mr.js": 290,
		"./ms": 292,
		"./ms-my": 291,
		"./ms-my.js": 291,
		"./ms.js": 292,
		"./my": 293,
		"./my.js": 293,
		"./nb": 294,
		"./nb.js": 294,
		"./ne": 295,
		"./ne.js": 295,
		"./nl": 297,
		"./nl-be": 296,
		"./nl-be.js": 296,
		"./nl.js": 297,
		"./nn": 298,
		"./nn.js": 298,
		"./pa-in": 299,
		"./pa-in.js": 299,
		"./pl": 300,
		"./pl.js": 300,
		"./pt": 302,
		"./pt-br": 301,
		"./pt-br.js": 301,
		"./pt.js": 302,
		"./ro": 303,
		"./ro.js": 303,
		"./ru": 153,
		"./ru.js": 153,
		"./se": 304,
		"./se.js": 304,
		"./si": 305,
		"./si.js": 305,
		"./sk": 306,
		"./sk.js": 306,
		"./sl": 307,
		"./sl.js": 307,
		"./sq": 308,
		"./sq.js": 308,
		"./sr": 310,
		"./sr-cyrl": 309,
		"./sr-cyrl.js": 309,
		"./sr.js": 310,
		"./ss": 311,
		"./ss.js": 311,
		"./sv": 312,
		"./sv.js": 312,
		"./sw": 313,
		"./sw.js": 313,
		"./ta": 314,
		"./ta.js": 314,
		"./te": 315,
		"./te.js": 315,
		"./tet": 316,
		"./tet.js": 316,
		"./th": 317,
		"./th.js": 317,
		"./tl-ph": 318,
		"./tl-ph.js": 318,
		"./tlh": 319,
		"./tlh.js": 319,
		"./tr": 320,
		"./tr.js": 320,
		"./tzl": 321,
		"./tzl.js": 321,
		"./tzm": 323,
		"./tzm-latn": 322,
		"./tzm-latn.js": 322,
		"./tzm.js": 323,
		"./uk": 324,
		"./uk.js": 324,
		"./uz": 325,
		"./uz.js": 325,
		"./vi": 326,
		"./vi.js": 326,
		"./x-pseudo": 327,
		"./x-pseudo.js": 327,
		"./yo": 328,
		"./yo.js": 328,
		"./zh-cn": 329,
		"./zh-cn.js": 329,
		"./zh-hk": 330,
		"./zh-hk.js": 330,
		"./zh-tw": 331,
		"./zh-tw.js": 331
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 840;


/***/ },
/* 841 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(841)))

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
	 * Sortable
	 * @author	RubaXa   <trash@rubaxa.org>
	 * @license MIT
	 */
	
	(function sortableModule(factory) {
		"use strict";
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof module != "undefined" && typeof module.exports != "undefined") {
			module.exports = factory();
		}
		else {
			/* jshint sub:true */
			window["Sortable"] = factory();
		}
	})(function sortableFactory() {
		"use strict";
	
		if (typeof window == "undefined" || !window.document) {
			return function sortableError() {
				throw new Error("Sortable.js requires a window with a document");
			};
		}
	
		var dragEl,
			parentEl,
			ghostEl,
			cloneEl,
			rootEl,
			nextEl,
			lastDownEl,
	
			scrollEl,
			scrollParentEl,
			scrollCustomFn,
	
			lastEl,
			lastCSS,
			lastParentCSS,
	
			oldIndex,
			newIndex,
	
			activeGroup,
			putSortable,
	
			autoScroll = {},
	
			tapEvt,
			touchEvt,
	
			moved,
	
			/** @const */
			R_SPACE = /\s+/g,
			R_FLOAT = /left|right|inline/,
	
			expando = 'Sortable' + (new Date).getTime(),
	
			win = window,
			document = win.document,
			parseInt = win.parseInt,
	
			$ = win.jQuery || win.Zepto,
			Polymer = win.Polymer,
	
			captureMode = false,
	
			supportDraggable = !!('draggable' in document.createElement('div')),
			supportCssPointerEvents = (function (el) {
				// false when IE11
				if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
					return false;
				}
				el = document.createElement('x');
				el.style.cssText = 'pointer-events:auto';
				return el.style.pointerEvents === 'auto';
			})(),
	
			_silent = false,
	
			abs = Math.abs,
			min = Math.min,
	
			savedInputChecked = [],
			touchDragOverListeners = [],
	
			_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
				// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
				if (rootEl && options.scroll) {
					var _this = rootEl[expando],
						el,
						rect,
						sens = options.scrollSensitivity,
						speed = options.scrollSpeed,
	
						x = evt.clientX,
						y = evt.clientY,
	
						winWidth = window.innerWidth,
						winHeight = window.innerHeight,
	
						vx,
						vy,
	
						scrollOffsetX,
						scrollOffsetY
					;
	
					// Delect scrollEl
					if (scrollParentEl !== rootEl) {
						scrollEl = options.scroll;
						scrollParentEl = rootEl;
						scrollCustomFn = options.scrollFn;
	
						if (scrollEl === true) {
							scrollEl = rootEl;
	
							do {
								if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
									(scrollEl.offsetHeight < scrollEl.scrollHeight)
								) {
									break;
								}
								/* jshint boss:true */
							} while (scrollEl = scrollEl.parentNode);
						}
					}
	
					if (scrollEl) {
						el = scrollEl;
						rect = scrollEl.getBoundingClientRect();
						vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
						vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
					}
	
	
					if (!(vx || vy)) {
						vx = (winWidth - x <= sens) - (x <= sens);
						vy = (winHeight - y <= sens) - (y <= sens);
	
						/* jshint expr:true */
						(vx || vy) && (el = win);
					}
	
	
					if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
						autoScroll.el = el;
						autoScroll.vx = vx;
						autoScroll.vy = vy;
	
						clearInterval(autoScroll.pid);
	
						if (el) {
							autoScroll.pid = setInterval(function () {
								scrollOffsetY = vy ? vy * speed : 0;
								scrollOffsetX = vx ? vx * speed : 0;
	
								if ('function' === typeof(scrollCustomFn)) {
									return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
								}
	
								if (el === win) {
									win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
								} else {
									el.scrollTop += scrollOffsetY;
									el.scrollLeft += scrollOffsetX;
								}
							}, 24);
						}
					}
				}
			}, 30),
	
			_prepareGroup = function (options) {
				function toFn(value, pull) {
					if (value === void 0 || value === true) {
						value = group.name;
					}
	
					if (typeof value === 'function') {
						return value;
					} else {
						return function (to, from) {
							var fromGroup = from.options.group.name;
	
							return pull
								? value
								: value && (value.join
									? value.indexOf(fromGroup) > -1
									: (fromGroup == value)
								);
						};
					}
				}
	
				var group = {};
				var originalGroup = options.group;
	
				if (!originalGroup || typeof originalGroup != 'object') {
					originalGroup = {name: originalGroup};
				}
	
				group.name = originalGroup.name;
				group.checkPull = toFn(originalGroup.pull, true);
				group.checkPut = toFn(originalGroup.put);
				group.revertClone = originalGroup.revertClone;
	
				options.group = group;
			}
		;
	
	
		/**
		 * @class  Sortable
		 * @param  {HTMLElement}  el
		 * @param  {Object}       [options]
		 */
		function Sortable(el, options) {
			if (!(el && el.nodeType && el.nodeType === 1)) {
				throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
			}
	
			this.el = el; // root element
			this.options = options = _extend({}, options);
	
	
			// Export instance
			el[expando] = this;
	
			// Default options
			var defaults = {
				group: Math.random(),
				sort: true,
				disabled: false,
				store: null,
				handle: null,
				scroll: true,
				scrollSensitivity: 30,
				scrollSpeed: 10,
				draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
				ghostClass: 'sortable-ghost',
				chosenClass: 'sortable-chosen',
				dragClass: 'sortable-drag',
				ignore: 'a, img',
				filter: null,
				preventOnFilter: true,
				animation: 0,
				setData: function (dataTransfer, dragEl) {
					dataTransfer.setData('Text', dragEl.textContent);
				},
				dropBubble: false,
				dragoverBubble: false,
				dataIdAttr: 'data-id',
				delay: 0,
				forceFallback: false,
				fallbackClass: 'sortable-fallback',
				fallbackOnBody: false,
				fallbackTolerance: 0,
				fallbackOffset: {x: 0, y: 0}
			};
	
	
			// Set default options
			for (var name in defaults) {
				!(name in options) && (options[name] = defaults[name]);
			}
	
			_prepareGroup(options);
	
			// Bind all private methods
			for (var fn in this) {
				if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
					this[fn] = this[fn].bind(this);
				}
			}
	
			// Setup drag mode
			this.nativeDraggable = options.forceFallback ? false : supportDraggable;
	
			// Bind events
			_on(el, 'mousedown', this._onTapStart);
			_on(el, 'touchstart', this._onTapStart);
			_on(el, 'pointerdown', this._onTapStart);
	
			if (this.nativeDraggable) {
				_on(el, 'dragover', this);
				_on(el, 'dragenter', this);
			}
	
			touchDragOverListeners.push(this._onDragOver);
	
			// Restore sorting
			options.store && this.sort(options.store.get(this));
		}
	
	
		Sortable.prototype = /** @lends Sortable.prototype */ {
			constructor: Sortable,
	
			_onTapStart: function (/** Event|TouchEvent */evt) {
				var _this = this,
					el = this.el,
					options = this.options,
					preventOnFilter = options.preventOnFilter,
					type = evt.type,
					touch = evt.touches && evt.touches[0],
					target = (touch || evt).target,
					originalTarget = evt.target.shadowRoot && evt.path[0] || target,
					filter = options.filter,
					startIndex;
	
				_saveInputCheckedState(el);
	
	
				// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
				if (dragEl) {
					return;
				}
	
				if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
					return; // only left button or enabled
				}
	
	
				target = _closest(target, options.draggable, el);
	
				if (!target) {
					return;
				}
	
				if (lastDownEl === target) {
					// Ignoring duplicate `down`
					return;
				}
	
				// Get the index of the dragged element within its parent
				startIndex = _index(target, options.draggable);
	
				// Check filter
				if (typeof filter === 'function') {
					if (filter.call(this, evt, target, this)) {
						_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
						preventOnFilter && evt.preventDefault();
						return; // cancel dnd
					}
				}
				else if (filter) {
					filter = filter.split(',').some(function (criteria) {
						criteria = _closest(originalTarget, criteria.trim(), el);
	
						if (criteria) {
							_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
							return true;
						}
					});
	
					if (filter) {
						preventOnFilter && evt.preventDefault();
						return; // cancel dnd
					}
				}
	
				if (options.handle && !_closest(originalTarget, options.handle, el)) {
					return;
				}
	
				// Prepare `dragstart`
				this._prepareDragStart(evt, touch, target, startIndex);
			},
	
			_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
				var _this = this,
					el = _this.el,
					options = _this.options,
					ownerDocument = el.ownerDocument,
					dragStartFn;
	
				if (target && !dragEl && (target.parentNode === el)) {
					tapEvt = evt;
	
					rootEl = el;
					dragEl = target;
					parentEl = dragEl.parentNode;
					nextEl = dragEl.nextSibling;
					lastDownEl = target;
					activeGroup = options.group;
					oldIndex = startIndex;
	
					this._lastX = (touch || evt).clientX;
					this._lastY = (touch || evt).clientY;
	
					dragEl.style['will-change'] = 'transform';
	
					dragStartFn = function () {
						// Delayed drag has been triggered
						// we can re-enable the events: touchmove/mousemove
						_this._disableDelayedDrag();
	
						// Make the element draggable
						dragEl.draggable = _this.nativeDraggable;
	
						// Chosen item
						_toggleClass(dragEl, options.chosenClass, true);
	
						// Bind the events: dragstart/dragend
						_this._triggerDragStart(evt, touch);
	
						// Drag start event
						_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
					};
	
					// Disable "draggable"
					options.ignore.split(',').forEach(function (criteria) {
						_find(dragEl, criteria.trim(), _disableDraggable);
					});
	
					_on(ownerDocument, 'mouseup', _this._onDrop);
					_on(ownerDocument, 'touchend', _this._onDrop);
					_on(ownerDocument, 'touchcancel', _this._onDrop);
					_on(ownerDocument, 'pointercancel', _this._onDrop);
					_on(ownerDocument, 'selectstart', _this);
	
					if (options.delay) {
						// If the user moves the pointer or let go the click or touch
						// before the delay has been reached:
						// disable the delayed drag
						_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
						_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
						_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
						_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
						_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
						_on(ownerDocument, 'pointermove', _this._disableDelayedDrag);
	
						_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
					} else {
						dragStartFn();
					}
	
	
				}
			},
	
			_disableDelayedDrag: function () {
				var ownerDocument = this.el.ownerDocument;
	
				clearTimeout(this._dragStartTimer);
				_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
				_off(ownerDocument, 'touchend', this._disableDelayedDrag);
				_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
				_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
				_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
				_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
			},
	
			_triggerDragStart: function (/** Event */evt, /** Touch */touch) {
				touch = touch || (evt.pointerType == 'touch' ? evt : null);
	
				if (touch) {
					// Touch device support
					tapEvt = {
						target: dragEl,
						clientX: touch.clientX,
						clientY: touch.clientY
					};
	
					this._onDragStart(tapEvt, 'touch');
				}
				else if (!this.nativeDraggable) {
					this._onDragStart(tapEvt, true);
				}
				else {
					_on(dragEl, 'dragend', this);
					_on(rootEl, 'dragstart', this._onDragStart);
				}
	
				try {
					if (document.selection) {					
						// Timeout neccessary for IE9					
						setTimeout(function () {
							document.selection.empty();
						});					
					} else {
						window.getSelection().removeAllRanges();
					}
				} catch (err) {
				}
			},
	
			_dragStarted: function () {
				if (rootEl && dragEl) {
					var options = this.options;
	
					// Apply effect
					_toggleClass(dragEl, options.ghostClass, true);
					_toggleClass(dragEl, options.dragClass, false);
	
					Sortable.active = this;
	
					// Drag start event
					_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
				} else {
					this._nulling();
				}
			},
	
			_emulateDragOver: function () {
				if (touchEvt) {
					if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
						return;
					}
	
					this._lastX = touchEvt.clientX;
					this._lastY = touchEvt.clientY;
	
					if (!supportCssPointerEvents) {
						_css(ghostEl, 'display', 'none');
					}
	
					var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
						parent = target,
						i = touchDragOverListeners.length;
	
					if (parent) {
						do {
							if (parent[expando]) {
								while (i--) {
									touchDragOverListeners[i]({
										clientX: touchEvt.clientX,
										clientY: touchEvt.clientY,
										target: target,
										rootEl: parent
									});
								}
	
								break;
							}
	
							target = parent; // store last element
						}
						/* jshint boss:true */
						while (parent = parent.parentNode);
					}
	
					if (!supportCssPointerEvents) {
						_css(ghostEl, 'display', '');
					}
				}
			},
	
	
			_onTouchMove: function (/**TouchEvent*/evt) {
				if (tapEvt) {
					var	options = this.options,
						fallbackTolerance = options.fallbackTolerance,
						fallbackOffset = options.fallbackOffset,
						touch = evt.touches ? evt.touches[0] : evt,
						dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
						dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
						translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';
	
					// only set the status to dragging, when we are actually dragging
					if (!Sortable.active) {
						if (fallbackTolerance &&
							min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
						) {
							return;
						}
	
						this._dragStarted();
					}
	
					// as well as creating the ghost element on the document body
					this._appendGhost();
	
					moved = true;
					touchEvt = touch;
	
					_css(ghostEl, 'webkitTransform', translate3d);
					_css(ghostEl, 'mozTransform', translate3d);
					_css(ghostEl, 'msTransform', translate3d);
					_css(ghostEl, 'transform', translate3d);
	
					evt.preventDefault();
				}
			},
	
			_appendGhost: function () {
				if (!ghostEl) {
					var rect = dragEl.getBoundingClientRect(),
						css = _css(dragEl),
						options = this.options,
						ghostRect;
	
					ghostEl = dragEl.cloneNode(true);
	
					_toggleClass(ghostEl, options.ghostClass, false);
					_toggleClass(ghostEl, options.fallbackClass, true);
					_toggleClass(ghostEl, options.dragClass, true);
	
					_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
					_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
					_css(ghostEl, 'width', rect.width);
					_css(ghostEl, 'height', rect.height);
					_css(ghostEl, 'opacity', '0.8');
					_css(ghostEl, 'position', 'fixed');
					_css(ghostEl, 'zIndex', '100000');
					_css(ghostEl, 'pointerEvents', 'none');
	
					options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);
	
					// Fixing dimensions.
					ghostRect = ghostEl.getBoundingClientRect();
					_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
					_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
				}
			},
	
			_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
				var dataTransfer = evt.dataTransfer,
					options = this.options;
	
				this._offUpEvents();
	
				if (activeGroup.checkPull(this, this, dragEl, evt)) {
					cloneEl = _clone(dragEl);
	
					cloneEl.draggable = false;
					cloneEl.style['will-change'] = '';
	
					_css(cloneEl, 'display', 'none');
					_toggleClass(cloneEl, this.options.chosenClass, false);
	
					rootEl.insertBefore(cloneEl, dragEl);
					_dispatchEvent(this, rootEl, 'clone', dragEl);
				}
	
				_toggleClass(dragEl, options.dragClass, true);
	
				if (useFallback) {
					if (useFallback === 'touch') {
						// Bind touch events
						_on(document, 'touchmove', this._onTouchMove);
						_on(document, 'touchend', this._onDrop);
						_on(document, 'touchcancel', this._onDrop);
						_on(document, 'pointermove', this._onTouchMove);
						_on(document, 'pointerup', this._onDrop);
					} else {
						// Old brwoser
						_on(document, 'mousemove', this._onTouchMove);
						_on(document, 'mouseup', this._onDrop);
					}
	
					this._loopId = setInterval(this._emulateDragOver, 50);
				}
				else {
					if (dataTransfer) {
						dataTransfer.effectAllowed = 'move';
						options.setData && options.setData.call(this, dataTransfer, dragEl);
					}
	
					_on(document, 'drop', this);
					setTimeout(this._dragStarted, 0);
				}
			},
	
			_onDragOver: function (/**Event*/evt) {
				var el = this.el,
					target,
					dragRect,
					targetRect,
					revert,
					options = this.options,
					group = options.group,
					activeSortable = Sortable.active,
					isOwner = (activeGroup === group),
					isMovingBetweenSortable = false,
					canSort = options.sort;
	
				if (evt.preventDefault !== void 0) {
					evt.preventDefault();
					!options.dragoverBubble && evt.stopPropagation();
				}
	
				if (dragEl.animated) {
					return;
				}
	
				moved = true;
	
				if (activeSortable && !options.disabled &&
					(isOwner
						? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
						: (
							putSortable === this ||
							(
								(activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) &&
								group.checkPut(this, activeSortable, dragEl, evt)
							)
						)
					) &&
					(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
				) {
					// Smart auto-scrolling
					_autoScroll(evt, options, this.el);
	
					if (_silent) {
						return;
					}
	
					target = _closest(evt.target, options.draggable, el);
					dragRect = dragEl.getBoundingClientRect();
	
					if (putSortable !== this) {
						putSortable = this;
						isMovingBetweenSortable = true;
					}
	
					if (revert) {
						_cloneHide(activeSortable, true);
						parentEl = rootEl; // actualization
	
						if (cloneEl || nextEl) {
							rootEl.insertBefore(dragEl, cloneEl || nextEl);
						}
						else if (!canSort) {
							rootEl.appendChild(dragEl);
						}
	
						return;
					}
	
	
					if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
						(el === evt.target) && (target = _ghostIsLast(el, evt))
					) {
						if (target) {
							if (target.animated) {
								return;
							}
	
							targetRect = target.getBoundingClientRect();
						}
	
						_cloneHide(activeSortable, isOwner);
	
						if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
							if (!dragEl.contains(el)) {
								el.appendChild(dragEl);
								parentEl = el; // actualization
							}
	
							this._animate(dragRect, dragEl);
							target && this._animate(targetRect, target);
						}
					}
					else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
						if (lastEl !== target) {
							lastEl = target;
							lastCSS = _css(target);
							lastParentCSS = _css(target.parentNode);
						}
	
						targetRect = target.getBoundingClientRect();
	
						var width = targetRect.right - targetRect.left,
							height = targetRect.bottom - targetRect.top,
							floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display)
								|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
							isWide = (target.offsetWidth > dragEl.offsetWidth),
							isLong = (target.offsetHeight > dragEl.offsetHeight),
							halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
							nextSibling = target.nextElementSibling,
							moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt),
							after = false
						;
	
						if (moveVector !== false) {
							_silent = true;
							setTimeout(_unsilent, 30);
	
							_cloneHide(activeSortable, isOwner);
	
							if (moveVector === 1 || moveVector === -1) {
								after = (moveVector === 1);
							}
							else if (floating) {
								var elTop = dragEl.offsetTop,
									tgTop = target.offsetTop;
	
								if (elTop === tgTop) {
									after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
								}
								else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
									after = (evt.clientY - targetRect.top) / height > 0.5;
								} else {
									after = tgTop > elTop;
								}
							} else if (!isMovingBetweenSortable) {
								after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
							}
	
							if (!dragEl.contains(el)) {
								if (after && !nextSibling) {
									el.appendChild(dragEl);
								} else {
									target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
								}
							}
	
							parentEl = dragEl.parentNode; // actualization
	
							this._animate(dragRect, dragEl);
							this._animate(targetRect, target);
						}
					}
				}
			},
	
			_animate: function (prevRect, target) {
				var ms = this.options.animation;
	
				if (ms) {
					var currentRect = target.getBoundingClientRect();
	
					if (prevRect.nodeType === 1) {
						prevRect = prevRect.getBoundingClientRect();
					}
	
					_css(target, 'transition', 'none');
					_css(target, 'transform', 'translate3d('
						+ (prevRect.left - currentRect.left) + 'px,'
						+ (prevRect.top - currentRect.top) + 'px,0)'
					);
	
					target.offsetWidth; // repaint
	
					_css(target, 'transition', 'all ' + ms + 'ms');
					_css(target, 'transform', 'translate3d(0,0,0)');
	
					clearTimeout(target.animated);
					target.animated = setTimeout(function () {
						_css(target, 'transition', '');
						_css(target, 'transform', '');
						target.animated = false;
					}, ms);
				}
			},
	
			_offUpEvents: function () {
				var ownerDocument = this.el.ownerDocument;
	
				_off(document, 'touchmove', this._onTouchMove);
				_off(document, 'pointermove', this._onTouchMove);
				_off(ownerDocument, 'mouseup', this._onDrop);
				_off(ownerDocument, 'touchend', this._onDrop);
				_off(ownerDocument, 'pointerup', this._onDrop);
				_off(ownerDocument, 'touchcancel', this._onDrop);
				_off(ownerDocument, 'selectstart', this);
			},
	
			_onDrop: function (/**Event*/evt) {
				var el = this.el,
					options = this.options;
	
				clearInterval(this._loopId);
				clearInterval(autoScroll.pid);
				clearTimeout(this._dragStartTimer);
	
				// Unbind events
				_off(document, 'mousemove', this._onTouchMove);
	
				if (this.nativeDraggable) {
					_off(document, 'drop', this);
					_off(el, 'dragstart', this._onDragStart);
				}
	
				this._offUpEvents();
	
				if (evt) {
					if (moved) {
						evt.preventDefault();
						!options.dropBubble && evt.stopPropagation();
					}
	
					ghostEl && ghostEl.parentNode.removeChild(ghostEl);
	
					if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
						// Remove clone
						cloneEl && cloneEl.parentNode.removeChild(cloneEl);
					}
	
					if (dragEl) {
						if (this.nativeDraggable) {
							_off(dragEl, 'dragend', this);
						}
	
						_disableDraggable(dragEl);
						dragEl.style['will-change'] = '';
	
						// Remove class's
						_toggleClass(dragEl, this.options.ghostClass, false);
						_toggleClass(dragEl, this.options.chosenClass, false);
	
						if (rootEl !== parentEl) {
							newIndex = _index(dragEl, options.draggable);
	
							if (newIndex >= 0) {
								// Add event
								_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);
	
								// Remove event
								_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);
	
								// drag from one list and drop into another
								_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
						else {
							if (dragEl.nextSibling !== nextEl) {
								// Get the index of the dragged element within its parent
								newIndex = _index(dragEl, options.draggable);
	
								if (newIndex >= 0) {
									// drag & drop within the same list
									_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
									_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
								}
							}
						}
	
						if (Sortable.active) {
							/* jshint eqnull:true */
							if (newIndex == null || newIndex === -1) {
								newIndex = oldIndex;
							}
	
							_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);
	
							// Save sorting
							this.save();
						}
					}
	
				}
	
				this._nulling();
			},
	
			_nulling: function() {
				rootEl =
				dragEl =
				parentEl =
				ghostEl =
				nextEl =
				cloneEl =
				lastDownEl =
	
				scrollEl =
				scrollParentEl =
	
				tapEvt =
				touchEvt =
	
				moved =
				newIndex =
	
				lastEl =
				lastCSS =
	
				putSortable =
				activeGroup =
				Sortable.active = null;
	
				savedInputChecked.forEach(function (el) {
					el.checked = true;
				});
				savedInputChecked.length = 0;
			},
	
			handleEvent: function (/**Event*/evt) {
				switch (evt.type) {
					case 'drop':
					case 'dragend':
						this._onDrop(evt);
						break;
	
					case 'dragover':
					case 'dragenter':
						if (dragEl) {
							this._onDragOver(evt);
							_globalDragOver(evt);
						}
						break;
	
					case 'selectstart':
						evt.preventDefault();
						break;
				}
			},
	
	
			/**
			 * Serializes the item into an array of string.
			 * @returns {String[]}
			 */
			toArray: function () {
				var order = [],
					el,
					children = this.el.children,
					i = 0,
					n = children.length,
					options = this.options;
	
				for (; i < n; i++) {
					el = children[i];
					if (_closest(el, options.draggable, this.el)) {
						order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
					}
				}
	
				return order;
			},
	
	
			/**
			 * Sorts the elements according to the array.
			 * @param  {String[]}  order  order of the items
			 */
			sort: function (order) {
				var items = {}, rootEl = this.el;
	
				this.toArray().forEach(function (id, i) {
					var el = rootEl.children[i];
	
					if (_closest(el, this.options.draggable, rootEl)) {
						items[id] = el;
					}
				}, this);
	
				order.forEach(function (id) {
					if (items[id]) {
						rootEl.removeChild(items[id]);
						rootEl.appendChild(items[id]);
					}
				});
			},
	
	
			/**
			 * Save the current sorting
			 */
			save: function () {
				var store = this.options.store;
				store && store.set(this);
			},
	
	
			/**
			 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
			 * @param   {HTMLElement}  el
			 * @param   {String}       [selector]  default: `options.draggable`
			 * @returns {HTMLElement|null}
			 */
			closest: function (el, selector) {
				return _closest(el, selector || this.options.draggable, this.el);
			},
	
	
			/**
			 * Set/get option
			 * @param   {string} name
			 * @param   {*}      [value]
			 * @returns {*}
			 */
			option: function (name, value) {
				var options = this.options;
	
				if (value === void 0) {
					return options[name];
				} else {
					options[name] = value;
	
					if (name === 'group') {
						_prepareGroup(options);
					}
				}
			},
	
	
			/**
			 * Destroy
			 */
			destroy: function () {
				var el = this.el;
	
				el[expando] = null;
	
				_off(el, 'mousedown', this._onTapStart);
				_off(el, 'touchstart', this._onTapStart);
				_off(el, 'pointerdown', this._onTapStart);
	
				if (this.nativeDraggable) {
					_off(el, 'dragover', this);
					_off(el, 'dragenter', this);
				}
	
				// Remove draggable attributes
				Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
					el.removeAttribute('draggable');
				});
	
				touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);
	
				this._onDrop();
	
				this.el = el = null;
			}
		};
	
	
		function _cloneHide(sortable, state) {
			if (sortable.lastPullMode !== 'clone') {
				state = true;
			}
	
			if (cloneEl && (cloneEl.state !== state)) {
				_css(cloneEl, 'display', state ? 'none' : '');
	
				if (!state) {
					if (cloneEl.state) {
						if (sortable.options.group.revertClone) {
							rootEl.insertBefore(cloneEl, nextEl);
							sortable._animate(dragEl, cloneEl);
						} else {
							rootEl.insertBefore(cloneEl, dragEl);
						}
					}
				}
	
				cloneEl.state = state;
			}
		}
	
	
		function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
			if (el) {
				ctx = ctx || document;
	
				do {
					if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
						return el;
					}
					/* jshint boss:true */
				} while (el = _getParentOrHost(el));
			}
	
			return null;
		}
	
	
		function _getParentOrHost(el) {
			var parent = el.host;
	
			return (parent && parent.nodeType) ? parent : el.parentNode;
		}
	
	
		function _globalDragOver(/**Event*/evt) {
			if (evt.dataTransfer) {
				evt.dataTransfer.dropEffect = 'move';
			}
			evt.preventDefault();
		}
	
	
		function _on(el, event, fn) {
			el.addEventListener(event, fn, captureMode);
		}
	
	
		function _off(el, event, fn) {
			el.removeEventListener(event, fn, captureMode);
		}
	
	
		function _toggleClass(el, name, state) {
			if (el) {
				if (el.classList) {
					el.classList[state ? 'add' : 'remove'](name);
				}
				else {
					var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
					el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
				}
			}
		}
	
	
		function _css(el, prop, val) {
			var style = el && el.style;
	
			if (style) {
				if (val === void 0) {
					if (document.defaultView && document.defaultView.getComputedStyle) {
						val = document.defaultView.getComputedStyle(el, '');
					}
					else if (el.currentStyle) {
						val = el.currentStyle;
					}
	
					return prop === void 0 ? val : val[prop];
				}
				else {
					if (!(prop in style)) {
						prop = '-webkit-' + prop;
					}
	
					style[prop] = val + (typeof val === 'string' ? '' : 'px');
				}
			}
		}
	
	
		function _find(ctx, tagName, iterator) {
			if (ctx) {
				var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
	
				if (iterator) {
					for (; i < n; i++) {
						iterator(list[i], i);
					}
				}
	
				return list;
			}
	
			return [];
		}
	
	
	
		function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
			sortable = (sortable || rootEl[expando]);
	
			var evt = document.createEvent('Event'),
				options = sortable.options,
				onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
	
			evt.initEvent(name, true, true);
	
			evt.to = rootEl;
			evt.from = fromEl || rootEl;
			evt.item = targetEl || rootEl;
			evt.clone = cloneEl;
	
			evt.oldIndex = startIndex;
			evt.newIndex = newIndex;
	
			rootEl.dispatchEvent(evt);
	
			if (options[onName]) {
				options[onName].call(sortable, evt);
			}
		}
	
	
		function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt) {
			var evt,
				sortable = fromEl[expando],
				onMoveFn = sortable.options.onMove,
				retVal;
	
			evt = document.createEvent('Event');
			evt.initEvent('move', true, true);
	
			evt.to = toEl;
			evt.from = fromEl;
			evt.dragged = dragEl;
			evt.draggedRect = dragRect;
			evt.related = targetEl || toEl;
			evt.relatedRect = targetRect || toEl.getBoundingClientRect();
	
			fromEl.dispatchEvent(evt);
	
			if (onMoveFn) {
				retVal = onMoveFn.call(sortable, evt, originalEvt);
			}
	
			return retVal;
		}
	
	
		function _disableDraggable(el) {
			el.draggable = false;
		}
	
	
		function _unsilent() {
			_silent = false;
		}
	
	
		/** @returns {HTMLElement|false} */
		function _ghostIsLast(el, evt) {
			var lastEl = el.lastElementChild,
				rect = lastEl.getBoundingClientRect();
	
			// 5 — min delta
			// abs — нельзя добавлять, а то глюки при наведении сверху
			return (
				(evt.clientY - (rect.top + rect.height) > 5) ||
				(evt.clientX - (rect.right + rect.width) > 5)
			) && lastEl;
		}
	
	
		/**
		 * Generate id
		 * @param   {HTMLElement} el
		 * @returns {String}
		 * @private
		 */
		function _generateId(el) {
			var str = el.tagName + el.className + el.src + el.href + el.textContent,
				i = str.length,
				sum = 0;
	
			while (i--) {
				sum += str.charCodeAt(i);
			}
	
			return sum.toString(36);
		}
	
		/**
		 * Returns the index of an element within its parent for a selected set of
		 * elements
		 * @param  {HTMLElement} el
		 * @param  {selector} selector
		 * @return {number}
		 */
		function _index(el, selector) {
			var index = 0;
	
			if (!el || !el.parentNode) {
				return -1;
			}
	
			while (el && (el = el.previousElementSibling)) {
				if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
					index++;
				}
			}
	
			return index;
		}
	
		function _matches(/**HTMLElement*/el, /**String*/selector) {
			if (el) {
				selector = selector.split('.');
	
				var tag = selector.shift().toUpperCase(),
					re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');
	
				return (
					(tag === '' || el.nodeName.toUpperCase() == tag) &&
					(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
				);
			}
	
			return false;
		}
	
		function _throttle(callback, ms) {
			var args, _this;
	
			return function () {
				if (args === void 0) {
					args = arguments;
					_this = this;
	
					setTimeout(function () {
						if (args.length === 1) {
							callback.call(_this, args[0]);
						} else {
							callback.apply(_this, args);
						}
	
						args = void 0;
					}, ms);
				}
			};
		}
	
		function _extend(dst, src) {
			if (dst && src) {
				for (var key in src) {
					if (src.hasOwnProperty(key)) {
						dst[key] = src[key];
					}
				}
			}
	
			return dst;
		}
	
		function _clone(el) {
			return $
				? $(el).clone(true)[0]
				: (Polymer && Polymer.dom
					? Polymer.dom(el).cloneNode(true)
					: el.cloneNode(true)
				);
		}
	
		function _saveInputCheckedState(root) {
			var inputs = root.getElementsByTagName('input');
			var idx = inputs.length;
	
			while (idx--) {
				var el = inputs[idx];
				el.checked && savedInputChecked.push(el);
			}
		}
	
		// Fixed #973: 
		_on(document, 'touchmove', function (evt) {
			if (Sortable.active) {
				evt.preventDefault();
			}
		});
	
		try {
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				get: function () {
					captureMode = {
						capture: false,
						passive: false
					};
				}
			}));
		} catch (err) {}
	
		// Export utils
		Sortable.utils = {
			on: _on,
			off: _off,
			css: _css,
			find: _find,
			is: function (el, selector) {
				return !!_closest(el, selector, el);
			},
			extend: _extend,
			throttle: _throttle,
			closest: _closest,
			toggleClass: _toggleClass,
			clone: _clone,
			index: _index
		};
	
	
		/**
		 * Create sortable instance
		 * @param {HTMLElement}  el
		 * @param {Object}      [options]
		 */
		Sortable.create = function (el, options) {
			return new Sortable(el, options);
		};
	
	
		// Export
		Sortable.version = '1.5.1';
		return Sortable;
	});


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(788);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./animate.css", function() {
				var newContent = require("!!../css-loader/index.js!./animate.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(789);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./bootstrap.min.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./bootstrap.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(790);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./bootstrap-datetimepicker.min.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./bootstrap-datetimepicker.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(792);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./bs-spacing.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./bs-spacing.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(793);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./old-browsers.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./old-browsers.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(794);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(60)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./shop24.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!./shop24.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/448c34a56d699c29117adc64c43affeb.woff2";

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/fee66e712a8a08eef5805a46892932ad.woff";

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/b06871f281fee6b241d60582ae9369b9.ttf";

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/89889688147bd7575d6327160d64e760.svg";

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "files/912ec66d7572ff821749319396470bde.svg";

/***/ },
/* 858 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bundle.js